/**
 * The Object.assign polyfill is required for ASF 1.0.0-alpha
 * https://github.com/json-schema-form/angular-schema-form/issues/869
 *
 * The implementation was copied from:
 * https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
 */

if (typeof Object.assign != 'function') {
  Object.assign = function(target, varArgs) { // .length of function is 2
    'use strict';
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

// This implementation was copied from
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
//
// https://tc39.github.io/ecma262/#sec-array.prototype.find
if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      var thisArg = arguments[1];

      // 5. Let k be 0.
      var k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        var kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return kValue;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return undefined.
      return undefined;
    },
    configurable: true,
    writable: true
  });
}
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 2.5.6 - 2017-10-14
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.tabindex","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.multiMap","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
          expandedExpr = $parse(attrs.expanded),
          collapsingExpr = $parse(attrs.collapsing),
          collapsedExpr = $parse(attrs.collapsed),
          horizontal = false,
          css = {},
          cssTo = {};

        init();

        function init() {
          horizontal = !!('horizontal' in attrs);
          if (horizontal) {
            css = {
              width: ''
            };
            cssTo = {width: '0'};
          } else {
            css = {
              height: ''
            };
            cssTo = {height: '0'};
          }
          if (!scope.$eval(attrs.uibCollapse)) {
            element.addClass('in')
              .addClass('collapse')
              .attr('aria-expanded', true)
              .attr('aria-hidden', false)
              .css(css);
          }
        }

        function getScrollFromElement(element) {
          if (horizontal) {
            return {width: element.scrollWidth + 'px'};
          }
          return {height: element.scrollHeight + 'px'};
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  css: {
                    overflow: 'hidden'
                  },
                  to: getScrollFromElement(element[0])
                }).then(expandDone);
              }
            }, angular.noop);
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css(css);
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
              // IMPORTANT: The width must be set before adding "collapsing" class.
              // Otherwise, the browser attempts to animate from width 0 (in
              // collapsing class) to the given width here.
                .css(getScrollFromElement(element[0]))
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: cssTo
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: cssTo
                }).then(collapseDone);
              }
            }, angular.noop);
        }

        function collapseDone() {
          element.css(cssTo); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.tabindex', [])

.directive('uibTabindexToggle', function() {
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      attrs.$observe('disabled', function(disabled) {
        attrs.$set('tabindex', disabled ? -1 : null);
      });
    }
  };
});

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse', 'ui.bootstrap.tabindex'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      element.addClass('panel');
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector(getHeaderSelectors()));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };

  function getHeaderSelectors() {
      return 'uib-accordion-header,' +
          'data-uib-accordion-header,' +
          'x-uib-accordion-header,' +
          'uib\\:accordion-header,' +
          '[uib-accordion-header],' +
          '[data-uib-accordion-header],' +
          '[x-uib-accordion-header]';
  }
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$element', '$attrs', '$interpolate', '$timeout', function($scope, $element, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  $element.addClass('alert');
  $attrs.$set('role', 'alert');
  if ($scope.closeable) {
    $element.addClass('alert-dismissible');
  }

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    scope: {
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying;

  var destroyed = false;
  $element.addClass('carousel');

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $element.on('mouseenter', $scope.pause);
  $element.on('mouseleave', $scope.play);

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    restrict: 'A',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', ['$animate', function($animate) {
  return {
    require: '^uibCarousel',
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      element.addClass('item');
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        $animate[active ? 'addClass' : 'removeClass'](element, 'active');
      });
    }
  };
}])

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', 'filterFilter', function($log, $locale, dateFilter, orderByFilter, filterFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];

    if (angular.version.major >= 1 && angular.version.minor > 4) {
      formatCodeToRegex.push({
        key: 'LLLL',
        regex: $locale.DATETIME_FORMATS.STANDALONEMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.STANDALONEMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'LLLL'); }
      });
    }
  };

  this.init();

  function getFormatCodeToRegex(key) {
    return filterFilter(formatCodeToRegex, {key: key}, true)[0];
  }

  this.getParser = function (key) {
    var f = getFormatCodeToRegex(key);
    return f && f.apply || null;
  };

  this.overrideParser = function (key, parser) {
    var f = getFormatCodeToRegex(key);
    if (f && angular.isFunction(parser)) {
      this.parsers = {};
      f.apply = parser;
    }
  }.bind(this);

  function createParser(format) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data.apply,
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  function createFormatter(format) {
    var formatters = [];
    var i = 0;
    var formatter, literalIdx;
    while (i < format.length) {
      if (angular.isNumber(literalIdx)) {
        if (format.charAt(i) === '\'') {
          if (i + 1 >= format.length || format.charAt(i + 1) !== '\'') {
            formatters.push(constructLiteralFormatter(format, literalIdx, i));
            literalIdx = null;
          }
        } else if (i === format.length) {
          while (literalIdx < format.length) {
            formatter = constructFormatterFromIdx(format, literalIdx);
            formatters.push(formatter);
            literalIdx = formatter.endIdx;
          }
        }

        i++;
        continue;
      }

      if (format.charAt(i) === '\'') {
        literalIdx = i;
        i++;
        continue;
      }

      formatter = constructFormatterFromIdx(format, i);

      formatters.push(formatter.parser);
      i = formatter.endIdx;
    }

    return formatters;
  }

  function constructLiteralFormatter(format, literalIdx, endIdx) {
    return function() {
      return format.substr(literalIdx + 1, endIdx - literalIdx - 1);
    };
  }

  function constructFormatterFromIdx(format, i) {
    var currentPosStr = format.substr(i);
    for (var j = 0; j < formatCodeToRegex.length; j++) {
      if (new RegExp('^' + formatCodeToRegex[j].key).test(currentPosStr)) {
        var data = formatCodeToRegex[j];
        return {
          endIdx: i + data.key.length,
          parser: data.formatter
        };
      }
    }

    return {
      endIdx: i + 1,
      parser: function() {
        return currentPosStr.charAt(0);
      }
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createFormatter(format);
    }

    var formatters = this.formatters[format];

    return formatters.reduce(function(str, formatter) {
      return str + formatter(date);
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/622c42169699ec07fc6daaa19fe6d224e5d2f70e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    timezone = timezone.replace(/:/g, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  monthColumns: 3,
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$element', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $element, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [];

  $element.addClass('uib-datepicker');
  $attrs.$set('role', 'application');

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'monthColumns',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'monthColumns':
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.getOption('timezone'));
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.getOption('timezone')) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : $scope.datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = extractOptions(ngModelCtrl);

    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.getOption('timezone')) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.getOption('timezone'));
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    var date = ngModelCtrl.$modelValue ? new Date(ngModelCtrl.$modelValue) : new Date();
    this.activeDate = !isNaN(date) ?
      dateParser.fromTimezone(date, ngModelOptions.getOption('timezone')) :
      dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.getOption('timezone'));
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.getOption('timezone')) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.getOption('timezone'));
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $element.on('keydown', function(evt) {
    $scope.$apply(function() {
      $scope.keydown(evt);
    });
  });

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = ngModelCtrl.$options ||
        $scope.datepickerOptions.ngModelOptions ||
        datepickerConfig.ngModelOptions ||
        {};

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      // ng-model-options defaults timezone to null; don't let its precedence squash a non-null value
      var timezone = ngModelCtrl.$options.getOption('timezone') ||
        ($scope.datepickerOptions.ngModelOptions ? $scope.datepickerOptions.ngModelOptions.timezone : null) ||
        (datepickerConfig.ngModelOptions ? datepickerConfig.ngModelOptions.timezone : null);

      // values passed to createChild override existing values
      ngModelOptions = ngModelCtrl.$options // start with a ModelOptions instance
        .createChild(datepickerConfig.ngModelOptions) // lowest precedence
        .createChild($scope.datepickerOptions.ngModelOptions)
        .createChild(ngModelCtrl.$options) // highest precedence
        .createChild({timezone: timezone}); // to keep from squashing a non-null value
    }

    return ngModelOptions;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, this.monthColumns);
    scope.yearHeaderColspan = this.monthColumns > 3 ? this.monthColumns - 2 : 1;
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - this.monthColumns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + this.monthColumns;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    restrict: 'A',
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    restrict: 'A',
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    restrict: 'A',
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    restrict: 'A',
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
       * Provides a way to adjust the top positioning after first
       * render to correctly align element to top after content
       * rendering causes resized element height
       *
       * @param {array} placementClasses - The array of strings of classes
       * element should have.
       * @param {object} containerPosition - The object with container
       * position information
       * @param {number} initialHeight - The initial height for the elem.
       * @param {number} currentHeight - The current height for the elem.
       */
      adjustTop: function(placementClasses, containerPosition, initialHeight, currentHeight) {
        if (placementClasses.indexOf('top') !== -1 && initialHeight !== currentHeight) {
          return {
            top: containerPosition.top - currentHeight + 'px'
          };
        }
      },

      /**
       * Provides a way for positioning tooltip & dropdown
       * arrows when using placement options beyond the standard
       * left, right, top, or bottom.
       *
       * @param {element} elem - The tooltip/dropdown element.
       * @param {string} placement - The placement for the elem.
       */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [];

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = extractOptions(ngModel);
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }

        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, ngModelOptions.getOption('timezone'));
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), ngModelOptions.getOption('timezone'));
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = new Date($scope.datepickerOptions[key]);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    $scope.date = dt;
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = dateParser.fromTimezone(today, ngModelOptions.getOption('timezone'));
        date.setHours(0, 0, 0, 0);
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.getOption('timezone'));
      }
    }

    return ngModelOptions.getOption('allowInvalid') ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(value));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  function extractOptions(ngModelCtrl) {
    var ngModelOptions;

    if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
      // guarantee a value
      ngModelOptions = angular.isObject(ngModelCtrl.$options) ?
        ngModelCtrl.$options :
        {
          timezone: null
        };

      // mimic 1.6+ api
      ngModelOptions.getOption = function (key) {
        return ngModelOptions[key];
      };
    } else { // in angular >=1.6 $options is always present
      ngModelOptions = ngModelCtrl.$options;
    }

    return ngModelOptions;
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    restrict: 'A',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.multiMap', [])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.multiMap', 'ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', '$$multiMap', function($document, $rootScope, $$multiMap) {
  var openScope = null;
  var openedContainers = $$multiMap.createNew();

  this.isOnlyOpen = function(dropdownScope, appendTo) {
    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openDropdown = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (openDropdown) {
        return openedDropdowns.length === 1;
      }
    }

    return false;
  };

  this.open = function(dropdownScope, element, appendTo) {
    if (!openScope) {
      $document.on('click', closeDropdown);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var openedScopes = openedDropdowns.map(function(dropdown) {
        return dropdown.scope;
      });
      if (openedScopes.indexOf(dropdownScope) === -1) {
        openedContainers.put(appendTo, {
          scope: dropdownScope
        });
      }
    } else {
      openedContainers.put(appendTo, {
        scope: dropdownScope
      });
    }
  };

  this.close = function(dropdownScope, element, appendTo) {
    if (openScope === dropdownScope) {
      $document.off('click', closeDropdown);
      $document.off('keydown', this.keybindFilter);
      openScope = null;
    }

    if (!appendTo) {
      return;
    }

    var openedDropdowns = openedContainers.get(appendTo);
    if (openedDropdowns) {
      var dropdownToClose = openedDropdowns.reduce(function(toClose, dropdown) {
        if (dropdown.scope === dropdownScope) {
          return dropdown;
        }

        return toClose;
      }, {});
      if (dropdownToClose) {
        openedContainers.remove(appendTo, dropdownToClose);
      }
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope || !openScope.isOpen) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.focusToggleElement();
    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  this.keybindFilter = function(evt) {
    if (!openScope) {
      // see this.close as ESC could have been pressed which kills the scope so we can not proceed
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    var toggleElement = openScope.getToggleElement();
    var dropdownElementTargeted = dropdownElement && dropdownElement[0].contains(evt.target);
    var toggleElementTargeted = toggleElement && toggleElement[0].contains(evt.target);
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen && (dropdownElementTargeted || toggleElementTargeted)) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    keynavEnabled = angular.isDefined($attrs.keyboardNav);
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  function removeDropdownMenu() {
    $element.append(self.dropdownMenu);
  }

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    var appendTo = null,
      appendToBody = false;

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    if (angular.isDefined($attrs.dropdownAppendToBody)) {
      var appendToBodyValue = $parse($attrs.dropdownAppendToBody)(scope);
      if (appendToBodyValue !== false) {
        appendToBody = true;
      }
    }

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      if (isOpen) {
        appendTo.append(self.dropdownMenu);
        $element.on('$destroy', removeDropdownMenu);
      } else {
        $element.off('$destroy', removeDropdownMenu);
        removeDropdownMenu();
      }
    }

    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign,
        scrollbarPadding,
        scrollbarWidth = 0;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        scrollbarPadding = $position.scrollbarPadding(appendTo);

        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
          scrollbarWidth = scrollbarPadding.scrollbarWidth;
        }

        css.right = window.innerWidth - scrollbarWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var dropdownOpenClass = appendTo ? appendToOpenClass : openClass;
    var hasOpenClass = openContainer.hasClass(dropdownOpenClass);
    var isOnlyOpen = uibDropdownService.isOnlyOpen($scope, appendTo);

    if (hasOpenClass === !isOpen) {
      var toggleClass;
      if (appendTo) {
        toggleClass = !isOnlyOpen ? 'addClass' : 'removeClass';
      } else {
        toggleClass = isOpen ? 'addClass' : 'removeClass';
      }
      $animate[toggleClass](openContainer, dropdownOpenClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
            $document.on('keydown', uibDropdownService.keybindFilter);
          });
        });
      } else {
        $document.on('keydown', uibDropdownService.keybindFilter);
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element, appendTo);
    } else {
      uibDropdownService.close(scope, $element, appendTo);
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.on('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.off('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.pop();
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.multiMap', 'ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      restrict: 'A',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      restrict: 'A',
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is rendered.
        var modalRenderDeferObj = $q.defer();
        // Resolve render promise post-digest
        scope.$$postDigest(function() {
          modalRenderDeferObj.resolve();
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus) then there's no need to try to focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          $animate.enter(clone, element);
        });
      }
    };
  }])

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;
      var ARIA_HIDDEN_ATTRIBUTE_NAME = 'data-bootstrap-modal-aria-hidden-count';

      //Modal focus behavior
      var tabbableSelector = 'a[href], area[href], input:not([disabled]):not([tabindex=\'-1\']), ' +
        'button:not([disabled]):not([tabindex=\'-1\']),select:not([disabled]):not([tabindex=\'-1\']), textarea:not([disabled]):not([tabindex=\'-1\']), ' +
        'iframe, object, embed, *[tabindex]:not([tabindex=\'-1\']), *[contenteditable=true]';
      var scrollbarPadding;
      var SNAKE_CASE_REGEXP = /[A-Z]/g;

      // TODO: extract into common dependency with tooltip
      function snake_case(name) {
        var separator = '-';
        return name.replace(SNAKE_CASE_REGEXP, function(letter, pos) {
          return (pos ? separator : '') + letter.toLowerCase();
        });
      }

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            if (done) {
              done();
            }

            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr({
            'class': 'modal-backdrop',
            'ng-style': '{\'z-index\': 1040 + (index && 1 || 0) + index*10}',
            'uib-modal-animation-class': 'fade',
            'modal-in-class': 'in'
          });
          if (modal.backdropClass) {
            backdropDomEl.addClass(modal.backdropClass);
          }

          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          if ($uibPosition.isScrollable(appendToElement)) {
            scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
            if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
              appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
            }
          }
        }

        var content;
        if (modal.component) {
          content = document.createElement(snake_case(modal.component.name));
          content = angular.element(content);
          content.attr({
            resolve: '$resolve',
            'modal-instance': '$uibModalInstance',
            close: '$close($value)',
            dismiss: '$dismiss($value)'
          });
        } else {
          content = modal.content;
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'class': 'modal',
          'template-url': modal.windowTemplateUrl,
          'window-top-class': modal.windowTopClass,
          'role': 'dialog',
          'aria-labelledby': modal.ariaLabelledBy,
          'aria-describedby': modal.ariaDescribedBy,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate',
          'ng-style': '{\'z-index\': 1050 + $$topModalIndex*10, display: \'block\'}',
          'tabindex': -1,
          'uib-modal-animation-class': 'fade',
          'modal-in-class': 'in'
        }).append(content);
        if (modal.windowClass) {
          angularDomEl.addClass(modal.windowClass);
        }

        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        if (modal.scope) {
          // we need to explicitly add the modal index to the modal scope
          // because it is needed by ngStyle to compute the zIndex property.
          modal.scope.$$topModalIndex = topModalIndex;
        }
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        applyAriaHidden(angularDomEl);

        function applyAriaHidden(el) {
          if (!el || el[0].tagName === 'BODY') {
            return;
          }

          getSiblings(el).forEach(function(sibling) {
            var elemIsAlreadyHidden = sibling.getAttribute('aria-hidden') === 'true',
              ariaHiddenCount = parseInt(sibling.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10);

            if (!ariaHiddenCount) {
              ariaHiddenCount = elemIsAlreadyHidden ? 1 : 0;
            }

            sibling.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, ariaHiddenCount + 1);
            sibling.setAttribute('aria-hidden', 'true');
          });

          return applyAriaHidden(el.parent());

          function getSiblings(el) {
            var children = el.parent() ? el.parent().children() : [];

            return Array.prototype.filter.call(children, function(child) {
              return child !== el[0];
            });
          }
        }
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      function unhideBackgroundElements() {
        Array.prototype.forEach.call(
          document.querySelectorAll('[' + ARIA_HIDDEN_ATTRIBUTE_NAME + ']'),
          function(hiddenEl) {
            var ariaHiddenCount = parseInt(hiddenEl.getAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME), 10),
              newHiddenCount = ariaHiddenCount - 1;
            hiddenEl.setAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME, newHiddenCount);

            if (!newHiddenCount) {
              hiddenEl.removeAttribute(ARIA_HIDDEN_ATTRIBUTE_NAME);
              hiddenEl.removeAttribute('aria-hidden');
            }
          }
        );
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }

        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        unhideBackgroundElements();
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabbableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            if (!modalOptions.appendTo.length) {
              throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
            }

            //verify options
            if (!modalOptions.component && !modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of component or template or templateUrl options is required.');
            }

            var templateAndResolvePromise;
            if (modalOptions.component) {
              templateAndResolvePromise = $q.when($uibResolve.resolve(modalOptions.resolve, {}, null, null));
            } else {
              templateAndResolvePromise =
                $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
            }

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var modal = {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  ariaLabelledBy: modalOptions.ariaLabelledBy,
                  ariaDescribedBy: modalOptions.ariaDescribedBy,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                };

                var component = {};
                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                if (modalOptions.component) {
                  constructLocals(component, false, true, false);
                  component.name = modalOptions.component;
                  modal.component = component;
                } else if (modalOptions.controller) {
                  constructLocals(ctrlLocals, true, false, true);

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true, modalOptions.controllerAs);
                  if (modalOptions.controllerAs && modalOptions.bindToController) {
                    ctrlInstance = ctrlInstantiate.instance;
                    ctrlInstance.$close = modalScope.$close;
                    ctrlInstance.$dismiss = modalScope.$dismiss;
                    angular.extend(ctrlInstance, {
                      $resolve: ctrlLocals.$scope.$resolve
                    }, providedScope);
                  }

                  ctrlInstance = ctrlInstantiate();

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                if (!modalOptions.component) {
                  modal.content = tplAndVars[0];
                }

                $modalStack.open(modalInstance, modal);
                modalOpenedDeferred.resolve(true);

                function constructLocals(obj, template, instanceOnScope, injectable) {
                  obj.$scope = modalScope;
                  obj.$scope.$resolve = {};
                  if (instanceOnScope) {
                    obj.$scope.$uibModalInstance = modalInstance;
                  } else {
                    obj.$uibModalInstance = modalInstance;
                  }

                  var resolves = template ? tplAndVars[1] : tplAndVars;
                  angular.forEach(resolves, function(value, key) {
                    if (injectable) {
                      obj[key] = value;
                    }

                    obj.$scope.$resolve[key] = value;
                  });
                }
            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    restrict: 'A',
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pager');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging', 'ui.bootstrap.tabindex'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  $attrs.$set('role', 'menu');

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    restrict: 'A',
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    link: function(scope, element, attrs, ctrls) {
      element.addClass('pagination');
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keyup', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keyup', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'origin-scope="origScope" ' +
          'class="uib-position-measure ' + prefix + '" ' +
          'tooltip-animation-class="fade"' +
          'uib-tooltip-classes ' +
          'ng-class="{ in: isOpen }" ' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var adjustmentTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  var initialHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                  var elementPos = appendToBody ? $position.offset(element) : $position.position(element);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });
                  var placementClasses = ttPosition.placement.split('-');

                  if (!tooltip.hasClass(placementClasses[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(placementClasses[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  adjustmentTimeout = $timeout(function() {
                    var currentHeight = angular.isDefined(tooltip.offsetHeight) ? tooltip.offsetHeight : tooltip.prop('offsetHeight');
                    var adjustment = $position.adjustTop(placementClasses, elementPos, initialHeight, currentHeight);
                    if (adjustment) {
                      tooltip.css(adjustment);
                    }
                    adjustmentTimeout = null;
                  }, 0, false);

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              openedTooltips.add(ttScope, {
                close: hide
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                
                tooltip = null;
                if (adjustmentTimeout) {
                  $timeout.cancel(adjustmentTimeout);
                }
              }

              openedTooltips.remove(ttScope);
              
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            // KeyboardEvent handler to hide the tooltip on Escape key press
            function hideOnEscapeKey(e) {
              if (e.which === 27) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
                element.off('keypress', hideOnEscapeKey);
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var showTriggers = [], hideTriggers = [];
              var val = scope.$eval(attrs[prefix + 'Trigger']);
              unregisterTriggers();

              if (angular.isObject(val)) {
                Object.keys(val).forEach(function(key) {
                  showTriggers.push(key);
                  hideTriggers.push(val[key]);
                });
                triggers = {
                  show: showTriggers,
                  hide: hideTriggers
                };
              } else {
                triggers = getTriggers(val);
              }

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }
                  element.on('keypress', hideOnEscapeKey);
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    restrict: 'A',
    scope: { content: '@' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', contentExp: '&', originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    restrict: 'A',
    scope: { contentExp: '&', uibTitle: '@' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    restrict: 'A',
    scope: { uibTitle: '@', content: '@' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles: ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    restrict: 'A',
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt,
          $selectedIndex: index
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isDefined(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isDefined(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isDefined(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var hoursModelCtrl, minutesModelCtrl, secondsModelCtrl;
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    hoursModelCtrl = hoursInputEl.controller('ngModel');
    minutesModelCtrl = minutesInputEl.controller('ngModel');
    secondsModelCtrl = secondsInputEl.controller('ngModel');

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.on('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.on('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
        if (hoursModelCtrl) {
          hoursModelCtrl.$setValidity('hours', false);
        }
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
        if (minutesModelCtrl) {
          minutesModelCtrl.$setValidity('minutes', false);
        }
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
        if (secondsModelCtrl) {
          secondsModelCtrl.$setValidity('seconds', false);
        }
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.on('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.on('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    if (hoursModelCtrl) {
      hoursModelCtrl.$setValidity('hours', true);
    }

    if (minutesModelCtrl) {
      minutesModelCtrl.$setValidity('minutes', true);
    }

    if (secondsModelCtrl) {
      secondsModelCtrl.$setValidity('seconds', true);
    }

    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    restrict: 'A',
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      000001111111100000000000002222222200000000000000003333333333333330000000000044444444000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a function to determine if an event should cause selection
    var isSelectEvent = attrs.typeaheadShouldSelect ? $parse(attrs.typeaheadShouldSelect) : function(scope, vals) {
      var evt = vals.$event;
      return evt.which === 13 || evt.which === 9;
    };

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions.getOption('getterSetter')) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });

      if (hintInputElem.attr('id')) {
        hintInputElem.removeAttr('id'); // remove duplicate id if present.
      }
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      var shouldSelect = isSelectEvent(originalScope, {$event: evt});

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && shouldSelect || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 27: // escape
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38: // up arrow
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40: // down arrow
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl[0].querySelectorAll('.uib-typeahead-match')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        default:
          if (shouldSelect) {
            scope.$apply(function() {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(scope.activeIdx, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(scope.activeIdx, evt);
              }
            });
          }
      }
    });

    element.on('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.on('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        scope.$apply(function() {
          // Reset validity as we are clearing
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);
        });
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl) {
      modelCtrl = _modelCtrl;
      ngModelOptions = extractOptions(modelCtrl);

      scope.debounceUpdate = $parse(ngModelOptions.getOption('debounce'))(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };

    function extractOptions(ngModelCtrl) {
      var ngModelOptions;

      if (angular.version.minor < 6) { // in angular < 1.6 $options could be missing
        // guarantee a value
        ngModelOptions = ngModelCtrl.$options || {};

        // mimic 1.6+ api
        ngModelOptions.getOption = function (key) {
          return ngModelOptions[key];
        };
      } else { // in angular >=1.6 $options is always present
        ngModelOptions = ngModelCtrl.$options;
      }

      return ngModelOptions;
    }
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[1].init(ctrls[0]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "  <h4 class=\"panel-title\">\n" +
    "    <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\" ng-disabled=\"isDisabled\" uib-tabindex-toggle><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "  </h4>\n" +
    "</div>\n" +
    "<div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "  <div class=\"panel-body\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "  <span aria-hidden=\"true\">&times;</span>\n" +
    "  <span class=\"sr-only\">Close</span>\n" +
    "</button>\n" +
    "<div ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div class=\"carousel-inner\" ng-transclude></div>\n" +
    "<a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "  <span class=\"sr-only\">previous</span>\n" +
    "</a>\n" +
    "<a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "  <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "  <span class=\"sr-only\">next</span>\n" +
    "</a>\n" +
    "<ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "  <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "    <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "  </li>\n" +
    "</ol>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div class=\"text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\">\n" +
    "  <div uib-daypicker ng-switch-when=\"day\" tabindex=\"0\" class=\"uib-daypicker\"></div>\n" +
    "  <div uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\" class=\"uib-monthpicker\"></div>\n" +
    "  <div uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\" class=\"uib-yearpicker\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::yearHeaderColspan}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/popup.html",
    "<div>\n" +
    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "    <li ng-transclude></li>\n" +
    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "      <span class=\"btn-group pull-left\">\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "      </span>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></i><span class=\"sr-only\">previous</span></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></i><span class=\"sr-only\">next</span></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\" role=\"row\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<ul role=\"presentation\" class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "  <li ng-transclude></li>\n" +
    "  <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "    <span class=\"btn-group pull-left\">\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "    </span>\n" +
    "    <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "  </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/backdrop.html",
    "<div class=\"modal-backdrop\"\n" +
    "     uib-modal-animation-class=\"fade\"\n" +
    "     modal-in-class=\"in\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('first')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle>{{::getText('previous')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('next')}}</a></li>\n" +
    "<li role=\"menuitem\" ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle>{{::getText('last')}}</a></li>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip-arrow\"></div>\n" +
    "<div class=\"tooltip-inner\"\n" +
    "  uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "  tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\"\n" +
    "      uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "      tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"arrow\"></div>\n" +
    "\n" +
    "<div class=\"popover-inner\">\n" +
    "    <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "    <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"-1\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li class=\"uib-typeahead-match\" ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });
/*
Author: Geraint Luff and others
Year: 2013

This code is released into the "public domain" by its author(s).  Anybody may use, alter and distribute the code without restriction.  The author makes no guarantees, and takes no liability of any kind for use of this code.

If you find a bug or make an improvement, it would be courteous to let the author know, but it is not compulsory.
*/
(function (global, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if (typeof module !== 'undefined' && module.exports){
    // CommonJS. Define export.
    module.exports = factory();
  } else {
    // Browser globals
    global.tv4 = factory();
  }
}(this, function () {

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/keys?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FObject%2Fkeys
if (!Object.keys) {
	Object.keys = (function () {
		var hasOwnProperty = Object.prototype.hasOwnProperty,
			hasDontEnumBug = !({toString: null}).propertyIsEnumerable('toString'),
			dontEnums = [
				'toString',
				'toLocaleString',
				'valueOf',
				'hasOwnProperty',
				'isPrototypeOf',
				'propertyIsEnumerable',
				'constructor'
			],
			dontEnumsLength = dontEnums.length;

		return function (obj) {
			if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) {
				throw new TypeError('Object.keys called on non-object');
			}

			var result = [];

			for (var prop in obj) {
				if (hasOwnProperty.call(obj, prop)) {
					result.push(prop);
				}
			}

			if (hasDontEnumBug) {
				for (var i=0; i < dontEnumsLength; i++) {
					if (hasOwnProperty.call(obj, dontEnums[i])) {
						result.push(dontEnums[i]);
					}
				}
			}
			return result;
		};
	})();
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/create
if (!Object.create) {
	Object.create = (function(){
		function F(){}

		return function(o){
			if (arguments.length !== 1) {
				throw new Error('Object.create implementation only accepts one parameter.');
			}
			F.prototype = o;
			return new F();
		};
	})();
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FisArray
if(!Array.isArray) {
	Array.isArray = function (vArg) {
		return Object.prototype.toString.call(vArg) === "[object Array]";
	};
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf?redirectlocale=en-US&redirectslug=JavaScript%2FReference%2FGlobal_Objects%2FArray%2FindexOf
if (!Array.prototype.indexOf) {
	Array.prototype.indexOf = function (searchElement /*, fromIndex */ ) {
		if (this === null) {
			throw new TypeError();
		}
		var t = Object(this);
		var len = t.length >>> 0;

		if (len === 0) {
			return -1;
		}
		var n = 0;
		if (arguments.length > 1) {
			n = Number(arguments[1]);
			if (n !== n) { // shortcut for verifying if it's NaN
				n = 0;
			} else if (n !== 0 && n !== Infinity && n !== -Infinity) {
				n = (n > 0 || -1) * Math.floor(Math.abs(n));
			}
		}
		if (n >= len) {
			return -1;
		}
		var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
		for (; k < len; k++) {
			if (k in t && t[k] === searchElement) {
				return k;
			}
		}
		return -1;
	};
}

// Grungey Object.isFrozen hack
if (!Object.isFrozen) {
	Object.isFrozen = function (obj) {
		var key = "tv4_test_frozen_key";
		while (obj.hasOwnProperty(key)) {
			key += Math.random();
		}
		try {
			obj[key] = true;
			delete obj[key];
			return false;
		} catch (e) {
			return true;
		}
	};
}
// Based on: https://github.com/geraintluff/uri-templates, but with all the de-substitution stuff removed

var uriTemplateGlobalModifiers = {
	"+": true,
	"#": true,
	".": true,
	"/": true,
	";": true,
	"?": true,
	"&": true
};
var uriTemplateSuffices = {
	"*": true
};

function notReallyPercentEncode(string) {
	return encodeURI(string).replace(/%25[0-9][0-9]/g, function (doubleEncoded) {
		return "%" + doubleEncoded.substring(3);
	});
}

function uriTemplateSubstitution(spec) {
	var modifier = "";
	if (uriTemplateGlobalModifiers[spec.charAt(0)]) {
		modifier = spec.charAt(0);
		spec = spec.substring(1);
	}
	var separator = "";
	var prefix = "";
	var shouldEscape = true;
	var showVariables = false;
	var trimEmptyString = false;
	if (modifier === '+') {
		shouldEscape = false;
	} else if (modifier === ".") {
		prefix = ".";
		separator = ".";
	} else if (modifier === "/") {
		prefix = "/";
		separator = "/";
	} else if (modifier === '#') {
		prefix = "#";
		shouldEscape = false;
	} else if (modifier === ';') {
		prefix = ";";
		separator = ";";
		showVariables = true;
		trimEmptyString = true;
	} else if (modifier === '?') {
		prefix = "?";
		separator = "&";
		showVariables = true;
	} else if (modifier === '&') {
		prefix = "&";
		separator = "&";
		showVariables = true;
	}

	var varNames = [];
	var varList = spec.split(",");
	var varSpecs = [];
	var varSpecMap = {};
	for (var i = 0; i < varList.length; i++) {
		var varName = varList[i];
		var truncate = null;
		if (varName.indexOf(":") !== -1) {
			var parts = varName.split(":");
			varName = parts[0];
			truncate = parseInt(parts[1], 10);
		}
		var suffices = {};
		while (uriTemplateSuffices[varName.charAt(varName.length - 1)]) {
			suffices[varName.charAt(varName.length - 1)] = true;
			varName = varName.substring(0, varName.length - 1);
		}
		var varSpec = {
			truncate: truncate,
			name: varName,
			suffices: suffices
		};
		varSpecs.push(varSpec);
		varSpecMap[varName] = varSpec;
		varNames.push(varName);
	}
	var subFunction = function (valueFunction) {
		var result = "";
		var startIndex = 0;
		for (var i = 0; i < varSpecs.length; i++) {
			var varSpec = varSpecs[i];
			var value = valueFunction(varSpec.name);
			if (value === null || value === undefined || (Array.isArray(value) && value.length === 0) || (typeof value === 'object' && Object.keys(value).length === 0)) {
				startIndex++;
				continue;
			}
			if (i === startIndex) {
				result += prefix;
			} else {
				result += (separator || ",");
			}
			if (Array.isArray(value)) {
				if (showVariables) {
					result += varSpec.name + "=";
				}
				for (var j = 0; j < value.length; j++) {
					if (j > 0) {
						result += varSpec.suffices['*'] ? (separator || ",") : ",";
						if (varSpec.suffices['*'] && showVariables) {
							result += varSpec.name + "=";
						}
					}
					result += shouldEscape ? encodeURIComponent(value[j]).replace(/!/g, "%21") : notReallyPercentEncode(value[j]);
				}
			} else if (typeof value === "object") {
				if (showVariables && !varSpec.suffices['*']) {
					result += varSpec.name + "=";
				}
				var first = true;
				for (var key in value) {
					if (!first) {
						result += varSpec.suffices['*'] ? (separator || ",") : ",";
					}
					first = false;
					result += shouldEscape ? encodeURIComponent(key).replace(/!/g, "%21") : notReallyPercentEncode(key);
					result += varSpec.suffices['*'] ? '=' : ",";
					result += shouldEscape ? encodeURIComponent(value[key]).replace(/!/g, "%21") : notReallyPercentEncode(value[key]);
				}
			} else {
				if (showVariables) {
					result += varSpec.name;
					if (!trimEmptyString || value !== "") {
						result += "=";
					}
				}
				if (varSpec.truncate != null) {
					value = value.substring(0, varSpec.truncate);
				}
				result += shouldEscape ? encodeURIComponent(value).replace(/!/g, "%21"): notReallyPercentEncode(value);
			}
		}
		return result;
	};
	subFunction.varNames = varNames;
	return {
		prefix: prefix,
		substitution: subFunction
	};
}

function UriTemplate(template) {
	if (!(this instanceof UriTemplate)) {
		return new UriTemplate(template);
	}
	var parts = template.split("{");
	var textParts = [parts.shift()];
	var prefixes = [];
	var substitutions = [];
	var varNames = [];
	while (parts.length > 0) {
		var part = parts.shift();
		var spec = part.split("}")[0];
		var remainder = part.substring(spec.length + 1);
		var funcs = uriTemplateSubstitution(spec);
		substitutions.push(funcs.substitution);
		prefixes.push(funcs.prefix);
		textParts.push(remainder);
		varNames = varNames.concat(funcs.substitution.varNames);
	}
	this.fill = function (valueFunction) {
		var result = textParts[0];
		for (var i = 0; i < substitutions.length; i++) {
			var substitution = substitutions[i];
			result += substitution(valueFunction);
			result += textParts[i + 1];
		}
		return result;
	};
	this.varNames = varNames;
	this.template = template;
}
UriTemplate.prototype = {
	toString: function () {
		return this.template;
	},
	fillFromObject: function (obj) {
		return this.fill(function (varName) {
			return obj[varName];
		});
	}
};
var ValidatorContext = function ValidatorContext(parent, collectMultiple, errorReporter, checkRecursive, trackUnknownProperties) {
	this.missing = [];
	this.missingMap = {};
	this.formatValidators = parent ? Object.create(parent.formatValidators) : {};
	this.schemas = parent ? Object.create(parent.schemas) : {};
	this.collectMultiple = collectMultiple;
	this.errors = [];
	this.handleError = collectMultiple ? this.collectError : this.returnError;
	if (checkRecursive) {
		this.checkRecursive = true;
		this.scanned = [];
		this.scannedFrozen = [];
		this.scannedFrozenSchemas = [];
		this.scannedFrozenValidationErrors = [];
		this.validatedSchemasKey = 'tv4_validation_id';
		this.validationErrorsKey = 'tv4_validation_errors_id';
	}
	if (trackUnknownProperties) {
		this.trackUnknownProperties = true;
		this.knownPropertyPaths = {};
		this.unknownPropertyPaths = {};
	}
	this.errorReporter = errorReporter || defaultErrorReporter('en');
	if (typeof this.errorReporter === 'string') {
		throw new Error('debug');
	}
	this.definedKeywords = {};
	if (parent) {
		for (var key in parent.definedKeywords) {
			this.definedKeywords[key] = parent.definedKeywords[key].slice(0);
		}
	}
};
ValidatorContext.prototype.defineKeyword = function (keyword, keywordFunction) {
	this.definedKeywords[keyword] = this.definedKeywords[keyword] || [];
	this.definedKeywords[keyword].push(keywordFunction);
};
ValidatorContext.prototype.createError = function (code, messageParams, dataPath, schemaPath, subErrors, data, schema) {
	var error = new ValidationError(code, messageParams, dataPath, schemaPath, subErrors);
	error.message = this.errorReporter(error, data, schema);
	return error;
};
ValidatorContext.prototype.returnError = function (error) {
	return error;
};
ValidatorContext.prototype.collectError = function (error) {
	if (error) {
		this.errors.push(error);
	}
	return null;
};
ValidatorContext.prototype.prefixErrors = function (startIndex, dataPath, schemaPath) {
	for (var i = startIndex; i < this.errors.length; i++) {
		this.errors[i] = this.errors[i].prefixWith(dataPath, schemaPath);
	}
	return this;
};
ValidatorContext.prototype.banUnknownProperties = function (data, schema) {
	for (var unknownPath in this.unknownPropertyPaths) {
		var error = this.createError(ErrorCodes.UNKNOWN_PROPERTY, {path: unknownPath}, unknownPath, "", null, data, schema);
		var result = this.handleError(error);
		if (result) {
			return result;
		}
	}
	return null;
};

ValidatorContext.prototype.addFormat = function (format, validator) {
	if (typeof format === 'object') {
		for (var key in format) {
			this.addFormat(key, format[key]);
		}
		return this;
	}
	this.formatValidators[format] = validator;
};
ValidatorContext.prototype.resolveRefs = function (schema, urlHistory) {
	if (schema['$ref'] !== undefined) {
		urlHistory = urlHistory || {};
		if (urlHistory[schema['$ref']]) {
			return this.createError(ErrorCodes.CIRCULAR_REFERENCE, {urls: Object.keys(urlHistory).join(', ')}, '', '', null, undefined, schema);
		}
		urlHistory[schema['$ref']] = true;
		schema = this.getSchema(schema['$ref'], urlHistory);
	}
	return schema;
};
ValidatorContext.prototype.getSchema = function (url, urlHistory) {
	var schema;
	if (this.schemas[url] !== undefined) {
		schema = this.schemas[url];
		return this.resolveRefs(schema, urlHistory);
	}
	var baseUrl = url;
	var fragment = "";
	if (url.indexOf('#') !== -1) {
		fragment = url.substring(url.indexOf("#") + 1);
		baseUrl = url.substring(0, url.indexOf("#"));
	}
	if (typeof this.schemas[baseUrl] === 'object') {
		schema = this.schemas[baseUrl];
		var pointerPath = decodeURIComponent(fragment);
		if (pointerPath === "") {
			return this.resolveRefs(schema, urlHistory);
		} else if (pointerPath.charAt(0) !== "/") {
			return undefined;
		}
		var parts = pointerPath.split("/").slice(1);
		for (var i = 0; i < parts.length; i++) {
			var component = parts[i].replace(/~1/g, "/").replace(/~0/g, "~");
			if (schema[component] === undefined) {
				schema = undefined;
				break;
			}
			schema = schema[component];
		}
		if (schema !== undefined) {
			return this.resolveRefs(schema, urlHistory);
		}
	}
	if (this.missing[baseUrl] === undefined) {
		this.missing.push(baseUrl);
		this.missing[baseUrl] = baseUrl;
		this.missingMap[baseUrl] = baseUrl;
	}
};
ValidatorContext.prototype.searchSchemas = function (schema, url) {
	if (Array.isArray(schema)) {
		for (var i = 0; i < schema.length; i++) {
			this.searchSchemas(schema[i], url);
		}
	} else if (schema && typeof schema === "object") {
		if (typeof schema.id === "string") {
			if (isTrustedUrl(url, schema.id)) {
				if (this.schemas[schema.id] === undefined) {
					this.schemas[schema.id] = schema;
				}
			}
		}
		for (var key in schema) {
			if (key !== "enum") {
				if (typeof schema[key] === "object") {
					this.searchSchemas(schema[key], url);
				} else if (key === "$ref") {
					var uri = getDocumentUri(schema[key]);
					if (uri && this.schemas[uri] === undefined && this.missingMap[uri] === undefined) {
						this.missingMap[uri] = uri;
					}
				}
			}
		}
	}
};
ValidatorContext.prototype.addSchema = function (url, schema) {
	//overload
	if (typeof url !== 'string' || typeof schema === 'undefined') {
		if (typeof url === 'object' && typeof url.id === 'string') {
			schema = url;
			url = schema.id;
		}
		else {
			return;
		}
	}
	if (url === getDocumentUri(url) + "#") {
		// Remove empty fragment
		url = getDocumentUri(url);
	}
	this.schemas[url] = schema;
	delete this.missingMap[url];
	normSchema(schema, url);
	this.searchSchemas(schema, url);
};

ValidatorContext.prototype.getSchemaMap = function () {
	var map = {};
	for (var key in this.schemas) {
		map[key] = this.schemas[key];
	}
	return map;
};

ValidatorContext.prototype.getSchemaUris = function (filterRegExp) {
	var list = [];
	for (var key in this.schemas) {
		if (!filterRegExp || filterRegExp.test(key)) {
			list.push(key);
		}
	}
	return list;
};

ValidatorContext.prototype.getMissingUris = function (filterRegExp) {
	var list = [];
	for (var key in this.missingMap) {
		if (!filterRegExp || filterRegExp.test(key)) {
			list.push(key);
		}
	}
	return list;
};

ValidatorContext.prototype.dropSchemas = function () {
	this.schemas = {};
	this.reset();
};
ValidatorContext.prototype.reset = function () {
	this.missing = [];
	this.missingMap = {};
	this.errors = [];
};

ValidatorContext.prototype.validateAll = function (data, schema, dataPathParts, schemaPathParts, dataPointerPath) {
	var topLevel;
	schema = this.resolveRefs(schema);
	if (!schema) {
		return null;
	} else if (schema instanceof ValidationError) {
		this.errors.push(schema);
		return schema;
	}

	var startErrorCount = this.errors.length;
	var frozenIndex, scannedFrozenSchemaIndex = null, scannedSchemasIndex = null;
	if (this.checkRecursive && data && typeof data === 'object') {
		topLevel = !this.scanned.length;
		if (data[this.validatedSchemasKey]) {
			var schemaIndex = data[this.validatedSchemasKey].indexOf(schema);
			if (schemaIndex !== -1) {
				this.errors = this.errors.concat(data[this.validationErrorsKey][schemaIndex]);
				return null;
			}
		}
		if (Object.isFrozen(data)) {
			frozenIndex = this.scannedFrozen.indexOf(data);
			if (frozenIndex !== -1) {
				var frozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].indexOf(schema);
				if (frozenSchemaIndex !== -1) {
					this.errors = this.errors.concat(this.scannedFrozenValidationErrors[frozenIndex][frozenSchemaIndex]);
					return null;
				}
			}
		}
		this.scanned.push(data);
		if (Object.isFrozen(data)) {
			if (frozenIndex === -1) {
				frozenIndex = this.scannedFrozen.length;
				this.scannedFrozen.push(data);
				this.scannedFrozenSchemas.push([]);
			}
			scannedFrozenSchemaIndex = this.scannedFrozenSchemas[frozenIndex].length;
			this.scannedFrozenSchemas[frozenIndex][scannedFrozenSchemaIndex] = schema;
			this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = [];
		} else {
			if (!data[this.validatedSchemasKey]) {
				try {
					Object.defineProperty(data, this.validatedSchemasKey, {
						value: [],
						configurable: true
					});
					Object.defineProperty(data, this.validationErrorsKey, {
						value: [],
						configurable: true
					});
				} catch (e) {
					//IE 7/8 workaround
					data[this.validatedSchemasKey] = [];
					data[this.validationErrorsKey] = [];
				}
			}
			scannedSchemasIndex = data[this.validatedSchemasKey].length;
			data[this.validatedSchemasKey][scannedSchemasIndex] = schema;
			data[this.validationErrorsKey][scannedSchemasIndex] = [];
		}
	}

	var errorCount = this.errors.length;
	var error = this.validateBasic(data, schema, dataPointerPath)
		|| this.validateNumeric(data, schema, dataPointerPath)
		|| this.validateString(data, schema, dataPointerPath)
		|| this.validateArray(data, schema, dataPointerPath)
		|| this.validateObject(data, schema, dataPointerPath)
		|| this.validateCombinations(data, schema, dataPointerPath)
		|| this.validateHypermedia(data, schema, dataPointerPath)
		|| this.validateFormat(data, schema, dataPointerPath)
		|| this.validateDefinedKeywords(data, schema, dataPointerPath)
		|| null;

	if (topLevel) {
		while (this.scanned.length) {
			var item = this.scanned.pop();
			delete item[this.validatedSchemasKey];
		}
		this.scannedFrozen = [];
		this.scannedFrozenSchemas = [];
	}

	if (error || errorCount !== this.errors.length) {
		while ((dataPathParts && dataPathParts.length) || (schemaPathParts && schemaPathParts.length)) {
			var dataPart = (dataPathParts && dataPathParts.length) ? "" + dataPathParts.pop() : null;
			var schemaPart = (schemaPathParts && schemaPathParts.length) ? "" + schemaPathParts.pop() : null;
			if (error) {
				error = error.prefixWith(dataPart, schemaPart);
			}
			this.prefixErrors(errorCount, dataPart, schemaPart);
		}
	}

	if (scannedFrozenSchemaIndex !== null) {
		this.scannedFrozenValidationErrors[frozenIndex][scannedFrozenSchemaIndex] = this.errors.slice(startErrorCount);
	} else if (scannedSchemasIndex !== null) {
		data[this.validationErrorsKey][scannedSchemasIndex] = this.errors.slice(startErrorCount);
	}

	return this.handleError(error);
};
ValidatorContext.prototype.validateFormat = function (data, schema) {
	if (typeof schema.format !== 'string' || !this.formatValidators[schema.format]) {
		return null;
	}
	var errorMessage = this.formatValidators[schema.format].call(null, data, schema);
	if (typeof errorMessage === 'string' || typeof errorMessage === 'number') {
		return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage}, '', '/format', null, data, schema);
	} else if (errorMessage && typeof errorMessage === 'object') {
		return this.createError(ErrorCodes.FORMAT_CUSTOM, {message: errorMessage.message || "?"}, errorMessage.dataPath || '', errorMessage.schemaPath || "/format", null, data, schema);
	}
	return null;
};
ValidatorContext.prototype.validateDefinedKeywords = function (data, schema, dataPointerPath) {
	for (var key in this.definedKeywords) {
		if (typeof schema[key] === 'undefined') {
			continue;
		}
		var validationFunctions = this.definedKeywords[key];
		for (var i = 0; i < validationFunctions.length; i++) {
			var func = validationFunctions[i];
			var result = func(data, schema[key], schema, dataPointerPath);
			if (typeof result === 'string' || typeof result === 'number') {
				return this.createError(ErrorCodes.KEYWORD_CUSTOM, {key: key, message: result}, '', '', null, data, schema).prefixWith(null, key);
			} else if (result && typeof result === 'object') {
				var code = result.code;
				if (typeof code === 'string') {
					if (!ErrorCodes[code]) {
						throw new Error('Undefined error code (use defineError): ' + code);
					}
					code = ErrorCodes[code];
				} else if (typeof code !== 'number') {
					code = ErrorCodes.KEYWORD_CUSTOM;
				}
				var messageParams = (typeof result.message === 'object') ? result.message : {key: key, message: result.message || "?"};
				var schemaPath = result.schemaPath || ("/" + key.replace(/~/g, '~0').replace(/\//g, '~1'));
				return this.createError(code, messageParams, result.dataPath || null, schemaPath, null, data, schema);
			}
		}
	}
	return null;
};

function recursiveCompare(A, B) {
	if (A === B) {
		return true;
	}
	if (A && B && typeof A === "object" && typeof B === "object") {
		if (Array.isArray(A) !== Array.isArray(B)) {
			return false;
		} else if (Array.isArray(A)) {
			if (A.length !== B.length) {
				return false;
			}
			for (var i = 0; i < A.length; i++) {
				if (!recursiveCompare(A[i], B[i])) {
					return false;
				}
			}
		} else {
			var key;
			for (key in A) {
				if (B[key] === undefined && A[key] !== undefined) {
					return false;
				}
			}
			for (key in B) {
				if (A[key] === undefined && B[key] !== undefined) {
					return false;
				}
			}
			for (key in A) {
				if (!recursiveCompare(A[key], B[key])) {
					return false;
				}
			}
		}
		return true;
	}
	return false;
}

ValidatorContext.prototype.validateBasic = function validateBasic(data, schema, dataPointerPath) {
	var error;
	if (error = this.validateType(data, schema, dataPointerPath)) {
		return error.prefixWith(null, "type");
	}
	if (error = this.validateEnum(data, schema, dataPointerPath)) {
		return error.prefixWith(null, "type");
	}
	return null;
};

ValidatorContext.prototype.validateType = function validateType(data, schema) {
	if (schema.type === undefined) {
		return null;
	}
	var dataType = typeof data;
	if (data === null) {
		dataType = "null";
	} else if (Array.isArray(data)) {
		dataType = "array";
	}
	var allowedTypes = schema.type;
	if (!Array.isArray(allowedTypes)) {
		allowedTypes = [allowedTypes];
	}

	for (var i = 0; i < allowedTypes.length; i++) {
		var type = allowedTypes[i];
		if (type === dataType || (type === "integer" && dataType === "number" && (data % 1 === 0))) {
			return null;
		}
	}
	return this.createError(ErrorCodes.INVALID_TYPE, {type: dataType, expected: allowedTypes.join("/")}, '', '', null, data, schema);
};

ValidatorContext.prototype.validateEnum = function validateEnum(data, schema) {
	if (schema["enum"] === undefined) {
		return null;
	}
	for (var i = 0; i < schema["enum"].length; i++) {
		var enumVal = schema["enum"][i];
		if (recursiveCompare(data, enumVal)) {
			return null;
		}
	}
	return this.createError(ErrorCodes.ENUM_MISMATCH, {value: (typeof JSON !== 'undefined') ? JSON.stringify(data) : data}, '', '', null, data, schema);
};

ValidatorContext.prototype.validateNumeric = function validateNumeric(data, schema, dataPointerPath) {
	return this.validateMultipleOf(data, schema, dataPointerPath)
		|| this.validateMinMax(data, schema, dataPointerPath)
		|| this.validateNaN(data, schema, dataPointerPath)
		|| null;
};

var CLOSE_ENOUGH_LOW = Math.pow(2, -51);
var CLOSE_ENOUGH_HIGH = 1 - CLOSE_ENOUGH_LOW;
ValidatorContext.prototype.validateMultipleOf = function validateMultipleOf(data, schema) {
	var multipleOf = schema.multipleOf || schema.divisibleBy;
	if (multipleOf === undefined) {
		return null;
	}
	if (typeof data === "number") {
		var remainder = (data/multipleOf)%1;
		if (remainder >= CLOSE_ENOUGH_LOW && remainder < CLOSE_ENOUGH_HIGH) {
			return this.createError(ErrorCodes.NUMBER_MULTIPLE_OF, {value: data, multipleOf: multipleOf}, '', '', null, data, schema);
		}
	}
	return null;
};

ValidatorContext.prototype.validateMinMax = function validateMinMax(data, schema) {
	if (typeof data !== "number") {
		return null;
	}
	if (schema.minimum !== undefined) {
		if (data < schema.minimum) {
			return this.createError(ErrorCodes.NUMBER_MINIMUM, {value: data, minimum: schema.minimum}, '', '/minimum', null, data, schema);
		}
		if (schema.exclusiveMinimum && data === schema.minimum) {
			return this.createError(ErrorCodes.NUMBER_MINIMUM_EXCLUSIVE, {value: data, minimum: schema.minimum}, '', '/exclusiveMinimum', null, data, schema);
		}
	}
	if (schema.maximum !== undefined) {
		if (data > schema.maximum) {
			return this.createError(ErrorCodes.NUMBER_MAXIMUM, {value: data, maximum: schema.maximum}, '', '/maximum', null, data, schema);
		}
		if (schema.exclusiveMaximum && data === schema.maximum) {
			return this.createError(ErrorCodes.NUMBER_MAXIMUM_EXCLUSIVE, {value: data, maximum: schema.maximum}, '', '/exclusiveMaximum', null, data, schema);
		}
	}
	return null;
};

ValidatorContext.prototype.validateNaN = function validateNaN(data, schema) {
	if (typeof data !== "number") {
		return null;
	}
	if (isNaN(data) === true || data === Infinity || data === -Infinity) {
		return this.createError(ErrorCodes.NUMBER_NOT_A_NUMBER, {value: data}, '', '/type', null, data, schema);
	}
	return null;
};

ValidatorContext.prototype.validateString = function validateString(data, schema, dataPointerPath) {
	return this.validateStringLength(data, schema, dataPointerPath)
		|| this.validateStringPattern(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateStringLength = function validateStringLength(data, schema) {
	if (typeof data !== "string") {
		return null;
	}
	if (schema.minLength !== undefined) {
		if (data.length < schema.minLength) {
			return this.createError(ErrorCodes.STRING_LENGTH_SHORT, {length: data.length, minimum: schema.minLength}, '', '/minLength', null, data, schema);
		}
	}
	if (schema.maxLength !== undefined) {
		if (data.length > schema.maxLength) {
			return this.createError(ErrorCodes.STRING_LENGTH_LONG, {length: data.length, maximum: schema.maxLength}, '', '/maxLength', null, data, schema);
		}
	}
	return null;
};

ValidatorContext.prototype.validateStringPattern = function validateStringPattern(data, schema) {
	if (typeof data !== "string" || (typeof schema.pattern !== "string" && !(schema.pattern instanceof RegExp))) {
		return null;
	}
	var regexp;
	if (schema.pattern instanceof RegExp) {
	  regexp = schema.pattern;
	}
	else {
	  var body, flags = '';
	  // Check for regular expression literals
	  // @see http://www.ecma-international.org/ecma-262/5.1/#sec-7.8.5
	  var literal = schema.pattern.match(/^\/(.+)\/([img]*)$/);
	  if (literal) {
	    body = literal[1];
	    flags = literal[2];
	  }
	  else {
	    body = schema.pattern;
	  }
	  regexp = new RegExp(body, flags);
	}
	if (!regexp.test(data)) {
		return this.createError(ErrorCodes.STRING_PATTERN, {pattern: schema.pattern}, '', '/pattern', null, data, schema);
	}
	return null;
};

ValidatorContext.prototype.validateArray = function validateArray(data, schema, dataPointerPath) {
	if (!Array.isArray(data)) {
		return null;
	}
	return this.validateArrayLength(data, schema, dataPointerPath)
		|| this.validateArrayUniqueItems(data, schema, dataPointerPath)
		|| this.validateArrayItems(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateArrayLength = function validateArrayLength(data, schema) {
	var error;
	if (schema.minItems !== undefined) {
		if (data.length < schema.minItems) {
			error = this.createError(ErrorCodes.ARRAY_LENGTH_SHORT, {length: data.length, minimum: schema.minItems}, '', '/minItems', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	if (schema.maxItems !== undefined) {
		if (data.length > schema.maxItems) {
			error = this.createError(ErrorCodes.ARRAY_LENGTH_LONG, {length: data.length, maximum: schema.maxItems}, '', '/maxItems', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateArrayUniqueItems = function validateArrayUniqueItems(data, schema) {
	if (schema.uniqueItems) {
		for (var i = 0; i < data.length; i++) {
			for (var j = i + 1; j < data.length; j++) {
				if (recursiveCompare(data[i], data[j])) {
					var error = this.createError(ErrorCodes.ARRAY_UNIQUE, {match1: i, match2: j}, '', '/uniqueItems', null, data, schema);
					if (this.handleError(error)) {
						return error;
					}
				}
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateArrayItems = function validateArrayItems(data, schema, dataPointerPath) {
	if (schema.items === undefined) {
		return null;
	}
	var error, i;
	if (Array.isArray(schema.items)) {
		for (i = 0; i < data.length; i++) {
			if (i < schema.items.length) {
				if (error = this.validateAll(data[i], schema.items[i], [i], ["items", i], dataPointerPath + "/" + i)) {
					return error;
				}
			} else if (schema.additionalItems !== undefined) {
				if (typeof schema.additionalItems === "boolean") {
					if (!schema.additionalItems) {
						error = (this.createError(ErrorCodes.ARRAY_ADDITIONAL_ITEMS, {}, '/' + i, '/additionalItems', null, data, schema));
						if (this.handleError(error)) {
							return error;
						}
					}
				} else if (error = this.validateAll(data[i], schema.additionalItems, [i], ["additionalItems"], dataPointerPath + "/" + i)) {
					return error;
				}
			}
		}
	} else {
		for (i = 0; i < data.length; i++) {
			if (error = this.validateAll(data[i], schema.items, [i], ["items"], dataPointerPath + "/" + i)) {
				return error;
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateObject = function validateObject(data, schema, dataPointerPath) {
	if (typeof data !== "object" || data === null || Array.isArray(data)) {
		return null;
	}
	return this.validateObjectMinMaxProperties(data, schema, dataPointerPath)
		|| this.validateObjectRequiredProperties(data, schema, dataPointerPath)
		|| this.validateObjectProperties(data, schema, dataPointerPath)
		|| this.validateObjectDependencies(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateObjectMinMaxProperties = function validateObjectMinMaxProperties(data, schema) {
	var keys = Object.keys(data);
	var error;
	if (schema.minProperties !== undefined) {
		if (keys.length < schema.minProperties) {
			error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MINIMUM, {propertyCount: keys.length, minimum: schema.minProperties}, '', '/minProperties', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	if (schema.maxProperties !== undefined) {
		if (keys.length > schema.maxProperties) {
			error = this.createError(ErrorCodes.OBJECT_PROPERTIES_MAXIMUM, {propertyCount: keys.length, maximum: schema.maxProperties}, '', '/maxProperties', null, data, schema);
			if (this.handleError(error)) {
				return error;
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateObjectRequiredProperties = function validateObjectRequiredProperties(data, schema) {
	if (schema.required !== undefined) {
		for (var i = 0; i < schema.required.length; i++) {
			var key = schema.required[i];
			if (data[key] === undefined) {
				var error = this.createError(ErrorCodes.OBJECT_REQUIRED, {key: key}, '', '/required/' + i, null, data, schema);
				if (this.handleError(error)) {
					return error;
				}
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateObjectProperties = function validateObjectProperties(data, schema, dataPointerPath) {
	var error;
	for (var key in data) {
		var keyPointerPath = dataPointerPath + "/" + key.replace(/~/g, '~0').replace(/\//g, '~1');
		var foundMatch = false;
		if (schema.properties !== undefined && schema.properties[key] !== undefined) {
			foundMatch = true;
			if (error = this.validateAll(data[key], schema.properties[key], [key], ["properties", key], keyPointerPath)) {
				return error;
			}
		}
		if (schema.patternProperties !== undefined) {
			for (var patternKey in schema.patternProperties) {
				var regexp = new RegExp(patternKey);
				if (regexp.test(key)) {
					foundMatch = true;
					if (error = this.validateAll(data[key], schema.patternProperties[patternKey], [key], ["patternProperties", patternKey], keyPointerPath)) {
						return error;
					}
				}
			}
		}
		if (!foundMatch) {
			if (schema.additionalProperties !== undefined) {
				if (this.trackUnknownProperties) {
					this.knownPropertyPaths[keyPointerPath] = true;
					delete this.unknownPropertyPaths[keyPointerPath];
				}
				if (typeof schema.additionalProperties === "boolean") {
					if (!schema.additionalProperties) {
						error = this.createError(ErrorCodes.OBJECT_ADDITIONAL_PROPERTIES, {key: key}, '', '/additionalProperties', null, data, schema).prefixWith(key, null);
						if (this.handleError(error)) {
							return error;
						}
					}
				} else {
					if (error = this.validateAll(data[key], schema.additionalProperties, [key], ["additionalProperties"], keyPointerPath)) {
						return error;
					}
				}
			} else if (this.trackUnknownProperties && !this.knownPropertyPaths[keyPointerPath]) {
				this.unknownPropertyPaths[keyPointerPath] = true;
			}
		} else if (this.trackUnknownProperties) {
			this.knownPropertyPaths[keyPointerPath] = true;
			delete this.unknownPropertyPaths[keyPointerPath];
		}
	}
	return null;
};

ValidatorContext.prototype.validateObjectDependencies = function validateObjectDependencies(data, schema, dataPointerPath) {
	var error;
	if (schema.dependencies !== undefined) {
		for (var depKey in schema.dependencies) {
			if (data[depKey] !== undefined) {
				var dep = schema.dependencies[depKey];
				if (typeof dep === "string") {
					if (data[dep] === undefined) {
						error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: dep}, '', '', null, data, schema).prefixWith(null, depKey).prefixWith(null, "dependencies");
						if (this.handleError(error)) {
							return error;
						}
					}
				} else if (Array.isArray(dep)) {
					for (var i = 0; i < dep.length; i++) {
						var requiredKey = dep[i];
						if (data[requiredKey] === undefined) {
							error = this.createError(ErrorCodes.OBJECT_DEPENDENCY_KEY, {key: depKey, missing: requiredKey}, '', '/' + i, null, data, schema).prefixWith(null, depKey).prefixWith(null, "dependencies");
							if (this.handleError(error)) {
								return error;
							}
						}
					}
				} else {
					if (error = this.validateAll(data, dep, [], ["dependencies", depKey], dataPointerPath)) {
						return error;
					}
				}
			}
		}
	}
	return null;
};

ValidatorContext.prototype.validateCombinations = function validateCombinations(data, schema, dataPointerPath) {
	return this.validateAllOf(data, schema, dataPointerPath)
		|| this.validateAnyOf(data, schema, dataPointerPath)
		|| this.validateOneOf(data, schema, dataPointerPath)
		|| this.validateNot(data, schema, dataPointerPath)
		|| null;
};

ValidatorContext.prototype.validateAllOf = function validateAllOf(data, schema, dataPointerPath) {
	if (schema.allOf === undefined) {
		return null;
	}
	var error;
	for (var i = 0; i < schema.allOf.length; i++) {
		var subSchema = schema.allOf[i];
		if (error = this.validateAll(data, subSchema, [], ["allOf", i], dataPointerPath)) {
			return error;
		}
	}
	return null;
};

ValidatorContext.prototype.validateAnyOf = function validateAnyOf(data, schema, dataPointerPath) {
	if (schema.anyOf === undefined) {
		return null;
	}
	var errors = [];
	var startErrorCount = this.errors.length;
	var oldUnknownPropertyPaths, oldKnownPropertyPaths;
	if (this.trackUnknownProperties) {
		oldUnknownPropertyPaths = this.unknownPropertyPaths;
		oldKnownPropertyPaths = this.knownPropertyPaths;
	}
	var errorAtEnd = true;
	for (var i = 0; i < schema.anyOf.length; i++) {
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = {};
			this.knownPropertyPaths = {};
		}
		var subSchema = schema.anyOf[i];

		var errorCount = this.errors.length;
		var error = this.validateAll(data, subSchema, [], ["anyOf", i], dataPointerPath);

		if (error === null && errorCount === this.errors.length) {
			this.errors = this.errors.slice(0, startErrorCount);

			if (this.trackUnknownProperties) {
				for (var knownKey in this.knownPropertyPaths) {
					oldKnownPropertyPaths[knownKey] = true;
					delete oldUnknownPropertyPaths[knownKey];
				}
				for (var unknownKey in this.unknownPropertyPaths) {
					if (!oldKnownPropertyPaths[unknownKey]) {
						oldUnknownPropertyPaths[unknownKey] = true;
					}
				}
				// We need to continue looping so we catch all the property definitions, but we don't want to return an error
				errorAtEnd = false;
				continue;
			}

			return null;
		}
		if (error) {
			errors.push(error.prefixWith(null, "" + i).prefixWith(null, "anyOf"));
		}
	}
	if (this.trackUnknownProperties) {
		this.unknownPropertyPaths = oldUnknownPropertyPaths;
		this.knownPropertyPaths = oldKnownPropertyPaths;
	}
	if (errorAtEnd) {
		errors = errors.concat(this.errors.slice(startErrorCount));
		this.errors = this.errors.slice(0, startErrorCount);
		return this.createError(ErrorCodes.ANY_OF_MISSING, {}, "", "/anyOf", errors, data, schema);
	}
};

ValidatorContext.prototype.validateOneOf = function validateOneOf(data, schema, dataPointerPath) {
	if (schema.oneOf === undefined) {
		return null;
	}
	var validIndex = null;
	var errors = [];
	var startErrorCount = this.errors.length;
	var oldUnknownPropertyPaths, oldKnownPropertyPaths;
	if (this.trackUnknownProperties) {
		oldUnknownPropertyPaths = this.unknownPropertyPaths;
		oldKnownPropertyPaths = this.knownPropertyPaths;
	}
	for (var i = 0; i < schema.oneOf.length; i++) {
		if (this.trackUnknownProperties) {
			this.unknownPropertyPaths = {};
			this.knownPropertyPaths = {};
		}
		var subSchema = schema.oneOf[i];

		var errorCount = this.errors.length;
		var error = this.validateAll(data, subSchema, [], ["oneOf", i], dataPointerPath);

		if (error === null && errorCount === this.errors.length) {
			if (validIndex === null) {
				validIndex = i;
			} else {
				this.errors = this.errors.slice(0, startErrorCount);
				return this.createError(ErrorCodes.ONE_OF_MULTIPLE, {index1: validIndex, index2: i}, "", "/oneOf", null, data, schema);
			}
			if (this.trackUnknownProperties) {
				for (var knownKey in this.knownPropertyPaths) {
					oldKnownPropertyPaths[knownKey] = true;
					delete oldUnknownPropertyPaths[knownKey];
				}
				for (var unknownKey in this.unknownPropertyPaths) {
					if (!oldKnownPropertyPaths[unknownKey]) {
						oldUnknownPropertyPaths[unknownKey] = true;
					}
				}
			}
		} else if (error) {
			errors.push(error);
		}
	}
	if (this.trackUnknownProperties) {
		this.unknownPropertyPaths = oldUnknownPropertyPaths;
		this.knownPropertyPaths = oldKnownPropertyPaths;
	}
	if (validIndex === null) {
		errors = errors.concat(this.errors.slice(startErrorCount));
		this.errors = this.errors.slice(0, startErrorCount);
		return this.createError(ErrorCodes.ONE_OF_MISSING, {}, "", "/oneOf", errors, data, schema);
	} else {
		this.errors = this.errors.slice(0, startErrorCount);
	}
	return null;
};

ValidatorContext.prototype.validateNot = function validateNot(data, schema, dataPointerPath) {
	if (schema.not === undefined) {
		return null;
	}
	var oldErrorCount = this.errors.length;
	var oldUnknownPropertyPaths, oldKnownPropertyPaths;
	if (this.trackUnknownProperties) {
		oldUnknownPropertyPaths = this.unknownPropertyPaths;
		oldKnownPropertyPaths = this.knownPropertyPaths;
		this.unknownPropertyPaths = {};
		this.knownPropertyPaths = {};
	}
	var error = this.validateAll(data, schema.not, null, null, dataPointerPath);
	var notErrors = this.errors.slice(oldErrorCount);
	this.errors = this.errors.slice(0, oldErrorCount);
	if (this.trackUnknownProperties) {
		this.unknownPropertyPaths = oldUnknownPropertyPaths;
		this.knownPropertyPaths = oldKnownPropertyPaths;
	}
	if (error === null && notErrors.length === 0) {
		return this.createError(ErrorCodes.NOT_PASSED, {}, "", "/not", null, data, schema);
	}
	return null;
};

ValidatorContext.prototype.validateHypermedia = function validateCombinations(data, schema, dataPointerPath) {
	if (!schema.links) {
		return null;
	}
	var error;
	for (var i = 0; i < schema.links.length; i++) {
		var ldo = schema.links[i];
		if (ldo.rel === "describedby") {
			var template = new UriTemplate(ldo.href);
			var allPresent = true;
			for (var j = 0; j < template.varNames.length; j++) {
				if (!(template.varNames[j] in data)) {
					allPresent = false;
					break;
				}
			}
			if (allPresent) {
				var schemaUrl = template.fillFromObject(data);
				var subSchema = {"$ref": schemaUrl};
				if (error = this.validateAll(data, subSchema, [], ["links", i], dataPointerPath)) {
					return error;
				}
			}
		}
	}
};

// parseURI() and resolveUrl() are from https://gist.github.com/1088850
//   -  released as public domain by author ("Yaffle") - see comments on gist

function parseURI(url) {
	var m = String(url).replace(/^\s+|\s+$/g, '').match(/^([^:\/?#]+:)?(\/\/(?:[^:@]*(?::[^:@]*)?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
	// authority = '//' + user + ':' + pass '@' + hostname + ':' port
	return (m ? {
		href     : m[0] || '',
		protocol : m[1] || '',
		authority: m[2] || '',
		host     : m[3] || '',
		hostname : m[4] || '',
		port     : m[5] || '',
		pathname : m[6] || '',
		search   : m[7] || '',
		hash     : m[8] || ''
	} : null);
}

function resolveUrl(base, href) {// RFC 3986

	function removeDotSegments(input) {
		var output = [];
		input.replace(/^(\.\.?(\/|$))+/, '')
			.replace(/\/(\.(\/|$))+/g, '/')
			.replace(/\/\.\.$/, '/../')
			.replace(/\/?[^\/]*/g, function (p) {
				if (p === '/..') {
					output.pop();
				} else {
					output.push(p);
				}
		});
		return output.join('').replace(/^\//, input.charAt(0) === '/' ? '/' : '');
	}

	href = parseURI(href || '');
	base = parseURI(base || '');

	return !href || !base ? null : (href.protocol || base.protocol) +
		(href.protocol || href.authority ? href.authority : base.authority) +
		removeDotSegments(href.protocol || href.authority || href.pathname.charAt(0) === '/' ? href.pathname : (href.pathname ? ((base.authority && !base.pathname ? '/' : '') + base.pathname.slice(0, base.pathname.lastIndexOf('/') + 1) + href.pathname) : base.pathname)) +
		(href.protocol || href.authority || href.pathname ? href.search : (href.search || base.search)) +
		href.hash;
}

function getDocumentUri(uri) {
	return uri.split('#')[0];
}
function normSchema(schema, baseUri) {
	if (schema && typeof schema === "object") {
		if (baseUri === undefined) {
			baseUri = schema.id;
		} else if (typeof schema.id === "string") {
			baseUri = resolveUrl(baseUri, schema.id);
			schema.id = baseUri;
		}
		if (Array.isArray(schema)) {
			for (var i = 0; i < schema.length; i++) {
				normSchema(schema[i], baseUri);
			}
		} else {
			if (typeof schema['$ref'] === "string") {
				schema['$ref'] = resolveUrl(baseUri, schema['$ref']);
			}
			for (var key in schema) {
				if (key !== "enum") {
					normSchema(schema[key], baseUri);
				}
			}
		}
	}
}

function defaultErrorReporter(language) {
	language = language || 'en';

	var errorMessages = languages[language];

	return function (error) {
		var messageTemplate = errorMessages[error.code] || ErrorMessagesDefault[error.code];
		if (typeof messageTemplate !== 'string') {
			return "Unknown error code " + error.code + ": " + JSON.stringify(error.messageParams);
		}
		var messageParams = error.params;
		// Adapted from Crockford's supplant()
		return messageTemplate.replace(/\{([^{}]*)\}/g, function (whole, varName) {
			var subValue = messageParams[varName];
			return typeof subValue === 'string' || typeof subValue === 'number' ? subValue : whole;
		});
	};
}

var ErrorCodes = {
	INVALID_TYPE: 0,
	ENUM_MISMATCH: 1,
	ANY_OF_MISSING: 10,
	ONE_OF_MISSING: 11,
	ONE_OF_MULTIPLE: 12,
	NOT_PASSED: 13,
	// Numeric errors
	NUMBER_MULTIPLE_OF: 100,
	NUMBER_MINIMUM: 101,
	NUMBER_MINIMUM_EXCLUSIVE: 102,
	NUMBER_MAXIMUM: 103,
	NUMBER_MAXIMUM_EXCLUSIVE: 104,
	NUMBER_NOT_A_NUMBER: 105,
	// String errors
	STRING_LENGTH_SHORT: 200,
	STRING_LENGTH_LONG: 201,
	STRING_PATTERN: 202,
	// Object errors
	OBJECT_PROPERTIES_MINIMUM: 300,
	OBJECT_PROPERTIES_MAXIMUM: 301,
	OBJECT_REQUIRED: 302,
	OBJECT_ADDITIONAL_PROPERTIES: 303,
	OBJECT_DEPENDENCY_KEY: 304,
	// Array errors
	ARRAY_LENGTH_SHORT: 400,
	ARRAY_LENGTH_LONG: 401,
	ARRAY_UNIQUE: 402,
	ARRAY_ADDITIONAL_ITEMS: 403,
	// Custom/user-defined errors
	FORMAT_CUSTOM: 500,
	KEYWORD_CUSTOM: 501,
	// Schema structure
	CIRCULAR_REFERENCE: 600,
	// Non-standard validation options
	UNKNOWN_PROPERTY: 1000
};
var ErrorCodeLookup = {};
for (var key in ErrorCodes) {
	ErrorCodeLookup[ErrorCodes[key]] = key;
}
var ErrorMessagesDefault = {
	INVALID_TYPE: "Invalid type: {type} (expected {expected})",
	ENUM_MISMATCH: "No enum match for: {value}",
	ANY_OF_MISSING: "Data does not match any schemas from \"anyOf\"",
	ONE_OF_MISSING: "Data does not match any schemas from \"oneOf\"",
	ONE_OF_MULTIPLE: "Data is valid against more than one schema from \"oneOf\": indices {index1} and {index2}",
	NOT_PASSED: "Data matches schema from \"not\"",
	// Numeric errors
	NUMBER_MULTIPLE_OF: "Value {value} is not a multiple of {multipleOf}",
	NUMBER_MINIMUM: "Value {value} is less than minimum {minimum}",
	NUMBER_MINIMUM_EXCLUSIVE: "Value {value} is equal to exclusive minimum {minimum}",
	NUMBER_MAXIMUM: "Value {value} is greater than maximum {maximum}",
	NUMBER_MAXIMUM_EXCLUSIVE: "Value {value} is equal to exclusive maximum {maximum}",
	NUMBER_NOT_A_NUMBER: "Value {value} is not a valid number",
	// String errors
	STRING_LENGTH_SHORT: "String is too short ({length} chars), minimum {minimum}",
	STRING_LENGTH_LONG: "String is too long ({length} chars), maximum {maximum}",
	STRING_PATTERN: "String does not match pattern: {pattern}",
	// Object errors
	OBJECT_PROPERTIES_MINIMUM: "Too few properties defined ({propertyCount}), minimum {minimum}",
	OBJECT_PROPERTIES_MAXIMUM: "Too many properties defined ({propertyCount}), maximum {maximum}",
	OBJECT_REQUIRED: "Missing required property: {key}",
	OBJECT_ADDITIONAL_PROPERTIES: "Additional properties not allowed",
	OBJECT_DEPENDENCY_KEY: "Dependency failed - key must exist: {missing} (due to key: {key})",
	// Array errors
	ARRAY_LENGTH_SHORT: "Array is too short ({length}), minimum {minimum}",
	ARRAY_LENGTH_LONG: "Array is too long ({length}), maximum {maximum}",
	ARRAY_UNIQUE: "Array items are not unique (indices {match1} and {match2})",
	ARRAY_ADDITIONAL_ITEMS: "Additional items not allowed",
	// Format errors
	FORMAT_CUSTOM: "Format validation failed ({message})",
	KEYWORD_CUSTOM: "Keyword failed: {key} ({message})",
	// Schema structure
	CIRCULAR_REFERENCE: "Circular $refs: {urls}",
	// Non-standard validation options
	UNKNOWN_PROPERTY: "Unknown property (not in schema)"
};

function ValidationError(code, params, dataPath, schemaPath, subErrors) {
	Error.call(this);
	if (code === undefined) {
		throw new Error ("No error code supplied: " + schemaPath);
	}
	this.message = '';
	this.params = params;
	this.code = code;
	this.dataPath = dataPath || "";
	this.schemaPath = schemaPath || "";
	this.subErrors = subErrors || null;

	var err = new Error(this.message);
	this.stack = err.stack || err.stacktrace;
	if (!this.stack) {
		try {
			throw err;
		}
		catch(err) {
			this.stack = err.stack || err.stacktrace;
		}
	}
}
ValidationError.prototype = Object.create(Error.prototype);
ValidationError.prototype.constructor = ValidationError;
ValidationError.prototype.name = 'ValidationError';

ValidationError.prototype.prefixWith = function (dataPrefix, schemaPrefix) {
	if (dataPrefix !== null) {
		dataPrefix = dataPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
		this.dataPath = "/" + dataPrefix + this.dataPath;
	}
	if (schemaPrefix !== null) {
		schemaPrefix = schemaPrefix.replace(/~/g, "~0").replace(/\//g, "~1");
		this.schemaPath = "/" + schemaPrefix + this.schemaPath;
	}
	if (this.subErrors !== null) {
		for (var i = 0; i < this.subErrors.length; i++) {
			this.subErrors[i].prefixWith(dataPrefix, schemaPrefix);
		}
	}
	return this;
};

function isTrustedUrl(baseUrl, testUrl) {
	if(testUrl.substring(0, baseUrl.length) === baseUrl){
		var remainder = testUrl.substring(baseUrl.length);
		if ((testUrl.length > 0 && testUrl.charAt(baseUrl.length - 1) === "/")
			|| remainder.charAt(0) === "#"
			|| remainder.charAt(0) === "?") {
			return true;
		}
	}
	return false;
}

var languages = {};
function createApi(language) {
	var globalContext = new ValidatorContext();
	var currentLanguage;
	var customErrorReporter;
	var api = {
		setErrorReporter: function (reporter) {
			if (typeof reporter === 'string') {
				return this.language(reporter);
			}
			customErrorReporter = reporter;
			return true;
		},
		addFormat: function () {
			globalContext.addFormat.apply(globalContext, arguments);
		},
		language: function (code) {
			if (!code) {
				return currentLanguage;
			}
			if (!languages[code]) {
				code = code.split('-')[0]; // fall back to base language
			}
			if (languages[code]) {
				currentLanguage = code;
				return code; // so you can tell if fall-back has happened
			}
			return false;
		},
		addLanguage: function (code, messageMap) {
			var key;
			for (key in ErrorCodes) {
				if (messageMap[key] && !messageMap[ErrorCodes[key]]) {
					messageMap[ErrorCodes[key]] = messageMap[key];
				}
			}
			var rootCode = code.split('-')[0];
			if (!languages[rootCode]) { // use for base language if not yet defined
				languages[code] = messageMap;
				languages[rootCode] = messageMap;
			} else {
				languages[code] = Object.create(languages[rootCode]);
				for (key in messageMap) {
					if (typeof languages[rootCode][key] === 'undefined') {
						languages[rootCode][key] = messageMap[key];
					}
					languages[code][key] = messageMap[key];
				}
			}
			return this;
		},
		freshApi: function (language) {
			var result = createApi();
			if (language) {
				result.language(language);
			}
			return result;
		},
		validate: function (data, schema, checkRecursive, banUnknownProperties) {
			var def = defaultErrorReporter(currentLanguage);
			var errorReporter = customErrorReporter ? function (error, data, schema) {
				return customErrorReporter(error, data, schema) || def(error, data, schema);
			} : def;
			var context = new ValidatorContext(globalContext, false, errorReporter, checkRecursive, banUnknownProperties);
			if (typeof schema === "string") {
				schema = {"$ref": schema};
			}
			context.addSchema("", schema);
			var error = context.validateAll(data, schema, null, null, "");
			if (!error && banUnknownProperties) {
				error = context.banUnknownProperties(data, schema);
			}
			this.error = error;
			this.missing = context.missing;
			this.valid = (error === null);

			this.toString = function () {
				if (this.error) {
					return this.error.message;
				} else {
					return 'Object passed schema validation';
				}
			};

			return this.valid;
		},
		validateResult: function () {
			var result = {};
			this.validate.apply(result, arguments);
			return result;
		},
		validateMultiple: function (data, schema, checkRecursive, banUnknownProperties) {
			var def = defaultErrorReporter(currentLanguage);
			var errorReporter = customErrorReporter ? function (error, data, schema) {
				return customErrorReporter(error, data, schema) || def(error, data, schema);
			} : def;
			var context = new ValidatorContext(globalContext, true, errorReporter, checkRecursive, banUnknownProperties);
			if (typeof schema === "string") {
				schema = {"$ref": schema};
			}
			context.addSchema("", schema);
			context.validateAll(data, schema, null, null, "");
			if (banUnknownProperties) {
				context.banUnknownProperties(data, schema);
			}
			var result = {};
			result.errors = context.errors;
			result.missing = context.missing;
			result.valid = (result.errors.length === 0);
			return result;
		},
		addSchema: function () {
			return globalContext.addSchema.apply(globalContext, arguments);
		},
		getSchema: function () {
			return globalContext.getSchema.apply(globalContext, arguments);
		},
		getSchemaMap: function () {
			return globalContext.getSchemaMap.apply(globalContext, arguments);
		},
		getSchemaUris: function () {
			return globalContext.getSchemaUris.apply(globalContext, arguments);
		},
		getMissingUris: function () {
			return globalContext.getMissingUris.apply(globalContext, arguments);
		},
		dropSchemas: function () {
			globalContext.dropSchemas.apply(globalContext, arguments);
		},
		defineKeyword: function () {
			globalContext.defineKeyword.apply(globalContext, arguments);
		},
		defineError: function (codeName, codeNumber, defaultMessage) {
			if (typeof codeName !== 'string' || !/^[A-Z]+(_[A-Z]+)*$/.test(codeName)) {
				throw new Error('Code name must be a string in UPPER_CASE_WITH_UNDERSCORES');
			}
			if (typeof codeNumber !== 'number' || codeNumber%1 !== 0 || codeNumber < 10000) {
				throw new Error('Code number must be an integer > 10000');
			}
			if (typeof ErrorCodes[codeName] !== 'undefined') {
				throw new Error('Error already defined: ' + codeName + ' as ' + ErrorCodes[codeName]);
			}
			if (typeof ErrorCodeLookup[codeNumber] !== 'undefined') {
				throw new Error('Error code already used: ' + ErrorCodeLookup[codeNumber] + ' as ' + codeNumber);
			}
			ErrorCodes[codeName] = codeNumber;
			ErrorCodeLookup[codeNumber] = codeName;
			ErrorMessagesDefault[codeName] = ErrorMessagesDefault[codeNumber] = defaultMessage;
			for (var langCode in languages) {
				var language = languages[langCode];
				if (language[codeName]) {
					language[codeNumber] = language[codeNumber] || language[codeName];
				}
			}
		},
		reset: function () {
			globalContext.reset();
			this.error = null;
			this.missing = [];
			this.valid = true;
		},
		missing: [],
		error: null,
		valid: true,
		normSchema: normSchema,
		resolveUrl: resolveUrl,
		getDocumentUri: getDocumentUri,
		errorCodes: ErrorCodes
	};
	api.language(language || 'en');
	return api;
}

var tv4 = createApi();
tv4.addLanguage('en-gb', ErrorMessagesDefault);

//legacy property
tv4.tv4 = tv4;

return tv4; // used by _header.js to globalise.

}));

/*!
 * angular-schema-form
 * @version 2.0.9
 * @date Wed, 02 Apr 2025 09:47:07 GMT
 * @link https://github.com/json-schema-form/angular-schema-form
 * @license MIT
 * Copyright (c) 2014-2025 JSON Schema Form
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * json-schema-form-core
 * @version 1.0.0-alpha.5
 * @date Sat, 24 Jun 2017 14:16:26 GMT
 * @link https://github.com/json-schema-form/json-schema-form-core
 * @license MIT
 * Copyright (c) 2014-2017 JSON Schema Form
 */
module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_objectpath__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_objectpath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_objectpath__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_objectpath__, "parse")) __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_0_objectpath__["parse"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_objectpath__, "stringify")) __webpack_require__.d(__webpack_exports__, "stringify", function() { return __WEBPACK_IMPORTED_MODULE_0_objectpath__["stringify"]; });
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0_objectpath__, "normalize")) __webpack_require__.d(__webpack_exports__, "normalize", function() { return __WEBPACK_IMPORTED_MODULE_0_objectpath__["normalize"]; });
/* harmony export (immutable) */ __webpack_exports__["name"] = name;




/**
 * I am a name formatter function for processing keys into names for classes or Id.
 *
 * @param  {Array<string>} key         I am the key array of a processed schema key
 * @param  {string}        separator   I am the separator between the key items and optional form name
 * @param  {string}        formName    I am an optional form name
 * @param  {boolean}       omitNumbers I determine if numeric values should be included in the output or withheld
 *
 * @return {string}                    I am the formatted key
 */
function name(key, separator) {
  var formName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var omitNumbers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (key) {
    var fieldKey = key.slice();
    var fieldSeparator = separator || '-';

    if (omitNumbers) {
      fieldKey = fieldKey.filter(function (currentKey) {
        return typeof currentKey !== 'number';
      });
    };

    return (formName.length !== 0 ? formName + fieldSeparator : '') + fieldKey.join(fieldSeparator);
  };

  return '';
};

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// Takes a titleMap in either object or list format and returns one
/* harmony default export */ __webpack_exports__["a"] = function (titleMap, originalEnum) {
  if (!Array.isArray(titleMap)) {
    var _ret = function () {
      var canonical = [];
      if (originalEnum) {
        originalEnum.forEach(function (value) {
          canonical.push({ name: titleMap[value], value: value });
        });
      } else {
        Object.keys(titleMap).forEach(function (value) {
          canonical.push({ name: titleMap[value], value: value });
        });
      }
      return {
        v: canonical
      };
    }();

    if ((typeof _ret === "undefined" ? "undefined" : _typeof(_ret)) === "object") return _ret.v;
  }
  return titleMap;
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11).ObjectPath;


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sf_path__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__canonical_title_map__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["defaultFormDefinition"] = defaultFormDefinition;
/* harmony export (immutable) */ __webpack_exports__["stdFormObj"] = stdFormObj;
/* harmony export (immutable) */ __webpack_exports__["text"] = text;
/* harmony export (immutable) */ __webpack_exports__["number"] = number;
/* harmony export (immutable) */ __webpack_exports__["integer"] = integer;
/* harmony export (immutable) */ __webpack_exports__["checkbox"] = checkbox;
/* harmony export (immutable) */ __webpack_exports__["select"] = select;
/* harmony export (immutable) */ __webpack_exports__["checkboxes"] = checkboxes;
/* harmony export (immutable) */ __webpack_exports__["fieldset"] = fieldset;
/* harmony export (immutable) */ __webpack_exports__["array"] = array;
/* harmony export (immutable) */ __webpack_exports__["createDefaults"] = createDefaults;
/* harmony export (immutable) */ __webpack_exports__["defaultForm"] = defaultForm;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




/* Utils */
var stripNullType = function stripNullType(type) {
  if (Array.isArray(type) && type.length === 2) {
    if (type[0] === 'null') {
      return type[1];
    };
    if (type[1] === 'null') {
      return type[0];
    };
  };
  return type;
};

// Creates an default titleMap list from an enum, i.e. a list of strings.
var enumToTitleMap = function enumToTitleMap(enm) {
  var titleMap = []; // canonical titleMap format is a list.
  enm.forEach(function (name) {
    titleMap.push({ name: name, value: name });
  });
  return titleMap;
};

/**
 * Creates a default form definition from a schema.
 */
function defaultFormDefinition(schemaTypes, name, schema, options) {
  var rules = schemaTypes[stripNullType(schema.type)];
  if (rules) {
    var def = void 0;
    // We give each rule a possibility to recurse it's children.
    var innerDefaultFormDefinition = function innerDefaultFormDefinition(childName, childSchema, childOptions) {
      return defaultFormDefinition(schemaTypes, childName, childSchema, childOptions);
    };
    for (var i = 0; i < rules.length; i++) {
      def = rules[i](name, schema, options, innerDefaultFormDefinition);

      // first handler in list that actually returns something is our handler!
      if (def) {

        // Do we have form defaults in the schema under the x-schema-form-attribute?
        if (def.schema['x-schema-form']) {
          Object.assign(def, def.schema['x-schema-form']);
        }

        return def;
      }
    }
  }
}

/**
 * Creates a form object with all common properties
 */
function stdFormObj(name, schema, options) {
  options = options || {};

  // The Object.assign used to be a angular.copy. Should work though.
  var f = options.global && options.global.formDefaults ? Object.assign({}, options.global.formDefaults) : {};
  if (options.global && options.global.supressPropertyTitles === true) {
    f.title = schema.title;
  } else {
    f.title = schema.title || name;
  }

  if (schema.description) {
    f.description = schema.description;
  }
  if (options.required === true || schema.required === true) {
    f.required = true;
  }
  if (schema.maxLength) {
    f.maxlength = schema.maxLength;
  }
  if (schema.minLength) {
    f.minlength = schema.minLength;
  }
  if (schema.readOnly || schema.readonly) {
    f.readonly = true;
  }
  if (schema.minimum) {
    f.minimum = schema.minimum + (schema.exclusiveMinimum ? 1 : 0);
  }
  if (schema.maximum) {
    f.maximum = schema.maximum - (schema.exclusiveMaximum ? 1 : 0);
  }

  // Non standard attributes (DONT USE DEPRECATED)
  // If you must set stuff like this in the schema use the x-schema-form attribute
  if (schema.validationMessage) {
    f.validationMessage = schema.validationMessage;
  }
  if (schema.enumNames) {
    f.titleMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__canonical_title_map__["a" /* default */])(schema.enumNames, schema['enum']);
  }
  f.schema = schema;

  // Ng model options doesn't play nice with undefined, might be defined
  // globally though
  f.ngModelOptions = f.ngModelOptions || {};

  return f;
};

/*** Schema types to form type mappings, with defaults ***/
function text(name, schema, options) {
  if (stripNullType(schema.type) === 'string' && !schema['enum']) {
    var f = stdFormObj(name, schema, options);
    f.key = options.path;
    f.type = 'text';
    options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;
    return f;
  }
}

// default in json form for number and integer is a text field
// input type="number" would be more suitable don't ya think?
function number(name, schema, options) {
  if (stripNullType(schema.type) === 'number') {
    var f = stdFormObj(name, schema, options);
    f.key = options.path;
    f.type = 'number';
    options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;
    return f;
  }
}

function integer(name, schema, options) {
  if (stripNullType(schema.type) === 'integer') {
    var f = stdFormObj(name, schema, options);
    f.key = options.path;
    f.type = 'number';
    options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;
    return f;
  }
}

function checkbox(name, schema, options) {
  if (stripNullType(schema.type) === 'boolean') {
    var f = stdFormObj(name, schema, options);
    f.key = options.path;
    f.type = 'checkbox';
    options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;
    return f;
  }
}

function select(name, schema, options) {
  if (stripNullType(schema.type) === 'string' && schema['enum']) {
    var f = stdFormObj(name, schema, options);
    f.key = options.path;
    f.type = 'select';
    if (!f.titleMap) {
      f.titleMap = enumToTitleMap(schema['enum']);
    }
    options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;
    return f;
  }
}

function checkboxes(name, schema, options) {
  if (stripNullType(schema.type) === 'array' && schema.items && schema.items['enum']) {
    var f = stdFormObj(name, schema, options);
    f.key = options.path;
    f.type = 'checkboxes';
    if (!f.titleMap) {
      f.titleMap = enumToTitleMap(schema.items['enum']);
    }
    options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;
    return f;
  }
}

function fieldset(name, schema, options, defaultFormDef) {
  if (stripNullType(schema.type) === 'object') {
    var _ret = function () {
      var f = stdFormObj(name, schema, options);
      f.type = 'fieldset';
      f.key = options.path;
      f.items = [];
      options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;

      // recurse down into properties
      if (schema.properties) {
        Object.keys(schema.properties).forEach(function (key) {
          var value = schema.properties[key];
          var path = options.path.slice();
          path.push(key);
          if (options.ignore[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(path)] !== true) {
            var required = schema.required && schema.required.indexOf(key) !== -1;

            var def = defaultFormDef(key, value, {
              path: path,
              required: required || false,
              lookup: options.lookup,
              ignore: options.ignore,
              global: options.global
            });
            if (def) {
              f.items.push(def);
            }
          }
        });
      }
      return {
        v: f
      };
    }();

    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
  }
}

function array(name, schema, options, defaultFormDef) {
  if (stripNullType(schema.type) === 'array') {
    var f = stdFormObj(name, schema, options);
    f.type = 'array';
    f.key = options.path;
    options.lookup[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(options.path)] = f;

    var required = schema.required && schema.required.indexOf(options.path[options.path.length - 1]) !== -1;

    // The default is to always just create one child. This works since if the
    // schemas items declaration is of type: "object" then we get a fieldset.
    // We also follow json form notatation, adding empty brackets "[]" to
    // signify arrays.

    var arrPath = options.path.slice();
    arrPath.push('');

    f.items = [defaultFormDef(name, schema.items, {
      path: arrPath,
      required: required || false,
      lookup: options.lookup,
      ignore: options.ignore,
      global: options.global
    })];

    return f;
  }
}

function createDefaults() {
  // First sorted by schema type then a list.
  // Order has importance. First handler returning an form snippet will be used.
  return {
    string: [select, text],
    object: [fieldset],
    number: [number],
    integer: [integer],
    boolean: [checkbox],
    array: [checkboxes, array]
  };
};

/**
 * Create form defaults from schema
 */
function defaultForm(schema, defaultSchemaTypes, ignore, globalOptions) {
  var form = [];
  var lookup = {}; // Map path => form obj for fast lookup in merging
  ignore = ignore || {};
  globalOptions = globalOptions || {};
  defaultSchemaTypes = defaultSchemaTypes || createDefaults();

  if (schema.properties) {
    Object.keys(schema.properties).forEach(function (key) {
      if (ignore[key] !== true) {
        var required = schema.required && schema.required.indexOf(key) !== -1;
        var def = defaultFormDefinition(defaultSchemaTypes, key, schema.properties[key], {
          path: [key], // Path to this property in bracket notation.
          lookup: lookup, // Extra map to register with. Optimization for merger.
          ignore: ignore, // The ignore list of paths (sans root level name)
          required: required, // Is it required? (v4 json schema style)
          global: globalOptions // Global options, including form defaults
        });
        if (def) {
          form.push(def);
        }
      }
    });
  } else {
    throw new Error('Not implemented. Only type "object" allowed at root level of schema.');
  }
  return { form: form, lookup: lookup };
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_schema_defaults__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_sf_path__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_canonical_title_map__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_merge__ = __webpack_require__(6);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_3__lib_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_select__ = __webpack_require__(8);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return __WEBPACK_IMPORTED_MODULE_4__lib_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_resolve__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "jsonref", function() { return __WEBPACK_IMPORTED_MODULE_5__lib_resolve__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_traverse__ = __webpack_require__(9);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "traverseSchema", function() { return __WEBPACK_IMPORTED_MODULE_6__lib_traverse__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "traverseForm", function() { return __WEBPACK_IMPORTED_MODULE_6__lib_traverse__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_validate__ = __webpack_require__(10);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return __WEBPACK_IMPORTED_MODULE_7__lib_validate__["a"]; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sfPath", function() { return sfPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "schemaDefaults", function() { return schemaDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canonicalTitleMap", function() { return canonicalTitleMap; });










var sfPath = __WEBPACK_IMPORTED_MODULE_1__lib_sf_path__;
var schemaDefaults = __WEBPACK_IMPORTED_MODULE_0__lib_schema_defaults__;
var canonicalTitleMap = __WEBPACK_IMPORTED_MODULE_2__lib_canonical_title_map__["a" /* default */];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};(function(f){if(( false?"undefined":_typeof(exports))==="object"&&typeof module!=="undefined"){module.exports=f();}else if(true){!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}else{var g;if(typeof window!=="undefined"){g=window;}else if(typeof global!=="undefined"){g=global;}else if(typeof self!=="undefined"){g=self;}else{g=this;}g.JsonRefs=f();}})(function(){var define,module,exports;return function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f;}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e);},l,l.exports,e,t,n,r);}return n[o].exports;}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++){s(r[o]);}return s;}({1:[function(require,module,exports){/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Jeremy Whitlock
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */'use strict';/**
 * Various utilities for JSON References *(http://tools.ietf.org/html/draft-pbryan-zyp-json-ref-03)* and
 * JSON Pointers *(https://tools.ietf.org/html/rfc6901)*.
 *
 * @module JsonRefs
 */var path=require('path');var PathLoader=require('path-loader');var qs=require('querystring');var slash=require('slash');var URI=require('uri-js');var badPtrTokenRegex=/~(?:[^01]|$)/g;var remoteCache={};var remoteTypes=['relative','remote'];var remoteUriTypes=['absolute','uri'];var uriDetailsCache={};// Load promises polyfill if necessary
/* istanbul ignore if */if(typeof Promise==='undefined'){require('native-promise-only');}/* Internal Functions */// This is a very simplistic clone function that does not take into account non-JSON types.  For these types the
// original value is used as the clone.  So while it's not a complete deep clone, for the needs of this project
// this should be sufficient.
function clone(obj){var cloned;if(isType(obj,'Array')){cloned=[];obj.forEach(function(value,index){cloned[index]=clone(value);});}else if(isType(obj,'Object')){cloned={};Object.keys(obj).forEach(function(key){cloned[key]=clone(obj[key]);});}else{cloned=obj;}return cloned;}function combineQueryParams(qs1,qs2){var combined={};function mergeQueryParams(obj){Object.keys(obj).forEach(function(key){combined[key]=obj[key];});}mergeQueryParams(qs.parse(qs1||''));mergeQueryParams(qs.parse(qs2||''));return Object.keys(combined).length===0?undefined:qs.stringify(combined);}function combineURIs(u1,u2){// Convert Windows paths
if(isType(u1,'String')){u1=slash(u1);}if(isType(u2,'String')){u2=slash(u2);}var u2Details=parseURI(isType(u2,'Undefined')?'':u2);var u1Details;var combinedDetails;if(remoteUriTypes.indexOf(u2Details.reference)>-1){combinedDetails=u2Details;}else{u1Details=isType(u1,'Undefined')?undefined:parseURI(u1);if(!isType(u1Details,'Undefined')){combinedDetails=u1Details;// Join the paths
combinedDetails.path=slash(path.join(u1Details.path,u2Details.path));// Join query parameters
combinedDetails.query=combineQueryParams(u1Details.query,u2Details.query);}else{combinedDetails=u2Details;}}// Remove the fragment
combinedDetails.fragment=undefined;// For relative URIs, add back the '..' since it was removed above
return(remoteUriTypes.indexOf(combinedDetails.reference)===-1&&combinedDetails.path.indexOf('../')===0?'../':'')+URI.serialize(combinedDetails);}function findAncestors(obj,path){var ancestors=[];var node;if(path.length>0){node=obj;path.slice(0,path.length-1).forEach(function(seg){if(seg in node){node=node[seg];ancestors.push(node);}});}return ancestors;}function processSubDocument(mode,doc,subDocPath,refDetails,options,parents,parentPtrs,allRefs,indirect){var refValue;var rOptions;if(subDocPath.length>0){try{refValue=findValue(doc,subDocPath);}catch(err){// We only mark missing remote references as missing because local references can have deferred values
if(mode==='remote'){refDetails.error=err.message;refDetails.missing=true;}}}else{refValue=doc;}if(!isType(refValue,'Undefined')){refDetails.value=refValue;}if(isType(refValue,'Array')||isType(refValue,'Object')){rOptions=clone(options);if(mode==='local'){delete rOptions.subDocPath;// Traverse the dereferenced value
doc=refValue;}else{rOptions.relativeBase=path.dirname(parents[parents.length-1]);if(subDocPath.length===0){delete rOptions.subDocPath;}else{rOptions.subDocPath=subDocPath;}}return findRefsRecursive(doc,rOptions,parents,parentPtrs,allRefs,indirect);}}// Should this be its own exported API?
function findRefsRecursive(obj,options,parents,parentPtrs,allRefs,indirect){var allTasks=Promise.resolve();var parentPath=parentPtrs.length?pathFromPtr(parentPtrs[parentPtrs.length-1]):[];var refs=findRefs(obj,options);var subDocPath=options.subDocPath||[];var subDocPtr=pathToPtr(subDocPath);var ancestorPtrs=['#'];parents.forEach(function(parent,index){if(parent.charAt(0)!=='#'){ancestorPtrs.push(parentPtrs[index]);}});// Reverse the order so we search them in the proper order
ancestorPtrs.reverse();if((parents[parents.length-1]||'').charAt(0)!=='#'){allRefs.documents[pathToPtr(parentPath)]=obj;}Object.keys(refs).forEach(function(refPtr){var refDetails=refs[refPtr];var location;var parentIndex;var refFullPath;var refFullPtr;// If there are no parents, treat the reference pointer as-is.  Otherwise, the reference is a reference within a
// remote document and its sub document path prefix must be removed.
if(parents.length===0){refFullPath=parentPath.concat(pathFromPtr(refPtr));}else{refFullPath=parentPath.concat(pathFromPtr(refPtr).slice(parents.length===0?0:subDocPath.length));}refFullPtr=pathToPtr(refFullPath);// It is possible to process the same reference more than once in the event of hierarchical references so we avoid
// processing a reference if we've already done so.
if(!isType(allRefs[refFullPtr],'Undefined')){return;}// Record the reference metadata
allRefs.refs[refFullPtr]=refs[refPtr];// Do not process invalid references
if(isType(refDetails.error,'Undefined')&&refDetails.type!=='invalid'){if(remoteTypes.indexOf(refDetails.type)>-1){location=combineURIs(options.relativeBase,refDetails.uri);parentIndex=parents.indexOf(location);}else{location=refDetails.uri;parentIndex=parentPtrs.indexOf(location);}// Record ancestor paths
refDetails.ancestorPtrs=ancestorPtrs;// Record if the reference is indirect based on its parent
refDetails.indirect=indirect;// Only process non-circular references further
if(parentIndex===-1){if(remoteTypes.indexOf(refDetails.type)>-1){allTasks=allTasks.then(function(){return getRemoteDocument(location,options).then(function(doc){return processSubDocument('remote',doc,isType(refDetails.uriDetails.fragment,'Undefined')?[]:pathFromPtr(decodeURI(refDetails.uriDetails.fragment)),refDetails,options,parents.concat(location),parentPtrs.concat(refFullPtr),allRefs,indirect);}).catch(function(err){refDetails.error=err.message;refDetails.missing=true;});});}else{if(refFullPtr.indexOf(location+'/')!==0&&refFullPtr!==location&&subDocPtr.indexOf(location+'/')!==0&&subDocPtr!==location){if(location.indexOf(subDocPtr+'/')!==0){allTasks=allTasks.then(function(){return processSubDocument('local',obj,pathFromPtr(location),refDetails,options,parents.concat(location),parentPtrs.concat(refFullPtr),allRefs,indirect||location.indexOf(subDocPtr+'/')===-1&&location!==subDocPtr);});}}else{refDetails.circular=true;}}}else{// Mark seen ancestors as circular
parentPtrs.slice(parentIndex).forEach(function(parentPtr){allRefs.refs[parentPtr].circular=true;});refDetails.circular=true;}}});allTasks=allTasks.then(function(){// Identify indirect, local circular references (Issue 82)
var circulars=[];var processedRefPtrs=[];var processedRefs=[];function walkRefs(parentPtrs,parentRefs,refPtr,ref){Object.keys(allRefs.refs).forEach(function(dRefPtr){var dRefDetails=allRefs.refs[dRefPtr];// Do not process already processed references or references that are not a nested references
if(processedRefs.indexOf(ref)===-1&&processedRefPtrs.indexOf(refPtr)===-1&&circulars.indexOf(ref)===-1&&dRefPtr!==refPtr&&dRefPtr.indexOf(ref+'/')===0){if(parentRefs.indexOf(ref)>-1){parentRefs.forEach(function(parentRef){if(circulars.indexOf(ref)===-1){circulars.push(parentRef);}});}else{walkRefs(parentPtrs.concat(refPtr),parentRefs.concat(ref),dRefPtr,dRefDetails.uri);}processedRefPtrs.push(refPtr);processedRefs.push(ref);}});}Object.keys(allRefs.refs).forEach(function(refPtr){var refDetails=allRefs.refs[refPtr];// Only process local, non-circular references
if(refDetails.type==='local'&&!refDetails.circular&&circulars.indexOf(refDetails.uri)===-1){walkRefs([],[],refPtr,refDetails.uri);}});Object.keys(allRefs.refs).forEach(function(refPtr){var refDetails=allRefs.refs[refPtr];if(circulars.indexOf(refDetails.uri)>-1){refDetails.circular=true;}});}).then(function(){return allRefs;});return allTasks;}function findValue(obj,path){var value=obj;path.forEach(function(seg){seg=decodeURI(seg);if(seg in value){value=value[seg];}else{throw Error('JSON Pointer points to missing location: '+pathToPtr(path));}});return value;}function getExtraRefKeys(ref){return Object.keys(ref).filter(function(key){return key!=='$ref';});}function getRefType(refDetails){var type;// Convert the URI reference to one of our types
switch(refDetails.uriDetails.reference){case'absolute':case'uri':type='remote';break;case'same-document':type='local';break;default:type=refDetails.uriDetails.reference;}return type;}function getRemoteDocument(url,options){var cacheEntry=remoteCache[url];var allTasks=Promise.resolve();var loaderOptions=clone(options.loaderOptions||{});if(isType(cacheEntry,'Undefined')){// If there is no content processor, default to processing the raw response as JSON
if(isType(loaderOptions.processContent,'Undefined')){loaderOptions.processContent=function(res,callback){callback(undefined,JSON.parse(res.text));};}// Attempt to load the resource using path-loader
allTasks=PathLoader.load(decodeURI(url),loaderOptions);// Update the cache
allTasks=allTasks.then(function(res){remoteCache[url]={value:res};return res;}).catch(function(err){remoteCache[url]={error:err};throw err;});}else{// Return the cached version
allTasks=allTasks.then(function(){return cacheEntry.value;});}// Return a cloned version to avoid updating the cache
allTasks=allTasks.then(function(res){return clone(res);});return allTasks;}function isRefLike(obj,throwWithDetails){var refLike=true;try{if(!isType(obj,'Object')){throw new Error('obj is not an Object');}else if(!isType(obj.$ref,'String')){throw new Error('obj.$ref is not a String');}}catch(err){if(throwWithDetails){throw err;}refLike=false;}return refLike;}function isType(obj,type){// A PhantomJS bug (https://github.com/ariya/phantomjs/issues/11722) prohibits us from using the same approach for
// undefined checking that we use for other types.
if(type==='Undefined'){return typeof obj==='undefined';}else{return Object.prototype.toString.call(obj)==='[object '+type+']';}}function makeRefFilter(options){var refFilter;var validTypes;if(isType(options.filter,'Array')||isType(options.filter,'String')){validTypes=isType(options.filter,'String')?[options.filter]:options.filter;refFilter=function refFilter(refDetails){// Check the exact type or for invalid URIs, check its original type
return validTypes.indexOf(refDetails.type)>-1||validTypes.indexOf(getRefType(refDetails))>-1;};}else if(isType(options.filter,'Function')){refFilter=options.filter;}else if(isType(options.filter,'Undefined')){refFilter=function refFilter(){return true;};}return function(refDetails,path){return(refDetails.type!=='invalid'||options.includeInvalid===true)&&refFilter(refDetails,path);};}function makeSubDocPath(options){var subDocPath;if(isType(options.subDocPath,'Array')){subDocPath=options.subDocPath;}else if(isType(options.subDocPath,'String')){subDocPath=pathFromPtr(options.subDocPath);}else if(isType(options.subDocPath,'Undefined')){subDocPath=[];}return subDocPath;}function parseURI(uri){// We decode first to avoid doubly encoding
return URI.parse(encodeURI(decodeURI(uri)));}function setValue(obj,refPath,value){findValue(obj,refPath.slice(0,refPath.length-1))[decodeURI(refPath[refPath.length-1])]=value;}function walk(ancestors,node,path,fn){var processChildren=true;function walkItem(item,segment){path.push(segment);walk(ancestors,item,path,fn);path.pop();}// Call the iteratee
if(isType(fn,'Function')){processChildren=fn(ancestors,node,path);}// We do not process circular objects again
if(ancestors.indexOf(node)===-1){ancestors.push(node);if(processChildren!==false){if(isType(node,'Array')){node.forEach(function(member,index){walkItem(member,index.toString());});}else if(isType(node,'Object')){Object.keys(node).forEach(function(key){walkItem(node[key],key);});}}}ancestors.pop();}function validateOptions(options,obj){if(isType(options,'Undefined')){// Default to an empty options object
options={};}else{// Clone the options so we do not alter the ones passed in
options=clone(options);}if(!isType(options,'Object')){throw new TypeError('options must be an Object');}else if(!isType(options.filter,'Undefined')&&!isType(options.filter,'Array')&&!isType(options.filter,'Function')&&!isType(options.filter,'String')){throw new TypeError('options.filter must be an Array, a Function of a String');}else if(!isType(options.includeInvalid,'Undefined')&&!isType(options.includeInvalid,'Boolean')){throw new TypeError('options.includeInvalid must be a Boolean');}else if(!isType(options.refPreProcessor,'Undefined')&&!isType(options.refPreProcessor,'Function')){throw new TypeError('options.refPreProcessor must be a Function');}else if(!isType(options.refPostProcessor,'Undefined')&&!isType(options.refPostProcessor,'Function')){throw new TypeError('options.refPostProcessor must be a Function');}else if(!isType(options.subDocPath,'Undefined')&&!isType(options.subDocPath,'Array')&&!isPtr(options.subDocPath)){// If a pointer is provided, throw an error if it's not the proper type
throw new TypeError('options.subDocPath must be an Array of path segments or a valid JSON Pointer');}options.filter=makeRefFilter(options);// Set the subDocPath to avoid everyone else having to compute it
options.subDocPath=makeSubDocPath(options);if(!isType(obj,'Undefined')){try{findValue(obj,options.subDocPath);}catch(err){err.message=err.message.replace('JSON Pointer','options.subDocPath');throw err;}}return options;}/* Module Members *//*
 * Each of the functions below are defined as function statements and *then* exported in two steps instead of one due
 * to a bug in jsdoc (https://github.com/jsdoc2md/jsdoc-parse/issues/18) that causes our documentation to be
 * generated improperly.  The impact to the user is significant enough for us to warrant working around it until this
 * is fixed.
 *//**
 * The options used for various JsonRefs APIs.
 *
 * @typedef {object} JsonRefsOptions
 *
 * @param {string|string[]|function} [filter=function () {return true;}] - The filter to use when gathering JSON
 * References *(If this value is a single string or an array of strings, the value(s) are expected to be the `type(s)`
 * you are interested in collecting as described in {@link module:JsonRefs.getRefDetails}.  If it is a function, it is
 * expected that the function behaves like {@link module:JsonRefs~RefDetailsFilter}.)*
 * @param {boolean} [includeInvalid=false] - Whether or not to include invalid JSON Reference details *(This will make
 * it so that objects that are like JSON Reference objects, as in they are an `Object` and the have a `$ref` property,
 * but fail validation will be included.  This is very useful for when you want to know if you have invalid JSON
 * Reference definitions.  This will not mean that APIs will process invalid JSON References but the reasons as to why
 * the JSON References are invalid will be included in the returned metadata.)*
 * @param {object} [loaderOptions] - The options to pass to
 * {@link https://github.com/whitlockjc/path-loader/blob/master/docs/API.md#module_PathLoader.load|PathLoader~load}
 * @param {module:JsonRefs~RefPreProcessor} [refPreProcessor] - The callback used to pre-process a JSON Reference like
 * object *(This is called prior to validating the JSON Reference like object and getting its details)*
 * @param {module:JsonRefs~RefPostProcessor} [refPostProcessor] - The callback used to post-process the JSON Reference
 * metadata *(This is called prior filtering the references)*
 * @param {string} [options.relativeBase] - The base location to use when resolving relative references *(Only useful
 * for APIs that do remote reference resolution.  If this value is not defined,
 * {@link https://github.com/whitlockjc/path-loader|path-loader} will use `window.location.href` for the browser and
 * `process.cwd()` for Node.js.)*
 * @param {string|string[]} [options.subDocPath=[]] - The JSON Pointer or array of path segments to the sub document
 * location to search from
 *//**
 * Simple function used to filter out JSON References.
 *
 * @typedef {function} RefDetailsFilter
 *
 * @param {module:JsonRefs~UnresolvedRefDetails} refDetails - The JSON Reference details to test
 * @param {string[]} path - The path to the JSON Reference
 *
 * @returns {boolean} whether the JSON Reference should be filtered *(out)* or not
 *//**
 * Simple function used to pre-process a JSON Reference like object.
 *
 * @typedef {function} RefPreProcessor
 *
 * @param {object} obj - The JSON Reference like object
 * @param {string[]} path - The path to the JSON Reference like object
 *
 * @returns {object} the processed JSON Reference like object
 *//**
 * Simple function used to post-process a JSON Reference details.
 *
 * @typedef {function} RefPostProcessor
 *
 * @param {module:JsonRefs~UnresolvedRefDetails} refDetails - The JSON Reference details to test
 * @param {string[]} path - The path to the JSON Reference
 *
 * @returns {object} the processed JSON Reference details object
 *//**
 * Detailed information about resolved JSON References.
 *
 * @typedef {module:JsonRefs~UnresolvedRefDetails} ResolvedRefDetails
 *
 * @property {boolean} [circular] - Whether or not the JSON Reference is circular *(Will not be set if the JSON
 * Reference is not circular)*
 * @property {boolean} [missing] - Whether or not the referenced value was missing or not *(Will not be set if the
 * referenced value is not missing)*
 * @property {*} [value] - The referenced value *(Will not be set if the referenced value is missing)*
 *//**
 * The results of resolving the JSON References of an array/object.
 *
 * @typedef {object} ResolvedRefsResults
 *
 * @property {module:JsonRefs~ResolvedRefDetails} refs - An object whose keys are JSON Pointers *(fragment version)*
 * to where the JSON Reference is defined and whose values are {@link module:JsonRefs~ResolvedRefDetails}
 * @property {object} resolved - The array/object with its JSON References fully resolved
 *//**
 * An object containing the retrieved document and detailed information about its JSON References.
 *
 * @typedef {module:JsonRefs~ResolvedRefsResults} RetrievedRefsResults
 *
 * @property {object} value - The retrieved document
 *//**
 * An object containing the retrieved document, the document with its references resolved and  detailed information
 * about its JSON References.
 *
 * @typedef {object} RetrievedResolvedRefsResults
 *
 * @property {module:JsonRefs~UnresolvedRefDetails} refs - An object whose keys are JSON Pointers *(fragment version)*
 * to where the JSON Reference is defined and whose values are {@link module:JsonRefs~UnresolvedRefDetails}
 * @property {ResolvedRefsResults} - An object whose keys are JSON Pointers *(fragment version)*
 * to where the JSON Reference is defined and whose values are {@link module:JsonRefs~ResolvedRefDetails}
 * @property {object} value - The retrieved document
 *//**
 * Detailed information about unresolved JSON References.
 *
 * @typedef {object} UnresolvedRefDetails
 *
 * @property {object} def - The JSON Reference definition
 * @property {string} [error] - The error information for invalid JSON Reference definition *(Only present when the
 * JSON Reference definition is invalid or there was a problem retrieving a remote reference during resolution)*
 * @property {string} uri - The URI portion of the JSON Reference
 * @property {object} uriDetails - Detailed information about the URI as provided by
 * {@link https://github.com/garycourt/uri-js|URI.parse}.
 * @property {string} type - The JSON Reference type *(This value can be one of the following: `invalid`, `local`,
 * `relative` or `remote`.)*
 * @property {string} [warning] - The warning information *(Only present when the JSON Reference definition produces a
 * warning)*
 *//**
 * Clears the internal cache of remote documents, reference details, etc.
 *
 * @alias module:JsonRefs.clearCache
 */function clearCache(){remoteCache={};}/**
 * Takes an array of path segments and decodes the JSON Pointer tokens in them.
 *
 * @param {string[]} path - The array of path segments
 *
 * @returns {string} the array of path segments with their JSON Pointer tokens decoded
 *
 * @throws {Error} if the path is not an `Array`
 *
 * @see {@link https://tools.ietf.org/html/rfc6901#section-3}
 *
 * @alias module:JsonRefs.decodePath
 */function decodePath(path){if(!isType(path,'Array')){throw new TypeError('path must be an array');}return path.map(function(seg){if(!isType(seg,'String')){seg=JSON.stringify(seg);}return decodeURI(seg.replace(/~1/g,'/').replace(/~0/g,'~'));});}/**
 * Takes an array of path segments and encodes the special JSON Pointer characters in them.
 *
 * @param {string[]} path - The array of path segments
 *
 * @returns {string} the array of path segments with their JSON Pointer tokens encoded
 *
 * @throws {Error} if the path is not an `Array`
 *
 * @see {@link https://tools.ietf.org/html/rfc6901#section-3}
 *
 * @alias module:JsonRefs.encodePath
 */function encodePath(path){if(!isType(path,'Array')){throw new TypeError('path must be an array');}return path.map(function(seg){if(!isType(seg,'String')){seg=JSON.stringify(seg);}return seg.replace(/~/g,'~0').replace(/\//g,'~1');});}/**
 * Finds JSON References defined within the provided array/object.
 *
 * @param {array|object} obj - The structure to find JSON References within
 * @param {module:JsonRefs~JsonRefsOptions} [options] - The JsonRefs options
 *
 * @returns {object} an object whose keys are JSON Pointers *(fragment version)* to where the JSON Reference is defined
 * and whose values are {@link module:JsonRefs~UnresolvedRefDetails}.
 *
 * @throws {Error} when the input arguments fail validation or if `options.subDocPath` points to an invalid location
 *
 * @alias module:JsonRefs.findRefs
 *
 * @example
 * // Finding all valid references
 * var allRefs = JsonRefs.findRefs(obj);
 * // Finding all remote references
 * var remoteRefs = JsonRefs.findRefs(obj, {filter: ['relative', 'remote']});
 * // Finding all invalid references
 * var invalidRefs = JsonRefs.findRefs(obj, {filter: 'invalid', includeInvalid: true});
 */function findRefs(obj,options){var refs={};// Validate the provided document
if(!isType(obj,'Array')&&!isType(obj,'Object')){throw new TypeError('obj must be an Array or an Object');}// Validate options
options=validateOptions(options,obj);// Walk the document (or sub document) and find all JSON References
walk(findAncestors(obj,options.subDocPath),findValue(obj,options.subDocPath),clone(options.subDocPath),function(ancestors,node,path){var processChildren=true;var refDetails;if(isRefLike(node)){// Pre-process the node when necessary
if(!isType(options.refPreProcessor,'Undefined')){node=options.refPreProcessor(clone(node),path);}refDetails=getRefDetails(node);// Post-process the reference details
if(!isType(options.refPostProcessor,'Undefined')){refDetails=options.refPostProcessor(refDetails,path);}if(options.filter(refDetails,path)){refs[pathToPtr(path)]=refDetails;}// Whenever a JSON Reference has extra children, its children should not be processed.
//   See: http://tools.ietf.org/html/draft-pbryan-zyp-json-ref-03#section-3
if(getExtraRefKeys(node).length>0){processChildren=false;}}return processChildren;});return refs;}/**
 * Finds JSON References defined within the document at the provided location.
 *
 * This API is identical to {@link module:JsonRefs.findRefs} except this API will retrieve a remote document and then
 * return the result of {@link module:JsonRefs.findRefs} on the retrieved document.
 *
 * @param {string} location - The location to retrieve *(Can be relative or absolute, just make sure you look at the
 * {@link module:JsonRefs~JsonRefsOptions|options documentation} to see how relative references are handled.)*
 * @param {module:JsonRefs~JsonRefsOptions} [options] - The JsonRefs options
 *
 * @returns {Promise} a promise that resolves a {@link module:JsonRefs~RetrievedRefsResults} and rejects with an
 * `Error` when the input arguments fail validation, when `options.subDocPath` points to an invalid location or when
 *  the location argument points to an unloadable resource
 *
 * @alias module:JsonRefs.findRefsAt
 *
 * @example
 * // Example that only resolves references within a sub document
 * JsonRefs.findRefsAt('http://petstore.swagger.io/v2/swagger.json', {
 *     subDocPath: '#/definitions'
 *   })
 *   .then(function (res) {
 *      // Do something with the response
 *      //
 *      // res.refs: JSON Reference locations and details
 *      // res.value: The retrieved document
 *   }, function (err) {
 *     console.log(err.stack);
 *   });
 */function findRefsAt(location,options){var allTasks=Promise.resolve();allTasks=allTasks.then(function(){// Validate the provided location
if(!isType(location,'String')){throw new TypeError('location must be a string');}// Validate options
options=validateOptions(options);// Combine the location and the optional relative base
location=combineURIs(options.relativeBase,location);return getRemoteDocument(location,options);}).then(function(res){var cacheEntry=clone(remoteCache[location]);var cOptions=clone(options);var uriDetails=parseURI(location);if(isType(cacheEntry.refs,'Undefined')){// Do not filter any references so the cache is complete
delete cOptions.filter;delete cOptions.subDocPath;cOptions.includeInvalid=true;remoteCache[location].refs=findRefs(res,cOptions);}// Add the filter options back
if(!isType(options.filter,'Undefined')){cOptions.filter=options.filter;}if(!isType(uriDetails.fragment,'Undefined')){cOptions.subDocPath=pathFromPtr(decodeURI(uriDetails.fragment));}else if(!isType(uriDetails.subDocPath,'Undefined')){cOptions.subDocPath=options.subDocPath;}// This will use the cache so don't worry about calling it twice
return{refs:findRefs(res,cOptions),value:res};});return allTasks;}/**
 * Returns detailed information about the JSON Reference.
 *
 * @param {object} obj - The JSON Reference definition
 *
 * @returns {module:JsonRefs~UnresolvedRefDetails} the detailed information
 *
 * @alias module:JsonRefs.getRefDetails
 */function getRefDetails(obj){var details={def:obj};var cacheKey;var extraKeys;var uriDetails;try{if(isRefLike(obj,true)){cacheKey=obj.$ref;uriDetails=uriDetailsCache[cacheKey];if(isType(uriDetails,'Undefined')){uriDetails=uriDetailsCache[cacheKey]=parseURI(cacheKey);}details.uri=cacheKey;details.uriDetails=uriDetails;if(isType(uriDetails.error,'Undefined')){details.type=getRefType(details);}else{details.error=details.uriDetails.error;details.type='invalid';}// Identify warning
extraKeys=getExtraRefKeys(obj);if(extraKeys.length>0){details.warning='Extra JSON Reference properties will be ignored: '+extraKeys.join(', ');}}else{details.type='invalid';}}catch(err){details.error=err.message;details.type='invalid';}return details;}/**
 * Returns whether the argument represents a JSON Pointer.
 *
 * A string is a JSON Pointer if the following are all true:
 *
 *   * The string is of type `String`
 *   * The string must be empty, `#` or start with a `/` or `#/`
 *
 * @param {string} ptr - The string to check
 * @param {boolean} [throwWithDetails=false] - Whether or not to throw an `Error` with the details as to why the value
 * provided is invalid
 *
 * @returns {boolean} the result of the check
 *
 * @throws {error} when the provided value is invalid and the `throwWithDetails` argument is `true`
 *
 * @alias module:JsonRefs.isPtr
 *
 * @see {@link https://tools.ietf.org/html/rfc6901#section-3}
 *
 * @example
 * // Separating the different ways to invoke isPtr for demonstration purposes
 * if (isPtr(str)) {
 *   // Handle a valid JSON Pointer
 * } else {
 *   // Get the reason as to why the value is not a JSON Pointer so you can fix/report it
 *   try {
 *     isPtr(str, true);
 *   } catch (err) {
 *     // The error message contains the details as to why the provided value is not a JSON Pointer
 *   }
 * }
 */function isPtr(ptr,throwWithDetails){var valid=true;var firstChar;try{if(isType(ptr,'String')){if(ptr!==''){firstChar=ptr.charAt(0);if(['#','/'].indexOf(firstChar)===-1){throw new Error('ptr must start with a / or #/');}else if(firstChar==='#'&&ptr!=='#'&&ptr.charAt(1)!=='/'){throw new Error('ptr must start with a / or #/');}else if(ptr.match(badPtrTokenRegex)){throw new Error('ptr has invalid token(s)');}}}else{throw new Error('ptr is not a String');}}catch(err){if(throwWithDetails===true){throw err;}valid=false;}return valid;}/**
 * Returns whether the argument represents a JSON Reference.
 *
 * An object is a JSON Reference only if the following are all true:
 *
 *   * The object is of type `Object`
 *   * The object has a `$ref` property
 *   * The `$ref` property is a valid URI *(We do not require 100% strict URIs and will handle unescaped special
 *     characters.)*
 *
 * @param {object} obj - The object to check
 * @param {boolean} [throwWithDetails=false] - Whether or not to throw an `Error` with the details as to why the value
 * provided is invalid
 *
 * @returns {boolean} the result of the check
 *
 * @throws {error} when the provided value is invalid and the `throwWithDetails` argument is `true`
 *
 * @alias module:JsonRefs.isRef
 *
 * @see {@link http://tools.ietf.org/html/draft-pbryan-zyp-json-ref-03#section-3}
 *
 * @example
 * // Separating the different ways to invoke isRef for demonstration purposes
 * if (isRef(obj)) {
 *   // Handle a valid JSON Reference
 * } else {
 *   // Get the reason as to why the value is not a JSON Reference so you can fix/report it
 *   try {
 *     isRef(str, true);
 *   } catch (err) {
 *     // The error message contains the details as to why the provided value is not a JSON Reference
 *   }
 * }
 */function isRef(obj,throwWithDetails){return isRefLike(obj,throwWithDetails)&&getRefDetails(obj,throwWithDetails).type!=='invalid';}/**
 * Returns an array of path segments for the provided JSON Pointer.
 *
 * @param {string} ptr - The JSON Pointer
 *
 * @returns {string[]} the path segments
 *
 * @throws {Error} if the provided `ptr` argument is not a JSON Pointer
 *
 * @alias module:JsonRefs.pathFromPtr
 */function pathFromPtr(ptr){if(!isPtr(ptr)){throw new Error('ptr must be a JSON Pointer');}var segments=ptr.split('/');// Remove the first segment
segments.shift();return decodePath(segments);}/**
 * Returns a JSON Pointer for the provided array of path segments.
 *
 * **Note:** If a path segment in `path` is not a `String`, it will be converted to one using `JSON.stringify`.
 *
 * @param {string[]} path - The array of path segments
 * @param {boolean} [hashPrefix=true] - Whether or not create a hash-prefixed JSON Pointer
 *
 * @returns {string} the corresponding JSON Pointer
 *
 * @throws {Error} if the `path` argument is not an array
 *
 * @alias module:JsonRefs.pathToPtr
 */function pathToPtr(path,hashPrefix){if(!isType(path,'Array')){throw new Error('path must be an Array');}// Encode each segment and return
return(hashPrefix!==false?'#':'')+(path.length>0?'/':'')+encodePath(path).join('/');}/**
 * Finds JSON References defined within the provided array/object and resolves them.
 *
 * @param {array|object} obj - The structure to find JSON References within
 * @param {module:JsonRefs~JsonRefsOptions} [options] - The JsonRefs options
 *
 * @returns {Promise} a promise that resolves a {@link module:JsonRefs~ResolvedRefsResults} and rejects with an
 * `Error` when the input arguments fail validation, when `options.subDocPath` points to an invalid location or when
 *  the location argument points to an unloadable resource
 *
 * @alias module:JsonRefs.resolveRefs
 *
 * @example
 * // Example that only resolves relative and remote references
 * JsonRefs.resolveRefs(swaggerObj, {
 *     filter: ['relative', 'remote']
 *   })
 *   .then(function (res) {
 *      // Do something with the response
 *      //
 *      // res.refs: JSON Reference locations and details
 *      // res.resolved: The document with the appropriate JSON References resolved
 *   }, function (err) {
 *     console.log(err.stack);
 *   });
 */function resolveRefs(obj,options){var allTasks=Promise.resolve();allTasks=allTasks.then(function(){// Validate the provided document
if(!isType(obj,'Array')&&!isType(obj,'Object')){throw new TypeError('obj must be an Array or an Object');}// Validate options
options=validateOptions(options,obj);// Clone the input so we do not alter it
obj=clone(obj);}).then(function(){return findRefsRecursive(obj,options,[],[],{documents:{},refs:{}});}).then(function(allRefs){var deferredRefs={};var refs={};function pathSorter(p1,p2){return pathFromPtr(p1).length-pathFromPtr(p2).length;}// Resolve all references with a known value
Object.keys(allRefs.refs).sort(pathSorter).forEach(function(refPtr){var refDetails=allRefs.refs[refPtr];// Record all direct references
if(!refDetails.indirect){refs[refPtr]=refDetails;}// Delete helper property
delete refDetails.indirect;if(isType(refDetails.error,'Undefined')&&refDetails.type!=='invalid'){if(isType(refDetails.value,'Undefined')&&refDetails.circular){refDetails.value=refDetails.def;}// We defer processing all references without a value until later
if(isType(refDetails.value,'Undefined')){deferredRefs[refPtr]=refDetails;}else{if(refPtr==='#'){obj=refDetails.value;}else{setValue(obj,pathFromPtr(refPtr),refDetails.value);}// Delete helper property
delete refDetails.ancestorPtrs;}}else{// Delete helper property
delete refDetails.ancestorPtrs;}});// Resolve all deferred references
Object.keys(deferredRefs).forEach(function(refPtr){var refDetails=deferredRefs[refPtr];// Attempt to resolve the value against all if its ancestors in order
refDetails.ancestorPtrs.forEach(function(ancestorPtr,index){if(isType(refDetails.value,'Undefined')){try{refDetails.value=findValue(allRefs.documents[ancestorPtr],pathFromPtr(refDetails.uri));// Delete helper property
delete refDetails.ancestorPtrs;setValue(obj,pathFromPtr(refPtr),refDetails.value);}catch(err){if(index===refDetails.ancestorPtrs.length-1){refDetails.error=err.message;refDetails.missing=true;// Delete helper property
delete refDetails.ancestorPtrs;}}}});});return{refs:refs,resolved:obj};});return allTasks;}/**
 * Resolves JSON References defined within the document at the provided location.
 *
 * This API is identical to {@link module:JsonRefs.resolveRefs} except this API will retrieve a remote document and then
 * return the result of {@link module:JsonRefs.resolveRefs} on the retrieved document.
 *
 * @param {string} location - The location to retrieve *(Can be relative or absolute, just make sure you look at the
 * {@link module:JsonRefs~JsonRefsOptions|options documentation} to see how relative references are handled.)*
 * @param {module:JsonRefs~JsonRefsOptions} [options] - The JsonRefs options
 *
 * @returns {Promise} a promise that resolves a {@link module:JsonRefs~RetrievedResolvedRefsResults} and rejects with an
 * `Error` when the input arguments fail validation, when `options.subDocPath` points to an invalid location or when
 *  the location argument points to an unloadable resource
 *
 * @alias module:JsonRefs.resolveRefsAt
 *
 * @example
 * // Example that loads a JSON document (No options.loaderOptions.processContent required) and resolves all references
 * JsonRefs.resolveRefsAt('./swagger.json')
 *   .then(function (res) {
 *      // Do something with the response
 *      //
 *      // res.refs: JSON Reference locations and details
 *      // res.resolved: The document with the appropriate JSON References resolved
 *      // res.value: The retrieved document
 *   }, function (err) {
 *     console.log(err.stack);
 *   });
 */function resolveRefsAt(location,options){var allTasks=Promise.resolve();allTasks=allTasks.then(function(){// Validate the provided location
if(!isType(location,'String')){throw new TypeError('location must be a string');}// Validate options
options=validateOptions(options);// Combine the location and the optional relative base
location=combineURIs(options.relativeBase,location);return getRemoteDocument(location,options);}).then(function(res){var cOptions=clone(options);var uriDetails=parseURI(location);// Set the sub document path if necessary
if(!isType(uriDetails.fragment,'Undefined')){cOptions.subDocPath=pathFromPtr(decodeURI(uriDetails.fragment));}// Update the relative base based on the retrieved location
cOptions.relativeBase=path.dirname(location);return resolveRefs(res,cOptions).then(function(res2){return{refs:res2.refs,resolved:res2.resolved,value:res};});});return allTasks;}/* Export the module members */module.exports.clearCache=clearCache;module.exports.decodePath=decodePath;module.exports.encodePath=encodePath;module.exports.findRefs=findRefs;module.exports.findRefsAt=findRefsAt;module.exports.getRefDetails=getRefDetails;module.exports.isPtr=isPtr;module.exports.isRef=isRef;module.exports.pathFromPtr=pathFromPtr;module.exports.pathToPtr=pathToPtr;module.exports.resolveRefs=resolveRefs;module.exports.resolveRefsAt=resolveRefsAt;},{"native-promise-only":3,"path":4,"path-loader":5,"querystring":11,"slash":13,"uri-js":23}],2:[function(require,module,exports){/**
 * Expose `Emitter`.
 */module.exports=Emitter;/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */function Emitter(obj){if(obj)return mixin(obj);};/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */function mixin(obj){for(var key in Emitter.prototype){obj[key]=Emitter.prototype[key];}return obj;}/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */Emitter.prototype.on=Emitter.prototype.addEventListener=function(event,fn){this._callbacks=this._callbacks||{};(this._callbacks['$'+event]=this._callbacks['$'+event]||[]).push(fn);return this;};/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */Emitter.prototype.once=function(event,fn){function on(){this.off(event,on);fn.apply(this,arguments);}on.fn=fn;this.on(event,on);return this;};/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */Emitter.prototype.off=Emitter.prototype.removeListener=Emitter.prototype.removeAllListeners=Emitter.prototype.removeEventListener=function(event,fn){this._callbacks=this._callbacks||{};// all
if(0==arguments.length){this._callbacks={};return this;}// specific event
var callbacks=this._callbacks['$'+event];if(!callbacks)return this;// remove all handlers
if(1==arguments.length){delete this._callbacks['$'+event];return this;}// remove specific handler
var cb;for(var i=0;i<callbacks.length;i++){cb=callbacks[i];if(cb===fn||cb.fn===fn){callbacks.splice(i,1);break;}}return this;};/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */Emitter.prototype.emit=function(event){this._callbacks=this._callbacks||{};var args=[].slice.call(arguments,1),callbacks=this._callbacks['$'+event];if(callbacks){callbacks=callbacks.slice(0);for(var i=0,len=callbacks.length;i<len;++i){callbacks[i].apply(this,args);}}return this;};/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */Emitter.prototype.listeners=function(event){this._callbacks=this._callbacks||{};return this._callbacks['$'+event]||[];};/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */Emitter.prototype.hasListeners=function(event){return!!this.listeners(event).length;};},{}],3:[function(require,module,exports){(function(global){/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/(function UMD(name,context,definition){// special form of UMD for polyfilling across evironments
context[name]=context[name]||definition();if(typeof module!="undefined"&&module.exports){module.exports=context[name];}else if(typeof define=="function"&&define.amd){define(function $AMD$(){return context[name];});}})("Promise",typeof global!="undefined"?global:this,function DEF(){/*jshint validthis:true */"use strict";var builtInProp,cycle,scheduling_queue,ToString=Object.prototype.toString,timer=typeof setImmediate!="undefined"?function timer(fn){return setImmediate(fn);}:setTimeout;// dammit, IE8.
try{Object.defineProperty({},"x",{});builtInProp=function builtInProp(obj,name,val,config){return Object.defineProperty(obj,name,{value:val,writable:true,configurable:config!==false});};}catch(err){builtInProp=function builtInProp(obj,name,val){obj[name]=val;return obj;};}// Note: using a queue instead of array for efficiency
scheduling_queue=function Queue(){var first,last,item;function Item(fn,self){this.fn=fn;this.self=self;this.next=void 0;}return{add:function add(fn,self){item=new Item(fn,self);if(last){last.next=item;}else{first=item;}last=item;item=void 0;},drain:function drain(){var f=first;first=last=cycle=void 0;while(f){f.fn.call(f.self);f=f.next;}}};}();function schedule(fn,self){scheduling_queue.add(fn,self);if(!cycle){cycle=timer(scheduling_queue.drain);}}// promise duck typing
function isThenable(o){var _then,o_type=typeof o==="undefined"?"undefined":_typeof(o);if(o!=null&&(o_type=="object"||o_type=="function")){_then=o.then;}return typeof _then=="function"?_then:false;}function notify(){for(var i=0;i<this.chain.length;i++){notifyIsolated(this,this.state===1?this.chain[i].success:this.chain[i].failure,this.chain[i]);}this.chain.length=0;}// NOTE: This is a separate function to isolate
// the `try..catch` so that other code can be
// optimized better
function notifyIsolated(self,cb,chain){var ret,_then;try{if(cb===false){chain.reject(self.msg);}else{if(cb===true){ret=self.msg;}else{ret=cb.call(void 0,self.msg);}if(ret===chain.promise){chain.reject(TypeError("Promise-chain cycle"));}else if(_then=isThenable(ret)){_then.call(ret,chain.resolve,chain.reject);}else{chain.resolve(ret);}}}catch(err){chain.reject(err);}}function resolve(msg){var _then,self=this;// already triggered?
if(self.triggered){return;}self.triggered=true;// unwrap
if(self.def){self=self.def;}try{if(_then=isThenable(msg)){schedule(function(){var def_wrapper=new MakeDefWrapper(self);try{_then.call(msg,function $resolve$(){resolve.apply(def_wrapper,arguments);},function $reject$(){reject.apply(def_wrapper,arguments);});}catch(err){reject.call(def_wrapper,err);}});}else{self.msg=msg;self.state=1;if(self.chain.length>0){schedule(notify,self);}}}catch(err){reject.call(new MakeDefWrapper(self),err);}}function reject(msg){var self=this;// already triggered?
if(self.triggered){return;}self.triggered=true;// unwrap
if(self.def){self=self.def;}self.msg=msg;self.state=2;if(self.chain.length>0){schedule(notify,self);}}function iteratePromises(Constructor,arr,resolver,rejecter){for(var idx=0;idx<arr.length;idx++){(function IIFE(idx){Constructor.resolve(arr[idx]).then(function $resolver$(msg){resolver(idx,msg);},rejecter);})(idx);}}function MakeDefWrapper(self){this.def=self;this.triggered=false;}function MakeDef(self){this.promise=self;this.state=0;this.triggered=false;this.chain=[];this.msg=void 0;}function Promise(executor){if(typeof executor!="function"){throw TypeError("Not a function");}if(this.__NPO__!==0){throw TypeError("Not a promise");}// instance shadowing the inherited "brand"
// to signal an already "initialized" promise
this.__NPO__=1;var def=new MakeDef(this);this["then"]=function then(success,failure){var o={success:typeof success=="function"?success:true,failure:typeof failure=="function"?failure:false};// Note: `then(..)` itself can be borrowed to be used against
// a different promise constructor for making the chained promise,
// by substituting a different `this` binding.
o.promise=new this.constructor(function extractChain(resolve,reject){if(typeof resolve!="function"||typeof reject!="function"){throw TypeError("Not a function");}o.resolve=resolve;o.reject=reject;});def.chain.push(o);if(def.state!==0){schedule(notify,def);}return o.promise;};this["catch"]=function $catch$(failure){return this.then(void 0,failure);};try{executor.call(void 0,function publicResolve(msg){resolve.call(def,msg);},function publicReject(msg){reject.call(def,msg);});}catch(err){reject.call(def,err);}}var PromisePrototype=builtInProp({},"constructor",Promise,/*configurable=*/false);// Note: Android 4 cannot use `Object.defineProperty(..)` here
Promise.prototype=PromisePrototype;// built-in "brand" to signal an "uninitialized" promise
builtInProp(PromisePrototype,"__NPO__",0,/*configurable=*/false);builtInProp(Promise,"resolve",function Promise$resolve(msg){var Constructor=this;// spec mandated checks
// note: best "isPromise" check that's practical for now
if(msg&&(typeof msg==="undefined"?"undefined":_typeof(msg))=="object"&&msg.__NPO__===1){return msg;}return new Constructor(function executor(resolve,reject){if(typeof resolve!="function"||typeof reject!="function"){throw TypeError("Not a function");}resolve(msg);});});builtInProp(Promise,"reject",function Promise$reject(msg){return new this(function executor(resolve,reject){if(typeof resolve!="function"||typeof reject!="function"){throw TypeError("Not a function");}reject(msg);});});builtInProp(Promise,"all",function Promise$all(arr){var Constructor=this;// spec mandated checks
if(ToString.call(arr)!="[object Array]"){return Constructor.reject(TypeError("Not an array"));}if(arr.length===0){return Constructor.resolve([]);}return new Constructor(function executor(resolve,reject){if(typeof resolve!="function"||typeof reject!="function"){throw TypeError("Not a function");}var len=arr.length,msgs=Array(len),count=0;iteratePromises(Constructor,arr,function resolver(idx,msg){msgs[idx]=msg;if(++count===len){resolve(msgs);}},reject);});});builtInProp(Promise,"race",function Promise$race(arr){var Constructor=this;// spec mandated checks
if(ToString.call(arr)!="[object Array]"){return Constructor.reject(TypeError("Not an array"));}return new Constructor(function executor(resolve,reject){if(typeof resolve!="function"||typeof reject!="function"){throw TypeError("Not a function");}iteratePromises(Constructor,arr,function resolver(idx,msg){resolve(msg);},reject);});});return Promise;});}).call(this,typeof global!=="undefined"?global:typeof self!=="undefined"?self:typeof window!=="undefined"?window:{});},{}],4:[function(require,module,exports){(function(process){// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts,allowAboveRoot){// if the path tries to go above the root, `up` ends up > 0
var up=0;for(var i=parts.length-1;i>=0;i--){var last=parts[i];if(last==='.'){parts.splice(i,1);}else if(last==='..'){parts.splice(i,1);up++;}else if(up){parts.splice(i,1);up--;}}// if the path is allowed to go above the root, restore leading ..s
if(allowAboveRoot){for(;up--;up){parts.unshift('..');}}return parts;}// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;var splitPath=function splitPath(filename){return splitPathRe.exec(filename).slice(1);};// path.resolve([from ...], to)
// posix version
exports.resolve=function(){var resolvedPath='',resolvedAbsolute=false;for(var i=arguments.length-1;i>=-1&&!resolvedAbsolute;i--){var path=i>=0?arguments[i]:process.cwd();// Skip empty and invalid entries
if(typeof path!=='string'){throw new TypeError('Arguments to path.resolve must be strings');}else if(!path){continue;}resolvedPath=path+'/'+resolvedPath;resolvedAbsolute=path.charAt(0)==='/';}// At this point the path should be resolved to a full absolute path, but
// handle relative paths to be safe (might happen when process.cwd() fails)
// Normalize the path
resolvedPath=normalizeArray(filter(resolvedPath.split('/'),function(p){return!!p;}),!resolvedAbsolute).join('/');return(resolvedAbsolute?'/':'')+resolvedPath||'.';};// path.normalize(path)
// posix version
exports.normalize=function(path){var isAbsolute=exports.isAbsolute(path),trailingSlash=substr(path,-1)==='/';// Normalize the path
path=normalizeArray(filter(path.split('/'),function(p){return!!p;}),!isAbsolute).join('/');if(!path&&!isAbsolute){path='.';}if(path&&trailingSlash){path+='/';}return(isAbsolute?'/':'')+path;};// posix version
exports.isAbsolute=function(path){return path.charAt(0)==='/';};// posix version
exports.join=function(){var paths=Array.prototype.slice.call(arguments,0);return exports.normalize(filter(paths,function(p,index){if(typeof p!=='string'){throw new TypeError('Arguments to path.join must be strings');}return p;}).join('/'));};// path.relative(from, to)
// posix version
exports.relative=function(from,to){from=exports.resolve(from).substr(1);to=exports.resolve(to).substr(1);function trim(arr){var start=0;for(;start<arr.length;start++){if(arr[start]!=='')break;}var end=arr.length-1;for(;end>=0;end--){if(arr[end]!=='')break;}if(start>end)return[];return arr.slice(start,end-start+1);}var fromParts=trim(from.split('/'));var toParts=trim(to.split('/'));var length=Math.min(fromParts.length,toParts.length);var samePartsLength=length;for(var i=0;i<length;i++){if(fromParts[i]!==toParts[i]){samePartsLength=i;break;}}var outputParts=[];for(var i=samePartsLength;i<fromParts.length;i++){outputParts.push('..');}outputParts=outputParts.concat(toParts.slice(samePartsLength));return outputParts.join('/');};exports.sep='/';exports.delimiter=':';exports.dirname=function(path){var result=splitPath(path),root=result[0],dir=result[1];if(!root&&!dir){// No dirname whatsoever
return'.';}if(dir){// It has a dirname, strip trailing slash
dir=dir.substr(0,dir.length-1);}return root+dir;};exports.basename=function(path,ext){var f=splitPath(path)[2];// TODO: make this comparison case-insensitive on windows?
if(ext&&f.substr(-1*ext.length)===ext){f=f.substr(0,f.length-ext.length);}return f;};exports.extname=function(path){return splitPath(path)[3];};function filter(xs,f){if(xs.filter)return xs.filter(f);var res=[];for(var i=0;i<xs.length;i++){if(f(xs[i],i,xs))res.push(xs[i]);}return res;}// String.prototype.substr - negative index don't work in IE8
var substr='ab'.substr(-1)==='b'?function(str,start,len){return str.substr(start,len);}:function(str,start,len){if(start<0)start=str.length+start;return str.substr(start,len);};}).call(this,require('_process'));},{"_process":8}],5:[function(require,module,exports){/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Jeremy Whitlock
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */'use strict';/**
 * Utility that provides a single API for loading the content of a path/URL.
 *
 * @module PathLoader
 */var supportedLoaders={file:require('./lib/loaders/file'),http:require('./lib/loaders/http'),https:require('./lib/loaders/http')};var defaultLoader=(typeof window==="undefined"?"undefined":_typeof(window))==='object'||typeof importScripts==='function'?supportedLoaders.http:supportedLoaders.file;// Load promises polyfill if necessary
/* istanbul ignore if */if(typeof Promise==='undefined'){require('native-promise-only');}function getScheme(location){if(typeof location!=='undefined'){location=location.indexOf('://')===-1?'':location.split('://')[0];}return location;}/**
 * Callback used to provide access to altering a remote request prior to the request being made.
 *
 * @typedef {function} PrepareRequestCallback
 *
 * @param {object} req - The Superagent request object
 * @param {string} location - The location being retrieved
 * @param {function} callback - First callback
 *
 * @alias module:PathLoader~PrepareRequestCallback
 *//**
  * Callback used to provide access to processing the raw response of the request being made. *(HTTP loader only)*
  *
  * @typedef {function} ProcessResponseCallback
  *
  * @param {object} res - The Superagent response object *(For non-HTTP loaders, this object will be like the Superagent
  * object in that it will have a `text` property whose value is the raw string value being processed.  This was done
  * for consistency.)*
  * @param {function} callback - Error-first callback
  *
  * @returns {*} the result of processing the responsexs
  *
  * @alias module:PathLoader~ProcessResponseCallback
  */function getLoader(location){var scheme=getScheme(location);var loader=supportedLoaders[scheme];if(typeof loader==='undefined'){if(scheme===''){loader=defaultLoader;}else{throw new Error('Unsupported scheme: '+scheme);}}return loader;}/**
 * Loads a document at the provided location and returns a JavaScript object representation.
 *
 * @param {object} location - The location to the document
 * @param {object} [options] - The options
 * @param {string} [options.encoding='utf-8'] - The encoding to use when loading the file *(File loader only)*
 * @param {string} [options.method=get] - The HTTP method to use for the request *(HTTP loader only)*
 * @param {module:PathLoader~PrepareRequestCallback} [options.prepareRequest] - The callback used to prepare the request
 * *(HTTP loader only)*
 * @param {module:PathLoader~ProcessResponseCallback} [options.processContent] - The callback used to process the
 * response
 *
 * @returns {Promise} Always returns a promise even if there is a callback provided
 *
 * @example
 * // Example using Promises
 *
 * PathLoader
 *   .load('./package.json')
 *   .then(JSON.parse)
 *   .then(function (document) {
 *     console.log(document.name + ' (' + document.version + '): ' + document.description);
 *   }, function (err) {
 *     console.error(err.stack);
 *   });
 *
 * @example
 * // Example using options.prepareRequest to provide authentication details for a remotely secure URL
 *
 * PathLoader
 *   .load('https://api.github.com/repos/whitlockjc/path-loader', {
 *     prepareRequest: function (req, callback) {
 *       req.auth('my-username', 'my-password');
 *       callback(undefined, req);
 *     }
 *   })
 *   .then(JSON.parse)
 *   .then(function (document) {
 *     console.log(document.full_name + ': ' + document.description);
 *   }, function (err) {
 *     console.error(err.stack);
 *   });
 *
 * @example
 * // Example loading a YAML file
 *
 * PathLoader
 *   .load('/Users/not-you/projects/path-loader/.travis.yml')
 *   .then(YAML.safeLoad)
 *   .then(function (document) {
 *     console.log('path-loader uses the', document.language, 'language.');
 *   }, function (err) {
 *     console.error(err.stack);
 *   });
 *
 * @example
 * // Example loading a YAML file with options.processContent (Useful if you need information in the raw response)
 *
 * PathLoader
 *   .load('/Users/not-you/projects/path-loader/.travis.yml', {
 *     processContent: function (res, callback) {
 *       callback(YAML.safeLoad(res.text));
 *     }
 *   })
 *   .then(function (document) {
 *     console.log('path-loader uses the', document.language, 'language.');
 *   }, function (err) {
 *     console.error(err.stack);
 *   });
 */module.exports.load=function(location,options){var allTasks=Promise.resolve();// Default options to empty object
if(typeof options==='undefined'){options={};}// Validate arguments
allTasks=allTasks.then(function(){if(typeof location==='undefined'){throw new TypeError('location is required');}else if(typeof location!=='string'){throw new TypeError('location must be a string');}if(typeof options!=='undefined'){if((typeof options==="undefined"?"undefined":_typeof(options))!=='object'){throw new TypeError('options must be an object');}else if(typeof options.processContent!=='undefined'&&typeof options.processContent!=='function'){throw new TypeError('options.processContent must be a function');}}});// Load the document from the provided location and process it
allTasks=allTasks.then(function(){return new Promise(function(resolve,reject){var loader=getLoader(location);loader.load(location,options||{},function(err,document){if(err){reject(err);}else{resolve(document);}});});}).then(function(res){if(options.processContent){return new Promise(function(resolve,reject){// For consistency between file and http, always send an object with a 'text' property containing the raw
// string value being processed.
options.processContent((typeof res==="undefined"?"undefined":_typeof(res))==='object'?res:{text:res},function(err,processed){if(err){reject(err);}else{resolve(processed);}});});}else{// If there was no content processor, we will assume that for all objects that it is a Superagent response
// and will return its `text` property value.  Otherwise, we will return the raw response.
return(typeof res==="undefined"?"undefined":_typeof(res))==='object'?res.text:res;}});return allTasks;};},{"./lib/loaders/file":6,"./lib/loaders/http":7,"native-promise-only":3}],6:[function(require,module,exports){/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Jeremy Whitlock
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */'use strict';var unsupportedError=new TypeError('The \'file\' scheme is not supported in the browser');/**
 * The file loader is not supported in the browser.
 *
 * @throws {error} the file loader is not supported in the browser
 */module.exports.getBase=function(){throw unsupportedError;};/**
 * The file loader is not supported in the browser.
 */module.exports.load=function(){var fn=arguments[arguments.length-1];if(typeof fn==='function'){fn(unsupportedError);}else{throw unsupportedError;}};},{}],7:[function(require,module,exports){/* eslint-env node, browser *//*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 Jeremy Whitlock
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */'use strict';var request=require('superagent');var supportedHttpMethods=['delete','get','head','patch','post','put'];/**
 * Loads a file from an http or https URL.
 *
 * @param {string} location - The document URL (If relative, location is relative to window.location.origin).
 * @param {object} options - The loader options
 * @param {string} [options.method=get] - The HTTP method to use for the request
 * @param {module:PathLoader~PrepareRequestCallback} [options.prepareRequest] - The callback used to prepare a request
 * @param {module:PathLoader~ProcessResponseCallback} [options.processContent] - The callback used to process the
 * response
 * @param {function} callback - The error-first callback
 */module.exports.load=function(location,options,callback){var realMethod=options.method?options.method.toLowerCase():'get';var err;var realRequest;function makeRequest(err,req){if(err){callback(err);}else{// buffer() is only available in Node.js
if(typeof req.buffer==='function'){req.buffer(true);}req.end(function(err2,res){if(err2){callback(err2);}else{callback(undefined,res);}});}}if(typeof options.method!=='undefined'){if(typeof options.method!=='string'){err=new TypeError('options.method must be a string');}else if(supportedHttpMethods.indexOf(options.method)===-1){err=new TypeError('options.method must be one of the following: '+supportedHttpMethods.slice(0,supportedHttpMethods.length-1).join(', ')+' or '+supportedHttpMethods[supportedHttpMethods.length-1]);}}else if(typeof options.prepareRequest!=='undefined'&&typeof options.prepareRequest!=='function'){err=new TypeError('options.prepareRequest must be a function');}if(!err){realRequest=request[realMethod==='delete'?'del':realMethod](location);if(options.prepareRequest){try{options.prepareRequest(realRequest,makeRequest);}catch(err2){callback(err2);}}else{makeRequest(undefined,realRequest);}}else{callback(err);}};},{"superagent":14}],8:[function(require,module,exports){// shim for using process in browser
var process=module.exports={};var queue=[];var draining=false;var currentQueue;var queueIndex=-1;function cleanUpNextTick(){draining=false;if(currentQueue.length){queue=currentQueue.concat(queue);}else{queueIndex=-1;}if(queue.length){drainQueue();}}function drainQueue(){if(draining){return;}var timeout=setTimeout(cleanUpNextTick);draining=true;var len=queue.length;while(len){currentQueue=queue;queue=[];while(++queueIndex<len){if(currentQueue){currentQueue[queueIndex].run();}}queueIndex=-1;len=queue.length;}currentQueue=null;draining=false;clearTimeout(timeout);}process.nextTick=function(fun){var args=new Array(arguments.length-1);if(arguments.length>1){for(var i=1;i<arguments.length;i++){args[i-1]=arguments[i];}}queue.push(new Item(fun,args));if(queue.length===1&&!draining){setTimeout(drainQueue,0);}};// v8 likes predictible objects
function Item(fun,array){this.fun=fun;this.array=array;}Item.prototype.run=function(){this.fun.apply(null,this.array);};process.title='browser';process.browser=true;process.env={};process.argv=[];process.version='';// empty string to avoid regexp issues
process.versions={};function noop(){}process.on=noop;process.addListener=noop;process.once=noop;process.off=noop;process.removeListener=noop;process.removeAllListeners=noop;process.emit=noop;process.binding=function(name){throw new Error('process.binding is not supported');};process.cwd=function(){return'/';};process.chdir=function(dir){throw new Error('process.chdir is not supported');};process.umask=function(){return 0;};},{}],9:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj,prop){return Object.prototype.hasOwnProperty.call(obj,prop);}module.exports=function(qs,sep,eq,options){sep=sep||'&';eq=eq||'=';var obj={};if(typeof qs!=='string'||qs.length===0){return obj;}var regexp=/\+/g;qs=qs.split(sep);var maxKeys=1000;if(options&&typeof options.maxKeys==='number'){maxKeys=options.maxKeys;}var len=qs.length;// maxKeys <= 0 means that we should not limit keys count
if(maxKeys>0&&len>maxKeys){len=maxKeys;}for(var i=0;i<len;++i){var x=qs[i].replace(regexp,'%20'),idx=x.indexOf(eq),kstr,vstr,k,v;if(idx>=0){kstr=x.substr(0,idx);vstr=x.substr(idx+1);}else{kstr=x;vstr='';}k=decodeURIComponent(kstr);v=decodeURIComponent(vstr);if(!hasOwnProperty(obj,k)){obj[k]=v;}else if(isArray(obj[k])){obj[k].push(v);}else{obj[k]=[obj[k],v];}}return obj;};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};},{}],10:[function(require,module,exports){// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';var stringifyPrimitive=function stringifyPrimitive(v){switch(typeof v==="undefined"?"undefined":_typeof(v)){case'string':return v;case'boolean':return v?'true':'false';case'number':return isFinite(v)?v:'';default:return'';}};module.exports=function(obj,sep,eq,name){sep=sep||'&';eq=eq||'=';if(obj===null){obj=undefined;}if((typeof obj==="undefined"?"undefined":_typeof(obj))==='object'){return map(objectKeys(obj),function(k){var ks=encodeURIComponent(stringifyPrimitive(k))+eq;if(isArray(obj[k])){return map(obj[k],function(v){return ks+encodeURIComponent(stringifyPrimitive(v));}).join(sep);}else{return ks+encodeURIComponent(stringifyPrimitive(obj[k]));}}).join(sep);}if(!name)return'';return encodeURIComponent(stringifyPrimitive(name))+eq+encodeURIComponent(stringifyPrimitive(obj));};var isArray=Array.isArray||function(xs){return Object.prototype.toString.call(xs)==='[object Array]';};function map(xs,f){if(xs.map)return xs.map(f);var res=[];for(var i=0;i<xs.length;i++){res.push(f(xs[i],i));}return res;}var objectKeys=Object.keys||function(obj){var res=[];for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))res.push(key);}return res;};},{}],11:[function(require,module,exports){'use strict';exports.decode=exports.parse=require('./decode');exports.encode=exports.stringify=require('./encode');},{"./decode":9,"./encode":10}],12:[function(require,module,exports){/**
 * Reduce `arr` with `fn`.
 *
 * @param {Array} arr
 * @param {Function} fn
 * @param {Mixed} initial
 *
 * TODO: combatible error handling?
 */module.exports=function(arr,fn,initial){var idx=0;var len=arr.length;var curr=arguments.length==3?initial:arr[idx++];while(idx<len){curr=fn.call(null,curr,arr[idx],++idx,arr);}return curr;};},{}],13:[function(require,module,exports){'use strict';module.exports=function(str){var isExtendedLengthPath=/^\\\\\?\\/.test(str);var hasNonAscii=/[^\x00-\x80]+/.test(str);if(isExtendedLengthPath||hasNonAscii){return str;}return str.replace(/\\/g,'/');};},{}],14:[function(require,module,exports){/**
 * Module dependencies.
 */var Emitter=require('emitter');var reduce=require('reduce');var requestBase=require('./request-base');var isObject=require('./is-object');/**
 * Root reference for iframes.
 */var root;if(typeof window!=='undefined'){// Browser window
root=window;}else if(typeof self!=='undefined'){// Web Worker
root=self;}else{// Other environments
root=this;}/**
 * Noop.
 */function noop(){};/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * TODO: future proof, move to compoent land
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */function isHost(obj){var str={}.toString.call(obj);switch(str){case'[object File]':case'[object Blob]':case'[object FormData]':return true;default:return false;}}/**
 * Expose `request`.
 */var request=module.exports=require('./request').bind(null,Request);/**
 * Determine XHR.
 */request.getXHR=function(){if(root.XMLHttpRequest&&(!root.location||'file:'!=root.location.protocol||!root.ActiveXObject)){return new XMLHttpRequest();}else{try{return new ActiveXObject('Microsoft.XMLHTTP');}catch(e){}try{return new ActiveXObject('Msxml2.XMLHTTP.6.0');}catch(e){}try{return new ActiveXObject('Msxml2.XMLHTTP.3.0');}catch(e){}try{return new ActiveXObject('Msxml2.XMLHTTP');}catch(e){}}return false;};/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */var trim=''.trim?function(s){return s.trim();}:function(s){return s.replace(/(^\s*|\s*$)/g,'');};/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */function serialize(obj){if(!isObject(obj))return obj;var pairs=[];for(var key in obj){if(null!=obj[key]){pushEncodedKeyValuePair(pairs,key,obj[key]);}}return pairs.join('&');}/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */function pushEncodedKeyValuePair(pairs,key,val){if(Array.isArray(val)){return val.forEach(function(v){pushEncodedKeyValuePair(pairs,key,v);});}pairs.push(encodeURIComponent(key)+'='+encodeURIComponent(val));}/**
 * Expose serialization method.
 */request.serializeObject=serialize;/**
  * Parse the given x-www-form-urlencoded `str`.
  *
  * @param {String} str
  * @return {Object}
  * @api private
  */function parseString(str){var obj={};var pairs=str.split('&');var parts;var pair;for(var i=0,len=pairs.length;i<len;++i){pair=pairs[i];parts=pair.split('=');obj[decodeURIComponent(parts[0])]=decodeURIComponent(parts[1]);}return obj;}/**
 * Expose parser.
 */request.parseString=parseString;/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */request.types={html:'text/html',json:'application/json',xml:'application/xml',urlencoded:'application/x-www-form-urlencoded','form':'application/x-www-form-urlencoded','form-data':'application/x-www-form-urlencoded'};/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */request.serialize={'application/x-www-form-urlencoded':serialize,'application/json':JSON.stringify};/**
  * Default parsers.
  *
  *     superagent.parse['application/xml'] = function(str){
  *       return { object parsed from str };
  *     };
  *
  */request.parse={'application/x-www-form-urlencoded':parseString,'application/json':JSON.parse};/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */function parseHeader(str){var lines=str.split(/\r?\n/);var fields={};var index;var line;var field;var val;lines.pop();// trailing CRLF
for(var i=0,len=lines.length;i<len;++i){line=lines[i];index=line.indexOf(':');field=line.slice(0,index).toLowerCase();val=trim(line.slice(index+1));fields[field]=val;}return fields;}/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */function isJSON(mime){return /[\/+]json\b/.test(mime);}/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */function type(str){return str.split(/ *; */).shift();};/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */function params(str){return reduce(str.split(/ *; */),function(obj,str){var parts=str.split(/ *= */),key=parts.shift(),val=parts.shift();if(key&&val)obj[key]=val;return obj;},{});};/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */function Response(req,options){options=options||{};this.req=req;this.xhr=this.req.xhr;// responseText is accessible only if responseType is '' or 'text' and on older browsers
this.text=this.req.method!='HEAD'&&(this.xhr.responseType===''||this.xhr.responseType==='text')||typeof this.xhr.responseType==='undefined'?this.xhr.responseText:null;this.statusText=this.req.xhr.statusText;this.setStatusProperties(this.xhr.status);this.header=this.headers=parseHeader(this.xhr.getAllResponseHeaders());// getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
// getResponseHeader still works. so we get content-type even if getting
// other headers fails.
this.header['content-type']=this.xhr.getResponseHeader('content-type');this.setHeaderProperties(this.header);this.body=this.req.method!='HEAD'?this.parseBody(this.text?this.text:this.xhr.response):null;}/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */Response.prototype.get=function(field){return this.header[field.toLowerCase()];};/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */Response.prototype.setHeaderProperties=function(header){// content-type
var ct=this.header['content-type']||'';this.type=type(ct);// params
var obj=params(ct);for(var key in obj){this[key]=obj[key];}};/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */Response.prototype.parseBody=function(str){var parse=request.parse[this.type];if(!parse&&isJSON(this.type)){parse=request.parse['application/json'];}return parse&&str&&(str.length||str instanceof Object)?parse(str):null;};/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */Response.prototype.setStatusProperties=function(status){// handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
if(status===1223){status=204;}var type=status/100|0;// status / class
this.status=this.statusCode=status;this.statusType=type;// basics
this.info=1==type;this.ok=2==type;this.clientError=4==type;this.serverError=5==type;this.error=4==type||5==type?this.toError():false;// sugar
this.accepted=202==status;this.noContent=204==status;this.badRequest=400==status;this.unauthorized=401==status;this.notAcceptable=406==status;this.notFound=404==status;this.forbidden=403==status;};/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */Response.prototype.toError=function(){var req=this.req;var method=req.method;var url=req.url;var msg='cannot '+method+' '+url+' ('+this.status+')';var err=new Error(msg);err.status=this.status;err.method=method;err.url=url;return err;};/**
 * Expose `Response`.
 */request.Response=Response;/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */function Request(method,url){var self=this;this._query=this._query||[];this.method=method;this.url=url;this.header={};// preserves header name case
this._header={};// coerces header names to lowercase
this.on('end',function(){var err=null;var res=null;try{res=new Response(self);}catch(e){err=new Error('Parser is unable to parse the response');err.parse=true;err.original=e;// issue #675: return the raw response if the response parsing fails
err.rawResponse=self.xhr&&self.xhr.responseText?self.xhr.responseText:null;// issue #876: return the http status code if the response parsing fails
err.statusCode=self.xhr&&self.xhr.status?self.xhr.status:null;return self.callback(err);}self.emit('response',res);if(err){return self.callback(err,res);}if(res.status>=200&&res.status<300){return self.callback(err,res);}var new_err=new Error(res.statusText||'Unsuccessful HTTP response');new_err.original=err;new_err.response=res;new_err.status=res.status;self.callback(new_err,res);});}/**
 * Mixin `Emitter` and `requestBase`.
 */Emitter(Request.prototype);for(var key in requestBase){Request.prototype[key]=requestBase[key];}/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request}
 * @api public
 */Request.prototype.abort=function(){if(this.aborted)return;this.aborted=true;this.xhr.abort();this.clearTimeout();this.emit('abort');return this;};/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */Request.prototype.type=function(type){this.set('Content-Type',request.types[type]||type);return this;};/**
 * Set responseType to `val`. Presently valid responseTypes are 'blob' and 
 * 'arraybuffer'.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */Request.prototype.responseType=function(val){this._responseType=val;return this;};/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */Request.prototype.accept=function(type){this.set('Accept',request.types[type]||type);return this;};/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} pass
 * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */Request.prototype.auth=function(user,pass,options){if(!options){options={type:'basic'};}switch(options.type){case'basic':var str=btoa(user+':'+pass);this.set('Authorization','Basic '+str);break;case'auto':this.username=user;this.password=pass;break;}return this;};/**
* Add query-string `val`.
*
* Examples:
*
*   request.get('/shoes')
*     .query('size=10')
*     .query({ color: 'blue' })
*
* @param {Object|String} val
* @return {Request} for chaining
* @api public
*/Request.prototype.query=function(val){if('string'!=typeof val)val=serialize(val);if(val)this._query.push(val);return this;};/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `filename`.
 *
 * ``` js
 * request.post('/upload')
 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String} filename
 * @return {Request} for chaining
 * @api public
 */Request.prototype.attach=function(field,file,filename){this._getFormData().append(field,file,filename||file.name);return this;};Request.prototype._getFormData=function(){if(!this._formData){this._formData=new root.FormData();}return this._formData;};/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
  *      request.post('/user')
  *        .send('name=tobi')
  *        .send('species=ferret')
  *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */Request.prototype.send=function(data){var obj=isObject(data);var type=this._header['content-type'];// merge
if(obj&&isObject(this._data)){for(var key in data){this._data[key]=data[key];}}else if('string'==typeof data){if(!type)this.type('form');type=this._header['content-type'];if('application/x-www-form-urlencoded'==type){this._data=this._data?this._data+'&'+data:data;}else{this._data=(this._data||'')+data;}}else{this._data=data;}if(!obj||isHost(data))return this;if(!type)this.type('json');return this;};/**
 * @deprecated
 */Response.prototype.parse=function serialize(fn){if(root.console){console.warn("Client-side parse() method has been renamed to serialize(). This method is not compatible with superagent v2.0");}this.serialize(fn);return this;};Response.prototype.serialize=function serialize(fn){this._parser=fn;return this;};/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */Request.prototype.callback=function(err,res){var fn=this._callback;this.clearTimeout();fn(err,res);};/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */Request.prototype.crossDomainError=function(){var err=new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');err.crossDomain=true;err.status=this.status;err.method=this.method;err.url=this.url;this.callback(err);};/**
 * Invoke callback with timeout error.
 *
 * @api private
 */Request.prototype.timeoutError=function(){var timeout=this._timeout;var err=new Error('timeout of '+timeout+'ms exceeded');err.timeout=timeout;this.callback(err);};/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */Request.prototype.withCredentials=function(){this._withCredentials=true;return this;};/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */Request.prototype.end=function(fn){var self=this;var xhr=this.xhr=request.getXHR();var query=this._query.join('&');var timeout=this._timeout;var data=this._formData||this._data;// store callback
this._callback=fn||noop;// state change
xhr.onreadystatechange=function(){if(4!=xhr.readyState)return;// In IE9, reads to any property (e.g. status) off of an aborted XHR will
// result in the error "Could not complete the operation due to error c00c023f"
var status;try{status=xhr.status;}catch(e){status=0;}if(0==status){if(self.timedout)return self.timeoutError();if(self.aborted)return;return self.crossDomainError();}self.emit('end');};// progress
var handleProgress=function handleProgress(e){if(e.total>0){e.percent=e.loaded/e.total*100;}e.direction='download';self.emit('progress',e);};if(this.hasListeners('progress')){xhr.onprogress=handleProgress;}try{if(xhr.upload&&this.hasListeners('progress')){xhr.upload.onprogress=handleProgress;}}catch(e){}// Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
// Reported here:
// https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
// timeout
if(timeout&&!this._timer){this._timer=setTimeout(function(){self.timedout=true;self.abort();},timeout);}// querystring
if(query){query=request.serializeObject(query);this.url+=~this.url.indexOf('?')?'&'+query:'?'+query;}// initiate request
if(this.username&&this.password){xhr.open(this.method,this.url,true,this.username,this.password);}else{xhr.open(this.method,this.url,true);}// CORS
if(this._withCredentials)xhr.withCredentials=true;// body
if('GET'!=this.method&&'HEAD'!=this.method&&'string'!=typeof data&&!isHost(data)){// serialize stuff
var contentType=this._header['content-type'];var serialize=this._parser||request.serialize[contentType?contentType.split(';')[0]:''];if(!serialize&&isJSON(contentType))serialize=request.serialize['application/json'];if(serialize)data=serialize(data);}// set header fields
for(var field in this.header){if(null==this.header[field])continue;xhr.setRequestHeader(field,this.header[field]);}if(this._responseType){xhr.responseType=this._responseType;}// send stuff
this.emit('request',this);// IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
// We need null here if data is undefined
xhr.send(typeof data!=='undefined'?data:null);return this;};/**
 * Expose `Request`.
 */request.Request=Request;/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */request.get=function(url,data,fn){var req=request('GET',url);if('function'==typeof data)fn=data,data=null;if(data)req.query(data);if(fn)req.end(fn);return req;};/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */request.head=function(url,data,fn){var req=request('HEAD',url);if('function'==typeof data)fn=data,data=null;if(data)req.send(data);if(fn)req.end(fn);return req;};/**
 * DELETE `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Function} fn
 * @return {Request}
 * @api public
 */function del(url,fn){var req=request('DELETE',url);if(fn)req.end(fn);return req;};request['del']=del;request['delete']=del;/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */request.patch=function(url,data,fn){var req=request('PATCH',url);if('function'==typeof data)fn=data,data=null;if(data)req.send(data);if(fn)req.end(fn);return req;};/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} data
 * @param {Function} fn
 * @return {Request}
 * @api public
 */request.post=function(url,data,fn){var req=request('POST',url);if('function'==typeof data)fn=data,data=null;if(data)req.send(data);if(fn)req.end(fn);return req;};/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} data or fn
 * @param {Function} fn
 * @return {Request}
 * @api public
 */request.put=function(url,data,fn){var req=request('PUT',url);if('function'==typeof data)fn=data,data=null;if(data)req.send(data);if(fn)req.end(fn);return req;};},{"./is-object":15,"./request":17,"./request-base":16,"emitter":2,"reduce":12}],15:[function(require,module,exports){/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */function isObject(obj){return null!=obj&&'object'==(typeof obj==="undefined"?"undefined":_typeof(obj));}module.exports=isObject;},{}],16:[function(require,module,exports){/**
 * Module of mixed-in functions shared between node and client code
 */var isObject=require('./is-object');/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */exports.clearTimeout=function _clearTimeout(){this._timeout=0;clearTimeout(this._timer);return this;};/**
 * Force given parser
 *
 * Sets the body parser no matter type.
 *
 * @param {Function}
 * @api public
 */exports.parse=function parse(fn){this._parser=fn;return this;};/**
 * Set timeout to `ms`.
 *
 * @param {Number} ms
 * @return {Request} for chaining
 * @api public
 */exports.timeout=function timeout(ms){this._timeout=ms;return this;};/**
 * Faux promise support
 *
 * @param {Function} fulfill
 * @param {Function} reject
 * @return {Request}
 */exports.then=function then(fulfill,reject){return this.end(function(err,res){err?reject(err):fulfill(res);});};/**
 * Allow for extension
 */exports.use=function use(fn){fn(this);return this;};/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */exports.get=function(field){return this._header[field.toLowerCase()];};/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */exports.getHeader=exports.get;/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */exports.set=function(field,val){if(isObject(field)){for(var key in field){this.set(key,field[key]);}return this;}this._header[field.toLowerCase()]=val;this.header[field]=val;return this;};/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field
 */exports.unset=function(field){delete this._header[field.toLowerCase()];delete this.header[field];return this;};/**
 * Write the field `name` and `val` for "multipart/form-data"
 * request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 * ```
 *
 * @param {String} name
 * @param {String|Blob|File|Buffer|fs.ReadStream} val
 * @return {Request} for chaining
 * @api public
 */exports.field=function(name,val){this._getFormData().append(name,val);return this;};},{"./is-object":15}],17:[function(require,module,exports){// The node and browser modules expose versions of this with the
// appropriate constructor function bound as first argument
/**
 * Issue a request:
 *
 * Examples:
 *
 *    request('GET', '/users').end(callback)
 *    request('/users').end(callback)
 *    request('/users', callback)
 *
 * @param {String} method
 * @param {String|Function} url or callback
 * @return {Request}
 * @api public
 */function request(RequestConstructor,method,url){// callback
if('function'==typeof url){return new RequestConstructor('GET',method).end(url);}// url first
if(2==arguments.length){return new RequestConstructor('GET',method);}return new RequestConstructor(method,url);}module.exports=request;},{}],18:[function(require,module,exports){/*! https://mths.be/punycode v1.3.2 by @mathias, modified for URI.js */var punycode=function(){/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */var punycode,/** Highest positive signed 32-bit float value */maxInt=2147483647,// aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */base=36,tMin=1,tMax=26,skew=38,damp=700,initialBias=72,initialN=128,// 0x80
delimiter='-',// '\x2D'
/** Regular expressions */regexPunycode=/^xn--/,regexNonASCII=/[^\x20-\x7E]/,// unprintable ASCII chars + non-ASCII chars
regexSeparators=/[\x2E\u3002\uFF0E\uFF61]/g,// RFC 3490 separators
/** Error messages */errors={'overflow':'Overflow: input needs wider integers to process','not-basic':'Illegal input >= 0x80 (not a basic code point)','invalid-input':'Invalid input'},/** Convenience shortcuts */baseMinusTMin=base-tMin,floor=Math.floor,stringFromCharCode=String.fromCharCode,/** Temporary variable */key;/*--------------------------------------------------------------------------*//**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */function error(type){throw new RangeError(errors[type]);}/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */function map(array,fn){var length=array.length;var result=[];while(length--){result[length]=fn(array[length]);}return result;}/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */function mapDomain(string,fn){var parts=string.split('@');var result='';if(parts.length>1){// In email addresses, only the domain name should be punycoded. Leave
// the local part (i.e. everything up to `@`) intact.
result=parts[0]+'@';string=parts[1];}// Avoid `split(regex)` for IE8 compatibility. See #17.
string=string.replace(regexSeparators,'\x2E');var labels=string.split('.');var encoded=map(labels,fn).join('.');return result+encoded;}/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */function ucs2decode(string){var output=[],counter=0,length=string.length,value,extra;while(counter<length){value=string.charCodeAt(counter++);if(value>=0xD800&&value<=0xDBFF&&counter<length){// high surrogate, and there is a next character
extra=string.charCodeAt(counter++);if((extra&0xFC00)==0xDC00){// low surrogate
output.push(((value&0x3FF)<<10)+(extra&0x3FF)+0x10000);}else{// unmatched surrogate; only append this code unit, in case the next
// code unit is the high surrogate of a surrogate pair
output.push(value);counter--;}}else{output.push(value);}}return output;}/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */function ucs2encode(array){return map(array,function(value){var output='';if(value>0xFFFF){value-=0x10000;output+=stringFromCharCode(value>>>10&0x3FF|0xD800);value=0xDC00|value&0x3FF;}output+=stringFromCharCode(value);return output;}).join('');}/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */function basicToDigit(codePoint){if(codePoint-48<10){return codePoint-22;}if(codePoint-65<26){return codePoint-65;}if(codePoint-97<26){return codePoint-97;}return base;}/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */function digitToBasic(digit,flag){//  0..25 map to ASCII a..z or A..Z
// 26..35 map to ASCII 0..9
return digit+22+75*(digit<26)-((flag!=0)<<5);}/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */function adapt(delta,numPoints,firstTime){var k=0;delta=firstTime?floor(delta/damp):delta>>1;delta+=floor(delta/numPoints);for(;/* no initialization */delta>baseMinusTMin*tMax>>1;k+=base){delta=floor(delta/baseMinusTMin);}return floor(k+(baseMinusTMin+1)*delta/(delta+skew));}/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */function decode(input){// Don't use UCS-2
var output=[],inputLength=input.length,out,i=0,n=initialN,bias=initialBias,basic,j,index,oldi,w,k,digit,t,/** Cached calculation results */baseMinusT;// Handle the basic code points: let `basic` be the number of input code
// points before the last delimiter, or `0` if there is none, then copy
// the first basic code points to the output.
basic=input.lastIndexOf(delimiter);if(basic<0){basic=0;}for(j=0;j<basic;++j){// if it's not a basic code point
if(input.charCodeAt(j)>=0x80){error('not-basic');}output.push(input.charCodeAt(j));}// Main decoding loop: start just after the last delimiter if any basic code
// points were copied; start at the beginning otherwise.
for(index=basic>0?basic+1:0;index<inputLength;)/* no final expression */{// `index` is the index of the next character to be consumed.
// Decode a generalized variable-length integer into `delta`,
// which gets added to `i`. The overflow checking is easier
// if we increase `i` as we go, then subtract off its starting
// value at the end to obtain `delta`.
for(oldi=i,w=1,k=base;;/* no condition */k+=base){if(index>=inputLength){error('invalid-input');}digit=basicToDigit(input.charCodeAt(index++));if(digit>=base||digit>floor((maxInt-i)/w)){error('overflow');}i+=digit*w;t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(digit<t){break;}baseMinusT=base-t;if(w>floor(maxInt/baseMinusT)){error('overflow');}w*=baseMinusT;}out=output.length+1;bias=adapt(i-oldi,out,oldi==0);// `i` was supposed to wrap around from `out` to `0`,
// incrementing `n` each time, so we'll fix that now:
if(floor(i/out)>maxInt-n){error('overflow');}n+=floor(i/out);i%=out;// Insert `n` at position `i` of the output
output.splice(i++,0,n);}return ucs2encode(output);}/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */function encode(input){var n,delta,handledCPCount,basicLength,bias,j,m,q,k,t,currentValue,output=[],/** `inputLength` will hold the number of code points in `input`. */inputLength,/** Cached calculation results */handledCPCountPlusOne,baseMinusT,qMinusT;// Convert the input in UCS-2 to Unicode
input=ucs2decode(input);// Cache the length
inputLength=input.length;// Initialize the state
n=initialN;delta=0;bias=initialBias;// Handle the basic code points
for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<0x80){output.push(stringFromCharCode(currentValue));}}handledCPCount=basicLength=output.length;// `handledCPCount` is the number of code points that have been handled;
// `basicLength` is the number of basic code points.
// Finish the basic string - if it is not empty - with a delimiter
if(basicLength){output.push(delimiter);}// Main encoding loop:
while(handledCPCount<inputLength){// All non-basic code points < n have been handled already. Find the next
// larger one:
for(m=maxInt,j=0;j<inputLength;++j){currentValue=input[j];if(currentValue>=n&&currentValue<m){m=currentValue;}}// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
// but guard against overflow
handledCPCountPlusOne=handledCPCount+1;if(m-n>floor((maxInt-delta)/handledCPCountPlusOne)){error('overflow');}delta+=(m-n)*handledCPCountPlusOne;n=m;for(j=0;j<inputLength;++j){currentValue=input[j];if(currentValue<n&&++delta>maxInt){error('overflow');}if(currentValue==n){// Represent delta as a generalized variable-length integer
for(q=delta,k=base;;/* no condition */k+=base){t=k<=bias?tMin:k>=bias+tMax?tMax:k-bias;if(q<t){break;}qMinusT=q-t;baseMinusT=base-t;output.push(stringFromCharCode(digitToBasic(t+qMinusT%baseMinusT,0)));q=floor(qMinusT/baseMinusT);}output.push(stringFromCharCode(digitToBasic(q,0)));bias=adapt(delta,handledCPCountPlusOne,handledCPCount==basicLength);delta=0;++handledCPCount;}}++delta;++n;}return output.join('');}/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */function toUnicode(input){return mapDomain(input,function(string){return regexPunycode.test(string)?decode(string.slice(4).toLowerCase()):string;});}/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */function toASCII(input){return mapDomain(input,function(string){return regexNonASCII.test(string)?'xn--'+encode(string):string;});}/*--------------------------------------------------------------------------*//** Define the public API */punycode={/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */version:'1.3.2',/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ucs2:{decode:ucs2decode,encode:ucs2encode},decode:decode,encode:encode,toASCII:toASCII,toUnicode:toUnicode};return punycode;}();if(typeof COMPILED==="undefined"&&typeof module!=="undefined")module.exports=punycode;},{}],19:[function(require,module,exports){///<reference path="commonjs.d.ts"/>
require("./schemes/http");require("./schemes/urn");require("./schemes/mailto");},{"./schemes/http":20,"./schemes/mailto":21,"./schemes/urn":22}],20:[function(require,module,exports){///<reference path="../uri.ts"/>
if(typeof COMPILED==="undefined"&&typeof URI==="undefined"&&typeof require==="function")var URI=require("../uri");URI.SCHEMES["http"]=URI.SCHEMES["https"]={domainHost:true,parse:function parse(components,options){//report missing host
if(!components.host){components.error=components.error||"HTTP URIs must have a host.";}return components;},serialize:function serialize(components,options){//normalize the default port
if(components.port===(String(components.scheme).toLowerCase()!=="https"?80:443)||components.port===""){components.port=undefined;}//normalize the empty path
if(!components.path){components.path="/";}//NOTE: We do not parse query strings for HTTP URIs
//as WWW Form Url Encoded query strings are part of the HTML4+ spec,
//and not the HTTP spec. 
return components;}};},{"../uri":23}],21:[function(require,module,exports){///<reference path="../uri.ts"/>
if(typeof COMPILED==="undefined"&&typeof URI==="undefined"&&typeof require==="function"){var URI=require("../uri"),punycode=require("../punycode");}(function(){function merge(){var sets=[];for(var _i=0;_i<arguments.length;_i++){sets[_i-0]=arguments[_i];}if(sets.length>1){sets[0]=sets[0].slice(0,-1);var xl=sets.length-1;for(var x=1;x<xl;++x){sets[x]=sets[x].slice(1,-1);}sets[xl]=sets[xl].slice(1);return sets.join('');}else{return sets[0];}}function subexp(str){return"(?:"+str+")";}var O={},isIRI=URI.IRI_SUPPORT,//RFC 3986
UNRESERVED$$="[A-Za-z0-9\\-\\.\\_\\~"+(isIRI?"\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF":"")+"]",HEXDIG$$="[0-9A-Fa-f]",PCT_ENCODED$=subexp(subexp("%[EFef]"+HEXDIG$$+"%"+HEXDIG$$+HEXDIG$$+"%"+HEXDIG$$+HEXDIG$$)+"|"+subexp("%[89A-Fa-f]"+HEXDIG$$+"%"+HEXDIG$$+HEXDIG$$)+"|"+subexp("%"+HEXDIG$$+HEXDIG$$)),//RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; = 
//ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]",
//WSP$$ = "[\\x20\\x09]",
//OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]",  //(%d1-8 / %d11-12 / %d14-31 / %d127)
//QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$),  //%d33 / %d35-91 / %d93-126 / obs-qtext
//VCHAR$$ = "[\\x21-\\x7E]",
//WSP$$ = "[\\x20\\x09]",
//OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$)),  //%d0 / CR / LF / obs-qtext
//FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+"),
//QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$),
//QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"'),
ATEXT$$="[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]",QTEXT$$="[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]",VCHAR$$=merge(QTEXT$$,"[\\\"\\\\]"),DOT_ATOM_TEXT$=subexp(ATEXT$$+"+"+subexp("\\."+ATEXT$$+"+")+"*"),QUOTED_PAIR$=subexp("\\\\"+VCHAR$$),QCONTENT$=subexp(QTEXT$$+"|"+QUOTED_PAIR$),QUOTED_STRING$=subexp('\\"'+QCONTENT$+"*"+'\\"'),//RFC 6068
DTEXT_NO_OBS$$="[\\x21-\\x5A\\x5E-\\x7E]",SOME_DELIMS$$="[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]",QCHAR$=subexp(UNRESERVED$$+"|"+PCT_ENCODED$+"|"+SOME_DELIMS$$),DOMAIN$=subexp(DOT_ATOM_TEXT$+"|"+"\\["+DTEXT_NO_OBS$$+"*"+"\\]"),LOCAL_PART$=subexp(DOT_ATOM_TEXT$+"|"+QUOTED_STRING$),ADDR_SPEC$=subexp(LOCAL_PART$+"\\@"+DOMAIN$),TO$=subexp(ADDR_SPEC$+subexp("\\,"+ADDR_SPEC$)+"*"),HFNAME$=subexp(QCHAR$+"*"),HFVALUE$=HFNAME$,HFIELD$=subexp(HFNAME$+"\\="+HFVALUE$),HFIELDS2$=subexp(HFIELD$+subexp("\\&"+HFIELD$)+"*"),HFIELDS$=subexp("\\?"+HFIELDS2$),MAILTO_URI=URI.VALIDATE_SUPPORT&&new RegExp("^mailto\\:"+TO$+"?"+HFIELDS$+"?$"),UNRESERVED=new RegExp(UNRESERVED$$,"g"),PCT_ENCODED=new RegExp(PCT_ENCODED$,"g"),NOT_LOCAL_PART=new RegExp(merge("[^]",ATEXT$$,"[\\.]",'[\\"]',VCHAR$$),"g"),NOT_DOMAIN=new RegExp(merge("[^]",ATEXT$$,"[\\.]","[\\[]",DTEXT_NO_OBS$$,"[\\]]"),"g"),NOT_HFNAME=new RegExp(merge("[^]",UNRESERVED$$,SOME_DELIMS$$),"g"),NOT_HFVALUE=NOT_HFNAME,TO=URI.VALIDATE_SUPPORT&&new RegExp("^"+TO$+"$"),HFIELDS=URI.VALIDATE_SUPPORT&&new RegExp("^"+HFIELDS2$+"$");function toUpperCase(str){return str.toUpperCase();}function decodeUnreserved(str){var decStr=URI.pctDecChars(str);return!decStr.match(UNRESERVED)?str:decStr;}function toArray(obj){return obj!==undefined&&obj!==null?obj instanceof Array&&!obj.callee?obj:typeof obj.length!=="number"||obj.split||obj.setInterval||obj.call?[obj]:Array.prototype.slice.call(obj):[];}URI.SCHEMES["mailto"]={parse:function parse(components,options){if(URI.VALIDATE_SUPPORT&&!components.error){if(components.path&&!TO.test(components.path)){components.error="Email address is not valid";}else if(components.query&&!HFIELDS.test(components.query)){components.error="Header fields are invalid";}}var to=components.to=components.path?components.path.split(","):[];components.path=undefined;if(components.query){var unknownHeaders=false,headers={};var hfields=components.query.split("&");for(var x=0,xl=hfields.length;x<xl;++x){var hfield=hfields[x].split("=");switch(hfield[0]){case"to":var toAddrs=hfield[1].split(",");for(var x_1=0,xl_1=toAddrs.length;x_1<xl_1;++x_1){to.push(toAddrs[x_1]);}break;case"subject":components.subject=URI.unescapeComponent(hfield[1],options);break;case"body":components.body=URI.unescapeComponent(hfield[1],options);break;default:unknownHeaders=true;headers[URI.unescapeComponent(hfield[0],options)]=URI.unescapeComponent(hfield[1],options);break;}}if(unknownHeaders)components.headers=headers;}components.query=undefined;for(var x=0,xl=to.length;x<xl;++x){var addr=to[x].split("@");addr[0]=URI.unescapeComponent(addr[0]);if(typeof punycode!=="undefined"&&!options.unicodeSupport){//convert Unicode IDN -> ASCII IDN
try{addr[1]=punycode.toASCII(URI.unescapeComponent(addr[1],options).toLowerCase());}catch(e){components.error=components.error||"Email address's domain name can not be converted to ASCII via punycode: "+e;}}else{addr[1]=URI.unescapeComponent(addr[1],options).toLowerCase();}to[x]=addr.join("@");}return components;},serialize:function serialize(components,options){var to=toArray(components.to);if(to){for(var x=0,xl=to.length;x<xl;++x){var toAddr=String(to[x]);var atIdx=toAddr.lastIndexOf("@");var localPart=toAddr.slice(0,atIdx);var domain=toAddr.slice(atIdx+1);localPart=localPart.replace(PCT_ENCODED,decodeUnreserved).replace(PCT_ENCODED,toUpperCase).replace(NOT_LOCAL_PART,URI.pctEncChar);if(typeof punycode!=="undefined"){//convert IDN via punycode
try{domain=!options.iri?punycode.toASCII(URI.unescapeComponent(domain,options).toLowerCase()):punycode.toUnicode(domain);}catch(e){components.error=components.error||"Email address's domain name can not be converted to "+(!options.iri?"ASCII":"Unicode")+" via punycode: "+e;}}else{domain=domain.replace(PCT_ENCODED,decodeUnreserved).toLowerCase().replace(PCT_ENCODED,toUpperCase).replace(NOT_DOMAIN,URI.pctEncChar);}to[x]=localPart+"@"+domain;}components.path=to.join(",");}var headers=components.headers=components.headers||{};if(components.subject)headers["subject"]=components.subject;if(components.body)headers["body"]=components.body;var fields=[];for(var name_1 in headers){if(headers[name_1]!==O[name_1]){fields.push(name_1.replace(PCT_ENCODED,decodeUnreserved).replace(PCT_ENCODED,toUpperCase).replace(NOT_HFNAME,URI.pctEncChar)+"="+headers[name_1].replace(PCT_ENCODED,decodeUnreserved).replace(PCT_ENCODED,toUpperCase).replace(NOT_HFVALUE,URI.pctEncChar));}}if(fields.length){components.query=fields.join("&");}return components;}};})();},{"../punycode":18,"../uri":23}],22:[function(require,module,exports){///<reference path="../uri.ts"/>
if(typeof COMPILED==="undefined"&&typeof URI==="undefined"&&typeof require==="function")var URI=require("../uri");(function(){var pctEncChar=URI.pctEncChar,NID$="(?:[0-9A-Za-z][0-9A-Za-z\\-]{1,31})",PCT_ENCODED$="(?:\\%[0-9A-Fa-f]{2})",TRANS$$="[0-9A-Za-z\\(\\)\\+\\,\\-\\.\\:\\=\\@\\;\\$\\_\\!\\*\\'\\/\\?\\#]",NSS$="(?:(?:"+PCT_ENCODED$+"|"+TRANS$$+")+)",URN_SCHEME=new RegExp("^urn\\:("+NID$+")$"),URN_PATH=new RegExp("^("+NID$+")\\:("+NSS$+")$"),URN_PARSE=/^([^\:]+)\:(.*)/,URN_EXCLUDED=/[\x00-\x20\\\"\&\<\>\[\]\^\`\{\|\}\~\x7F-\xFF]/g,UUID=/^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;//RFC 2141
URI.SCHEMES["urn"]={parse:function parse(components,options){var matches=components.path.match(URN_PATH),scheme,schemeHandler;if(!matches){if(!options.tolerant){components.error=components.error||"URN is not strictly valid.";}matches=components.path.match(URN_PARSE);}if(matches){scheme="urn:"+matches[1].toLowerCase();schemeHandler=URI.SCHEMES[scheme];//in order to serialize properly, 
//every URN must have a serializer that calls the URN serializer 
if(!schemeHandler){//create fake scheme handler
schemeHandler=URI.SCHEMES[scheme]={parse:function parse(components,options){return components;},serialize:URI.SCHEMES["urn"].serialize};}components.scheme=scheme;components.path=matches[2];components=schemeHandler.parse(components,options);}else{components.error=components.error||"URN can not be parsed.";}return components;},serialize:function serialize(components,options){var scheme=components.scheme||options.scheme,matches;if(scheme&&scheme!=="urn"){var matches=scheme.match(URN_SCHEME);if(!matches){matches=["urn:"+scheme,scheme];}components.scheme="urn";components.path=matches[1]+":"+(components.path?components.path.replace(URN_EXCLUDED,pctEncChar):"");}return components;}};//RFC 4122
URI.SCHEMES["urn:uuid"]={parse:function parse(components,options){if(!options.tolerant&&(!components.path||!components.path.match(UUID))){components.error=components.error||"UUID is not valid.";}return components;},serialize:function serialize(components,options){//ensure UUID is valid
if(!options.tolerant&&(!components.path||!components.path.match(UUID))){//invalid UUIDs can not have this scheme
components.scheme=undefined;}else{//normalize UUID
components.path=(components.path||"").toLowerCase();}return URI.SCHEMES["urn"].serialize(components,options);}};})();},{"../uri":23}],23:[function(require,module,exports){/**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @version 2.0.0
 * @see http://github.com/garycourt/uri-js
 * @license URI.js v2.0.0 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js
 *//**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 *////<reference path="punycode.d.ts"/>
///<reference path="commonjs.d.ts"/>
/**
 * Compiler switch for indicating code is compiled
 * @define {boolean}
 */var COMPILED=false;/**
 * Compiler switch for supporting IRI URIs
 * @define {boolean}
 */var URI__IRI_SUPPORT=true;/**
 * Compiler switch for supporting URI validation
 * @define {boolean}
 */var URI__VALIDATE_SUPPORT=true;var URI=function(){function merge(){var sets=[];for(var _i=0;_i<arguments.length;_i++){sets[_i-0]=arguments[_i];}if(sets.length>1){sets[0]=sets[0].slice(0,-1);var xl=sets.length-1;for(var x=1;x<xl;++x){sets[x]=sets[x].slice(1,-1);}sets[xl]=sets[xl].slice(1);return sets.join('');}else{return sets[0];}}function subexp(str){return"(?:"+str+")";}function buildExps(isIRI){var ALPHA$$="[A-Za-z]",CR$="[\\x0D]",DIGIT$$="[0-9]",DQUOTE$$="[\\x22]",HEXDIG$$=merge(DIGIT$$,"[A-Fa-f]"),LF$$="[\\x0A]",SP$$="[\\x20]",PCT_ENCODED$=subexp(subexp("%[EFef]"+HEXDIG$$+"%"+HEXDIG$$+HEXDIG$$+"%"+HEXDIG$$+HEXDIG$$)+"|"+subexp("%[89A-Fa-f]"+HEXDIG$$+"%"+HEXDIG$$+HEXDIG$$)+"|"+subexp("%"+HEXDIG$$+HEXDIG$$)),GEN_DELIMS$$="[\\:\\/\\?\\#\\[\\]\\@]",SUB_DELIMS$$="[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]",RESERVED$$=merge(GEN_DELIMS$$,SUB_DELIMS$$),UCSCHAR$$=isIRI?"[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]":"[]",IPRIVATE$$=isIRI?"[\\uE000-\\uF8FF]":"[]",UNRESERVED$$=merge(ALPHA$$,DIGIT$$,"[\\-\\.\\_\\~]",UCSCHAR$$),SCHEME$=subexp(ALPHA$$+merge(ALPHA$$,DIGIT$$,"[\\+\\-\\.]")+"*"),USERINFO$=subexp(subexp(PCT_ENCODED$+"|"+merge(UNRESERVED$$,SUB_DELIMS$$,"[\\:]"))+"*"),DEC_OCTET$=subexp(subexp("25[0-5]")+"|"+subexp("2[0-4]"+DIGIT$$)+"|"+subexp("1"+DIGIT$$+DIGIT$$)+"|"+subexp("[1-9]"+DIGIT$$)+"|"+DIGIT$$),IPV4ADDRESS$=subexp(DEC_OCTET$+"\\."+DEC_OCTET$+"\\."+DEC_OCTET$+"\\."+DEC_OCTET$),H16$=subexp(HEXDIG$$+"{1,4}"),LS32$=subexp(subexp(H16$+"\\:"+H16$)+"|"+IPV4ADDRESS$),IPV6ADDRESS$=subexp(merge(UNRESERVED$$,SUB_DELIMS$$,"[\\:]")+"+"),IPVFUTURE$=subexp("v"+HEXDIG$$+"+\\."+merge(UNRESERVED$$,SUB_DELIMS$$,"[\\:]")+"+"),IP_LITERAL$=subexp("\\["+subexp(IPV6ADDRESS$+"|"+IPVFUTURE$)+"\\]"),REG_NAME$=subexp(subexp(PCT_ENCODED$+"|"+merge(UNRESERVED$$,SUB_DELIMS$$))+"*"),HOST$=subexp(IP_LITERAL$+"|"+IPV4ADDRESS$+"(?!"+REG_NAME$+")"+"|"+REG_NAME$),PORT$=subexp(DIGIT$$+"*"),AUTHORITY$=subexp(subexp(USERINFO$+"@")+"?"+HOST$+subexp("\\:"+PORT$)+"?"),PCHAR$=subexp(PCT_ENCODED$+"|"+merge(UNRESERVED$$,SUB_DELIMS$$,"[\\:\\@]")),SEGMENT$=subexp(PCHAR$+"*"),SEGMENT_NZ$=subexp(PCHAR$+"+"),SEGMENT_NZ_NC$=subexp(subexp(PCT_ENCODED$+"|"+merge(UNRESERVED$$,SUB_DELIMS$$,"[\\@]"))+"+"),PATH_ABEMPTY$=subexp(subexp("\\/"+SEGMENT$)+"*"),PATH_ABSOLUTE$=subexp("\\/"+subexp(SEGMENT_NZ$+PATH_ABEMPTY$)+"?"),PATH_NOSCHEME$=subexp(SEGMENT_NZ_NC$+PATH_ABEMPTY$),PATH_ROOTLESS$=subexp(SEGMENT_NZ$+PATH_ABEMPTY$),PATH_EMPTY$="(?!"+PCHAR$+")",PATH$=subexp(PATH_ABEMPTY$+"|"+PATH_ABSOLUTE$+"|"+PATH_NOSCHEME$+"|"+PATH_ROOTLESS$+"|"+PATH_EMPTY$),QUERY$=subexp(subexp(PCHAR$+"|"+merge("[\\/\\?]",IPRIVATE$$))+"*"),FRAGMENT$=subexp(subexp(PCHAR$+"|[\\/\\?]")+"*"),HIER_PART$=subexp(subexp("\\/\\/"+AUTHORITY$+PATH_ABEMPTY$)+"|"+PATH_ABSOLUTE$+"|"+PATH_ROOTLESS$+"|"+PATH_EMPTY$),URI$=subexp(SCHEME$+"\\:"+HIER_PART$+subexp("\\?"+QUERY$)+"?"+subexp("\\#"+FRAGMENT$)+"?"),RELATIVE_PART$=subexp(subexp("\\/\\/"+AUTHORITY$+PATH_ABEMPTY$)+"|"+PATH_ABSOLUTE$+"|"+PATH_NOSCHEME$+"|"+PATH_EMPTY$),RELATIVE$=subexp(RELATIVE_PART$+subexp("\\?"+QUERY$)+"?"+subexp("\\#"+FRAGMENT$)+"?"),URI_REFERENCE$=subexp(URI$+"|"+RELATIVE$),ABSOLUTE_URI$=subexp(SCHEME$+"\\:"+HIER_PART$+subexp("\\?"+QUERY$)+"?"),GENERIC_REF$="^("+SCHEME$+")\\:"+subexp(subexp("\\/\\/("+subexp("("+USERINFO$+")@")+"?("+HOST$+")"+subexp("\\:("+PORT$+")")+"?)")+"?("+PATH_ABEMPTY$+"|"+PATH_ABSOLUTE$+"|"+PATH_ROOTLESS$+"|"+PATH_EMPTY$+")")+subexp("\\?("+QUERY$+")")+"?"+subexp("\\#("+FRAGMENT$+")")+"?$",RELATIVE_REF$="^(){0}"+subexp(subexp("\\/\\/("+subexp("("+USERINFO$+")@")+"?("+HOST$+")"+subexp("\\:("+PORT$+")")+"?)")+"?("+PATH_ABEMPTY$+"|"+PATH_ABSOLUTE$+"|"+PATH_NOSCHEME$+"|"+PATH_EMPTY$+")")+subexp("\\?("+QUERY$+")")+"?"+subexp("\\#("+FRAGMENT$+")")+"?$",ABSOLUTE_REF$="^("+SCHEME$+")\\:"+subexp(subexp("\\/\\/("+subexp("("+USERINFO$+")@")+"?("+HOST$+")"+subexp("\\:("+PORT$+")")+"?)")+"?("+PATH_ABEMPTY$+"|"+PATH_ABSOLUTE$+"|"+PATH_ROOTLESS$+"|"+PATH_EMPTY$+")")+subexp("\\?("+QUERY$+")")+"?$",SAMEDOC_REF$="^"+subexp("\\#("+FRAGMENT$+")")+"?$",AUTHORITY_REF$="^"+subexp("("+USERINFO$+")@")+"?("+HOST$+")"+subexp("\\:("+PORT$+")")+"?$";return{URI_REF:URI__VALIDATE_SUPPORT&&new RegExp("("+GENERIC_REF$+")|("+RELATIVE_REF$+")"),NOT_SCHEME:new RegExp(merge("[^]",ALPHA$$,DIGIT$$,"[\\+\\-\\.]"),"g"),NOT_USERINFO:new RegExp(merge("[^\\%\\:]",UNRESERVED$$,SUB_DELIMS$$),"g"),NOT_HOST:new RegExp(merge("[^\\%]",UNRESERVED$$,SUB_DELIMS$$),"g"),NOT_PATH:new RegExp(merge("[^\\%\\/\\:\\@]",UNRESERVED$$,SUB_DELIMS$$),"g"),NOT_PATH_NOSCHEME:new RegExp(merge("[^\\%\\/\\@]",UNRESERVED$$,SUB_DELIMS$$),"g"),NOT_QUERY:new RegExp(merge("[^\\%]",UNRESERVED$$,SUB_DELIMS$$,"[\\:\\@\\/\\?]",IPRIVATE$$),"g"),NOT_FRAGMENT:new RegExp(merge("[^\\%]",UNRESERVED$$,SUB_DELIMS$$,"[\\:\\@\\/\\?]"),"g"),ESCAPE:new RegExp(merge("[^]",UNRESERVED$$,SUB_DELIMS$$),"g"),UNRESERVED:new RegExp(UNRESERVED$$,"g"),OTHER_CHARS:new RegExp(merge("[^\\%]",UNRESERVED$$,RESERVED$$),"g"),PCT_ENCODED:new RegExp(PCT_ENCODED$,"g")};}var URI_PROTOCOL=buildExps(false),IRI_PROTOCOL=URI__IRI_SUPPORT?buildExps(true):undefined,URI_PARSE=/^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?([^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n)*))?/i,RDS1=/^\.\.?\//,RDS2=/^\/\.(\/|$)/,RDS3=/^\/\.\.(\/|$)/,RDS4=/^\.\.?$/,RDS5=/^\/?(?:.|\n)*?(?=\/|$)/,NO_MATCH_IS_UNDEFINED="".match(/(){0}/)[1]===undefined;function pctEncChar(chr){var c=chr.charCodeAt(0),e;if(c<16)e="%0"+c.toString(16).toUpperCase();else if(c<128)e="%"+c.toString(16).toUpperCase();else if(c<2048)e="%"+(c>>6|192).toString(16).toUpperCase()+"%"+(c&63|128).toString(16).toUpperCase();else e="%"+(c>>12|224).toString(16).toUpperCase()+"%"+(c>>6&63|128).toString(16).toUpperCase()+"%"+(c&63|128).toString(16).toUpperCase();return e;}function pctDecChars(str){var newStr="",i=0,il=str.length,c,c2,c3;while(i<il){c=parseInt(str.substr(i+1,2),16);if(c<128){newStr+=String.fromCharCode(c);i+=3;}else if(c>=194&&c<224){if(il-i>=6){c2=parseInt(str.substr(i+4,2),16);newStr+=String.fromCharCode((c&31)<<6|c2&63);}else{newStr+=str.substr(i,6);}i+=6;}else if(c>=224){if(il-i>=9){c2=parseInt(str.substr(i+4,2),16);c3=parseInt(str.substr(i+7,2),16);newStr+=String.fromCharCode((c&15)<<12|(c2&63)<<6|c3&63);}else{newStr+=str.substr(i,9);}i+=9;}else{newStr+=str.substr(i,3);i+=3;}}return newStr;}function typeOf(o){return o===undefined?"undefined":o===null?"null":Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();}function toUpperCase(str){return str.toUpperCase();}var SCHEMES={};function _normalizeComponentEncoding(components,protocol){function decodeUnreserved(str){var decStr=pctDecChars(str);return!decStr.match(protocol.UNRESERVED)?str:decStr;}if(components.scheme)components.scheme=String(components.scheme).replace(protocol.PCT_ENCODED,decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME,"");if(components.userinfo!==undefined)components.userinfo=String(components.userinfo).replace(protocol.PCT_ENCODED,decodeUnreserved).replace(protocol.NOT_USERINFO,pctEncChar).replace(protocol.PCT_ENCODED,toUpperCase);if(components.host!==undefined)components.host=String(components.host).replace(protocol.PCT_ENCODED,decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST,pctEncChar).replace(protocol.PCT_ENCODED,toUpperCase);if(components.path!==undefined)components.path=String(components.path).replace(protocol.PCT_ENCODED,decodeUnreserved).replace(components.scheme?protocol.NOT_PATH:protocol.NOT_PATH_NOSCHEME,pctEncChar).replace(protocol.PCT_ENCODED,toUpperCase);if(components.query!==undefined)components.query=String(components.query).replace(protocol.PCT_ENCODED,decodeUnreserved).replace(protocol.NOT_QUERY,pctEncChar).replace(protocol.PCT_ENCODED,toUpperCase);if(components.fragment!==undefined)components.fragment=String(components.fragment).replace(protocol.PCT_ENCODED,decodeUnreserved).replace(protocol.NOT_FRAGMENT,pctEncChar).replace(protocol.PCT_ENCODED,toUpperCase);return components;};function parse(uriString,options){if(options===void 0){options={};}var protocol=URI__IRI_SUPPORT&&options.iri!==false?IRI_PROTOCOL:URI_PROTOCOL,matches,parseError=false,components={},schemeHandler;if(options.reference==="suffix")uriString=(options.scheme?options.scheme+":":"")+"//"+uriString;if(URI__VALIDATE_SUPPORT){matches=uriString.match(protocol.URI_REF);if(matches){if(matches[1]){//generic URI
matches=matches.slice(1,10);}else{//relative URI
matches=matches.slice(10,19);}}if(!matches){parseError=true;if(!options.tolerant)components.error=components.error||"URI is not strictly valid.";matches=uriString.match(URI_PARSE);}}else{matches=uriString.match(URI_PARSE);}if(matches){if(NO_MATCH_IS_UNDEFINED){//store each component
components.scheme=matches[1];//components.authority = matches[2];
components.userinfo=matches[3];components.host=matches[4];components.port=parseInt(matches[5],10);components.path=matches[6]||"";components.query=matches[7];components.fragment=matches[8];//fix port number
if(isNaN(components.port)){components.port=matches[5];}}else{//store each component
components.scheme=matches[1]||undefined;//components.authority = (uriString.indexOf("//") !== -1 ? matches[2] : undefined);
components.userinfo=uriString.indexOf("@")!==-1?matches[3]:undefined;components.host=uriString.indexOf("//")!==-1?matches[4]:undefined;components.port=parseInt(matches[5],10);components.path=matches[6]||"";components.query=uriString.indexOf("?")!==-1?matches[7]:undefined;components.fragment=uriString.indexOf("#")!==-1?matches[8]:undefined;//fix port number
if(isNaN(components.port)){components.port=uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/)?matches[4]:undefined;}}//determine reference type
if(components.scheme===undefined&&components.userinfo===undefined&&components.host===undefined&&components.port===undefined&&!components.path&&components.query===undefined){components.reference="same-document";}else if(components.scheme===undefined){components.reference="relative";}else if(components.fragment===undefined){components.reference="absolute";}else{components.reference="uri";}//check for reference errors
if(options.reference&&options.reference!=="suffix"&&options.reference!==components.reference){components.error=components.error||"URI is not a "+options.reference+" reference.";}//find scheme handler
schemeHandler=SCHEMES[(options.scheme||components.scheme||"").toLowerCase()];//check if scheme can't handle IRIs
if(URI__IRI_SUPPORT&&typeof punycode!=="undefined"&&!options.unicodeSupport&&(!schemeHandler||!schemeHandler.unicodeSupport)){//if host component is a domain name
if(components.host&&(options.domainHost||schemeHandler&&schemeHandler.domainHost)){//convert Unicode IDN -> ASCII IDN
try{components.host=punycode.toASCII(components.host.replace(protocol.PCT_ENCODED,pctDecChars).toLowerCase());}catch(e){components.error=components.error||"Host's domain name can not be converted to ASCII via punycode: "+e;}}//convert IRI -> URI
_normalizeComponentEncoding(components,URI_PROTOCOL);}else{//normalize encodings
_normalizeComponentEncoding(components,protocol);}//perform scheme specific parsing
if(schemeHandler&&schemeHandler.parse){schemeHandler.parse(components,options);}}else{parseError=true;components.error=components.error||"URI can not be parsed.";}return components;};function _recomposeAuthority(components,options){var uriTokens=[];if(components.userinfo!==undefined){uriTokens.push(components.userinfo);uriTokens.push("@");}if(components.host!==undefined){uriTokens.push(components.host);}if(typeof components.port==="number"){uriTokens.push(":");uriTokens.push(components.port.toString(10));}return uriTokens.length?uriTokens.join(""):undefined;};function removeDotSegments(input){var output=[],s;while(input.length){if(input.match(RDS1)){input=input.replace(RDS1,"");}else if(input.match(RDS2)){input=input.replace(RDS2,"/");}else if(input.match(RDS3)){input=input.replace(RDS3,"/");output.pop();}else if(input==="."||input===".."){input="";}else{s=input.match(RDS5)[0];input=input.slice(s.length);output.push(s);}}return output.join("");};function serialize(components,options){if(options===void 0){options={};}var protocol=URI__IRI_SUPPORT&&options.iri?IRI_PROTOCOL:URI_PROTOCOL,uriTokens=[],schemeHandler,authority,s;//find scheme handler
schemeHandler=SCHEMES[(options.scheme||components.scheme||"").toLowerCase()];//perform scheme specific serialization
if(schemeHandler&&schemeHandler.serialize)schemeHandler.serialize(components,options);//if host component is a domain name
if(URI__IRI_SUPPORT&&typeof punycode!=="undefined"&&components.host&&(options.domainHost||schemeHandler&&schemeHandler.domainHost)){//convert IDN via punycode
try{components.host=!options.iri?punycode.toASCII(components.host.replace(protocol.PCT_ENCODED,pctDecChars).toLowerCase()):punycode.toUnicode(components.host);}catch(e){components.error=components.error||"Host's domain name can not be converted to "+(!options.iri?"ASCII":"Unicode")+" via punycode: "+e;}}//normalize encoding
_normalizeComponentEncoding(components,protocol);if(options.reference!=="suffix"&&components.scheme){uriTokens.push(components.scheme);uriTokens.push(":");}authority=_recomposeAuthority(components,options);if(authority!==undefined){if(options.reference!=="suffix"){uriTokens.push("//");}uriTokens.push(authority);if(components.path&&components.path.charAt(0)!=="/"){uriTokens.push("/");}}if(components.path!==undefined){s=components.path;if(!options.absolutePath&&(!schemeHandler||!schemeHandler.absolutePath)){s=removeDotSegments(s);}if(authority===undefined){s=s.replace(/^\/\//,"/%2F");//don't allow the path to start with "//"
}uriTokens.push(s);}if(components.query!==undefined){uriTokens.push("?");uriTokens.push(components.query);}if(components.fragment!==undefined){uriTokens.push("#");uriTokens.push(components.fragment);}return uriTokens.join('');//merge tokens into a string
};function resolveComponents(base,relative,options,skipNormalization){if(options===void 0){options={};}var target={};if(!skipNormalization){base=parse(serialize(base,options),options);//normalize base components
relative=parse(serialize(relative,options),options);//normalize relative components
}options=options||{};if(!options.tolerant&&relative.scheme){target.scheme=relative.scheme;//target.authority = relative.authority;
target.userinfo=relative.userinfo;target.host=relative.host;target.port=relative.port;target.path=removeDotSegments(relative.path);target.query=relative.query;}else{if(relative.userinfo!==undefined||relative.host!==undefined||relative.port!==undefined){//target.authority = relative.authority;
target.userinfo=relative.userinfo;target.host=relative.host;target.port=relative.port;target.path=removeDotSegments(relative.path);target.query=relative.query;}else{if(!relative.path){target.path=base.path;if(relative.query!==undefined){target.query=relative.query;}else{target.query=base.query;}}else{if(relative.path.charAt(0)==="/"){target.path=removeDotSegments(relative.path);}else{if((base.userinfo!==undefined||base.host!==undefined||base.port!==undefined)&&!base.path){target.path="/"+relative.path;}else if(!base.path){target.path=relative.path;}else{target.path=base.path.slice(0,base.path.lastIndexOf("/")+1)+relative.path;}target.path=removeDotSegments(target.path);}target.query=relative.query;}//target.authority = base.authority;
target.userinfo=base.userinfo;target.host=base.host;target.port=base.port;}target.scheme=base.scheme;}target.fragment=relative.fragment;return target;};function resolve(baseURI,relativeURI,options){return serialize(resolveComponents(parse(baseURI,options),parse(relativeURI,options),options,true),options);};function normalize(uri,options){if(typeof uri==="string"){uri=serialize(parse(uri,options),options);}else if(typeOf(uri)==="object"){uri=parse(serialize(uri,options),options);}return uri;};function equal(uriA,uriB,options){if(typeof uriA==="string"){uriA=serialize(parse(uriA,options),options);}else if(typeOf(uriA)==="object"){uriA=serialize(uriA,options);}if(typeof uriB==="string"){uriB=serialize(parse(uriB,options),options);}else if(typeOf(uriB)==="object"){uriB=serialize(uriB,options);}return uriA===uriB;};function escapeComponent(str,options){return str&&str.toString().replace(!URI__IRI_SUPPORT||!options||!options.iri?URI_PROTOCOL.ESCAPE:IRI_PROTOCOL.ESCAPE,pctEncChar);};function unescapeComponent(str,options){return str&&str.toString().replace(!URI__IRI_SUPPORT||!options||!options.iri?URI_PROTOCOL.PCT_ENCODED:IRI_PROTOCOL.PCT_ENCODED,pctDecChars);};return{IRI_SUPPORT:URI__IRI_SUPPORT,VALIDATE_SUPPORT:URI__VALIDATE_SUPPORT,pctEncChar:pctEncChar,pctDecChars:pctDecChars,SCHEMES:SCHEMES,parse:parse,_recomposeAuthority:_recomposeAuthority,removeDotSegments:removeDotSegments,serialize:serialize,resolveComponents:resolveComponents,resolve:resolve,normalize:normalize,equal:equal,escapeComponent:escapeComponent,unescapeComponent:unescapeComponent};}();if(!COMPILED&&typeof module!=="undefined"&&typeof require==="function"){var punycode=require("./punycode");module.exports=URI;require("./schemes");}},{"./punycode":18,"./schemes":19}]},{},[1])(1);});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sf_path__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schema_defaults__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__canonical_title_map__ = __webpack_require__(1);
/* harmony export (immutable) */ __webpack_exports__["a"] = merge;
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };





// export function merge(schema, form, schemaDefaultTypes, ignore, options, readonly, asyncTemplates) {
function merge(lookup, form) {
  var typeDefaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__schema_defaults__["createDefaults"])();
  var ignore = arguments[3];
  var options = arguments[4];
  var readonly = arguments[5];
  var asyncTemplates = arguments[6];

  var formItems = [];
  var formItemRest = [];
  form = form || [];
  var idx = form.indexOf('*');
  options = options || {};
  var stdForm = {};

  var idxRest = form.indexOf('...');
  if ((typeof lookup === 'undefined' ? 'undefined' : _typeof(lookup)) === 'object' && lookup.hasOwnProperty('properties')) {
    readonly = readonly || lookup.readonly || lookup.readOnly;
    stdForm = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__schema_defaults__["defaultForm"])(lookup, typeDefaults, ignore, options);

    var defaultFormLookup = stdForm.lookup;

    lookup = defaultFormLookup || lookup;
    formItems = formItems.concat(stdForm.form);
  };

  if (idx !== -1) {
    form = form.slice(0, idx).concat(formItems).concat(form.slice(idx + 1));
  }

  //simple case, we have a "...", just put the formItemRest there
  if (stdForm.form && idxRest !== -1) {
    (function () {
      var formKeys = form.map(function (obj) {
        if (typeof obj === 'string') {
          return obj;
        } else if (obj.key) {
          return obj.key;
        };
      }).filter(function (element) {
        return element !== undefined;
      });

      formItemRest = formItemRest.concat(stdForm.form.map(function (obj) {
        var isInside = formKeys.indexOf(obj.key[0]) !== -1;
        if (!isInside) {
          return obj;
        };
      }).filter(function (element) {
        return element !== undefined;
      }));
    })();
  };

  if (idxRest !== -1) {
    form = form.slice(0, idxRest).concat(formItemRest).concat(form.slice(idxRest + 1));
  };

  // ok let's merge!
  // We look at the supplied form and extend it with schema standards
  return form.map(function (obj) {
    // handle the shortcut with just a name
    if (typeof obj === 'string') {
      obj = { key: obj };
    }

    if (obj.key) {
      if (typeof obj.key === 'string') {
        obj.key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["parse"])(obj.key);
      }
    }

    // If it has a titleMap make sure it's a list
    if (obj.titleMap) {
      obj.titleMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__canonical_title_map__["a" /* default */])(obj.titleMap);
    }

    // extend with std form from schema.
    if (obj.key) {
      var strid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__sf_path__["stringify"])(obj.key);
      if (lookup[strid]) {
        (function () {
          var schemaDefaults = lookup[strid];
          if (schemaDefaults) {
            Object.keys(schemaDefaults).forEach(function (attr) {
              if (obj[attr] === undefined) {
                obj[attr] = schemaDefaults[attr];
              }
            });
          }
        })();
      }
    }

    // Are we inheriting readonly?
    if (readonly === true) {
      // Inheriting false is not cool.
      obj.readonly = true;
    }

    // if it's a type with items, merge 'em!
    if (obj.items) {
      obj.items = merge(lookup, obj.items, typeDefaults, ignore, options, obj.readonly, asyncTemplates);
    }

    // if its has tabs, merge them also!
    if (obj.tabs) {
      obj.tabs.forEach(function (tab) {
        if (tab.items) {
          tab.items = merge(lookup, tab.items, typeDefaults, ignore, options, obj.readonly, asyncTemplates);
        }
      });
    }

    // Special case: checkbox
    // Since have to ternary state we need a default
    if (obj.type === 'checkbox') {
      // Check for schema property, as the checkbox may be part of the explicitly defined form
      if (obj.schema === undefined) {
        obj.schema = { default: false };
      } else if (obj.schema['default'] === undefined) {
        obj.schema['default'] = false;
      };
    };

    // Special case: template type with tempplateUrl that's needs to be loaded before rendering
    // TODO: this is not a clean solution. Maybe something cleaner can be made when $ref support
    // is introduced since we need to go async then anyway
    if (asyncTemplates && obj.type === 'template' && !obj.template && obj.templateUrl) {
      asyncTemplates.push(obj);
    };

    return obj;
  });
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_json_refs_standalone__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_json_refs_standalone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__lib_json_refs_standalone__);
/* harmony export (immutable) */ __webpack_exports__["a"] = jsonref;


function jsonref(schema, callBack) {
  var promise = new Promise(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_0__lib_json_refs_standalone__["resolveRefs"](schema, {
      "filter": ['relative', 'local', 'remote']
    }).then(function (res) {
      resolve(res.resolved);
    }).catch(function (err) {
      reject(new Error(err));
    });
  });

  if (typeof callBack === 'function') {
    promise.then(function (resolved) {
      callBack(null, resolved);
    }).catch(function (error) {
      callBack(error);
    });
  } else {
    return promise;
  }
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sf_path__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = select;


var numRe = /^\d+$/;

/**
  * @description
  * Utility method to access deep properties without
  * throwing errors when things are not defined.
  * Can also set a value in a deep structure, creating objects when missing
  * ex.
  * var foo = Select('address.contact.name',obj)
  * Select('address.contact.name',obj,'Leeroy')
  *
  * @param {string} projection A dot path to the property you want to get/set
  * @param {object} obj   (optional) The object to project on, defaults to 'this'
  * @param {Any}    valueToSet (opional)  The value to set, if parts of the path of
  *                 the projection is missing empty objects will be created.
  * @returns {Any|undefined} returns the value at the end of the projection path
  *                          or undefined if there is none.
  */
function select(projection, obj, valueToSet) {
  if (!obj) {
    obj = this;
  };

  // Support [] array syntax
  var parts = typeof projection === 'string' ? __WEBPACK_IMPORTED_MODULE_0__sf_path__["parse"](projection) : projection;

  if (typeof valueToSet !== 'undefined' && parts.length === 1) {
    // special case, just setting one variable
    obj[parts[0]] = valueToSet;

    return obj;
  };

  if (typeof valueToSet !== 'undefined' && typeof obj[parts[0]] === 'undefined') {
    // We need to look ahead to check if array is appropriate
    obj[parts[0]] = parts.length > 2 && numRe.test(parts[1]) ? [] : {};
  };

  var value = obj[parts[0]];

  for (var i = 1; i < parts.length; i++) {
    // Special case: We allow JSON Form syntax for arrays using empty brackets
    // These will of course not work here so we exit if they are found.
    if (parts[i] === '') {
      return undefined;
    };

    if (typeof valueToSet !== 'undefined') {
      if (i === parts.length - 1) {
        // last step. Let's set the value
        value[parts[i]] = valueToSet;
        return valueToSet;
      } else {
        // Make sure to create new objects on the way if they are not there.
        // We need to look ahead to check if array is appropriate
        var tmp = value[parts[i]];

        if (typeof tmp === 'undefined' || tmp === null) {
          tmp = numRe.test(parts[i + 1]) ? [] : {};
          value[parts[i]] = tmp;
        };

        value = tmp;
      };
    } else if (value) {
      // Just get nex value.
      value = value[parts[i]];
    };
  };

  return value;
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = traverseSchema;
/* harmony export (immutable) */ __webpack_exports__["b"] = traverseForm;
/**
 * Traverse a schema, applying a function(schema,path) on every sub schema
 * i.e. every property of an object.
 */
function traverseSchema(schema, fn, path, ignoreArrays) {
  ignoreArrays = ignoreArrays === undefined ? true : ignoreArrays;

  path = path || [];

  var traverse = function traverse(schemaObject, processorFunction, pathArray) {
    processorFunction(schemaObject, pathArray);
    if (schemaObject.properties) {
      Object.keys(schemaObject.properties).forEach(function (name) {
        var currentPath = pathArray.slice();
        currentPath.push(name);
        traverse(schemaObject.properties[name], processorFunction, currentPath);
      });
    }

    // Only support type "array" which have a schemaObject as "items".
    if (!ignoreArrays && schemaObject.items) {
      var arrPath = pathArray.slice();arrPath.push('');
      traverse(schemaObject.items, processorFunction, arrPath);
    }
  };

  traverse(schema, fn, path || []);
}

function traverseForm(form, fn) {
  fn(form);
  if (form.items) {
    form.items.forEach(function (f) {
      traverseForm(f, fn);
    });
  }

  if (form.tabs) {
    form.tabs.forEach(function (tab) {
      if (tab.items) {
        tab.items.forEach(function (f) {
          traverseForm(f, fn);
        });
      }
    });
  }
}

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tv4__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tv4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_tv4__);
/* harmony export (immutable) */ __webpack_exports__["a"] = validate;
/*  Common code for validating a value against its form and schema definition */


/**
 * Validate a value against its form definition and schema.
 * The value should either be of proper type or a string, some type
 * coercion is applied.
 *
 * @param {Object} form A merged form definition, i.e. one with a schema.
 * @param {Any} value the value to validate.
 * @return {Object} a tv4js result object.
 */
function validate(form, value) {
  if (!form) {
    return { valid: true };
  };

  var schema = form.schema;
  if (!schema) {
    return { valid: true };
  };

  // Input of type text and textareas will give us a viewValue of ''
  // when empty, this is a valid value in a schema and does not count as something
  // that breaks validation of 'required'. But for our own sanity an empty field should
  // not validate if it's required.
  if (value === '') {
    value = undefined;
  };

  // Numbers fields will give a null value, which also means empty field
  if (form.type === 'number' && value === null) {
    value = undefined;
  };

  // Version 4 of JSON Schema has the required property not on the
  // property itself but on the wrapping object. Since we like to test
  // only this property we wrap it in a fake object.
  var wrap = { type: 'object', 'properties': {}, required: undefined };
  var propName = form.key[form.key.length - 1];
  wrap.properties[propName] = schema;

  if (form.required) {
    wrap.required = [propName];
  };

  var valueWrap = {};
  if (typeof value !== 'undefined') {
    valueWrap[propName] = value;
  };

  return __WEBPACK_IMPORTED_MODULE_0_tv4___default.a.validateResult(valueWrap, wrap);
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

;!function(undefined) {

	var ObjectPath = {
		parse: function(str){
			if(typeof str !== 'string'){
				throw new TypeError('ObjectPath.parse must be passed a string');
			}

			var i = 0;
			var parts = [];
			var d, b, q, c;
			while (i < str.length){
				d = str.indexOf('.', i);
				b = str.indexOf('[', i);

				// we've reached the end
				if (d === -1 && b === -1){
					parts.push(str.slice(i, str.length));
					i = str.length;
				}

				// dots
				else if (b === -1 || (d !== -1 && d < b)) {
					parts.push(str.slice(i, d));
					i = d + 1;
				}

				// brackets
				else {
					if (b > i){
						parts.push(str.slice(i, b));
						i = b;
					}
					q = str.slice(b+1, b+2);
					if (q !== '"' && q !=='\'') {
						c = str.indexOf(']', b);
						if (c === -1) c = str.length;
						parts.push(str.slice(i + 1, c));
						i = (str.slice(c + 1, c + 2) === '.') ? c + 2 : c + 1;
					} else {
						c = str.indexOf(q+']', b);
						if (c === -1) c = str.length;
						while (str.slice(c - 1, c) === '\\' && b < str.length){
							b++;
							c = str.indexOf(q+']', b);
						}
						parts.push(str.slice(i + 2, c).replace(new RegExp('\\'+q,'g'), q));
						i = (str.slice(c + 2, c + 3) === '.') ? c + 3 : c + 2;
					}
				}
			}
			return parts;
		},

		// root === true : auto calculate root; must be dot-notation friendly
		// root String : the string to use as root
		stringify: function(arr, quote){

			if(!Array.isArray(arr))
				arr = [arr.toString()];

			quote = quote === '"' ? '"' : '\'';

			return arr.map(function(n){ return '[' + quote + (n.toString()).replace(new RegExp(quote, 'g'), '\\' + quote) + quote + ']'; }).join('');
		},

		normalize: function(data, quote){
			return ObjectPath.stringify(Array.isArray(data) ? data : ObjectPath.parse(data), quote);
		},

		// Angular
		registerModule: function(angular) {
			angular.module('ObjectPath', []).provider('ObjectPath', function(){
				this.parse = ObjectPath.parse;
				this.stringify = ObjectPath.stringify;
				this.normalize = ObjectPath.normalize;
				this.$get = function(){
					return ObjectPath;
				};
			});
		}
	};

	// AMD
	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return {ObjectPath: ObjectPath};
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}

	// CommonJS
	else if (typeof exports === 'object') {
		exports.ObjectPath = ObjectPath;
	}

	// Browser global
	else {
		window.ObjectPath = ObjectPath;
	}
	
}();

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports = tv4;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4);


/***/ })
/******/ ]);
//# sourceMappingURL=json-schema-form-core.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(19).setImmediate))

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_angular__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sf_builder_provider__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_schema_form_decorators_provider__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_schema_form_provider__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_sf_error_message_provider__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_sf_path_provider__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_sf_changed_directive__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_sf_field_directive__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_sf_message_directive__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_sf_array_directive__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_sf_key_directive__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_sf_schema_directive__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_schema_validate_directive__ = __webpack_require__(5);



// ./services/





// ./directives/








// Deps is sort of a problem for us, maybe in the future we will ask the user to depend
// on modules for add-ons
var deps = [];

try {
  // This throws an expection if module does not exist.
  __WEBPACK_IMPORTED_MODULE_1_angular___default.a.module('ngSanitize');
  deps.push('ngSanitize');
} catch (e) {}

try {
  // This throws an expection if module does not exist.
  __WEBPACK_IMPORTED_MODULE_1_angular___default.a.module('ui.sortable');
  deps.push('ui.sortable');
} catch (e) {}

try {
  // This throws an expection if module does not exist.
  __WEBPACK_IMPORTED_MODULE_1_angular___default.a.module('angularSpectrumColorpicker');
  deps.push('angularSpectrumColorpicker');
} catch (e) {}

__WEBPACK_IMPORTED_MODULE_1_angular___default.a.module('schemaForm', deps)

// Providers and services
.provider('sfPath', __WEBPACK_IMPORTED_MODULE_6_sf_path_provider__["a" /* default */]).provider('sfBuilder', ['sfPathProvider', __WEBPACK_IMPORTED_MODULE_2_sf_builder_provider__["a" /* default */]]).provider('schemaFormDecorators', ['$compileProvider', 'sfPathProvider', __WEBPACK_IMPORTED_MODULE_3_schema_form_decorators_provider__["a" /* default */]]).provider('sfErrorMessage', __WEBPACK_IMPORTED_MODULE_5_sf_error_message_provider__["a" /* default */]).provider('schemaForm', ['sfPathProvider', __WEBPACK_IMPORTED_MODULE_4_schema_form_provider__["a" /* default */]]).factory('sfSelect', function () {
  return __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["select"];
}).factory('sfValidator', function () {
  return __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["validate"];
})

// Directives
.directive('sfChanged', __WEBPACK_IMPORTED_MODULE_7_sf_changed_directive__["a" /* default */]).directive('sfField', ['$parse', '$compile', '$interpolate', 'sfErrorMessage', 'sfPath', 'sfSelect', __WEBPACK_IMPORTED_MODULE_8_sf_field_directive__["a" /* default */]]).directive('sfMessage', ['$injector', 'sfErrorMessage', __WEBPACK_IMPORTED_MODULE_9_sf_message_directive__["a" /* default */]]).directive('sfNewArray', ['sfSelect', 'sfPath', 'schemaForm', __WEBPACK_IMPORTED_MODULE_10_sf_array_directive__["a" /* default */]]).directive('sfSchema', ['$compile', '$http', '$templateCache', '$q', 'schemaForm', 'schemaFormDecorators', 'sfSelect', 'sfBuilder', __WEBPACK_IMPORTED_MODULE_12_sf_schema_directive__["a" /* default */]]).directive('schemaValidate', ['sfValidator', '$parse', 'sfSelect', '$interpolate', __WEBPACK_IMPORTED_MODULE_13_schema_validate_directive__["a" /* default */]]).directive('sfKeyController', ['sfPath', __WEBPACK_IMPORTED_MODULE_11_sf_key_directive__["a" /* default */]]);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


/**
 * I am the schema-validate directive
 *
 * @param  {function} sfValidator
 * @param  {function} $parse
 * @param  {function} sfSelect
 * @param  {function} $interpolate
 *
 * @return {object}   I am the directive properties made available to Angular
 */
/* harmony default export */ __webpack_exports__["a"] = (function (sfValidator, $parse, sfSelect, $interpolate) {
  return {
    restrict: 'A',
    scope: false,
    // We want the link function to be *after* the input directives link function so we get access
    // the parsed value, ex. a number instead of a string
    priority: 500,
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModel) {
      // We need the ngModelController on several places,
      // most notably for errors.
      // So we emit it up to the decorator directive so it can put it on scope.
      scope.$emit('schemaFormPropagateNgModelController', ngModel);

      var error = null;
      var form = scope.$eval(attrs.schemaValidate);

      // TODO move this out of validate
      var copyTo = typeof form.copyValueTo === 'string' ? [form.copyValueTo] : form.copyValueTo;
      if (copyTo && copyTo.length) {
        ngModel.$viewChangeListeners.push(function () {
          var context = {
            'model': scope.model,
            'form': form,
            'arrayIndex': scope.$index,
            'arrayIndices': scope.arrayIndices,
            'path': scope.path,
            '$i': scope.$i,
            '$index': scope.$index
          };
          __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(copyTo, function (copyToPath) {
            var path = copyToPath.replace(/\[/g, '[{{ ').replace(/\]/g, ' }}]').replace(/^model\./, '');
            path = $interpolate(path)(context);
            sfSelect(path, scope.model, ngModel.$modelValue);
          });
        });
      };
      // Validate against the schema.

      var validate = function validate(viewValue, triggered) {
        // Still might be undefined
        if (!form) {
          return viewValue;
        }

        // Omit TV4 validation
        if (scope.options && scope.options.tv4Validation === false) {
          return viewValue;
        }

        var result = sfValidator(form, viewValue);
        // console.log('result is', result)
        // Since we might have different tv4 errors we must clear all
        // errors that start with tv4-
        Object.keys(ngModel.$error).filter(function (k) {
          return k.indexOf('tv4-') === 0;
        }).forEach(function (k) {
          ngModel.$setValidity(k, true);
        });

        if (!result.valid && (!ngModel.$pristine || triggered || scope.options && scope.options.validateOnRender === true)) {
          // it is invalid, return undefined (no model update)
          ngModel.$setValidity('tv4-' + result.error.code, false);
          error = result.error;

          // In Angular 1.3+ return the viewValue, otherwise we inadvertenly
          // will trigger a 'parse' error.
          // we will stop the model value from updating with our own $validator
          // later.
          if (ngModel.$validators) {
            return viewValue;
          }

          // Angular 1.2 on the other hand lacks $validators and don't add a 'parse' error.
          return undefined;
        }

        return viewValue;
      };

      // Custom validators, parsers, formatters etc
      if (typeof form.ngModel === 'function') {
        form.ngModel(ngModel);
      }

      ['$parsers', '$viewChangeListeners', '$formatters'].forEach(function (attr) {
        if (form[attr] && ngModel[attr]) {
          form[attr].forEach(function (fn) {
            ngModel[attr].push(fn);
          });
        }
      });

      ['$validators', '$asyncValidators'].forEach(function (attr) {
        // Check if our version of angular has validators, i.e. 1.3+
        if (form[attr] && ngModel[attr]) {
          __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(form[attr], function (fn, name) {
            ngModel[attr][name] = function (modelValue, viewValue) {
              return fn(modelValue, viewValue, scope.model, form);
            };
          });
        }
      });

      // Get in last of the parses so the parsed value has the correct type.
      // We don't use $validators since we like to set different errors depending tv4 error codes
      ngModel.$parsers.push(validate);

      // But we do use one custom validator in the case of Angular 1.3 to stop the model from
      // updating if we've found an error.
      if (ngModel.$validators) {
        ngModel.$validators.schemaForm = function () {
          // console.log('validators called.')
          // Any error and we're out of here!
          return !Object.keys(ngModel.$error).some(function (e) {
            return e !== 'schemaForm';
          });
        };
      }

      var schema = form.schema;

      // A bit ugly but useful.
      scope.validateField = function (formName, triggered) {
        var noField = formName === undefined;
        // If we have specified a form name, and this model is not within
        // that form, then leave things be.
        if (!noField && ngModel.$$parentForm.$name !== formName) {
          return;
        };

        // Special case: arrays
        // TODO: Can this be generalized in a way that works consistently?
        // Just setting the viewValue isn't enough to trigger validation
        // since it's the same value. This will be better when we drop
        // 1.2 support.
        if (noField || schema && schema.type.indexOf('array') !== -1) {
          validate(ngModel.$modelValue, triggered);
        };

        // We set the viewValue to trigger parsers,
        // since modelValue might be empty and validating just that
        // might change an existing error to a "required" error message.
        if (ngModel.$setDirty) {
          // Angular 1.3+
          ngModel.$setDirty();
          ngModel.$setViewValue(ngModel.$viewValue);
          ngModel.$commitViewValue();

          // In Angular 1.3 setting undefined as a viewValue does not trigger parsers
          // so we need to do a special required check.

          // angulars checkbox directive isEmpty does not do the check we want.
          if (form.type === 'checkbox') {
            if (form.required && ngModel.$modelValue === undefined) {
              ngModel.$setValidity('tv4-302', false);
            };
          } else if (form.required && ngModel.$isEmpty(ngModel.$modelValue)) {
            ngModel.$setValidity('tv4-302', false);
          };
        } else {
          // Angular 1.2
          // In angular 1.2 setting a viewValue of undefined will trigger the parser.
          // hence required works.
          ngModel.$setViewValue(ngModel.$viewValue);
        }
      };

      var first = true;
      ngModel.$formatters.push(function (val) {
        // When a form first loads this will be called for each field.
        // we usually don't want that.
        if (ngModel.$pristine && first && (!scope.options || scope.options.validateOnRender !== true)) {
          first = false;
          return val;
        }
        validate(ngModel.$modelValue);
        return val;
      });

      // Listen to an event so we can validate the input on request
      scope.$on('schemaFormValidate', function (event, formName) {
        scope.validateField(formName, true);
      });

      scope.schemaError = function () {
        return error;
      };
    }
  };
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/**
 * Directive that handles the model arrays
 */
/* harmony default export */ __webpack_exports__["a"] = (function (sfSelect, sfPath, schemaForm) {
  return {
    scope: true,
    controller: ['$scope', function SFArrayController($scope) {
      this.key = $scope.form && $scope.form.key ? $scope.form.key.splice(0, -2) : [];
    }],
    link: function link(scope, element, attrs) {
      scope.min = 0;

      scope.trackBy = function (item, index) {
        if (item && (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') return item;
        return index;
      };

      scope.modelArray = scope.$eval(attrs.sfNewArray);

      // We need to have a ngModel to hook into validation. It doesn't really play well with
      // arrays though so we both need to trigger validation and onChange.
      // So we watch the value as well. But watching an array can be tricky. We wan't to know
      // when it changes so we can validate,
      var watchFn = function watchFn() {
        // scope.modelArray = modelArray;
        scope.modelArray = scope.$eval(attrs.sfNewArray);
        // validateField method is exported by schema-validate
        if (scope.ngModel && scope.ngModel.$pristine && (!scope.options || scope.options.validateOnRender !== true)) {
          return;
        } else if (scope.validateField) {
          scope.validateField();
        }
      };

      var onChangeFn = function onChangeFn() {
        if (scope.form && scope.form.onChange) {
          if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(scope.form.onChange)) {
            scope.form.onChange(scope.modelArray, scope.form);
          } else {
            scope.evalExpr(scope.form.onChange, { 'modelValue': scope.modelArray, 'form': scope.form });
          }
        }
      };

      // If model is undefined make sure it gets set.
      var getOrCreateModel = function getOrCreateModel() {
        var model = scope.modelArray;
        if (!model) {
          var selection = sfPath.parse(attrs.sfNewArray);
          model = [];
          sfSelect(selection, scope, model);
          scope.modelArray = model;
        }
        return model;
      };

      // We need the form definition to make a decision on how we should listen.
      var once = scope.$watch('form', function (form) {
        if (!form) {
          return;
        }

        // Always start with one empty form unless configured otherwise.
        // Special case: don't do it if form has a titleMap
        if (!form.titleMap && form.startEmpty !== true && (!scope.modelArray || scope.modelArray.length === 0)) {
          scope.appendToArray();
        }

        scope.$watch(function ($scope) {
          return JSON.stringify($scope.modelArray);
        }, function () {
          watchFn();onChangeFn();
        });

        // Title Map handling
        // If form has a titleMap configured we'd like to enable looping over
        // titleMap instead of modelArray, this is used for intance in
        // checkboxes. So instead of letiable number of things we like to create
        // a array value from a subset of values in the titleMap.
        // The problem here is that ng-model on a checkbox doesn't really map to
        // a list of values. This is here to fix that.
        if (form.titleMap && form.titleMap.length > 0) {
          scope.titleMapValues = [];

          // We watch the model for changes and the titleMapValues to reflect
          // the modelArray
          var updateTitleMapValues = function updateTitleMapValues(arr) {
            scope.titleMapValues = [];
            arr = arr || [];

            form.titleMap.forEach(function (item) {
              scope.titleMapValues.push(arr.indexOf(item.value) !== -1);
            });
          };

          // Catch default values
          updateTitleMapValues(scope.modelArray);

          // TODO: Refactor and see if we can get rid of this watch by piggy backing on the
          // validation watch.
          scope.$watchCollection('modelArray', updateTitleMapValues);

          // To get two way binding we also watch our titleMapValues
          scope.$watchCollection('titleMapValues', function (newVals, oldVals) {
            if (newVals && newVals !== oldVals) {
              var arr = getOrCreateModel();

              form.titleMap.forEach(function (item, index) {
                var arrIndex = arr.indexOf(item.value);
                if (arrIndex === -1 && newVals[index]) {
                  arr.push(item.value);
                }

                if (arrIndex !== -1 && !newVals[index]) {
                  arr.splice(arrIndex, 1);
                }
              });
              // Time to validate the rebuilt array.
              // validateField method is exported by schema-validate
              if (scope.validateField) {
                scope.validateField();
              }
            }
          });
        }

        once();
      });

      scope.appendToArray = function () {
        var empty = void 0;

        // Create and set an array if needed.
        var model = getOrCreateModel();

        // Same old add empty things to the array hack :(
        if (scope.form && scope.form.schema && scope.form.schema.items) {
          var items = scope.form.schema.items;
          if (items.type && items.type.indexOf('object') !== -1) {
            empty = {};

            // Check for possible defaults
            if (!scope.options || scope.options.setSchemaDefaults !== false) {
              empty = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.isDefined(items['default']) ? items['default'] : empty;

              // Check for defaults further down in the schema.
              // If the default instance sets the new array item to something falsy, i.e. null
              // then there is no need to go further down.
              if (empty) {
                schemaForm.traverseSchema(items, function (prop, path) {
                  if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isDefined(prop['default'])) {
                    sfSelect(path, empty, prop['default']);
                  }
                });
              }
            }
          } else {
            if (items.type) {
              if (items.type.indexOf('array') !== -1) {
                empty = [];
              } else if (items.type.indexOf('string') !== -1 || items.type.indexOf('number') !== -1) {
                empty = '';
              }
            }
            // No type? could still have defaults.
            if (!scope.options || scope.options.setSchemaDefaults !== false) {
              empty = items['default'] || empty;
            }
          }
        }
        model.push(empty);

        return model;
      };

      scope.deleteFromArray = function (item) {
        var model = scope.modelArray;
        if (model) {
          var index = model.indexOf(item);
          model.splice(index, 1);
        }

        return model;
      };

      // For backwards compatability, i.e. when a bootstrap-decorator tag is used
      // as child to the array.
      var setIndex = function setIndex(index) {
        return function (form) {
          if (form.key) {
            form.key[form.key.indexOf('')] = index;
          }
        };
      };

      var formDefCache = {};
      scope.copyWithIndex = function (index) {
        var form = scope.form;
        if (!formDefCache[index]) {
          // To be more compatible with JSON Form we support an array of items
          // in the form definition of "array" (the schema just a value).
          // for the subforms code to work this means we wrap everything in a
          // section. Unless there is just one.
          var subForm = form.items[0];
          if (form.items.length > 1) {
            subForm = {
              type: 'section',
              items: form.items.map(function (item) {
                item.ngModelOptions = form.ngModelOptions;
                if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isUndefined(item.readonly)) {
                  item.readonly = form.readonly;
                }
                return item;
              })
            };
          }

          if (subForm) {
            var copy = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(subForm);
            copy.arrayIndex = index;
            schemaForm.traverseForm(copy, setIndex(index));
            formDefCache[index] = copy;
          }
        }
        return formDefCache[index];
      };
    }
  };
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


/**
 * A version of ng-changed that only listens if
 * there is actually a onChange defined on the form
 *
 * Takes the form definition as argument.
 * If the form definition has a "onChange" defined as either a function or
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    require: 'ngModel',
    restrict: 'AC',
    scope: false,
    link: function link(scope, element, attrs, ctrl) {
      var form = scope.$eval(attrs.sfChanged);
      // "form" is really guaranteed to be here since the decorator directive
      // waits for it. But best be sure.
      if (form && form.onChange) {
        ctrl.$viewChangeListeners.push(function () {
          if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(form.onChange)) {
            form.onChange(ctrl.$modelValue, form);
          } else {
            scope.evalExpr(form.onChange, {
              'modelValue': ctrl.$modelValue,
              'form': form,
              'arrayIndex': scope.$index,
              'arrayIndices': scope.arrayIndices,
              'path': scope.path,
              '$i': scope.$i,
              '$index': scope.$index
            });
          }
        });
      }
    }
  };
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



/**
 * I am the directive for managing field properties
 *
 * @param  {function} $parse
 * @param  {function} $compile
 * @param  {function} $interpolate
 * @param  {object}   sfErrorMessage
 * @param  {object}   sfPath
 * @param  {function} sfSelect
 *
 * @return {object}   I am the object providing the directive API to Angular
 */
/* harmony default export */ __webpack_exports__["a"] = (function ($parse, $compile, $interpolate, sfErrorMessage, sfPath, sfSelect) {
  var keyFormat = {
    COMPLETE: '*',
    PATH: 'string',
    INDICES: 'number'
  };

  return {
    restrict: 'AE',
    replace: false,
    transclude: false,
    scope: true,
    require: ['^sfSchema', '?^form', '?^^sfKeyController'],
    link: {
      pre: function pre(scope, element, attrs, ctrl) {
        var sfSchema = ctrl[0];

        // The ngModelController is used in some templates and
        // is needed for error messages,
        scope.$on('schemaFormPropagateNgModelController', function (event, ngModel) {
          event.stopPropagation();
          event.preventDefault();
          scope.ngModel = ngModel;
        });

        // Fetch our form.
        // awd
        scope.initialForm = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(sfSchema.lookup['f' + attrs.sfField]);
        scope.form = sfSchema.lookup['f' + attrs.sfField];
      },
      post: function post(scope, element, attrs, ctrl) {
        var sfSchema = ctrl[0];
        var formCtrl = ctrl[1];

        scope.getKey = function (requiredFormat) {
          var format = requiredFormat || keyFormat.COMPLETE;
          var key = scope.parentKey ? scope.parentKey.slice(0, scope.parentKey.length - 1) : [];

          // Only calculate completeKey if not already saved to form.key
          if (scope.completeKey !== scope.form.key) {
            if (typeof scope.$index === 'number') {
              key = key.concat(scope.$index);
            }

            if (scope.form.key && scope.form.key.length) {
              if (typeof key[key.length - 1] === 'number' && scope.form.key.length >= 1) {
                var trim = scope.form.key.length - key.length;
                scope.completeKey = trim > 0 ? key.concat(scope.form.key.slice(-trim)) : key;
              } else {
                scope.completeKey = scope.form.key.slice();
              }
            }
          }

          // If there is no key then there's nothing to return
          if (!Array.isArray(scope.completeKey)) {
            return undefined;
          }

          // return the full key if not omiting any types via reduce
          if (format === keyFormat.COMPLETE) {
            return scope.completeKey;
          } else {
            // else to clearly show that data must be ommited
            return scope.completeKey.reduce(function (output, input, i) {
              if (-1 !== [format].indexOf(typeof input === 'undefined' ? 'undefined' : _typeof(input))) {
                return output.concat(input);
              }
              return output;
            }, []);
          }
        };

        // Now that getKey is defined, run it! ...if there's a key.
        if (scope.form.key) {
          // awe
          var k = scope.getKey();
          scope.form.key = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(k);
          scope.completeKey = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(k);
        }

        // Keep error prone logic from the template
        scope.showTitle = function () {
          return scope.form && scope.form.notitle !== true && scope.form.title;
        };

        // Normalise names and ids
        scope.fieldId = function (prependFormName, omitArrayIndexes) {
          var omit = omitArrayIndexes || false;
          var formName = prependFormName && formCtrl && formCtrl.$name ? formCtrl.$name : undefined;
          var key = scope.completeKey;

          if (Array.isArray(key)) {
            return sfPath.name(key, '-', formName, omit);
          } else {
            return '';
          }
        };

        scope.listToCheckboxValues = function (list) {
          var values = {};
          __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(list, function (v) {
            values[v] = true;
          });
          return values;
        };

        scope.checkboxValuesToList = function (values) {
          var lst = [];
          __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(values, function (v, k) {
            if (v) {
              lst.push(k);
            }
          });
          return lst;
        };

        scope.buttonClick = function ($event, form) {
          if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(form.onClick)) {
            form.onClick($event, form);
          } else if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isString(form.onClick)) {
            if (sfSchema) {
              // evaluating in scope outside of sfSchemas isolated scope
              sfSchema.evalInParentScope(form.onClick, { '$event': $event, 'form': form });
            } else {
              scope.$eval(form.onClick, { '$event': $event, 'form': form });
            }
          }
        };

        /**
         * Evaluate an expression, i.e. scope.$eval
         * but do it in sfSchemas parent scope sf-schema directive is used
         *
         * @param {string} expression
         * @param {Object} locals (optional)
         * @return {Any} the result of the expression
         */
        scope.evalExpr = function (expression, locals) {
          if (sfSchema) {
            // evaluating in scope outside of sfSchemas isolated scope
            return sfSchema.evalInParentScope(expression, locals);
          }

          return scope.$eval(expression, locals);
        };

        /**
         * Evaluate an expression, i.e. scope.$eval
         * in this decorators scope
         *
         * @param {string} expression
         * @param {Object} locals (optional)
         * @return {Any} the result of the expression
         */
        scope.evalInScope = function (expression, locals) {
          if (expression) {
            return scope.$eval(expression, locals);
          }
        };

        /**
         * Interpolate the expression.
         * Similar to `evalExpr()` and `evalInScope()`
         * but will not fail if the expression is
         * text that contains spaces.
         *
         * Use the Angular `{{ interpolation }}`
         * braces to access properties on `locals`.
         *
         * @param  {string} expression The string to interpolate.
         * @param  {Object} locals (optional) Properties that may be accessed in the
         *                         `expression` string.
         * @return {Any} The result of the expression or `undefined`.
         */
        scope.interp = function (expression, locals) {
          return expression && $interpolate(expression)(locals);
        };

        // This works since we get the ngModel from the array or the schema-validate directive.
        scope.hasSuccess = function () {
          if (!scope.ngModel) {
            return false;
          }
          if (scope.options && scope.options.pristine && scope.options.pristine.success === false) {
            return scope.ngModel.$valid && !scope.ngModel.$pristine && !scope.ngModel.$isEmpty(scope.ngModel.$modelValue);
          } else {
            return scope.ngModel.$valid && (!scope.ngModel.$pristine || !scope.ngModel.$isEmpty(scope.ngModel.$modelValue));
          }
        };

        scope.hasError = function () {
          if (!scope.ngModel) {
            return false;
          }
          if (!scope.options || !scope.options.pristine || scope.options.pristine.errors !== false) {
            // Show errors in pristine forms. The default.
            // Note that "validateOnRender" option defaults to *not* validate initial form.
            // so as a default there won't be any error anyway, but if the model is modified
            // from the outside the error will show even if the field is pristine.
            return scope.ngModel.$invalid;
          } else {
            // Don't show errors in pristine forms.
            return scope.ngModel.$invalid && !scope.ngModel.$pristine;
          }
        };

        /**
         * DEPRECATED: use sf-messages instead.
         * Error message handler
         * An error can either be a schema validation message or a angular js validtion
         * error (i.e. required)
         */
        scope.errorMessage = function (schemaError) {
          return sfErrorMessage.interpolate(schemaError && schemaError.code + '' || 'default', scope.ngModel && scope.ngModel.$modelValue || '', scope.ngModel && scope.ngModel.$viewValue || '', scope.form, scope.options && scope.options.validationMessage);
        };

        // append the field-id to the htmlClass
        scope.form.htmlClass = scope.form.htmlClass || '';
        scope.idClass = scope.fieldId(false) + ' ' + scope.fieldId(false, true);

        var form = scope.form;

        // Where there is a key there is probably a ngModel
        if (form.key) {
          // It looks better with dot notation.
          scope.$on('schemaForm.error.' + form.key.join('.'), function (event, error, validationMessage, validity, formName) {
            // validationMessage and validity are mutually exclusive
            formName = validity;
            if (validationMessage === true || validationMessage === false) {
              validity = validationMessage;
              validationMessage = undefined;
            }

            // If we have specified a form name, and this model is not within
            // that form, then leave things be.
            if (formName != undefined && scope.ngModel.$$parentForm.$name !== formName) {
              return;
            }

            if (scope.ngModel && error) {
              if (scope.ngModel.$setDirty) {
                scope.ngModel.$setDirty();
              } else {
                // FIXME: Check that this actually works on 1.2
                scope.ngModel.$dirty = true;
                scope.ngModel.$pristine = false;
              }

              // Set the new validation message if one is supplied
              // Does not work when validationMessage is just a string.
              if (validationMessage) {
                if (!form.validationMessage) {
                  form.validationMessage = {};
                }
                form.validationMessage[error] = validationMessage;
              }

              scope.ngModel.$setValidity(error, validity === true);

              if (validity === true) {
                // Re-trigger model validator, that model itself would be re-validated
                scope.ngModel.$validate();

                // Setting or removing a validity can change the field to believe its valid
                // but its not. So lets trigger its validation as well.
                scope.$broadcast('schemaFormValidate');
              }
            }
          });

          // Clean up the model when the corresponding form field is $destroy-ed.
          // Default behavior can be supplied as a globalOption, and behavior can be overridden
          // in the form definition.
          scope.$on('$destroy', function () {
            var key = scope.getKey();

            // If the entire schema form is destroyed we don't touch the model
            if (!scope.externalDestructionInProgress) {
              var destroyStrategy = form.destroyStrategy || scope.options && scope.options.destroyStrategy || 'remove';
              // No key no model, and we might have strategy 'retain'
              if (key && destroyStrategy !== 'retain') {
                // Type can also be a list in JSON Schema
                var type = form.schema && form.schema.type || '';

                // Empty means '',{} and [] for appropriate types and undefined for the rest
                var value = void 0;
                if (destroyStrategy === 'empty') {
                  value = type.indexOf('string') !== -1 ? '' : type.indexOf('object') !== -1 ? {} : type.indexOf('array') !== -1 ? [] : undefined;
                } else if (destroyStrategy === 'null') {
                  value = null;
                }

                if (value !== undefined) {
                  sfSelect(key, scope.model, value);
                } else {
                  // Get the object parent object
                  var obj = scope.model;
                  if (key.length > 1) {
                    obj = sfSelect(key.slice(0, key.length - 1), obj);
                  }

                  // parent can be undefined if the form hasn't been filled out
                  // entirely
                  if (obj === undefined) {
                    return;
                  }

                  // if parent is an array, then we have already been removed.
                  // set flag to all children (who are about to recieve a $destroy
                  // event as well) that we have already been destroyed
                  if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isArray(obj)) {
                    scope.externalDestructionInProgress = true;
                    return;
                  }

                  delete obj[key[key.length - 1]];
                }
              }
            }
          });
        }
      }
    }
  };
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * I am the directive that handles keys and array indexes
 *
 * @param  {function} sfPath
 *
 * @return {[type]}            [description]
 */
/* harmony default export */ __webpack_exports__["a"] = (function (sfPath) {
  return {
    scope: true,
    require: ['?^^sfNewArray'],
    link: {
      pre: function pre(scope, element, attrs, ctrl) {
        scope.parentKey = scope.parentKey || [];

        var currentKey = sfPath.parse(attrs.sfParentKey);
        var trim = currentKey.length - scope.parentKey.length;

        if (currentKey.length > 1) currentKey = currentKey.splice(-trim);

        scope.parentKey = scope.parentKey.concat(currentKey, Number(attrs.sfIndex));
        scope.arrayIndex = Number(attrs.sfIndex);
        scope.arrayIndices = scope.arrayIndices || [];
        scope.arrayIndices = scope.arrayIndices.concat(scope.arrayIndex);
        scope.$i = scope.arrayIndices;
        scope.path = function (modelPath) {
          var i = -1;
          modelPath = modelPath.replace(/\[\]/gi, function (matched) {
            i++;
            return '[' + scope.$i[i] + ']';
          });
          return scope.evalExpr(modelPath, scope);
        };
      }
    }
  };
});;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


/**
 * I am the messages directive for description and error message handling
 *
 * @param  {object} $injector I am the Angular injector for optional dependencies
 * @param  {object} sfErrorMessage I contain the interpolation function for messages
 *
 * @return {object} I am the message directive API
 */
/* harmony default export */ __webpack_exports__["a"] = (function ($injector, sfErrorMessage) {
  // Inject sanitizer if it exists
  var $sanitize = $injector.has('$sanitize') ? $injector.get('$sanitize') : function (html) {
    return html;
  };

  return {
    scope: false,
    restrict: 'EA',
    link: function link(scope, element, attrs) {
      var message = '';
      if (attrs.sfMessage) {
        scope.$watch(attrs.sfMessage, function (msg) {
          if (msg) {
            message = $sanitize(msg);
            update(!!scope.ngModel);
          }
        });
      }

      var currentMessage = void 0;
      // Only call html() if needed.
      var setMessage = function setMessage(msg) {
        if (msg !== currentMessage) {
          element.html(msg);
          currentMessage = msg;
        }
      };

      var update = function update(checkForErrors) {
        if (checkForErrors) {
          if (!scope.hasError()) {
            setMessage(message);
          } else {
            var errors = [];
            __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(scope.ngModel && scope.ngModel.$error, function (status, code) {
              if (status) {
                // if true then there is an error
                // Angular 1.3 removes properties, so we will always just have errors.
                // Angular 1.2 sets them to false.
                errors.push(code);
              }
            });

            // In Angular 1.3 we use one $validator to stop the model value from getting updated.
            // this means that we always end up with a 'schemaForm' error.
            errors = errors.filter(function (e) {
              return e !== 'schemaForm';
            });

            // We only show one error.
            // TODO: Make that optional
            var error = errors[0];

            if (error) {
              setMessage(sfErrorMessage.interpolate(error, scope.ngModel.$modelValue, scope.ngModel.$viewValue, scope.form, scope.options && scope.options.validationMessage));
            } else {
              setMessage(message);
            }
          }
        } else {
          setMessage(message);
        }
      };

      // Update once.
      update();

      var once = scope.$watch('ngModel', function (ngModel) {
        if (ngModel) {
          // We also listen to changes of the model via parsers and formatters.
          // This is since both the error message can change and given a pristine
          // option to not show errors the ngModel.$error might not have changed
          // but we're not pristine any more so we should change!
          ngModel.$parsers.push(function (val) {
            update(true);return val;
          });
          ngModel.$formatters.push(function (val) {
            update(true);return val;
          });
          once();
        }
      });

      // We watch for changes in $error
      scope.$watchCollection('ngModel.$error', function () {
        update(!!scope.ngModel);
      });
    }
  };
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


/**
FIXME: real documentation
<form sf-form="form"  sf-schema="schema" sf-decorator="foobar"></form>
*/
/**
 * [description]
 *
 * @param  {[type]} $compile             [description]
 * @param  {[type]} $http                [description]
 * @param  {[type]} $templateCache       [description]
 * @param  {[type]} $q                   [description]
 * @param  {[type]} schemaForm           [description]
 * @param  {[type]} schemaFormDecorators [description]
 * @param  {[type]} sfSelect             [description]
 * @param  {[type]} sfBuilder            [description]
 *
 * @return {[type]}                      [description]
 */
/* harmony default export */ __webpack_exports__["a"] = (function ($compile, $http, $templateCache, $q, schemaForm, schemaFormDecorators, sfSelect, sfBuilder) {
  return {
    scope: {
      schema: '=sfSchema',
      initialForm: '=sfForm',
      model: '=sfModel',
      options: '=sfOptions'
    },
    controller: ['$scope', function ($scope) {
      this.$onInit = function () {
        this.evalInParentScope = function (expr, locals) {
          return $scope.$parent.$eval(expr, locals);
        };

        // Set up form lookup map
        var that = this;
        $scope.lookup = function (lookup) {
          if (lookup) {
            that.lookup = lookup;
          }
          return that.lookup;
        };
      };

      // Prior to v1.5, we need to call `$onInit()` manually.
      // (Bindings will always be pre-assigned in these versions.)
      if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.version.major === 1 && __WEBPACK_IMPORTED_MODULE_0_angular___default.a.version.minor < 5) {
        this.$onInit();
      }
    }],
    replace: false,
    restrict: 'A',
    transclude: true,
    require: '?form',
    link: function link(scope, element, attrs, formCtrl, transclude) {
      // expose form controller on scope so that we don't force authors to use name on form
      scope.formCtrl = formCtrl;

      // We'd like to handle existing markup,
      // besides using it in our template we also
      // check for ng-model and add that to an ignore list
      // i.e. even if form has a definition for it or form is ["*"]
      // we don't generate it.
      var ignore = {};
      transclude(scope, function (clone) {
        clone.addClass('schema-form-ignore');
        element.prepend(clone);

        if (element[0].querySelectorAll) {
          var models = element[0].querySelectorAll('[ng-model]');
          if (models) {
            for (var i = 0; i < models.length; i++) {
              var key = models[i].getAttribute('ng-model');
              // skip first part before .
              ignore[key.substring(key.indexOf('.') + 1)] = true;
            }
          }
        }
      });

      var lastDigest = {};
      var childScope = void 0;

      // Common renderer function, can either be triggered by a watch or by an event.
      scope.resolveReferences = function (schema, form) {
        schemaForm.jsonref(schema).then(function (resolved) {
          scope.render(resolved, form);
        }).catch(function (err) {
          throw new Error(err);
        });
      };

      scope.render = function (schema, form) {
        var asyncTemplates = [];
        var merged = schemaForm.merge(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(schema), __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(form), undefined, ignore, scope.options, undefined, asyncTemplates);

        if (asyncTemplates.length > 0) {
          // Pre load all async templates and put them on the form for the builder to use.
          $q.all(asyncTemplates.map(function (form) {
            return $http.get(form.templateUrl, { cache: $templateCache }).then(function (res) {
              form.template = res.data;
            });
          })).then(function () {
            scope.internalRender(schema, form, merged);
          });
        } else {
          scope.internalRender(schema, form, merged);
        }
      };

      scope.internalRender = function (schema, form, merged) {
        // Create a new form and destroy the old one.
        // Not doing keeps old form elements hanging around after
        // they have been removed from the DOM
        // https:// github.com/Textalk/angular-schema-form/issues/200
        if (childScope) {
          // Destroy strategy should not be acted upon
          scope.externalDestructionInProgress = true;
          childScope.$destroy();
          scope.externalDestructionInProgress = false;
        }
        childScope = scope.$new();

        // make the form available to decorators
        childScope.schemaForm = { form: merged, schema: schema };

        // clean all but pre existing html.
        Array.prototype.forEach.call(element.children(), function (child) {
          var jchild = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.element(child);
          if (false === jchild.hasClass('schema-form-ignore')) {
            jchild.remove();
          }
        });

        // Find all slots.
        var slots = {};
        var slotsFound = element[0].querySelectorAll('*[sf-insert-field]');

        for (var i = 0; i < slotsFound.length; i++) {
          slots[slotsFound[i].getAttribute('sf-insert-field')] = slotsFound[i];
        }

        // if sfUseDecorator is undefined the default decorator is used.
        var decorator = schemaFormDecorators.decorator(attrs.sfUseDecorator);
        // Use the builder to build it and append the result
        var lookup = Object.create(null);
        scope.lookup(lookup); // give the new lookup to the controller.
        element[0].appendChild(sfBuilder.build(__WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(merged), decorator, slots, lookup));

        // We need to know if we're in the first digest looping
        // I.e. just rendered the form so we know not to validate
        // empty fields.
        childScope.firstDigest = true;
        // We use a ordinary timeout since we don't need a digest after this.
        setTimeout(function () {
          childScope.firstDigest = false;
          scope.$apply();
        }, 0);

        // compile only children
        $compile(element.children())(childScope);

        // ok, now that that is done let's set any defaults
        if (!scope.options || scope.options.setSchemaDefaults !== false) {
          schemaForm.traverseSchema(schema, function (prop, path) {
            if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isDefined(prop['default'])) {
              var val = sfSelect(path, scope.model);
              if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isUndefined(val)) {
                var defVal = prop['default'];
                if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isObject(defVal)) defVal = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(defVal);
                sfSelect(path, scope.model, defVal);
              }
            }
          });
        }

        scope.$emit('sf-render-finished', element);
      };

      var defaultForm = ['*'];

      // Since we are dependant on up to three
      // attributes we'll do a common watch
      scope.$watch(function () {
        return {
          schema: scope.schema,
          form: scope.initialForm || defaultForm
        };
      }, function (newVals) {
        if (newVals.form && newVals.schema && newVals.schema.type) {
          scope.resolveReferences(newVals.schema, newVals.form);
        }
      }, true);

      // We also listen to the event schemaFormRedraw so you can manually trigger a change if
      // part of the form or schema is chnaged without it being a new instance.
      scope.$on('schemaFormRedraw', function () {
        var schema = scope.schema;
        var form = scope.initialForm ? __WEBPACK_IMPORTED_MODULE_0_angular___default.a.copy(scope.initialForm) : ['*'];
        if (schema) {
          scope.resolveReferences(schema, form);
        }
      });

      scope.$on('$destroy', function () {
        // Each field listens to the $destroy event so that it can remove any value
        // from the model if that field is removed from the form. This is the default
        // destroy strategy. But if the entire form (or at least the part we're on)
        // gets removed, like when routing away to another page, then we definetly want to
        // keep the model intact. So therefore we set a flag to tell the others it's time to just
        // let it be.
        scope.externalDestructionInProgress = true;
      });

      /**
       * Evaluate an expression, i.e. scope.$eval
       * but do it in parent scope
       *
       * @param {String} expression
       * @param {Object} locals (optional)
       * @return {Any} the result of the expression
       */
      scope.evalExpr = function (expression, locals) {
        return scope.$parent.$eval(expression, locals);
      };
    }
  };
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);


/**
 * I am the schema-form-decorators provider and manage the decorator API
 *
 * @param  {object} $compileProvider
 * @param  {object} sfPathProvider
 *
 * @return {object} I am the directive properties made available to Angular
 */
/* harmony default export */ __webpack_exports__["a"] = (function ($compileProvider, sfPathProvider) {
  var defaultDecorator = '';
  var decorators = {};

  // Map template after decorator and type.
  var templateUrl = function templateUrl(name, form) {
    // schemaDecorator is alias for whatever is set as default
    if (name === 'sfDecorator') {
      name = defaultDecorator;
    }

    var decorator = decorators[name];
    if (decorator[form.type]) {
      return decorator[form.type].template;
    }

    // try default
    return decorator['default'].template;
  };

  /** ************************************************
   * DEPRECATED                                      *
   * The new builder and sf-field is preferred, but  *
   * we keep this in during a transitional period    *
   * so that add-ons that don't use the new builder  *
   * works.                                          *
   ************************************************ **/
  // TODO: Move to a compatability extra script.
  var createDirective = function createDirective(name) {
    $compileProvider.directive(name, ['$parse', '$compile', '$http', '$templateCache', '$interpolate', '$q', 'sfErrorMessage', 'sfPath', 'sfSelect', function ($parse, $compile, $http, $templateCache, $interpolate, $q, sfErrorMessage, sfPath, sfSelect) {
      return {
        restrict: 'AE',
        replace: false,
        transclude: false,
        scope: true,
        require: ['?^sfSchema', '?^form'],
        link: function link(scope, element, attrs, ctrl) {
          var sfSchema = ctrl[0];
          var formCtrl = ctrl[1];

          // The ngModelController is used in some templates and
          // is needed for error messages,
          scope.$on('schemaFormPropagateNgModelController', function (event, ngModel) {
            event.stopPropagation();
            event.preventDefault();
            scope.ngModel = ngModel;
          });

          // Keep error prone logic from the template
          scope.showTitle = function () {
            return scope.form && scope.form.notitle !== true && scope.form.title;
          };

          // Normalise names and ids
          scope.fieldId = function (prependFormName, omitArrayIndexes) {
            var key = scope.parentKey || [];
            if (scope.form.key) {
              if (typeof key[key.length - 1] === 'number') {
                var combinedKey = key.concat(scope.form.key.slice(-1));
                var formName = prependFormName && formCtrl && formCtrl.$name ? formCtrl.$name : undefined;
                return sfPath.name(combinedKey, '-', formName, omitArrayIndexes);
              } else {
                var _formName = prependFormName && formCtrl && formCtrl.$name ? formCtrl.$name : undefined;
                return sfPath.name(scope.form.key, '-', _formName, omitArrayIndexes);
              }
            } else {
              return '';
            }
          };

          scope.listToCheckboxValues = function (list) {
            var values = {};
            __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(list, function (v) {
              values[v] = true;
            });
            return values;
          };

          scope.checkboxValuesToList = function (values) {
            var lst = [];
            __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(values, function (v, k) {
              if (v) {
                lst.push(k);
              }
            });
            return lst;
          };

          scope.buttonClick = function ($event, form) {
            if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(form.onClick)) {
              form.onClick($event, form);
            } else if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isString(form.onClick)) {
              if (sfSchema) {
                // evaluating in scope outside of sfSchemas isolated scope
                sfSchema.evalInParentScope(form.onClick, { '$event': $event, 'form': form });
              } else {
                scope.$eval(form.onClick, { '$event': $event, 'form': form });
              };
            };
          };

          /**
           * Evaluate an expression, i.e. scope.$eval
           * but do it in sfSchemas parent scope sf-schema directive is used
           *
           * @param {string} expression
           * @param {Object} locals (optional)
           * @return {Any} the result of the expression
           */
          scope.evalExpr = function (expression, locals) {
            if (sfSchema) {
              // evaluating in scope outside of sfSchemas isolated scope
              return sfSchema.evalInParentScope(expression, locals);
            }

            return scope.$eval(expression, locals);
          };

          /**
           * Evaluate an expression, i.e. scope.$eval
           * in this decorators scope
           *
           * @param {string} expression
           * @param {Object} locals (optional)
           * @return {Any} the result of the expression
           */
          scope.evalInScope = function (expression, locals) {
            if (expression) {
              return scope.$eval(expression, locals);
            }
          };

          /**
           * Interpolate the expression.
           * Similar to `evalExpr()` and `evalInScope()`
           * but will not fail if the expression is
           * text that contains spaces.
           *
           * Use the Angular `{{ interpolation }}`
           * braces to access properties on `locals`.
           *
           * @param  {string} expression The string to interpolate.
           * @param  {Object} locals (optional) Properties that may be accessed in the
           *                         `expression` string.
           * @return {Any} The result of the expression or `undefined`.
           */
          scope.interp = function (expression, locals) {
            return expression && $interpolate(expression)(locals);
          };

          // This works since we ot the ngModel from the array or the schema-validate directive.
          scope.hasSuccess = function () {
            if (!scope.ngModel) {
              return false;
            }
            if (scope.options && scope.options.pristine && scope.options.pristine.success === false) {
              return scope.ngModel.$valid && !scope.ngModel.$pristine && !scope.ngModel.$isEmpty(scope.ngModel.$modelValue);
            } else {
              return scope.ngModel.$valid && (!scope.ngModel.$pristine || !scope.ngModel.$isEmpty(scope.ngModel.$modelValue));
            }
          };

          scope.hasError = function () {
            if (!scope.ngModel) {
              return false;
            }
            return scope.ngModel.$invalid && !scope.ngModel.$pristine;
          };

          /**
           * DEPRECATED: use sf-messages instead.
           * Error message handler
           * An error can either be a schema validation message or a angular js validtion
           * error (i.e. required)
           */
          scope.errorMessage = function (schemaError) {
            return sfErrorMessage.interpolate(schemaError && schemaError.code + '' || 'default', scope.ngModel && scope.ngModel.$modelValue || '', scope.ngModel && scope.ngModel.$viewValue || '', scope.form, scope.options && scope.options.validationMessage);
          };

          // Rebind our part of the form to the scope.
          var once = scope.$watch(attrs.form, function (form) {
            if (form) {
              // Workaround for 'updateOn' error from ngModelOptions
              // see https:// github.com/Textalk/angular-schema-form/issues/255
              // and https:// github.com/Textalk/angular-schema-form/issues/206
              form.ngModelOptions = form.ngModelOptions || {};
              scope.form = form;

              // ok let's replace that template!
              // We do this manually since we need to bind ng-model properly and also
              // for fieldsets to recurse properly.
              var templatePromise = void 0;

              // type: "template" is a special case. It can contain a template inline or an url.
              // otherwise we find out the url to the template and load them.
              if (form.type === 'template' && form.template) {
                templatePromise = $q.when(form.template);
              } else {
                var url = form.type === 'template' ? form.templateUrl : templateUrl(name, form);
                templatePromise = $http.get(url, { cache: $templateCache }).then(function (res) {
                  return res.data;
                });
              }

              templatePromise.then(function (template) {
                if (form.key) {
                  var key = form.key ? sfPathProvider.stringify(form.key).replace(/"/g, '&quot;') : '';
                  template = template.replace(/\$\$value\$\$/g, 'model' + (key[0] !== '[' ? '.' : '') + key);
                }
                element.html(template);

                // Do we have a condition? Then we slap on an ng-if on all children,
                // but be nice to existing ng-if.
                if (form.condition) {
                  var evalExpr = 'evalExpr(form.condition,{ model: model, "arrayIndex": arrayIndex})';
                  if (form.key) {
                    evalExpr = 'evalExpr(form.condition, {' + 'model: model, "arrayIndex": arrayIndex, "modelValue": model' + sfPath.stringify(form.key) + '})';
                  }

                  __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(element.children(), function (child) {
                    var ngIf = child.getAttribute('ng-if');
                    child.setAttribute('ng-if', ngIf ? '(' + ngIf + ') || (' + evalExpr + ')' : evalExpr);
                  });
                }
                $compile(element.contents())(scope);
              });

              // Where there is a key there is probably a ngModel
              if (form.key) {
                // It looks better with dot notation.
                scope.$on('schemaForm.error.' + form.key.join('.'), function (event, error, validationMessage, validity, formName) {
                  // validationMessage and validity are mutually exclusive
                  formName = validity;
                  if (validationMessage === true || validationMessage === false) {
                    validity = validationMessage;
                    validationMessage = undefined;
                  };

                  // If we have specified a form name, and this model is not within
                  // that form, then leave things be.
                  if (formName != undefined && scope.ngModel.$$parentForm.$name !== formName) {
                    return;
                  };

                  // If we have specified a form name, and this model is not within
                  // that form, then leave things be.
                  if (formName != undefined && scope.ngModel.$$parentForm.$name !== formName) {
                    return;
                  }

                  if (scope.ngModel && error) {
                    if (scope.ngModel.$setDirty) {
                      scope.ngModel.$setDirty();
                    } else {
                      // FIXME: Check that this actually works on 1.2
                      scope.ngModel.$dirty = true;
                      scope.ngModel.$pristine = false;
                    };

                    // Set the new validation message if one is supplied
                    // Does not work when validationMessage is just a string.
                    if (validationMessage) {
                      if (!form.validationMessage) {
                        form.validationMessage = {};
                      }
                      form.validationMessage[error] = validationMessage;
                    }

                    scope.ngModel.$setValidity(error, validity === true);

                    if (validity === true) {
                      // Re-trigger model validator, that model itself would be re-validated
                      scope.ngModel.$validate();

                      // Setting or removing a validity can change the field to believe its valid
                      // but its not. So lets trigger its validation as well.
                      scope.$broadcast('schemaFormValidate');
                    }
                  }
                });

                // Clean up the model when the corresponding form field is $destroy-ed.
                // Default behavior can be supplied as a globalOption, and behavior can be overridden
                // in the form definition.
                scope.$on('$destroy', function () {
                  // If the entire schema form is destroyed we don't touch the model
                  if (!scope.externalDestructionInProgress) {
                    var destroyStrategy = form.destroyStrategy || scope.options && scope.options.destroyStrategy || 'remove';
                    // No key no model, and we might have strategy 'retain'
                    if (form.key && destroyStrategy !== 'retain') {
                      // Get the object that has the property we wan't to clear.
                      var obj = scope.model;
                      if (form.key.length > 1) {
                        obj = sfSelect(form.key.slice(0, form.key.length - 1), obj);
                      }

                      // We can get undefined here if the form hasn't been filled out entirely
                      if (obj === undefined) {
                        return;
                      }

                      // Type can also be a list in JSON Schema
                      var type = form.schema && form.schema.type || '';

                      // Empty means '',{} and [] for appropriate types and undefined for the rest
                      if (destroyStrategy === 'empty' && type.indexOf('string') !== -1) {
                        obj[form.key.slice(-1)] = '';
                      } else if (destroyStrategy === 'empty' && type.indexOf('object') !== -1) {
                        obj[form.key.slice(-1)] = {};
                      } else if (destroyStrategy === 'empty' && type.indexOf('array') !== -1) {
                        obj[form.key.slice(-1)] = [];
                      } else if (destroyStrategy === 'null') {
                        obj[form.key.slice(-1)] = null;
                      } else {
                        delete obj[form.key.slice(-1)];
                      }
                    }
                  }
                });
              }

              once();
            }
          });
        }
      };
    }]);
  };

  var createManualDirective = function createManualDirective(type, templateUrl, transclude) {
    transclude = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.isDefined(transclude) ? transclude : false;
    $compileProvider.directive('sf' + type[0].toUpperCase() + type.substr(1), function () {
      return {
        restrict: 'EAC',
        scope: true,
        replace: true,
        transclude: transclude,
        template: '<sf-decorator form="form"></sf-decorator>',
        link: function link(scope, element, attrs) {
          var watchThis = {
            'items': 'c',
            'titleMap': 'c',
            'schema': 'c'
          };
          var form = { type: type };
          var once = true;
          __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(attrs, function (value, name) {
            if (name[0] !== '$' && name.indexOf('ng') !== 0 && name !== 'sfField') {
              var updateForm = function updateForm(val) {
                if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isDefined(val) && val !== form[name]) {
                  form[name] = val;

                  // when we have type, and if specified key we apply it on scope.
                  if (once && form.type && (form.key || __WEBPACK_IMPORTED_MODULE_0_angular___default.a.isUndefined(attrs.key))) {
                    scope.form = form;
                    once = false;
                  }
                }
              };

              if (name === 'model') {
                // "model" is bound to scope under the name "model" since this is what the decorators
                // know and love.
                scope.$watch(value, function (val) {
                  if (val && scope.model !== val) {
                    scope.model = val;
                  }
                });
              } else if (watchThis[name] === 'c') {
                // watch collection
                scope.$watchCollection(value, updateForm);
              } else {
                // $observe
                attrs.$observe(name, updateForm);
              }
            }
          });
        }
      };
    });
  };

  /**
   * DEPRECATED: use defineDecorator instead.
   * Create a decorator directive and its sibling "manual" use decorators.
   * The directive can be used to create form fields or other form entities.
   * It can be used in conjunction with <schema-form> directive in which case the decorator is
   * given it's configuration via a the "form" attribute.
   *
   * ex. Basic usage
   *   <sf-decorator form="myform"></sf-decorator>
   **
   * @param {string} name directive name (CamelCased)
   * @param {Object} templates, an object that maps "type" => "templateUrl"
   */
  this.createDecorator = function (name, templates) {
    // console.warn('schemaFormDecorators.createDecorator is DEPRECATED, use defineDecorator instead.');
    decorators[name] = { '__name': name };

    __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(templates, function (url, type) {
      decorators[name][type] = { template: url, replace: false, builder: [] };
    });

    if (!decorators[defaultDecorator]) {
      defaultDecorator = name;
    }
    createDirective(name);
  };

  /**
   * Define a decorator. A decorator is a set of form types with templates and builder functions
   * that help set up the form.
   *
   * @param {string} name directive name (CamelCased)
   * @param {Object} fields, an object that maps "type" => `{ template, builder, replace}`.
                     attributes `builder` and `replace` are optional, and replace defaults to true.
                      `template` should be the key of the template to load and it should be pre-loaded
                     in `$templateCache`.
                      `builder` can be a function or an array of functions. They will be called in
                     the order they are supplied.
                      `replace` (DEPRECATED) is for backwards compatability. If false the builder
                     will use the "old" way of building that form field using a <sf-decorator>
                     directive.
   */
  this.defineDecorator = function (name, fields) {
    decorators[name] = { '__name': name }; // TODO: this feels like a hack, come up with a better way.

    __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(fields, function (field, type) {
      field.builder = field.builder || [];
      field.replace = __WEBPACK_IMPORTED_MODULE_0_angular___default.a.isDefined(field.replace) ? field.replace : true;
      decorators[name][type] = field;
    });

    if (!decorators[defaultDecorator]) {
      defaultDecorator = name;
    }
    createDirective(name);
  };

  /**
   * DEPRECATED
   * Creates a directive of a decorator
   * Usable when you want to use the decorators without using <schema-form> directive.
   * Specifically when you need to reuse styling.
   *
   * ex. createDirective('text','...')
   *  <sf-text title="foobar" model="person" key="name" schema="schema"></sf-text>
   *
   * @param {string}  type The type of the directive, resulting directive will have sf- prefixed
   * @param {string}  templateUrl
   * @param {boolean} transclude (optional) sets transclude option of directive, defaults to false.
   */
  this.createDirective = createManualDirective;

  /**
   * DEPRECATED
   * Same as createDirective, but takes an object where key is 'type' and value is 'templateUrl'
   * Useful for batching.
   *
   * @param {Object} templates
   */
  this.createDirectives = function (templates) {
    __WEBPACK_IMPORTED_MODULE_0_angular___default.a.forEach(templates, function (url, type) {
      createManualDirective(type, url);
    });
  };

  /**
   * Getter for decorator settings
   *
   * @param {string} name (optional) defaults to defaultDecorator
   * @return {Object} rules and templates { rules: [],templates: {}}
   */
  this.decorator = function (name) {
    name = name || defaultDecorator;
    return decorators[name];
  };

  /**
   * DEPRECATED use defineAddOn() instead.
   * Adds a mapping to an existing decorator.
   *
   * @param {String} name Decorator name
   * @param {String} type Form type for the mapping
   * @param {String} url  The template url
   * @param {Function} builder (optional) builder function
   * @param {boolean} replace (optional) defaults to false. Replace decorator directive with template.
   */
  this.addMapping = function (name, type, url, builder, replace) {
    if (decorators[name]) {
      decorators[name][type] = {
        template: url,
        builder: builder,
        replace: !!replace
      };
    }
  };

  /**
   * Adds an add-on to an existing decorator.
   *
   * @param {String} name Decorator name
   * @param {String} type Form type for the mapping
   * @param {String} url  The template url
   * @param {Function|Array} builder (optional) builder function(s),
   */
  this.defineAddOn = function (name, type, url, builder) {
    if (decorators[name]) {
      decorators[name][type] = {
        template: url,
        builder: builder,
        replace: true
      };
    }
  };

  // Service is just a getter for directive templates and rules
  this.$get = function () {
    return {
      decorator: function decorator(name) {
        return decorators[name] || decorators[defaultDecorator];
      },
      defaultDecorator: defaultDecorator
    };
  };

  // Create a default directive
  createDirective('sfDecorator');
});;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__);


/**
 * Schema form service.
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var postProcessFn = function postProcessFn(form) {
    return form;
  };
  var defaults = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["schemaDefaults"].createDefaults();

  /**
   * Provider API
   */
  this.defaults = defaults;
  this.stdFormObj = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["schemaDefaults"].stdFormObj;
  this.defaultFormDefinition = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["schemaDefaults"].defaultFormDefinition;

  /**
   * Register a post process function.
   * This function is called with the fully merged
   * form definition (i.e. after merging with schema)
   * and whatever it returns is used as form.
   */
  this.postProcess = function (fn) {
    postProcessFn = fn;
  };

  /**
   * Append default form rule
   *
   * @param {string}   type json schema type
   * @param {Function} rule a function(propertyName,propertySchema,options) that returns a form
   *                        definition or undefined
   */
  this.appendRule = function (type, rule) {
    if (!this.defaults[type]) {
      this.defaults[type] = [];
    }
    this.defaults[type].push(rule);
  };

  /**
   * Prepend default form rule
   *
   * @param {string}   type json schema type
   * @param {Function} rule a function(propertyName,propertySchema,options) that returns a form
   *                        definition or undefined
   */
  this.prependRule = function (type, rule) {
    if (!this.defaults[type]) {
      this.defaults[type] = [];
    }
    this.defaults[type].unshift(rule);
  };

  /**
   * Utility function to create a standard form object.
   * This does *not* set the type of the form but rather all shared attributes.
   * You probably want to start your rule with creating the form with this method
   * then setting type and any other values you need.
   * @param {Object} schema
   * @param {Object} options
   * @return {Object} a form field defintion
   */
  this.createStandardForm = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["schemaDefaults"].stdFormObj;
  /* End Provider API */

  this.$get = function () {
    var service = {};
    var typeDefault = this.defaults;

    service.jsonref = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["jsonref"];

    /**
    * Create form defaults from schema
    */
    service.defaults = function (schema, types, ignore, options) {
      var defaultTypes = types || typeDefault;
      return __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["schemaDefaults"].defaultForm(schema, defaultTypes, ignore, options);
    };

    /**
     * merge
     *
     * @param  {Object}  schema                             [description]
     * @param  {Array}   [form=['*']]                       [description]
     * @param  {Object}  [typeDefaults=service.typeDefault] [description]
     * @param  {boolean} ignore                             [description]
     * @param  {Object}  [options={}]                       [description]
     * @param  {Boolean} [readonly=false]                   [description]
     * @param  {[type]}  asyncTemplates                     [description]
     *
     * @return {array}   I am the canonical schema with the combined schema and ui-schema
     */
    service.merge = function (schema) {
      var form = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['*'];
      var typeDefaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : service.typeDefault;
      var ignore = arguments[3];
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      var readonly = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var asyncTemplates = arguments[6];

      // We look at the supplied form and extend it with schema standards
      var canonical = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["merge"])(schema, form, typeDefaults, ignore, options, readonly, asyncTemplates);
      return postProcessFn(canonical);
    };

    // Utility functions
    /**
     * Form defaults for schema by type
     * As a form is generated from a schema these are the definitions of each json-schema type
     */
    service.typeDefault = typeDefault;

    /**
     * Traverse a schema, applying a function(schema,path) on every sub schema
     * i.e. every property of an object.
     */
    service.traverseSchema = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["traverseSchema"];

    service.traverseForm = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["traverseForm"];

    return service;
  };
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// FIXME: type template (using custom builder)
/**
 * I build the canonical schema
 *
 * @param  {[type]} sfPathProvider [description]
 *
 * @return {[type]}                [description]
 */
/* harmony default export */ __webpack_exports__["a"] = (function (sfPathProvider) {
  var SNAKE_CASE_REGEXP = /[A-Z]/g;
  var snakeCase = function snakeCase(name, separator) {
    separator = separator || '_';
    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  };
  var formId = 0;

  if (!('firstElementChild' in document.createDocumentFragment())) {
    Object.defineProperty(DocumentFragment.prototype, 'firstElementChild', {
      get: function get() {
        for (var nodes = this.childNodes, n, i = 0, l = nodes.length; i < l; ++i) {
          if (n = nodes[i], 1 === n.nodeType) return n;
        }return null;
      }
    });
  }

  var builders = {
    sfField: function sfField(args) {
      args.fieldFrag.firstElementChild.setAttribute('sf-field', formId);

      // We use a lookup table for easy access to our form.
      args.lookup['f' + formId] = args.form;
      formId++;
    },
    ngModel: function ngModel(args) {
      if (!args.form.key) {
        return;
      };

      var key = args.form.key;

      // Redact part of the key, used in arrays
      // KISS keyRedaction is a number.
      if (args.state.keyRedaction) {
        key = key.slice(args.state.keyRedaction);
      }

      // Stringify key.
      var modelValue = void 0;
      if (!args.state.modelValue) {
        var strKey = sfPathProvider.stringify(key).replace(/"/g, '&quot;');
        modelValue = args.state.modelName || 'model';

        if (strKey) {
          // Sometimes, like with arrays directly in arrays strKey is nothing.
          modelValue += (strKey[0] !== '[' ? '.' : '') + strKey;
        }
      } else {
        // Another builder, i.e. array has overriden the modelValue
        modelValue = args.state.modelValue;
      }

      // Find all sf-field-value attributes.
      // No value means a add a ng-model.
      // sf-field-value="replaceAll", loop over attributes and replace $$value$$ in each.
      // sf-field-value="attrName", replace or set value of that attribute.
      var nodes = args.fieldFrag.querySelectorAll('[sf-field-model]');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        var conf = n.getAttribute('sf-field-model');
        if (!conf || conf === '') {
          n.setAttribute('ng-model', modelValue);
        } else if (conf === 'replaceAll') {
          var attributes = n.attributes;
          for (var j = 0; j < attributes.length; j++) {
            if (attributes[j].value && attributes[j].value.indexOf('$$value') !== -1) {
              attributes[j].value = attributes[j].value.replace(/\$\$value\$\$/g, modelValue);
            }
          }
        } else {
          var val = n.getAttribute(conf);
          if (val && val.indexOf('$$value$$')) {
            n.setAttribute(conf, val.replace(/\$\$value\$\$/g, modelValue));
          } else {
            n.setAttribute(conf, modelValue);
          }
        }
      }
    },
    simpleTransclusion: function simpleTransclusion(args) {
      var children = args.build(args.form.items, args.path + '.items', args.state);
      args.fieldFrag.firstChild.appendChild(children);
    },

    // Patch on ngModelOptions, since it doesn't like waiting for its value.
    ngModelOptions: function ngModelOptions(args) {
      if (args.form.ngModelOptions && Object.keys(args.form.ngModelOptions).length > 0) {
        args.fieldFrag.firstChild.setAttribute('ng-model-options', JSON.stringify(args.form.ngModelOptions));
      }
    },
    transclusion: function transclusion(args) {
      var transclusions = args.fieldFrag.querySelectorAll('[sf-field-transclude]');

      if (transclusions.length) {
        for (var i = 0; i < transclusions.length; i++) {
          var n = transclusions[i];

          // The sf-transclude attribute is not a directive,
          // but has the name of what we're supposed to
          // traverse. Default to `items`
          var sub = n.getAttribute('sf-field-transclude') || 'items';
          var items = args.form[sub];

          if (items) {
            var childFrag = args.build(items, args.path + '.' + sub, args.state);
            n.appendChild(childFrag);
          }
        }
      }
    },
    condition: function condition(args) {
      var strKey = '';
      var strModel = 'undefined';
      var ngIf = '';
      // Do we have a condition? Then we slap on an ng-if on all children,
      // but be nice to existing ng-if.
      if (args.form.condition) {
        if (args.form.key) {
          strKey = sfPathProvider.stringify(args.form.key);
          strModel = 'model' + (strKey[0] === '[' ? '' : '.') + strKey;
        }

        var evalExpr = 'evalExpr(' + args.path + '.condition, { model: model, ' + '"arrayIndex": $index, ' + '"arrayIndices": arrayIndices, ' + '"path": path, ' + '"$i": $i, ' + '"$index": $index, ' + '"modelValue": ' + strModel + '})';

        var children = args.fieldFrag.children || args.fieldFrag.childNodes;

        for (var i = 0; i < children.length; i++) {
          var child = children[i];

          if (child.hasAttribute && child.hasAttribute('ng-if')) {
            ngIf = child.getAttribute('ng-if');
          };

          if (child.setAttribute) {
            child.setAttribute('ng-if', ngIf ? '(' + ngIf + ') || (' + evalExpr + ')' : evalExpr);
          };
        }
      }
    },
    array: function array(args) {
      var items = args.fieldFrag.querySelector('[schema-form-array-items]');

      if (items) {
        var state = angular.copy(args.state);
        state.keyRedaction = 0;
        state.keyRedaction += args.form.key.length + 1;

        // Special case, an array with just one item in it that is not an object.
        // So then we just override the modelValue
        if (args.form.schema && args.form.schema.items && args.form.schema.items.type && args.form.schema.items.type.indexOf('object') === -1 && args.form.schema.items.type.indexOf('array') === -1) {
          state.modelValue = 'modelArray[$index]';
        } else {
          state.modelName = 'item';
        }

        // Flag to the builder that we're in an array.
        // This is needed for compatabiliy if a "old" add-on is used that
        // hasn't been transitioned to the new builder.
        state.arrayCompatFlag = true;

        var childFrag = args.build(args.form.items, args.path + '.items', state);
        items.appendChild(childFrag);
      }
    },
    numeric: function numeric(args) {
      var inputFrag = args.fieldFrag.querySelector('input');
      var maximum = args.form.maximum || false;
      var exclusiveMaximum = args.form.exclusiveMaximum || false;
      var minimum = args.form.minimum || false;
      var exclusiveMinimum = args.form.exclusiveMinimum || false;
      var multipleOf = args.form.multipleOf || false;
      if (inputFrag) {
        if (multipleOf !== false) {
          inputFrag.setAttribute('step', multipleOf);
        };

        if (maximum !== false) {
          if (exclusiveMaximum !== false && multipleOf !== false) {
            maximum = maximum - multipleOf;
          };
          inputFrag.setAttribute('max', maximum);
        };

        if (minimum !== false) {
          if (exclusiveMinimum !== false && multipleOf !== false) {
            minimum = minimum + multipleOf;
          };
          inputFrag.setAttribute('min', minimum);
        };
      };
    }
  };
  this.builders = builders;
  var stdBuilders = [builders.sfField, builders.ngModel, builders.ngModelOptions, builders.condition];
  this.stdBuilders = stdBuilders;

  this.$get = ['$templateCache', 'schemaFormDecorators', 'sfPath', function ($templateCache, schemaFormDecorators, sfPath) {
    var checkForSlot = function checkForSlot(form, slots) {
      // Finally append this field to the frag.
      // Check for slots
      if (form.key) {
        var slot = slots[sfPath.stringify(form.key)];
        if (slot) {
          while (slot.firstChild) {
            slot.removeChild(slot.firstChild);
          }
          return slot;
        }
      }
    };

    var _build = function _build(items, decorator, templateFn, slots, path, state, lookup) {
      state = state || {};
      state = state || {};
      lookup = lookup || Object.create(null);
      path = path || 'schemaForm.form';
      var container = document.createDocumentFragment();
      items.reduce(function (frag, f, index) {
        // Sanity check.
        if (!f.type) {
          return frag;
        }

        var field = decorator[f.type] || decorator['default'];
        if (!field.replace) {
          // Backwards compatability build
          var n = document.createElement(snakeCase(decorator.__name, '-'));
          if (state.arrayCompatFlag) {
            n.setAttribute('form', 'copyWithIndex($index)');
          } else {
            n.setAttribute('form', path + '[' + index + ']');
          }

          (checkForSlot(f, slots) || frag).appendChild(n);
        } else {
          var tmpl = void 0;

          // Reset arrayCompatFlag, it's only valid for direct children of the array.
          state.arrayCompatFlag = false;

          // TODO: Create a couple of testcases, small and large and
          //       measure optmization. A good start is probably a
          //       cache of DOM nodes for a particular template
          //       that can be cloned instead of using innerHTML
          var div = document.createElement('div');
          var template = templateFn(f, field) || templateFn(f, decorator['default']);
          div.innerHTML = template;

          // Move node to a document fragment, we don't want the div.
          tmpl = document.createDocumentFragment();
          while (div.childNodes.length > 0) {
            tmpl.appendChild(div.childNodes[0]);
          }

          // Possible builder, often a noop
          var args = {
            fieldFrag: tmpl,
            form: f,
            lookup: lookup,
            state: state,
            path: path + '[' + index + ']',

            // Recursive build fn
            build: function build(items, path, state) {
              return _build(items, decorator, templateFn, slots, path, state, lookup);
            }

          };

          // Let the form definiton override builders if it wants to.
          var builderFn = f.builder || field.builder;

          // Builders are either a function or a list of functions.
          if (typeof builderFn === 'function') {
            builderFn(args);
          } else {
            builderFn.forEach(function (fn) {
              fn(args);
            });
          }

          // Append
          (checkForSlot(f, slots) || frag).appendChild(tmpl);
        }
        return frag;
      }, container);

      return container;
    };

    return {
      /**
       * Builds a form from a canonical form definition
       */
      build: function build(form, decorator, slots, lookup) {
        return _build(form, decorator, function (form, field) {
          if (form.type === 'template') {
            return form.template;
          }
          return $templateCache.get(field.template);
        }, slots, undefined, undefined, lookup);
      },
      builder: builders,
      stdBuilders: stdBuilders,
      internalBuild: _build
    };
  }];
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_angular___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_angular__);
/* eslint-disable quote-props, no-invalid-this */


/**
 * I am the error message provider
 *
 * @return {object} I return a service provider for error messages
 */
/* harmony default export */ __webpack_exports__["a"] = (function () {
  var self = this;
  // The codes are tv4 error codes.
  // Not all of these can actually happen in a field, but for
  // we never know when one might pop up so it's best to cover them all.

  // TODO: Humanize these.
  var defaultMessages = {
    'default': 'Field does not validate',
    0: 'Invalid type, expected {{schema.type}}',
    1: 'No enum match for: {{viewValue}}',
    10: 'Data does not match any schemas from "anyOf"',
    11: 'Data does not match any schemas from "oneOf"',
    12: 'Data is valid against more than one schema from "oneOf"',
    13: 'Data matches schema from "not"',
    // Numeric errors
    100: 'Value is not a multiple of {{schema.multipleOf}}',
    101: '{{viewValue}} is less than the allowed minimum of {{schema.minimum}}',
    102: '{{viewValue}} is equal to the exclusive minimum {{schema.minimum}}',
    103: '{{viewValue}} is greater than the allowed maximum of {{schema.maximum}}',
    104: '{{viewValue}} is equal to the exclusive maximum {{schema.maximum}}',
    105: 'Value is not a valid number',
    // String errors
    200: 'String is too short ({{viewValue.length}} chars), minimum {{schema.minLength}}',
    201: 'String is too long ({{viewValue.length}} chars), maximum {{schema.maxLength}}',
    202: 'String does not match pattern: {{schema.pattern}}',
    // Object errors
    300: 'Too few properties defined, minimum {{schema.minProperties}}',
    301: 'Too many properties defined, maximum {{schema.maxProperties}}',
    302: 'Required',
    303: 'Additional properties not allowed',
    304: 'Dependency failed - key must exist',
    // Array errors
    400: 'Array is too short ({{value.length}}), minimum {{schema.minItems}}',
    401: 'Array is too long ({{value.length}}), maximum {{schema.maxItems}}',
    402: 'Array items are not unique',
    403: 'Additional items not allowed',
    // Format errors
    500: 'Format validation failed',
    501: 'Keyword failed: "{{title}}"',
    // Schema structure
    600: 'Circular $refs',
    // Non-standard validation options
    1000: 'Unknown property (not in schema)'
  };

  // In some cases we get hit with an angular validation error
  defaultMessages.number = defaultMessages[105];
  defaultMessages.required = defaultMessages[302];
  defaultMessages.min = defaultMessages[101];
  defaultMessages.max = defaultMessages[103];
  defaultMessages.maxlength = defaultMessages[201];
  defaultMessages.minlength = defaultMessages[200];
  defaultMessages.pattern = defaultMessages[202];

  self.setDefaultMessages = function (messages) {
    defaultMessages = messages;
  };

  self.getDefaultMessages = function () {
    return defaultMessages;
  };

  self.setDefaultMessage = function (error, msg) {
    defaultMessages[error] = msg;
  };

  self.$get = ['$interpolate', function ($interpolate) {
    var service = {};
    service.defaultMessages = defaultMessages;

    /**
     * Interpolate and return proper error for an eror code.
     * Validation message on form trumps global error messages.
     * and if the message is a function instead of a string that function will be called instead.
     *
     * @param {string} error the error code, i.e. tv4-xxx for tv4 errors, otherwise it's whats on
     *                       ngModel.$error for custom errors.
     * @param {Any} value the actual model value.
     * @param {Any} viewValue the viewValue
     * @param {Object} form a form definition object for this field
     * @param  {Object} global the global validation messages object (even though its called global
     *                         its actually just shared in one instance of sf-schema)
     * @return {string} The error message.
     */
    service.interpolate = function (error, value, viewValue, form, global) {
      global = global || {};
      var validationMessage = form.validationMessage || {};

      // Drop tv4 prefix so only the code is left.
      if (error.indexOf('tv4-') === 0) {
        error = error.substring(4);
      }

      // First find apropriate message or function
      var message = validationMessage['default'] || global['default'] || '';

      [validationMessage, global, defaultMessages].some(function (val) {
        if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isString(val) || __WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(val)) {
          message = val;
          return true;
        }
        if (val && val[error]) {
          message = val[error];
          return true;
        }
      });

      var context = {
        error: error,
        value: value,
        viewValue: viewValue,
        form: form,
        schema: form.schema,
        title: form.title || form.schema && form.schema.title
      };
      if (__WEBPACK_IMPORTED_MODULE_0_angular___default.a.isFunction(message)) {
        return message(context);
      } else {
        return $interpolate(message)(context);
      }
    };

    return service;
  }];
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/**
 * @class sfPathProviderClass
 */

var sfPathProviderClass = function () {
  /**
   * @method constructor
   */
  function sfPathProviderClass() {
    _classCallCheck(this, sfPathProviderClass);

    this.name = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["sfPath"].name;
    this.parse = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["sfPath"].parse;
    this.stringify = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["sfPath"].stringify;
    this.normalize = __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["sfPath"].normalize;
  }

  /**
   * @method $get
   */


  _createClass(sfPathProviderClass, [{
    key: '$get',
    value: function $get() {
      return __WEBPACK_IMPORTED_MODULE_0_json_schema_form_core__["sfPath"];
    }
  }]);

  return sfPathProviderClass;
}();

/* harmony default export */ __webpack_exports__["a"] = (sfPathProviderClass);

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2), __webpack_require__(17)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(18);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1);
module.exports = __webpack_require__(4);


/***/ })
/******/ ]);
/*!
 * angular-schema-form
 * @version 2.0.9
 * @date Wed, 02 Apr 2025 09:47:07 GMT
 * @link https://github.com/json-schema-form/angular-schema-form
 * @license MIT
 * Copyright (c) 2014-2025 JSON Schema Form
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 20);
/******/ })
/************************************************************************/
/******/ ({

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/*!
 * angular-schema-form-bootstrap
 * @version 1.0.0-alpha.5
 * @date Sat, 29 Apr 2017 14:49:38 GMT
 * @link https://github.com/json-schema-form/angular-schema-form-bootstrap
 * @license MIT
 * Copyright (c) 2014-2017 JSON Schema Form
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.l = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// identity function for calling harmory imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };

/******/ 	// define getter function for harmory exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		Object.defineProperty(exports, name, {
/******/ 			configurable: false,
/******/ 			enumerable: true,
/******/ 			get: getter
/******/ 		});
/******/ 	};

/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};

/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 21);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

__webpack_require__(18);


/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

var path = '/bootstrap/actions.html';
var html = "<div class=\"btn-group schema-form-actions {{::form.htmlClass + ' ' + idClass}}\">\r\n  <input ng-repeat-start=\"item in form.items\"\r\n         type=\"submit\"\r\n         class=\"btn {{ item.style || 'btn-default' }} {{::form.fieldHtmlClass}}\"\r\n         value=\"{{item.title}}\"\r\n         ng-if=\"item.type === 'submit'\">\r\n  <button ng-repeat-end\r\n          class=\"btn {{ item.style || 'btn-default' }} {{::form.fieldHtmlClass}}\"\r\n          type=\"button\"\r\n          ng-disabled=\"form.readonly\"\r\n          ng-if=\"item.type !== 'submit'\"\r\n          ng-click=\"buttonClick($event,item)\"><span ng-if=\"item.icon\" class=\"{{item.icon}}\"></span>{{item.title}}</button>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 3 */
/***/ function(module, exports) {

var path = '/bootstrap/array.html';
var html = "<div  class=\"schema-form-array {{::form.htmlClass + ' ' + idClass}}\"\r\n      sf-field-model=\"sf-new-array\"\r\n      sf-new-array>\r\n  <label class=\"control-label\" ng-show=\"showTitle()\">{{ form.title }}</label>\r\n  <ol class=\"list-group\" sf-field-model ui-sortable=\"form.sortOptions\">\r\n    <li class=\"list-group-item {{::form.fieldHtmlClass}}\"\r\n        sf-field-model=\"ng-repeat\"\r\n        ng-repeat=\"item in $$value$$ track by $id(trackBy(item, $index))\">\r\n      <button ng-hide=\"form.readonly || form.remove === null\"\r\n              ng-click=\"deleteFromArray(item)\"\r\n              ng-disabled=\"form.schema.minItems >= modelArray.length\"\r\n              style=\"position: relative; z-index: 20;\"\r\n              type=\"button\" class=\"close pull-right\">\r\n              <span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span>\r\n      </button>\r\n      <div schema-form-array-items sf-key-controller sf-parent-key=\"[{{form.key.join('][')}}]\" sf-index=\"{{$index}}\"></div>\r\n    </li>\r\n  </ol>\r\n  <div class=\"clearfix\" style=\"padding: 15px;\" ng-model=\"modelArray\" schema-validate=\"form\">\r\n    <div class=\"help-block\"\r\n         ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"\r\n         ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\r\n\r\n    <button ng-hide=\"form.readonly || form.add === null\"\r\n            ng-click=\"appendToArray()\"\r\n            ng-disabled=\"form.schema.maxItems <= modelArray.length\"\r\n            type=\"button\"\r\n            class=\"btn {{ form.style.add || 'btn-default' }} pull-right\">\r\n      <i class=\"glyphicon glyphicon-plus\"></i>\r\n      {{ form.add || 'Add'}}\r\n    </button>\r\n  </div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 4 */
/***/ function(module, exports) {

var path = '/bootstrap/checkbox.html';
var html = "<div class=\"checkbox schema-form-checkbox {{::form.htmlClass + ' ' + idClass}}\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true && hasError(),\r\n       'has-success': form.disableSuccessState !== true && hasSuccess(),\r\n       'has-feedback': form.feedback !== false,\r\n       'required': form.required === true\r\n     }\">\r\n  <label class=\"{{::form.labelHtmlClass}}\">\r\n    <input type=\"checkbox\"\r\n           sf-changed=\"form\"\r\n           ng-disabled=\"form.readonly\"\r\n           sf-field-model\r\n           schema-validate=\"form\"\r\n           class=\"{{::form.fieldHtmlClass}}\"\r\n           name=\"{{::fieldId(true, false)}}\">\r\n    <span ng-bind-html=\"form.title\"></span>\r\n  </label>\r\n  <div class=\"help-block\" sf-message=\"form.description\"></div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 5 */
/***/ function(module, exports) {

var path = '/bootstrap/checkboxes.html';
var html = "<div sf-field-model=\"sf-new-array\"\r\n     sf-new-array\r\n     class=\"form-group schema-form-checkboxes {{::form.htmlClass + ' ' + idClass}}\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true &&  hasError(),\r\n       'has-success': form.disableSuccessState !== true &&  hasSuccess(),\r\n       'required': form.required === true\r\n     }\">\r\n  <label class=\"control-label {{::form.labelHtmlClass}}\"\r\n         sf-field-model\r\n         schema-validate=\"form\"\r\n         ng-show=\"showTitle()\">{{form.title}}</label>\r\n\r\n  <div class=\"checkbox\" ng-repeat=\"val in titleMapValues track by $index\" >\r\n    <label>\r\n      <input type=\"checkbox\"\r\n             ng-disabled=\"form.readonly\"\r\n             sf-changed=\"form\"\r\n             class=\"{{::form.fieldHtmlClass}}\"\r\n             ng-model=\"titleMapValues[$index]\"\r\n             name=\"{{::fieldId(true, false)}}\">\r\n      <span ng-bind-html=\"form.titleMap[$index].name\"></span>\r\n    </label>\r\n\r\n  </div>\r\n  <div class=\"help-block\" sf-message=\"form.description\"></div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 6 */
/***/ function(module, exports) {

var path = '/bootstrap/default.html';
var html = "<div class=\"form-group {{::form.htmlClass + ' schema-form-' + form.type + ' ' + idClass}}\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true && hasError(),\r\n       'has-success': form.disableSuccessState !== true && hasSuccess(),\r\n       'has-feedback': form.feedback !== false,\r\n       'required': form.required === true\r\n     }\">\r\n  <label class=\"control-label {{::form.labelHtmlClass}}\" ng-class=\"{'sr-only': !showTitle()}\" for=\"{{::fieldId(true, false)}}\">{{form.title}}</label>\r\n\r\n  <input ng-if=\"!form.fieldAddonLeft && !form.fieldAddonRight\"\r\n         ng-show=\"::form.key\"\r\n         type=\"{{::form.type}}\"\r\n         step=\"any\"\r\n         sf-changed=\"form\"\r\n         placeholder=\"{{::form.placeholder}}\"\r\n         class=\"form-control {{::form.fieldHtmlClass}}\"\r\n         id=\"{{::fieldId(true, false)}}\"\r\n         sf-field-model\r\n         ng-disabled=\"form.readonly\"\r\n         schema-validate=\"form\"\r\n         name=\"{{::fieldId(true, false)}}\"\r\n         aria-describedby=\"{{::fieldId(true, true) + '-status'}}\">\r\n\r\n  <div ng-if=\"form.fieldAddonLeft || form.fieldAddonRight\"\r\n       ng-class=\"{'input-group': (form.fieldAddonLeft || form.fieldAddonRight)}\">\r\n    <span ng-if=\"form.fieldAddonLeft\"\r\n          class=\"input-group-addon\"\r\n          ng-bind-html=\"form.fieldAddonLeft\"></span>\r\n    <input ng-show=\"::form.key\"\r\n           type=\"{{::form.type}}\"\r\n           step=\"any\"\r\n           sf-changed=\"form\"\r\n           placeholder=\"{{::form.placeholder}}\"\r\n           class=\"form-control {{::form.fieldHtmlClass}}\"\r\n           id=\"{{::fieldId(true, false)}}\"\r\n           sf-field-model\r\n           ng-disabled=\"form.readonly\"\r\n           schema-validate=\"form\"\r\n           name=\"{{::fieldId(true, false)}}\"\r\n           aria-describedby=\"{{::fieldId(true, true) + '-status'}}\">\r\n\r\n    <span ng-if=\"form.fieldAddonRight\"\r\n          class=\"input-group-addon\"\r\n          ng-bind-html=\"form.fieldAddonRight\"></span>\r\n  </div>\r\n\r\n  <span ng-if=\"form.feedback !== false\"\r\n        class=\"form-control-feedback\"\r\n        ng-class=\"evalInScope(form.feedback) || {'glyphicon': true, 'glyphicon-ok': form.disableSuccessState !== true && hasSuccess(), 'glyphicon-remove': form.disableErrorState !== true && hasError() }\"\r\n        aria-hidden=\"true\"></span>\r\n\r\n  <span ng-if=\"hasError() || hasSuccess()\"\r\n        id=\"{{::fieldId(true, true) + '-status'}}\"\r\n        class=\"sr-only\">{{ hasSuccess() ? '(success)' : '(error)' }}</span>\r\n\r\n  <div class=\"help-block\" sf-message=\"form.description\"></div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 7 */
/***/ function(module, exports) {

var path = '/bootstrap/fieldset.html';
var html = "<fieldset ng-disabled=\"form.readonly\" class=\"schema-form-fieldset {{::form.htmlClass + ' ' + idClass}}\">\r\n  <legend ng-class=\"{'sr-only': !showTitle() }\">{{ form.title }}</legend>\r\n  <div class=\"help-block\" ng-show=\"form.description\" ng-bind-html=\"form.description\"></div>\r\n</fieldset>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 8 */
/***/ function(module, exports) {

var path = '/bootstrap/help.html';
var html = "<div class=\"helpvalue schema-form-helpvalue {{::form.htmlClass + ' ' + idClass}}\" ng-bind-html=\"form.helpvalue\"></div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 9 */
/***/ function(module, exports) {

var path = '/bootstrap/radio-buttons.html';
var html = "<div class=\"form-group schema-form-radiobuttons {{::form.htmlClass + ' ' + idClass}}\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true &&  hasError(),\r\n       'has-success': form.disableSuccessState !== true &&  hasSuccess(),\r\n       'required': form.required === true\r\n     }\">\r\n  <div>\r\n    <label class=\"control-label {{::form.labelHtmlClass}}\" ng-show=\"showTitle()\">{{form.title}}</label>\r\n  </div>\r\n  <div class=\"btn-group\">\r\n    <label sf-field-model=\"replaceAll\" class=\"btn {{ (tm.value === $$value$$) ? form.style.selected || 'btn-default' : form.style.unselected || 'btn-default'; }}\"\r\n           ng-class=\"{ active: tm.value === $$value$$ }\"\r\n           ng-repeat=\"tm in form.titleMap\">\r\n      <input type=\"radio\"\r\n             class=\"{{::form.fieldHtmlClass}}\"\r\n             sf-changed=\"form\"\r\n             style=\"display: none;\"\r\n             ng-disabled=\"form.readonly\"\r\n             sf-field-model\r\n             schema-validate=\"form\"\r\n             ng-value=\"tm.value\"\r\n             name=\"{{::fieldId(true, false)}}\">\r\n      <span ng-bind-html=\"tm.name\"></span>\r\n    </label>\r\n  </div>\r\n  <div class=\"help-block\" sf-message=\"form.description\"></div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 10 */
/***/ function(module, exports) {

var path = '/bootstrap/radios-inline.html';
var html = "<div class=\"form-group schema-form-radios-inline {{::form.htmlClass + ' ' + idClass}}\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true &&  hasError(),\r\n       'has-success': form.disableSuccessState !== true && hasSuccess(),\r\n       'required': form.required === true\r\n     }\">\r\n  <label class=\"control-label {{::form.labelHtmlClass}}\"\r\n        ng-show=\"showTitle()\" sf-field-model\r\n        schema-validate=\"form\" >{{form.title}}</label>\r\n  <div>\r\n      <label class=\"radio-inline\" ng-repeat=\"tm in form.titleMap\" >\r\n      <input type=\"radio\"\r\n             class=\"{{::form.fieldHtmlClass}}\"\r\n             sf-changed=\"form\"\r\n             ng-disabled=\"form.readonly\"\r\n             sf-field-model\r\n             ng-value=\"tm.value\"\r\n             name=\"{{::fieldId(true, false)}}\">\r\n      <span ng-bind-html=\"tm.name\"></span>\r\n    </label>\r\n  </div>\r\n  <div class=\"help-block\" sf-message=\"form.description\"></div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 11 */
/***/ function(module, exports) {

var path = '/bootstrap/radios.html';
var html = "<div class=\"form-group schema-form-radios {{::form.htmlClass + ' ' + idClass}}\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true &&  hasError(),\n       'has-success': form.disableSuccessState !== true && hasSuccess(),\r\n       'required': form.required === true\r\n     }\">\r\n  <label class=\"control-label {{::form.labelHtmlClass}}\"\r\n         sf-field-model schema-validate=\"form\"\r\n         ng-show=\"showTitle()\">{{form.title}}</label>\r\n  <div class=\"radio\" ng-repeat=\"tm in form.titleMap\">\r\n    <label>\r\n      <input type=\"radio\"\r\n             class=\"{{::form.fieldHtmlClass}}\"\r\n             sf-changed=\"form\"\r\n             ng-disabled=\"form.readonly\"\r\n             sf-field-model\r\n             ng-value=\"tm.value\"\r\n             name=\"{{::fieldId(true, false)}}\">\r\n      <span ng-bind-html=\"tm.name\"></span>\r\n    </label>\r\n  </div>\r\n  <div class=\"help-block\" sf-message=\"form.description\"></div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 12 */
/***/ function(module, exports) {

var path = '/bootstrap/section.html';
var html = "<div class=\"schema-form-section {{::form.htmlClass + ' ' + idClass}}\" sf-key-controller sf-parent-key=\"[{{form.key.join('][')}}]\" sf-index=\"{{$index}}\"></div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 13 */
/***/ function(module, exports) {

var path = '/bootstrap/select.html';
var html = "<div class=\"form-group {{::form.htmlClass + ' ' + idClass}} schema-form-select\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true && hasError(),\r\n       'has-success': form.disableSuccessState !== true && hasSuccess(),\r\n       'has-feedback': form.feedback !== false,\r\n       'required': form.required === true\r\n     }\">\r\n  <label class=\"control-label {{::form.labelHtmlClass}}\" ng-show=\"showTitle()\" for=\"{{::fieldId(true, false)}}\">\r\n    {{form.title}}\r\n  </label>\r\n  <select sf-field-model\r\n          id=\"{{::fieldId(true, false)}}\"\r\n          ng-disabled=\"form.readonly\"\r\n          sf-changed=\"form\"\r\n          class=\"form-control {{::form.fieldHtmlClass}}\"\r\n          schema-validate=\"form\"\r\n          ng-options=\"item.value as item.name group by item.group for item in form.titleMap\"\r\n          name=\"{{::fieldId(true, false)}}\">\r\n  </select>\r\n  <div class=\"help-block\" sf-message=\"form.description\"></div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 14 */
/***/ function(module, exports) {

var path = '/bootstrap/submit.html';
var html = "<div class=\"form-group schema-form-submit {{::form.htmlClass + ' ' + idClass}}\">\r\n  <input type=\"submit\"\r\n         class=\"btn {{ form.style || 'btn-primary' }} {{::form.fieldHtmlClass}}\"\r\n         value=\"{{form.title}}\"\r\n         ng-disabled=\"form.readonly\"\r\n         ng-if=\"form.type === 'submit'\">\r\n  <button class=\"btn {{ form.style || 'btn-default' }}\"\r\n          type=\"button\"\r\n          ng-click=\"buttonClick($event,form)\"\r\n          ng-disabled=\"form.readonly\"\r\n          ng-if=\"form.type !== 'submit'\">\r\n      <span ng-if=\"form.icon\" class=\"{{form.icon}}\"></span>\r\n      {{form.title}}\r\n  </button>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 15 */
/***/ function(module, exports) {

var path = '/bootstrap/tabarray.html';
var html = "<div ng-init=\"selected = { tab: 0 }\"\r\n     ng-model=\"modelArray\" schema-validate=\"form\"\r\n     sf-field-model=\"sf-new-array\"\r\n     sf-new-array\r\n     class=\"clearfix schema-form-tabarray schema-form-tabarray-{{form.tabType || 'left'}} {{::form.htmlClass + ' ' + idClass}}\">\r\n  <div ng-if=\"!form.tabType || form.tabType !== 'right'\"\r\n       ng-class=\"{'col-xs-3': !form.tabType || form.tabType === 'left'}\">\r\n    <ol class=\"nav nav-tabs\"\r\n        ng-class=\"{ 'tabs-left': !form.tabType || form.tabType === 'left'}\"\r\n        sf-field-model ui-sortable=\"form.sortOptions\">\r\n      <li sf-field-model=\"ng-repeat\"\r\n          ng-repeat=\"item in $$value$$ track by $index\"\r\n          ng-click=\"$event.preventDefault() || (selected.tab = $index)\"\r\n          ng-class=\"{active: selected.tab === $index}\">\r\n          <a href=\"#\">{{interp(form.title,{'$index':$index, value: item}) || $index}}</a>\r\n      </li>\r\n      <li ng-hide=\"form.readonly || form.add === null\"\r\n          ng-disabled=\"form.schema.maxItems <= modelArray.length\"\r\n          ng-click=\"$event.preventDefault() || (selected.tab = appendToArray().length - 1)\">\r\n        <a href=\"#\">\r\n          <i class=\"glyphicon glyphicon-plus\"></i>\r\n          {{ form.add || 'Add'}}\r\n          </a>\r\n      </li>\r\n    </ol>\r\n  </div>\r\n\r\n  <div ng-class=\"{'col-xs-9': !form.tabType || form.tabType === 'left' || form.tabType === 'right'}\">\r\n    <div class=\"tab-content {{::form.fieldHtmlClass}}\">\r\n      <div class=\"tab-pane clearfix tab{{selected.tab}} index{{$index}}\"\r\n           sf-field-model=\"ng-repeat\"\r\n           ng-repeat=\"item in $$value$$ track by $index\"\r\n           ng-show=\"selected.tab === $index\"\r\n           ng-class=\"{active: selected.tab === $index}\">\r\n\r\n           <div schema-form-array-items sf-key-controller sf-parent-key=\"[{{form.key.join('][')}}]\" sf-index=\"{{$index}}\"></div>\r\n\r\n           <button ng-hide=\"form.readonly || form.remove === null\"\r\n                   ng-click=\"selected.tab = deleteFromArray($index).length - 1\"\r\n                   ng-disabled=\"form.schema.minItems >= modelArray.length\"\r\n                   type=\"button\"\r\n                   class=\"btn {{ form.style.remove || 'btn-default' }} pull-right\">\r\n             <i class=\"glyphicon glyphicon-trash\"></i>\r\n             {{ form.remove || 'Remove'}}\r\n           </button>\r\n      </div>\r\n      <div class=\"help-block\"\r\n           ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\"\r\n           ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <div ng-if=\"form.tabType === 'right'\" class=\"col-xs-3\">\r\n    <ul class=\"nav nav-tabs tabs-right\">\r\n      <li  sf-field-model=\"ng-repeat\"\r\n          ng-repeat=\"item in $$value$$ track by $index\"\r\n          ng-click=\"$event.preventDefault() || (selected.tab = $index)\"\r\n          ng-class=\"{active: selected.tab === $index}\">\r\n          <a href=\"#\">{{interp(form.title,{'$index':$index, value: item}) || $index}}</a>\r\n      </li>\r\n      <li ng-hide=\"form.readonly || form.add === null\"\r\n          ng-disabled=\"form.schema.maxItems <= modelArray.length\"\r\n          ng-click=\"$event.preventDefault() || (selected.tab = appendToArray().length - 1)\">\r\n        <a href=\"#\">\r\n          <i class=\"glyphicon glyphicon-plus\"></i>\r\n          {{ form.add || 'Add'}}\r\n          </a>\r\n      </li>\r\n    </ul>\r\n  </div>\r\n\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 16 */
/***/ function(module, exports) {

var path = '/bootstrap/tabs.html';
var html = "<div ng-init=\"selected = { tab: 0 }\" class=\"schema-form-tabs {{::form.htmlClass + ' ' + idClass}}\">\r\n  <ul class=\"nav nav-tabs\">\r\n    <li ng-repeat=\"tab in form.tabs\"\r\n        ng-disabled=\"form.readonly\"\r\n        ng-click=\"$event.preventDefault() || (selected.tab = $index)\"\r\n        ng-class=\"{active: selected.tab === $index}\">\r\n        <a href=\"#\">{{ tab.title }}</a>\r\n    </li>\r\n  </ul>\r\n\r\n  <div class=\"tab-content {{::form.fieldHtmlClass}}\">\r\n  </div>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 17 */
/***/ function(module, exports) {

var path = '/bootstrap/textarea.html';
var html = "<div class=\"form-group has-feedback {{::form.htmlClass + ' ' + idClass}} schema-form-textarea\"\r\n     ng-class=\"{\r\n       'has-error': form.disableErrorState !== true && hasError(),\r\n       'has-success': form.disableSuccessState !== true && hasSuccess(),\r\n       'has-feedback': form.feedback !== false,\r\n       'required': form.required === true\r\n     }\">\r\n  <label class=\"control-label {{::form.labelHtmlClass}}\" ng-class=\"{'sr-only': !showTitle()}\" for=\"{{::fieldId(true, false)}}\">{{form.title}}</label>\r\n\r\n  <textarea ng-if=\"!form.fieldAddonLeft && !form.fieldAddonRight\"\r\n            class=\"form-control {{::form.fieldHtmlClass}}\"\r\n            id=\"{{::fieldId(true, false)}}\"\r\n            sf-changed=\"form\"\r\n            ng-attr-placeholder=\"{{::form.placeholder}}\"\r\n            ng-disabled=\"form.readonly\"\r\n            sf-field-model\r\n            schema-validate=\"form\"\r\n            name=\"{{::fieldId(true, false)}}\"></textarea>\r\n\r\n  <div ng-if=\"form.fieldAddonLeft || form.fieldAddonRight\"\r\n       ng-class=\"{'input-group': (form.fieldAddonLeft || form.fieldAddonRight)}\">\r\n    <span ng-if=\"form.fieldAddonLeft\"\r\n          class=\"input-group-addon\"\r\n          ng-bind-html=\"form.fieldAddonLeft\"></span>\r\n    <textarea class=\"form-control {{::form.fieldHtmlClass}}\"\r\n              id=\"{{::fieldId(true, false)}}\"\r\n              sf-changed=\"form\"\r\n              ng-attr-placeholder=\"{{::form.placeholder}}\"\r\n              ng-disabled=\"form.readonly\"\r\n              sf-field-model\r\n              schema-validate=\"form\"\r\n              name=\"{{::fieldId(true, false)}}\"></textarea>\r\n    <span ng-if=\"form.fieldAddonRight\"\r\n          class=\"input-group-addon\"\r\n          ng-bind-html=\"form.fieldAddonRight\"></span>\r\n  </div>\r\n\r\n  <span class=\"help-block\" sf-message=\"form.description\"></span>\r\n</div>\r\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrap_actions_html__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrap_actions_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__bootstrap_actions_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_array_html__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bootstrap_array_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__bootstrap_array_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_checkbox_html__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bootstrap_checkbox_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__bootstrap_checkbox_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_checkboxes_html__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bootstrap_checkboxes_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__bootstrap_checkboxes_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_default_html__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bootstrap_default_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__bootstrap_default_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_fieldset_html__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__bootstrap_fieldset_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__bootstrap_fieldset_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_help_html__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__bootstrap_help_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__bootstrap_help_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_radio_buttons_html__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__bootstrap_radio_buttons_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__bootstrap_radio_buttons_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bootstrap_radios_html__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bootstrap_radios_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__bootstrap_radios_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bootstrap_radios_inline_html__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__bootstrap_radios_inline_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__bootstrap_radios_inline_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bootstrap_section_html__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bootstrap_section_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__bootstrap_section_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bootstrap_select_html__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bootstrap_select_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__bootstrap_select_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bootstrap_submit_html__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__bootstrap_submit_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__bootstrap_submit_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bootstrap_tabarray_html__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__bootstrap_tabarray_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__bootstrap_tabarray_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__bootstrap_tabs_html__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__bootstrap_tabs_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__bootstrap_tabs_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__bootstrap_textarea_html__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__bootstrap_textarea_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__bootstrap_textarea_html__);
// ngtemplate-loader embeds the html on build

















angular
  .module('schemaForm')
  .config(bootstrapDecoratorConfig);

bootstrapDecoratorConfig.$inject = [
  'schemaFormProvider', 'schemaFormDecoratorsProvider', 'sfBuilderProvider', 'sfPathProvider', '$injector'
];

function bootstrapDecoratorConfig(
    schemaFormProvider, decoratorsProvider, sfBuilderProvider, sfPathProvider, $injector) {
  var base = 'decorators/bootstrap/';

  var simpleTransclusion  = sfBuilderProvider.builders.simpleTransclusion;
  var ngModelOptions      = sfBuilderProvider.builders.ngModelOptions;
  var ngModel             = sfBuilderProvider.builders.ngModel;
  var sfField             = sfBuilderProvider.builders.sfField;
  var condition           = sfBuilderProvider.builders.condition;
  var array               = sfBuilderProvider.builders.array;
  var numeric             = sfBuilderProvider.builders.numeric;

  // Tabs is so bootstrap specific that it stays here.
  var tabs = function(args) {
    if (args.form.tabs && args.form.tabs.length > 0) {
      var tabContent = args.fieldFrag.querySelector('.tab-content');

      args.form.tabs.forEach(function(tab, index) {
        var evalExpr = '(evalExpr(' + args.path + '.tabs[' + index + ']' +
                       '.condition, { model: model, "arrayIndex": $index}))';
        var div = document.createElement('div');
        div.className = 'tab-pane';
        div.setAttribute('ng-disabled', 'form.readonly');
        div.setAttribute('ng-show', 'selected.tab === ' + index);
        div.setAttribute('ng-class', '{active: selected.tab === ' + index + '}');
        if(!!tab.condition) {
          div.setAttribute('ng-if', evalExpr);
        };

        var childFrag = args.build(tab.items, args.path + '.tabs[' + index + '].items', args.state);
        div.appendChild(childFrag);
        tabContent.appendChild(div);
      });
    }
  };

  var selectPlaceholder = function(args) {
    if (args.form.placeholder) {
      var selectBox = args.fieldFrag.querySelector('select');
      var option = document.createElement('option');
      option.setAttribute('value', '');

      /* We only want the placeholder to show when we do not have a value on the model.
       * We make ngModel builder replace all so we can use $$value$$.
       */
      option.setAttribute('sf-field-model', 'replaceAll');

      /* https://github.com/angular/angular.js/issues/12190#issuecomment-115277040
       * angular > 1.4 does a emptyOption.attr('selected', true)
       * which does not like the ng-if comment.
       */
      if (angular.version.major === 1 && angular.version.minor < 4) {
        option.setAttribute('ng-if', '$$value$$ === undefined');
      } else {
        option.setAttribute('ng-show', '$$value$$ === undefined');
      }

      option.textContent = args.form.placeholder;

      selectBox.appendChild(option);
    }
  };

  var defaults = [sfField, ngModel, ngModelOptions, condition];
  decoratorsProvider.defineDecorator('bootstrapDecorator', {
    actions: {template: __WEBPACK_IMPORTED_MODULE_0__bootstrap_actions_html___default.a, builder: defaults},
    array: {template: __WEBPACK_IMPORTED_MODULE_1__bootstrap_array_html___default.a, builder: [ sfField, ngModelOptions, ngModel, array, condition ]},
    button: {template: __WEBPACK_IMPORTED_MODULE_12__bootstrap_submit_html___default.a, builder: defaults},
    checkbox: {template: __WEBPACK_IMPORTED_MODULE_2__bootstrap_checkbox_html___default.a, builder: defaults},
    checkboxes: {template: __WEBPACK_IMPORTED_MODULE_3__bootstrap_checkboxes_html___default.a, builder: [ sfField, ngModelOptions, ngModel, array, condition ]},
    conditional: {template: __WEBPACK_IMPORTED_MODULE_10__bootstrap_section_html___default.a, builder: [ sfField, simpleTransclusion, condition ]},
    'default': {template: __WEBPACK_IMPORTED_MODULE_4__bootstrap_default_html___default.a, builder: defaults},
    fieldset: {template: __WEBPACK_IMPORTED_MODULE_5__bootstrap_fieldset_html___default.a, builder: [ sfField, simpleTransclusion, condition ]},
    help: {template: __WEBPACK_IMPORTED_MODULE_6__bootstrap_help_html___default.a, builder: defaults},
    number: {template: __WEBPACK_IMPORTED_MODULE_4__bootstrap_default_html___default.a, builder: defaults.concat(numeric)},
    password: {template: __WEBPACK_IMPORTED_MODULE_4__bootstrap_default_html___default.a, builder: defaults},
    radios: {template: __WEBPACK_IMPORTED_MODULE_8__bootstrap_radios_html___default.a, builder: defaults},
    'radios-inline': {template: __WEBPACK_IMPORTED_MODULE_9__bootstrap_radios_inline_html___default.a, builder: defaults},
    radiobuttons: {template: __WEBPACK_IMPORTED_MODULE_7__bootstrap_radio_buttons_html___default.a, builder: defaults},
    section: {template: __WEBPACK_IMPORTED_MODULE_10__bootstrap_section_html___default.a, builder: [ sfField, simpleTransclusion, condition ]},
    select: {template: __WEBPACK_IMPORTED_MODULE_11__bootstrap_select_html___default.a, builder: [ selectPlaceholder ].concat(defaults)},
    submit: {template: __WEBPACK_IMPORTED_MODULE_12__bootstrap_submit_html___default.a, builder: defaults},
    tabarray: {template: __WEBPACK_IMPORTED_MODULE_13__bootstrap_tabarray_html___default.a, builder: [ sfField, ngModelOptions, ngModel, array, condition ]},
    tabs: {template: __WEBPACK_IMPORTED_MODULE_14__bootstrap_tabs_html___default.a, builder: [ sfField, ngModelOptions, tabs, condition ]},
    textarea: {template: __WEBPACK_IMPORTED_MODULE_15__bootstrap_textarea_html___default.a, builder: defaults},
  }, []);
};


/***/ },
/* 19 */,
/* 20 */,
/* 21 */
/***/ function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ }
/******/ ]);

/***/ })

/******/ });
'use strict';
angular.module('angular-timeline', []);// Source: src/timeline-badge-directive.js
/**
 * @ngdoc directive
 * @name angular-timeline.directive:timeline-badge
 * @restrict AE
 *
 * @description
 * Shown in the centre pane (or left on narrow devices) to indicate the activity.
 */
angular.module('angular-timeline').directive('timelineBadge', function() {
  return {
    require: '^timelineEvent',
    restrict: 'AE',
    transclude: true,
    template: '<div class="timeline-badge" ng-transclude></div>'
  };
});

// Source: src/timeline-directive.js
/**
 * @ngdoc directive
 * @name angular-timeline
 * @restrict AE
 *
 * @description
 * Primary container for displaying a vertical set of timeline events.
 */
angular.module('angular-timeline').directive('timeline', function() {
  return {
    restrict: 'AE',
    transclude: true,
    template: '<ul class="timeline" ng-transclude></ul>',
    controller: function() {}
  };
});

// Source: src/timeline-event-directive.js
/**
 * @ngdoc directive
 * @name angular-timeline.directive:timeline
 * @restrict AE
 *
 * @description
 * Represents an event occuring at a point in time, displayed on the left or the right
 * of the timeline line.
 *
 * You typically embed a `timeline-badge` and `timeline-panel` element within a `timeline-event`.
 *
 * @param {string=} side  Define the side of the element (i.e. side="left", side="right", or use an {{ expression }}).
 */

angular.module('angular-timeline').directive('timelineEvent', function() {
  return {
    require: '^timeline',
    restrict: 'AE',
    transclude: true,
    template: '<li class="timeline-event" ng-class-odd="oddClass" ng-class-even="evenClass" ng-transclude></li>',
    link: function(scope, element, attrs, controller) {

      var checkClass = function(side, leftSide) {

        var leftClass = '';
        var rightClass = 'timeline-inverted';

        if (side === 'left' || (!side && leftSide === true)) {
          return leftClass;
        }
        else if ((side === 'alternate' || !side) && leftSide === false) {
          return rightClass;
        }
        else if (side === 'right') {
          return rightClass;
        }
        else {
          return leftClass;
        }
      };

      var updateRowClasses = function(value) {
        scope.oddClass = checkClass(value, true);
        scope.evenClass = checkClass(value, false);
      };

      attrs.$observe('side', function(newValue) {
        updateRowClasses(newValue);
      });

      updateRowClasses(attrs.side);
    }
  };
});

// Source: src/timeline-footer-directive.js
/**
 * @ngdoc directive
 * @name angular-timeline.directive:timeline-footer
 * @restrict AE
 *
 * @description
 * Optional element to add a footer section to the `timeline-panel` for links or other actions.
 */
angular.module('angular-timeline').directive('timelineFooter', function() {
  return {
    require: '^timelinePanel',
    restrict: 'AE',
    transclude: true,
    template: '<div class="timeline-footer" ng-transclude></div>'
  };
});

// Source: src/timeline-heading-directive.js
/**
 * @ngdoc directive
 * @name angular-timeline.directive:timeline-heading
 * @restrict AE
 *
 * @description
 * Optional element to show the heading for a `timeline-panel`.
 */
angular.module('angular-timeline').directive('timelineHeading', function() {
  return {
    require: '^timelinePanel',
    restrict: 'AE',
    transclude: true,
    template: '<div class="timeline-heading" ng-transclude></div>'
  };
});

// Source: src/timeline-panel-directive.js
/**
 * @ngdoc directive
 * @name angular-timeline.directive:timeline-panel
 * @restrict AE
 *
 * @description
 * An panel inside the `timeline-event` which shows detailed information about the event.
 */
angular.module('angular-timeline').directive('timelinePanel', function() {
  return {
    require: '^timeline',
    restrict: 'AE',
    transclude: true,
    template: '<div class="timeline-panel" ng-transclude></div>'
  };
});

'use strict';

angular.module('ui.keypress',[]).
factory('keypressHelper', ['$parse', function keypress($parse){
  var keysByCode = {
    8: 'backspace',
    9: 'tab',
    13: 'enter',
    27: 'esc',
    32: 'space',
    33: 'pageup',
    34: 'pagedown',
    35: 'end',
    36: 'home',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down',
    45: 'insert',
    46: 'delete'
  };

  var capitaliseFirstLetter = function (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return function(mode, scope, elm, attrs) {
    var params, combinations = [];
    params = scope.$eval(attrs['ui'+capitaliseFirstLetter(mode)]);

    // Prepare combinations for simple checking
    angular.forEach(params, function (v, k) {
      var combination, expression;
      expression = $parse(v);

      angular.forEach(k.split(' '), function(variation) {
        combination = {
          expression: expression,
          keys: {}
        };
        angular.forEach(variation.split('-'), function (value) {
          combination.keys[value] = true;
        });
        combinations.push(combination);
      });
    });

    // Check only matching of pressed keys one of the conditions
    elm.bind(mode, function (event) {
      // No need to do that inside the cycle
      var metaPressed = !!(event.metaKey && !event.ctrlKey);
      var altPressed = !!event.altKey;
      var ctrlPressed = !!event.ctrlKey;
      var shiftPressed = !!event.shiftKey;
      var keyCode = event.keyCode;

      // normalize keycodes
      if (mode === 'keypress' && !shiftPressed && keyCode >= 97 && keyCode <= 122) {
        keyCode = keyCode - 32;
      }

      // Iterate over prepared combinations
      angular.forEach(combinations, function (combination) {

        var mainKeyPressed = combination.keys[keysByCode[keyCode]] || combination.keys[keyCode.toString()];

        var metaRequired = !!combination.keys.meta;
        var altRequired = !!combination.keys.alt;
        var ctrlRequired = !!combination.keys.ctrl;
        var shiftRequired = !!combination.keys.shift;

        if (
          mainKeyPressed &&
          ( metaRequired === metaPressed ) &&
          ( altRequired === altPressed ) &&
          ( ctrlRequired === ctrlPressed ) &&
          ( shiftRequired === shiftPressed )
        ) {
          // Run the function
          scope.$apply(function () {
            combination.expression(scope, { '$event': event });
          });
        }
      });
    });
  };
}]);

/**
 * Bind one or more handlers to particular keys or their combination
 * @param hash {mixed} keyBindings Can be an object or string where keybinding expression of keys or keys combinations and AngularJS Exspressions are set. Object syntax: "{ keys1: expression1 [, keys2: expression2 [ , ... ]]}". String syntax: ""expression1 on keys1 [ and expression2 on keys2 [ and ... ]]"". Expression is an AngularJS Expression, and key(s) are dash-separated combinations of keys and modifiers (one or many, if any. Order does not matter). Supported modifiers are 'ctrl', 'shift', 'alt' and key can be used either via its keyCode (13 for Return) or name. Named keys are 'backspace', 'tab', 'enter', 'esc', 'space', 'pageup', 'pagedown', 'end', 'home', 'left', 'up', 'right', 'down', 'insert', 'delete'.
 * @example <input ui-keypress="{enter:'x = 1', 'ctrl-shift-space':'foo()', 'shift-13':'bar()'}" /> <input ui-keypress="foo = 2 on ctrl-13 and bar('hello') on shift-esc" />
 **/
angular.module('ui.keypress').directive('uiKeydown', ['keypressHelper', function(keypressHelper){
  return {
    link: function (scope, elm, attrs) {
      keypressHelper('keydown', scope, elm, attrs);
    }
  };
}]);

angular.module('ui.keypress').directive('uiKeypress', ['keypressHelper', function(keypressHelper){
  return {
    link: function (scope, elm, attrs) {
      keypressHelper('keypress', scope, elm, attrs);
    }
  };
}]);

angular.module('ui.keypress').directive('uiKeyup', ['keypressHelper', function(keypressHelper){
  return {
    link: function (scope, elm, attrs) {
      keypressHelper('keyup', scope, elm, attrs);
    }
  };
}]);

!function(){"use strict";angular.module("zxcvbn",[]).directive("zxcvbn",function(){return{scope:{password:"=",extras:"=?",data:"=?"},restrict:"E",template:"{{ display.crack_times_display }}",link:function(r,a,t){r.$watch("password",function(a){angular.isString(a)&&(r.extras?r.timeToCrack=zxcvbn(a,r.extras):r.timeToCrack=zxcvbn(a),"data"in t&&r.timeToCrack&&(r.data=angular.copy(r.timeToCrack)),r.display=angular.copy(r.timeToCrack))})}}})}(),function(){"use strict";angular.module("zxcvbn").directive("zxcvbn",function(){return{require:"ngModel",restrict:"A",scope:{zxResult:"=?zxcvbn",zxExtras:"=?",zxMinScore:"@?"},link:function(r,a,t,e){r.runZxcvbn=function(){angular.isUndefined(r.zxPassword)&&(r.zxPassword=""),angular.isDefined(r.zxExtrasArray)&&r.zxExtrasArray.length>0?r.zxResult=zxcvbn(r.zxPassword,r.zxExtrasArray):r.zxResult=zxcvbn(r.zxPassword)},r.isForm=function(r){try{return"FormController"===Object.getPrototypeOf(r).constructor.name}catch(a){return!1}},r.setZxExtrasWatcher=function(){var a=r.zxExtras;angular.isFunction(r.zxExtrasWatcher)&&r.zxExtrasWatcher(),r.zxExtrasWatcher=void 0,angular.isDefined(a)&&(angular.isArray(a)?r.zxArrayWatcher():r.isForm(a)&&r.zxFormWatcher())},r.zxFormWatcher=function(){var a=r.zxExtras;console.assert(r.isForm(a),"zx-extras element is some how not a form."),r.zxExtrasWatcher=r.$watch(function(){var r=[],t=new RegExp("^(?!\\$|__)");for(var e in a)t.test(e)&&a[e].hasOwnProperty("$viewValue")&&-1===e.toLowerCase().indexOf("password")&&r.push(a[e].$viewValue);return r},function(a){r.zxExtrasArray=[];for(var t=0;t<a.length;t++)angular.isString(a[t])&&r.zxExtrasArray.push(a[t]);e.$validate()},!0)},r.zxArrayWatcher=function(){r.zxExtrasWatcher=r.$watch("zxExtras",function(a){r.zxExtrasArray=a,e.$validate()},!0)},r.setZxExtrasWatcher(),e.$validators.passwordStrength=function(a){var t=parseInt(r.zxMinScore);return t=isNaN(t)||0>t||t>4?0:t,r.zxPassword=a,r.runZxcvbn(),t<=r.zxResult.score},t.$observe("zxExtras",function(){r.setZxExtrasWatcher(),e.$validate()}),t.$observe("zxMinScore",function(a){r.zxMinScore=a,e.$validate()})}}})}();
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));

!function(e,n){if("object"==typeof exports&&"object"==typeof module)module.exports=n(require("_"),require("moment"));else if("function"==typeof define&&define.amd)define(["_","moment"],n);else{var r="object"==typeof exports?n(require("_"),require("moment")):n(e._,e.moment);for(var t in r)("object"==typeof exports?exports:e)[t]=r[t]}}(self,(function(e,n){return function(){"use strict";var r={10183:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(48845),i=r(66394),o=r(63566),s=new t.NumberUtilsService;function l(e,n){return e>n}n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var u=(0,a.getConstants)(),c={},d={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var p=(0,i.getIncome)(e,r,u);d=Object.assign(d,p);var g=u.fullCostCapitalLimit[r],f=l(p.totalCapital||0,g),m=(p.additionalPropertyEquity||0)>0;if(f||m){var v=(u.maxContribution||{})[r];return{contributions:s.isNumeric(v)?{maxContribution:v}:{},workings:d,isMaxCost:!0}}var h=(0,i.getDisregards)(e,r,u,d);d=Object.assign(d,h);var y=(0,o.getExpenses)(e,r);d=Object.assign(d,y);var P=(0,i.getDREs)(e,r,u,d);d=Object.assign(d,P),c=Object.assign(c,{expensesAboveMaxThreshold:(0,i.getExpensesAboveThreshold)(e,r,u,d)});var C=(0,i.getAllowances)(e,r,u,d);d=Object.assign(d,C);var w=(0,i.getPartnerTransfer)(e,r,u,d);if(l((d=Object.assign(d,w)).partnerTotalCapital||0,g)&&(0,i.isPartnerApplyingForCare)(e)){v=(u.maxContribution||{})[r];return{contributions:s.isNumeric(v)?{maxContribution:v}:{},workings:d}}}else c=Object.assign(c,{fullCost:!0});for(var I in d)if(Object.prototype.hasOwnProperty.call(d,I)){var O=d[I]||0;d[I]=s.roundNearest(O)}return(0,i.getCostOfCare)(e,r,u,d,c)}},23964:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",respite:"respite",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},warPensionDisregard:0,warSpecialPaymentDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},constantAttendanceAllowance:{exceptional:{amount:0},intermediate:{amount:0},normal:{amount:0},partTime:{amount:0}},fullCostCapitalLimit:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,maxContribution:{nonResidential:Number.POSITIVE_INFINITY,respite:Number.POSITIVE_INFINITY,week1Residential:Number.POSITIVE_INFINITY,week5Residential:Number.POSITIVE_INFINITY,week13Residential:Number.POSITIVE_INFINITY},waiveContributionThreshold:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:Number.POSITIVE_INFINITY,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:Number.POSITIVE_INFINITY,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},childPremium:0,carersPremium:0,configuration:{calculatorConfig:{weeksPerYear:52}},waterCostsPerCohabitant:[],tariffBasedHeatingCosts:[{tariffDate:"previousYear",applicant:{flat:0,terraced:0,semiDetached:0,detached:0},eachExtraPerson:{flat:0,terraced:0,semiDetached:0,detached:0}},{tariffDate:"currentYear",applicant:{flat:0,terraced:0,semiDetached:0,detached:0},eachExtraPerson:{flat:0,terraced:0,semiDetached:0,detached:0}}],washingExcessPremium:0,dreCaps:{domesticHelp:0,holidayCarer:0,poweredBed:0,bedTurning:0,stairLift:0,hoistPurchase:0,manualWheelchairPurchase:0,poweredWheelchairPurchase:0,poweredRecliningChair:0}}},48845:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.constants=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(23964);Object.defineProperty(n,"constants",{enumerable:!0,get:function(){return a.constants}});var i=r(834);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(22960);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},834:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,warSpecialPaymentDisregard:111.74,maxDREAllowance:14.61,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},constantAttendanceAllowance:{exceptional:180.4,intermediate:135.3,normal:90.2,partTime:45.1},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,maxContribution:{nonResidential:597,respite:Number.POSITIVE_INFINITY,week1Residential:Number.POSITIVE_INFINITY,week5Residential:Number.POSITIVE_INFINITY,week13Residential:Number.POSITIVE_INFINITY},waiveContributionThreshold:{nonResidential:1,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},loneParentUser:{under25:{base:112.5,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,DISREGARD_MAX:10.6}},childPremium:102.95,carersPremium:53.25,waterCostsPerCohabitant:[6.34,9.25,12.14,15.03,16.49],washingExcessPremium:4.86,tariffBasedHeatingCosts:[{tariffDate:"previousYear",applicant:{flat:40.85,terraced:40.85,semiDetached:43.38,detached:52.78},eachExtraPerson:{flat:13.05,terraced:13.05,semiDetached:13.89,detached:16.8}},{tariffDate:"currentYear",applicant:{flat:37.98,terraced:37.98,semiDetached:40.34,detached:49.08},eachExtraPerson:{flat:12.13,terraced:12.13,semiDetached:12.92,detached:15.62}}],dreCaps:{domesticHelp:72.84,holidayCarer:18.29,poweredBed:5.6,bedTurning:9.8,stairLift:7.91,hoistPurchase:3.89,manualWheelchairPurchase:5.07,poweredWheelchairPurchase:12.31,poweredRecliningChair:4.44}}},22960:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,warSpecialPaymentDisregard:111.74,maxDREAllowance:14.61,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},constantAttendanceAllowance:{exceptional:177.4,intermediate:133.05,normal:88.7,partTime:44.35},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,maxContribution:{nonResidential:597,respite:Number.POSITIVE_INFINITY,week1Residential:Number.POSITIVE_INFINITY,week5Residential:Number.POSITIVE_INFINITY,week13Residential:Number.POSITIVE_INFINITY},waiveContributionThreshold:{nonResidential:1,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},loneParentUser:{under25:{base:110.6,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:34.8,edp:17.15},over25:{base:86.85,dp:34.8,edp:17.15},pensionAge:{base:174.6,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:301.22,INCOME_HIGH:332.95,DISREGARD_MAX:10.4}},childPremium:101.25,carersPremium:52.35,waterCostsPerCohabitant:[6.34,9.25,12.14,15.03,16.49],washingExcessPremium:4.74,tariffBasedHeatingCosts:[{tariffDate:"previousYear",applicant:{flat:53.11,terraced:53.11,semiDetached:56.41,detached:68.63},eachExtraPerson:{flat:16.96,terraced:16.96,semiDetached:18.06,detached:21.84}},{tariffDate:"currentYear",applicant:{flat:40.85,terraced:40.85,semiDetached:43.38,detached:52.78},eachExtraPerson:{flat:13.04,terraced:13.04,semiDetached:13.89,detached:16.8}}],dreCaps:{domesticHelp:68.73,holidayCarer:17.83,poweredBed:5.46,bedTurning:9.55,stairLift:7.71,hoistPurchase:3.79,manualWheelchairPurchase:4.94,poweredWheelchairPurchase:12,poweredRecliningChair:4.33}}},96810:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.share=n.ratio=n.full=void 0;var t=new(r(32954).NumberUtilsService);function a(e){return t.roundUp(e)}n.full=function(e){return a(e.amount)},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,a(r))}},n.share=function(e){var n=e.amount,r=e.numberOfPeopleOnTheContract,t=void 0===r?1:r,i=n*(t>1?100/t:100)/100;return Math.max(0,a(i))}},63566:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerExpenses=n.getExpenses=n.getPartnerArrangement=void 0;var t=r(91569),a=r(48845),i=r(94492);n.getPartnerArrangement=function(e){var n=e.hasPartner,r=e.partnerCohabits,t=e.numberOfPeopleOnTheContract;return n?r?"cohabitingPartner":"nonCohabitingPartner":t>1?"cohabitingWithOther":"single"},n.getExpenses=function(e,r){var o=(0,a.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,i.housingExpenses,{getPartnerArrangement:n.getPartnerArrangement})},n.getPartnerExpenses=function(e,r){var o=(0,a.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,i.partnerHousingExpenses,{getPartnerArrangement:n.getPartnerArrangement})}},94492:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerHousingExpenses=n.housingExpenses=void 0;var t=r(73185),a=r(96810);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],personalAlarm:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],personalAlarm:[a.full]},ownedByPartner:{serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},ownedByOther:{rentLessHousing:[a.full],rent:[a.full],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]}},cohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],personalAlarm:[(0,a.ratio)(50)]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],personalAlarm:[(0,a.ratio)(50)]},ownedByPartner:{serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],personalAlarm:[(0,a.ratio)(50)]},tenant:{rent:[(0,a.ratio)(50)],rentLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],personalAlarm:[(0,a.ratio)(50)]},ownedByOther:{rent:[(0,a.ratio)(50)],rentLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],personalAlarm:[(0,a.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},ownedByPartner:{serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},ownedByOther:{rentLessHousing:[a.full],rent:[a.full],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},ownedByPartner:{serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},tenant:{rentLessHousing:[a.share],rent:[a.share],serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]},ownedByOther:{serviceCharge:[a.full],groundRent:[a.full],councilTax:[a.full],personalAlarm:[a.full]}}},respite:{single:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],personalAlarm:[a.full],combinedHomeInsurance:[a.full],homeInsurance:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],personalAlarm:[a.full],homeInsurance:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedByPartner:{councilTax:[a.full],personalAlarm:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],personalAlarm:[a.full],homeInsurance:[a.full],combinedHomeInsurance:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedByOther:{councilTax:[a.full],personalAlarm:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],personalAlarm:[a.full],combinedHomeInsurance:[a.full],homeInsurance:[a.full],contentsInsurance:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],waterRates:[(0,a.ratio)(50)]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],personalAlarm:[a.full],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],waterRates:[(0,a.ratio)(50)]},ownedByPartner:{councilTax:[(0,a.ratio)(50)],personalAlarm:[a.full],contentsInsurance:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],waterRates:[(0,a.ratio)(50)]},tenant:{rentLessHousing:[(0,a.ratio)(50)],rent:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],waterRates:[(0,a.ratio)(50)],personalAlarm:[a.full]},ownedByOther:{councilTax:[(0,a.ratio)(50)],personalAlarm:[a.full],contentsInsurance:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],waterRates:[(0,a.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],personalAlarm:[a.full],combinedHomeInsurance:[a.full],homeInsurance:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],personalAlarm:[a.full],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedByPartner:{councilTax:[a.full],personalAlarm:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],personalAlarm:[a.full],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedByOther:{councilTax:[a.full],personalAlarm:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],personalAlarm:[a.full],combinedHomeInsurance:[a.full],homeInsurance:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],personalAlarm:[a.full],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedByPartner:{councilTax:[a.full],personalAlarm:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},tenant:{rentLessHousing:[a.share],rent:[a.share],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],personalAlarm:[a.full],combinedHomeInsurance:[a.full],homeInsurance:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]},ownedByOther:{councilTax:[a.full],personalAlarm:[a.full],contentsInsurance:[a.full],compulsoryCourtPayments:[a.full],waterRates:[a.full]}}},week1Residential:{single:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{rentLessHousing:[(0,a.ratio)(50)],rent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},nonCohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingWithOther:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{rentLessHousing:[a.share],rent:[a.share],compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}}},week5Residential:{single:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},nonCohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingWithOther:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}}},week13Residential:{single:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},nonCohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingWithOther:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}}}},n.partnerHousingExpenses=(0,t.cloneDeep)(n.housingExpenses);var i=((n.partnerHousingExpenses.nonResidential||{}).cohabitingPartner||{}).ownedByYou||{};i.mortgage=[(0,a.ratio)(0)],i.mortgageLessHousing=[(0,a.ratio)(0)]},40404:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(84133);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r).getDisabilityLevelProcessor,d=(0,a.getParameters)(e,l);return d=(0,i.runProcessors)(d,r,{getDisabilityLevelProcessor:c}),(0,t.sharedCalculator)(n,s,d,u)},n.partnerCalculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r).getPartnerDistabilityLevelProcessor,d=(0,a.getPartnerParameters)(e,l);return d=(0,i.runProcessors)(d,r,{getDisabilityLevelProcessor:c}),(0,t.sharedCalculator)(n,s,d,u)}},79449:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerAllowances=n.getAllowances=void 0;var t=r(66394);n.getAllowances=function(e,n,r,a){var i=(0,t.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,i,a)};n.getPartnerAllowances=function(e,n,r,a){var i=(0,t.getAllowancesConfig)(r).partnerLookup;return(0,t.partnerCalculator)(e,n,r,i,a)}},98111:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(66394);n.getCostOfCare=function(e,n,r,a,i){var o=(0,t.getCostOfCareConfig)(r,i).costOfCareLookup,s=(0,t.calculator)(e,n,r,o,a);return Object.assign({contributions:s,workings:a},i)}},34038:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(66394);n.getDisregards=function(e,n,r,a){var i=(0,t.getDisregardsConfig)(r).disregardsLookup;return(0,t.calculator)(e,n,r,i,a)};n.getPartnerDisregards=function(e,n,r,a,i){var o=(0,t.getDisregardsConfig)(r).partnerLookup;return i=i||o,(0,t.partnerCalculator)(e,n,r,i,a)}},30469:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpensesAboveThreshold=n.getDREs=void 0;var t=r(66394);n.getDREs=function(e,n,r,a){var i=(0,t.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,i,a)};n.getExpensesAboveThreshold=function(e,n,r,a){var i=(0,t.getDREConfig)(r).dreLimitLookup;return(0,t.calculator)(e,n,r,i,a,{getRollup:function(e){var n=[],t=e.dreTotal,a=r.dreCaps||{};return Object.entries(t).forEach((function(e){var r=e[0];e[1]>(a[r]||Number.POSITIVE_INFINITY)&&n.push(r)})),n}})}},18229:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCapitalTariff=n.getPartnerIncome=n.getIncome=void 0;var t=r(74954),a=r(66394);n.getIncome=function(e,n,r){var t=(0,a.getIncomeConfig)(r).incomeLookup;return(0,a.calculator)(e,n,r,t)};n.getPartnerIncome=function(e,n,r){var t=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,a.partnerCalculator)(e,n,r,t)};n.getCapitalTariff=function(e,n,r){return(0,(0,a.getIncomeFunctions)(r).tariff)(r.capitalLimit,r.capitalTariff.nonResidential)({amount:n,parameters:(0,t.getParameters)(e)})}},92273:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=n.isPartnerApplyingForCare=void 0;var a=r(66394),i=r(63566);n.isPartnerApplyingForCare=function(e){var n,r=null===(n=e.person.intro)||void 0===n?void 0:n.hasPartner,t=e.partner||{},a=r?t.details:{},i=!0===a.sameAddress,o=!0===(t.intro||{}).discloseFinances;return i&&o&&!0===a.partnerApplyingForCare};var o=function(e,r,a){return function(i){var o=i.partnerTransfer,s=void 0===o?0:o,l=i.jointCostOfCare,u=void 0===l?0:l,c=i.partnerCostOfCare,d=void 0===c?0:c,p=i.applicantCostOfCare,g=void 0===p?0:p;return(0,n.isPartnerApplyingForCare)(e)?g+d<u?(a.grossIncome=(a.grossIncome||0)+(a.partnerGrossIncome||0),a.capitalTariff=(a.capitalTariff||0)+(a.partnerCapitalTariff||0),a.disregardsTotal=(a.disregardsTotal||0)+(a.partnerDisregardsTotal||0),a.expensesTotal=(a.expensesTotal||0)+(a.partnerExpensesTotal||0),a.livingAllowanceTotal=(a.livingAllowanceTotal||0)+(a.partnerLivingAllowanceTotal||0)):(a.grossIncome=a.jointIncome||0,a.capitalTariff=a.jointCapitalTariff||0,a.disregardsTotal=a.jointDisregardsTotal,a.expensesTotal=a.jointExpensesTotal,a.livingAllowanceTotal=a.jointAllowances||0):(a.partnerTotalCapital||0)>r.fullCostCapitalLimit.nonResidential?s=0:g>u&&(s=g-u),t(t({},a),{partnerTransfer:s})}};n.getPartnerTransfer=function(e,r,t,s){var l,u={},c=null===(l=e.person.intro)||void 0===l?void 0:l.hasPartner,d=e.partner||{},p=c?d.details:{},g=d.intro||{},f=!0===p.sameAddress,m=!0===g.discloseFinances,v=[t.careTypes.nonResidential].includes(r);if(!(c&&f&&m&&v))return{partnerTransfer:0};var h,y=(0,a.getPartnerIncome)(e,r,t);if(u=Object.assign(u,y),(0,n.isPartnerApplyingForCare)(e)){var P=(0,a.getDisregardsConfig)(t).partnerApplyingForCareLookup;h=(0,a.getPartnerDisregards)(e,r,t,s,P)}else h=(0,a.getPartnerDisregards)(e,r,t,s);u=Object.assign(u,h);var C=(0,i.getPartnerExpenses)(e,r);u=Object.assign(u,C);var w=(0,a.getPartnerAllowances)(e,r,t,u);u=Object.assign(u,w),s.partnerGrossIncome=u.grossIncome,s.partnerTotalCapital=u.totalCapital,s.partnerCapitalTariff=u.capitalTariff,s.partnerDisregardsTotal=u.disregardsTotal,s.partnerQualifyingIncome=u.qualifyingIncome,s.partnerExpensesTotal=u.expensesTotal,s.partnerLivingAllowanceTotal=u.livingAllowanceTotal,s.ptApplicantIncome=s.grossIncome,s.partnerSUDisregardsTotal=s.disregardsTotal,s.partnerSUAllowanceTotal=s.livingAllowanceTotal,s.partnerSUExpensesTotal=s.expensesTotal,s.jointTotalCapital=(s.totalCapital||0)+(u.totalCapital||0),s.jointCapitalTariff=(0,a.getCapitalTariff)(e,s.jointTotalCapital,t),s.jointIncome=s.grossIncome-s.capitalTariff+((u.grossIncome||0)-(u.capitalTariff||0))+s.jointCapitalTariff,s.jointDisregardsTotal=s.disregardsTotal+(u.disregardsTotal||0),s.jointExpensesTotal=s.expensesTotal+(u.expensesTotal||0),s.jointAllowances=s.livingAllowanceTotal+(s.partnerLivingAllowanceTotal||0);var I=(0,a.getPartnerTransferConfig)(t).lookup;return(0,a.calculator)(e,r,t,I,s,{getRollup:o(e,t,s)})}},47929:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(66394);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,a=n.dp,i=n.edp,o=n.pea,s=n.carer,l=n.child,u=(0,t.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[o],carerPremium:[u],childPremium:[u]},plaRate:[o],childPremium:[u],carerPremium:[u]},nonResidential:{livingAllowanceTotal:{plaRate:[r,a,i],childPremium:[l],carerPremium:[s]},plaRate:[r,a,i],childPremium:[l],carerPremium:[s]}},partnerLookup:{default:{livingAllowanceTotal:{plaRate:[o],carerPremium:[u],childPremium:[u]},plaRate:[o],childPremium:[u],carerPremium:[u]},nonResidential:{livingAllowanceTotal:{plaRate:[r,a,i],carerPremium:[s],childPremium:[u]},plaRate:[r,a,i],carerPremium:[s],childPremium:[u]}}}}},48323:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(66394);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.cap,o=r.waive,s=r.fullCostContribution,l=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i("respite"),o("respite"),s("respite",n),l]},nonResidential:{maxContribution:[a,i("nonResidential"),o("nonResidential"),s("nonResidential",n),l]}}}}},44990:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(66394);n.getDisregardsConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.joint,i=n.round,o=n.full,s=n.wages,l=n.upliftable,u=n.zero,c=n.ucRollup,d=(0,a.getDisregardsFunctions)(e),p=d.boardingIncome,g=d.warWidowsPension,f=d.psc,m=d.singlePSC,v=d.ifUpliftableIsLow,h={childTaxCredit:[r,i],workingTaxCredit:[r,i],warDisablementPension:[r,i],childBenefit:[r,i],charitableIncome:[r,i],housingBenefit:[r,i],childMaintenance:[r,i],armedForcesCompensation:[r,i],studentIncome:[r,i],boardingIncome:[p,i],warWidowsPension:[g,i],wages:[s,i],mobilityAllowance:[l],universalCreditBreakdown:[c(["housingElement"]),i],pensionSavingsCredit:[r,i]};return{disregardsLookup:{default:{disregardsTotal:t({},h)},nonResidential:{disregardsTotal:t(t({},h),{dlaCare:[l,v]})},respite:{disregardsTotal:t(t({},h),{attendanceAllowance:[l],dlaCare:[l],pipDailyLiving:[l],pensionSavingsCredit:[r,f],workingTaxCredit:[u]})},week1Residential:{disregardsTotal:t(t({},h),{pensionSavingsCredit:[o,m],workingTaxCredit:[u]})},week5Residential:{disregardsTotal:t(t({},h),{attendanceAllowance:[l],dlaCare:[l],pipDailyLiving:[l],pensionSavingsCredit:[o,m],workingTaxCredit:[u]})},week13Residential:{disregardsTotal:t(t({},h),{attendanceAllowance:[l],dlaCare:[l],pipDailyLiving:[l],pensionSavingsCredit:[o,m],workingTaxCredit:[u]})}},partnerLookup:{default:{disregardsTotal:t(t({},h),{boardingIncome:[u]})},nonResidential:{disregardsTotal:t(t({},h),{boardingIncome:[u],attendanceAllowance:[l],dlaCare:[l],pipDailyLiving:[l]})}},partnerApplyingForCareLookup:{default:{disregardsTotal:t(t({},h),{boardingIncome:[u]})}}}}},12097:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(66394);n.getDREConfig=function(e){var n=(0,t.getDREFunctions)(e),r=n.oneOffExpense,a=n.periodicExpense,i=n.annualExpense,o=n.limit,s=n.gardening,l=n.round,u=n.washingPerWeek,c=n.water,d=n.fuel;return{dreLookup:{default:{dreTotal:[(0,t.getIncomeFunctions)(e).zero]},nonResidential:{dreTotal:{gardening:[i,s,l],washingPerWeek:[u],fuel:[a,d],waterRates:[a,c],domesticHelp:[a,o],holidayCarer:[a,o],poweredBed:[r(10),o],bedTurning:[r(10),o],stairLift:[r(10),o],hoistPurchase:[r(10),o],manualWheelchairPurchase:[r(5),o],poweredWheelchairPurchase:[r(10),o],poweredRecliningChair:[r(10),o]}}},dreLimitLookup:{default:{dreTotal:{}},nonResidential:{dreTotal:{domesticHelp:[a],holidayCarer:[a],poweredBed:[r(10)],bedTurning:[r(10)],stairLift:[r(10)],hoistPurchase:[r(10)],manualWheelchairPurchase:[r(5)],poweredWheelchairPurchase:[r(10)],poweredRecliningChair:[r(10)]}}}}}},9029:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var a=r(66394);n.getIncomeConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.zero,i=n.round,o=n.full,s=n.joint,l=n.ucRollup,u=n.wages,c=n.pensions,d=n.partnerStatePension,p=n.partnerPensions,g=n.otherBenefit,f=n.upliftable,m=n.ratio,v=n.additionalPropertyEquity,h=n.primaryPropertyEquity,y=n.partnerAdditionalPropertyEquity,P=n.savings,C=n.partnerSavings,w=n.shareHoldings,I=n.partnerShareHoldings,O=n.tariff,b=n.ifNoProtectedCohabitants,A=function(n){return O(e.capitalLimit,e.capitalTariff[n])},T={retirementPension:[o,d],privatePensions:[c,p],capitalTariff:[[[v,m(90)],P,C,[w,m(90)],A("nonResidential")],[[y,m(90)],C,[I,m(90)],A("nonResidential")]]},R={grossIncome:{childTaxCredit:[s,i],workingTaxCredit:[s,i],incomeSupportPayment:[s,i],employmentSupport:[s,i],jobSeekersAllowance:[s,i],industrialInjuriesBenefit:[s,i],warWidowsPension:[s,i],maintenance:[s,i],rentalIncome:[s,i],boardingIncome:[s,i],retirementPension:[s,i],carersAllowance:[s,i],incapacityBenefit:[s,i],warDisablementPension:[s,i],childBenefit:[s,i],charitableIncome:[s,i],housingBenefit:[s,i],childMaintenance:[s,i],severeDisablementAllowance:[s,i],trustIncome:[s,i],studentIncome:[s,i],armedForcesCompensation:[s,i],pensionGuaranteeCredit:[s,i],pensionSavingsCredit:[s,i],wages:[u,i],privatePensions:[c,i],otherBenefit:[g,i],universalCreditBreakdown:[l(["totalUCReceived","benefitLimit","advanceRepayments","debts","landlordPayment"]),i],attendanceAllowance:[f],pipDailyLiving:[f],dlaCare:[f],mobilityAllowance:[f],constantAttendanceAllowance:[f]}};return{incomeLookup:{default:{grossIncome:t(t({},R.grossIncome),{capitalTariff:[[v,m(90)],P,[w,m(90)],A("nonResidential")]}),additionalPropertyEquity:[v,m(90)],totalCapital:[[v,m(90)],P,[w,m(90)]],capitalTariff:[[v,m(90)],P,[w,m(90)],A("nonResidential")],qualifyingIncome:T},week1Residential:{grossIncome:t(t({},R.grossIncome),{capitalTariff:[[v,m(90)],P,[w,m(90)],A("nonResidential")]}),qualifyingIncome:{retirementPension:[o],privatePensions:[c],capitalTariff:[[[v,m(90)],P,[w,m(90)],A("nonResidential")]]}},week5Residential:{grossIncome:t(t({},R.grossIncome),{capitalTariff:[[v,m(90)],P,[w,m(90)],A("nonResidential")]}),qualifyingIncome:{retirementPension:[o],privatePensions:[c],capitalTariff:[[[v,m(90)],P,[w,m(90)],A("nonResidential")]]}},week13Residential:{grossIncome:t(t({},R.grossIncome),{capitalTariff:[[h,b,m(90)],[v,m(90)],P,[w,m(90)],A("week13Residential")]}),totalCapital:[P,[w,m(90)],[h,b,m(90)],[v,m(90)]],capitalTariff:[[h,b,m(90)],[v,m(90)],P,[w,m(90)],A("week13Residential")],qualifyingIncome:{retirementPension:[o],privatePensions:[c],capitalTariff:[[[v,m(90)],P,[w,m(90)],A("nonResidential")]]}}},partnerIncomeLookup:{default:{grossIncome:t({},R.grossIncome),additionalPropertyEquity:[v,m(90)],totalCapital:[[v,m(90)],P,[w,m(90)]],capitalTariff:[[v,m(90)],P,[w,m(90)],A("nonResidential")],qualifyingIncome:T},respite:t(t({},R),{totalCapital:[r],capitalTariff:[r]}),week1Residential:t(t({},R),{totalCapital:[r],capitalTariff:[r]}),week5Residential:t(t({},R),{totalCapital:[r],capitalTariff:[r]}),week13Residential:t(t({},R),{totalCapital:[r],capitalTariff:[r]})}}}},17025:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(66394);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e),r=n.jointCostOfCare,a=n.partnerCostOfCare,i=n.applicantCostOfCare,o=(0,t.getIncomeFunctions)(e),s=o.minZero,l=o.zero;return{lookup:{default:{jointCostOfCare:[l],partnerCostOfCare:[l],applicantCostOfCare:[l]},nonResidential:{jointCostOfCare:[r,s],partnerCostOfCare:[a,s],applicantCostOfCare:[i,s]}}}}},18428:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance||(a.universalCreditBreakdown||{}).carer,s="yes"===i.carersAllowanceIsEntitled;return r+(o||s?e.carersPremium:0)}})}},55670:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(48845),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},8241:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(48845),i=r(24609),o=r(32954),s=r(56822),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,u=new s.CareAssessmentService(r,n),c=new i.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e),p=function(e){var n=e.amount,r=e.parameters,t=r.workings,i=void 0===t?{}:t,o=r.hasPartner,s=void 0!==o&&o,l=r.suDOB,c=n>0,d=i.qualifyingIncome||0,p=u.getAgeLevel(l,(0,a.getConstants)().levels).level,g=function(e){void 0===e&&(e=!1);var n=(0,a.getConstants)().pensionSavingsCreditIncomeThreshold,r=n?n.singleApplicant:{};return e&&(r=n&&n.applicantAndPartner||{}),r}(s);return p!==(0,a.getConstants)().levels.high||d<g.INCOME_LOW?0:d>=g.INCOME_LOW&&d<g.INCOME_HIGH?c?Math.min(n||0,g.DISREGARD_MAX):0:(g.INCOME_HIGH,g.DISREGARD_MAX)};return t(t({},d),{warWidowsPension:function(e){var n=e.amount,r=e.key,t=e.parameters,i=t.incomeFields[r];i=c.getWeeklyAmount(t.incomeFields,r);var o=!0===t.incomeFields.warWidowsPensionIncludesSupplement;return n+(i=i?Math.min(i,o?((0,a.getConstants)().warPensionDisregard||0)+((0,a.getConstants)().warSpecialPaymentDisregard||0):(0,a.getConstants)().warPensionDisregard||0):0)},psc:function(e){var n=e.amount,r=e.parameters;return p({amount:n,parameters:r})},singlePSC:function(e){var n=e.amount,r=e.parameters;return r=t(t({},r),{hasPartner:!1}),p({amount:n,parameters:r})},ifUpliftableIsLow:function(e){var n=e.amount,r=e.key;return e.parameters.incomeFields[r]===(0,a.getConstants)().levels.low?n:0}})}},77456:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(48845),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{gardening:function(n){return n.amount*(34/((e.configuration.calculatorConfig||{}).weeksPerYear||52))},round:function(e){var n=e.amount;return r.roundUp(n)},washingPerWeek:function(n){return(n.parameters.dreExpensesFields.washingPerWeek||0)>0&&e.washingExcessPremium||0},fuel:function(n){var t=n.amount,a=n.parameters,i=a.dreExpensesFields,o=a.propertyFields,s=a.partnerCohabits,l=a.peopleLivingWithYou,u=(l.hasOtherPeople?(l.otherPeople||[]).length:0)+(s?1:0),c=o.propertyType||"",d=0,p="previousYear"===i.fuelTariffDate?(e.tariffBasedHeatingCosts||[]).find((function(e){return"previousYear"===e.tariffDate})):(e.tariffBasedHeatingCosts||[]).find((function(e){return"currentYear"===e.tariffDate}));if(void 0!==p){var g=p.applicant[c]||0,f=p.eachExtraPerson[c]||0;d=u>0?r.roundUp(g+f*u):g}return Math.max(0,t-d)},water:function(n){var r=n.amount,t=n.parameters,a=t.partnerCohabits,i=t.peopleLivingWithYou,o=(i.hasOtherPeople?(i.otherPeople||[]).length:0)+(a?1:0),s=e.waterCostsPerCohabitant||[],l=s[Math.min(o,s.length-1)];return Math.max(0,r-l)}})}},12968:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(48845),o=r(24609),s=r(32954),l=r(56822);n.getIncomeFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultIncomeHelpers)(c,u,e);return t(t({},d),{round:function(e){var n=e.amount;return r.roundDown(n)}})}},81124:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{jointCostOfCare:function(e){var n=e.amount,r=e.parameters.workings,t=void 0===r?{}:r;return n+((t.jointIncome||0)-(t.jointDisregardsTotal||0)-(t.jointExpensesTotal||0)-(t.dreTotal||0)-(t.jointAllowances||0))},partnerCostOfCare:function(e){var n=e.amount,r=e.parameters.workings,t=void 0===r?{}:r;return n+((t.partnerGrossIncome||0)-(t.partnerDisregardsTotal||0)-(t.partnerExpensesTotal||0)-(t.partnerLivingAllowanceTotal||0))},applicantCostOfCare:function(e){var n=e.amount,r=e.parameters.workings,t=void 0===r?{}:r;return n+((t.grossIncome||0)-(t.disregardsTotal||0)-(t.expensesTotal||0)-(t.dreTotal||0)-(t.livingAllowanceTotal||0))}})}},66394:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.isPartnerApplyingForCare=n.getPartnerTransfer=n.getPartnerAllowances=n.getAllowances=n.getExpensesAboveThreshold=n.getDREs=n.getPartnerDisregards=n.getDisregards=n.getCapitalTariff=n.getPartnerIncome=n.getIncome=void 0;var t=r(18229);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}}),Object.defineProperty(n,"getCapitalTariff",{enumerable:!0,get:function(){return t.getCapitalTariff}});var a=r(34038);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(30469);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}}),Object.defineProperty(n,"getExpensesAboveThreshold",{enumerable:!0,get:function(){return i.getExpensesAboveThreshold}});var o=r(79449);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}}),Object.defineProperty(n,"getPartnerAllowances",{enumerable:!0,get:function(){return o.getPartnerAllowances}});var s=r(92273);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}}),Object.defineProperty(n,"isPartnerApplyingForCare",{enumerable:!0,get:function(){return s.isPartnerApplyingForCare}});var l=r(98111);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(9029);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(44990);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(12097);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(47929);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(17025);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(48323);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(12968);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(8241);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(77456);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(18428);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(81124);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(55670);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(40404);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(84133);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},84133:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel,r=function(e,n){var r=!(!(n.employmentSupport||0)||"Support"!==n.employmentSupportGroup),t=!!(((n.universalCreditBreakdown||{}).limitedWorkAndRelatedCapability||0)>0);return(r||t)&&(e="edp"),e};return{getDisabilityLevelProcessor:function(e){var a=e.incomeFields,i=n(a);return i=r(i,a),t(t({},e),{disabilityLevel:i})},getPartnerDistabilityLevelProcessor:function(e){var a=e.partnerIncomeFields,i=n(a);return i=r(i,a),t(t({},e),{disabilityLevel:i})}}}},91403:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calderdale=void 0;var t=r(10183),a=r(48845);n.calderdale={calculator:t.calculator,getConstants:a.getConstants}},32772:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(77876),i=r(6263),o=r(12645),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l);c=Object.assign(c,d);var p=l.fullCostCapitalLimit[r];if((d.totalCapital||0)>=p){var g=(l.maxContribution||{})[r];return{contributions:s.isNumeric(g)?{maxContribution:g}:{},workings:c}}var f=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,f);var m=(0,o.getExpenses)(e,r);c=Object.assign(c,m),u=Object.assign(u,{expensesAboveMaxThreshold:[]});var v=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,v);var h=(0,i.getPartnerTransfer)(e,r,l,c);c=Object.assign(c,h)}else u=Object.assign(u,{fullCost:!0});for(var y in c)if(Object.prototype.hasOwnProperty.call(c,y)){var P=c[y];void 0!==P&&(c[y]=s.roundNearest(P))}return(0,i.getCostOfCare)(e,r,l,c,u)}},49873:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",week1respite:"week1respite",week5respite:"week5respite",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},warWidowsPensionDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,week1respite:0,week5respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,week1respite:0,week5respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},livingAllowancesMap:{singleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}},coupleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}},partnerNonResidential:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}},partnerRespite:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}}},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},configuration:{calculatorConfig:{weeksPerYear:52}}}},77876:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(49873),i=r(99701);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(61123);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},99701:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,week1respite:23250,week5respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,week1respite:250,week5respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}},partnerNonResidential:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}},partnerRespite:{under25:{base:72.9,dp:0,edp:0},over25:{base:92.05,dp:0,edp:0},pensionAge:{base:227.1,dp:0,edp:0}}},carersPremium:53.25,childPremium:102.95,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,DISREGARD_MAX:10.6}}}},61123:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,week1respite:23250,week5respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,week1respite:250,week5respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:34.8,edp:17.15},over25:{base:86.85,dp:34.8,edp:17.15},pensionAge:{base:174.6,dp:0,edp:0}},partnerNonResidential:{under25:{base:86.85,dp:34.8,edp:17.15},over25:{base:86.85,dp:34.8,edp:17.15},pensionAge:{base:174.6,dp:0,edp:0}},partnerRespite:{under25:{base:71.7,dp:0,edp:0},over25:{base:90.5,dp:0,edp:0},pensionAge:{base:218.15,dp:0,edp:0}}},carersPremium:52.35,childPremium:101.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:301.22,INCOME_HIGH:332.95,DISREGARD_MAX:10.4}}}},89373:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.share=n.half=n.full=void 0,n.full=function(e){return e.amount},n.half=function(e){return e.amount/2},n.share=function(e){var n,r=e.numberOfPeopleOnTheContract,t=void 0===r?1:r;return t<1&&(t=1),(n=100/t,function(e){var r=e.amount*n/100;return Math.max(0,r)})(e)}},12645:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getOwnershipStatus=void 0;var t=r(91569),a=r(98131),i=r(77876);n.getOwnershipStatus=function(e){var n;switch(e.propertyOwnership){case"ownedByYou":n="ownedByYou";break;case"ownedJointly":case"ownedJointlyWithPartner":n="ownedJointly";break;case"ownedByPartner":n="ownedByPartner";break;default:n="tenant"}return n},n.getExpenses=function(e,r){var o=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,a.housingExpenses,{getOwnershipStatus:n.getOwnershipStatus})}},98131:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(89373);n.housingExpenses={nonResidential:{cohabitingPartner:{ownedByPartner:{councilTax:[t.half]},ownedByYou:{councilTax:[t.half],mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share],rent:[t.share],rentLessHousing:[t.share],councilTax:[t.half],serviceCharge:[t.half]},tenant:{rent:[t.share],rentLessHousing:[t.share],councilTax:[t.half],serviceCharge:[t.half]}},cohabitingWithOther:{ownedByPartner:{councilTax:[t.share]},ownedByYou:{councilTax:[t.share],mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]},ownedJointly:{councilTax:[t.share],mortgage:[t.share],mortgageLessHousing:[t.share],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share]},tenant:{councilTax:[t.share],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share]}},nonCohabitingPartner:{ownedByPartner:{councilTax:[t.half]},ownedByYou:{councilTax:[t.half],mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]},ownedJointly:{councilTax:[t.half],mortgage:[t.share],mortgageLessHousing:[t.share],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.half]},tenant:{councilTax:[t.half],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.half]}},single:{ownedByPartner:{councilTax:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]},ownedByYou:{councilTax:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share],rent:[t.share],rentLessHousing:[t.share],councilTax:[t.full],serviceCharge:[t.full]},tenant:{councilTax:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]}}},week1respite:{cohabitingPartner:{ownedByPartner:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],lineRental:[t.half],personalAlarm:[t.full],rent:[t.half],rentLessHousing:[t.half],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]},ownedByYou:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],mortgage:[t.full],mortgageLessHousing:[t.full],lineRental:[t.half],personalAlarm:[t.full],rent:[t.half],rentLessHousing:[t.half],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]},ownedJointly:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],mortgage:[t.share],mortgageLessHousing:[t.share],lineRental:[t.half],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]},tenant:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],lineRental:[t.half],personalAlarm:[t.full],rent:[t.half],rentLessHousing:[t.half],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]}},cohabitingWithOther:{ownedByPartner:{councilTax:[t.share],electric:[t.share],gas:[t.share],homeInsurance:[t.share],lineRental:[t.share],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share],tvLicence:[t.share],water:[t.share],waterRates:[t.share]},ownedByYou:{councilTax:[t.share],electric:[t.share],gas:[t.share],homeInsurance:[t.share],mortgage:[t.full],mortgageLessHousing:[t.full],lineRental:[t.share],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share],tvLicence:[t.share],water:[t.share],waterRates:[t.share]},ownedJointly:{councilTax:[t.share],electric:[t.share],gas:[t.share],homeInsurance:[t.share],mortgage:[t.share],mortgageLessHousing:[t.share],lineRental:[t.share],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share],tvLicence:[t.share],water:[t.share],waterRates:[t.share]},tenant:{councilTax:[t.share],electric:[t.share],gas:[t.share],homeInsurance:[t.share],lineRental:[t.share],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share],tvLicence:[t.share],water:[t.share],waterRates:[t.share]}},nonCohabitingPartner:{ownedByPartner:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedByYou:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedJointly:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],mortgage:[t.share],mortgageLessHousing:[t.share],lineRental:[t.full],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},tenant:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]}},single:{ownedByPartner:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedByYou:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedJointly:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],mortgage:[t.share],mortgageLessHousing:[t.share],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},tenant:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]}}},week5respite:{cohabitingPartner:{ownedByPartner:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],lineRental:[t.half],personalAlarm:[t.full],rent:[t.half],rentLessHousing:[t.half],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]},ownedByYou:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],mortgage:[t.full],mortgageLessHousing:[t.full],lineRental:[t.half],personalAlarm:[t.full],rent:[t.half],rentLessHousing:[t.half],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]},ownedJointly:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],mortgage:[t.share],mortgageLessHousing:[t.share],lineRental:[t.half],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]},tenant:{councilTax:[t.half],electric:[t.half],gas:[t.half],homeInsurance:[t.half],lineRental:[t.half],personalAlarm:[t.full],rent:[t.half],rentLessHousing:[t.half],serviceCharge:[t.half],tvLicence:[t.half],water:[t.half],waterRates:[t.half]}},cohabitingWithOther:{ownedByPartner:{personalAlarm:[t.full]},ownedByYou:{councilTax:[t.share],electric:[t.share],gas:[t.share],homeInsurance:[t.share],mortgage:[t.full],mortgageLessHousing:[t.full],lineRental:[t.share],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share],tvLicence:[t.share],water:[t.share],waterRates:[t.share]},ownedJointly:{councilTax:[t.share],electric:[t.share],gas:[t.share],homeInsurance:[t.share],mortgage:[t.share],mortgageLessHousing:[t.share],lineRental:[t.share],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share],tvLicence:[t.share],water:[t.share],waterRates:[t.share]},tenant:{personalAlarm:[t.full]}},nonCohabitingPartner:{ownedByPartner:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedByYou:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedJointly:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],mortgage:[t.share],mortgageLessHousing:[t.share],lineRental:[t.full],personalAlarm:[t.full],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},tenant:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]}},single:{ownedByPartner:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedByYou:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},ownedJointly:{councilTax:[t.full],electric:[t.full],gas:[t.full],mortgage:[t.share],mortgageLessHousing:[t.share],rent:[t.share],rentLessHousing:[t.share],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]},tenant:{councilTax:[t.full],electric:[t.full],gas:[t.full],homeInsurance:[t.full],lineRental:[t.full],personalAlarm:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],tvLicence:[t.full],water:[t.full],waterRates:[t.full]}}},week1Residential:{cohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},cohabitingWithOther:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},nonCohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},single:{ownedByPartner:{},ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share]},tenant:{}}},week5Residential:{cohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},cohabitingWithOther:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},nonCohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},single:{ownedByPartner:{},ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share]},tenant:{}}},week13Residential:{cohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},cohabitingWithOther:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},nonCohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},single:{ownedByPartner:{},ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share]},tenant:{}}}}},36677:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(80110);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getAllowanceTypeProcessor,p=c.getAgeLevelProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getAllowanceTypeProcessor:d,getAgeLevelProcessor:p}),(0,t.sharedCalculator)(n,s,g,u)},n.partnerCalculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getPartnerAllowanceType,p=c.getAgeLevelProcessor,g=(0,a.getPartnerParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getAgeLevelProcessor:p,getAllowanceTypeProcessor:d(n)}),(0,t.sharedCalculator)(n,s,g,u)}},75742:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerAllowances=n.getAllowances=void 0;var t=r(6263),a=r(6263);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).partnerLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},1044:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(6263),a=r(6263);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},18813:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(6263),a=r(6263);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i,o){var s=(0,a.getDisregardsConfig)(r).partnerLookup;return o=o||s,(0,t.partnerCalculator)(e,n,r,o,i)}},91198:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getIncome=void 0;var t=r(6263),a=r(6263);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)};n.getPartnerIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,t.partnerCalculator)(e,n,r,i)}},29604:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var a=r(6263),i=r(91198),o=r(18813),s=r(75742),l=r(6263),u=function(e,n,r){return function(e){var n=e.partnerTransfer,a=void 0===n?0:n,i=e.partnerNetIncome,o=void 0===i?0:i,s=e.partnerExpensesTotal,l=void 0===s?0:s,u=r.partnerLivingAllowanceTotal,c=o-(void 0===u?0:u)-l;return c<0&&(a=0-c),t(t({},r),{partnerTransfer:a,partnerExpensesTotal:l,notionalPartnerTransfer:c})}};n.getPartnerTransfer=function(e,n,r,t){var c,d={},p=null===(c=e.person.intro)||void 0===c?void 0:c.hasPartner,g=e.partner||{},f=!0===(p?g.details:{}).sameAddress,m=!0===(g.intro||{}).discloseFinances;if(!f||!m)return{partnerTransfer:0};var v=(0,i.getPartnerIncome)(e,n,r),h=v.grossIncome,y=v.totalCapital,P=v.capitalTariff,C=v.qualifyingIncome;d=Object.assign(d,v);var w=(0,o.getPartnerDisregards)(e,n,r,v),I=w.disregardsTotal;d=Object.assign(d,w),t=Object.assign(t,{partnerGrossIncome:h,partnerTotalCapital:y,partnerCapitalTariff:P,partnerDisregardsTotal:I,partnerQualifyingIncome:C});var O=(0,s.getPartnerAllowances)(e,n,r,d),b=O.livingAllowanceTotal,A=O.carerPremium;d=Object.assign(d,O),t=Object.assign(t,{partnerLivingAllowanceTotal:b,ptCarerPremium:A});var T=(0,l.getPartnerTransferConfig)(r).lookup;return(0,a.calculator)(e,n,r,T,t,{getRollup:u(0,0,t)})}},56102:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(6263),a=r(6263);n.getAllowancesConfig=function(e){var n=(0,a.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,t.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s],carerPremium:[c],childPremium:[c]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}},partnerLookup:{default:{livingAllowanceTotal:{plaRate:[c],carerPremium:[c],childPremium:[c]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],carerPremium:[l],childPremium:[c]},plaRate:[r,i,o],carerPremium:[l],childPremium:[c]},week1respite:{livingAllowanceTotal:{plaRate:[r,i,o],carerPremium:[l],childPremium:[c]},plaRate:[r,i,o],carerPremium:[l],childPremium:[c]},week5respite:{livingAllowanceTotal:{plaRate:[r,i,o],carerPremium:[l],childPremium:[c]},plaRate:[r,i,o],carerPremium:[l],childPremium:[c]}}}}},592:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(6263);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},55877:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(6263),i=r(6263);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.full,o=n.cap,s=n.individual,l=n.joint,u=n.wages,c=n.upliftable,d=n.zero,p=n.ucRollup,g=n.pensions,f=(0,a.getDisregardsFunctions)(e),m=f.psc,v=f.pscOrFull,h=f.singlePSC,y=f.disregardTransferredPension,P=f.ifPartnerIsSpouseOrCivilPartner,C=f.aa,w=f.dla,I=f.pip,O=f.maintenance,b=f.ifNotReceivingExtraCare,A={childTaxCredit:[l],childBenefit:[l],charitableIncome:[l],statutorySickPay:[l],sickPayFromPaidEmployment:[l],maintenance:[r,O],warPension:[l],warSpecialPayment:[l],warWidowsPension:[s,o(e.warWidowsPensionDisregard)],wages:[u],privatePensions:[g,y,P],attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c],mobilityAllowance:[c],universalCreditBreakdown:[p(["children","disabledChild","housingElement","childcare"])],pensionSavingsCredit:[l,v]};return{incomeLookup:{default:{disregardsTotal:t({},A)},nonResidential:{disregardsTotal:t(t({},A),{workingTaxCredit:[l],privatePensions:[d],attendanceAllowance:[c,C,b],pipDailyLiving:[c,I,b],dlaCare:[c,w,b]})},week1respite:{disregardsTotal:t(t({},A),{pensionSavingsCredit:[l,m]})},week5respite:{disregardsTotal:t(t({},A),{pensionSavingsCredit:[l,m]})},week1Residential:{disregardsTotal:t(t({},A),{carersAllowance:[l],universalCreditBreakdown:[p(["children","disabledChild","childcare"])],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d],pensionSavingsCredit:[l,h]})},week5Residential:{disregardsTotal:t(t({},A),{carersAllowance:[l],universalCreditBreakdown:[p(["children","disabledChild","childcare"])],pensionSavingsCredit:[l,h]})},week13Residential:{disregardsTotal:t(t({},A),{universalCreditBreakdown:[p(["children","disabledChild","childcare"])],carersAllowance:[l],pensionSavingsCredit:[l,h]})}},partnerLookup:{default:{disregardsTotal:{attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c],mobilityAllowance:[c]}}}}}},77838:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(6263);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.individual,o=n.full,s=n.fullPartner,l=n.joint,u=n.ucRollup,c=n.wages,d=n.partnerWages,p=n.pensions,g=n.partnerPensions,f=n.transferredPensionForPartner,m=n.ifPartnerIsSpouseOrCivilPartner,v=n.otherBenefit,h=n.upliftable,y=n.ratio,P=n.additionalPropertyEquity,C=n.primaryPropertyEquity,w=n.partnerPrimaryPropertyEquity,I=n.partnerAdditionalPropertyEquity,O=n.savings,b=n.partnerSavings,A=n.shareHoldings,T=n.partnerShareHoldings,R=n.tariff,_=n.ifNoProtectedCohabitants,E=function(n){return R(e.capitalLimit,e.capitalTariff[n])},D=[O,[P,A,y(90)]],L=[b,[I,T,y(90)]],S={wages:[c],retirementPension:[r],warPension:[r],warWidowsPension:[r],rentalIncome:[r],privatePensions:[p],capitalTariff:[a(a([],D,!0),[R(1e4,500)],!1)]},N={wages:[c,d],retirementPension:[o,s],warPension:[o,s],warWidowsPension:[o,s],rentalIncome:[o,s],privatePensions:[p,g],capitalTariff:[[a(a([],D,!0),L,!0),R(1e4,500)]]},k={grossIncome:{retirementPension:[l],incomeSupportPayment:[l],incapacityBenefit:[l],employmentSupport:[l],jobSeekersAllowance:[l],industrialInjuriesBenefit:[l],rentalIncome:[l],workingTaxCredit:[l],childTaxCredit:[l],maintenance:[l],warWidowsPension:[l],childBenefit:[l],carersAllowance:[l],pensionGuaranteeCredit:[l],pensionSavingsCredit:[l],charitableIncome:[l],severeDisablementAllowance:[l],warPension:[l],warSpecialPayment:[l],statutorySickPay:[l],sickPayFromPaidEmployment:[l],wages:[c],privatePensions:[p],otherBenefit:[v],universalCreditBreakdown:[u(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"])],attendanceAllowance:[h],pipDailyLiving:[h],dlaCare:[h],mobilityAllowance:[h],capitalTariff:a(a([],D,!0),[E("nonResidential")],!1)}},j={default:{grossIncome:t({},k.grossIncome),additionalPropertyEquity:[P,y(90)],totalCapital:a([],D,!0),capitalTariff:a(a([],D,!0),[E("nonResidential")],!1),qualifyingIncome:N},week1Residential:t(t({},k),{qualifyingIncome:S}),week5Residential:t(t({},k),{qualifyingIncome:S}),week13Residential:{grossIncome:t(t({},k.grossIncome),{capitalTariff:[[[C,y(90)],_],a(a([],D,!0),[E("nonResidential")],!1)]}),totalCapital:[[[C,y(90)],_],a([],D,!0)],capitalTariff:[[[C,y(90)],_],a([],D,!0),E("week13Residential")],qualifyingIncome:S}},M=[O,[I,A,y(90)]],x={retirementPension:[o],privatePensions:[p],capitalTariff:[a(a([],M,!0),[R(1e4,500)],!1)]};return{incomeLookup:j,partnerIncomeLookup:{default:{grossIncome:t(t({},k.grossIncome),{privatePensions:[p,[g,f,m]]}),totalCapital:a([],M,!0),capitalTariff:a(a([],M,!0),[E("nonResidential")],!1),qualifyingIncome:x},nonResidential:{grossIncome:t({},k.grossIncome),totalCapital:a([],M,!0),capitalTariff:a(a([],M,!0),[E("nonResidential")],!1),qualifyingIncome:x},week13Residential:{grossIncome:t(t({},k.grossIncome),{privatePensions:[p,[g,f,m]],capitalTariff:[[[w,y(90)],_],a(a([],M,!0),[E("week13Residential")],!1)]}),totalCapital:[[[w,y(90)],_],a([],M,!0)],capitalTariff:[[[w,y(90)],_],a([],M,!0),E("week13Residential")],qualifyingIncome:x}}}}},56464:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(6263),a=r(6263);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e),r=n.partnerNetIncome,i=n.partnerExpenses,o=(0,a.getIncomeFunctions)(e),s=o.minZero;return{lookup:{default:{partnerNetIncome:[r,s],partnerExpensesTotal:[o.zero]},nonResidential:{partnerNetIncome:[r,s],partnerExpensesTotal:[i]}}}}},62073:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance||(a.universalCreditBreakdown||{}).carer,s="yes"===i.carersAllowanceIsEntitled;return r+(o||s?e.carersPremium:0)}})}},10059:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(77876),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},25632:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(5416),i=r(24609),o=r(32954),s=r(56822),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,u=new s.CareAssessmentService(r,n),c=new i.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e),p=function(n){void 0===n&&(n=!1);var r=e.pensionSavingsCreditIncomeThreshold,t=r?r.singleApplicant:{};return n&&(t=r&&r.applicantAndPartner||{}),t};return t(t({},d),{psc:function(e){return function(e){var n=e.amount,r=e.parameters,t=r.workings,i=void 0===t?{}:t,o=r.hasPartner,s=void 0!==o&&o,l=r.suDOB,u=n>0,c=i.qualifyingIncome||0,d=p(s),g=a("05/04/1953","DD/MM/YYYY"),f=a(l,"DD/MM/YYYY");return g.diff(f,"days")<=0||c<d.INCOME_LOW?0:c>=d.INCOME_LOW&&c<d.INCOME_HIGH?u?Math.min(n,d.DISREGARD_MAX):0:c>=d.INCOME_HIGH&&u&&!s?Math.min(n,d.DISREGARD_MAX):d.DISREGARD_MAX}({amount:e.amount,parameters:e.parameters})},pscOrFull:function(e){return function(e){var n=e.amount,r=e.parameters,t=r.workings,i=void 0===t?{}:t,o=r.hasPartner,s=void 0!==o&&o,l=r.suDOB,u=i.qualifyingIncome||0,c=p(s),d=a("05/04/1953","DD/MM/YYYY"),g=a(l,"DD/MM/YYYY");return d.diff(g,"days")<=0?0:0===(null!=n?n:0)?u<c.INCOME_LOW?0:u>=c.INCOME_LOW&&u<c.INCOME_HIGH?Math.min(n||0,c.DISREGARD_MAX):(c.INCOME_HIGH,c.DISREGARD_MAX):n||0}({amount:e.amount,parameters:e.parameters})},singlePSC:function(e){var n=e.amount,r=e.parameters;return function(e){var n=e.amount,r=e.parameters,t=r.workings,i=void 0===t?{}:t,o=r.hasPartner,s=void 0!==o&&o,l=r.suDOB,u=n>0,c=i.qualifyingIncome||0,d=p(s),g=a("05/04/1953","DD/MM/YYYY"),f=a(l,"DD/MM/YYYY");return g.diff(f,"days")<=0||c<d.INCOME_LOW?0:c>=d.INCOME_LOW&&c<d.INCOME_HIGH?u?Math.min(n,d.DISREGARD_MAX):0:c>=d.INCOME_HIGH&&u?Math.min(n,d.DISREGARD_MAX):d.DISREGARD_MAX}({amount:n,parameters:r=t(t({},r),{hasPartner:!1})})}})}},90329:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(77876),o=r(24609),s=r(32954),l=r(56822);n.getIncomeFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultIncomeHelpers)(c,u,e);return t(t({},d),{primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.propertyFields.ownership,o=r.numberOfPeopleOnTheContract;return n+(t+="ownedByYou"===i?a:"ownedJointly"===i?a/o:0)},partnerPrimaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.propertyFields.ownership,o=r.numberOfPeopleOnTheContract;return n+(t+="ownedByPartner"===i?a:"ownedJointly"===i?a/o:0)}})}},17027:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{partnerExpenses:function(e){e.amount;return(e.parameters.workings||{}).expensesTotal||0},partnerNetIncome:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.partnerGrossIncome,s=void 0===o?0:o,l=i.partnerDisregardsTotal;return s-(void 0===l?0:l)}})}},6263:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getPartnerAllowances=n.getAllowances=n.getPartnerDisregards=n.getDisregards=n.getPartnerIncome=n.getIncome=void 0;var t=r(91198);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}});var a=r(18813);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(75742);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return i.getAllowances}}),Object.defineProperty(n,"getPartnerAllowances",{enumerable:!0,get:function(){return i.getPartnerAllowances}});var o=r(29604);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return o.getPartnerTransfer}});var s=r(1044);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return s.getCostOfCare}});var l=r(77838);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return l.getIncomeConfig}});var u=r(55877);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return u.getDisregardsConfig}});var c=r(56102);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return c.getAllowancesConfig}});var d=r(56464);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return d.getPartnerTransferConfig}});var p=r(592);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return p.getCostOfCareConfig}});var g=r(90329);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return g.getIncomeFunctions}});var f=r(25632);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return f.getDisregardsFunctions}});var m=r(62073);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return m.getAllowancesFunctions}});var v=r(17027);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return v.getPartnerTransferFunctions}});var h=r(10059);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return h.getCostOfCareFunctions}});var y=r(36677);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return y.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return y.partnerCalculator}});var P=r(80110);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return P.getProcessors}})},80110:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e),r=n.getAgeLevel,i=n.getAgeLevelKey;return{getAgeLevelProcessor:function(e){var n=e.dob,a=r(n),o=i(a);return t(t({},e),{ageLevel:o})},getAllowanceTypeProcessor:function(e){var n=e.hasPartner?"coupleServiceUser":"singleServiceUser";return t(t({},e),{allowanceType:n})},getPartnerAllowanceType:function(e){return function(n){var r=["week1respite","week5respite"].includes(e)?"partnerRespite":"partnerNonResidential";return t(t({},n),{allowanceType:r})}}}}},52434:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.cornwall=void 0;var t=r(32772),a=r(77876);n.cornwall={calculator:t.calculator,getConstants:a.getConstants}},29495:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(16765),i=r(30602),o=r(51454),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u=!1,c={},d={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var p=(0,i.getIncome)(e,r,l);d=Object.assign(d,p);var g=l.fullCostCapitalLimit[r];(p.totalCapital||0)>=g&&(u=!0);var f=(0,i.getDisregards)(e,r,l,d);d=Object.assign(d,f);var m=(0,o.getExpenses)(e,r);d=Object.assign(d,m);var v=(0,i.getAllowances)(e,r,l,d);d=Object.assign(d,v)}else u=!0;for(var h in c=Object.assign(c,{fullCost:u}),d)if(Object.prototype.hasOwnProperty.call(d,h)){var y=d[h]||0;d[h]=s.roundNearest(y)}return(0,i.getCostOfCare)(e,r,l,d,c)}},42220:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{directPayment:"directPayment",nonResidential:"nonResidential",shortStay:"shortStay",longStayWeek1WithAADLAPIP:"longStayWeek1WithAADLAPIP",longStayWeek1WithoutAADLAPIP:"longStayWeek1WithoutAADLAPIP",longStayWeek13:"longStayWeek13"},warWidowsPensionDisregard:0,rentalIncomeDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{directPayment:0,nonResidential:0,shortStay:0,longStayWeek1WithAADLAPIP:0,longStayWeek1WithoutAADLAPIP:0,longStayWeek13:0},capitalTariff:{directPayment:0,nonResidential:0,shortStay:0,longStayWeek1WithAADLAPIP:0,longStayWeek1WithoutAADLAPIP:0,longStayWeek13:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},maxDREAllowance:0,personalLivingAllowance:{residentialRate:0},livingAllowancesMap:{singleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}},coupleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}},partnerShortStay:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}}},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},configuration:{calculatorConfig:{weeksPerYear:52}}}},16765:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(42220),i=r(74514);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(26560);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},74514:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,rentalIncomeDisregard:20,maxDREAllowance:0,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{directPayment:23250,nonResidential:23250,shortStay:23250,longStayWeek1WithAADLAPIP:23250,longStayWeek1WithoutAADLAPIP:23250,longStayWeek13:23250},capitalTariff:{directPayment:250,nonResidential:250,shortStay:250,longStayWeek1WithAADLAPIP:250,longStayWeek1WithoutAADLAPIP:250,longStayWeek13:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}}},childPremium:102.95,carersPremium:53.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,DISREGARD_MAX:10.6}}}},26560:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,rentalIncomeDisregard:20,maxDREAllowance:0,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{directPayment:23250,nonResidential:23250,shortStay:23250,longStayWeek1WithAADLAPIP:23250,longStayWeek1WithoutAADLAPIP:23250,longStayWeek13:23250},capitalTariff:{directPayment:250,nonResidential:250,shortStay:250,longStayWeek1WithAADLAPIP:250,longStayWeek1WithoutAADLAPIP:250,longStayWeek13:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:34.8,edp:17.15},over25:{base:86.85,dp:34.8,edp:17.15},pensionAge:{base:174.6,dp:0,edp:0}},partnerShortStay:{under25:{base:71.7,dp:0,edp:0},over25:{base:90.5,dp:0,edp:0},pensionAge:{base:218.15,dp:0,edp:0}}},childPremium:101.25,carersPremium:52.35,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:301.22,INCOME_HIGH:332.95,DISREGARD_MAX:10.4}}}},23578:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}}},51454:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getPartnerArrangement=void 0;var t=r(91569),a=r(16765),i=r(50380);n.getPartnerArrangement=function(e){var n=e.hasPartner,r=e.partnerCohabits;return n&&r?"cohabitingPartner":"single"},n.getExpenses=function(e,r){var o=(0,a.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,i.housingExpenses,{getPartnerArrangement:n.getPartnerArrangement})}},50380:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(23578);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},ownedByOther:{mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},tenant:{rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},tenant:{rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]}}},shortStay:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},ownedByOther:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]},tenant:{rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],groundRent:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},tenant:{rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]}}},longStayWeek1WithAADLAPIP:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],groundRent:[t.full]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],groundRent:[t.full]},ownedByOther:{mortgage:[t.full],mortgageLessHousing:[t.full],groundRent:[t.full]},tenant:{groundRent:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]},tenant:{}}}},n.housingExpenses.directPayment=n.housingExpenses.nonResidential,n.housingExpenses.longStayWeek1WithoutAADLAPIP=n.housingExpenses.longStayWeek1WithAADLAPIP,n.housingExpenses.longStayWeek13=n.housingExpenses.longStayWeek1WithAADLAPIP},88036:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(31541);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getDisabilityLevelProcessor,p=c.getAllowanceTypeProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getDisabilityLevelProcessor:d,getAllowanceTypeProcessor:p}),(0,t.sharedCalculator)(n,s,g,u)}},57417:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(30602),a=r(30602);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},71279:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(30602),a=r(30602);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},99910:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(30602),a=r(30602);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)}},45957:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getIncome=void 0;var t=r(30602),a=r(30602);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)}},7401:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(30602);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,a=n.dp,i=n.edp,o=n.pea,s=n.carer,l=n.child;return{lookup:{default:{livingAllowanceTotal:{plaRate:[o]}},nonResidential:{livingAllowanceTotal:{plaRate:[r,a,i],childPremium:[l],carerPremium:[s]}},directPayment:{livingAllowanceTotal:{plaRate:[r,a,i],childPremium:[l],carerPremium:[s]}}}}}},14227:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(30602);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},6638:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(30602),i=r(30602);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.full,o=n.joint,s=n.individual,l=n.wages,u=n.upliftable,c=n.zero,d=n.ucRollup,p=n.cap,g=(0,a.getDisregardsFunctions)(e),f=g.aa,m=g.dla,v=g.psc,h=g.onlyIfCapitalBelowThreshold,y={childTaxCredit:[o],workingTaxCredit:[o],childBenefit:[o],warPension:[o],warSpecialPayment:[o],charitableIncome:[o],warWidowsPension:[s,p(e.warWidowsPensionDisregard)],rentalIncome:[o,p(e.rentalIncomeDisregard)],wages:[l],attendanceAllowance:[u,f],pipDailyLiving:[c],dlaCare:[u,m],mobilityAllowance:[u],universalCreditBreakdown:[d(["children"])]};return{incomeLookup:{default:{disregardsTotal:t(t({},y),{pensionSavingsCredit:[s]})},directPayment:{disregardsTotal:t(t({},y),{pensionSavingsCredit:[s]})},shortStay:{disregardsTotal:t(t({},y),{workingTaxCredit:[c],attendanceAllowance:[u],dlaCare:[u],pipDailyLiving:[u],mobilityAllowance:[u],pensionSavingsCredit:[r,v]})},longStayWeek1WithAADLAPIP:{disregardsTotal:t(t({},y),{workingTaxCredit:[c],attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c],pensionSavingsCredit:[r,v]})},longStayWeek1WithoutAADLAPIP:{disregardsTotal:t(t({},y),{workingTaxCredit:[c],attendanceAllowance:[u],dlaCare:[u],pipDailyLiving:[u],pensionSavingsCredit:[r,v]})},longStayWeek13:{disregardsTotal:t(t({},y),{workingTaxCredit:[c],attendanceAllowance:[u,h],dlaCare:[u,h],pipDailyLiving:[u,h],pensionSavingsCredit:[r,v]})}}}}},16949:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(30602);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.full,o=n.joint,s=n.ucRollup,l=n.ucDeductionRollup,u=n.wages,c=n.pensions,d=n.otherBenefit,p=n.upliftable,g=n.primaryPropertyEquity,f=n.additionalPropertyEquity,m=n.savings,v=n.shareHoldings,h=n.tariff,y=n.minZero,P=n.transferPensionToPartner,C=n.ifLivesAlone,w=function(n){return h(e.capitalLimit,e.capitalTariff[n])},I=[m,v,f],O={retirementPension:[r],privatePensions:[c],capitalTariff:a(a([],I,!0),[w("nonResidential")],!1)},b={grossIncome:{retirementPension:[o],incomeSupportPayment:[o],incapacityBenefit:[o],employmentSupport:[o],jobSeekersAllowance:[o],industrialInjuriesBenefit:[o],rentalIncome:[o],workingTaxCredit:[o],childTaxCredit:[o],childMaintenance:[o],maintenance:[o],warPension:[o],warWidowsPension:[o],warSpecialPayment:[o],childBenefit:[o],carersAllowance:[o],charitableIncome:[o],pensionGuaranteeCredit:[o],pensionSavingsCredit:[o],wages:[u],privatePensions:[c],otherBenefit:[d],universalCreditBreakdown:[s(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"]),l(["other","earnings","capitalTariff","benefitLimit"]),y],attendanceAllowance:[p],pipDailyLiving:[p],dlaCare:[p],mobilityAllowance:[p],capitalTariff:a(a([],I,!0),[w("nonResidential")],!1)}};return{incomeLookup:{default:{grossIncome:t({},b.grossIncome),additionalPropertyEquity:[f],totalCapital:a([],I,!0),capitalTariff:a(a([],I,!0),[w("nonResidential")],!1),qualifyingIncome:O},shortStay:{grossIncome:t(t({},b.grossIncome),{privatePensions:[c,P]})},longStayWeek13:t(t({},b),{totalCapital:[[g,C],a([],I,!0)],capitalTariff:[[g,C],a([],I,!0),w("longStayWeek13")]})}}}},22924:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r,t=n.amount,a=n.parameters,i=0,o=a.incomeFields,s=a.introFields,l=a.partnerCohabits,u=a.partnerIncomeFields,c=a.partnerIntroFields,d=(o.carersAllowance||0)>0,p="yes"===s.carersAllowanceIsEntitled;if(r=(d||p)&&e.carersPremium||0,l){var g=(u.carersAllowance||0)>0,f="yes"===c.carersAllowanceIsEntitled;i=(g||f)&&e.carersPremium||0}return t+((r||i)&&e.carersPremium||0)}})}},21798:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(16765),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},4897:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(5416),i=r(24609),o=r(32954),s=r(56822),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,u=new s.CareAssessmentService(r,n),c=new i.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e);return t(t({},d),{psc:function(n){var r=n.amount,t=n.parameters,i=t.workings,o=void 0===i?{}:i,s=t.suDOB,l=o.qualifyingIncome||0,u=e.pensionSavingsCreditIncomeThreshold,c=u?u.singleApplicant:{},d=a("05/04/1953","DD/MM/YYYY"),p=a(s,"DD/MM/YYYY");return d.diff(p,"days")<=0||l<c.INCOME_LOW?0:l>=c.INCOME_LOW&&r>0?Math.min(r,c.DISREGARD_MAX):c.DISREGARD_MAX},onlyIfCapitalBelowThreshold:function(n){var r=n.amount,t=n.parameters.workings,a=(void 0===t?{}:t).totalCapital;return(void 0===a?0:a)<e.fullCostCapitalLimit.longStayWeek13?r:0}})}},33304:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t({},c)}},30602:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.calculator=n.getCostOfCareFunctions=n.getAllowancesFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getAllowancesConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getAllowances=n.getDisregards=n.getIncome=void 0;var t=r(45957);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}});var a=r(99910);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(57417);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return i.getAllowances}});var o=r(71279);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return o.getCostOfCare}});var s=r(16949);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return s.getIncomeConfig}});var l=r(6638);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return l.getDisregardsConfig}});var u=r(7401);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return u.getAllowancesConfig}});var c=r(14227);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return c.getCostOfCareConfig}});var d=r(33304);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return d.getIncomeFunctions}});var p=r(4897);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return p.getDisregardsFunctions}});var g=r(22924);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return g.getAllowancesFunctions}});var f=r(21798);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return f.getCostOfCareFunctions}});var m=r(88036);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return m.calculator}});var v=r(31541);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return v.getProcessors}})},31541:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel;return{getAllowanceTypeProcessor:function(e){var n=e.hasPartner?"coupleServiceUser":"singleServiceUser";return t(t({},e),{allowanceType:n})},getDisabilityLevelProcessor:function(e){var r=e.incomeFields,a=n(r),i=r.employmentSupport,o=r.employmentSupportGroup;return i&&"Support"===o&&(a="edp"),t(t({},e),{disabilityLevel:a})}}}},97115:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.doncaster=void 0;var t=r(29495),a=r(16765),i=r(25237);n.doncaster={calculator:t.calculator,getConstants:a.getConstants,migrations:i.migrations}},5674:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;n.m1=function(e){void 0===e&&(e={});var n=null!=e?e:{},r=JSON.parse(JSON.stringify(n)),t=n.person;void 0===t&&(t={});var a=n.partner;void 0===t&&(t={});var i=t.details;void 0===i&&(i={});var o=i.homePhoneNumber,s=i.mobilePhoneNumber;void 0!==o&&o.length>0&&(r.person.details.phoneNumber=o);void 0!==s&&s.length>0&&(r.person.details.phoneNumber=s);if(void 0!==a){var l=a.details;if(void 0!==l){var u=l.homePhoneNumber,c=l.mobilePhoneNumber;if(void 0!==u&&u.length>0)r.partner.details.phoneNumber=u;if(void 0!==c&&c.length>0)r.partner.details.phoneNumber=c}}return r}},25237:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.migrations=void 0;var t=r(5674);n.migrations={DO_FCA:{1:[t.m1]}}},26632:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(80432),i=r(17723),o=r(8217),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l);c=Object.assign(c,d);var p=l.fullCostCapitalLimit[r],g=(d.totalCapital||0)>p,f=(d.additionalPropertyEquity||0)>0;if(g||f){var m=(l.maxContribution||{})[r];return{contributions:s.isNumeric(m)?{maxContribution:m}:{},workings:c,isMaxCost:!0}}var v=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,v);var h=(0,o.getExpenses)(e,r);c=Object.assign(c,h);var y=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,y),u=Object.assign(u,{expensesAboveMaxThreshold:(0,i.getExpensesAboveThreshold)(e,r,l,c)});var P=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,P)}else u=Object.assign(u,{fullCost:!0});for(var C in c)if(Object.prototype.hasOwnProperty.call(c,C)){var w=c[C]||0;c[C]=s.roundNearest(w)}return(0,i.getCostOfCare)(e,r,l,c,u)}},41869:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",temporary:"temporary",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},warPensionDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,temporary:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,temporary:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},configuration:{calculatorConfig:{weeksPerYear:52}},dreRatio:0}},80432:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(41869),i=r(60881);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(96295);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},60881:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,temporary:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,temporary:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:112.5,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},loneParentUser:{under25:{base:112.5,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}}},childPremium:102.95,carersPremium:53.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}},dreRatio:.35}},96295:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,temporary:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,temporary:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:110.6,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},loneParentUser:{under25:{base:110.6,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}}},childPremium:101.25,carersPremium:52.35,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95}},dreRatio:.35}},15753:function(e,n){function r(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}}Object.defineProperty(n,"__esModule",{value:!0}),n.bi=n.shareOnContract=n.shareInProperty=n.half=n.full=void 0,n.full=function(e){return e.amount},n.half=function(e){return e.amount/2},n.shareInProperty=function(e){return r(100/((e.partnerCohabits?1:0)+(e.numberOfOtherPeople||0)+1))(e)},n.shareOnContract=function(e){return r(100/(e.numberOfPeopleOnTheContract||0))(e)},n.bi=function(e){return r(!0===e.expenseFields.isHomeInsuranceCombined?80:100)(e)}},8217:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=void 0;var t=r(91569),a=r(31919),i=r(80432);n.getExpenses=function(e,n){var r=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(r,e,n,a.housingExpenses)}},31919:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(15753),a={cohabitingPartner:{ownedByPartner:{boilerInsurance:[t.half],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.half]},ownedByYou:{boilerInsurance:[t.half],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.half]},ownedJointly:{boilerInsurance:[t.half],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.half]},tenant:{boilerInsurance:[t.half],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.half],homeInsurance:[t.bi,t.shareInProperty],rent:[t.shareInProperty],rentLessHousing:[t.shareInProperty],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.half]}},cohabitingWithOther:{ownedByPartner:{boilerInsurance:[t.shareInProperty],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.shareOnContract],mortgageLessHousing:[t.shareOnContract],rent:[t.shareOnContract],rentLessHousing:[t.shareOnContract],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.shareInProperty]},ownedByYou:{boilerInsurance:[t.half],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.half]},ownedJointly:{boilerInsurance:[t.half],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.half]},tenant:{boilerInsurance:[t.shareInProperty],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],rent:[t.shareOnContract],rentLessHousing:[t.shareOnContract],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.shareInProperty]}},nonCohabitingPartner:{ownedByPartner:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.shareOnContract],mortgageLessHousing:[t.shareOnContract],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]},ownedByYou:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]},ownedJointly:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]},tenant:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],rent:[t.shareInProperty],rentLessHousing:[t.shareInProperty],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]}},single:{ownedByPartner:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],rent:[t.shareInProperty],rentLessHousing:[t.shareInProperty],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]},ownedByYou:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]},ownedJointly:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]},tenant:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],rent:[t.shareInProperty],rentLessHousing:[t.shareInProperty],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]}}},i={cohabitingPartner:a.cohabitingPartner,single:a.single,cohabitingWithOther:{ownedByYou:a.cohabitingWithOther.ownedByYou,ownedJointly:a.cohabitingWithOther.ownedJointly,ownedByPartner:{boilerInsurance:[t.shareInProperty],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],mortgage:[t.shareOnContract],mortgageLessHousing:[t.shareOnContract],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.shareInProperty]},tenant:{boilerInsurance:[t.shareInProperty],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],rent:[t.shareOnContract],rentLessHousing:[t.shareOnContract],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.shareInProperty]}},nonCohabitingPartner:{ownedByYou:a.nonCohabitingPartner.ownedByYou,ownedJointly:a.nonCohabitingPartner.ownedJointly,ownedByPartner:{boilerInsurance:[t.full],compulsoryCourtPayments:[t.full],councilTax:[t.shareInProperty],groundRent:[t.shareInProperty],homeInsurance:[t.bi,t.shareInProperty],serviceCharge:[t.shareInProperty],whiteGoodsInsurance:[t.full]},tenant:a.nonCohabitingPartner.tenant}},o={cohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},cohabitingWithOther:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},nonCohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},single:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}}};n.housingExpenses={nonResidential:a,temporary:i,week1Residential:o,week5Residential:o,week13Residential:o}},25201:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(39786);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getAllowanceTypeProcessor,p=c.getDisabilityLevelProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getAllowanceTypeProcessor:d,getDisabilityLevelProcessor:p}),(0,t.sharedCalculator)(n,s,g,u)}},22138:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(17723),a=r(17723);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},28552:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(17723),a=r(17723);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},88569:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(17723),a=r(17723);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)}},37924:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpensesAboveThreshold=n.getDREs=void 0;var t=r(17723),a=r(17723);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)};n.getExpensesAboveThreshold=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLimitLookup;return(0,t.calculator)(e,n,r,o,i,{getRollup:function(e){var n=[],t=e.dreTotal,a=r.dreCaps||{};return Object.entries(t).forEach((function(e){var r=e[0];e[1]>(a[r]||Number.POSITIVE_INFINITY)&&n.push(r)})),n}})}},15418:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getIncome=void 0;var t=r(17723),a=r(17723);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)}},89794:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(17723),a=r(17723);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,a.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}}}}},81780:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(17723);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.fullCostContribution;return{costOfCareLookup:{default:{maxContribution:[a,i("respite",n)]},nonResidential:{maxContribution:[a,i("nonResidential",n)]}}}}},86961:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(17723),i=r(17723);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.full,o=n.joint,s=n.individual,l=n.wages,u=n.upliftable,c=n.zero,d=n.ucRollup,p=n.cap,g=n.pensions,f=n.transferredPensionForPartner,m=(0,a.getDisregardsFunctions)(e).psc,v={childBenefit:[o],warSpecialPayment:[o],childMaintenance:[o],housingBenefit:[o],severeDisablementAllowance:[o],warWidowsPension:[o],carersAllowance:[o],warPension:[s,p(e.warPensionDisregard)],wages:[l],attendanceAllowance:[u],dlaCare:[u],pipDailyLiving:[u],mobilityAllowance:[u],universalCreditBreakdown:[d(["children","disabledChild","housingElement","childcare","carer"])]};return{incomeLookup:{default:{disregardsTotal:t(t({},v),{carersAllowance:[c],severeDisablementAllowance:[c],pensionSavingsCredit:[s],attendanceAllowance:[c],dlaCare:[c],pipDailyLiving:[c],universalCreditBreakdown:[d(["children","disabledChild","housingElement","childcare"])]})},temporary:{disregardsTotal:t(t({},v),{privatePensions:[g,f],mobilityAllowance:[u],pensionSavingsCredit:[r,m]})},week1Residential:{disregardsTotal:t(t({},v),{privatePensions:[g,f],pensionSavingsCredit:[r,m]})},week5Residential:{disregardsTotal:t(t({},v),{privatePensions:[g,f],pensionSavingsCredit:[r,m]})},week13Residential:{disregardsTotal:t(t({},v),{privatePensions:[g,f],pensionSavingsCredit:[r,m]})}}}}},73372:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(17723),a=r(17723);n.getDREConfig=function(e){var n=(0,a.getIncomeFunctions)(e).zero,r=(0,t.getDREFunctions)(e);return{dreLookup:{default:{dreTotal:[n]},nonResidential:{dreTotal:[r.dre,r.round]}},dreLimitLookup:{default:{dreTotal:{}}}}}},45674:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(17723);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.ratio,o=n.full,s=n.joint,l=n.ucRollup,u=n.wages,c=n.pensions,d=n.otherBenefit,p=n.upliftable,g=n.primaryPropertyEquity,f=n.additionalPropertyEquity,m=n.savings,v=n.shareHoldings,h=n.tariff,y=function(n){return h(e.capitalLimit,e.capitalTariff[n])},P=[m,v,[f,r(90)]],C={retirementPension:[o],privatePensions:[c],capitalTariff:a(a([],P,!0),[y("nonResidential")],!1)},w={grossIncome:{retirementPension:[s],incomeSupportPayment:[s],incapacityBenefit:[s],employmentSupport:[s],jobSeekersAllowance:[s],industrialInjuriesBenefit:[s],rentalIncome:[s],childMaintenance:[s],maintenance:[s],warPension:[s],warWidowsPension:[s],warSpecialPayment:[s],childBenefit:[s],carersAllowance:[s],charitableIncome:[s],pensionGuaranteeCredit:[s],pensionSavingsCredit:[s],severeDisablementAllowance:[s],housingBenefit:[s],wages:[u],privatePensions:[c],otherBenefit:[d],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare","healthAllowance"])],attendanceAllowance:[p],pipDailyLiving:[p],dlaCare:[p],mobilityAllowance:[p],capitalTariff:a(a([],P,!0),[y("nonResidential")],!1)}};return{incomeLookup:{default:{grossIncome:t({},w.grossIncome),additionalPropertyEquity:[f],totalCapital:a([],P,!0),capitalTariff:a(a([],P,!0),[y("nonResidential")],!1),qualifyingIncome:C},temporary:{grossIncome:t({},w.grossIncome)},week13Residential:t(t({},w),{totalCapital:[[g,r(90)],a([],P,!0)],capitalTariff:[[g,r(90)],a([],P,!0),y("week13Residential")]})}}}},6925:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance||(a.universalCreditBreakdown||{}).carer,s="yes"===i.carersAllowanceIsEntitled;return r+((o||s)&&e.carersPremium||0)}})}},17287:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(80432),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},67172:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(5416),i=r(24609),o=r(32954),s=r(56822),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,u=new s.CareAssessmentService(r,n),c=new i.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e);return t(t({},d),{psc:function(n){var r=n.amount,t=n.parameters,i=t.workings,o=void 0===i?{}:i,s=t.suDOB,l=o.qualifyingIncome||0,u=e.pensionSavingsCreditIncomeThreshold,c=u?u.singleApplicant:{},d=a("05/04/1953","DD/MM/YYYY"),p=a(s,"DD/MM/YYYY");return d.diff(p,"days")<=0||l<c.INCOME_LOW?0:l>=c.INCOME_LOW&&r>0?Math.min(r,c.DISREGARD_MAX):c.DISREGARD_MAX}})}},51987:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(80432),o=r(24609),s=r(32954),l=r(56822),u=r(17723);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,c=new l.CareAssessmentService(r,n),d=new o.Helpers(n),p=(0,u.getIncomeFunctions)(e).upliftable,g=(0,a.getDefaultDREHelpers)(d,c,e);return t(t({},g),{round:function(e){var n=e.amount;return Math.round(100*n)/100},dre:function(n){n.amount;var r=n.parameters;return(p({amount:0,key:"attendanceAllowance",parameters:r})+p({amount:0,key:"pipDailyLiving",parameters:r})+p({amount:0,key:"dlaCare",parameters:r}))*(e.dreRatio||0)}})}},33837:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).map((function(e){var n,r;return(null!==(n=e.value)&&void 0!==n?n:0)/(null!==(r=e.numberOfPeopleOnTheContract)&&void 0!==r?r:1)})).reduce((function(e,n){return e+n}),0)},primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.partnerCohabits,i=r.dependentChildrenCount,o=r.peopleLivingWithYou,s=r.propertyFields.value||0,l=r.propertyFields.numberOfPeopleOnTheContract||1;return t+=1===i+((o.hasOtherPeople?(o.otherPeople||[]).length:0)+(a?2:1))?s:s/l,a&&(t=0),n+t}})}},17723:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.calculator=n.getCostOfCareFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getAllowances=n.getExpensesAboveThreshold=n.getDREs=n.getDisregards=n.getIncome=void 0;var t=r(15418);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}});var a=r(88569);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(37924);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}}),Object.defineProperty(n,"getExpensesAboveThreshold",{enumerable:!0,get:function(){return i.getExpensesAboveThreshold}});var o=r(22138);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(28552);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return s.getCostOfCare}});var l=r(45674);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return l.getIncomeConfig}});var u=r(86961);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return u.getDisregardsConfig}});var c=r(73372);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return c.getDREConfig}});var d=r(89794);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return d.getAllowancesConfig}});var p=r(81780);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return p.getCostOfCareConfig}});var g=r(33837);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return g.getIncomeFunctions}});var f=r(67172);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return f.getDisregardsFunctions}});var m=r(51987);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return m.getDREFunctions}});var v=r(6925);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return v.getAllowancesFunctions}});var h=r(17287);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return h.getCostOfCareFunctions}});var y=r(25201);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return y.calculator}});var P=r(39786);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return P.getProcessors}})},39786:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel;return{getAllowanceTypeProcessor:function(e){var n=e.dependentChildrenCount>0?"loneParentUser":"singleServiceUser";return t(t({},e),{allowanceType:n})},getDisabilityLevelProcessor:function(e){var r=e.incomeFields,a=n(r),i=r.severeDisablementAllowance||0,o=r.incapacityBenefit||0,s=r.employmentSupport||0,l=r.employmentSupportGroup||"";return i>0&&"base"===a&&(a="dp"),o>0&&"base"===a&&(a="dp"),s>0&&"Support"===l&&(a="edp"),t(t({},e),{disabilityLevel:a})}}}},47630:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.ealing=void 0;var t=r(26632),a=r(80432);n.ealing={calculator:t.calculator,getConstants:a.getConstants}},97112:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(26848),i=r(8043),o=r(36105);n.calculator=function(e,n,r,s){(0,a.setOptions)(s,e);var l=(0,a.getConstants)(),u=new t.NumberUtilsService,c={},d={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var p=(0,i.getQualifyingIncome)(e,r,l);d=Object.assign(d,p);var g=(0,i.getIncome)(e,r,l,d);d=Object.assign(d,g);var f=l.fullCostCapitalLimit[r];if((g.totalCapital||0)>=f){var m=(l.maxContribution||{})[r];return{contributions:u.isNumeric(m)?{maxContribution:m}:{},workings:d}}var v=(0,i.getDisregards)(e,r,l,d);d=Object.assign(d,v);var h=(0,o.getExpenses)(e,r);d=Object.assign(d,h);var y=(0,i.getDREs)(e,r,l,d);d=Object.assign(d,y);var P=(0,i.getAllowances)(e,r,l,d);d=Object.assign(d,P);var C=(0,i.getPartnerTransfer)(e,r,l,d);d=Object.assign(d,C)}else c=Object.assign(c,{fullCost:!0});for(var w in d)if(Object.prototype.hasOwnProperty.call(d,w)){var I=d[w]||0;d[w]=u.roundNearest(I)}return(0,i.getCostOfCare)(e,r,l,d,c)}},72285:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",residentialWeek1:"residentialWeek1",residentialWeek5:"residentialWeek5",residentialWeek13:"residentialWeek13"},attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,residentialWeek1:0,residentialWeek5:0,residentialWeek13:0},capitalTariff:{nonResidential:0,residentialWeek1:0,residentialWeek5:0,residentialWeek13:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},maxDREAllowance:0,personalLivingAllowance:{residentialRate:0},childPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},configuration:{calculatorConfig:{weeksPerYear:52}}}},26848:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(72285),i=r(87617);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(67063);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},87617:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,warWidowsPensionDisregard:10,maxDREAllowance:14.61,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,residentialWeek1:23250,residentialWeek5:23250,residentialWeek13:23250},capitalTariff:{nonResidential:250,residentialWeek1:250,residentialWeek5:250,residentialWeek13:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:91.13,dp:54,edp:26.5},over25:{base:115.06,dp:54,edp:26.5},pensionAge:{base:278.69,dp:0,edp:0}},coupleServiceUser:{under25:{base:90.41,dp:38.53,edp:18.9},over25:{base:90.41,dp:38.53,edp:18.9},pensionAge:{base:212.67,dp:0,edp:0}}},carerPremiumRatesMap:{singleServiceUser:{under25:{base:58,dp:58,edp:58},over25:{base:58,dp:58,edp:58},pensionAge:{base:58.25,dp:58.25,edp:58.25}},coupleServiceUser:{under25:{base:29,dp:29,edp:29},over25:{base:29,dp:29,edp:29},pensionAge:{base:29.13,dp:29.13,edp:29.13}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}}}},67063:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,warWidowsPensionDisregard:10,maxDREAllowance:14.61,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,residentialWeek1:23250,residentialWeek5:23250,residentialWeek13:23250},capitalTariff:{nonResidential:250,residentialWeek1:250,residentialWeek5:250,residentialWeek13:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:89.91,dp:53.12,edp:26.07},over25:{base:113.5,dp:53.12,edp:26.06},pensionAge:{base:272.69,dp:0,edp:0}},coupleServiceUser:{under25:{base:89.08,dp:37.87,edp:18.6},over25:{base:89.08,dp:37.87,edp:18.6},pensionAge:{base:208.09,dp:0,edp:0}}},carerPremiumRatesMap:{singleServiceUser:{under25:{base:57.01,dp:57.01,edp:57},over25:{base:57,dp:57,edp:57},pensionAge:{base:57,dp:57,edp:57}},coupleServiceUser:{under25:{base:28.5,dp:28.5,edp:28.5},over25:{base:28.5,dp:28.5,edp:28.5},pensionAge:{base:28.5,dp:28.5,edp:28.5}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95}}}},15449:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}}},36105:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=void 0;var t=r(91569),a=r(20319),i=(0,r(26848).getConstants)().configuration;n.getExpenses=function(e,n){return(0,t.expensesCalculator)(i,e,n,a.housingExpenses)}},20319:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(15449);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},tenant:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByOther:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},tenant:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},tenant:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByOther:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},tenant:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]}}},residentialWeek1:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],otherCommitments:[t.full]},ownedByPartner:{otherCommitments:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],otherCommitments:[t.full]}}},residentialWeek13:{single:{ownedByYou:{otherCommitments:[t.full]},ownedJointly:{otherCommitments:[t.full]},ownedByPartner:{otherCommitments:[t.full]},tenant:{otherCommitments:[t.full]},ownedByOther:{otherCommitments:[t.full]}},cohabitingPartner:{ownedByYou:{otherCommitments:[t.full]},ownedJointly:{otherCommitments:[t.full]},ownedByPartner:{otherCommitments:[t.full]},tenant:{otherCommitments:[t.full]},ownedByOther:{otherCommitments:[t.full]}},nonCohabitingPartner:{ownedByYou:{otherCommitments:[t.full]},ownedJointly:{otherCommitments:[t.full]},ownedByPartner:{otherCommitments:[t.full]},tenant:{otherCommitments:[t.full]},ownedByOther:{otherCommitments:[t.full]}},cohabitingWithOther:{ownedByYou:{otherCommitments:[t.full]},ownedJointly:{otherCommitments:[t.full]},ownedByPartner:{otherCommitments:[t.full]},tenant:{otherCommitments:[t.full]},ownedByOther:{otherCommitments:[t.full]}}}}},58305:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(7098);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getDisabilityLevelProcessor,p=c.getAllowanceTypeProcessor,g=c.getCarerPremiumRateLookupProcessor,f=(0,a.getParameters)(e,l);return f=(0,i.runProcessors)(f,r,{getDisabilityLevelProcessor:d,getAllowanceTypeProcessor:p,additionalProcessors:[g]}),(0,t.sharedCalculator)(n,s,f,u)},n.partnerCalculator=function(e,n,r,o,s,l){var u=(0,a.getPartnerParameters)(e,s);return u=(0,i.runProcessors)(u,r),(0,t.sharedCalculator)(n,o,u,l)}},70186:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(8043),a=r(8043);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},2808:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(8043),a=r(8043);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},38153:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getJointSUDisregards=n.getDisregards=void 0;var t=r(8043),a=r(8043);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).disregardsLookup;return(0,t.calculator)(e,n,r,o,i)};n.getJointSUDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).jointSUConfig;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).partnerDisregardsLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},43444:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(8043),a=r(8043);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},12938:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getQualifyingIncome=n.getIncome=void 0;var t=r(8043),a=r(8043);n.getIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)};n.getQualifyingIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).qiLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},27088:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var a=r(8043),i=r(12938),o=r(38153),s=r(8043),l=function(e){return function(n){var r=n.jointIncome,a=void 0===r?0:r,i=n.jointDisregards;return t(t({},e),{grossIncome:a,disregardsTotal:i,jointIncome:a,disregardedJointIncome:i,partnerTransfer:0})}};n.getPartnerTransfer=function(e,n,r,u){var c,d=null===(c=e.person.intro)||void 0===c?void 0:c.hasPartner,p=e.partner||{},g=!0===(d?p.details:{}).sameAddress,f=!0===(p.intro||{}).discloseFinances;if(!g||!f)return{partnerTransfer:0};var m=(0,o.getJointSUDisregards)(e,n,r,u);u=Object.assign(u,t(t({},m),{partnerSUDisregardsTotal:m.disregardsTotal}));var v=(0,i.getPartnerIncome)(e,n,r,u),h=v.grossIncome,y=v.totalCapital,P=v.capitalTariff,C=v.qualifyingIncome,w=(0,o.getPartnerDisregards)(e,n,r,u).disregardsTotal;u=Object.assign(u,{partnerGrossIncome:h,partnerTotalCapital:y,partnerCapitalTariff:P,partnerDisregardsTotal:w,partnerQualifyingIncome:C});var I=(0,s.getPartnerTransferConfig)(r).lookup;return(0,a.calculator)(e,n,r,I,u,{getRollup:l(u)})}},59378:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(8043),a=r(8043);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,a.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}}}}},14724:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(8043);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},45569:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(8043),i=r(8043);n.getDisregardsConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.ratio,o=n.cap,s=n.full,l=n.wages,u=n.upliftable,c=n.pensions,d=n.zero,p=n.otherBenefit,g=n.ucRollup,f=(0,i.getDisregardsFunctions)(e).psc,m={wages:[l],childTaxCredit:[s],workingTaxCredit:[s],childBenefit:[s],historicalTransitionProtection:[s],warPension:[s,o(e.warPensionDisregard)],warWidowsPension:[s,o(e.warWidowsPensionDisregard)],attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u],mobilityAllowance:[u],pensionSavingsCredit:[s,f]},v={default:{disregardsTotal:t({},m)},nonResidential:{disregardsTotal:t(t({},m),{warPension:[s],warWidowsPension:[s],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d],pensionSavingsCredit:[s]})}},h=[g(["standardAllowance","limitedWorkCapability","limitedWorkAndRelatedCapability","carer"])],y={industrialInjuriesBenefit:[s],retirementPension:[s],carersAllowance:[s],severeDisablementAllowance:[s],bereavementSupportAllowance:[s],childTaxCredit:[s],workingTaxCredit:[s],incomeSupportPayment:[s,r(50)],employmentSupport:[s,r(50)],maintenance:[s,r(50)],rentalIncome:[s,r(50)],childBenefit:[s],pensionGuaranteeCredit:[s,r(50)],historicalTransitionProtection:[s],warPension:[s],warWidowsPension:[s],universalCreditBreakdown:[h,r(50)],wages:[l],privatePensions:[c],otherBenefit:[p],attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u],mobilityAllowance:[u],pensionSavingsCredit:[s]},P={default:{disregardsTotal:t({},y)},nonResidential:{disregardsTotal:t(t({},y),{industrialInjuriesBenefit:[s,r(50)],retirementPension:[s,r(50)],carersAllowance:[s,r(50)],severeDisablementAllowance:[s,r(50)],bereavementSupportAllowance:[s,r(50)],privatePensions:[c,r(50)],otherBenefit:[p,r(50)]})},residentialWeek13:{disregardsTotal:t(t({},y),{incomeSupportPayment:[s],employmentSupport:[s],maintenance:[s],pensionGuaranteeCredit:[s],universalCreditBreakdown:h})}},C={industrialInjuriesBenefit:[d],retirementPension:[d],carersAllowance:[s],severeDisablementAllowance:[d],bereavementSupportAllowance:[d],childTaxCredit:[s],workingTaxCredit:[s],incomeSupportPayment:[s,r(50)],employmentSupport:[s,r(50)],maintenance:[s,r(50)],rentalIncome:[s,r(50)],childBenefit:[s],pensionGuaranteeCredit:[s,r(50)],historicalTransitionProtection:[s],warPension:[s],warWidowsPension:[s],universalCreditBreakdown:[h,r(50)],wages:[l],privatePensions:[c,r(50)],otherBenefit:[d],attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u],mobilityAllowance:[u],pensionSavingsCredit:[s,f]};return{disregardsLookup:v,partnerDisregardsLookup:P,jointSUConfig:{default:{disregardsTotal:t({},C)},nonResidential:{disregardsTotal:t(t({},C),{industrialInjuriesBenefit:[s,r(50)],retirementPension:[s,r(50)],carersAllowance:[s,r(50)],severeDisablementAllowance:[s,r(50)],bereavementSupportAllowance:[s,r(50)],otherBenefit:[p,r(50)],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d],mobilityAllowance:[u],pensionSavingsCredit:[s]})},residentialWeek1:{disregardsTotal:t(t({},C),{attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d],mobilityAllowance:[u]})},residentialWeek13:{disregardsTotal:t(t({},C),{incomeSupportPayment:[d],employmentSupport:[d],maintenance:[s],pensionGuaranteeCredit:[d],universalCreditBreakdown:[d]})}}}}},77836:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(8043),a=r(8043);n.getDREConfig=function(e){var n=(0,a.getIncomeFunctions)(e).zero,r=(0,t.getDREFunctions)(e);return{dreLookup:{default:{dreTotal:[n]},nonResidential:{dreTotal:[r.dre,r.round]}}}}},67418:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var a=r(8043);n.getIncomeConfig=function(e){var n,r=(0,a.getIncomeFunctions)(e),i=r.full,o=r.tariff,s=r.wages,l=r.pensions,u=r.ucRollup,c=r.otherBenefit,d=r.upliftable,p=r.savings,g=r.shareHoldings,f=r.additionalPropertyEquity,m=r.partnerAdditionalPropertyEquity,v=[f,p,g,(n="nonResidential",o(e.capitalLimit,e.capitalTariff[n]))],h={privatePensions:[l],retirementPension:[i],capitalTariff:v},y=[u(["standardAllowance","limitedWorkCapability","limitedWorkAndRelatedCapability","carer"])],P={grossIncome:{retirementPension:[i],warPension:[i],warWidowsPension:[i],warSpecialPayment:[i],carersAllowance:[i],childBenefit:[i],incomeSupportPayment:[i],employmentSupport:[i],industrialInjuriesBenefit:[i],maintenance:[i],rentalIncome:[i],severeDisablementAllowance:[i],childTaxCredit:[i],workingTaxCredit:[i],pensionSavingsCredit:[i],pensionGuaranteeCredit:[i],bereavementSupportAllowance:[i],wages:[s],privatePensions:[l],otherBenefit:[c],universalCreditBreakdown:y,attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d],mobilityAllowance:[d],privatePension:[i],capitalTariff:v}},C={default:{qualifyingIncome:h}};return{qiLookup:C,incomeLookup:{default:t({grossIncome:t({},P.grossIncome),additionalPropertyEquity:[f],totalCapital:[f,p,g],capitalTariff:v,universalCreditBreakdown:y},C.default)},partnerIncomeLookup:{default:{grossIncome:t(t({},P.grossIncome),{capitalTariff:v}),totalCapital:[p,g,m],capitalTariff:v}}}}},82044:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(8043);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e);return{lookup:{default:{jointIncome:[n.jointIncome],jointDisregards:[n.jointDisregards]}}}}},44989:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(e){var n=e.amount,r=e.parameters,t=r.incomeFields,a=r.introFields,i=r.partnerCohabits,o=r.partnerIncomeFields,s=r.partnerIntroFields,l=r.carerPremiumRatesLookup,u=r.disabilityLevel,c=0,d=l[void 0===u?"base":u],p=t.carersAllowance,g="yes"===a.receivesCarersAllowanceForSomeoneElse,f="yes"===a.receivesUCCarerElement,m=(t.universalCreditBreakdown||{}).carer,v="yes"===a.carersAllowanceIsEntitled;if(c=g||f||v||p||m?d:0,i){var h=o.carersAllowance,y=(o.universalCreditBreakdown||{}).carer,P="yes"===s.receivesCarersAllowanceForSomeoneElse,C="yes"===s.receivesUCCarerElement,w="yes"===s.carersAllowanceIsEntitled;c+=P||C||y||h||w?d:0}return n+c}})}},51607:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(26848),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},78356:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e),d=function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.hasPartner,s=void 0!==o&&o,u=t.suDOB,c=r>0,d=i.qualifyingIncome||0,p=l.getAgeLevel(u,e.levels).level,g=function(n){void 0===n&&(n=!1);var r=e.pensionSavingsCreditIncomeThreshold,t=r?r.singleApplicant:{};return n&&(t=r&&r.applicantAndPartner||{}),t}(s);return p!==e.levels.high||d<g.INCOME_LOW?0:c?Math.min(r||0,g.DISREGARD_MAX):0};return t(t({},c),{psc:function(e){var n=e.amount,r=e.parameters;return d({amount:n,parameters:r})}})}},95971:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(26848),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{round:function(e){var n=e.amount;return Math.round(100*n)/100},dre:function(n){var r=n.amount,t=n.parameters,a=t.dreExpensesFields,i=t.incomeFields,o=a.hasApprovedDRE?c.getWeeklyAmount(a,"approvedDRE"):0,s=i.attendanceAllowance||"none",l=i.dlaCare||"none",u=i.pipDailyLiving||"none",d=("low"===s||"high"===s||"medium"===l||"high"===l||"low"===u||"high"===u)&&e.maxDREAllowance||0;return o>0&&(d=Math.max(o,d||0)),r+d}})}},84285:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{ucRollup:function(e){return void 0===e&&(e=[]),function(n){var r=n.amount,t=n.parameters,a=Object.keys(t.incomeFields.universalCreditBreakdown||{}).reduce((function(n,r){return e.includes(r)?n+((t.incomeFields.universalCreditBreakdown||{})[r]||0):n}),0);return r+l.toWeeklyAmount(a,s.PERIODS.Monthly)}}})}},12743:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{jointIncome:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.grossIncome,s=void 0===o?0:o,l=i.partnerGrossIncome;return n+s+(void 0===l?0:l)},jointDisregards:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.partnerSUDisregardsTotal,s=void 0===o?0:o,l=i.partnerDisregardsTotal;return n+s+(void 0===l?0:l)}})}},8043:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getAllowances=n.getDREs=n.getPartnerDisregards=n.getDisregards=n.getQualifyingIncome=n.getPartnerIncome=n.getIncome=void 0;var t=r(12938);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}}),Object.defineProperty(n,"getQualifyingIncome",{enumerable:!0,get:function(){return t.getQualifyingIncome}});var a=r(38153);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(43444);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(70186);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(27088);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(2808);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(67418);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(45569);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(77836);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(59378);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(82044);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(14724);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(84285);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(78356);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(95971);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(44989);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(12743);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(51607);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(58305);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(7098);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},7098:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel;return t(t({},(0,a.getDefaultProcessors)(e)),{getDisabilityLevelProcessor:function(e){var r=e.incomeFields,a=n(r),i=!(!(r.employmentSupport||0)||"support"!==r.employmentSupportGroup),o=!(!r.hasUniversalCredit||"lcwra"!==r.assessedForLimitedWorkCapability);return(i||o)&&(a="edp"),t(t({},e),{disabilityLevel:a})},getAllowanceTypeProcessor:function(e){var n=e.hasPartner?"coupleServiceUser":"singleServiceUser";return t(t({},e),{allowanceType:n})}})}},44894:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.halton=void 0;var t=r(97112),a=r(26848);n.halton={calculator:t.calculator,getConstants:a.getConstants}},6639:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(54341),i=r(18962),o=r(46486),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l);c=Object.assign(c,d);var p=l.fullCostCapitalLimit[r],g=(d.totalCapital||0)>=p,f=(d.additionalPropertyEquity||0)>0;if(g||f){var m=(l.maxContribution||{})[r];return{contributions:s.isNumeric(m)?{maxContribution:m}:{},workings:c}}var v=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,v);var h=(0,o.getExpenses)(e,r);c=Object.assign(c,h);var y=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,y),u=Object.assign(u,{expensesAboveMaxThreshold:(0,i.getExpensesAboveThreshold)(e,r,l,c)});var P=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,P);var C=(0,i.getPartnerTransfer)(e,r,l,c);c=Object.assign(c,C)}else u=Object.assign(u,{fullCost:!0});for(var w in c)if(Object.prototype.hasOwnProperty.call(c,w)){var I=c[w]||0;c[w]=s.roundNearest(I)}return(0,i.getCostOfCare)(e,r,l,c,u)}},72468:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},warWidowsPensionDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},configuration:{calculatorConfig:{weeksPerYear:52}},washingExcessPremium:0,washingAllowancePerWash:0,maxContributionRatio:{nonResidential:0,week1Residential:0,week5Residential:0,week13Residential:0}}},54341:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(72468),i=r(77226);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(89224);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},77226:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:111.49,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},loneParentUser:{under25:{base:112.5,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}}},childPremium:102.95,carersPremium:53.25,washingAllowancePerWash:.978,maxContributionRatio:{nonResidential:1,week1Residential:1,week5Residential:1,week13Residential:1},dreCaps:{gardening:19.97,domesticHelp:19.97,transport:29.2,chiropodist:6,specialClothes:9.46,alarm:10.09,incontinenceAids:18.92,additionalBedding:3.97,dietary:12.18,medication:2.2,homeMaintenance:8.14,recharging:1.88,internetAccess:7.47,poweredBedMaintenance:9.86,hoistMaintenance:3.91,poweredRecliningChairMaintenance:4.47,stairLiftMaintenance:7.96,manualWheelchairMaintenance:5.1,poweredWheelchairMaintenance:12.38,washingPerWeek:4.89}}},89224:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:111.49,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},loneParentUser:{under25:{base:110.6,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:34.8,edp:17.15},over25:{base:86.85,dp:34.8,edp:17.15},pensionAge:{base:174.6,dp:0,edp:0}}},childPremium:101.25,carersPremium:52.35,washingAllowancePerWash:.948,maxContributionRatio:{nonResidential:.95,week1Residential:1,week5Residential:1,week13Residential:1},dreCaps:{gardening:19.35,domesticHelp:19.35,transport:28.7,chiropodist:5.75,specialClothes:9.17,alarm:9.78,incontinenceAids:18.33,additionalBedding:3.85,dietary:11.81,medication:2.15,homeMaintenance:7.89,recharging:1.82,internetAccess:7.24,poweredBedMaintenance:9.55,hoistMaintenance:3.79,poweredRecliningChairMaintenance:4.33,stairLiftMaintenance:7.71,manualWheelchairMaintenance:4.94,poweredWheelchairMaintenance:12,washingPerWeek:4.74}}},68802:function(e,n){function r(e){var n,r=(e.numberOfOtherPeople||0)+(e.partnerCohabits?2:1);return(n=100/r,function(e){var r=e.amount*n/100;return Math.max(0,r)})(e)}Object.defineProperty(n,"__esModule",{value:!0}),n.named=n.share=n.half=n.full=void 0,n.full=function(e){return e.amount},n.half=function(e){return e.amount/2},n.share=r,n.named=function(e){return e.namedOnContract?r(e):0}},46486:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getOwnershipStatus=n.getPartnerArrangement=void 0;var t=r(91569),a=r(82468),i=r(54341);n.getPartnerArrangement=function(e){var n=e.hasPartner,r=e.partnerCohabits;return e.livesWithOther?"cohabitingWithOther":n?r?"cohabitingPartner":"nonCohabitingPartner":"single"};n.getOwnershipStatus=function(e){var n;switch(e.propertyOwnership){case"ownedByYou":n="ownedByYou";break;case"ownedJointly":case"ownedJointlyWithPartner":n="ownedJointly";break;case"ownedByPartner":n="ownedByPartner";break;default:n="tenant"}return n},n.getExpenses=function(e,r){var o=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,a.housingExpenses,{getPartnerArrangement:n.getPartnerArrangement,getOwnershipStatus:n.getOwnershipStatus})}},82468:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(68802),a={cohabitingPartner:{ownedByPartner:{councilTax:[t.half],groundRent:[t.half],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.half]},ownedByYou:{councilTax:[t.half],groundRent:[t.half],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.half]},ownedJointly:{councilTax:[t.half],groundRent:[t.half],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.half]},tenant:{councilTax:[t.half],groundRent:[t.half],rent:[t.half],rentLessHousing:[t.half],serviceCharge:[t.half]}},cohabitingWithOther:{ownedByPartner:{councilTax:[t.share],groundRent:[t.share],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.share]},ownedByYou:{councilTax:[t.share],groundRent:[t.share],mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.share]},ownedJointly:{councilTax:[t.share],groundRent:[t.share],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.share]},tenant:{councilTax:[t.share],groundRent:[t.share],rent:[t.named],rentLessHousing:[t.named],serviceCharge:[t.share]}},nonCohabitingPartner:{ownedByPartner:{councilTax:[t.full],groundRent:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.full]},ownedByYou:{councilTax:[t.full],groundRent:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full]},ownedJointly:{councilTax:[t.full],groundRent:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.full]},tenant:{councilTax:[t.full],groundRent:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]}},single:{ownedByPartner:{councilTax:[t.full],groundRent:[t.full],serviceCharge:[t.full]},ownedByYou:{combinedHomeInsurance:[t.full],councilTax:[t.full],groundRent:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full]},ownedJointly:{councilTax:[t.full],groundRent:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],serviceCharge:[t.full]},tenant:{councilTax:[t.full],groundRent:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full]}}},i={cohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},cohabitingWithOther:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},nonCohabitingPartner:{ownedByPartner:{},ownedByYou:{},ownedJointly:{},tenant:{}},single:{ownedByPartner:{councilTax:[t.full],groundRent:[t.full],homeInsurance:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],waterRates:[t.full]},ownedByYou:{councilTax:[t.full],groundRent:[t.full],homeInsurance:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],waterRates:[t.full]},ownedJointly:{councilTax:[t.full],groundRent:[t.full],homeInsurance:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],waterRates:[t.full]},tenant:{councilTax:[t.full],groundRent:[t.full],homeInsurance:[t.full],rent:[t.full],rentLessHousing:[t.full],serviceCharge:[t.full],waterRates:[t.full]}}},o={cohabitingPartner:i.cohabitingPartner,cohabitingWithOther:i.cohabitingWithOther,nonCohabitingPartner:i.nonCohabitingPartner,single:{ownedByPartner:{},ownedByYou:i.single.ownedByYou,ownedJointly:i.single.ownedJointly,tenant:{}}};n.housingExpenses={nonResidential:a,week1Residential:i,week5Residential:o,week13Residential:o}},57388:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(23901);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getAllowanceTypeProcessor,p=c.getDisabilityLevelProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getAllowanceTypeProcessor:d,getDisabilityLevelProcessor:p}),(0,t.sharedCalculator)(n,s,g,u)},n.partnerCalculator=function(e,n,r,o,s,l){var u=(0,a.getPartnerParameters)(e,s);return u=(0,i.runProcessors)(u,r),(0,t.sharedCalculator)(n,o,u,l)}},27297:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(18962),a=r(18962);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},46503:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(18962),a=r(18962);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},42030:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(18962),a=r(18962);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i,o){var s=(0,a.getDisregardsConfig)(r).partnerLookup;return o=o||s,(0,t.partnerCalculator)(e,n,r,o,i)}},42525:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpensesAboveThreshold=n.getDREs=void 0;var t=r(18962),a=r(18962);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)};n.getExpensesAboveThreshold=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLimitLookup;return(0,t.calculator)(e,n,r,o,i,{getRollup:function(e){var n=[],t=e.dreTotal,a=r.dreCaps||{};return Object.entries(t).forEach((function(e){var r=e[0];e[1]>(a[r]||Number.POSITIVE_INFINITY)&&n.push(r)})),n}})}},88893:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getIncome=void 0;var t=r(18962),a=r(18962);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)};n.getPartnerIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,t.partnerCalculator)(e,n,r,i)}},8585:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var t=r(18962),a=r(88893),i=r(42030),o=r(18962);n.getPartnerTransfer=function(e,n,r,s){var l,u=null===(l=e.person.intro)||void 0===l?void 0:l.hasPartner,c=e.partner||{},d=!0===(u?c.details:{}).sameAddress,p=!0===(c.intro||{}).discloseFinances;if(!d||!p)return{notionalPartnerTransfer:0,partnerTransfer:0};var g=(0,a.getPartnerIncome)(e,n,r),f=g.grossIncome,m=g.totalCapital,v=g.capitalTariff,h=(0,i.getPartnerDisregards)(e,n,r,g).disregardsTotal;s=Object.assign(s,{partnerGrossIncome:f-v,partnerTotalCapital:m,partnerCapitalTariff:v,partnerDisregardsTotal:h});var y=(0,o.getPartnerTransferConfig)(r).lookup;return(0,t.calculator)(e,n,r,y,s)}},58081:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(18962);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,a=n.dp,i=n.edp,o=n.pea,s=n.carer,l=n.child;return{lookup:{default:{livingAllowanceTotal:{plaRate:[o],carerPremium:[s]},plaRate:[o],carerPremium:[s]},nonResidential:{livingAllowanceTotal:{plaRate:[r,a,i],childPremium:[l],carerPremium:[s]},plaRate:[r,a,i],childPremium:[l],carerPremium:[s]}}}}},15403:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(18962);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.ratio,s=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o("week1Residential"),s]},nonResidential:{maxContribution:[a,i(n),o("nonResidential"),s]}}}}},82262:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(18962),i=r(18962);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.cap,o=n.full,s=n.individual,l=n.joint,u=n.wages,c=n.upliftable,d=n.zero,p=n.ucRollup,g=(0,a.getDisregardsFunctions)(e),f=g.aa,m=g.dla,v=g.trust,h=g.bonds,y=g.maintenance,P=g.ifNotReceivingExtraCare,C={workingTaxCredit:[l],childTaxCredit:[l],warPension:[l],warSpecialPayment:[l],charitableIncome:[l],trustIncome:[o,v],bondIncome:[o,h],maintenance:[o,y],warWidowsPension:[s,r(e.warWidowsPensionDisregard)],wages:[u],attendanceAllowance:[c],dlaCare:[c],pipDailyLiving:[c],mobilityAllowance:[c],universalCreditBreakdown:[p(["children","disabledChild","childcare","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer"])]};return{incomeLookup:{default:{disregardsTotal:t({},C)},nonResidential:{disregardsTotal:t(t({},C),{childBenefit:[l],universalCreditBreakdown:[p(["children","disabledChild","childcare"])],attendanceAllowance:[c,f,P],pipDailyLiving:[d],dlaCare:[c,m,P],pensionSavingsCredit:[l]})},week1Residential:{disregardsTotal:t(t({},C),{carersAllowance:[l],attendanceAllowance:[d],dlaCare:[d]})},week5Residential:{disregardsTotal:t(t({},C),{carersAllowance:[l]})},week13Residential:{disregardsTotal:t(t({},C),{carersAllowance:[l]})}},partnerLookup:{default:{disregardsTotal:{attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c],mobilityAllowance:[c]}}}}}},8889:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(18962);n.getDREConfig=function(e){var n=(0,t.getDREFunctions)(e),r=n.oneOffExpense,a=n.periodicExpense,i=n.annualExpense,o=n.limit,s=n.shareWithPartner,l=n.washingPerWeek;return{dreLookup:{default:{dreTotal:{gardening:[i,s,o],domesticHelp:[a,s,o],homeMaintenance:[a,s,o],transport:[a,o],chiropodist:[a,o],specialClothes:[a,o],alarm:[a,o],incontinenceAids:[a,o],additionalBedding:[a,o],dietary:[a,o],medication:[a,o],recharging:[a,o],internetAccess:[a,o],poweredBedMaintenance:[a,o],hoistMaintenance:[a,o],poweredRecliningChairMaintenance:[a,o],stairLiftMaintenance:[a,o],manualWheelchairMaintenance:[a,o],poweredWheelchairMaintenance:[a,o],washingPerWeek:[l,o],poweredBed:[r(10,50),o],stairLift:[r(10,50),o],hoistPurchase:[r(10,50),o],manualWheelchairPurchase:[r(10,50),o],poweredWheelchairPurchase:[r(10,50),o],poweredRecliningChair:[r(10,50),o]}}},dreLimitLookup:{default:{dreTotal:{gardening:[i,s],domesticHelp:[a,s],homeMaintenance:[a,s],transport:[a],chiropodist:[a],specialClothes:[a],alarm:[a],incontinenceAids:[a],additionalBedding:[a],dietary:[a],medication:[a],recharging:[a],internetAccess:[a],poweredBedMaintenance:[a],hoistMaintenance:[a],poweredRecliningChairMaintenance:[a],stairLiftMaintenance:[a],manualWheelchairMaintenance:[a],poweredWheelchairMaintenance:[a],washingPerWeek:[l],poweredBed:[r(10,50)],stairLift:[r(10,50)],hoistPurchase:[r(10,50)],manualWheelchairPurchase:[r(10,50)],poweredWheelchairPurchase:[r(10,50)],poweredRecliningChair:[r(10,50)]}}}}}},78637:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(18962);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.zero,o=n.joint,s=n.jointPartner,l=n.ucRollup,u=n.wages,c=n.pensions,d=n.otherBenefit,p=n.upliftable,g=n.additionalPropertyEquity,f=n.primaryPropertyEquity,m=n.partnerAdditionalPropertyEquity,v=n.savings,h=n.shareHoldings,y=n.tariff,P=n.ifNoProtectedCohabitants,C=function(n){return y(e.capitalLimit,e.capitalTariff[n])},w=[v,h,g],I={grossIncome:{retirementPension:[o],incomeSupportPayment:[o],incapacityBenefit:[o],employmentSupport:[o],jobSeekersAllowance:[o],industrialInjuriesBenefit:[o],boardingIncome:[o],rentalIncome:[o],workingTaxCredit:[o],childTaxCredit:[o],maintenance:[o],warPension:[o],warWidowsPension:[o],warSpecialPayment:[o],childBenefit:[o],carersAllowance:[o],pensionGuaranteeCredit:[o],pensionSavingsCredit:[o],charitableIncome:[o],housingBenefit:[o],trustIncome:[o],bondIncome:[o],wages:[u],privatePensions:[c],otherBenefit:[d],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare","transitionalProtection"])],attendanceAllowance:[p],pipDailyLiving:[p],dlaCare:[p],mobilityAllowance:[p],capitalTariff:a(a([],w,!0),[C("nonResidential")],!1)}},O=[v,h,m];return{incomeLookup:{default:{grossIncome:t({},I.grossIncome),additionalPropertyEquity:[g],totalCapital:a([],w,!0),capitalTariff:a(a([],w,!0),[C("nonResidential")],!1),qualifyingIncome:[r]},week13Residential:{grossIncome:t(t({},I.grossIncome),{capitalTariff:[[f,P],a(a([],w,!0),[C("nonResidential")],!1)]}),totalCapital:[[f,P],a([],w,!0)],capitalTariff:[[f,P],a([],w,!0),C("week13Residential")]}},partnerIncomeLookup:{default:{grossIncome:t(t({},I.grossIncome),{privatePensions:[c],pensionSavingsCredit:[r],workingTaxCredit:[s],wages:[r]}),totalCapital:a([],O,!0),capitalTariff:a(a([],O,!0),[C("nonResidential")],!1),qualifyingIncome:[r]}}}}},18713:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(18962),a=r(18962);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e).partnerTransfer,r=(0,a.getIncomeFunctions)(e),i=r.minZero;return{lookup:{default:{partnerTransfer:[r.zero]},nonResidential:{partnerTransfer:[n,i]}}}}},28116:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance||(a.universalCreditBreakdown||{}).carer,s="yes"===i.receivesCarersAllowanceForSomeoneElse,l="yes"===i.receivesUCCarerElement;return r+((o||l||s)&&e.carersPremium||0)}})}},86478:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(54341),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},82841:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e);return t(t({},c),{trust:function(e){var n=e.amount;return e.parameters.incomeFields.trustIncomeIsAbsolute?0:n},bonds:function(e){var n=e.amount;return e.parameters.incomeFields.bondIncomeIsLifeAssured?0:n}})}},13752:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(54341),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{shareWithPartner:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerCohabits,i=!0===r.partnerDetailsFields.partnerReceivesResidentialCare;return t&&a&&!i?n/2:n},round:function(e){var n=e.amount;return r.roundUp(n)},washingPerWeek:function(n){var r=n.parameters.dreExpensesFields.washingPerWeek,t=void 0===r?0:r;return(e.washingAllowancePerWash||0)*t}})}},91648:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(54341),o=r(24609),s=r(32954),l=r(56822);n.getIncomeFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultIncomeHelpers)(c,u,e);return t({},d)}},94796:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{partnerTransfer:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=0,o=r.workings||{},s=o.partnerDisregardsTotal,l=void 0===s?0:s,u=o.partnerGrossIncome,c=void 0===u?0:u,d=o.plaRate,p=void 0===d?0:d,g=o.expensesTotal,f=p+(void 0===g?0:g)-(c-l);return f>0&&(i=f),n+i}})}},18962:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getAllowances=n.getExpensesAboveThreshold=n.getDREs=n.getPartnerDisregards=n.getDisregards=n.getPartnerIncome=n.getIncome=void 0;var t=r(88893);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}});var a=r(42030);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(42525);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}}),Object.defineProperty(n,"getExpensesAboveThreshold",{enumerable:!0,get:function(){return i.getExpensesAboveThreshold}});var o=r(27297);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(8585);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(46503);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(78637);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(82262);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(8889);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(58081);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(18713);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(15403);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(91648);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(82841);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(13752);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(28116);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(94796);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(86478);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(57388);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(23901);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},23901:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel;return{getAllowanceTypeProcessor:function(e){var n=e.hasPartner,r=e.dependentChildrenCount,a=e.partnerDetailsFields.partnerReceivesResidentialCare,i=n?a?"singleServiceUser":"coupleServiceUser":r>0?"loneParentUser":"singleServiceUser";return t(t({},e),{allowanceType:i})},getDisabilityLevelProcessor:function(e){var r,a,i=e.incomeFields,o=n(i),s=i.hasUniversalCredit&&(null!==(a=null===(r=i.universalCreditBreakdown)||void 0===r?void 0:r.limitedWorkAndRelatedCapability)&&void 0!==a?a:0)>0,l=i.employmentSupport||0,u=i.employmentSupportGroup||"";return s&&(o="edp"),l>0&&"Support"===u&&"base"===o&&(o="dp"),t(t({},e),{disabilityLevel:o})}}}},30147:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.hampshire=void 0;var t=r(6639),a=r(54341);n.hampshire={calculator:t.calculator,getConstants:a.getConstants}},5318:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(14530),i=r(94957),o=r(89987),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u=!1,c={},d={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerDisregard:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0},p={},g=(e.person.intro||{}).provideFinancialDetails;if("agree"===g||"savingsDropped"===g){var f=(0,i.getQualifyingIncome)(e,r,l);d=Object.assign(d,f);var m=(0,i.getIncome)(e,r,l,d);d=Object.assign(d,m);var v=l.fullCostCapitalLimit[r],h=(m.totalCapital||0)>=v,y=d.additionalPropertyEquity||0;(h||y)&&(u=!0);var P=(0,i.getDisregards)(e,r,l,d);d=Object.assign(d,P);var C=(0,o.getExpenses)(e,r);d=Object.assign(d,C);var w=(0,i.getDREs)(e,r,l,d);d=Object.assign(d,w),c=Object.assign(c,{expensesAboveMaxThreshold:(0,i.getExpensesAboveThreshold)(e,r,l,d)});var I=(0,i.getAllowances)(e,r,l,d);d=Object.assign(d,I);var O=(0,i.getPartnerTransfer)(e,r,l,d);d=Object.assign(d,O);var b=(0,i.getEntitlements)(e,r,l,d);p=Object.assign(p,b)}else u=!0;for(var A in c=Object.assign(c,{fullCost:u}),d)if(Object.prototype.hasOwnProperty.call(d,A)){var T=d[A]||0;d[A]=s.roundNearest(T)}return(0,i.getCostOfCare)(e,r,l,d,c,p)}},2859:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{carephone:"carephone",nonResidential:"nonResidential",respite:"respite",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},maxContribution:{carephone:Number.POSITIVE_INFINITY,nonResidential:Number.POSITIVE_INFINITY,respite:Number.POSITIVE_INFINITY,week1Residential:Number.POSITIVE_INFINITY,week5Residential:Number.POSITIVE_INFINITY,week13Residential:Number.POSITIVE_INFINITY},warPensionDisregard:0,warSpecialPaymentDisregard:0,disabilityBenefits:{low:{amount:0},medium:{amount:0},high:{amount:0}},attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{carephone:0,nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{carephone:0,nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,partnerCapitalLimit:0,partnerCapitalTariff:0,partnersEarningsDisregarded:0,childPremium:0,carersPremium:0,sdpPremium:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:Number.POSITIVE_INFINITY,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:Number.POSITIVE_INFINITY,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},pensionGuaranteeCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},pensionGuaranteeCreditEntitlements:{base:{single:0,couple:0},sdp:0,carer:0},dreCaps:{domesticHelp:0,gardening:0},dreThresholds:{waterRates:0},heatingCosts:{applicant:{flat:Number.POSITIVE_INFINITY,terraced:Number.POSITIVE_INFINITY,semiDetached:Number.POSITIVE_INFINITY,detached:Number.POSITIVE_INFINITY},eachExtraPerson:{flat:Number.POSITIVE_INFINITY,terraced:Number.POSITIVE_INFINITY,semiDetached:Number.POSITIVE_INFINITY,detached:Number.POSITIVE_INFINITY}},washingExcessPremium:0,configuration:{calculatorConfig:{}}}},14530:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.y2425=n.y2324=n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(2859),i=r(68127);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(54021);Object.defineProperty(n,"y2324",{enumerable:!0,get:function(){return o.latest}});var s=r(91001);Object.defineProperty(n,"y2425",{enumerable:!0,get:function(){return s.latest}}),n.annualRatesLookupRules=[{start:"2023-04-10",end:"2024-04-07",values:o.latest,label:"2023-2024"},{start:"2024-04-08",end:"2025-04-06",values:s.latest,label:"2024-2025",isBackdatingDefault:!0},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var l=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),l=(0,t.applyOptions)({constants:l,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return l}},68127:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={maxContribution:{carephone:10.26,nonResidential:5e3,respite:5e3,week1Residential:5e3,week5Residential:5e3,week13Residential:5e3},warPensionDisregard:10,warSpecialPaymentDisregard:121.26,disabilityBenefits:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{carephone:23250,nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{carephone:250,nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,partnerCapitalLimit:1e4,partnerCapitalTariff:200,partnersEarningsDisregarded:.45,childPremium:102.95,sdpPremium:0,carersPremium:53.25,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}},partnerNonResidential:{under25:{base:144.65,dp:61.65,edp:30.25},over25:{base:144.65,dp:61.65,edp:30.25},pensionAge:{base:332.95,dp:0,edp:0}},partnerRespite:{under25:{base:72.9,dp:43.2,edp:21.2},over25:{base:92.05,dp:43.2,edp:21.2},pensionAge:{base:227.1,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,DISREGARD_MAX:10.6}},pensionGuaranteeCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:218.15,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:81.5}},pensionGuaranteeCreditEntitlements:{base:{single:227.1,couple:346.6},sdp:82.9,carer:46.4},dreCaps:{domesticHelp:60,gardening:25},dreThresholds:{waterRates:11.55},heatingCosts:{applicant:{flat:37.88,terraced:37.88,semiDetached:40.24,detached:48.95},eachExtraPerson:{flat:12.1,terraced:12.1,semiDetached:12.88,detached:15.58}},washingExcessPremium:5.96}},54021:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={maxContribution:{carephone:6.3,nonResidential:5e3,respite:5e3,week1Residential:5e3,week5Residential:5e3,week13Residential:5e3},warPensionDisregard:10,warSpecialPaymentDisregard:111.74,disabilityBenefits:{low:26.9,medium:68.1,high:101.75},mobilityAllowance:{low:26.9,high:71},fullCostCapitalLimit:{carephone:23250,nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{carephone:250,nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,partnerCapitalLimit:1e4,partnerCapitalTariff:200,partnersEarningsDisregarded:.45,childPremium:94.9,carersPremium:49.05,sdpPremium:76.4,residentialPEA:28.25,livingAllowancesMap:{singleServiceUser:{under25:{base:82.15,dp:45.75,edp:22.35},over25:{base:103.65,dp:45.75,edp:22.35},pensionAge:{base:214.35,dp:0,edp:0}},coupleServiceUser:{under25:{base:81.4,dp:32.6,edp:16.05},over25:{base:81.4,dp:32.6,edp:16.05},pensionAge:{base:163.65,dp:0,edp:0}},partnerNonResidential:{under25:{base:133.3,dp:56.8,edp:27.9},over25:{base:133.3,dp:56.8,edp:27.9},pensionAge:{base:306.85,dp:0,edp:0}},partnerRespite:{under25:{base:67.2,dp:39.85,edp:19.55},over25:{base:84.8,dp:39.85,edp:19.55},pensionAge:{base:201.05,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:174.49,INCOME_HIGH:201.05,DISREGARD_MAX:6.5},applicantAndPartner:{INCOME_LOW:277.12,INCOME_HIGH:306.85,DISREGARD_MAX:9.75}},pensionGuaranteeCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:201.05,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:76.4}},pensionGuaranteeCreditEntitlements:{base:{single:201.05,couple:306.85},sdp:76.4,carer:42.75},dreCaps:{domesticHelp:0,gardening:0},dreThresholds:{waterRates:0},heatingCosts:{applicant:{flat:Number.POSITIVE_INFINITY,terraced:Number.POSITIVE_INFINITY,semiDetached:Number.POSITIVE_INFINITY,detached:Number.POSITIVE_INFINITY},eachExtraPerson:{flat:Number.POSITIVE_INFINITY,terraced:Number.POSITIVE_INFINITY,semiDetached:Number.POSITIVE_INFINITY,detached:Number.POSITIVE_INFINITY}},washingExcessPremium:0}},91001:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={maxContribution:{carephone:10.26,nonResidential:5e3,respite:5e3,week1Residential:5e3,week5Residential:5e3,week13Residential:5e3},warPensionDisregard:10,warSpecialPaymentDisregard:119.23,disabilityBenefits:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{carephone:23250,nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{carephone:250,nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,partnerCapitalLimit:1e4,partnerCapitalTariff:200,partnersEarningsDisregarded:.45,childPremium:101.25,sdpPremium:0,carersPremium:52.35,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:34.8,edp:17.15},over25:{base:86.85,dp:34.8,edp:17.15},pensionAge:{base:174.6,dp:0,edp:0}},partnerNonResidential:{under25:{base:142.25,dp:60.6,edp:29.75},over25:{base:142.25,dp:60.6,edp:29.75},pensionAge:{base:332.95,dp:0,edp:0}},partnerRespite:{under25:{base:71.7,dp:42.5,edp:20.85},over25:{base:90.5,dp:42.5,edp:20.85},pensionAge:{base:218.15,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:301.22,INCOME_HIGH:332.95,DISREGARD_MAX:10.4}},pensionGuaranteeCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:218.15,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:81.5}},pensionGuaranteeCreditEntitlements:{base:{single:218.15,couple:332.95},sdp:81.5,carer:45.6},dreCaps:{domesticHelp:0,gardening:0},dreThresholds:{waterRates:0},heatingCosts:{applicant:{flat:Number.POSITIVE_INFINITY,terraced:Number.POSITIVE_INFINITY,semiDetached:Number.POSITIVE_INFINITY,detached:Number.POSITIVE_INFINITY},eachExtraPerson:{flat:Number.POSITIVE_INFINITY,terraced:Number.POSITIVE_INFINITY,semiDetached:Number.POSITIVE_INFINITY,detached:Number.POSITIVE_INFINITY}},washingExcessPremium:0}},96759:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.share=n.full=void 0;var t=new(r(32954).NumberUtilsService);function a(e){return t.roundUp(e)}n.full=function(e){return a(e.amount)},n.share=function(e){var n=e.amount*(e.hasPartner?50:100)/100;return Math.max(0,a(n))}},89987:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getOwnershipStatus=n.getPartnerArrangement=void 0;var t=r(91569),a=(0,r(14530).getConstants)().configuration,i=r(77757);n.getPartnerArrangement=function(e){return e.hasPartner?"cohabitingPartner":"single"};n.getOwnershipStatus=function(e){e.propertyOwnership;return"any"},n.getExpenses=function(e,r){return(0,t.expensesCalculator)(a,e,r,i.housingExpenses,{getPartnerArrangement:n.getPartnerArrangement,getOwnershipStatus:n.getOwnershipStatus})}},77757:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(96759);n.housingExpenses={nonResidential:{single:{any:{mortgage:[t.full],rent:[t.full],councilTax:[t.full],compulsoryCourtPayments:[t.full]}},cohabitingPartner:{any:{mortgage:[t.share],rent:[t.share],councilTax:[t.share],compulsoryCourtPayments:[t.full]}}},respite:{single:{any:{mortgage:[t.full],rent:[t.full],councilTax:[t.full],contentsInsurance:[t.full],groundRent:[t.full],waterRates:[t.full],compulsoryCourtPayments:[t.full]}},cohabitingPartner:{any:{mortgage:[t.share],rent:[t.share],councilTax:[t.share],contentsInsurance:[t.share],groundRent:[t.share],waterRates:[t.share],compulsoryCourtPayments:[t.full]}}},carephone:{single:{any:{mortgage:[t.full],rent:[t.full],councilTax:[t.full],compulsoryCourtPayments:[t.full]}},cohabitingPartner:{any:{mortgage:[t.share],rent:[t.share],councilTax:[t.share],compulsoryCourtPayments:[t.full]}}},week1Residential:{single:{any:{mortgage:[t.share],compulsoryCourtPayments:[t.full]}},cohabitingPartner:{any:{mortgage:[t.share],compulsoryCourtPayments:[t.full]}}},week5Residential:{single:{any:{mortgage:[t.share],compulsoryCourtPayments:[t.full]}},cohabitingPartner:{any:{mortgage:[t.share],compulsoryCourtPayments:[t.full]}}},week13Residential:{single:{any:{mortgage:[t.share],compulsoryCourtPayments:[t.full]}},cohabitingPartner:{any:{mortgage:[t.share],compulsoryCourtPayments:[t.full]}}}}},51479:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(88372);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getAllowanceTypeProcessor,p=c.getDisabilityLevelProcessor,g=c.getAgeLevelProcessor,f=(0,a.getParameters)(e,l);return f=(0,i.runProcessors)(f,r,{getAllowanceTypeProcessor:d,getDisabilityLevelProcessor:p,getAgeLevelProcessor:g}),(0,t.sharedCalculator)(n,s,f,u)},n.partnerCalculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getPartnerAllowanceType,p=c.getPartnerAgeLevel,g=c.getPartnerDisabilityLevel,f=(0,a.getPartnerParameters)(e,l);return f=(0,i.runProcessors)(f,r,{getDisabilityLevelProcessor:g(n),getAgeLevelProcessor:p(n),getAllowanceTypeProcessor:d(n)}),(0,t.sharedCalculator)(n,s,f,u)}},63320:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerAllowances=n.getAllowances=void 0;var t=r(94957),a=r(94957);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).partnerLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},42654:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(94957),a=r(94957);n.getCostOfCare=function(e,n,r,i,o,s){var l=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,u=(0,t.calculator)(e,n,r,l,i);return Object.assign({contributions:u,workings:i,entitlements:s},o)}},84647:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(94957),a=r(94957);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).disregardsLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).partnerDisregardsLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},67766:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpensesAboveThreshold=n.getDREs=void 0;var t=r(94957),a=r(74954),i=r(94957);n.getDREs=function(e,n,r,o){var s=(0,t.getDREConfig)(r).dreLookup,l=(0,i.getIncomeFunctions)(r).upliftable;return(0,t.calculator)(e,n,r,s,o,{getRollup:function(e,t){if(n===r.careTypes.nonResidential){var i=e.dreTotal;if(!(l({amount:0,key:"disabilityBenefits",parameters:t})>0))return{dreTotal:0};var o=i.approvedDRE,s=void 0===o?0:o;if(s>0)return{dreTotal:s}}return(0,a.getRollup)(e)}})};n.getExpensesAboveThreshold=function(e,n,r,a){var i=(0,t.getDREConfig)(r).dreLimitLookup;return(0,t.calculator)(e,n,r,i,a,{getRollup:function(e){var n=[],t=e.dreTotal,a=r.dreCaps||{};return Object.entries(t).forEach((function(e){var r=e[0];e[1]>(a[r]||Number.POSITIVE_INFINITY)&&n.push(r)})),n}})}},66592:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getEntitlements=n.getPartnerIncome=n.getQualifyingIncome=n.getIncome=void 0;var a=r(94957),i=r(94957);n.getIncome=function(e,n,r,t){var o=(0,i.getIncomeConfig)(r).incomeLookup;return(0,a.calculator)(e,n,r,o,t)};n.getQualifyingIncome=function(e,n,r,t){var o=(0,i.getIncomeConfig)(r).qiLookup;return(0,a.calculator)(e,n,r,o,t)};n.getPartnerIncome=function(e,n,r,t){var o=(0,i.getIncomeConfig)(r).partnerIncomeLookup;return(0,a.partnerCalculator)(e,n,r,o,t)};n.getEntitlements=function(e,n,r,o){var s,l=(0,i.getIncomeConfig)(r),u=l.entitlementsLookup,c=l.entitlementsPeriods,d=(0,a.calculator)(e,n,r,u,o),p=t({},null!==(s=c.default)&&void 0!==s?s:{}),g=c[n],f=Object.assign({},p,g);return Object.keys(d).forEach((function(e){var n;d=t(t({},d),((n={})["".concat(e,"Period")]=f[e],n))})),d}},71270:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var t=r(94957),a=r(63320),i=r(66592),o=r(84647),s=r(94957);n.getPartnerTransfer=function(e,n,r,l){var u=!!(e.person.intro||{}).hasPartner,c=!!u&&!0===((e.partner||{}).intro||{}).discloseFinances;if(!u||!c)return{partnerGrossIncome:0,partnerLivingAllowanceTotal:0,partnerTransfer:0};var d=(0,i.getPartnerIncome)(e,n,r),p=d.grossIncome,g=d.totalCapital,f=d.capitalTariff,m=(0,o.getPartnerDisregards)(e,n,r,d).disregardsTotal,v=(0,a.getPartnerAllowances)(e,n,r,l).livingAllowanceTotal;l=Object.assign(l,{partnerGrossIncome:p,partnerTotalCapital:g,partnerCapitalTariff:f,partnerDisregardsTotal:m,partnerLivingAllowanceTotal:v});var h=(0,s.getPartnerTransferConfig)(r).lookup;return(0,t.calculator)(e,n,r,h,l)}},47632:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(94957),a=r(94957);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.child,u=n.carer,c=(0,a.getIncomeFunctions)(e).ratio;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[l],carerPremium:[u]},plaRate:[r,i,o],childPremium:[l],carerPremium:[u]},carephone:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[l],carerPremium:[u]},plaRate:[r,i,o],childPremium:[l],carerPremium:[u]}},partnerLookup:{default:{livingAllowanceTotal:{plaRate:[r,i,o]},plaRate:[r,i,o]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o,c(50)]},plaRate:[r,i,o,c(50)]},carephone:{livingAllowanceTotal:{plaRate:[r,i,o,c(50)]},plaRate:[r,i,o,c(50)]}}}}},27562:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(94957);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.fullCostContribution,o=r.fullCostIfMax,s=r.actualContribution,l=r.cap,u=r.round;return{costOfCareLookup:{default:{maxContribution:[a,l("nonResidential"),i("nonResidential",n),o("nonResidential",n),u],actualContribution:[a,l("nonResidential"),i("nonResidential",n),o("nonResidential",n),s("nonResidential"),u]},respite:{maxContribution:[a,l("respite"),i("respite",n),o("respite",n),u],actualContribution:[a,l("respite"),i("respite",n),o("respite",n),s("respite"),u]},carephone:{maxContribution:[a,l("carephone"),i("carephone",n),u],actualContribution:[a,l("carephone"),i("carephone",n),s("carephone"),u]},week1Residential:{maxContribution:[a,l("week1Residential"),i("week1Residential",n),o("week1Residential",n),u],actualContribution:[a,l("week1Residential"),i("week1Residential",n),o("week1Residential",n),s("week1Residential"),u]},week5Residential:{maxContribution:[a,l("week5Residential"),i("week5Residential",n),o("week5Residential",n),u],actualContribution:[a,l("week5Residential"),i("week5Residential",n),o("week5Residential",n),s("week5Residential"),u]},week13Residential:{maxContribution:[a,l("week13Residential"),i("week13Residential",n),o("week13Residential",n),u],actualContribution:[a,l("week13Residential"),i("week13Residential",n),o("week13Residential",n),s("week13Residential"),u]}}}}},93487:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(94957),i=r(94957);n.getDisregardsConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.cap,o=n.joint,s=n.full,l=n.wages,u=n.upliftable,c=n.pensions,d=n.zero,p=(0,i.getDisregardsFunctions)(e),g=p.db,f=p.zeroIfOwnsProperty,m=p.halfIfCouple,v=p.psc,h=p.singlePSC,y=p.partnerWageDisregard,P=p.sdpPremium,C={earningsFromPaidEmployment:[s],wages:[l],privatePensions:[c,p.disregardTransferredPension],disabilityBenefits:[u],mobilityAllowance:[u],childBenefit:[s],warDisablementPension:[s],warSpecialPayment:[s,r(e.warSpecialPaymentDisregard)],warPension:[s,r(e.warPensionDisregard)],pensionSavingsCredit:[o,v]};return{disregardsLookup:{default:{disregardsTotal:t({},C)},nonResidential:{disregardsTotal:t(t({},C),{privatePensions:[d],pensionSavingsCredit:[o,m],disabilityBenefits:[u,g]})},carephone:{disregardsTotal:t(t({},C),{wages:[d],privatePensions:[d],pensionSavingsCredit:[o,m],disabilityBenefits:[u,g]})},respite:{disregardsTotal:t(t({},C),{pensionSavingsCredit:[s,v]})},week1Residential:{disregardsTotal:t(t({},C),{disabilityBenefits:[d],pensionSavingsCredit:[s,h]})},week5Residential:{disregardsTotal:t(t({},C),{disabilityBenefits:[u],pensionSavingsCredit:[s,h],sdpDisregard:[P]})},week13Residential:{disregardsTotal:t(t({},C),{disabilityBenefits:[u,f],pensionSavingsCredit:[s,h],sdpDisregard:[P]})}},partnerDisregardsLookup:{default:{disregardsTotal:{wages:[l,y],earningsFromPaidEmployment:[s,y],childBenefit:[s],warDisablementPension:[s]}}}}}},58094:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(94957);n.getDREConfig=function(e){var n=(0,t.getDREFunctions)(e),r=n.periodicExpense,a=n.annualExpense,i=n.limit,o=n.dre,s=n.washingPerWeek,l=n.fuel,u=n.ifApproved,c=n.ratio,d=n.shareWithAdults,p=n.threshold;return{dreLookup:{default:{dreTotal:[(0,t.getIncomeFunctions)(e).zero]},nonResidential:{dreTotal:{gardening:[a,c(75),i,u],fuel:[r,l,u],waterRates:[r,p,d,u],domesticHelp:[r,i,u],washingPerWeek:[s,u],approvedDRE:[o]}}},dreLimitLookup:{default:{dreTotal:{}},nonResidential:{dreTotal:{gardening:[a],fuel:[r],waterRates:[r],domesticHelp:[r]}}}}}},60176:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var a=r(50237),i=r(94957);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.zero,o=n.round,s=n.full,l=n.fullPartner,u=n.joint,c=n.jointBenefits,d=n.jointIfCouple,p=n.halfOfSU,g=n.wages,f=n.partnerWages,m=n.pensions,v=n.otherBenefit,h=n.upliftable,y=n.individualCapital,P=n.jointCapital,C=n.additionalPropertyEquity,w=n.savings,I=n.shareHoldings,O=n.tariff,b=n.disposedAssets,A=n.ucRollup,T=n.ucDeductionRollup,R=n.partnerUcRollup,_=n.partnerUcDeductionRollup,E=n.partnerPensions,D=n.onlyIfJoint,L=n.partnerOtherBenefit,S=n.pgc,N=n.singlePGC,k=n.sdpAndCarerPGC,j=n.singleSDPAndCarerPGC,M=n.singleSDPPGC,x=n.deductQI,F=n.partnerSavings,H=n.partnerShareHoldings,B=["standardAllowance","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","transitionalProtection"],W=["other","earnings","capitalTariff","benefitLimit"],Y=function(n){return O(e.capitalLimit,e.capitalTariff[n])},G=function(e){return O(1e4,500)},U={wages:[g],earningsFromPaidEmployment:[s],privatePension:[s],privatePensions:[m],incapacityBenefit:[s],retirementPension:[s],warPension:[s],warDisablementPension:[s],carersAllowance:[s],workingTaxCredit:[s],otherBenefit:[v],universalCreditBreakdown:[[A(B,!0),T(W,!0)]],capitalTariff:[y,P,w,I,G()]},V={wages:[g,f],earningsFromPaidEmployment:[s,l],privatePension:[s,l],privatePensions:[m,E],incapacityBenefit:[s,l],retirementPension:[s,l],warPension:[s,l],warDisablementPension:[s,l],carersAllowance:[s,l],workingTaxCredit:[s,l],otherBenefit:[v,L],universalCreditBreakdown:[[A(B,!0),T(W,!0)],[R(B,!0),_(W)]],capitalTariff:[y,P,w,I,F,H,G()]},Z={privatePensions:[m,E],universalCreditBreakdown:[[A(B,!0),T(W,!0),D],[R(B),_(W)]],retirementPension:[s,l],warPension:[[s,D],l],warSpecialPayment:[[s,D],l],carersAllowance:[[s,D],l],childBenefit:[[s,D],l],warDisablementPension:[[s,D],l],incapacityBenefit:[[s,D],l],pensionSavingsCredit:[[s,D],l],otherBenefit:[[v,L],D],capitalTariff:[y,P,C,w,I,b,Y("nonResidential")]},J=[A(B),T(W)],q={grossIncome:{retirementPension:[s],warPension:[s],warSpecialPayment:[s],carersAllowance:[s],childBenefit:[s],warDisablementPension:[s],incapacityBenefit:[u],workingTaxCredit:[d],pensionSavingsCredit:[d],pensionGuaranteeCredit:[d],earningsFromPaidEmployment:[s],wages:[g],privatePensions:[m],otherBenefit:[v],universalCreditBreakdown:J,disabilityBenefits:[h],mobilityAllowance:[h],privatePension:[s],capitalTariff:[y,P,C,w,[I],b,Y("nonResidential")]}},X={default:{qualifyingIncome:Z,pgcQualifyingIncome:U},nonResidential:{qualifyingIncome:t(t({},Z),{privatePensions:[r],universalCreditBreakdown:[r],retirementPension:[r],warPension:[r],warSpecialPayment:[r],carersAllowance:[r],childBenefit:[r],warDisablementPension:[r],incapacityBenefit:[r],pensionSavingsCredit:[r]}),pgcQualifyingIncome:V},carephone:{qualifyingIncome:t(t({},Z),{privatePensions:[r],universalCreditBreakdown:[r],retirementPension:[r],warPension:[r],warSpecialPayment:[r],carersAllowance:[r],childBenefit:[r],warDisablementPension:[r],incapacityBenefit:[r],pensionSavingsCredit:[r]}),additionalPropertyEquity:[r],pgcQualifyingIncome:V},respite:{qualifyingIncome:Z,pgcQualifyingIncome:V}};return{qiLookup:X,incomeLookup:{default:t({grossIncome:t({},q.grossIncome),additionalPropertyEquity:[C],totalCapital:[y,P,C,w,I,b],capitalTariff:[y,P,C,w,I,b,Y("nonResidential")],universalCreditBreakdown:J},X.default),nonResidential:t({grossIncome:t(t({},q.grossIncome),{workingTaxCredit:[r],privatePensions:[m]}),additionalPropertyEquity:[r],universalCreditBreakdown:J},X.nonResidential),carephone:t({grossIncome:t(t({},q.grossIncome),{workingTaxCredit:[r],privatePensions:[m]}),additionalPropertyEquity:[r],universalCreditBreakdown:J},X.carephone),respite:t({grossIncome:t({},q.grossIncome),totalCapital:[y,P,C,w,I,b],capitalTariff:[y,P,C,w,I,b,Y("nonResidential")],additionalPropertyEquity:[r],universalCreditBreakdown:J},X.respite),week1Residential:t({grossIncome:t({},q.grossIncome),additionalPropertyEquity:[C],totalCapital:[y,P,C,w,I,b],capitalTariff:[y,P,C,w,I,b,Y("nonResidential")],universalCreditBreakdown:J},X.default)},partnerIncomeLookup:{default:{grossIncome:t(t({},q.grossIncome),{incapacityBenefit:[c],privatePensions:[m],workingTaxCredit:[d,p],pensionSavingsCredit:[d,p],pensionGuaranteeCredit:[d,p],disabilityBenefits:[r],mobilityAllowance:[r],universalCreditBreakdown:[[A(B,!0),T(W,!0),D],[R(B),_(W)]],capitalTariff:[r]})},nonResidential:{grossIncome:t(t({},q.grossIncome),{incapacityBenefit:[c],pensionGuaranteeCredit:[d,p],privatePensions:[m],workingTaxCredit:[r],disabilityBenefits:[r],mobilityAllowance:[r],universalCreditBreakdown:[[A(B,!0),T(W,!0),D],[R(B),_(W)]],capitalTariff:[r]})},carephone:{grossIncome:t(t({},q.grossIncome),{incapacityBenefit:[c],pensionGuaranteeCredit:[d,p],privatePensions:[m],workingTaxCredit:[r],disabilityBenefits:[r],mobilityAllowance:[r],universalCreditBreakdown:[[A(B,!0),T(W,!0),D],[R(B),_(W)]],capitalTariff:[r]})},respite:{grossIncome:t(t({},q.grossIncome),{incapacityBenefit:[c],privatePensions:[m],workingTaxCredit:[d,p],pensionSavingsCredit:[d,p],pensionGuaranteeCredit:[d,p],disabilityBenefits:[r],mobilityAllowance:[r],universalCreditBreakdown:[[A(B,!0),T(W,!0),D],[R(B),_(W)]],capitalTariff:[r]})}},entitlementsLookup:{default:{pensionGuaranteeCredit:[N,M,x,o]},nonResidential:{pensionGuaranteeCredit:[S,k,x,o]},carephone:{pensionGuaranteeCredit:[S,k,x,o]},respite:{pensionGuaranteeCredit:[S,k,x,o]},week1Residential:{pensionGuaranteeCredit:[N,j,x,o]}},entitlementsPeriods:{default:{pensionGuaranteeCredit:a.PERIODS.Weekly}}}}},88706:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(94957),a=r(94957);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e),r=n.partnerTransfer,i=n.deductPension,o=(0,a.getIncomeFunctions)(e),s=o.pensions,l=o.transferredPensionForPartner,u=o.minZero;return{lookup:{default:{partnerTransfer:[r,[s,l,i],u]},nonResidential:{partnerTransfer:[r,u]}}}}},32499:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance,s="yes"===i.carersAllowanceIsEntitled;return r+(o||s?e.carersPremium:0)},child:function(n){var r=n.amount,t=n.parameters,a=t.introFields,i=t.dependentChildrenCount;return r+(a.dependentChildrenLivingInProperty||i||0)*e.childPremium}})}},9365:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(14530),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t(t({},d),{actualContribution:function(e){return function(n){var t=n.amount,a=(n.parameters.fields.careAssessment||{})[e],i=void 0!==a?a.cost:void 0;return null===i?Number.POSITIVE_INFINITY:void 0!==i&&r.isNumeric(i)?(i>t&&(i=t),i):Number.POSITIVE_INFINITY}},fullCostIfMax:function(n,r){void 0===r&&(r={});var t=(e.maxContribution||{})[n];return function(e){var n=e.amount;e.parameters;return n>=t?Number.POSITIVE_INFINITY:n}}})}},48770:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(5416),i=r(24609),o=r(32954),s=r(56822),l=r(73378),u=r(94957);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,c=new s.CareAssessmentService(r,n),d=new i.Helpers(n),p=(0,l.getDefaultDisregardsHelpers)(d,c,e),g=(0,u.getIncomeFunctions)(e),f=g.getPGCCriteria,m=g.simpleIncome,v=function(n){void 0===n&&(n=!1);var r=e.pensionSavingsCreditIncomeThreshold,t=r?r.singleApplicant:{};return n&&(t=r&&r.applicantAndPartner||{}),t},h=function(n){var r=n.amount,t=n.parameters,i=t.workings,o=void 0===i?{}:i,s=t.hasPartner,l=void 0!==s&&s,u=t.suDOB,d=r>0,p=o.qualifyingIncome||0,g=c.getAgeLevel(u,e.levels,e.overridePensionAge,e.configuration.effectiveDate).level,f=v(l),m=a("05/04/1953","DD/MM/YYYY"),h=a(u,"DD/MM/YYYY");return m.diff(h,"days")<=0||g!==e.levels.high||p<f.INCOME_LOW?0:p>=f.INCOME_LOW&&p<f.INCOME_HIGH?d?Math.min(r||0,f.DISREGARD_MAX):f.DISREGARD_MAX:(f.INCOME_HIGH,f.DISREGARD_MAX)};return t(t({},p),{db:function(n){var r=n.amount,t=e.disabilityBenefits||{},a=t.high,i=void 0===a?{amount:0}:a,o=t.medium,s=void 0===o?{amount:0}:o;return r===i.amount?i.amount-s.amount:0},halfIfCouple:function(e){var n=e.amount,r=e.parameters;return!0===r.incomeFields.benefitsPaidAsCouple||n&&r.hasPartner&&(n/=2),n},singlePSC:function(e){var n=e.amount,r=e.parameters,t=h({amount:n,parameters:r}),a=v(!1);return Math.min(a.DISREGARD_MAX,t)},psc:function(e){var n=e.amount,r=e.parameters;return h({amount:n,parameters:r})},partnerWageDisregard:function(n){var r=n.amount;n.parameters;return r?r*(e.partnersEarningsDisregarded||0):0},sdpPremium:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=f(t),s=o.bornBeforeCutoff,l=o.applicantHighDisabilityLevel;if(s){var u=(e.pensionGuaranteeCreditIncomeThreshold||{}).singleApplicant||{},c=m("pensionGuaranteeCredit",t.incomeFields),d=(e.pensionGuaranteeCreditEntitlements||{}).sdp||0;l&&((i.pgcQualifyingIncome||0)>u.INCOME_LOW?r=Math.min(d,c):c>=d&&(r=d||0))}return r},disregardTransferredPension:function(e){var n=e.amount;return e.parameters.hasPartner?n/2:0}})}},40477:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(14530),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e),p=(0,a.getDefaultIncomeHelpers)(c,u,e).ratio;return t(t({},d),{ifApproved:function(e){var n=e.amount,r=e.parameters.dreExpensesFields.individualDRESApproved;return void 0!==r&&r?n:0},dre:function(e){var n=e.amount,r=e.parameters.dreExpensesFields,t=r.hasApprovedDRE?c.getWeeklyAmount(r,"approvedDRE"):0;return t>0&&(n=t),n},washingPerWeek:function(n){return(n.parameters.dreExpensesFields.excessLaundry||!1)&&e.washingExcessPremium||0},fuel:function(n){var r,t=n.amount,a=n.parameters,i=a.propertyFields,o=a.hasPartner,s=a.peopleLivingWithYou,l=(s.hasOtherPeople?(s.otherPeople||[]).length:0)+(o?2:1),u=Math.min(l,2),c=i.propertyType;(r=(e.heatingCosts||{}).applicant[c]||0,u>1)&&(r+=(u-1)*((e.heatingCosts||{}).eachExtraPerson[c]||0));return Math.max((t-r)/u,0)},ratio:p,shareWithAdults:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.peopleLivingWithYou;return n/((a.hasOtherPeople?(a.otherPeople||[]).length:0)+(t?2:1))}})}},1019:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=function(n){var r=n.fields,t=n.hasPartner,a=void 0!==t&&t,i=n.suDOB,o=n.introFields,s=n.partnerDisclosesFinances,u=r.person.income||{},c=(r.partner||{}).income||{},d=e.overridePensionAge;return{hasPartner:a,partnerDisclosesFinances:s,bornBeforeCutoff:"high"===l.getAgeLevel(i,e.levels,d).level,receivesPensionGuaranteeCredit:(u.pensionGuaranteeCredit||0)>0,applicantHighDisabilityLevel:u.disabilityBenefits===e.levels.high||u.disabilityBenefits===e.levels.medium,partnerHighDisabilityLevel:c.disabilityBenefits===e.levels.high||c.disabilityBenefits===e.levels.medium,applicantCarersAllowance:u.carersAllowance||0,partnerCarersAllowance:c.carersAllowance||0,applicantEntitledToCarersAllowance:"yes"===o.carersAllowanceIsEntitled}},d=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},d),{round:function(e){var n=e.amount;return r.roundDown(n)},disposedAssets:function(e){var n;return e.amount+(null!==(n=e.parameters.disposedAssets.assetValue)&&void 0!==n?n:0)},joint:function(e){var n=e.amount,r=e.key,t=e.parameters,a=r,i=!0===t.incomeFields.benefitsPaidAsCouple||!0===t.partnerIncomeFields.benefitsPaidAsCouple,o="".concat(r,"Period"),l=t.incomeFields[o];void 0===l&&(l=s.PERIODS.Weekly);var c=u.getWeeklyAmount(t.incomeFields,a,{period:l});return n+(c=i?c/2:c)},jointBenefits:function(e){var n=e.amount,r=e.key,t=e.parameters,a=r,i=!0===t.incomeFields.benefitsPaidAsCouple||!0===t.partnerIncomeFields.benefitsPaidAsCouple,o="".concat(r,"Period"),l=t.incomeFields[o];void 0===l&&(l=s.PERIODS.Weekly);var c=u.getWeeklyAmount(t.incomeFields,a,{period:l});c=i?c/2:c,void 0===(l=t.partnerIncomeFields[o])&&(l=s.PERIODS.Weekly);var d=u.getWeeklyAmount(t.partnerIncomeFields,a,{period:l});return n+(c+(d=i?d/2:0))},halfOfSU:function(e){var n=e.amount,r=e.key,t=e.parameters,a=r,i=!0===t.hasPartner,o="".concat(r,"Period"),l=t.partnerIncomeFields[o];void 0===l&&(l=s.PERIODS.Weekly);var c=u.getWeeklyAmount(t.partnerIncomeFields,a,{period:l});return n+(c=i?c/2:0)},jointIfCouple:function(e){var n=e.amount,r=e.key,t=e.parameters,a=r,i=!0===t.hasPartner,o="".concat(r,"Period"),l=t.incomeFields[o];void 0===l&&(l=s.PERIODS.Weekly);var c=u.getWeeklyAmount(t.incomeFields,a,{period:l});return n+(c=i?c/2:c)},onlyIfJoint:function(e){var n=e.amount;return!0===e.parameters.hasPartner?n:0},ucRollup:function(e,n){return void 0===e&&(e=[]),void 0===n&&(n=!1),function(r){var t=r.amount,a=r.parameters,i=Object.keys(a.incomeFields.universalCreditBreakdown||{}).reduce((function(r,t){if(!e.includes(t))return r;var i=(a.incomeFields.universalCreditBreakdown||{})[t]||0;return r+(!n&&a.hasPartner?i/2:i)}),0);return t+l.toWeeklyAmount(i,s.PERIODS.Monthly)}},ucDeductionRollup:function(e,n){return void 0===e&&(e=[]),void 0===n&&(n=!1),function(r){var t=r.amount,a=r.parameters,i=Object.keys(a.incomeFields.universalCreditBreakdown||{}).reduce((function(r,t){if(!e.includes(t))return r;var i=(a.incomeFields.universalCreditBreakdown||{})[t]||0;return r+(!n&&a.hasPartner?i/2:i)}),0),o=l.toWeeklyAmount(i,s.PERIODS.Monthly);return Math.max(0,t-o)}},partnerUcRollup:function(e,n){return void 0===e&&(e=[]),void 0===n&&(n=!1),function(r){var t=r.amount,a=r.parameters,i=Object.keys(a.partnerIncomeFields.universalCreditBreakdown||{}).reduce((function(r,t){if(!e.includes(t))return r;var i=(a.partnerIncomeFields.universalCreditBreakdown||{})[t]||0;return r+(!n&&a.hasPartner?i/2:i)}),0);return t+l.toWeeklyAmount(i,s.PERIODS.Monthly)}},partnerUcDeductionRollup:function(e){return void 0===e&&(e=[]),function(n){var r=n.amount,t=n.parameters,a=Object.keys(t.partnerIncomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var a=(t.partnerIncomeFields.universalCreditBreakdown||{})[r]||0;return n+(t.hasPartner?a/2:a)}),0),i=l.toWeeklyAmount(a,s.PERIODS.Monthly);return Math.max(0,r-i)}},additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){return(n.equity||0)+e}),0)},individualCapital:function(e){return e.amount+(e.parameters.capitalFields.individual||0)},jointCapital:function(e){return e.amount+(e.parameters.capitalFields.joint||0)/2},getPGCCriteria:c,pgc:function(n){var r=n.amount,t=n.parameters,a=c(t),i=a.hasPartner,o=a.partnerDisclosesFinances,s=a.bornBeforeCutoff,l=a.receivesPensionGuaranteeCredit;if(s&&l){var u=e.pensionGuaranteeCreditEntitlements||{};r+=i&&o?u.base.couple:u.base.single}return r},singlePGC:function(n){var r=n.amount,t=n.parameters,a=c(t),i=a.bornBeforeCutoff,o=a.receivesPensionGuaranteeCredit;i&&(o&&(r+=(e.pensionGuaranteeCreditEntitlements||{}).base.single));return r},sdpAndCarerPGC:function(n){var r=n.amount,t=n.parameters,a=c(t),i=a.bornBeforeCutoff,o=a.receivesPensionGuaranteeCredit,s=a.applicantHighDisabilityLevel,l=a.partnerHighDisabilityLevel,u=a.applicantCarersAllowance,d=a.partnerCarersAllowance,p=a.applicantEntitledToCarersAllowance;if(i&&o){var g=e.pensionGuaranteeCreditEntitlements||{};s&&(r+=g.sdp),l&&(r+=g.sdp),(u||p)&&(r+=g.carer),d&&(r+=g.carer)}return r},singleSDPAndCarerPGC:function(n){var r=n.amount,t=n.parameters,a=c(t),i=a.bornBeforeCutoff,o=a.receivesPensionGuaranteeCredit,s=a.applicantHighDisabilityLevel,l=a.applicantCarersAllowance,u=a.applicantEntitledToCarersAllowance;if(i&&o){var d=e.pensionGuaranteeCreditEntitlements||{};s&&(r+=d.sdp),(l||u)&&(r+=d.carer)}return r},singleSDPPGC:function(n){var r=n.amount,t=n.parameters,a=c(t),i=a.bornBeforeCutoff,o=a.receivesPensionGuaranteeCredit,s=a.applicantHighDisabilityLevel;if(i&&o){var l=e.pensionGuaranteeCreditEntitlements||{};s&&(r+=l.sdp)}return r},deductQI:function(e){var n=e.amount,r=e.parameters.workings,t=(void 0===r?{}:r).pgcQualifyingIncome;return n=Math.max(0,n-(t||0))}})}},72557:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{partnerTransfer:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=0,o=r.workings||{},s=o.partnerDisregardsTotal,l=void 0===s?0:s,u=o.partnerGrossIncome,c=void 0===u?0:u,d=o.partnerLivingAllowanceTotal,p=void 0===d?0:d,g=Math.max(0,p);return c>0&&(i=Math.max(0,g-(c-l))),n+i},deductPension:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;return t&&a?0-n:n}})}},94957:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getExpensesAboveThreshold=n.getDREs=n.getPartnerAllowances=n.getAllowances=n.getPartnerDisregards=n.getDisregards=n.getEntitlements=n.getQualifyingIncome=n.getPartnerIncome=n.getIncome=void 0;var t=r(66592);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}}),Object.defineProperty(n,"getQualifyingIncome",{enumerable:!0,get:function(){return t.getQualifyingIncome}}),Object.defineProperty(n,"getEntitlements",{enumerable:!0,get:function(){return t.getEntitlements}});var a=r(84647);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(63320);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return i.getAllowances}}),Object.defineProperty(n,"getPartnerAllowances",{enumerable:!0,get:function(){return i.getPartnerAllowances}});var o=r(67766);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return o.getDREs}}),Object.defineProperty(n,"getExpensesAboveThreshold",{enumerable:!0,get:function(){return o.getExpensesAboveThreshold}});var s=r(71270);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(42654);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(60176);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(93487);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(58094);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(47632);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(88706);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(27562);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(1019);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(48770);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(40477);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(32499);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(72557);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(9365);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(51479);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(88372);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},88372:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e),r=n.getAgeLevel,i=n.getAgeLevelKey,o=function(n){var r=n.disabilityBenefits;return r===e.levels.high?"edp":r&&"none"!==r?"dp":"base"},s=function(n,r){var t=e.levels.low,a=[n,r];return a.includes(e.levels.high)?t=e.levels.high:a.includes(e.levels.medium)&&(t=e.levels.medium),t},l=function(e,n){var r="base",t=[e,n];return t.includes("edp")?r="edp":t.includes("dp")&&(r="dp"),r};return{getDisabilityLevelProcessor:function(e){var n=e.incomeFields,r=e.partnerIncomeFields,a=o(n),i=o(r),s=l(a,i);return t(t({},e),{disabilityLevel:s})},getAgeLevelProcessor:function(n){var a=n.dob,o=n.partnerDOB,l=r(a),u=""!==o?r(o):e.levels.low,c=s(l,u),d=i(c);return t(t({},n),{ageLevel:d})},getAllowanceTypeProcessor:function(e){var n=e.hasPartner?"coupleServiceUser":"singleServiceUser";return t(t({},e),{allowanceType:n})},getPartnerAllowanceType:function(e){return function(n){var r=["nonResidential","carephone"].includes(e)?"partnerNonResidential":"partnerRespite";return t(t({},n),{allowanceType:r})}},getPartnerAgeLevel:function(n){return function(a){var o=a.dob,l=a.partnerDOB,u=r(o),c=""!==l?r(l):e.levels.low,d=["nonResidential","carephone"].includes(n)?s(u,c):u,p=i(d);return t(t({},a),{ageLevel:p})}},getPartnerDisabilityLevel:function(e){return function(n){var r=n.incomeFields,a=n.partnerIncomeFields,i=o(r),s=o(a),u=["nonResidential","carephone"].includes(e)?l(i,s):i;return t(t({},n),{disabilityLevel:u})}}}}},32412:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.kirklees=void 0;var t=r(5318),a=r(14530),i=r(4296);n.kirklees={calculator:t.calculator,getConstants:a.getConstants,migrations:i.migrations,annualRatesLookupRules:a.annualRatesLookupRules}},82745:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;var a=r(14530),i=function(e,n){return Object.keys(n).reduce((function(r,a){var i,o,s=null!==(o=e[a])&&void 0!==o?o:a;return t(t({},r),((i={})[s]=n[a],i))}),{})},o=function(e){var n={};return void 0!==e&&(n=t(t(t({},e),i({attendanceAllowance:"disabilityBenefits"},e.benefits||{})),i({universalCredit:"universalCreditBreakdown"},e))),(e.benefits||{}).otherBenefit?n=t(t({},n),{hasOtherBenefit:((e.benefits||{}).otherBenefit||0)>0,otherBenefit:[{otherBenefitAmount:(e.benefits||{}).otherBenefit||0,otherBenefitPeriod:(e.benefits||{}).otherBenefitPeriod}]}):(n.otherBenefit=[],n.hasOtherBenefit=!1),n},s=function(e,n){void 0===e&&(e={}),void 0===n&&(n={});var r=n.isEntitledToCarersPremium;return void 0!==r&&(e=t(t({},e),{carersAllowanceIsEntitled:r?"yes":"no"})),t({},e)};n.m1=function(e){var n,r,l,u,c;void 0===e&&(e={}),e=null!=e?e:{};var d=JSON.parse(JSON.stringify(e));if(void 0!==e.person){var p=e.person.income||{};void 0!==p&&(d.person.income=t(t({},d.person.income),o(p)),d.person.intro=t({},s(d.person.intro,p)),delete(d.person.income||{}).benefits,delete(d.person.income||{}).otherBenefitPeriod,delete(d.person.income||{}).universalCredit,delete(d.person.income||{}).isEntitledToCarersPremium)}if(void 0!==e.partner){var g=(null===(n=e.partner)||void 0===n?void 0:n.income)||{};void 0!==g&&(d.partner=d.partner||{details:{}},d.partner.income=t(t({},d.partner.income),o(g)),d.partner.intro=t(t({},(null===(r=d.partner)||void 0===r?void 0:r.intro)||{}),s(null===(l=d.partner)||void 0===l?void 0:l.intro,g)),delete((d.partner||{}).income||{}).benefits,delete((d.partner||{}).income||{}).otherBenefitPeriod,delete((d.partner||{}).income||{}).universalCredit,delete((d.partner||{}).income||{}).isEntitledToCarersPremium)}if(void 0!==e.person){var f=e.person.details;void 0!==f&&(d.person.intro=t(t({},d.person.intro),{hasPartner:f.hasPartner}),delete d.person.details.hasPartner,d.person.intro.hasPartner&&(d.partner=d.partner||{details:{}},d.partner.intro=t(t({},(null===(u=d.partner)||void 0===u?void 0:u.intro)||{}),{discloseFinances:f.declarePartnerFinances}),delete d.person.details.declarePartnerFinances),d.person.property=t(t({},d.person.property),{ownership:f.propertyTenancy,propertyTenancyAdditionalDetails:f.propertyTenancyAdditionalDetails}),delete d.person.details.propertyTenancy,delete d.person.details.propertyTenancyAdditionalDetails)}if(void 0!==e.person){var m=e.person.expenses;void 0!==m&&(d.person.expenses=t(t({},d.person.expenses),i({compulsoryPayments:"compulsoryCourtPayments",compulsoryPaymentsPeriod:"compulsoryCourtPaymentsPeriod",homeContentsInsurance:"contentsInsurance",homeContentsInsurancePeriod:"contentsInsurancePeriod"},m)),delete(d.person.expenses||{}).compulsoryPayments,delete(d.person.expenses||{}).compulsoryPaymentsPeriod,delete(d.person.expenses||{}).homeContentsInsurance,delete(d.person.expenses||{}).homeContentsInsurancePeriod)}if(void 0!==e.partner){var v=null===(c=e.partner)||void 0===c?void 0:c.expenses;void 0!==v&&(d.partner=d.partner||{details:{}},d.partner.expenses=t(t({},d.partner.expenses),i({compulsoryPayments:"compulsoryCourtPayments",compulsoryPaymentsPeriod:"compulsoryCourtPaymentsPeriod"},v)),delete d.partner.expenses.compulsoryPayments,delete d.partner.expenses.compulsoryPaymentsPeriod)}var h=e.declaration;void 0!==h&&(d.person.intro=t(t({},d.person.intro),{provideFinancialDetails:h.provideFinancialDetails}),delete d.declaration.provideFinancialDetails);var y,P=e.careAssessment,C=(0,a.getConstants)().careTypes,w=function(e){return void 0===e&&(e={}),Object.keys(e).reduce((function(n,r){var a,i,o=e[r];return"workings"===r&&(i=o,o=Object.keys(i).reduce((function(e,n){var r,a=i[n],o=i[n];if("string"==typeof a){var s=parseFloat(a);o=isNaN(s)?o:s}return t(t({},e),((r={})[n]=o,r))}),{})),n=t(t({},n),((a={})[r]=o,a))}),{})};return void 0!==P&&(d.careAssessment=t({},(void 0===(y=P)&&(y={}),Object.keys(y).reduce((function(e,n){var r,a=void 0;return a=y[n],Object.keys(C).includes(n)&&(a=w(y[n])),t(t({},e),((r={})[n]=a,r))}),{})))),d}},94288:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.m2=void 0;n.m2=function(e){return void 0===e&&(e={}),e=null!=e?e:{},JSON.parse(JSON.stringify(e))}},99237:function(e,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},r.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;var t=function(e,n){return Object.keys(n).reduce((function(t,a){var i,o,s=null!==(o=e[a])&&void 0!==o?o:a;return r(r({},t),((i={})[s]=n[a],i))}),{})},a=function(e){void 0===e&&(e={});var n={};return delete(n=r(r({},e),t({universalCredit:"universalCreditBreakdown",attendanceAllowance:"disabilityBenefits"},e))).universalCredit,delete n.attendanceAllowance,e.otherBenefit?delete(n=r(r({},n),{hasOtherBenefit:(e.otherBenefit||0)>0,otherBenefit:[{otherBenefitAmount:e.otherBenefit||0,otherBenefitPeriod:e.otherBenefitPeriod}]})).otherBenefitPeriod:(n.otherBenefit=[],n.hasOtherBenefit=!1),n};n.m1=function(e){var n,i,o;void 0===e&&(e={}),e=null!=e?e:{};var s=JSON.parse(JSON.stringify(e));if(void 0!==e.person){var l=e.person.income||{};void 0!==l&&(s.person.income=a(l))}if(void 0!==e.partner){var u=(null===(n=e.partner)||void 0===n?void 0:n.income)||{};void 0!==u&&(s.partner=s.partner||{details:{}},s.partner.income=a(u),s.partner.intro=r({},(null===(i=s.partner)||void 0===i?void 0:i.intro)||{}))}if(void 0!==e.person){var c=e.person.intro||{};if(void 0!==c){var d=c.isEntitledToCarersPremium;s.person.intro=r(r({},s.person.intro),{hasPartner:c.havePartner,carersAllowanceIsEntitled:d?"yes":"no"}),s.person.details=r(r({},s.person.details||{}),{dob:c.dob}),delete(s.person.intro||{}).dob,delete(s.person.intro||{}).havePartner,delete(s.person.intro||{}).isEntitledToCarersPremium,s.person.intro.hasPartner&&(s.partner=s.partner||{details:{}},s.partner.details=r(r({},s.partner.details),{dob:((s.partner||{}).intro||{}).dob}),s.partner.intro=r(r({},(null===(o=s.partner)||void 0===o?void 0:o.intro)||{}),{discloseFinances:c.declarePartnerFinances}),delete((s.partner||{}).intro||{}).dob,delete(s.person.intro||{}).declarePartnerFinances)}}if(void 0!==e.person){var p=e.person.expenses;void 0!==p&&(s.person.expenses=r(r({},s.person.expenses),t({compulsoryPayments:"compulsoryCourtPayments",compulsoryPaymentsPeriod:"compulsoryCourtPaymentsPeriod"},p)),delete(s.person.expenses||{}).compulsoryPayments,delete(s.person.expenses||{}).compulsoryPaymentsPeriod)}var g=e.declaration;return void 0!==g&&(s.person.intro=r(r({},s.person.intro),{provideFinancialDetails:g.provideFinancialDetails}),delete s.declaration.provideFinancialDetails),s}},4296:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.migrations=void 0;var t=r(82745),a=r(94288),i=r(99237);n.migrations={FCA:{1:[t.m1],2:[a.m2]},KR_CA:{1:[i.m1],2:[a.m2]}}},14076:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var a=r(32954),i=r(2652),o=r(83199),s=r(3709),l=new a.NumberUtilsService;n.calculator=function(e,n,r,a){(0,i.setOptions)(a,e);var u=(0,i.getConstants)(),c={},d={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails||n){var p=(0,o.getIncome)(e,r,u);d=Object.assign(d,p);var g=u.fullCostCapitalLimit[r],f=(p.totalCapital||0)>g,m=(p.additionalPropertyEquity||0)>0;if(f||m){var v=(u.maxContribution||{})[r];return{contributions:l.isNumeric(v)?{maxContribution:v}:{},workings:d,isMaxCost:!0}}var h=(0,o.getDisregards)(e,r,u,d);d=Object.assign(d,h);var y=(0,s.getExpenses)(e,r);d=Object.assign(d,y);var P=(0,o.getDREs)(e,r,u,d);d=Object.assign(d,P);var C=(0,o.getAllowances)(e,r,u,d);d=Object.assign(d,C)}else c=Object.assign(c,{fullCost:!0});for(var w in d)if(Object.prototype.hasOwnProperty.call(d,w)){var I=d[w]||0;d[w]=l.roundNearest(I)}var O=(0,o.getGeneratedFields)(e,u),b=(0,o.getCostOfCare)(e,r,u,d,c);return t(t({},b),{generated:O})}},90713:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",temporaryResidential:"temporaryResidential",permWeek1Residential:"permWeek1Residential",permWeek13Residential:"permWeek13Residential"},attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,temporaryResidential:0,permWeek1Residential:0,permWeek13Residential:0},capitalTariff:{nonResidential:0,temporaryResidential:0,permWeek1Residential:0,permWeek13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,sdpPremium:0,housingAllowance:0,ageAddition:0,dwpMIG:0,dwpMIGIncomeThreshold:0,dwpCapitalThreshold:{low:0,medium:0},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},configuration:{calculatorConfig:{weeksPerYear:365/7}}}},2652:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(90713),i=r(47917);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}}),n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-07",values:i.latest,label:"2024-2025"}];var o=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),o=(0,t.applyOptions)({constants:o,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return o}},47917:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,temporaryResidential:23250,permWeek1Residential:23250,permWeek13Residential:23250},capitalTariff:{nonResidential:250,temporaryResidential:250,permWeek1Residential:250,permWeek13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:136.45-87.65,edp:160.3-136.45},over25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},pensionAge:{base:228.7,dp:0,edp:0}},loneParentUser:{under25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},over25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},over25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},pensionAge:{base:174.6,dp:0,edp:0}}},childPremium:101.25,carersPremium:52.35,sdpPremium:81.5,housingAllowance:55,ageAddition:.25,dwpMIG:172.8,dwpMIGIncomeThreshold:201.05,dwpCapitalThreshold:{low:1e4,medium:14250},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95}}}},83973:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.halfCombined=n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},n.halfCombined=function(e){var n=e.amount;return e.expenseFields.isHomeInsuranceCombined?n/2:n}},3709:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getOwnershipStatus=n.getPartnerArrangement=void 0;var t=r(91569),a=r(2652),i=r(1707);n.getPartnerArrangement=function(e){var n=e.partnerCohabits,r=e.numberOfOtherPeople;return n?"cohabitingPartner":r>1?"cohabitingWithOther":"single"};n.getOwnershipStatus=function(e){return"default"};var o={temporaryResidential:function(e,n){var r=e.partnerCohabits,t=e.numberOfOtherPeople,i=(0,a.getConstants)(),o=["mortgage","mortgageInsurance","rent","groundRent","homeInsurance"],s=["waterRates","gas","electric","councilTax","lifeline"],l=Object.keys(n).filter((function(e){return o.includes(e)})).reduce((function(e,r){return e+n[r]}),0),u=Object.keys(n).filter((function(e){return s.includes(e)})).reduce((function(e,r){return e+n[r]}),0),c=1+(r||t>1?1:0),d=(i.housingAllowance||0)/c;return{expensesTotal:l+(u>0?d:0)}}};n.getExpenses=function(e,r){var s=(0,a.getConstants)().configuration;return(0,t.expensesCalculator)(s,e,r,i.housingExpenses,{getPartnerArrangement:n.getPartnerArrangement,getOwnershipStatus:n.getOwnershipStatus,expensesRollupConfig:o})}},1707:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(83973);n.housingExpenses={nonResidential:{single:{default:{mortgage:[t.full],mortgageInsurance:[t.full],rent:[t.full],councilTax:[t.full],compulsoryCourtPayments:[],homeInsurance:[t.full,t.halfCombined],serviceCharge:[],groundRent:[],waterRates:[],gas:[],electric:[],lifeline:[]}},cohabitingPartner:{default:{mortgage:[(0,t.ratio)(50)],mortgageInsurance:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],compulsoryCourtPayments:[],homeInsurance:[(0,t.ratio)(50),t.halfCombined],serviceCharge:[],groundRent:[],waterRates:[],gas:[],electric:[],lifeline:[]}},cohabitingWithOther:{default:{mortgage:[t.full],mortgageInsurance:[t.full],rent:[t.full],councilTax:[t.full],compulsoryCourtPayments:[],homeInsurance:[t.full,t.halfCombined],serviceCharge:[],groundRent:[],waterRates:[],gas:[],electric:[],lifeline:[]}}},temporaryResidential:{single:{default:{mortgage:[t.full],mortgageInsurance:[t.full],rent:[t.full],councilTax:[t.full],compulsoryCourtPayments:[],homeInsurance:[t.full,t.halfCombined],serviceCharge:[],groundRent:[t.full],waterRates:[t.full],gas:[t.full],electric:[t.full],lifeline:[t.full]}},cohabitingPartner:{default:{mortgage:[(0,t.ratio)(50)],mortgageInsurance:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],compulsoryCourtPayments:[],homeInsurance:[(0,t.ratio)(50),t.halfCombined],serviceCharge:[],groundRent:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],lifeline:[(0,t.ratio)(50)]}},cohabitingWithOther:{default:{mortgage:[(0,t.ratio)(50)],mortgageInsurance:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],compulsoryCourtPayments:[],homeInsurance:[(0,t.ratio)(50),t.halfCombined],serviceCharge:[],groundRent:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],lifeline:[(0,t.ratio)(50)]}}},permWeek1Residential:{},permWeek13Residential:{}}},29037:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(43702);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getAllowanceTypeProcessor,p=c.getDisabilityLevelProcessor,g=c.getAgeLevelProcessor,f=(0,a.getParameters)(e,l);return f=(0,i.runProcessors)(f,r,{getAllowanceTypeProcessor:d,getDisabilityLevelProcessor:p,getAgeLevelProcessor:g}),(0,t.sharedCalculator)(n,s,f,u)}},27446:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(83199),a=r(83199);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},22444:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(32954),a=r(83199),i=r(74954),o=r(83199),s=r(83199),l=r(83199);n.getCostOfCare=function(e,n,r,u,c){var d=new t.NumberUtilsService,p=(0,s.getIncomeFunctions)(r),g=p.full,f=p.pensions,m=p.meansTestedBenefits,v=(0,l.getDisregardsFunctions)(r),h=v.premiumDisregard,y=v.jointPremiumDisregard;if(["permWeek1Residential","permWeek13Residential"].includes(n)){var P=e.person.intro||{},C=e.person.details;if(void 0===C&&(C={}),!!P.hasPartner){var w=e.person.income||{},I=(e.partner||{}).income||{},O=w.pensionGuaranteeCredit||0,b=I.pensionGuaranteeCredit||0;if(!(!O&&!b||!w.pensionGuaranteeCreditIsJoint&&!I.pensionGuaranteeCreditIsJoint)){var A=(0,i.getParameters)(e,u),T=["pensionGuaranteeCredit","employmentSupport","incomeSupportPayment","jobSeekersAllowance"].reduce((function(e,n){return e+m({amount:0,key:n,parameters:A})}),0)+g({amount:0,key:"pensionSavingsCredit",parameters:A});u.grossIncome-=Math.max(0,T);var R=["pensionGuaranteeCredit","incomeSupportPayment","jobSeekersAllowance"].reduce((function(e,n){return e+h({amount:m({amount:0,key:n,parameters:A}),key:n,parameters:A})}),0)+y({amount:m({amount:0,key:"employmentSupport",parameters:A}),key:"employmentSupport",parameters:A});u.disregardsTotal-=Math.max(0,R);var _=f({amount:0,parameters:A});if(!0!==C.transferHalfPensionToPartner&&(u.disregardsTotal+=Math.max(0,_/2)),(u.grossIncome||0)+(u.capitalTariff||0)<(r.dwpMIGIncomeThreshold||0))if((u.totalCapital||0)<=((r.dwpCapitalThreshold||{}).low||0))c=Object.assign(c,{contributions:{maxContribution:d.roundNearest(Math.max(0,(r.dwpMIG||0)-_/2))}});else if((u.totalCapital||0)<=((r.dwpCapitalThreshold||{}).medium||0)){var E=Math.ceil(((u.totalCapital||0)-((r.dwpCapitalThreshold||{}).low||0))/500);c=Object.assign(c,{contributions:{maxContribution:d.roundNearest(Math.max(0,(r.dwpMIG||0)-E-_/2))}})}else if((u.totalCapital||0)>((r.dwpCapitalThreshold||{}).medium||0)){E=Math.ceil(((u.totalCapital||0)-((r.dwpCapitalThreshold||{}).low||0))/500);var D=Math.ceil(((u.totalCapital||0)-((r.dwpCapitalThreshold||{}).medium||0))/250);c=Object.assign(c,{contributions:{maxContribution:d.roundNearest(Math.max(0,(r.dwpMIG||0)-E+D-_/2))}})}}}}var L=(0,o.getCostOfCareConfig)(r,c).costOfCareLookup,S=(0,a.calculator)(e,n,r,L,u);return Object.assign({contributions:S,workings:u},c)}},27781:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(83199),a=r(83199);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).disregardsLookup;return(0,t.calculator)(e,n,r,o,i)}},46600:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(83199),a=r(83199);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},21014:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getGeneratedFields=n.getIncome=void 0;var t=r(50237),a=r(83199),i=r(83199),o=r(83199),s=r(74954);n.getIncome=function(e,n,r){var t=(0,o.getIncomeConfig)(r).incomeLookup;return(0,a.calculator)(e,n,r,t)};n.getGeneratedFields=function(e,n){var r,a=(0,i.getIncomeFunctions)(n).getAgeAdjustedPension,o=(0,s.getParameters)(e),l={person:{statePensionBeforeAgeAddition:{amount:a({amount:0,parameters:o}),period:t.PERIODS.Weekly}}};return o.partnerDisclosesFinances&&(r={statePensionBeforeAgeAddition:{amount:a({amount:0,parameters:o=(0,s.getPartnerParameters)(e)}),period:t.PERIODS.Weekly}},l.partner=r),l}},84190:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(83199),a=r(83199);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.child,u=n.carer,c=(0,a.getIncomeFunctions)(e).ratio;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[l],carerPremium:[u]},plaRate:[r,i,o],childPremium:[l],carerPremium:[u]}},partnerLookup:{default:{livingAllowanceTotal:{plaRate:[r,i,o]},plaRate:[r,i,o]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o,c(50)]},plaRate:[r,i,o,c(50)]}}}}},87720:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(83199);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},64301:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(83199),i=r(83199);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.zero,o=n.full,s=n.cap,l=n.joint,u=n.individual,c=n.pensions,d=n.upliftable,p=n.meansTestedBenefits,g=n.ucRollup,f=(0,a.getDisregardsFunctions)(e),m=f.aa,v=f.dla,h=f.pip,y=f.psc,P=f.disregardTransferredPension,C=f.ifTransferPension,w=f.onlyIfPartnerNotReceivingCare,I=f.jointSU,O=f.premiumDisregard,b=f.jointPremiumDisregard,A={housingBenefit:[I],warPension:[u],charitableIncome:[l],childMaintenance:[l],armedForcesCompensation:[l],studentIncome:[l],warWidowsPension:[o,s(10)],privatePensions:[c,P,C,w],attendanceAllowance:[d],dlaCare:[d],pipDailyLiving:[d],mobilityAllowance:[d],pensionSavingsCredit:[l,y],sdpDisregard:{employmentSupport:[p,b],incomeSupportPayment:[p,O],jobSeekersAllowance:[p,O],pensionGuaranteeCredit:[p,b]}};return{disregardsLookup:{default:{disregardsTotal:t({},A)},nonResidential:{disregardsTotal:t(t({},A),{privatePensions:[c,P,C],warWidowsPension:[r],warPension:[r],employmentSupport:[I],jobSeekersAllowance:[I],incomeSupportPayment:[I],pensionSavingsCredit:[o],pensionGuaranteeCredit:[I],attendanceAllowance:[d,m],dlaCare:[d,v],pipDailyLiving:[d,h],sdpDisregard:[r]})},temporaryResidential:{disregardsTotal:t(t({},A),{workingTaxCredit:[r],universalCreditBreakdown:[g(["carer"])]})},permWeek1Residential:{disregardsTotal:t(t({},A),{workingTaxCredit:[r],universalCreditBreakdown:[g(["carer","housingElement"])],sdpDisregard:{employmentSupport:[p,b],incomeSupportPayment:[p,O],jobSeekersAllowance:[p,O],pensionGuaranteeCredit:[p,O]}})},permWeek13Residential:{disregardsTotal:t(t({},A),{workingTaxCredit:[r],universalCreditBreakdown:[g(["carer","housingElement"])],sdpDisregard:{employmentSupport:[p,b],incomeSupportPayment:[p,O],jobSeekersAllowance:[p,O],pensionGuaranteeCredit:[p,O]}})}}}}},86896:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(83199),a=r(83199);n.getDREConfig=function(e){return{dreLookup:{default:{dreTotal:[(0,a.getIncomeFunctions)(e).zero]},nonResidential:{dreTotal:[(0,t.getDREFunctions)(e).dre]}}}}},66022:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var a=r(83199);n.getIncomeConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.ratio,i=n.annuities,o=n.bonds,s=n.full,l=n.ucRollup,u=n.ucDeductionRollup,c=n.pensions,d=n.deferredPensions,p=n.otherBenefit,g=n.upliftable,f=n.savings,m=n.shareHoldings,v=n.tariff,h=n.additionalPropertyEquity,y=n.zeroIfExceedsCapitalThreshold,P=n.individualCapital,C=n.jointCapital,w=n.primaryPropertyEquity,I=n.ifNoProtectedCohabitants,O=n.meansTestedBenefits,b=function(n){return v(e.capitalLimit,e.capitalTariff[n])},A={retirementPensionReceived:[s],privatePensions:[c],deferredPensions:[d],annuities:[i],annuitiesIncome:[s],privatePension:[s],capitalTariff:[P,C,f,o,m,v(e.capitalLimit,500)]},T={grossIncome:{incapacityBenefit:[s],maternityAllowance:[s],maintenance:[s],severeDisablementAllowance:[s],exceptionalSevereDisablementAllowance:[s],pensionSavingsCredit:[s],industrialInjuriesBenefit:[s],rentalIncome:[s],annuitiesIncome:[s],trustFunds:[s],retirementPensionReceived:[s],carersAllowance:[s],otherIncome:[s],housingBenefit:[s],incomeSupportPayment:[O],employmentSupport:[O],jobSeekersAllowance:[O],pensionGuaranteeCredit:[O],privatePensions:[c],deferredPensions:[d],annuities:[i],otherBenefit:[p],universalCreditBreakdown:[l(["standardAllowance","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer"]),u(["other","earnings","capitalTariff","benefitLimit"])],attendanceAllowance:[g],pipDailyLiving:[g],dlaCare:[g],mobilityAllowance:[g],otherSingleBenefit:[s],privatePension:[s]}};return{incomeLookup:{default:{grossIncome:t(t({},T.grossIncome),{warPension:[s],warWidowsPension:[s]}),totalCapital:[P,C,[h,r(90)],o,f,m],capitalTariff:[P,C,[h,r(90)],o,f,m,y("nonResidential"),b("nonResidential")],qualifyingIncome:A},nonResidential:{grossIncome:t(t({},T.grossIncome),{incomeSupportPayment:[s],employmentSupport:[s],jobSeekersAllowance:[s],pensionGuaranteeCredit:[s]}),totalCapital:[P,C,o,f,m],capitalTariff:[P,C,o,f,m,y("nonResidential"),b("nonResidential")],qualifyingIncome:A},permWeek13Residential:{grossIncome:t(t({},T.grossIncome),{warPension:[s],warWidowsPension:[s]}),totalCapital:[P,C,o,f,m,[h,r(90)],[w,r(90),I]],capitalTariff:[P,C,o,f,m,[h,r(90)],[w,r(90),I],y("nonResidential"),b("nonResidential")]}}}}},61889:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance,s="yes"===i.carersAllowanceIsEntitled;return r+(o||s?e.carersPremium:0)},child:function(n){var r=n.amount,t=n.parameters,a=t.introFields,i=t.dependentChildrenCount;return r+(a.dependentChildrenLivingInProperty||i||0)*e.childPremium}})}},35155:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(2652),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t(t({},d),{netContribution:function(e){e.amount;var n=e.parameters.workings,r=void 0===n?{}:n;return(r.grossIncome||0)+(r.capitalTariff||0)-(r.disregardsTotal||0)-(r.expensesTotal||0)-(r.dreTotal||0)-(r.livingAllowanceTotal||0)-(r.partnerTransfer||0)}})}},78296:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(50237),i=r(24609),o=r(32954),s=r(56822),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,u=new s.CareAssessmentService(r,n),c=new i.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e);return t(t({},d),{psc:function(n){var r=n.amount,t=(n.key,n.parameters),a=t.workings,i=void 0===a?{}:a,o=t.suDOB,s=i.qualifyingIncome||0,l=u.getAgeLevel(o,e.levels).level,c=e.pensionSavingsCreditIncomeThreshold,d=c?c.singleApplicant:{},p=r>0;return l!==e.levels.high||s<d.INCOME_LOW?0:s>=d.INCOME_LOW&&s<d.INCOME_HIGH?p?Math.min(r||0,d.DISREGARD_MAX):0:(d.INCOME_HIGH,d.DISREGARD_MAX)},onlyIfPartnerNotReceivingCare:function(e){var n=e.amount;return e.parameters.detailsFields.partnerReceivesCare?0:n},jointSU:function(e){var n=e.amount,r=e.key,t=e.parameters,i="".concat(r,"IsJoint"),o=!0===t.incomeFields[i],s="".concat(r,"Period"),l=void 0===t.incomeFields[s]?a.PERIODS.Weekly:t.incomeFields[s],u=c.getWeeklyAmount(t.incomeFields,r,{period:l});return n+(u=o?u/2:0)},premiumDisregard:function(n){var r=n.amount,t=n.key,a=n.parameters,i=0,o=!0===a.incomeFields["".concat(t,"IsJoint")],s="yes"===a.incomeFields["".concat(t,"IncludesSDP")],l="yes"===a.incomeFields["".concat(t,"IncludesCarersPremium")];return o?r/2:(s&&(i+=e.sdpPremium||0),l&&(i+=e.carersPremium||0),Math.min(i,r))},jointPremiumDisregard:function(n){var r=n.amount,t=n.key,a=n.parameters,i=0,o=!0===a.incomeFields["".concat(t,"IsJoint")]||!0===a.partnerIncomeFields["".concat(t,"IsJoint")],s=a.partnerDisclosesFinances,l="yes"===a.incomeFields["".concat(t,"IncludesSDP")],u="yes"===a.incomeFields["".concat(t,"IncludesCarersPremium")],c=s&&o&&"yes"===a.partnerIncomeFields["".concat(t,"IncludesSDP")],d=s&&o&&"yes"===a.partnerIncomeFields["".concat(t,"IncludesCarersPremium")];return l&&(i+=e.sdpPremium||0),u&&(i+=e.carersPremium||0),c&&(i+=e.sdpPremium||0),d&&(i+=e.carersPremium||0),o&&(i+=(r-i)/2),Math.min(i,r)}})}},45183:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(2652),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{dre:function(n){n.amount;var r=n.parameters.incomeFields,t=r.attendanceAllowance,a=r.dlaCare,i=r.pipDailyLiving,o=0;return a===e.levels.low?o=10:a===e.levels.medium||i===e.levels.low||t===e.levels.low?o=15:a!==e.levels.high&&i!==e.levels.high&&t!==e.levels.high||(o=25),o}})}},11457:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(50237),i=r(73378),o=r(24609),s=r(32954),l=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,i.getDefaultIncomeHelpers)(c,u,e),p=d.full,g=d.fullPartner;return t(t({},d),{annuities:function(e){return e.amount+(e.parameters.incomeFields.annuities||[]).reduce((function(e,n){return e+(n.amount||0)}),0)},deferredPensions:function(e){return e.amount+(e.parameters.incomeFields.deferredPensions||[]).reduce((function(e,n){return e+(n.amount||0)}),0)},bonds:function(e){var n=e.amount,r=e.parameters,t=function(e,n){var r=n.amount;switch(n.accountType){case"savings_bond":case"investment_bond":e+=n.lifeAssured?0:r;break;case"trust":break;default:e+=r}return e},a=r.capitalFields.bonds||[],i=r.jointCapitalFields.bonds||[];return n+a.reduce(t,0)+i.reduce(t,0)/2},ucRollup:function(e){return void 0===e&&(e=[]),function(n){var r=n.amount,t=n.parameters,i=Object.keys(t.incomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var a=(t.incomeFields.universalCreditBreakdown||{})[r]||0;return n+(t.partnerDisclosesFinances?a/2:a)}),0);return i+=Object.keys(t.partnerIncomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var a=(t.partnerIncomeFields.universalCreditBreakdown||{})[r]||0;return n+(t.partnerDisclosesFinances?a/2:0)}),0),r+u.toWeeklyAmount(i,a.PERIODS.Monthly)}},ucDeductionRollup:function(e){return void 0===e&&(e=[]),function(n){var r=n.amount,t=n.parameters,i=Object.keys(t.incomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var a=(t.incomeFields.universalCreditBreakdown||{})[r]||0;return n+(t.partnerDisclosesFinances?a/2:a)}),0);i+=Object.keys(t.partnerIncomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var a=(t.partnerIncomeFields.universalCreditBreakdown||{})[r]||0;return n+(t.partnerDisclosesFinances?a/2:0)}),0);var o=u.toWeeklyAmount(i,a.PERIODS.Monthly);return Math.max(0,r-o)}},getAgeAdjustedPension:function(n){var t=n.parameters,a=c.getWeeklyAmount(t.incomeFields,"retirementPensionReceived");return u.getAge(t.dob)>=80&&(a=Math.max(0,a-(e.ageAddition||0))),r.roundNearest(a)},individualCapital:function(e){return e.amount+(e.parameters.capitalFields.individual||0)},jointCapital:function(e){return e.amount+(e.parameters.capitalFields.joint||0)/2},meansTestedBenefits:function(e){var n=e.amount,r=e.key,t=e.parameters,a=p({amount:0,key:r,parameters:t}),i=g({amount:0,key:r,parameters:t});return n+a+(!0===t.partnerIncomeFields["".concat(r,"IsJoint")]?i:0)},additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){return(n.value||0)+e}),0)},primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.detailsFields.currentlyInCare,o=r.propertyFields.ownership;return i&&(o=r.propertyFields.ownershipOfPreviousProperty),n+(t+=["ownedByYou","ownedOrPartOwned"].includes(o||"")?a:0)}})}},83199:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.calculator=n.getCostOfCareFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getAllowances=n.getDREs=n.getDisregards=n.getGeneratedFields=n.getIncome=void 0;var t=r(21014);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getGeneratedFields",{enumerable:!0,get:function(){return t.getGeneratedFields}});var a=r(27781);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(46600);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(27446);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(22444);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return s.getCostOfCare}});var l=r(66022);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return l.getIncomeConfig}});var u=r(64301);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return u.getDisregardsConfig}});var c=r(86896);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return c.getDREConfig}});var d=r(84190);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return d.getAllowancesConfig}});var p=r(87720);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return p.getCostOfCareConfig}});var g=r(11457);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return g.getIncomeFunctions}});var f=r(78296);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return f.getDisregardsFunctions}});var m=r(45183);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return m.getDREFunctions}});var v=r(61889);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return v.getAllowancesFunctions}});var h=r(35155);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return h.getCostOfCareFunctions}});var y=r(29037);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return y.calculator}});var P=r(43702);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return P.getProcessors}})},43702:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e),r=n.getAgeLevel,i=n.getAgeLevelKey;return{getDisabilityLevelProcessor:function(n){var r=n.incomeFields,a=n.partnerIncomeFields,i="base";return r.dlaCare!==e.levels.medium&&r.pipDailyLiving!==e.levels.low&&a.dlaCare!==e.levels.medium&&a.pipDailyLiving!==e.levels.low||(i="dp"),r.dlaCare!==e.levels.high&&r.pipDailyLiving!==e.levels.high&&a.dlaCare!==e.levels.high&&a.pipDailyLiving!==e.levels.high||(i="edp"),t(t({},n),{disabilityLevel:i})},getAgeLevelProcessor:function(n){var a=n.dob,o=n.partnerDOB,s=function(n,r){var t=e.levels.low,a=[n,r];return a.includes(e.levels.high)?t=e.levels.high:a.includes(e.levels.medium)&&(t=e.levels.medium),t}(r(a),""!==o?r(o):e.levels.low),l=i(s);return t(t({},n),{ageLevel:l})},getAllowanceTypeProcessor:function(e){var n=e.hasPartner,r=e.dependentChildrenCount,a=n?"coupleServiceUser":r>0?"loneParentUser":"singleServiceUser";return t(t({},e),{allowanceType:a})}}}},76634:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.lincolnshire=void 0;var t=r(14076),a=r(2652),i=r(59018);n.lincolnshire={calculator:t.calculator,getConstants:a.getConstants,migrations:i.migrations}},12881:function(e,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},r.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;var t=function(e,n){return Object.keys(n).reduce((function(t,a){var i,o=void 0!==e[a]?e[a]:a;return r(r({},t),((i={})[o]=n[a],i))}),{})},a=function(e){var n={};return e.sources&&(delete(n=r(r({},e),t({severeDisablement:"severeDisablementAllowance",severeDisablementPeriod:"severeDisablementAllowancePeriod",exceptionalSevereDisablement:"exceptionalSevereDisablementAllowance",exceptionalSevereDisablementPeriod:"exceptionalSevereDisablementAllowancePeriod"},e.sources))).sources,n=t({universalCredit:"universalCreditBreakdown"},n),e.sources.otherBenefit&&delete(n=r(r({},n),{hasOtherBenefit:e.sources.otherBenefit>0,otherBenefit:[{otherBenefitAmount:e.sources.otherBenefit,otherBenefitPeriod:e.sources.otherBenefitPeriod}]})).otherBenefitPeriod,e.sources.wages&&delete(n=r(r({},n),{hasWage:e.sources.wages>0,wages:[{amount:e.sources.wages,amountPeriod:e.sources.wagesPeriod}]})).wagesPeriod),n};n.m1=function(e){var n,i,o,s,l,u,c,d,p,g,f,m,v,h,y,P,C;void 0===e&&(e={}),e=null!=e?e:{};var w=JSON.parse(JSON.stringify(e));if(void 0!==e.person){w.person=w.person||{};var I=null===(n=e.person)||void 0===n?void 0:n.income;I&&(w.person.income=a(I))}if(e.partner){var O=null===(i=e.partner)||void 0===i?void 0:i.income;O&&(w.partner=w.partner||{details:{}},w.partner.income=a(O))}var b=null===(o=e.person)||void 0===o?void 0:o.details;b&&(w.person=w.person||{},w.person.details=void 0===w.person.details?{}:w.person.details,w.person.intro=r(r({},w.person.intro),{hasPartner:b.hasPartner}),null===(l=null===(s=w.person)||void 0===s?void 0:s.details)||void 0===l||delete l.hasPartner,w.person.details=r(r({},w.person.details),{sameAddress:b.partnerLivesAtSameAddress}),null===(c=null===(u=w.person)||void 0===u?void 0:u.details)||void 0===c||delete c.partnerLivesAtSameAddress,w.person.intro.hasPartner&&(w.partner=w.partner||{details:{}},w.partner.intro=r(r({},(null===(d=w.partner)||void 0===d?void 0:d.intro)||{}),{discloseFinances:b.declarePartnerFinances}),null===(g=null===(p=w.person)||void 0===p?void 0:p.details)||void 0===g||delete g.declarePartnerFinances),w.person.intro=r(r({},w.person.intro),{carersAllowanceIsEntitled:b.isEntitledToCarersPremium?"yes":"no"}),null===(m=null===(f=w.person)||void 0===f?void 0:f.details)||void 0===m||delete m.isEntitledToCarersPremium);var A=null===(v=e.person)||void 0===v?void 0:v.expenses;A&&(w.person=w.person||{},w.person.expenses=r(r({},w.person.expenses),t({compulsoryPayments:"compulsoryCourtPayments",compulsoryPaymentsPeriod:"compulsoryCourtPaymentsPeriod"},A)),null===(y=null===(h=w.person)||void 0===h?void 0:h.expenses)||void 0===y||delete y.compulsoryPayments,null===(C=null===(P=w.person)||void 0===P?void 0:P.expenses)||void 0===C||delete C.compulsoryPaymentsPeriod);var T=e.declaration;return T&&(w.person=w.person||{},w.person.intro=r(r({},w.person.intro),{provideFinancialDetails:T.provideFinancialDetails}),delete w.declaration.provideFinancialDetails),w}},1320:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.propertyFields=void 0;var a=r(56530),i=a.z.object({person:a.z.object({details:a.z.object({propertyTenancy:a.z.string().optional(),propertyType:a.z.string().optional(),heatingType:a.z.string().optional(),otherHeatingType:a.z.string().optional(),propertyRentedByApplicant:a.z.object({serviceChargesIncluded:a.z.boolean().optional()}).optional(),hasPreviouslyOwnedProperty:a.z.boolean().optional(),propertyPreviouslyOwned:a.z.object({addressLine1:a.z.string().optional(),addressLine2:a.z.string().optional(),addressLine3:a.z.string().optional(),postcode:a.z.string().optional(),dateSold:a.z.string().optional(),saleReason:a.z.string().optional()}).optional(),propertyTenancyAdditionalDetails:a.z.string().optional(),propertyOwnedByApplicant:a.z.object({soleOwner:a.z.boolean().optional(),soleOwnerDetails:a.z.string().optional(),inTrust:a.z.boolean().optional(),inTrustDetails:a.z.string().optional(),equityReleaseScheme:a.z.boolean().optional(),equityReleaseSchemeDetails:a.z.string().optional(),loansSecuredAgainst:a.z.boolean().optional(),furtherInformation:a.z.string().optional(),caravanLandValue:a.z.number().optional(),marketValue:a.z.number().optional()}).optional()})})});n.propertyFields=function(e){var n,r,a;void 0===e&&(e={}),e=null!=e?e:{};var o,s=JSON.parse(JSON.stringify(e));if(o=e,i.safeParse(o).success){var l=i.parse(e),u=null!==(n=s.person)&&void 0!==n?n:{};u.property=u.property||{},l.person.details.propertyTenancy&&(u.property.ownership=l.person.details.propertyTenancy),l.person.details.propertyType&&(u.property.propertyType=l.person.details.propertyType),l.person.details.heatingType&&(u.property.heatingType=l.person.details.heatingType),l.person.details.otherHeatingType&&(u.property.otherHeatingType=l.person.details.otherHeatingType),void 0!==(l.person.details.propertyRentedByApplicant||{}).serviceChargesIncluded&&(u.property.serviceChargesIncluded=(l.person.details.propertyRentedByApplicant||{}).serviceChargesIncluded||!1),void 0!==l.person.details.hasPreviouslyOwnedProperty&&(u.property.hasPreviouslyOwnedProperty=l.person.details.hasPreviouslyOwnedProperty||!1),l.person.details.propertyPreviouslyOwned&&(u.property.propertyPreviouslyOwned=l.person.details.propertyPreviouslyOwned),l.person.details.propertyTenancyAdditionalDetails&&(u.property.propertyTenancyAdditionalDetails=l.person.details.propertyTenancyAdditionalDetails),l.person.details.propertyOwnedByApplicant&&(u.property=t(t({},u.property),function(e,n){return Object.keys(n).reduce((function(r,a){var i,o=void 0!==e[a]?e[a]:a;return t(t({},r),((i={})[o]=n[a],i))}),{})}({marketValue:"value"},l.person.details.propertyOwnedByApplicant)));var c=null!==(a=(null!==(r=s.person)&&void 0!==r?r:{}).details)&&void 0!==a?a:{};delete c.propertyTenancy,delete c.propertyType,delete c.heatingType,delete c.otherHeatingType,delete c.propertyRentedByApplicant,delete c.hasPreviouslyOwnedProperty,delete c.propertyPreviouslyOwned,delete c.propertyTenancyAdditionalDetails,delete c.propertyOwnedByApplicant}return s}},59018:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.migrations=void 0;var t=r(12881),a=r(1320);n.migrations={LI_RFCA:{1:[t.m1],2:[a.propertyFields]}}},78895:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=n.getIncomeDisregards=n.calculateWeeklyUniversalCredit=void 0;var t=r(5416),a=r(76947),i=r(73185),o=r(38510),s=r(72147),l=r(6998),u=r(32954),c=r(56822),d=r(13342),p=new u.NumberUtilsService,g=new c.CareAssessmentService(p,{});function f(e,n){return(0,i.find)(e,{name:n})}function m(e){return p.isNumeric(e)?p.roundNearest(e,2):e}function v(e){void 0===e&&(e={});var n=p.sumArgs(e.standardAllowance||0,e.housingElement||0,e.limitedWorkCapability||0,e.limitedWorkAndRelatedCapability||0,e.carer||0);return n-=p.sumArgs(e.other||0,e.earnings||0,e.capitalTariff||0,e.benefitLimit||0),g.toWeeklyAmount(n,"Monthly")}function h(e,n,r,t){var a=0,i=e.getWeeklyIncome("dlaCare"),s=e.getWeeklyIncome("pipDailyLiving"),l=e.getWeeklyIncome("attendanceAllowance");a+=t.getPartialDisregard(l,o.constants.attendanceAllowance),a+=t.getPartialDisregard(i,o.constants.dlaCare),a+=t.getPartialDisregard(s,o.constants.pipDailyLiving),e.transferHalfPensionToPartner&&(a+=e.getWeeklyIncome("privatePension")/2),a+=e.getWeeklyIncome("mobilityAllowance");var u=e.dob,c=g.getAgeLevel(u,o.constants.levels).level,d=e.getFullWeeklyIncome("pensionSavingsCredit");a+=t.getPensionSavingsCreditDisregard({qualifyingIncome:r,pscAmount:d,hasPartner:n,ageLevel:c});var p=e.getWeeklyIncome("warPension"),f=e.getWeeklyIncome("warWidowsPension");a+=t.getWarPensionDisregard(p),a+=t.getWarWidowsPensionDisregard(f),a+=["pensionGuaranteeCredit","incomeSupportPayment","employmentSupport","jobSeekersAllowance","housingBenefit"].reduce((function(n,r){return e.incomes.some((function(e){return e.name===r&&e.isJoint}))&&(n+=e.getWeeklyIncome(r)),n}),0);var m=!1,v=e.workingAgeBenefitsIncludePremia,h=["employmentSupport","incomeSupportPayment","jobSeekersAllowance"].reduce((function(n,r){return e.incomes.some((function(e){return e.name===r&&e.isJoint}))&&(m=!0),n+e.getWeeklyIncome(r)}),0);a+=t.getPremiumDisregard(m,v,h);var y=!1,P=e.pensionAgeBenefitsIncludePremia,C=["pensionGuaranteeCredit"].reduce((function(n,r){return e.incomes.some((function(e){return e.name===r&&e.isJoint}))&&(y=!0),n+e.getWeeklyIncome(r)}),0);return a+=t.getPremiumDisregard(y,P,C)}n.calculateWeeklyUniversalCredit=v,n.getIncomeDisregards=h,n.calculator=function(e,n,r){var i,u,c=o.constants.careTypes;switch(r){case c.temporaryResidential:u=new d.TemporaryResidentialCareType;break;case c.permWeek1Residential:u=new d.PermWeek1ResidentialCareType;break;case c.permWeek13Residential:u=new d.PermWeek13ResidentialCareType;break;case c.nonResidential:default:u=new d.NonResidentialCareType,r=c.nonResidential}var y=n?new s.ShortAssessmentInputModel(e,u):new l.FullAssessmentInputModel(e,u),P=y.getApplicantData(),C=y.isCouple(),w=y.partnerCohabits(),I=y.getPartnerData(),O=(null===(i=e.peopleLivingWithYou)||void 0===i?void 0:i.otherPeople)||[],b=P.partnerInLongTermCare,A=P.partnerInShortTermCare,T={totalIncome:0,totalIncomeLessDisregards:0,totalCapital:0,tariffIncomeFromCapital:0,allowableHousingCosts:0,disabilityRelatedExpenses:0,standardDisregards:0,totalExpenses:0,netIncome:0,qualifyingIncome:0};if("notExempt"!==P.chargingExemption)return{contributions:{maxContribution:0,actualContribution:0},workings:T};var R=P.incomes.reduce((function(e,n){return e+u.getGrossIncomeForType(n)}),0),_=P.qiIncomes.reduce((function(e,n){return e+u.getGrossIncomeForType(n)}),0),E=0,D=v(P.personUniversalCredit);console.log("personWeeklyUniversalCredit",D),D>0?(E=D,P.declarePartnerFinances&&(E/=2)):(E=v(P.partnerUniversalCredit),E/=2),R+=Math.max(E,0),T.totalIncome=m(R),console.log("Total weekly income",R);var L=P.individualCapital+y.getJointCapital()/2;T.totalCapital=m(L),_+=Math.ceil(Math.max(0,(L-o.constants.qiCapitalLimit)/500)),T.qualifyingIncome=_,R-=h(P,C,_,u),console.log("Total weekly income net of disregards",R),T.totalIncomeLessDisregards=m(R);var S=Number.POSITIVE_INFINITY;if(L<o.constants.fullCostCapitalLimit[r]){var N=Math.max(0,(L-o.constants.capitalLimit)/250);N=Math.ceil(N),T.tariffIncomeFromCapital=m(N),R+=N;var k=y.getWeeklyExpense("mortgage")+y.getWeeklyExpense("mortgageInsurance"),j=y.getWeeklyExpense("homeInsurance");k+=j*=P.isHomeInsuranceCombined?.5:1;var M=y.getWeeklyExpense("rent"),x=y.getWeeklyExpense("councilTax");console.log("Weekly council tax",x);var F=k+M,H=y.getWeeklyExpense("waterRates"),B=y.getWeeklyExpense("gas"),W=y.getWeeklyExpense("electric"),Y=y.getWeeklyExpense("lifeline"),G=u.getHouseholdExpenses(F,C,w,O.length,b,A),U=u.getCouncilTaxCosts(x,C,w,O.length,b,A),V=u.getWaterRates(H,C,w,O.length,b,A),Z=u.getGasCosts(B,C,w,O.length,b,A),J=u.getElectricCosts(W,C,w,O.length,b,A),q=u.getLifelineCosts(Y,C,w,O.length,b,A),X=y.getWeeklyExpense("compulsoryPayments"),z=y.getWeeklyExpense("groundRent");X=u.getCCP(X,C,w,O.length,b,A),z=u.getGroundRent(z,C,w,O.length,b,A);var K=u.getAllowableHousingCosts(G,U,V,Z,J,q,z,O.length);T.allowableHousingCosts=m(K);var $=[G,U,V,Z,J,q,z,X].reduce((function(e,n){return e+n}));T.totalExpenses=m($);var Q=function(e,n){var r=(f(e.incomes,"dlaCare")||{}).level,t=(f(e.incomes,"pipDailyLiving")||{}).level,a=(f(e.incomes,"attendanceAllowance")||{}).level,i=0;return r===o.constants.levels.low?i=10:r===o.constants.levels.medium||t===o.constants.levels.low||a===o.constants.levels.low?i=15:r!==o.constants.levels.high&&t!==o.constants.levels.high&&a!==o.constants.levels.high||(i=25),n.getDREExpenses(i)}(P,u);T.disabilityRelatedExpenses=m(Q);var ee=function(e,n,r){void 0===n&&(n={});var a=e.dob;if(n.dob){var i=t(a,"DD/MM/YYYY");t(n.dob,"DD/MM/YYYY").isBefore(i)&&(a=n.dob)}var s=g.getAgeLevel(a,o.constants.levels).level,l=e.allowanceType,u=e.allowanceUserType,c=r.getMIGRate(s,l,u),d=e.dependentChildren.length,p=o.constants.childPremium*d,f=e.isEntitledToCarersAllowance?o.constants.carersPremium:0;return m(c+(p=r.getChildPremium(p))+(f=r.getCarersPremium(f)))}(P,I,u);T.standardDisregards=ee;var ne=R-(K+Q+ee);T.netIncome=m(ne),S=Math.max(p.roundNearest(ne),0)}var re=function(e,n){var r,t=e.getWeeklyIncome("retirementPensionReceived");g.getAge(e.dob)>=80&&(t=Math.max(0,t-o.constants.ageAddition));var i={person:{statePensionBeforeAgeAddition:{amount:p.roundNearest(t),period:a.PERIODS.Weekly}}};if(n.getWeeklyIncome){var s=n.getWeeklyIncome("retirementPensionReceived");g.getAge(n.dob||"")>=80&&(s=Math.max(0,s-o.constants.ageAddition)),r={statePensionBeforeAgeAddition:{amount:p.roundNearest(s),period:a.PERIODS.Weekly}},i.partner=r}return i}(P,I),te=P.incomes.find((function(e){return"otherIncome"==e.name}));(te?te.amount:0)>o.constants.fullCostCapitalLimit[r]&&(S=Number.POSITIVE_INFINITY);var ae={};return p.isNumeric(S)&&(ae.maxContribution=S),{contributions:ae,workings:T,generated:re}}},13342:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.PermWeek13ResidentialCareType=n.PermWeek1ResidentialCareType=n.TemporaryResidentialCareType=n.NonResidentialCareType=void 0;var t=r(53431);Object.defineProperty(n,"NonResidentialCareType",{enumerable:!0,get:function(){return t.NonResidentialCareType}});var a=r(30127);Object.defineProperty(n,"TemporaryResidentialCareType",{enumerable:!0,get:function(){return a.TemporaryResidentialCareType}});var i=r(58041);Object.defineProperty(n,"PermWeek1ResidentialCareType",{enumerable:!0,get:function(){return i.PermWeek1ResidentialCareType}});var o=r(7722);Object.defineProperty(n,"PermWeek13ResidentialCareType",{enumerable:!0,get:function(){return o.PermWeek13ResidentialCareType}})},53431:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.NonResidentialCareType=void 0;var t=r(73185),a=r(38510),i=function(){function e(){}return e.prototype.getEquityInAdditionalProperties=function(e){return void 0===e&&(e=[]),0},e.prototype.isPensionTransferred=function(e){return!0===(e.person.details||{}).transferHalfPensionToPartner},e.prototype.getPartialDisregard=function(e,n){var r,a=(0,t.find)(Object.keys(n),(function(r){var t=n[r];return(null==t?void 0:t.amount)===e})),i=null===(r=n[a])||void 0===r?void 0:r.disregard;return null!=i?i:0},e.prototype.getHouseholdExpenses=function(e,n,r,t){return e?e/(1+(r?1:0)):0},e.prototype.getCouncilTaxCosts=function(e,n,r,t){return e?e/(1+(r?1:0)):0},e.prototype.getWaterRates=function(e,n,r,t){return 0},e.prototype.getGasCosts=function(e,n,r,t){return 0},e.prototype.getElectricCosts=function(e,n,r,t){return 0},e.prototype.getLifelineCosts=function(e,n,r,t){return 0},e.prototype.getGroundRent=function(e,n,r,t){return e?e/(1+(r?1:0)):0},e.prototype.getCCP=function(e,n,r,t){return 0},e.prototype.getAllowableHousingCosts=function(e,n,r,t,a,i,o){return e+n+r+t+a+i},e.prototype.getMIGRate=function(e,n,r){var t=0;return a.constants.migRates[r].some((function(r){return r.age===e&&r.allowanceType===n&&(t=r.value),0!==t})),t},e.prototype.getChildPremium=function(e){return e},e.prototype.getCarersPremium=function(e){return e},e.prototype.getDREExpenses=function(e){return e},e.prototype.getWarPensionDisregard=function(e){return 0},e.prototype.getWarWidowsPensionDisregard=function(e){return 0},e.prototype.getGrossIncomeForType=function(e){return["warPension","warWidowsPension"].indexOf(e.name)<0?e.weeklyAmount:0},e.prototype.getPensionSavingsCreditDisregard=function(e){return e.pscAmount},e.prototype.getPremiumDisregard=function(e,n,r){return 0},e}();n.NonResidentialCareType=i},7722:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.PermWeek13ResidentialCareType=void 0;var t=new(r(13342).PermWeek1ResidentialCareType),a=function(){function e(){}return e.prototype.getEquityInAdditionalProperties=function(e){return void 0===e&&(e=[]),t.getEquityInAdditionalProperties(e)},e.prototype.isPensionTransferred=function(e){return t.isPensionTransferred(e)},e.prototype.getPartialDisregard=function(e,n){return t.getPartialDisregard(e,n)},e.prototype.getHouseholdExpenses=function(e,n,r,a){return t.getHouseholdExpenses(e,n,r,a)},e.prototype.getCouncilTaxCosts=function(e,n,r,a){return t.getCouncilTaxCosts(e,n,r,a)},e.prototype.getWaterRates=function(e,n,r,a){return t.getWaterRates(e,n,r,a)},e.prototype.getGasCosts=function(e,n,r,a){return t.getGasCosts(e,n,r,a)},e.prototype.getElectricCosts=function(e,n,r,a){return t.getElectricCosts(e,n,r,a)},e.prototype.getLifelineCosts=function(e,n,r,a){return t.getLifelineCosts(e,n,r,a)},e.prototype.getGroundRent=function(e,n,r,a){return t.getGroundRent(e,n,r,a)},e.prototype.getCCP=function(e,n,r,a){return t.getCCP(e,n,r,a)},e.prototype.getAllowableHousingCosts=function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];return t.getAllowableHousingCosts.apply(t,e)},e.prototype.getMIGRate=function(e,n,r){return t.getMIGRate(e,n,r)},e.prototype.getChildPremium=function(e){return t.getChildPremium(e)},e.prototype.getCarersPremium=function(e){return t.getCarersPremium(e)},e.prototype.getDREExpenses=function(e){return t.getDREExpenses(e)},e.prototype.getWarPensionDisregard=function(e){return t.getWarPensionDisregard(e)},e.prototype.getWarWidowsPensionDisregard=function(e){return t.getWarWidowsPensionDisregard(e)},e.prototype.getGrossIncomeForType=function(e){return t.getGrossIncomeForType(e)},e.prototype.getPensionSavingsCreditDisregard=function(e){return t.getPensionSavingsCreditDisregard(e)},e.prototype.getPremiumDisregard=function(e,n,r){return t.getPremiumDisregard(e,n,r)},e}();n.PermWeek13ResidentialCareType=a},58041:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.PermWeek1ResidentialCareType=void 0;var t=r(13342),a=r(38510),i=new t.TemporaryResidentialCareType,o=function(){function e(){}return e.prototype.getEquityInAdditionalProperties=function(e){return void 0===e&&(e=[]),i.getEquityInAdditionalProperties(e)},e.prototype.isPensionTransferred=function(e){return i.isPensionTransferred(e)},e.prototype.getPartialDisregard=function(e,n){return i.getPartialDisregard(e,n)},e.prototype.getHouseholdExpenses=function(e,n,r,t){return 0},e.prototype.getCouncilTaxCosts=function(e,n,r,t){return 0},e.prototype.getWaterRates=function(e,n,r,t){return 0},e.prototype.getGasCosts=function(e,n,r,t){return 0},e.prototype.getElectricCosts=function(e,n,r,t){return 0},e.prototype.getLifelineCosts=function(e,n,r,t){return 0},e.prototype.getGroundRent=function(e,n,r,t){return 0},e.prototype.getCCP=function(e,n,r,t){return 0},e.prototype.getAllowableHousingCosts=function(e,n,r,t,a,i,o){return void 0===e&&(e=0),void 0===n&&(n=0),void 0===r&&(r=0),void 0===t&&(t=0),void 0===a&&(a=0),void 0===i&&(i=0),void 0===o&&(o=0),e+n+r+t+a+i+o},e.prototype.getMIGRate=function(e,n,r){return a.constants.migRates.residentialRate},e.prototype.getChildPremium=function(e){return 0},e.prototype.getCarersPremium=function(e){return 0},e.prototype.getDREExpenses=function(e){return 0},e.prototype.getWarPensionDisregard=function(e){return e},e.prototype.getWarWidowsPensionDisregard=function(e){return Math.min(10,e)},e.prototype.getGrossIncomeForType=function(e){return i.getGrossIncomeForType(e)},e.prototype.getPensionSavingsCreditDisregard=function(e){return i.getPensionSavingsCreditDisregard(e)},e.prototype.getPremiumDisregard=function(e,n,r){return i.getPremiumDisregard(e,n,r)},e}();n.PermWeek1ResidentialCareType=o},30127:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.TemporaryResidentialCareType=void 0;var t=r(38510),a=function(){function e(){}return e.prototype.getEquityInAdditionalProperties=function(e){void 0===e&&(e=[]);var n=0;return e.forEach((function(e){var r=e.value||0;e.isJointlyOwned&&(r=0),n+=r})),n},e.prototype.isPensionTransferred=function(e){var n=e.person.details||{};return!0===n.transferHalfPensionToPartner&&!0==!n.partnerReceivesCare},e.prototype.getPartialDisregard=function(e,n){return e},e.prototype.getCohabitingAdults=function(e){var n=e.cohabitingAdults,r=void 0===n?0:n,t=(e.partnerCohabits,e.partnerInLongTermCare,e.partnerInShortTermCare,1);return r&&t++,t},e.prototype.getHouseholdExpenses=function(e,n,r,t,a,i){return e},e.prototype.getCouncilTaxCosts=function(e,n,r,t,a,i){return e},e.prototype.getWaterRates=function(e,n,r,t,a,i){return e},e.prototype.getGasCosts=function(e,n,r,t,a,i){return e},e.prototype.getElectricCosts=function(e,n,r,t,a,i){return e},e.prototype.getLifelineCosts=function(e,n,r,t,a,i){return e},e.prototype.getGroundRent=function(e,n,r,t,a,i){return e},e.prototype.getCCP=function(e,n,r,t,a,i){return 0},e.prototype.getAllowableHousingCosts=function(e,n,r,a,i,o,s,l){var u=this.getCohabitingAdults({cohabitingAdults:l}),c=e+s+(n+r+a+i+o>0?t.constants.expenseLimit:0);return c?c/u:0},e.prototype.getMIGRate=function(e,n,r){return t.constants.migRates.residentialRate},e.prototype.getChildPremium=function(e){return 0},e.prototype.getCarersPremium=function(e){return 0},e.prototype.getDREExpenses=function(e){return 0},e.prototype.getWarPensionDisregard=function(e){return e},e.prototype.getWarWidowsPensionDisregard=function(e){return Math.min(10,e)},e.prototype.getGrossIncomeForType=function(e){return e.weeklyAmount},e.prototype.getPensionSavingsCreditDisregard=function(e){var n=t.constants.pensionSavingsCreditIncomeThreshold.singleApplicant,r=n.INCOME_LOW,a=n.INCOME_HIGH,i=n.DISREGARD_MAX,o=e.qualifyingIncome;return e.ageLevel!==t.constants.levels.high||o<r?0:o>=r&&o<=a?e.pscAmount>0?Math.min(e.pscAmount,i):0:i},e.prototype.getPremiumDisregard=function(e,n,r){var a=0;if(e)return a;switch(n){case"sdpPremium":a=Math.min(r,t.constants.sdpPremiumDisregard);break;case"carerPremium":a=Math.min(r,t.constants.carerPremiumDisregard)}return a},e}();n.TemporaryResidentialCareType=a},38510:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=n.AllowanceUserTypes=n.AllowanceTypes=void 0;var t,a,i=r(50237),o=r(76947);!function(e){e.personal="personal",e.disabilityPremium="disabilityPremium",e.enhancedDisabilityPremium="enhancedDisabilityPremium"}(t=n.AllowanceTypes||(n.AllowanceTypes={})),function(e){e.single="single",e.loneParent="loneParent",e.couple="couple"}(a=n.AllowanceUserTypes||(n.AllowanceUserTypes={})),n.constants={personalLivingAllowance:{},configuration:{},careTypes:{nonResidential:"nonResidential",temporaryResidential:"temporaryResidential",permWeek1Residential:"permWeek1Residential",permWeek13Residential:"permWeek13Residential"},fullCostCapitalLimit:{nonResidential:23250,temporaryResidential:23250,permWeek1Residential:23250,permWeek13Residential:23250},userTypes:{user:"user",partner:"partner"},fixedPaymentPeriods:{councilTax:o.PERIODS.Annually},expenseTypes:["compulsoryPayments","rent","councilTax","mortgage","mortgageInsurance","homeInsurance","groundRent","waterRates","gas","electric","lifeline"],upliftableIncomeTypes:["attendanceAllowance","dlaCare","mobilityAllowance","pipDailyLiving"],incomeTypes:["carersAllowance","retirementPensionReceived","pensionGuaranteeCredit","pensionSavingsCredit","otherBenefit","incomeSupportPayment","incapacityBenefit","employmentSupport","severeDisablement","maternityAllowance","maintenance","exceptionalSevereDisablement","jobSeekersAllowance","industrialInjuriesBenefit","privatePension","rentalIncome","annuitiesIncome","trustFunds","otherIncome","housingBenefit","warPension","warWidowsPension"],qiIncomeTypes:["retirementPensionReceived","privatePension","annuitiesIncome"],levels:{low:i.Levels.low,medium:i.Levels.medium,high:i.Levels.high},sdpPremiumDisregard:82.9,carerPremiumDisregard:53.25,carersPremium:53.25,childPremium:102.85,capitalLimit:14250,qiCapitalLimit:14250,capitalTariff:{nonResidential:250,temporaryResidential:250,permWeek1Residential:250,permWeek13Residential:250},attendanceAllowance:{low:{amount:73.9,disregard:0},high:{amount:110.4,disregard:36.5}},pipDailyLiving:{low:{amount:73.9,disregard:0},high:{amount:110.4,disregard:36.5}},dlaCare:{low:{amount:29.2,disregard:0},medium:{amount:73.9,disregard:0},high:{amount:110.4,disregard:36.5}},mobilityAllowance:{low:{amount:29.2},high:{amount:77.95}},allowanceTypes:{personal:t.personal,disabilityPremium:t.disabilityPremium,enhancedDisabilityPremium:t.enhancedDisabilityPremium},allowanceUserTypes:{single:a.single,loneParent:a.loneParent,couple:a.couple},migRates:{residentialRate:30.65,single:[{age:i.Levels.low,allowanceType:t.personal,value:89.15},{age:i.Levels.low,allowanceType:t.disabilityPremium,value:141.2},{age:i.Levels.low,allowanceType:t.enhancedDisabilityPremium,value:163.05},{age:i.Levels.medium,allowanceType:t.personal,value:112.5},{age:i.Levels.medium,allowanceType:t.disabilityPremium,value:162.15},{age:i.Levels.medium,allowanceType:t.enhancedDisabilityPremium,value:186.4},{age:i.Levels.high,allowanceType:t.personal,value:232.6},{age:i.Levels.high,allowanceType:t.disabilityPremium,value:232.6},{age:i.Levels.high,allowanceType:t.enhancedDisabilityPremium,value:232.6}],loneParent:[{age:i.Levels.low,allowanceType:t.personal,value:112.5},{age:i.Levels.low,allowanceType:t.disabilityPremium,value:162.15},{age:i.Levels.low,allowanceType:t.enhancedDisabilityPremium,value:186.4},{age:i.Levels.medium,allowanceType:t.personal,value:112.5},{age:i.Levels.medium,allowanceType:t.disabilityPremium,value:162.15},{age:i.Levels.medium,allowanceType:t.enhancedDisabilityPremium,value:186.4},{age:i.Levels.high,allowanceType:t.personal,value:232.6},{age:i.Levels.high,allowanceType:t.disabilityPremium,value:232.6},{age:i.Levels.high,allowanceType:t.enhancedDisabilityPremium,value:232.6}],couple:[{age:i.Levels.low,allowanceType:t.personal,value:88.35},{age:i.Levels.low,allowanceType:t.disabilityPremium,value:123.75},{age:i.Levels.low,allowanceType:t.enhancedDisabilityPremium,value:141.2},{age:i.Levels.medium,allowanceType:t.personal,value:88.35},{age:i.Levels.medium,allowanceType:t.disabilityPremium,value:123.75},{age:i.Levels.medium,allowanceType:t.enhancedDisabilityPremium,value:141.2},{age:i.Levels.high,allowanceType:t.personal,value:177.55},{age:i.Levels.high,allowanceType:t.disabilityPremium,value:177.55},{age:i.Levels.high,allowanceType:t.enhancedDisabilityPremium,value:177.55}]},expenseLimit:55,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}},ageAddition:.25}},86915:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.lincs=void 0;var t=r(78895),a=r(38510);n.lincs={calculator:t.calculator,constants:a.constants}},76947:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.PERIODS=void 0;var t=r(56822);Object.defineProperty(n,"PERIODS",{enumerable:!0,get:function(){return t.PERIODS}})},6998:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.FullAssessmentInputModel=void 0;var t=r(73185),a=r(76947),i=r(32954),o=r(58600),s=r(38510),l=r(56822),u=new o.ObjectUtilsService,c=new i.NumberUtilsService,d=new l.CareAssessmentService(c,{});function p(e,n){var r=n.amount;switch(n.accountType){case"premium_bond":case"isa":default:break;case"savings_bond":case"investment_bond":r=n.lifeAssured?0:r;break;case"trust":r=0}return e+=r||0}function g(e){return e=e||"amount",function(n,r){return n+r[e]}}var f=function(){function e(e,n){this.fields=e,this.careTypeStrategy=n}return e.prototype.getJointCapital=function(){var e=this.fields.joint&&this.fields.joint.capital;return e?(e.hasSavingsInvestments&&e.savingsInvestments?e.savingsInvestments.reduce(g(),0):0)+(e.hasShareholdings&&e.shareholdings?e.shareholdings.reduce(g("totalValue"),0):0)+(e.hasBonds&&e.bonds?e.bonds.reduce(p,0):0):0},e.prototype.getPeriodicAmounts=function(e,n){var r=[];return n?(e.forEach((function(e){if(void 0!==n[e]){var t=n[e],a=s.constants.fixedPaymentPeriods[e];a=void 0!==a?a:n[e+"Period"];var i=!(!0!==n[e+"IsJoint"]);r.push({name:e,amount:t,weeklyAmount:d.toWeeklyAmount(t,a),isJoint:i})}})),r):r},e.prototype.getPeriodicUpliftables=function(e,n){var r=[];return n?(e.forEach((function(e){if(void 0!==n[e]){var t=n[e],a=s.constants[e][t],i=void 0!==a?a.amount:0,o=!(!0!==n[e+"IsJoint"]);r.push({name:e,amount:i,weeklyAmount:i,level:t,isJoint:o})}})),r):r},e.prototype.weeklyTotal=function(e){return e?e.reduce((function(e,n){var r,t;return e+d.toWeeklyAmount(null!==(r=n.amount)&&void 0!==r?r:0,null!==(t=n.amountPeriod)&&void 0!==t?t:a.PERIODS.Weekly)}),0):0},e.prototype.getPersonalData=function(e){var n=[],r=[];if(e.income){n=this.getPeriodicAmounts(s.constants.incomeTypes,e.income.sources),r=this.getPeriodicAmounts(s.constants.qiIncomeTypes,e.income.sources);var a=this.weeklyTotal(e.income.privatePensions)+this.weeklyTotal(e.income.deferredPensions),i=this.weeklyTotal(e.income.annuities);n.push({name:"annuitiesIncome",amount:i,weeklyAmount:i}),r.push({name:"annuitiesIncome",amount:i,weeklyAmount:i}),n.push({name:"privatePension",amount:a,weeklyAmount:a}),r.push({name:"privatePension",amount:a,weeklyAmount:a});var o=this.getPeriodicUpliftables(s.constants.upliftableIncomeTypes,e.income.sources);n=n.concat(o)}var l=0,u=0,c=0;if(e.capital){var d=e.capital;l=d.hasSavingsInvestments&&d.savingsInvestments?d.savingsInvestments.reduce(g(),0):0,u=d.hasShareholdings&&d.shareholdings?d.shareholdings.reduce(g("totalValue"),0):0,c=d.hasBonds&&d.bonds?d.bonds.reduce(p,0):0}var f,m=(e.property||{}).additionalProperties||[];return f=this.careTypeStrategy.getEquityInAdditionalProperties(m),e.details=e.details||{},{dob:e.details.dob,individualCapital:l+u+c+f,incomes:n,qiIncomes:r,getWeeklyIncome:function(e){var r=(0,t.find)(n,{name:e}),a=r?r.weeklyAmount:0;return r&&r.isJoint&&(a/=2),a},getFullWeeklyIncome:function(e){var r=(0,t.find)(n,{name:e});return r?r.weeklyAmount:0}}},e.prototype.getWeeklyExpense=function(e){var n=this.getPeriodicAmounts(s.constants.expenseTypes,this.fields.person.expenses),r=(0,t.find)(n,{name:e});return r?r.weeklyAmount:0},e.prototype.getApplicantData=function(){var e,n,r,t,a,i,o,l=this.getPersonalData(this.fields.person);l.propertyType=(null===(e=this.fields.person.details)||void 0===e?void 0:e.propertyType)||"",l.transferHalfPensionToPartner=this.careTypeStrategy.isPensionTransferred(this.fields),l.declarePartnerFinances=(null===(n=this.fields.person.details)||void 0===n?void 0:n.declarePartnerFinances)||!1,l.chargingExemption=(null===(r=this.fields.person.details)||void 0===r?void 0:r.chargingExemption)||"",l.isHomeInsuranceCombined=u.getPropertyPath(this.fields,"person.expenses.isHomeInsuranceCombined");var c=u.getPropertyPath(this.fields,"person.income.sources.dlaCare"),d=u.getPropertyPath(this.fields,"person.income.sources.pipDailyLiving"),p=u.getPropertyPath(this.fields,"partner.income.sources.dlaCare"),g=u.getPropertyPath(this.fields,"partner.income.sources.pipDailyLiving");l.allowanceType=s.constants.allowanceTypes.personal,c!==s.constants.levels.medium&&d!==s.constants.levels.low&&p!==s.constants.levels.medium&&d!==s.constants.levels.low||(l.allowanceType=s.constants.allowanceTypes.disabilityPremium),c!==s.constants.levels.high&&d!==s.constants.levels.high&&p!==s.constants.levels.high&&g!==s.constants.levels.high||(l.allowanceType=s.constants.allowanceTypes.enhancedDisabilityPremium),l.dependentChildren=(null===(t=this.fields.peopleLivingWithYou)||void 0===t?void 0:t.dependentChildren)||[],this.isCouple()?l.allowanceUserType=s.constants.allowanceUserTypes.couple:(l.allowanceUserType=s.constants.allowanceUserTypes.single,l.dependentChildren.length&&(l.allowanceUserType=s.constants.allowanceUserTypes.loneParent)),l.isEntitledToCarersAllowance=u.getPropertyPath(this.fields,"person.details.isEntitledToCarersPremium"),l.isPartnerEntitledToCarersAllowance=u.getPropertyPath(this.fields,"partner.details.isEntitledToCarersPremium");var f=u.getPropertyPath(this.fields,"person.income.hasUniversalCredit");l.personUniversalCredit=f&&(null===(a=this.fields.person.income)||void 0===a?void 0:a.universalCredit)||{};var m=u.getPropertyPath(this.fields,"partner.income.hasUniversalCredit");l.partnerUniversalCredit=m&&(null===(o=null===(i=this.fields.partner)||void 0===i?void 0:i.income)||void 0===o?void 0:o.universalCredit)||{};var v=u.getPropertyPath(this.fields,"person.details.partnerResidentialCareTerm"),h="longTerm"===v,y="shortTerm"===v||"unknown"===v;return l.partnerInLongTermCare=h,l.partnerInShortTermCare=y,l.workingAgeBenefitsIncludePremia=u.getPropertyPath(this.fields,"person.income.sources.workingAgeBenefitsIncludePremia"),l.pensionAgeBenefitsIncludePremia=u.getPropertyPath(this.fields,"person.income.sources.pensionAgeBenefitsIncludePremia"),l},e.prototype.getPartnerData=function(){return this.isCouple()&&this.fields.partner?this.getPersonalData(this.fields.partner):{}},e.prototype.isCouple=function(){var e;return!0===(null===(e=this.fields.person.details)||void 0===e?void 0:e.hasPartner)},e.prototype.partnerCohabits=function(){var e;return!0===(null===(e=this.fields.person.details)||void 0===e?void 0:e.partnerLivesAtSameAddress)},e}();n.FullAssessmentInputModel=f},72147:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.ShortAssessmentInputModel=void 0;var t=r(73185),a=r(32954),i=r(58600),o=r(38510),s=r(56822),l=new i.ObjectUtilsService,u=new a.NumberUtilsService,c=new s.CareAssessmentService(u,{}),d=function(){function e(e,n){this.fields=e,this.careTypeStrategy=n}return e.prototype.getJointCapital=function(){return l.getPropertyPath(this.fields,"person.capital.joint")||0},e.prototype.getPeriodicAmounts=function(e,n){var r=[];return n?(e.forEach((function(e){if(void 0!==n[e]){var t=n[e],a=o.constants.fixedPaymentPeriods[e];a=void 0!==a?a:n[e+"Period"];var i=!(!0!==n[e+"IsJoint"]);r.push({name:e,amount:t,weeklyAmount:c.toWeeklyAmount(t,a),isJoint:i})}})),r):r},e.prototype.getPeriodicUpliftables=function(e,n){var r=[];return n?(e.forEach((function(e){if(void 0!==n[e]){var t=n[e],a=o.constants[e][t],i=void 0!==a?a.amount:0,s=!(!0!==n[e+"IsJoint"]);r.push({name:e,amount:i,weeklyAmount:i,level:t,isJoint:s})}})),r):r},e.prototype.getPersonalData=function(e){var n,r=[];r=this.getPeriodicAmounts(o.constants.incomeTypes,e.income||{}),n=this.getPeriodicAmounts(o.constants.qiIncomeTypes,e.income||{});var a=this.getPeriodicUpliftables(o.constants.upliftableIncomeTypes,e.income);return r=r.concat(a),e.intro=e.intro||{},{dob:e.intro.dob,individualCapital:e.capital&&e.capital.individual||0,incomes:r,qiIncomes:n,getWeeklyIncome:function(e){var n=(0,t.find)(r,{name:e}),a=n?n.weeklyAmount:0;return n&&n.isJoint&&(a/=2),a},getFullWeeklyIncome:function(e){var n=(0,t.find)(r,{name:e});return n?n.weeklyAmount:0}}},e.prototype.getWeeklyExpense=function(e){var n=this.getPeriodicAmounts(o.constants.expenseTypes,this.fields.person.expenses),r=(0,t.find)(n,{name:e});return r?r.weeklyAmount:0},e.prototype.getApplicantData=function(){var e,n,r,t,a,i,s,u=this.getPersonalData(this.fields.person);u.propertyType=(null===(e=this.fields.person.intro)||void 0===e?void 0:e.propertyType)||"",u.transferHalfPensionToPartner=this.careTypeStrategy.isPensionTransferred(this.fields),u.declarePartnerFinances=(null===(n=this.fields.person.intro)||void 0===n?void 0:n.declarePartnerFinances)||!1,u.chargingExemption=(null===(r=this.fields.person.intro)||void 0===r?void 0:r.chargingExemption)||"",u.isHomeInsuranceCombined=l.getPropertyPath(this.fields,"person.expenses.isHomeInsuranceCombined");var c=l.getPropertyPath(this.fields,"person.income.dlaCare"),d=l.getPropertyPath(this.fields,"person.income.pipDailyLiving");u.allowanceType=o.constants.allowanceTypes.personal,c!==o.constants.levels.medium&&d!==o.constants.levels.low||(u.allowanceType=o.constants.allowanceTypes.disabilityPremium),c!==o.constants.levels.high&&d!==o.constants.levels.high||(u.allowanceType=o.constants.allowanceTypes.enhancedDisabilityPremium),u.dependentChildren=(null===(t=this.fields.peopleLivingWithYou)||void 0===t?void 0:t.dependentChildren)||[],this.isCouple()?u.allowanceUserType=o.constants.allowanceUserTypes.couple:(u.allowanceUserType=o.constants.allowanceUserTypes.single,u.dependentChildren.length&&(u.allowanceUserType=o.constants.allowanceUserTypes.loneParent)),u.isEntitledToCarersAllowance=l.getPropertyPath(this.fields,"person.intro.isEntitledToCarersPremium"),u.isPartnerEntitledToCarersAllowance=l.getPropertyPath(this.fields,"partner.intro.isEntitledToCarersPremium");var p=l.getPropertyPath(this.fields,"person.income.hasUniversalCredit");u.personUniversalCredit=p&&(null===(a=this.fields.person.income)||void 0===a?void 0:a.universalCredit)||{};var g=l.getPropertyPath(this.fields,"partner.income.hasUniversalCredit");u.partnerUniversalCredit=g&&(null===(s=null===(i=this.fields.partner)||void 0===i?void 0:i.income)||void 0===s?void 0:s.universalCredit)||{};var f=l.getPropertyPath(this.fields,"person.intro.partnerResidentialCareTerm"),m="Long term"===f,v="Short term"===f||"Not sure"===f;return u.partnerInLongTermCare=m,u.partnerInShortTermCare=v,u.workingAgeBenefitsIncludePremia=l.getPropertyPath(this.fields,"person.income.workingAgeBenefitsIncludePremia"),u.pensionAgeBenefitsIncludePremia=l.getPropertyPath(this.fields,"person.income.pensionAgeBenefitsIncludePremia"),u},e.prototype.getPartnerData=function(){return this.isCouple()&&this.fields.partner?this.getPersonalData(this.fields.partner):{}},e.prototype.isCouple=function(){var e;return!0===(null===(e=this.fields.person.intro)||void 0===e?void 0:e.havePartner)},e.prototype.partnerCohabits=function(){var e;return!0===(null===(e=this.fields.person.intro)||void 0===e?void 0:e.partnerLivesAtSameAddress)},e}();n.ShortAssessmentInputModel=d},1156:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(65620),i=r(96983),o=r(3077),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l);c=Object.assign(c,d);var p=l.fullCostCapitalLimit[r];if((d.totalCapital||0)>=p){var g=(l.maxContribution||{})[r];return{contributions:s.isNumeric(g)?{maxContribution:g}:{},workings:c}}var f=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,f);var m=(0,o.getExpenses)(e,r);c=Object.assign(c,m);var v=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,v);var h=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,h)}else u=Object.assign(u,{fullCost:!0});for(var y in c)if(Object.prototype.hasOwnProperty.call(c,y)){var P=c[y]||0;c[y]=s.roundNearest(P)}return(0,i.getCostOfCare)(e,r,l,c,u)}},39281:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",shortStayResidential:"shortStayResidential",longStayResidential:"longStayResidential"},warWidowsPensionDisregard:0,warPensionDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},constantAttendanceAllowance:{exceptional:{amount:0},intermediate:{amount:0},normal:{amount:0},partTime:{amount:0}},fullCostCapitalLimit:{nonResidential:0,shortStayResidential:0,longStayResidential:0},capitalTariff:{nonResidential:0,shortStayResidential:0,longStayResidential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},maxDREAllowance:0,washingExcessPremiumLevels:[0,0,0],additionalBeddingLevels:[0,0,0],carersMealAllowance:0,dreThresholds:{waterRates:Number.POSITIVE_INFINITY,fuel:Number.POSITIVE_INFINITY,transport:Number.POSITIVE_INFINITY,clothing:Number.POSITIVE_INFINITY},dreCaps:{gardening:0,domesticHelp:0,prescription:0,homeMaintenance:0,disabilityCard:0,blueBadge:0},configuration:{calculatorConfig:{weeksPerYear:365/7}}}},65620:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(39281),i=r(47541);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}}),n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-07",values:i.latest,label:"2024-2025"}];var o=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),o=(0,t.applyOptions)({constants:o,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return o}},47541:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,warWidowsPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},constantAttendanceAllowance:{exceptional:180.4,intermediate:135.3,normal:90.2,partTime:45.1},fullCostCapitalLimit:{nonResidential:23250,shortStayResidential:23250,longStayResidential:23250},capitalTariff:{nonResidential:250,shortStayResidential:250,longStayResidential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:186.4,dp:0,edp:0},over25:{base:186.4,dp:0,edp:0},pensionAge:{base:232.6,dp:0,edp:0}}},childPremium:102.95,carersPremium:53.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}},washingExcessPremiumLevels:[4.89,9.78,14.67],additionalBeddingLevels:[7.09,11.82,18.91],carersMealAllowance:12.5,dreCaps:{gardening:25.75,domesticHelp:25.75,prescription:2.2,homeMaintenance:6.93,disabilityCard:.19,blueBadge:.06},dreThresholds:{waterRates:9.11,fuel:24.46,transport:9.62,clothing:10.63},maxDREAllowance:20}},10589:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}}},3077:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getOwnershipStatus=n.getPartnerArrangement=void 0;var t=r(91569),a=r(48627),i=r(65620);n.getPartnerArrangement=function(e){e.hasPartner,e.partnerCohabits,e.livesWithOther;return"single"};n.getOwnershipStatus=function(e){var n;switch(e.propertyOwnership){case"ownedByYou":n="ownedByYou";break;case"ownedJointly":n="ownedJointly";break;case"jointTenant":n="jointTenant";break;default:n="tenant"}return n},n.getExpenses=function(e,r){var o=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,a.housingExpenses,{getOwnershipStatus:n.getOwnershipStatus,getPartnerArrangement:n.getPartnerArrangement})}},48627:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(10589);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]},tenant:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},jointTenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]}}},shortStayResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]},tenant:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},jointTenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]}}},longStayResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]},tenant:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},jointTenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]}}}}},10949:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(29870);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r).getAllowanceTypeProcessor,d=(0,a.getParameters)(e,l);return d=(0,i.runProcessors)(d,r,{getAllowanceTypeProcessor:c}),(0,t.sharedCalculator)(n,s,d,u)}},9950:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(96983),a=r(96983);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},73588:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(96983),a=r(96983);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},32093:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(96983),a=r(96983);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)}},12128:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(96983),a=r(74954),i=r(96983),o=r(96983);n.getDREs=function(e,n,r,s){var l=(0,o.getDREConfig)(r).dreLookup,u=(0,i.getIncomeFunctions)(r).upliftable;return(0,t.calculator)(e,n,r,l,s,{getRollup:function(e,t){var i=(0,a.getRollup)(e);if([r.careTypes.nonResidential].includes(n)){var o=u({amount:0,key:"attendanceAllowance",parameters:t}),s=u({amount:0,key:"pipDailyLiving",parameters:t});if(!(o+u({amount:0,key:"dlaCare",parameters:t})+s>0))return i.dreTotal=0,i;var l=i.dreTotal,c=void 0===l?0:l,d=i.approvedDRE,p=void 0===d?0:d,g=Math.max(c,r.maxDREAllowance||0);(p||0)>0&&(g=p+(r.maxDREAllowance||0)),i.dreTotal=g}return i}})}},94206:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getIncome=void 0;var t=r(96983),a=r(96983);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)}},55206:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(96983),a=r(96983);n.getAllowancesConfig=function(e){var n=(0,a.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,t.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},longStayResidential:{livingAllowanceTotal:{plaRate:[s],carerPremium:[c],childPremium:[c]},plaRate:[s],carerPremium:[c],childPremium:[c]}}}}},89424:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(96983);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},92805:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(96983),i=r(96983);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.full,o=n.joint,s=n.individual,l=n.wages,u=n.upliftable,c=n.cap,d=n.pensions,p=n.transferredPensionForPartner,g=(0,a.getDisregardsFunctions)(e),f=g.pscNonRes,m=g.pscLongStay,v=g.ifTransferPension,h={workingTaxCredit:[o],childTaxCredit:[o],childBenefit:[o],maintenance:[o],warSpecialPayment:[o],carersAllowance:[o],warPension:[s,c(e.warPensionDisregard)],warWidowsPension:[s,c(e.warWidowsPensionDisregard)],wages:[l],mobilityAllowance:[u],pensionSavingsCredit:[r,f]};return{incomeLookup:{default:{disregardsTotal:t({},h)},longStayResidential:{disregardsTotal:t(t({},h),{pensionSavingsCredit:[r,m],privatePensions:[d,p,v]})}}}}},89960:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(96983),a=r(96983);n.getDREConfig=function(e){var n=(0,a.getDREFunctions)(e),r=n.oneOffExpense,i=n.annualExpense,o=n.periodicExpense,s=n.limit,l=n.limitPerHour,u=n.threshold,c=n.afterMobility,d=n.share,p=n.additionalBeddingPerYear,g=n.washingPerWeek,f=n.windowCleanerLimit,m=n.mealsForCarers,v=n.approvedDres,h=(0,t.getIncomeFunctions)(e).zero;return{dreLookup:{default:{dreTotal:[h],approvedDRE:[h]},nonResidential:{approvedDRE:[v],dreTotal:{fuel:[o,u,d],waterRates:[o,u,d],gardening:[o,l(2),d],domesticHelp:[o,l(3),d],windowCleaner:[f,d],homeMaintenance:[o,s],washingPerWeek:[g],appointeeAndDeputyFees:[o],specialClothes:[o],clothing:[o,u],additionalBedding:[p],prescription:[o,s],dietary:[o],privateCare:[o],nonNHSHealthNeeds:[o],mobilityScooter:[r(5),s],manualWheelchairPurchase:[r(10),s],poweredWheelchairPurchase:[r(5),s],poweredBed:[r(5),s],replacementMattress:[i],insuranceOnSpecialistEquipment:[o],maintenanceOfSpecialistEquipment:[o],specialistEquipmentRental:[i],therapyAssistanceAnimals:[o],respiteAccommodation:[o],disabilityCard:[o,s],blueBadge:[o,s],communicationEquipment:[r(2),s],technologyEnabledCare:[o],transport:[o,c,u],mealsForCarers:[o,m]}}}}}},69294:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(96983);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.ratio,o=n.individual,s=n.joint,l=n.ucRollup,u=n.wages,c=n.pensions,d=n.otherBenefit,p=n.upliftable,g=n.additionalPropertyEquity,f=n.savings,m=n.shareHoldings,v=n.tariff,h=function(n){return v(e.capitalLimit,e.capitalTariff[n])},y=[f,[m,r(90)],g],P={retirementPension:[o],warPension:[o],warWidowsPension:[o],warSpecialPayment:[o],privatePensions:[c],capitalTariff:a(a([],y,!0),[h("nonResidential")],!1)},C={grossIncome:{retirementPension:[s],incomeSupportPayment:[s],incapacityBenefit:[s],employmentSupport:[s],jobSeekersAllowance:[s],universalCredit:[s],industrialInjuriesBenefit:[s],rentalIncome:[s],workingTaxCredit:[s],childTaxCredit:[s],maintenance:[s],warSpecialPayment:[s],childBenefit:[s],carersAllowance:[s],pensionGuaranteeCredit:[s],pensionSavingsCredit:[s],charitableIncome:[s],warPension:[s],warWidowsPension:[s],wages:[u],privatePensions:[c],otherBenefit:[d],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare","healthAllowance"])],constantAttendanceAllowance:[p],attendanceAllowance:[p],pipDailyLiving:[p],dlaCare:[p],mobilityAllowance:[p],capitalTariff:a(a([],y,!0),[h("nonResidential")],!1)}};return{incomeLookup:{default:{grossIncome:t({},C.grossIncome),additionalPropertyEquity:[g],totalCapital:a([],y,!0),capitalTariff:a(a([],y,!0),[h("nonResidential")],!1),qualifyingIncome:P},shortStayResidential:{grossIncome:t({},C.grossIncome)},longStayResidential:t(t({},C),{totalCapital:[a([],y,!0)],capitalTariff:[a([],y,!0),h("longStayResidential")]})}}}},86841:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance||(a.universalCreditBreakdown||{}).carer,s="yes"===i.carersAllowanceIsEntitled,l="yes"===i.receivesUCCarerElement,u="yes"===i.receivesCarersAllowanceForSomeoneElse;return r+(o||s||l||u?e.carersPremium:0)}})}},39691:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(65620),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},40928:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e);return t(t({},c),{pscNonRes:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.suDOB,s=i.qualifyingIncome||0,u=e.pensionSavingsCreditIncomeThreshold,c=u?u.singleApplicant:{};return l.getAgeLevel(o,e.levels).level!==e.levels.high||s<c.INCOME_LOW||s>=c.INCOME_LOW&&s<c.INCOME_HIGH||s>=c.INCOME_HIGH&&r>0?r:c.DISREGARD_MAX},pscLongStay:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.suDOB,s=i.qualifyingIncome||0,u=e.pensionSavingsCreditIncomeThreshold,c=u?u.singleApplicant:{};return l.getAgeLevel(o,e.levels).level!==e.levels.high||s<c.INCOME_LOW?0:s>=c.INCOME_LOW&&s<c.INCOME_HIGH?r>0?Math.min(r||0,c.DISREGARD_MAX):0:s>=c.INCOME_HIGH?r>0?Math.min(r||0,c.DISREGARD_MAX):c.DISREGARD_MAX:0}})}},69127:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(65620),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{share:function(e){var n=e.amount,r=e.parameters,t=r.partnerCohabits,a=r.peopleLivingWithYou;return n/((a.hasOtherPeople?(a.otherPeople||[]).length:0)+(t?2:1))},washingPerWeek:function(n){var r=n.parameters.dreExpensesFields.washingPerWeek,t=void 0===r?0:r,a=0;return t>4&&t<8?a=(e.washingExcessPremiumLevels||[])[0]:t>7&&t<15?a=(e.washingExcessPremiumLevels||[])[1]:t>14&&(a=(e.washingExcessPremiumLevels||[])[2]),a},windowCleanerLimit:function(n){var r=n.parameters.dreExpensesFields,t=r.windowCleaner,a=void 0===t?0:t,i=r.windowCleaningPerYear,o=void 0===i?0:i,s=(e.configuration.calculatorConfig||{}).weeksPerYear||52;return a*Math.min(o,12)/s},additionalBeddingPerYear:function(n){var r=n.parameters.dreExpensesFields.additionalBeddingPerYear,t=void 0===r?0:r,a=0;return t>0&&t<3?a=(e.additionalBeddingLevels||[])[0]:t>2&&t<5?a=(e.additionalBeddingLevels||[])[1]:t>4&&(a=(e.additionalBeddingLevels||[])[2]),a},mealsForCarers:function(n){var r=n.amount,t=n.parameters.dreExpensesFields.carersPerWeek,a=void 0===t?0:t;return Math.min(e.carersMealAllowance||0,r/a)*a},approvedDres:function(e){var n=e.parameters.dreExpensesFields;return n.hasApprovedDRE?c.getWeeklyAmount(n,"approvedDRE"):0}})}},2169:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){var r=n.value||0;return"joint"===n.ownership?r/=2:"other"===n.ownership&&(r=0),r+e}),0)}})}},96983:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.calculator=n.getCostOfCareFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getAllowances=n.getDREs=n.getDisregards=n.getIncome=void 0;var t=r(94206);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}});var a=r(32093);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(12128);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(9950);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(73588);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return s.getCostOfCare}});var l=r(69294);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return l.getIncomeConfig}});var u=r(92805);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return u.getDisregardsConfig}});var c=r(89960);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return c.getDREConfig}});var d=r(55206);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return d.getAllowancesConfig}});var p=r(89424);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return p.getCostOfCareConfig}});var g=r(2169);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return g.getIncomeFunctions}});var f=r(40928);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return f.getDisregardsFunctions}});var m=r(69127);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return m.getDREFunctions}});var v=r(86841);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return v.getAllowancesFunctions}});var h=r(39691);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return h.getCostOfCareFunctions}});var y=r(10949);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return y.calculator}});var P=r(29870);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return P.getProcessors}})},29870:function(e,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},r.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0,n.getProcessors=function(e){return{getAllowanceTypeProcessor:function(e){return r(r({},e),{allowanceType:"singleServiceUser"})}}}},60114:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.nottinghamshire=void 0;var t=r(1156),a=r(65620),i=r(15186);n.nottinghamshire={calculator:t.calculator,getConstants:a.getConstants,migrations:i.migrations}},12261:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;var t=r(56530),a=t.z.object({value:t.z.number().optional(),isJointlyOwned:t.z.boolean().optional()}),i=t.z.object({person:t.z.object({property:t.z.object({additionalProperties:t.z.array(a).optional()}).optional()}).optional()});n.m1=function(e){var n,r;void 0===e&&(e={}),e=null!=e?e:{};var t,a=JSON.parse(JSON.stringify(e));if(t=e,i.safeParse(t).success){var o=null===(r=null===(n=i.parse(e).person)||void 0===n?void 0:n.property)||void 0===r?void 0:r.additionalProperties;if(null==o?void 0:o.length){var s=o.reduce((function(e,n){var r={value:n.value,ownership:"sole"};return n.isJointlyOwned&&(r.ownership="joint"),e.push(r),e}),[]);(a.person.property||{}).additionalProperties=s}}return a}},15186:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.migrations=void 0;var t=r(12261);n.migrations={NO_FCA:{1:[t.m1]}}},28848:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(30920),i=r(36339),o=r(52417),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l);c=Object.assign(c,d);var p=l.fullCostCapitalLimit[r];if((d.totalCapital||0)>=p){var g=(l.maxContribution||{})[r];return{contributions:s.isNumeric(g)?{maxContribution:g}:{},workings:c}}var f=(0,i.getPartnerIncome)(e,r,l),m=Object.assign({},f),v=m.appropriateAmount,h=m.qualifyingIncome;c.partnerQualifyingIncome=h,c.partnerAppropriateAmount=v;var y=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,y);var P=(0,o.getExpenses)(e,r);c=Object.assign(c,P);var C=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,C);var w=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,w);var I=(0,i.getPartnerTransfer)(e,r,l,c);c=Object.assign(c,I)}else u=Object.assign(u,{fullCost:!0});for(var O in c)if(Object.prototype.hasOwnProperty.call(c,O)){var b=c[O]||0;c[O]=s.roundNearest(b)}return(0,i.getCostOfCare)(e,r,l,c,u)}},38341:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",respite:"respite",shortStay:"shortStay",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},warWidowsPensionDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},constantAttendanceAllowance:{exceptional:{amount:0},intermediate:{amount:0},normal:{amount:0},partTime:{amount:0}},fullCostCapitalLimit:{nonResidential:0,respite:0,shortStay:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,respite:0,shortStay:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},configuration:{calculatorConfig:{weeksPerYear:52}},disabilityBasedDREAllowance:{high:0,medium:0,low:0},pensionGuaranteeCreditEntitlements:{base:{single:0,couple:0},sdp:0,carer:0},partnerCapitalLimit:0,partnerCapitalTariff:0,jointCapitalLimit:0,jointCapitalTariff:0}},30920:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(38341),i=r(46905);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(63135);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},46905:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,respite:23250,shortStay:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,shortStay:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:91.2,dp:54,edp:26.5},over25:{base:115.1,dp:54,edp:26.5},pensionAge:{base:283.9,dp:0,edp:0}},coupleServiceUser:{under25:{base:90.5,dp:38.5,edp:18.9},over25:{base:90.5,dp:38.5,edp:18.9},pensionAge:{base:216.7,dp:0,edp:0}},localCoupleServiceUser:{under25:{base:180.9,dp:77,edp:38.5},over25:{base:180.9,dp:77,edp:38.5},pensionAge:{base:433.3,dp:0,edp:0}}},sdpPremium:24.8,carersPremium:58,childPremium:105.8,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:7.05}},disabilityBasedDREAllowance:{high:58.67,medium:22.17,low:8.76},pensionGuaranteeCreditEntitlements:{base:{single:227.1,couple:0},sdp:82.9,carer:53.25},partnerCapitalLimit:1e4,partnerCapitalTariff:500,jointCapitalLimit:28500,jointCapitalTariff:250}},63135:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,respite:23250,shortStay:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,shortStay:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:91.2,dp:54,edp:26.5},over25:{base:115.1,dp:54,edp:26.5},pensionAge:{base:283.9,dp:0,edp:0}},coupleServiceUser:{under25:{base:90.5,dp:38.5,edp:18.9},over25:{base:90.5,dp:38.5,edp:18.9},pensionAge:{base:216.7,dp:0,edp:0}},localCoupleServiceUser:{under25:{base:180.9,dp:77,edp:37.8},over25:{base:180.9,dp:77,edp:37.8},pensionAge:{base:433.3,dp:0,edp:0}}},sdpPremium:24.8,carersPremium:58,childPremium:105.8,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,DISREGARD_MAX:10.6}},disabilityBasedDREAllowance:{high:58.67,medium:22.17,low:8.76},pensionGuaranteeCreditEntitlements:{base:{single:227.1,couple:0},sdp:82.9,carer:53.25},partnerCapitalLimit:1e4,partnerCapitalTariff:500,jointCapitalLimit:28500,jointCapitalTariff:250}},43905:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}}},52417:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerExpenses=n.getExpenses=void 0;var t=r(91569),a=r(59191),i=r(30920);n.getExpenses=function(e,n){var r=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(r,e,n,a.housingExpenses)},n.getPartnerExpenses=function(e,n){var r=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(r,e,n,a.partnerHousingExpenses)}},59191:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerHousingExpenses=n.housingExpenses=void 0;var t=r(43905);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedByPartner:{serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]}}},respite:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedByPartner:{serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full]}}},shortStay:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedByPartner:{serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedByPartner:{serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedByPartner:{serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],personalAlarm:[t.full],waterRates:[t.full]}}},week1Residential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],homeInsurance:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]}},cohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],homeInsurance:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],homeInsurance:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],homeInsurance:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]}}}},n.housingExpenses.week5Residential=n.housingExpenses.week1Residential,n.housingExpenses.week13Residential=n.housingExpenses.week1Residential,n.partnerHousingExpenses={nonResidential:{cohabitingPartner:{ownedByYou:{serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],personalAlarm:[(0,t.ratio)(50)]}}}},n.partnerHousingExpenses.respite=n.partnerHousingExpenses.nonResidential,n.partnerHousingExpenses.shortStay={},n.partnerHousingExpenses.week1Residential={},n.partnerHousingExpenses.week5Residential={},n.partnerHousingExpenses.week13Residential={}},26537:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(71074);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getDisabilityLevelProcessor,p=c.getAllowanceTypeProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getAllowanceTypeProcessor:p,getDisabilityLevelProcessor:d}),(0,t.sharedCalculator)(n,s,g,u)},n.partnerCalculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getPartnerAllowanceTypeProcessor,p=c.getPartnerAgeLevelProcessor,g=c.getPartnerDisabilityLevelProcessor,f=(0,a.getPartnerParameters)(e,l);return f=(0,i.runProcessors)(f,r,{getDisabilityLevelProcessor:g,getAllowanceTypeProcessor:d,getAgeLevelProcessor:p}),(0,t.sharedCalculator)(n,s,f,u)}},85442:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerAllowances=n.getAllowances=void 0;var t=r(36339),a=r(36339);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).partnerLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},76976:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var a=r(36339),i=r(36339);n.getCostOfCare=function(e,n,r,o,s){var l,u=(0,i.getCostOfCareConfig)(r,s).costOfCareLookup,c=(0,a.calculator)(e,n,r,u,o),d=o.grossIncome,p=void 0===d?0:d,g=o.partnerGrossIncome,f=void 0===g?0:g,m=o.disregardsTotal,v=void 0===m?0:m,h=o.partnerDisregardsTotal,y=void 0===h?0:h,P=o.expensesTotal,C=void 0===P?0:P,w=o.partnerExpensesTotal,I=void 0===w?0:w,O=o.partnerLivingAllowanceTotal,b=void 0===O?0:O,A=o.partnerSdpPremium,T=void 0===A?0:A,R=o.partnerPlaRate,_=void 0===R?0:R,E=o.capitalTariff,D=void 0===E?0:E,L=o.partnerCapitalTariff,S=void 0===L?0:L,N=o.jointCapitalTariff,k=void 0===N?0:N,j=c.maxContribution||0,M=Math.max(0,p-D),x=Math.max(0,f-S),F=t(t({},o),{grossIncome:M+x+k,capitalTariff:k,disregardsTotal:v+y,expensesTotal:C+I,livingAllowanceTotal:b,sdpPremium:T,plaRate:_}),H=(0,a.calculator)(e,n,r,u,F),B=Number.POSITIVE_INFINITY,W=null===(l=e.person.intro)||void 0===l?void 0:l.hasPartner,Y=e.partner||{},G=!0===(W?Y.details:{}).sameAddress,U=Y.intro||{},V=!0===U.discloseFinances,Z=U.alreadyReceivingCare,J=[r.careTypes.nonResidential,r.careTypes.respite].includes(n);if(G&&V&&J){if(Z){var q=(H.maxContribution||0)/2;H.maxContribution=q}B=H.maxContribution||0}return B<=j||Z?Object.assign({contributions:H,workings:F},s):Object.assign({contributions:c,workings:o},s)}},74161:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(36339),a=r(36339);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).disregardsLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).partnerDisregardsLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},89500:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(36339),a=r(36339);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},78242:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getIncome=void 0;var t=r(36339),a=r(36339);n.getIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},83640:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var t=r(36339),a=r(78242),i=r(74161),o=r(85442),s=r(36339),l=r(52417);n.getPartnerTransfer=function(e,n,r,u){var c={},d=(0,a.getPartnerIncome)(e,n,r),p=d.grossIncome,g=d.totalCapital,f=d.capitalTariff,m=d.qualifyingIncome;c=Object.assign(c,d);var v=(0,i.getPartnerDisregards)(e,n,r,d),h=v.disregardsTotal;c=Object.assign(c,v);var y=(0,l.getPartnerExpenses)(e,n);c=Object.assign(c,y),(u=Object.assign(u,{partnerGrossIncome:p,partnerTotalCapital:g,partnerCapitalTariff:f,partnerDisregardsTotal:h,partnerQualifyingIncome:m})).partnerExpensesTotal=c.expensesTotal;var P=(0,o.getPartnerAllowances)(e,n,r,c),C=P.livingAllowanceTotal,w=P.sdpPremium,I=P.plaRate;c=Object.assign(c,P),u=Object.assign(u,{partnerPlaRate:I,partnerLivingAllowanceTotal:C,partnerSdpPremium:w});var O=(0,s.getPartnerTransferConfig)(r).lookup;return(0,t.calculator)(e,n,r,O,u)}},1834:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(36339),a=r(36339);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=n.sdp,d=n.partnerSdp,p=n.shareWithPartner,g=(0,a.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[g],carerPremium:[g],sdpPremium:[g]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u,p],carerPremium:[l,p],sdpPremium:[c]},plaRate:[r,i,o],childPremium:[u,p],carerPremium:[l,p],sdpPremium:[c]},respite:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u,p],carerPremium:[l,p],sdpPremium:[c]},plaRate:[r,i,o],childPremium:[u,p],carerPremium:[l,p],sdpPremium:[c]}},partnerLookup:{default:{livingAllowanceTotal:{plaRate:[s],carerPremium:[g],childPremium:[g]},plaRate:[s],childPremium:[g],carerPremium:[g]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l],sdpPremium:[d]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l],sdpPremium:[d]},respite:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l],sdpPremium:[d]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l],sdpPremium:[d]}}}}},38172:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(36339);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}},jointCostOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},77609:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(36339),i=r(36339);n.getDisregardsConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.joint,o=n.cap,s=n.full,l=n.wages,u=n.upliftable,c=n.zero,d=n.pensions,p=n.transferredPensionForPartner,g=n.ucRollup,f=(0,i.getDisregardsFunctions)(e),m=f.psc,v={wages:[l],privatePensions:[d,p,f.ifTransferPension],workingTaxCredit:[r],childTaxCredit:[r],childBenefit:[r],charitableIncome:[r],warPension:[r],warWidowsPension:[s,o(e.warWidowsPensionDisregard)],universalCreditBreakdown:[g(["children","disabledChild","housingElement","childcare"])],attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u],mobilityAllowance:[u],pensionSavingsCredit:[r,m]};return{disregardsLookup:{default:{disregardsTotal:t({},v)},nonResidential:{disregardsTotal:t(t({},v),{privatePensions:[c],attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c],pensionSavingsCredit:[r]})},respite:{disregardsTotal:t(t({},v),{privatePensions:[c],attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c],pensionSavingsCredit:[r]})},week1Residential:{disregardsTotal:t(t({},v),{attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c]})},week5Residential:{disregardsTotal:t({},v)},week13Residential:{disregardsTotal:t({},v)}},partnerDisregardsLookup:{default:{disregardsTotal:{wages:[l],childTaxCredit:[r],childBenefit:[r],warPension:[r],warWidowsPension:[s,o(e.warWidowsPensionDisregard)],attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u],mobilityAllowance:[u],pensionSavingsCredit:[r]}}}}}},73268:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(36339),a=r(36339);n.getDREConfig=function(e){var n=(0,a.getIncomeFunctions)(e).zero,r=(0,t.getDREFunctions)(e).dre;return{dreLookup:{default:{dreTotal:[n]},nonResidential:{dreTotal:[r]},respite:{dreTotal:[r]}}}}},5778:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(36339);n.getIncomeConfig=function(e){var n,r=(0,i.getIncomeFunctions)(e),o=r.zero,s=r.ratio,l=r.joint,u=r.individual,c=r.full,d=r.tariff,p=r.wages,g=r.pensions,f=r.ucRollup,m=r.otherBenefit,v=r.upliftable,h=r.savings,y=r.partnerSavings,P=r.shareHoldings,C=r.partnerShareHoldings,w=r.additionalPropertyEquity,I=r.primaryPropertyEquity,O=r.ifNoProtectedCohabitants,b=r.partnerAdditionalPropertyEquity,A=r.appropriateAmount,T=[w,h,[P,s(90)],(n="nonResidential",d(e.capitalLimit,e.capitalTariff[n]))],R=[b,h,[P,s(90)],d(e.partnerCapitalLimit||0,e.partnerCapitalTariff||0)],_=[w,h,[P,s(90)],b,y,[C,s(90)],d(e.jointCapitalLimit||0,e.jointCapitalTariff||0)],E=[f(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"])],D={retirementPension:[l],incomeSupportPayment:[l],incapacityBenefit:[l],employmentSupport:[l],jobSeekersAllowance:[l],industrialInjuriesBenefit:[l],rentalIncome:[l],workingTaxCredit:[l],maintenance:[l],privatePensions:[g],wages:[p],universalCreditBreakdown:E,capitalTariff:[T]},L={retirementPension:[u],rentalIncome:[u],warPension:[u],warWidowsPension:[u],industrialInjuriesBenefit:[u],maintenance:[u],privatePensions:[g],wages:[p],capitalTariff:R},S={grossIncome:{retirementPension:[l],incomeSupportPayment:[l],incapacityBenefit:[l],employmentSupport:[l],jobSeekersAllowance:[l],industrialInjuriesBenefit:[l],rentalIncome:[l],workingTaxCredit:[l],childTaxCredit:[l],maintenance:[l],warPension:[l],warWidowsPension:[l],childBenefit:[l],carersAllowance:[l],charitableIncome:[l],pensionGuaranteeCredit:[l],pensionSavingsCredit:[l],wages:[p],privatePensions:[g],otherBenefit:[m],universalCreditBreakdown:E,attendanceAllowance:[v],pipDailyLiving:[v],dlaCare:[v],mobilityAllowance:[v],privatePension:[c],capitalTariff:T}},N=[w,h,[P,s(90)]];return{incomeLookup:{default:{grossIncome:t({},S.grossIncome),additionalPropertyEquity:[w],totalCapital:N,capitalTariff:T,jointCapitalTariff:_,universalCreditBreakdown:E,qualifyingIncome:D},shortStay:{grossIncome:t({},S.grossIncome),totalCapital:[w,h,[P,s(90)]]},week1Residential:{grossIncome:t({},S.grossIncome),totalCapital:[w,h,[P,s(90)]]},week5Residential:{grossIncome:t({},S.grossIncome),totalCapital:[w,h,[P,s(90)]]},week13Residential:{grossIncome:t({},S.grossIncome),totalCapital:[[I,s(90),O],w,h,[P,s(90)]],capitalTariff:a([[I,s(90),O]],T,!0),universalCreditBreakdown:[o],qualifyingIncome:D}},partnerIncomeLookup:{default:{grossIncome:t(t({},S.grossIncome),{capitalTariff:R}),additionalPropertyEquity:[w],totalCapital:[h,[P,s(90)],b],capitalTariff:R,qualifyingIncome:L,appropriateAmount:[A]},shortStay:{grossIncome:t(t({},S.grossIncome),{capitalTariff:R}),additionalPropertyEquity:[w],totalCapital:[h,[P,s(90)],b],capitalTariff:R,qualifyingIncome:L},week1Residential:{grossIncome:t(t({},S.grossIncome),{capitalTariff:R}),additionalPropertyEquity:[w],totalCapital:[h,[P,s(90)],b],capitalTariff:R,qualifyingIncome:L},week5Residential:{grossIncome:t(t({},S.grossIncome),{capitalTariff:R}),additionalPropertyEquity:[w],totalCapital:[h,[P,s(90)],b],capitalTariff:R,qualifyingIncome:L},week13Residential:{grossIncome:t(t({},S.grossIncome),{capitalTariff:R}),additionalPropertyEquity:[w],totalCapital:[h,[P,s(90)],b],capitalTariff:R,qualifyingIncome:L}}}}},65156:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(36339),a=r(36339);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e),r=n.jointIncome,i=n.partnerNetIncome,o=(0,a.getIncomeFunctions)(e).zero;return{lookup:{default:{partnerTransfer:[o],jointIncome:[r],partnerNetIncome:[i]},nonResidential:{partnerTransfer:[o],jointIncome:[r],partnerNetIncome:[i]}}}}},43333:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e),d=function(n){var r=n.introFields,t=n.incomeFields,a=n.partnerCohabits,i=n.partnerIntroFields,o=n.partnerIncomeFields,s=0,l="yes"===r.receivesSDP,u=(t.universalCreditBreakdown||{}).healthAllowance||0,c=l||u>0,d=t.attendanceAllowance,p=t.dlaCare,g=t.pipDailyLiving,f=[d,p,g].some((function(e){return["medium","high"].includes(e)}))||[d,g].some((function(e){return["low","high"].includes(e)}));if(c&&f&&(s+=e.sdpPremium||0),a){var m="yes"===i.receivesSDP,v=(o.universalCreditBreakdown||{}).healthAllowance||0,h=m||v>0,y=o.attendanceAllowance,P=o.dlaCare,C=o.pipDailyLiving,w=[y,P,C].some((function(e){return["medium","high"].includes(e)}))||[y,C].some((function(e){return["low","high"].includes(e)}));c&&f&&h&&w&&(s+=e.sdpPremium||0)}return s};return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=0,i=t.incomeFields,o=t.introFields,s=t.partnerCohabits,l=t.partnerIncomeFields,u=t.partnerIntroFields,c=i.carersAllowance,d=(i.universalCreditBreakdown||{}).carer,p="yes"===o.carersAllowanceIsEntitled;if(a=c||d||p?e.carersPremium:0,s){var g=l.carersAllowance,f=(l.universalCreditBreakdown||{}).carer,m="yes"===u.carersAllowanceIsEntitled;a+=g||f||m?e.carersPremium:0}return r+a},sdp:function(e){var n=e.amount,r=e.parameters,t=r.introFields,a=r.incomeFields,i=r.partnerCohabits,o=r.partnerIntroFields,s=r.partnerIncomeFields,l=d({introFields:t,incomeFields:a,partnerCohabits:i,partnerIntroFields:o,partnerIncomeFields:s});return n+(l=i?l/2:l)},partnerSdp:function(e){var n=e.amount,r=e.parameters,t=r.introFields,a=r.incomeFields,i=r.partnerCohabits,o=r.partnerIntroFields,s=r.partnerIncomeFields;return n+d({introFields:o,incomeFields:s,partnerCohabits:i,partnerIntroFields:t,partnerIncomeFields:a})},child:function(n){var r=n.amount,t=n.parameters.dependentChildrenCount;return r+(Math.min(2,t)||0)*e.childPremium},shareWithPartner:function(e){var n=e.amount;return e.parameters.partnerCohabits?n/2:n}})}},82655:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(30920),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},34988:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(5416),i=r(24609),o=r(32954),s=r(56822),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,u=new s.CareAssessmentService(r,n),c=new i.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e);return t(t({},d),{psc:function(n){var r=n.amount,t=n.parameters,i=t.workings,o=void 0===i?{}:i,s=t.suDOB,l=r>0,u=o.qualifyingIncome||0,c=e.pensionSavingsCreditIncomeThreshold,d=c?c.singleApplicant:{},p=a("05/04/1953","DD/MM/YYYY"),g=a(s,"DD/MM/YYYY");return p.diff(g,"days")<=0?0:u<d.INCOME_LOW?l?Math.min(r||0,d.DISREGARD_MAX):0:u>=d.INCOME_LOW&&l?Math.min(r||0,d.DISREGARD_MAX):d.DISREGARD_MAX},ifTransferPension:function(e){var n=e.amount,r=e.parameters,t=r.workings,a=void 0===t?{}:t,i=r.partnerCohabits,o=r.partnerDisclosesFinances;if(i&&o){var s=a.partnerAppropriateAmount,l=void 0===s?0:s,u=a.partnerQualifyingIncome;if(l-(void 0===u?0:u)<n)return n}return 0}})}},891:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(30920),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{dre:function(n){var r,t=n.amount,a=n.parameters.incomeFields,i=a.attendanceAllowance||"none",o=a.dlaCare||"none",s=a.pipDailyLiving||"none",l="none";return[o].includes(e.levels.low)&&(l="low"),[i,s].includes(e.levels.low)&&(l="medium"),[i,o,s].includes(e.levels.medium)&&(l="medium"),[i,o,s].includes(e.levels.high)&&(l="high"),t+("none"===l?0:(null!==(r=e.disabilityBasedDREAllowance)&&void 0!==r?r:{})[l]||0)}})}},72357:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{savings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.capitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount)}),0),t+=(r.thirdPartyCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount)}),0),n+(t+=(r.jointCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount/2)}),0))},partnerSavings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.partnerCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount)}),0),n+(t+=(r.jointCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount/2)}),0))},primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.propertyFields.ownership;return n+(t+="ownedByYou"===i?a:"ownedJointly"===i?a/2:0)},appropriateAmount:function(n){var r=n.amount,t=n.parameters,a=t.partnerDisclosesFinances,i=t.dob,o=t.incomeFields,s=t.partnerIncomeFields,u=t.introFields,c=t.disabilityLevel;if(!a)return 0;if(l.getAgeLevel(i,e.levels).level!==e.levels.high)return 0;var d=(o.pensionGuaranteeCredit||0)>0,p=!0===s.pensionGuaranteeCreditIsJoint&&(s.pensionGuaranteeCredit||0)>0;if(!d&&!p)return 0;var g=e.pensionGuaranteeCreditEntitlements||{},f=g.base,m=g.sdp,v=g.carer;r+=f.single,"edp"===c&&(r+=m);var h=(o.carersAllowance||0)>0,y="yes"===u.carersAllowanceIsEntitled;return(h||y)&&(r+=v),r}})}},24671:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{jointIncome:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.grossIncome,s=void 0===o?0:o,l=i.partnerGrossIncome;return n+s+(void 0===l?0:l)},partnerNetIncome:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.partnerGrossIncome,s=void 0===o?0:o,l=i.partnerDisregardsTotal;return s-(void 0===l?0:l)},partnerTransfer:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.partnerLivingAllowanceTotal,s=void 0===o?0:o,l=i.partnerGrossIncome,u=void 0===l?0:l,c=i.partnerDisregardsTotal;return n+(s-(u-(void 0===c?0:c)))}})}},36339:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getPartnerAllowances=n.getAllowances=n.getDREs=n.getPartnerDisregards=n.getDisregards=n.getPartnerIncome=n.getIncome=void 0;var t=r(78242);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}});var a=r(74161);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(89500);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(85442);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}}),Object.defineProperty(n,"getPartnerAllowances",{enumerable:!0,get:function(){return o.getPartnerAllowances}});var s=r(83640);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(76976);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(5778);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(77609);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(73268);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(1834);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(65156);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(38172);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(72357);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(34988);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(891);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(43333);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(24671);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(82655);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(26537);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(71074);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},71074:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e),r=n.getIncomeBasedDisabilityLevel,i=n.getAgeLevel,o=n.getAgeLevelKey,s=function(e){var n=r(e),t=e.employmentSupport,a=e.employmentSupportGroup,i=e.universalCreditBreakdown||{},o=i.healthAllowance||0,s=i.limitedWorkAndRelatedCapability||0;return"base"===n&&o>0&&(n="dp"),(t&&"Support"===a||s>0)&&(n="edp"),n};return t(t({},(0,a.getDefaultProcessors)(e)),{getDisabilityLevelProcessor:function(e){var n=e.incomeFields,r=s(n);return t(t({},e),{disabilityLevel:r})},getAllowanceTypeProcessor:function(e){var n=e.hasPartner?"coupleServiceUser":"singleServiceUser";return t(t({},e),{allowanceType:n})},getPartnerDisabilityLevelProcessor:function(e){var n=e.incomeFields,r=e.partnerIncomeFields,a="base",i=[s(n),s(r)];return i.includes("edp")?a="edp":i.includes("dp")&&(a="dp"),t(t({},e),{disabilityLevel:a})},getPartnerAgeLevelProcessor:function(n){var r=n.suDOB,a=n.partnerDOB,s=n.partnerDisclosesFinances,l=n.partnerCohabits,u=function(n,r){var t=e.levels.low,a=[n,r];return a.includes(e.levels.high)?t=e.levels.high:a.includes(e.levels.medium)&&(t=e.levels.medium),t}(i(r),s&&l&&""!==a?i(a):e.levels.low),c=o(u);return t(t({},n),{ageLevel:c})},getPartnerAllowanceTypeProcessor:function(e){return t(t({},e),{allowanceType:"localCoupleServiceUser"})}})}},34566:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.plymouth=void 0;var t=r(28848),a=r(30920);n.plymouth={calculator:t.calculator,getConstants:a.getConstants}},732:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(52892),i=r(25887),o=r(64861),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0},d=(e.person.intro||{}).provideFinancialDetails;if("agree"===d||"savingsDropped"===d){var p=(0,i.getIncome)(e,r,l);c=Object.assign(c,p);var g=l.fullCostCapitalLimit[r];if((p.totalCapital||0)>=g){var f=(l.maxContribution||{})[r];return{contributions:s.isNumeric(f)?{maxContribution:f}:{},workings:c}}var m=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,m);var v=(0,o.getExpenses)(e,r);c=Object.assign(c,v);var h=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,h);var y=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,y);var P=(0,i.getPartnerTransfer)(e,r,l,c);c=Object.assign(c,P)}else u=Object.assign(u,{fullCost:!0});for(var C in c)if(Object.prototype.hasOwnProperty.call(c,C)){var w=c[C]||0;c[C]=s.roundNearest(w)}return(0,i.getCostOfCare)(e,r,l,c,u)}},48537:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={cappedRespiteRates:{low:0,medium:0,high:0},careTypes:{nonResidential:"nonResidential",respite:"respite",permWeek1Residential:"permWeek1Residential",permWeek5Residential:"permWeek5Residential",permWeek13Residential:"permWeek13Residential"},warWidowsPensionDisregard:0,rentalIncomeDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,respite:0,permWeek1Residential:0,permWeek5Residential:0,permWeek13Residential:0},capitalTariff:{nonResidential:0,respite:0,permWeek1Residential:0,permWeek5Residential:0,permWeek13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},overridePensionAge:60,configuration:{calculatorConfig:{weeksPerYear:52}},heatingCosts:{applicant:{flat:0,terraced:0,semiDetached:0,detached:0},eachExtraPerson:{flat:0,terraced:0,semiDetached:0,detached:0}},dreRates:{bedTurning:0,poweredBed:0,stairLift:0,hoistPurchase:0,poweredWheelchairPurchase:0,manualWheelchairPurchase:0,poweredRecliningChair:0},washingExcessPremium:0,personalLivingAllowance:{residentialRate:0}}},52892:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(48537),i=r(38989);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(2923);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},38989:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={cappedRespiteRates:{low:85.45,medium:104.6,high:196.45},warWidowsPensionDisregard:10,rentalIncomeDisregard:20,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23251,respite:23251,permWeek1Residential:23251,permWeek5Residential:23251,permWeek13Residential:23251},capitalTariff:{nonResidential:250,respite:250,permWeek1Residential:250,permWeek5Residential:250,permWeek13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:163.05,dp:0,edp:0},over25:{base:186.4,dp:0,edp:0},pensionAge:{base:232.6,dp:0,edp:0}},loneParentUser:{under25:{base:186.4,dp:0,edp:0},over25:{base:186.4,dp:0,edp:0},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:141.2,dp:0,edp:0},over25:{base:141.2,dp:0,edp:0},pensionAge:{base:177.55,dp:0,edp:0}},partnerNonResidential:{under25:{base:57.41,dp:18.32,edp:30.52},over25:{base:72.47,dp:18.32,edp:30.52},pensionAge:{base:173.3,dp:82.9,edp:0}},partnerNonResidentialWithESA:{under25:{base:71.13,dp:98.02,edp:0},over25:{base:71.13,dp:98.02,edp:0},pensionAge:{base:173.3,dp:82.9,edp:0}}},carerPremiumRatesMap:{partnerNonResidential:{under25:{base:23.27,dp:23.27,edp:23.27},over25:{base:23.27,dp:23.27,edp:23.27},pensionAge:{base:46.4,dp:46.4,edp:46.4}},partnerNonResidentialWithESA:{under25:{base:46.4,dp:46.4,edp:46.4},over25:{base:46.4,dp:45.92,edp:46.4},pensionAge:{base:46.4,dp:46.4,edp:46.4}}},carersPremium:53.25,childPremium:102.95,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}},heatingCosts:{applicant:{flat:37.98,terraced:37.98,semiDetached:40.34,detached:49.08},eachExtraPerson:{flat:12.13,terraced:12.13,semiDetached:12.92,detached:15.62}},dreRates:{bedTurning:9.86,poweredBed:5.63,stairLift:7.96,hoistPurchase:3.91,poweredWheelchairPurchase:12.38,manualWheelchairPurchase:5.1,poweredRecliningChair:4.47},washingExcessPremium:4.89}},2923:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={cappedRespiteRates:{low:84.05,medium:102.85,high:188},warWidowsPensionDisregard:10,rentalIncomeDisregard:20,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23251,respite:23251,permWeek1Residential:23251,permWeek5Residential:23251,permWeek13Residential:23251},capitalTariff:{nonResidential:250,respite:250,permWeek1Residential:250,permWeek5Residential:250,permWeek13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:160.3,dp:0,edp:0},over25:{base:183.25,dp:0,edp:0},pensionAge:{base:228.7,dp:0,edp:0}},loneParentUser:{under25:{base:183.25,dp:0,edp:0},over25:{base:183.25,dp:0,edp:0},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:138.8,dp:0,edp:0},over25:{base:138.8,dp:0,edp:0},pensionAge:{base:174.6,dp:0,edp:0}},partnerNonResidential:{under25:{base:56.45,dp:18.01,edp:30.01},over25:{base:66.79,dp:18.01,edp:30.01},pensionAge:{base:166.48,dp:81.5,edp:0}},partnerNonResidentialWithESA:{under25:{base:71.13,dp:96.38,edp:0},over25:{base:71.13,dp:96.38,edp:0},pensionAge:{base:166.48,dp:81.5,edp:0}}},carerPremiumRatesMap:{partnerNonResidential:{under25:{base:22.88,dp:22.88,edp:22.88},over25:{base:22.88,dp:22.88,edp:22.88},pensionAge:{base:45.6,dp:45.6,edp:45.6}},partnerNonResidentialWithESA:{under25:{base:45.6,dp:45.6,edp:45.6},over25:{base:45.6,dp:45.6,edp:45.6},pensionAge:{base:45.6,dp:45.6,edp:45.6}}},carersPremium:52.35,childPremium:101.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95}},heatingCosts:{applicant:{flat:40.84,terraced:40.84,semiDetached:43.38,detached:52.78},eachExtraPerson:{flat:13.04,terraced:13.04,semiDetached:13.89,detached:69.57-52.78}},dreRates:{bedTurning:9.55,poweredBed:5.46,stairLift:7.71,hoistPurchase:3.79,poweredWheelchairPurchase:12,manualWheelchairPurchase:4.94,poweredRecliningChair:4.33},washingExcessPremium:4.74}},76005:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.shareByContract=n.share=n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},n.share=function(e){var n=e.amount,r=e.numberOfOtherPeople,t=void 0===r?0:r,a=n*(t>0?100/(t+1):100)/100;return Math.max(0,a)},n.shareByContract=function(e){var n=e.amount,r=e.numberOfPeopleOnTheContract,t=void 0===r?1:r,a=n*(t>1?100/t:100)/100;return Math.max(0,a)}},64861:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=void 0;var t=r(91569),a=r(45803),i=r(52892);n.getExpenses=function(e,n){var r=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(r,e,n,a.housingExpenses)}},45803:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(76005);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[t.full],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByPartner:{},tenant:{rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full]},ownedByOther:{}},cohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[(0,t.ratio)(50)],serviceCharge:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByPartner:{councilTax:[(0,t.ratio)(50)]},tenant:{rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByOther:{}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[t.full],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full]},tenant:{rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full]},ownedByOther:{}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share],councilTax:[t.share],serviceCharge:[t.share],groundRent:[t.share]},ownedByPartner:{},tenant:{rent:[t.full],rentLessHousing:[t.full],councilTax:[t.share],serviceCharge:[t.shareByContract],groundRent:[t.shareByContract]},ownedByOther:{}}},permWeek5Residential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]}},cohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]}}},permWeek13Residential:{single:{ownedByYou:{},ownedJointly:{}},cohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]}}}},n.housingExpenses.respite=n.housingExpenses.nonResidential},15885:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(41174);n.calculator=function(e,n,r,o,s,l){var u=(0,a.getParameters)(e,s);return u=(0,i.runProcessors)(u,r),(0,t.sharedCalculator)(n,o,u,l)},n.partnerCalculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getPartnerAllowanceTypeProcessor,p=c.getCarerPremiumRateLookupProcessor,g=c.getPartnerDisabilityLevelProcessor,f=(0,a.getPartnerParameters)(e,l);return f=(0,i.runProcessors)(f,r,{getDisabilityLevelProcessor:g,getAllowanceTypeProcessor:d,additionalProcessors:[p]}),(0,t.sharedCalculator)(n,s,f,u)}},79958:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerAllowances=n.getAllowances=void 0;var t=r(25887),a=r(25887);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).partnerLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},61516:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(25887),a=r(25887);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},92037:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(25887),a=r(25887);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i,o){var s=(0,a.getDisregardsConfig)(r).partnerLookup;return o=o||s,(0,t.partnerCalculator)(e,n,r,o,i)}},86312:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(25887),a=r(25887);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},41526:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getIncome=void 0;var t=r(25887),a=r(25887);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)};n.getPartnerIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,t.partnerCalculator)(e,n,r,i)}},54668:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var a=r(25887),i=r(41526),o=r(92037),s=r(79958),l=r(25887);n.getPartnerTransfer=function(e,n,r,u){var c={},d=(0,i.getPartnerIncome)(e,n,r),p=d.grossIncome,g=d.totalCapital,f=d.capitalTariff;c=Object.assign(c,d),u=Object.assign(u,{partnerGrossIncome:p,partnerTotalCapital:g,partnerCapitalTariff:f});var m=(0,o.getPartnerDisregards)(e,n,r,d),v=m.disregardsTotal;c=Object.assign(c,m),u=Object.assign(u,{partnerDisregardsTotal:v});var h=(0,s.getPartnerAllowances)(e,n,r,c),y=h.livingAllowanceTotal;c=Object.assign(c,h),u=Object.assign(u,{partnerLivingAllowanceTotal:y});var P=(0,l.getPartnerTransferConfig)(r).lookup,C=(0,a.calculator)(e,n,r,P,u);return t(t({},u),C)}},45662:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(25887),a=r(25887);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=n.partnerCarerPremium,d=(0,a.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[d],carerPremium:[d]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}},partnerLookup:{default:{livingAllowanceTotal:{plaRate:[d],carerPremium:[d],childPremium:[d]},plaRate:[s],childPremium:[d],carerPremium:[d]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],carerPremium:[c],childPremium:[d]},plaRate:[r,i,o],childPremium:[d],carerPremium:[c]}}}}},53192:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(25887);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round,s=r.ageBasedCap;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]},respite:{maxContribution:[a,i(n),s,o]},permWeek1Residential:{maxContribution:[a,i(n),s,o]}}}}},32781:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(25887),i=r(25887);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.ratio,o=n.cap,s=n.full,l=n.individual,u=n.joint,c=n.wages,d=n.upliftable,p=n.zero,g=n.ucRollup,f=n.pensions,m=n.transferredPensionForPartner,v=(0,a.getDisregardsFunctions)(e),h=v.aaNonRes,y=v.dlaNonRes,P=v.pipNonRes,C=v.aa,w=v.dla,I=v.psc,O=v.partnerUCRollup,b={warPension:[u],warSpecialPayment:[u],statutorySickPay:[u],housingBenefit:[s],rentalIncome:[l,o(e.rentalIncomeDisregard)],warWidowsPension:[l,o(e.warWidowsPensionDisregard)],wages:[c],attendanceAllowance:[d],dlaCare:[d],pipDailyLiving:[d],mobilityAllowance:[d],universalCreditBreakdown:[g(["children","disabledChild","housingElement","childcare","carer"])],pensionSavingsCredit:[s]},A={default:{disregardsTotal:t({},b)},nonResidential:{disregardsTotal:t(t({},b),{housingBenefit:[p],universalCreditBreakdown:[g(["disabledChild","childcare"])],attendanceAllowance:[d,h],dlaCare:[d,y],pipDailyLiving:[d,P]})},respite:{disregardsTotal:t(t({},b),{attendanceAllowance:[d,C],dlaCare:[d,w],pipDailyLiving:[p]})},permWeek1Residential:{disregardsTotal:t(t({},b),{attendanceAllowance:[p],dlaCare:[p],pipDailyLiving:[p],privatePensions:[f,m]})},permWeek5Residential:{disregardsTotal:t(t({},b),{privatePensions:[f,m],pensionSavingsCredit:[u,I]})},permWeek13Residential:{disregardsTotal:t(t({},b),{privatePensions:[f,m],pensionSavingsCredit:[u,I]})}},T=O(["children","disabledChild","housingElement","childcare","carer"]);return{incomeLookup:A,partnerLookup:{default:{disregardsTotal:{housingBenefit:[u],warPension:[l],warSpecialPayment:[l],universalCreditBreakdown:[O(["disabledChild","childcare"])],wages:[c],attendanceAllowance:[d],dlaCare:[d],pipDailyLiving:[d]}},respite:{disregardsTotal:t(t({},b),{housingBenefit:[p],rentalIncome:[p],warWidowsPension:[p],universalCreditBreakdown:[T],attendanceAllowance:[d,C],dlaCare:[d,w],pipDailyLiving:[p]})},permWeek1Residential:{disregardsTotal:t(t({},b),{housingBenefit:[p],rentalIncome:[p],warWidowsPension:[p],universalCreditBreakdown:[T],attendanceAllowance:[p],dlaCare:[p],pipDailyLiving:[p],privatePensions:[f,r(50)]})},permWeek5Residential:{disregardsTotal:t(t({},b),{housingBenefit:[p],rentalIncome:[p],warWidowsPension:[p],universalCreditBreakdown:[T],privatePensions:[f,r(50)],pensionSavingsCredit:[u,I]})},permWeek13Residential:{disregardsTotal:t(t({},b),{housingBenefit:[p],rentalIncome:[p],warWidowsPension:[p],universalCreditBreakdown:[T],privatePensions:[f,r(50)],pensionSavingsCredit:[u,I]})}}}}},30224:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(25887),a=r(25887);n.getDREConfig=function(e){var n=(0,a.getDREFunctions)(e),r=n.oneOffExpense,i=n.annualExpense,o=n.periodicExpense,s=n.rated,l=n.afterMobility,u=n.ifHasDRE,c=n.washingPerWeek,d=n.otherDRE,p=n.round,g=n.fuel;return{dreLookup:{default:{dreTotal:[(0,t.getIncomeFunctions)(e).zero]},nonResidential:{dreTotal:{fuel:[o,g,p],gardening:[i,p],domesticHelp:[o,p],windowCleaner:[o,p],chiropodist:[o,p],specialClothes:[o,p],alarm:[o,p],additionalBedding:[o,p],incontinenceAids:[o,p],creamsAndWipes:[o,p],dietary:[o,p],medicationDelivery:[o,p],privateCare:[o,p],washingPerWeek:[c,p],communicationEquipment:[r(10,50),p],holidayCarer:[r(1),p],transport:[o,l,p],mobilityScooter:[r(10,50),l,p],bedTurning:[s,u,p],poweredBed:[s,u,p],stairLift:[s,u,p],hoistPurchase:[s,u,p],poweredWheelchairPurchase:[s,u,p],manualWheelchairPurchase:[s,u,p],poweredRecliningChair:[s,u,p],otherDRE:[d,p]}}}}}},60678:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(25887);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.individual,o=n.joint,s=n.ucRollup,l=n.ucDeductionRollup,u=n.wages,c=n.pensions,d=n.otherBenefit,p=n.upliftable,g=n.primaryPropertyEquity,f=n.probablyIncorrectPrimaryPropertyEquity,m=n.partnerPrimaryPropertyEquity,v=n.partnerAdditionalPropertyEquity,h=n.additionalPropertyEquity,y=n.savings,P=n.shareHoldings,C=n.tariff,w=n.minZero,I=n.partnerPensions,O=n.transferredPensionForPartner,b=function(n){return C(e.capitalLimit,e.capitalTariff[n])},A=[y,P,h],T={retirementPension:[r],privatePensions:[c],capitalTariff:a(a([],A,!0),[C(1e4,500)],!1)},R={grossIncome:{carersAllowance:[o],employmentSupport:[o],housingBenefit:[o],industrialInjuriesBenefit:[o],maintenance:[o],pensionGuaranteeCredit:[o],pensionSavingsCredit:[o],rentalIncome:[o],retirementPension:[o],trustIncome:[o],warPension:[o],warSpecialPayment:[o],warWidowsPension:[o],wages:[u],privatePensions:[c],otherBenefit:[d],universalCreditBreakdown:[s(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"]),l(["other","earnings","benefitLimit","capitalTariff"]),w],attendanceAllowance:[p],pipDailyLiving:[p],dlaCare:[p],mobilityAllowance:[p],capitalTariff:a(a([],A,!0),[b("nonResidential")],!1)}},_=[y,P,v];return{incomeLookup:{default:{grossIncome:t({},R.grossIncome),additionalPropertyEquity:[h],totalCapital:a([],A,!0),capitalTariff:a(a([],A,!0),[b("nonResidential")],!1),qualifyingIncome:T},permWeek1Residential:{grossIncome:t({},R.grossIncome),additionalPropertyEquity:[h],totalCapital:a(a([],A,!0),[f],!1),capitalTariff:a(a([],A,!0),[f,b("nonResidential")],!1),qualifyingIncome:T},permWeek5Residential:{grossIncome:t({},R.grossIncome),additionalPropertyEquity:[h],totalCapital:a(a([],A,!0),[f],!1),capitalTariff:a(a([],A,!0),[f,b("nonResidential")],!1),qualifyingIncome:T},permWeek13Residential:{grossIncome:t({},R.grossIncome),additionalPropertyEquity:[h],totalCapital:a(a([],A,!0),[g],!1),capitalTariff:a(a([],A,!0),[g,b("permWeek13Residential")],!1),qualifyingIncome:T}},partnerIncomeLookup:{default:{grossIncome:t({},R.grossIncome),totalCapital:a([],_,!0),capitalTariff:a(a([],_,!0),[b("nonResidential")],!1)},permWeek1Residential:{grossIncome:t(t({},R.grossIncome),{privatePensions:[c,[I,O]]}),additionalPropertyEquity:[v],totalCapital:a(a([],_,!0),[m],!1),capitalTariff:a(a([],_,!0),[m,b("nonResidential")],!1),qualifyingIncome:T},permWeek5Residential:{grossIncome:t(t({},R.grossIncome),{privatePensions:[c,[I,O]]}),additionalPropertyEquity:[v],totalCapital:a(a([],_,!0),[m],!1),capitalTariff:a(a([],_,!0),[m,b("nonResidential")],!1),qualifyingIncome:T},permWeek13Residential:{grossIncome:t(t({},R.grossIncome),{privatePensions:[c,[I,O]]}),additionalPropertyEquity:[v],totalCapital:a(a([],_,!0),[m],!1),capitalTariff:a(a([],_,!0),[m,b("permWeek13Residential")],!1),qualifyingIncome:T}}}}},38776:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(25887),a=r(25887);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e).partnerTransfer,r=(0,a.getIncomeFunctions)(e),i=r.minZero;return{lookup:{default:{partnerTransfer:[r.zero]},nonResidential:{partnerTransfer:[n,i]}}}}},52961:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378),l=r(19666);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,u=new o.CareAssessmentService(r,n),c=new a.Helpers(n),d=(0,s.getDefaultAllowancesHelpers)(c,u,e),p=(0,l.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel;return t(t({},d),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance||(a.universalCreditBreakdown||{}).carer,s="yes"===i.carersAllowanceIsEntitled,l="yes"===i.receivesUCCarerElement,u="yes"===i.receivesCarersAllowanceForSomeoneElse;return r+(o||s||l||u?e.carersPremium:0)},partnerCarerPremium:function(e){var n=e.amount,r=e.parameters,t=r.incomeFields,a=r.partnerIncomeFields,i=r.introFields,o=r.partnerCohabits,s=r.carerPremiumRatesLookup,l=r.disabilityLevel,u=void 0===l?"base":l,c=p(a),d=0;if(o){var g=s[u],f=t.carersAllowance,m="yes"===i.carersAllowanceIsEntitled;d=["dp","edp"].includes(c)||m||f?g:0}return n+d}})}},8691:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(19666),i=r(73378),o=r(52892),s=r(24609),l=r(32954),u=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,o.getConstants)().configuration,r=new l.NumberUtilsService,c=new u.CareAssessmentService(r,n),d=new s.Helpers(n),p=(0,i.getDefaultCostOfCareHelpers)(d,c,e),g=(0,a.getDefaultProcessors)(e).getAgeLevel;return t(t({},p),{ageBasedCap:function(n){var r=n.amount,t=n.parameters,a=e.cappedRespiteRates||{},i=t.dob,o=g(i);return"low"===o?r=a.low||r:"medium"===o?r=a.medium||r:"high"===o&&(r=a.high||r),r}})}},67384:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e),d=c.aa,p=c.dla;return t(t({},c),{aaNonRes:function(n){var r=n.amount,t=n.parameters,a=e.attendanceAllowance,i=a.high,o=a.low,s=t.incomeFields.receivesExtraCare;return r===i.amount?!0===s?0:i.amount-o.amount:0},pipNonRes:function(n){var r=n.amount,t=n.parameters,a=e.pipDailyLiving,i=a.high,o=a.low,s=t.incomeFields.receivesExtraCare;return r===i.amount?!0===s?0:i.amount-o.amount:0},dlaNonRes:function(n){var r=n.amount,t=n.parameters,a=e.dlaCare,i=a.high,o=a.medium,s=void 0===o?{}:o,l=t.incomeFields.receivesExtraCare;return r===i.amount?!0===l?0:i.amount-s.amount:0},aa:d,dla:p,psc:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.suDOB,s=i.qualifyingIncome||0,u=e.pensionSavingsCreditIncomeThreshold,c=u?u.singleApplicant:{},d=r>0;return l.getAgeLevel(o,e.levels).level!==e.levels.high||s<c.INCOME_LOW?0:s>=c.INCOME_LOW&&s<c.INCOME_HIGH||s>=c.INCOME_HIGH?d?Math.min(r||0,c.DISREGARD_MAX):c.DISREGARD_MAX:0},partnerUCRollup:function(e){return void 0===e&&(e=[]),function(n){var r=n.amount,t=n.parameters,a=Object.keys(t.incomeFields.universalCreditBreakdown||{}).reduce((function(n,r){return e.includes(r)?n+((t.incomeFields.universalCreditBreakdown||{})[r]||0):n}),0);return r+l.toWeeklyAmount(a,o.PERIODS.Monthly)}}})}},9727:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(52892),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{round:function(e){var n=e.amount-1e-4;return r.roundUp(n)},washingPerWeek:function(e){return!0===e.parameters.dreExpensesFields.washesPerWeekAboveAverage&&(0,i.getConstants)().washingExcessPremium||0},ifHasDRE:function(e){var n,r=e.amount,t=e.key;return null!==(n=e.parameters.dreExpensesFields["has".concat(t[0].toUpperCase()+t.slice(1))])&&void 0!==n&&n?r:0},fuel:function(n){var r,t=n.amount,a=n.parameters,i=a.propertyFields,o=a.partnerCohabits?2:1,s=i.propertyType;(r=(e.heatingCosts||{}).applicant[s]||0,o>1)&&(r+=(o-1)*((e.heatingCosts||{}).eachExtraPerson[s]||0));return Math.max((t-r)/o,0)}})}},11713:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{probablyIncorrectPrimaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.dependentChildrenCount,i=r.partnerCohabits,o=r.peopleLivingWithYou,s=void 0===o?{}:o,l=r.propertyFields.value||0,u=r.propertyFields.ownership,c=(s.otherPeople||[]).length;return a<1&&c<1&&!i||"ownedByYou"!==u||(t+=l),n+t},primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0;return"ownedByYou"===r.propertyFields.ownership&&(t+=a),n+t},partnerPrimaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.dependentChildrenCount,i=r.partnerCohabits,o=r.peopleLivingWithYou,s=void 0===o?{}:o,l=r.propertyFields.value||0,u=r.propertyFields.ownership,c=(s.otherPeople||[]).length;return n+(t+="ownedByPartner"===u?a<1&&c<1&&!i?0:l:0)},additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){return(n.value||0)+e}),0)},partnerAdditionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){var r=n.value||0;return n.isJointlyOwned&&(e+=r),e}),0)}})}},94459:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{partnerTransfer:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.partnerLivingAllowanceTotal,s=void 0===o?0:o,l=i.partnerGrossIncome,u=void 0===l?0:l,c=i.partnerDisregardsTotal;return n+(s-(u-(void 0===c?0:c)))}})}},25887:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getPartnerAllowances=n.getAllowances=n.getDREs=n.getPartnerDisregards=n.getDisregards=n.getPartnerIncome=n.getIncome=void 0;var t=r(41526);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}});var a=r(92037);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(86312);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(79958);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}}),Object.defineProperty(n,"getPartnerAllowances",{enumerable:!0,get:function(){return o.getPartnerAllowances}});var s=r(54668);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(61516);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(60678);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(32781);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(30224);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(45662);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(38776);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(53192);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(11713);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(67384);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(9727);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(52961);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(94459);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(8691);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(15885);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(41174);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},41174:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel;return t(t({},(0,a.getDefaultProcessors)(e)),{getPartnerAllowanceTypeProcessor:function(e){var n,r=(null!==(n=e.incomeFields.employmentSupport)&&void 0!==n?n:0)>0?"partnerNonResidentialWithESA":"partnerNonResidential";return t(t({},e),{allowanceType:r})},getPartnerDisabilityLevelProcessor:function(e){var r=e.incomeFields,a=e.partnerIncomeFields,i=e.partnerCohabits,o=n(a),s=n(r),l="base",u="dp"===s||"edp"===s,c=i?!("dp"!==s&&"edp"!==s||"dp"!==o&&"edp"!==o):"dp"===s||"edp"===s||"dp"===o||"edp"===o;return u||c||(l="base"),u&&c&&(l="dp"),!u&&c&&(l="edp"),t(t({},e),{disabilityLevel:l})}})}},77562:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.somerset=void 0;var t=r(732),a=r(52892);n.somerset={calculator:t.calculator,getConstants:a.getConstants}},50986:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(22350),i=r(49041),o=r(54215),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l),p=l.fullCostCapitalLimit[r];if((d.totalCapital||0)>=p)return{contributions:{},workings:c};c=Object.assign(c,d);var g=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,g);var f=(0,o.getExpenses)(e,r);c=Object.assign(c,f);var m=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,m),u=Object.assign(u,{expensesAboveMaxThreshold:(0,i.getExpensesAboveThreshold)(e,r,l,c)});var v=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,v)}else u=Object.assign(u,{fullCost:!0});for(var h in c)if(Object.prototype.hasOwnProperty.call(c,h)){var y=c[h]||0;c[h]=s.roundNearest(y)}return(0,i.getCostOfCare)(e,r,l,c,u)}},31687:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={warWidowsPensionDisregard:0,rentalIncomeDisregard:0,careTypes:{nonResidential:"nonResidential",shortStayResidential:"shortStayResidential",permanentResidentialWeek1:"permanentResidentialWeek1",permanentResidentialWeek5:"permanentResidentialWeek5",permanentResidentialWeek13:"permanentResidentialWeek13"},attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,shortStayResidential:0,permanentResidentialWeek1:0,permanentResidentialWeek5:0,permanentResidentialWeek13:0},capitalTariff:{nonResidential:0,shortStayResidential:0,permanentResidentialWeek1:0,permanentResidentialWeek5:0,permanentResidentialWeek13:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,INCOME_LIMIT:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,INCOME_LIMIT:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},overridePensionAge:60,configuration:{calculatorConfig:{weeksPerYear:365/7}},heatingCosts:{applicant:{flat:0,terraced:0,semiDetached:0,detached:0},eachExtraPerson:{flat:0,terraced:0,semiDetached:0,detached:0}},dreCaps:{alarm:0,chiropodist:0,domesticHelp:0,shoppingHelp:0,gardening:0,manualWheelchairHire:0,manualWheelchairPurchase:0,poweredWheelchairPurchase:0,poweredWheelchairHire:0},washingExcessPremium:0,landlineTelephoneAllowance:0}},22350:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(31687),i=r(61515);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(48541);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},61515:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,rentalIncomeDisregard:20,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,shortStayResidential:23250,permanentResidentialWeek1:23250,permanentResidentialWeek5:23250,permanentResidentialWeek13:23250},capitalTariff:{nonResidential:250,shortStayResidential:250,permanentResidentialWeek1:250,permanentResidentialWeek5:250,permanentResidentialWeek13:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}}},childPremium:102.95,carersPremium:53.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,INCOME_LIMIT:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,INCOME_LIMIT:346.6,DISREGARD_MAX:10.6}},heatingCosts:{applicant:{flat:37.98,terraced:37.98,semiDetached:40.34,detached:49.08},eachExtraPerson:{flat:12.13,terraced:12.13,semiDetached:12.92,detached:15.62}},dreCaps:{alarm:6.25,chiropodist:5.2,domesticHelp:15.6,shoppingHelp:15.6,gardening:15.6,manualWheelchairHire:5.07,manualWheelchairPurchase:5.07,poweredWheelchairPurchase:12.31,poweredWheelchairHire:12.31},washingExcessPremium:4.86,landlineTelephoneAllowance:2}},48541:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,rentalIncomeDisregard:20,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,shortStayResidential:23250,permanentResidentialWeek1:23250,permanentResidentialWeek5:23250,permanentResidentialWeek13:23250},capitalTariff:{nonResidential:250,shortStayResidential:250,permanentResidentialWeek1:250,permanentResidentialWeek5:250,permanentResidentialWeek13:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:136.45-87.65,edp:160.3-136.45},over25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},over25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},pensionAge:{base:174.6,dp:0,edp:0}}},childPremium:101.25,carersPremium:52.35,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,INCOME_LIMIT:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:301.22,INCOME_HIGH:332.95,INCOME_LIMIT:332.95,DISREGARD_MAX:10.4}},heatingCosts:{applicant:{flat:40.84,terraced:40.84,semiDetached:43.37,detached:52.77},eachExtraPerson:{flat:13.04,terraced:13.04,semiDetached:57.27-43.37,detached:69.57-52.77}},dreCaps:{alarm:6.25,chiropodist:5.2,domesticHelp:15.6,shoppingHelp:15.6,gardening:15.6,manualWheelchairHire:4.94,manualWheelchairPurchase:4.94,poweredWheelchairPurchase:12,poweredWheelchairHire:12},washingExcessPremium:4.74,landlineTelephoneAllowance:2}},54691:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.fixedOrNone=n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},n.fixedOrNone=function(e){return function(n){return n.amount?e:0}}},54215:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getPartnerArrangement=void 0;var t=r(91569),a=r(87321),i=r(22350);n.getPartnerArrangement=function(e){var n=e.hasPartner,r=e.partnerCohabits;return e.livesWithOther?"cohabitingWithOther":n?r?"cohabitingPartner":"nonCohabitingPartner":"single"},n.getExpenses=function(e,r){var o=(0,i.getConstants)(),s=(0,a.getHousingExpenses)(o),l=o.configuration;return(0,t.expensesCalculator)(l,e,r,s,{getPartnerArrangement:n.getPartnerArrangement})}},87321:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getHousingExpenses=void 0;var t=r(54691);n.getHousingExpenses=function(e){var n={nonResidential:{single:{ownedByYou:{mortgageLessHousing:[t.full],mortgage:[t.full],endowmentInsurance:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByPartner:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{communityAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],serviceCharge:[t.full],communityAlarm:[t.full]}},cohabitingPartner:{ownedByYou:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByPartner:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{communityAlarm:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],communityAlarm:[t.full]}},nonCohabitingPartner:{ownedByYou:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByPartner:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{communityAlarm:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],communityAlarm:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgageLessHousing:[t.full],mortgage:[t.full],endowmentInsurance:[t.full],councilTax:[t.full],serviceCharge:[t.full],groundRent:[t.full],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByPartner:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{communityAlarm:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],communityAlarm:[t.full]}}},shortStayResidential:{single:{ownedByYou:{mortgageLessHousing:[t.full],mortgage:[t.full],endowmentInsurance:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full],waterRates:[t.full],gas:[t.full],electric:[t.full],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],serviceCharge:[t.full],groundRent:[t.full],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],communityAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],contentsInsurance:[t.full],waterRates:[t.full],gas:[t.full],electric:[t.full],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],communityAlarm:[t.full]}},cohabitingPartner:{ownedByYou:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByPartner:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],communityAlarm:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]}},nonCohabitingPartner:{ownedByYou:{mortgageLessHousing:[t.full],mortgage:[t.full],endowmentInsurance:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full],waterRates:[t.full],gas:[t.full],electric:[t.full],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],serviceCharge:[t.full],groundRent:[t.full],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByPartner:{councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],communityAlarm:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgageLessHousing:[t.full],mortgage:[t.full],endowmentInsurance:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full],waterRates:[t.full],gas:[t.full],electric:[t.full],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],serviceCharge:[t.full],groundRent:[t.full],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByPartner:{councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],communityAlarm:[t.full]},ownedByOther:{landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],communityAlarm:[t.full]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],communityAlarm:[t.full]}}},permanentResidentialWeek1:{single:{ownedByYou:{mortgageLessHousing:[t.full],mortgage:[t.full],endowmentInsurance:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full],waterRates:[t.full],gas:[t.full],electric:[t.full],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],serviceCharge:[t.full],groundRent:[t.full],communityAlarm:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],communityAlarm:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],contentsInsurance:[t.full],waterRates:[t.full],gas:[t.full],electric:[t.full],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0)],serviceCharge:[t.full],communityAlarm:[t.full]}},cohabitingPartner:{tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],communityAlarm:[t.full]}},nonCohabitingPartner:{tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],communityAlarm:[t.full]}},cohabitingWithOther:{tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],gas:[(0,t.ratio)(50)],electric:[(0,t.ratio)(50)],landlineTelephone:[(0,t.fixedOrNone)(e.landlineTelephoneAllowance||0),(0,t.ratio)(50)],communityAlarm:[t.full]}}},permanentResidentialWeek5:{single:{ownedByYou:{mortgageLessHousing:[t.full],mortgage:[t.full],endowmentInsurance:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full],waterRates:[t.full],serviceCharge:[t.full],groundRent:[t.full]},ownedJointly:{mortgageLessHousing:[(0,t.ratio)(50)],mortgage:[(0,t.ratio)(50)],endowmentInsurance:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]}}}};return n.permanentResidentialWeek13=n.permanentResidentialWeek5,n}},73315:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(98944);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getDisabilityLevelProcessor,p=c.getAllowanceTypeProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getDisabilityLevelProcessor:d,getAllowanceTypeProcessor:p}),(0,t.sharedCalculator)(n,s,g,u)}},64692:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(49041),a=r(49041);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},13522:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(49041),a=r(49041);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},79155:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(49041),a=r(49041);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)}},56090:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpensesAboveThreshold=n.getDREs=void 0;var t=r(49041),a=r(49041);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)};n.getExpensesAboveThreshold=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLimitLookup;return(0,t.calculator)(e,n,r,o,i,{getRollup:function(e){var n=[],t=e.dreTotal,a=r.dreCaps||{};return Object.entries(t).forEach((function(e){var r=e[0];e[1]>(a[r]||Number.POSITIVE_INFINITY)&&n.push(r)})),n}})}},69756:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getIncome=void 0;var t=r(49041),a=r(49041);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)}},4556:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(49041),a=r(49041);n.getAllowancesConfig=function(e){var n=(0,a.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,t.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s],carerPremium:[c],childPremium:[u]},plaRate:[s],carerPremium:[c],childPremium:[u]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}}}}},66270:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(49041);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},33547:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(49041),i=r(49041);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.joint,o=n.individual,s=n.wages,l=n.upliftable,u=n.zero,c=n.pensions,d=n.cap,p=n.transferredPensionForPartner,g=(0,a.getDisregardsFunctions)(e),f=g.psc,m=g.shareWithPartner,v={childTaxCredit:[o],warPension:[o],warSpecialPayment:[o],childBenefit:[o],charitableIncome:[o],workingTaxCredit:[u],warWidowsPension:[o,d(e.warWidowsPensionDisregard)],wages:[s],privatePensions:[c,p],attendanceAllowance:[l],pipDailyLiving:[l],dlaCare:[l],mobilityAllowance:[l],pensionSavingsCredit:[r,f]};return{incomeLookup:{default:{disregardsTotal:t({},v),pscDisregard:{pensionSavingsCredit:[r,f]}},nonResidential:{disregardsTotal:t(t({},v),{workingTaxCredit:[o],attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u],pensionSavingsCredit:[o,m],privatePensions:[u]}),pscDisregard:{pensionSavingsCredit:[o,m]}},permanentResidentialWeek1:{disregardsTotal:t(t({},v),{attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u]})},permanentResidentialWeek13:{disregardsTotal:t(t({},v),{attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u]})}}}}},99170:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(49041),a=r(49041);n.getDREConfig=function(e){var n=(0,a.getDREFunctions)(e),r=n.oneOffExpense,i=n.annualExpense,o=n.periodicExpense,s=n.washingPerWeek,l=n.fuel,u=n.shareWithOne,c=n.limit,d=n.chiropody,p=(0,t.getIncomeFunctions)(e);return{dreLookup:{default:{dreTotal:[p.zero]},nonResidential:{dreTotal:{fuel:[o,u,l],alarm:[o,c],chiropodist:[d,c],domesticHelp:[o,c],shoppingHelp:[o,c],gardening:[i,(0,p.ratio)(50),c],manualWheelchairPurchase:[r(5),c],poweredWheelchairPurchase:[r(5),c],manualWheelchairHire:[o,c],poweredWheelchairHire:[o,c],washingPerWeek:[s]}}},dreLimitLookup:{default:{dreTotal:{alarm:[o],chiropodist:[o],domesticHelp:[o],shoppingHelp:[o],gardening:[i],manualWheelchairPurchase:[r(5)],poweredWheelchairPurchase:[r(5)],manualWheelchairHire:[o],poweredWheelchairHire:[o]}}}}}},88364:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(49041);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.incomeAfterDisregard,o=n.full,s=n.individual,l=n.ucRollup,u=n.wages,c=n.pensions,d=n.otherBenefit,p=n.upliftable,g=n.savings,f=n.shareHoldings,m=n.tariff,v=function(n){return m(e.capitalLimit,e.capitalTariff[n])},h=[g,f],y={retirementPension:[o],warPension:[o],industrialInjuriesBenefit:[o],carersAllowance:[o],wages:[u],privatePensions:[c],warWidowsPension:[o,r(e.warWidowsPensionDisregard)],rentalIncome:[o,r(e.rentalIncomeDisregard)]},P={grossIncome:{retirementPension:[s],universalCredit:[s],incomeSupportPayment:[s],incapacityBenefit:[s],employmentSupport:[s],jobSeekersAllowance:[s],industrialInjuriesBenefit:[s],rentalIncome:[s],workingTaxCredit:[s],childTaxCredit:[s],maintenance:[s],warSpecialPayment:[s],childBenefit:[s],carersAllowance:[s],pensionGuaranteeCredit:[s],pensionSavingsCredit:[s],charitableIncome:[s],warPension:[s],warWidowsPension:[s],wages:[u],privatePensions:[c],otherBenefit:[d],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare","healthAllowance"])],attendanceAllowance:[p],pipDailyLiving:[p],dlaCare:[p],mobilityAllowance:[p],capitalTariff:a(a([],h,!0),[v("nonResidential")],!1)}};return{incomeLookup:{default:{grossIncome:t({},P.grossIncome),totalCapital:a([],h,!0),capitalTariff:a(a([],h,!0),[v("nonResidential")],!1),qualifyingIncome:y}}}}},88759:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){return n.amount+(n.parameters.incomeFields.carersAllowance?e.carersPremium:0)}})}},53713:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(22350),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},43030:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e);return t(t({},c),{shareWithPartner:function(e){var n=e.amount;return e.parameters.hasPartner?n/2:n},psc:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.suDOB,s=t.hasPartner,u=i.qualifyingIncome,c=void 0===u?0:u,d=l.getAgeLevel(o,e.levels).level,p=e.pensionSavingsCreditIncomeThreshold,g=p?p.singleApplicant:{};s&&(g=p&&p.applicantAndPartner||{});var f=r>0;return d!==e.levels.high||c<g.INCOME_LOW?0:c>=g.INCOME_LOW&&c<g.INCOME_HIGH?f?Math.min(r||0,g.DISREGARD_MAX):g.DISREGARD_MAX:c>=g.INCOME_HIGH&&g.INCOME_LIMIT&&c<g.INCOME_LIMIT?f?Math.min(r||0,g.DISREGARD_MAX):0:g.DISREGARD_MAX}})}},73721:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(22350),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{washingPerWeek:function(n){return(n.parameters.dreExpensesFields.washingPerWeek||0)>=5&&e.washingExcessPremium||0},chiropody:function(n){n.amount,n.key;var r=n.parameters.dreExpensesFields,t=(e.configuration.calculatorConfig||{}).weeksPerYear||52;return Math.min(4,r.chiropodySessions||0)*(r.chiropodyCost||0)/t},shareWithOne:function(e){var n=e.amount,r=(e.key,e.parameters),t=r.partnerCohabits,a=r.peopleLivingWithYou;return(a.hasOtherPeople?(a.otherPeople||[]).length:0)+(t?2:1)>1&&(n/=2),n},fuel:function(n){var r=n.amount,t=n.parameters,a=t.propertyFields,i=t.partnerCohabits,o=t.peopleLivingWithYou,s=(o.hasOtherPeople?(o.otherPeople||[]).length:0)+(i?1:0),l=a.propertyType||"",u=e.heatingCosts,c=u.applicant[l]||0,d=u.eachExtraPerson[l]||0,p=c;return s>0&&(p=(c+d)/2),Math.max(0,r-p)}})}},48127:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{incomeAfterDisregard:function(e){return void 0===e&&(e=0),function(n){var r=n.amount;n.parameters;return Math.max(0,r-e)}}})}},49041:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.calculator=n.getCostOfCareFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getAllowances=n.getExpensesAboveThreshold=n.getDREs=n.getDisregards=n.getIncome=void 0;var t=r(69756);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}});var a=r(79155);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(56090);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}}),Object.defineProperty(n,"getExpensesAboveThreshold",{enumerable:!0,get:function(){return i.getExpensesAboveThreshold}});var o=r(64692);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(13522);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return s.getCostOfCare}});var l=r(88364);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return l.getIncomeConfig}});var u=r(33547);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return u.getDisregardsConfig}});var c=r(99170);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return c.getDREConfig}});var d=r(4556);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return d.getAllowancesConfig}});var p=r(66270);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return p.getCostOfCareConfig}});var g=r(48127);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return g.getIncomeFunctions}});var f=r(43030);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return f.getDisregardsFunctions}});var m=r(73721);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return m.getDREFunctions}});var v=r(88759);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return v.getAllowancesFunctions}});var h=r(53713);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return h.getCostOfCareFunctions}});var y=r(73315);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return y.calculator}});var P=r(98944);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return P.getProcessors}})},98944:function(e,n){var r=this&&this.__assign||function(){return r=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},r.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0,n.getProcessors=function(e){return{getDisabilityLevelProcessor:function(e){var n,t=e.incomeFields,a=t.dlaCare,i=t.pipDailyLiving;return n=a&&"none"!==a||i&&"none"!==i?"high"===a||"high"===i?"edp":"dp":"base",r(r({},e),{disabilityLevel:n})},getAllowanceTypeProcessor:function(e){var n=e.hasPartner?"coupleServiceUser":"singleServiceUser";return r(r({},e),{allowanceType:n})}}}},38136:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.southampton=void 0;var t=r(50986),a=r(22350);n.southampton={calculator:t.calculator,getConstants:a.getConstants}},13640:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(48368),i=r(27995),o=r(59033),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l);c=Object.assign(c,d);var p=l.fullCostCapitalLimit[r],g=(d.totalCapital||0)>=p,f=(d.additionalPropertyEquity||0)>0;if(g||f){var m=(l.maxContribution||{})[r];return{contributions:s.isNumeric(m)?{maxContribution:m}:{},workings:c}}var v=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,v);var h=(0,o.getExpenses)(e,r);c=Object.assign(c,h);var y=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,y);var P=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,P)}else u=Object.assign(u,{fullCost:!0});for(var C in c)if(Object.prototype.hasOwnProperty.call(c,C)){var w=c[C]||0;c[C]=s.roundNearest(w)}return(0,i.getCostOfCare)(e,r,l,c,u)}},45197:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={warPensionDisregard:0,careTypes:{nonResidential:"nonResidential",respite:"respite",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},overridePensionAge:60,configuration:{calculatorConfig:{weeksPerYear:52}},maxDREAllowance:0}},48368:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(45197),i=r(39729);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(91495);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},39729:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:89.15,dp:35.4,edp:17.45},over25:{base:89.15,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}},loneParentUser:{under25:{base:112.5,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},localSingleServiceUser:{under25:{base:232.6,dp:0,edp:0},over25:{base:232.6,dp:0,edp:0},pensionAge:{base:232.6,dp:0,edp:0}},localLoneParentUser:{under25:{base:232.6,dp:-70.45,edp:24.25},over25:{base:232.6,dp:-70.45,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},localCoupleServiceUser:{under25:{base:177.55,dp:0,edp:0},over25:{base:177.55,dp:0,edp:0},pensionAge:{base:177.55,dp:0,edp:0}},localCoupleWithChildrenUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}}},carerPremiumRatesMap:{localSingleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:7.05},pensionAge:{base:53.25,dp:53.25,edp:53.25}},localLoneParentUser:{under25:{base:-65.75,dp:52.35,edp:52.35},over25:{base:-66.85,dp:53.25,edp:53.25},pensionAge:{base:53.25,dp:53.25,edp:53.25}},localCoupleServiceUser:{under25:{base:0,dp:0,edp:16.9},over25:{base:0,dp:0,edp:16.9},pensionAge:{base:53.25,dp:53.25,edp:53.25}},localCoupleWithChildrenUser:{under25:{base:52.15,dp:67.15,edp:52.35},over25:{base:53.25,dp:53.25,edp:53.25},pensionAge:{base:53.25,dp:53.25,edp:53.25}}},childPremium:102.95,carersPremium:53.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}},maxDREAllowance:10}},91495:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:136.45-87.65,edp:160.3-136.45},over25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},over25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},pensionAge:{base:174.6,dp:0,edp:0}},loneParentUser:{under25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},over25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},pensionAge:{base:228.7,dp:0,edp:0}},localSingleServiceUser:{under25:{base:228.7,dp:0,edp:0},over25:{base:228.7,dp:0,edp:0},pensionAge:{base:228.7,dp:0,edp:0}},localLoneParentUser:{under25:{base:228.7,dp:0,edp:0},over25:{base:228.7,dp:0,edp:0},pensionAge:{base:228.7,dp:0,edp:0}},localCoupleServiceUser:{under25:{base:174.6,dp:0,edp:0},over25:{base:174.6,dp:0,edp:0},pensionAge:{base:174.6,dp:0,edp:0}},localCoupleWithChildrenUser:{under25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},over25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},pensionAge:{base:174.6,dp:0,edp:0}}},carerPremiumRatesMap:{localSingleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:6.9},pensionAge:{base:52.35,dp:52.35,edp:52.35}},localLoneParentUser:{under25:{base:-65.75,dp:52.35,edp:52.35},over25:{base:-65.75,dp:52.35,edp:52.35},pensionAge:{base:52.35,dp:52.35,edp:52.35}},localCoupleServiceUser:{under25:{base:0,dp:0,edp:16.55},over25:{base:0,dp:0,edp:16.55},pensionAge:{base:52.35,dp:52.35,edp:52.35}},localCoupleWithChildrenUser:{under25:{base:52.15,dp:67.15,edp:52.35},over25:{base:52.15,dp:67.15,edp:52.35},pensionAge:{base:52.35,dp:52.35,edp:52.35}}},childPremium:101.25,carersPremium:52.35,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95}},maxDREAllowance:10}},10953:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.bi=n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},n.bi=function(e){return!0===e.expenseFields.isHomeInsuranceCombined?e.amount/2:e.amount}},59033:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getPartnerArrangement=void 0;var t=r(91569),a=r(62991),i=r(48368);n.getPartnerArrangement=function(e){var n=e.hasPartner,r=e.partnerCohabits,t=e.livesWithOther;return n?r?"cohabitingPartner":"nonCohabitingPartner":t?"cohabitingWithOther":"single"},n.getExpenses=function(e,r){var o=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,a.housingExpenses,{getPartnerArrangement:n.getPartnerArrangement})}},62991:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(10953);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi,t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[t.full],homeInsurance:[t.bi,(0,t.ratio)(50)]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi,t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[t.full],homeInsurance:[t.bi,(0,t.ratio)(50)]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi,t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]}}},respite:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[t.full],homeInsurance:[t.bi,(0,t.ratio)(50)]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[t.full],homeInsurance:[t.bi,(0,t.ratio)(50)]},ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi,t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[t.bi,(0,t.ratio)(50)]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full]}}},week1Residential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full]}}},week5Residential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.bi]}}}}},34449:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.localCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(31370);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r).getAllowanceTypeProcessor,d=(0,a.getParameters)(e,l);return d=(0,i.runProcessors)(d,r,{getAllowanceTypeProcessor:c}),(0,t.sharedCalculator)(n,s,d,u)},n.localCalculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getLocalAllowanceTypeProcessor,p=c.getCarerPremiumRateLookupProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getAllowanceTypeProcessor:d,additionalProcessors:[p]}),(0,t.sharedCalculator)(n,s,g,u)}},54938:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var a=r(27995),i=r(27995);n.getAllowances=function(e,n,r,o){var s=(0,i.getAllowancesConfig)(r),l=s.standardLookup,u=s.localLookup,c=(0,a.calculator)(e,n,r,l,o),d=(0,a.localCalculator)(e,n,r,u,o),p=c.livingAllowanceTotal,g=d.livingAllowanceTotal,f=Math.max(g,p);return o=t(t({},o),{gmrAllowanceTotal:p,sgrAllowanceTotal:g,livingAllowanceTotal:f})}},61352:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(27995),a=r(27995);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},21369:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(27995),a=r(27995);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)}},13092:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(27995),a=r(27995);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},81722:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getIncome=void 0;var t=r(27995),a=r(27995);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)}},52034:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(27995),a=r(27995);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,a.getIncomeFunctions)(e).zero;return{standardLookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},respite:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}},localLookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[c],carerPremium:[l]},plaRate:[r,i,o],childPremium:[c],carerPremium:[l]},respite:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[c],carerPremium:[l]},plaRate:[r,i,o],childPremium:[c],carerPremium:[l]}}}}},44020:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(27995);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},49201:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(27995),i=r(27995);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.joint,o=n.individual,s=n.wages,l=n.upliftable,u=n.zero,c=n.pensions,d=n.cap,p=n.transferredPensionForPartner,g=n.ifTransferPension,f=(0,a.getDisregardsFunctions)(e),m=f.aa,v=f.dla,h=f.pip,y=f.psc,P=f.ifNotReceivingExtraCare,C=f.zeroIfOwnsPropertyWithoutCohabitingPartner,w={workingTaxCredit:[r],childTaxCredit:[r],childMaintenance:[r],warSpecialPayment:[r],warWidowsPension:[r],veteranWarPension:[r],childBenefit:[r],warPension:[o,d(e.warPensionDisregard)],wages:[s],privatePensions:[c,p,g],attendanceAllowance:[l],pipDailyLiving:[l],dlaCare:[l],mobilityAllowance:[l],pensionSavingsCredit:[r,y]};return{incomeLookup:{default:{disregardsTotal:t({},w),pscDisregard:{pensionSavingsCredit:[r,y]}},nonResidential:{disregardsTotal:t(t({},w),{attendanceAllowance:[l,m,P],pipDailyLiving:[l,h,P],dlaCare:[l,v,P],pensionSavingsCredit:[o],privatePensions:[u]}),pscDisregard:{pensionSavingsCredit:[o]}},respite:{disregardsTotal:t(t({},w),{attendanceAllowance:[l,m,P],pipDailyLiving:[l,h,P],dlaCare:[l,v,P],privatePensions:[u],pensionSavingsCredit:[o]}),pscDisregard:{pensionSavingsCredit:[o]}},week1Residential:{disregardsTotal:t(t({},w),{attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u]}),pscDisregard:{pensionSavingsCredit:[r,y]}},week13Residential:{disregardsTotal:t(t({},w),{attendanceAllowance:[l,C],pipDailyLiving:[l,C],dlaCare:[l,C]}),pscDisregard:{pensionSavingsCredit:[r,y]}}}}}},82620:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(27995),a=r(27995);n.getDREConfig=function(e){var n=(0,a.getIncomeFunctions)(e).zero,r=(0,t.getDREFunctions)(e).dre;return{dreLookup:{default:{dreTotal:[n]},nonResidential:{dreTotal:[r]},respite:{dreTotal:[r]}}}}},87178:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(27995);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.ratio,o=n.full,s=n.joint,l=n.individual,u=n.ucRollup,c=n.wages,d=n.pensions,p=n.otherBenefit,g=n.upliftable,f=n.savings,m=n.shareHoldings,v=n.tariff,h=n.primaryPropertyEquity,y=n.additionalPropertyEquity,P=n.ifLivesAlone,C=n.zeroIfExceedsCapitalThreshold,w=function(n){return v(e.capitalLimit,e.capitalTariff[n])},I=v(1e4,500),O=[f,[m,r(90),y]],b={retirementPension:[l],privatePensions:[d],capitalTariff:[[O,C("nonResidential")],I]},A={grossIncome:{universalCredit:[s],retirementPension:[s],incomeSupportPayment:[s],incapacityBenefit:[s],industrialInjuriesBenefit:[s],workingTaxCredit:[s],childTaxCredit:[s],maintenance:[s],warPension:[s],veteranWarPension:[s],warWidowsPension:[s],warSpecialPayment:[s],childBenefit:[s],carersAllowance:[s],pensionGuaranteeCredit:[s],pensionSavingsCredit:[s],childMaintenance:[s],employmentSupport:[o],jobSeekersAllowance:[o],wages:[c],privatePensions:[d],otherBenefit:[p],universalCreditBreakdown:[u(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare","healthAllowance"])],attendanceAllowance:[g],pipDailyLiving:[g],dlaCare:[g],mobilityAllowance:[g],capitalTariff:a(a([],O,!0),[w("nonResidential")],!1)}};return{incomeLookup:{default:{grossIncome:t({},A.grossIncome),additionalPropertyEquity:[y],totalCapital:a([],O,!0),capitalTariff:a(a([],O,!0),[w("nonResidential")],!1),qualifyingIncome:b},week13Residential:{grossIncome:t({},A.grossIncome),additionalPropertyEquity:[y],totalCapital:a(a([],O,!0),[[h,P]],!1),capitalTariff:a(a([],O,!0),[w("week13Residential")],!1),qualifyingIncome:b}}}}},86573:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=t.partnerCohabits,s=t.partnerIncomeFields,l=t.partnerIntroFields,u=t.carerPremiumRatesLookup,c=t.disabilityLevel,d=void 0===c?"base":c,p=0,g=a.carersAllowance,f="yes"===i.carersAllowanceIsEntitled,m=e.carersPremium||0;if(void 0!==u&&(m=u[d]),p=g||f?m:0,o){var v=s.carersAllowance,h="yes"===l.carersAllowanceIsEntitled;p+=v||h?m:0}return r+p}})}},96935:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(48368),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},46820:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e);return t(t({},c),{psc:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.suDOB,s=i.qualifyingIncome,u=void 0===s?0:s,c=l.getAgeLevel(o,e.levels).level,d=e.pensionSavingsCreditIncomeThreshold,p=d?d.singleApplicant:{},g=r>0;return c!==e.levels.high||u<p.INCOME_LOW?0:u>=p.INCOME_LOW&&u<p.INCOME_HIGH?g?Math.min(r||0,p.DISREGARD_MAX):p.DISREGARD_MAX:u>=p.INCOME_HIGH&&g?Math.min(r||0,p.DISREGARD_MAX):p.DISREGARD_MAX},zeroIfOwnsPropertyWithoutCohabitingPartner:function(e){var n=e.amount,r=e.parameters,t=r.partnerCohabits,a=r.propertyFields.ownership;return("ownedByYou"===a||"ownedJointly"===a)&&!t?0:n}})}},62515:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(48368),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{dre:function(n){n.amount;return e.maxDREAllowance||0}})}},9005:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=(r.propertyFields.estimatedValue||0)-(r.propertyFields.outstandingMortgage||0),i=r.propertyFields.ownership;return n+(t+="ownedByYou"===i?a:"ownedJointly"===i?a/2:0)},additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){var r=(n.estimatedValue||0)-(n.outstandingMortgage||0);return n.isJointlyOwned&&(r/=2),r+e}),0)}})}},27995:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.localCalculator=n.calculator=n.getCostOfCareFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getAllowances=n.getDREs=n.getDisregards=n.getIncome=void 0;var t=r(81722);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}});var a=r(21369);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(13092);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(54938);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(61352);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return s.getCostOfCare}});var l=r(87178);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return l.getIncomeConfig}});var u=r(49201);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return u.getDisregardsConfig}});var c=r(82620);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return c.getDREConfig}});var d=r(52034);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return d.getAllowancesConfig}});var p=r(44020);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return p.getCostOfCareConfig}});var g=r(9005);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return g.getIncomeFunctions}});var f=r(46820);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return f.getDisregardsFunctions}});var m=r(62515);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return m.getDREFunctions}});var v=r(86573);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return v.getAllowancesFunctions}});var h=r(96935);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return h.getCostOfCareFunctions}});var y=r(34449);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return y.calculator}}),Object.defineProperty(n,"localCalculator",{enumerable:!0,get:function(){return y.localCalculator}});var P=r(31370);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return P.getProcessors}})},31370:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){return t(t({},(0,a.getDefaultProcessors)(e)),{getAllowanceTypeProcessor:function(e){var n=e.hasPartner,r=e.dependentChildrenCount,a=n?"coupleServiceUser":r>0?"loneParentUser":"singleServiceUser";return t(t({},e),{allowanceType:a})},getLocalAllowanceTypeProcessor:function(e){var n=e.hasPartner,r=e.dependentChildrenCount,a=n?r>0?"localCoupleWithChildrenUser":"localCoupleServiceUser":r>0?"localLoneParentUser":"localSingleServiceUser";return t(t({},e),{allowanceType:a})}})}},63662:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.southglos=void 0;var t=r(13640),a=r(48368),i=r(26710);n.southglos={calculator:t.calculator,getConstants:a.getConstants,migrations:i.migrations}},40380:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;var t=r(50237);n.m1=function(e){void 0===e&&(e={});var n=null!=e?e:{},r=JSON.parse(JSON.stringify(n)),a=["retirementPension","incomeSupportPayment","incapacityBenefit","employmentSupport","jobSeekersAllowance","industrialInjuriesBenefit","childBenefit","carersAllowance","pensionSavingsCredit","pensionGuaranteeCredit"],i=n.person;void 0===i&&(i={});var o=i.income;if(void 0!==o){var s=r.person.income;a.forEach((function(e){var n="".concat(e,"Period");o[n]===t.PERIODS.Monthly&&(s[n]=t.PERIODS["4 Weekly"])}))}var l=(n.partner||{}).income;if(void 0!==l){var u=r.partner.income;a.forEach((function(e){var n="".concat(e,"Period");l[n]===t.PERIODS.Monthly&&(u[n]=t.PERIODS["4 Weekly"])}))}return r}},26710:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.migrations=void 0;var t=r(40380);n.migrations={SG_FCA:{1:[t.m1]}}},88806:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCalculator=void 0;var t=r(50237),a=r(4896);n.getCalculator=function(e){if(void 0===e)throw new Error(t.CalculatorError.CALCULATOR_MISSING_FORMTYPECODE);if(void 0===a.calculatorLookup[e])throw new Error(t.CalculatorError.CALCULATOR_UNKNOWN_FORMTYPECODE);var n=a.calculatorLookup[e];return function(r,a,i){if(void 0===r)throw new Error(t.CalculatorError.CALCULATOR_MISSING_FORMDATA);if(void 0===a)throw new Error(t.CalculatorError.CALCULATOR_MISSING_CARETYPE);var o=["LI_CA","KR_CA"].includes(e);return n(r,o,a,i)}}},4896:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculatorLookup=void 0;var t=r(52434),a=r(86915),i=r(76634),o=r(38136),s=r(39082),l=r(97115),u=r(63662),c=r(80422),d=r(44894),p=r(60114),g=r(91403),f=r(30147),m=r(77562),v=r(70439),h=r(47630),y=r(32412),P=r(6148),C=r(34566);n.calculatorLookup={CO_FCA:t.cornwall.calculator,LI_RFCA:i.lincolnshire.calculator,LI_FCA:a.lincs.calculator,LI_CA:a.lincs.calculator,SOT_FCA:o.southampton.calculator,WF_FCA:s.wakefield.calculator,DO_FCA:l.doncaster.calculator,SG_FCA:u.southglos.calculator,WK_FCA:c.warwickshire.calculator,HA_FCA:d.halton.calculator,NO_FCA:p.nottinghamshire.calculator,CAL_FCA:g.calderdale.calculator,HAM_FCA:f.hampshire.calculator,SOM_FCA:m.somerset.calculator,WO_FCA:v.wokingham.calculator,EA_FCA:h.ealing.calculator,FCA:y.kirklees.calculator,KR_CA:y.kirklees.calculator,WOL_FCA:P.wolverhampton.calculator,PL_FCA:C.plymouth.calculator}},41401:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getConstants=n.annualRatesLookup=void 0;var t=r(50237),a=r(83745),i=r(85619),o=r(74138),s=r(14530);n.annualRatesLookup={FCA:s.annualRatesLookupRules,KR_CA:s.annualRatesLookupRules};n.getConstants=function(e,r){if(void 0===e)throw new Error(t.ConstantsError.CONSTANTS_MISSING_FORMTYPECODE);if(void 0===a.constantsLookup[e])throw new Error(t.ConstantsError.CONSTANTS_UNKNOWN_FORMTYPECODE);var s=Object.assign({},a.constantsLookup[e]);if(void 0!==n.annualRatesLookup[e]){var l=Object.assign({},n.annualRatesLookup[e]);if(void 0!==r){var u=(0,i.getRulesForEffectiveDate)(r,l);s=(0,o.setOptionsInConstants)(s,u)}}return s}},85619:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getRulesForEffectiveDate=void 0;var t=r(5416),a=r(73185),i=r(50237);n.getRulesForEffectiveDate=function(e,n){var r;if(void 0===e)r=t();else if(/\d{4}-\d{2}-\d{2}/.exec(e))r=t(e,"YYYY-MM-DD");else{if(!(/\d{2}\/\d{2}\/\d{4}/.exec(e)||[]).length)throw new Error(i.ConstantsError.CONSTANTS_INVALID_EFFECTIVEDATE);r=t(e,"DD/MM/YYYY")}if(!r.isValid())throw new Error(i.ConstantsError.CONSTANTS_INVALID_EFFECTIVEDATE);var o=a.find(n,(function(e){var n=t(e.start,"YYYY-MM-DD"),a=void 0!==e.end?t(e.end,"YYYY-MM-DD"):null;return n.isSameOrBefore(r)&&(!a||a.isSameOrAfter(r))}));if(!o)throw new Error(i.ConstantsError.CONSTANTS_UNSUPPORTED_EFFECTIVEDATE);var s=Object.assign({},o.values);return s.effectiveDate=r.format("DD/MM/YYYY"),s}},3644:function(e,n,r){var t=this&&this.__createBinding||(Object.create?function(e,n,r,t){void 0===t&&(t=r),Object.defineProperty(e,t,{enumerable:!0,get:function(){return n[r]}})}:function(e,n,r,t){void 0===t&&(t=r),e[t]=n[r]}),a=this&&this.__exportStar||function(e,n){for(var r in e)"default"===r||Object.prototype.hasOwnProperty.call(n,r)||t(n,e,r)};Object.defineProperty(n,"__esModule",{value:!0}),n.kerpCfa=void 0;var i=r(52434),o=r(86915),s=r(76634),l=r(38136),u=r(39082),c=r(97115),d=r(63662),p=r(80422),g=r(44894),f=r(60114),m=r(91403),v=r(30147),h=r(77562),y=r(70439),P=r(47630),C=r(32412),w=r(6148),I=r(34566),O=r(58600),b=r(32954),A=r(56822),T=r(24609),R=r(67871),_=r(20203),E=r(88806),D=r(41401);a(r(50237),n);var L={Helpers:T.Helpers,ObjectUtilsService:O.ObjectUtilsService,NumberUtilsService:b.NumberUtilsService,CareAssessmentService:A.CareAssessmentService};n.kerpCfa={cornwall:i.cornwall,lincs:o.lincs,lincolnshire:s.lincolnshire,southampton:l.southampton,wakefield:u.wakefield,doncaster:c.doncaster,southglos:d.southglos,warwickshire:p.warwickshire,halton:g.halton,nottinghamshire:f.nottinghamshire,calderdale:m.calderdale,hampshire:v.hampshire,somerset:h.somerset,wokingham:y.wokingham,ealing:P.ealing,kirklees:C.kirklees,wolverhampton:w.wolverhampton,plymouth:I.plymouth,common:L,migrate:R.migrate,metadata:_.metadata,getCalculator:E.getCalculator,getConstants:D.getConstants}},24609:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.Helpers=void 0;var t=r(32954),a=r(56822),i=new t.NumberUtilsService,o=function(){function e(e){void 0===e&&(e={}),this.careAssessmentService=new a.CareAssessmentService(i,e)}return e.prototype.getWeeklyAmount=function(e,n,r){var t=(e=e||{})[n];if(!t)return 0;var a={period:e[n+"Period"]};r||(r={}),a.limit=r.limit;var o=this.careAssessmentService.PERIOD[r.period];void 0!==o&&(a.period=o);var s=this.careAssessmentService.toWeeklyAmount(t,a.period);return i.isNumeric(a.limit)?Math.min(s,a.limit):s},e.prototype.getWeeklyAmountOverFiveYears=function(e,n){void 0===e&&(e={});return(e[n]||0)/260},e.prototype.sumNamedValues=function(e,n){return void 0===e&&(e={}),n.reduce((function(n,r){return n+=e[r]||0}),0)},e.prototype.sumAllValues=function(e){void 0===e&&(e={});var n=Object.keys(e);return this.sumNamedValues(e,n)},e.prototype.weeklyTotal=function(e){var n=this;return e?e.reduce((function(e,r){return e+n.careAssessmentService.toWeeklyAmount(r.amount||0,r.amountPeriod)}),0):0},e.prototype.getUpliftable=function(e,n,r){var t,a=e[n];if(void 0!==a&&void 0!==r[n]&&r[n][a])return(null===(t=r[n][a])||void 0===t?void 0:t.amount)||0;return 0},e}();n.Helpers=o},81053:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.expensesCalculationHelper=n.rollupHelper=n.rollup=n.expenseRatioHelper=n.ownershipStatusHelper=n.partnerArrangementHelper=n.expenseFieldHelper=void 0;var a=r(50237),i=r(32954),o=r(56822),s=new i.NumberUtilsService,l=new o.CareAssessmentService(s,{});n.expenseFieldHelper=function(e){var n,r,t,a,i=e.person.intro||{},o=e.person.property||{},s=e.person.income||{},u=e.person.expenses||{},c=!!i.hasPartner,d=e.partner||{},p=c&&null!==(n=d.details)&&void 0!==n?n:{},g=c&&null!==(r=d.intro)&&void 0!==r?r:{},f=c&&!0===p.sameAddress,m=!0===g.discloseFinances,v=c&&1==g.alreadyReceivingCare,h=c&&!0===p.partnerReceivesResidentialCare,y=!0===(e.peopleLivingWithYou||{}).hasOtherPeople,P=!0===o.isABoarder,C=null!==(a=((null!==(t=e.peopleLivingWithYou)&&void 0!==t?t:{}).otherPeople||[]).filter((function(e){return!(e.dateOfBirth&&l.getAge(e.dateOfBirth)<18)})).length)&&void 0!==a?a:0,w=o.numberOfPeopleOnTheContract,I=void 0===w?1:w,O=o.namedOnContract,b=void 0!==O&&O;return{hasPartner:c,partnerCohabits:f,livesWithOther:y,isABoarder:P,numberOfOtherPeople:C,numberOfPeopleOnTheContract:I,propertyOwnership:o.ownership,propertyType:o.propertyType||"",incomeFields:s,expenseFields:u,partnerAlreadyReceivingCare:v,partnerReceivesResidentialCare:h,namedOnContract:b,partnerDisclosesFinances:m}};n.partnerArrangementHelper=function(e){var n=e.hasPartner,r=e.partnerCohabits,t=e.livesWithOther;return n?r?"cohabitingPartner":"nonCohabitingPartner":t?"cohabitingWithOther":"single"};n.ownershipStatusHelper=function(e){var n;switch(e.propertyOwnership){case"ownedByYou":n="ownedByYou";break;case"ownedJointly":case"ownedJointlyWithPartner":n="ownedJointly";break;case"ownedByPartner":n="ownedByPartner";break;case"ownedByOther":n="ownedByOther";break;default:n="tenant"}return n};n.expenseRatioHelper=function(e,n,r,t){return((n[e]||{})[r]||{})[t]||{}};n.rollup=function(e,n){return{expensesTotal:Object.keys(n).reduce((function(e,r){return n[r]+e}),0)}};n.rollupHelper=function(e,r,t,a){var i=r[e]||{};if("function"==typeof i)return i;var o=i[t]||{};if("function"==typeof o)return o;var s=o[a];return"function"==typeof s?s:n.rollup};n.expensesCalculationHelper=function(e,n,r){var i=e.hasPartner,o=e.expenseFields,s=e.partnerCohabits,l=e.numberOfOtherPeople,u=e.numberOfPeopleOnTheContract,c=e.propertyType,d=e.incomeFields,p=e.partnerAlreadyReceivingCare,g=e.partnerReceivesResidentialCare,f=e.namedOnContract,m=e.partnerDisclosesFinances,v=Object.keys(n).reduce((function(e,v){var h,y=n[v]||[];if(y.length){var P={};"councilTax"===v&&(P.period=a.PERIODS.Annually);var C=r.getWeeklyAmount(o,v,P),w=o[v+"ShareCount"]||0,I=y.reduce((function(e,n){var r={amount:e,hasPartner:i,partnerCohabits:s,numberOfOtherPeople:l,numberOfPeopleOnTheContract:u,billSharers:w,propertyType:c,incomeFields:d,expenseFields:o,originalAmount:C,partnerAlreadyReceivingCare:p,partnerReceivesResidentialCare:g,namedOnContract:f,partnerDisclosesFinances:m};return n.call(null,r)}),C);e=t(t({},e),((h={})[v]=I,h))}return e}),{});return t({},v)}},91569:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.expensesCalculator=void 0;var t=r(24609),a=r(81053);n.expensesCalculator=function(e,n,r,i,o){var s=void 0===o?{}:o,l=s.getPartnerArrangement,u=void 0===l?a.partnerArrangementHelper:l,c=s.getOwnershipStatus,d=void 0===c?a.ownershipStatusHelper:c,p=s.getExpenseParameters,g=void 0===p?a.expenseFieldHelper:p,f=s.getExpenseRatios,m=void 0===f?a.expenseRatioHelper:f,v=s.getRollup,h=void 0===v?a.rollupHelper:v,y=s.getExpensesWorkings,P=void 0===y?a.expensesCalculationHelper:y,C=s.expensesRollupConfig,w=void 0===C?{}:C,I=new t.Helpers(e),O=g(n),b=u(O),A=d(O),T=P(O,m(r,i,b,A),I);return h(r,w,b,A)(O,T)}},20103:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.getDefaultAllowancesHelpers=void 0;n.getDefaultAllowancesHelpers=function(e,n,r){return{base:function(e){return e.amount+e.parameters.migLookup.base},dp:function(e){var n=e.amount,r=e.parameters,t=r.migLookup,a=r.disabilityLevel,i=void 0===a?"base":a,o=t.dp;return n+("dp"===i||"edp"===i?o:0)},edp:function(e){var n=e.amount,r=e.parameters,t=r.migLookup,a=r.disabilityLevel,i=void 0===a?"base":a,o=t.edp;return n+("edp"===i?o:0)},pea:function(e){return r.personalLivingAllowance.residentialRate||0},child:function(e){return e.amount+(e.parameters.dependentChildrenCount||0)*r.childPremium}}}},68879:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.sharedCalculator=void 0;var t=r(74954);n.sharedCalculator=function(e,n,r,a){var i=void 0===a?{}:a,o=i.getConfig,s=void 0===o?t.getConfig:o,l=i.getResults,u=void 0===l?t.getResults:l,c=i.getRollup;return(void 0===c?t.getRollup:c)(u(s(e,n),r),r)}},37281:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDefaultCostOfCareHelpers=void 0;var t=new(r(32954).NumberUtilsService);n.getDefaultCostOfCareHelpers=function(e,n,r){return{netContribution:function(e){e.amount;var n=e.parameters.workings,r=void 0===n?{}:n;return(r.grossIncome||0)-(r.disregardsTotal||0)-(r.expensesTotal||0)-(r.dreTotal||0)-(r.livingAllowanceTotal||0)-(r.partnerTransfer||0)},cap:function(e){var n=(r.maxContribution||{})[e],t=void 0===n?0:n;return function(e){var n=e.amount;e.parameters;return n>t&&(n=t),n}},waive:function(e){var n=(r.waiveContributionThreshold||{})[e];return function(e){var r=e.amount;e.parameters;return r<n&&(r=0),r}},fullCostContribution:function(e,n){void 0===n&&(n={});var t=(r.maxContribution||{})[e],a=void 0===t?0:t;return function(e){var r=e.amount;e.parameters;return n.fullCost?a:Math.max(r,0)}},maxContribution:function(e){return void 0===e&&(e={}),function(n){var r=n.amount;n.parameters;return e.fullCost?Number.POSITIVE_INFINITY:Math.max(r,0)}},ratio:function(e){var n=(r.maxContributionRatio||{})[e];return function(e){var r=e.amount;e.parameters;return r*=n}},round:function(e){var n=e.amount;return t.roundNearest(n)}}}},41734:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.getDefaultDisregardsHelpers=void 0;n.getDefaultDisregardsHelpers=function(e,n,r){return{aa:function(e){var n=e.amount,t=(e.parameters,r.attendanceAllowance),a=t.high,i=t.low;return n===a.amount?a.amount-i.amount:0},dla:function(e){var n=e.amount,t=(e.parameters,r.dlaCare),a=t.high,i=t.medium,o=void 0===i?{}:i;return n===a.amount?a.amount-o.amount:0},pip:function(e){var n=e.amount,t=(e.parameters,r.pipDailyLiving),a=t.high,i=t.low;return n===a.amount?a.amount-i.amount:0},ifNotReceivingExtraCare:function(e){var n=e.amount;return e.parameters.incomeFields.receivesExtraCare?0:n},boardingIncome:function(n){var r=n.amount,t=n.key,a=n.parameters,i=a.incomeFields[t];return i=e.getWeeklyAmount(a.incomeFields,t),r+(i=Math.min(i||0,20)+Math.max(0,(i||0)-20)/2)},maintenance:function(e){var n=e.amount;return!0===e.parameters.incomeFields.maintenanceIsCourtOrderOrChildRelated?n:0},disregardTransferredPension:function(e){var n=e.amount;e.parameters;return n/2},ifTransferPension:function(e){var n=e.amount;return!0===e.parameters.detailsFields.transferHalfPensionToPartner?n:0},ifPartnerNotReceivingresidentialCare:function(e){var n=e.amount;return!0===e.parameters.partnerDetailsFields.partnerReceivesResidentialCare?0:n},ifPartnerIsSpouseOrCivilPartner:function(e){var n=e.amount,r=e.parameters;return"spouse"===r.partnerStatus||"civil_partner"===r.partnerStatus?n:0},ifPartnerCohabits:function(e){var n=e.amount;return e.parameters.partnerCohabits?n:0},zeroIfOwnsProperty:function(e){var n=e.amount,r=e.parameters.propertyFields.ownership;return"ownedByYou"===r||"ownedJointly"===r?0:n}}}},1129:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDefaultDREHelpers=void 0;var t=r(56822),a=r(73378);n.getDefaultDREHelpers=function(e,n,r){var i=(0,a.getDefaultIncomeHelpers)(e,n,r).upliftable;return{oneOffExpense:function(e,n){return function(t){t.amount;var a=t.key,i=t.parameters.dreExpensesFields;n=n||((r.configuration.calculatorConfig||{}).weeksPerYear||52);var o=e*n;return(i[a]||0)/o}},periodicExpense:function(n){n.amount;var r,a=n.key,i=n.parameters.dreExpensesFields,o=null!==(r=i["".concat(a,"Period")])&&void 0!==r?r:t.PERIODS.Weekly;return e.getWeeklyAmount(i,a,{period:o})},annualExpense:function(n){n.amount;var r=n.key,a=n.parameters.dreExpensesFields;return e.getWeeklyAmount(a,r,{period:t.PERIODS.Annually})},limit:function(e){var n=e.amount,t=e.key,a=(e.parameters,(r.dreCaps||{})[t]);return a=void 0!==a?a:Number.POSITIVE_INFINITY,Math.min(n,a)},limitPerHour:function(e){return function(n){var t=n.amount,a=n.key,i=n.parameters.dreExpensesFields["".concat(a,"Hours")]||0,o=(r.dreCaps||{})[a];return o=void 0!==o?o:Number.POSITIVE_INFINITY,o*=Math.min(i,e),Math.min(t,o)}},threshold:function(e){var n=e.amount,t=e.key,a=(e.parameters,(r.dreThresholds||{})[t]||Number.POSITIVE_INFINITY);return n=n>=a?Math.max(0,n-a):0},rated:function(e){e.amount;var n=e.key;e.parameters;return(r.dreRates||{})[n]||0},afterMobility:function(e){var n=e.amount,r=e.parameters,t=i({amount:0,key:"mobilityAllowance",parameters:r});return Math.max(0,n-t)},otherDRE:function(e){var r,a=e.amount,i=e.parameters,o=(void 0===(r=i.dreExpensesFields)&&(r={}),(r.otherDRE||[]).reduce((function(e,r){var a=r.amount,i=void 0===a?0:a,o=r.amountPeriod,s=void 0===o?t.PERIODS.Weekly:o;return e+n.toWeeklyAmount(i,s)}),0));return a+o},fuel:function(e){var n,t=e.amount,a=e.parameters,i=a.propertyFields,o=a.partnerCohabits,s=a.peopleLivingWithYou,l=(s.hasOtherPeople?(s.otherPeople||[]).length:0)+(o?2:1),u=(s.hasDependentChildren?(s.dependentChildren||[]).length:0)+l,c=i.propertyType;(n=(r.heatingCosts||{}).applicant[c]||0,u>1)&&(n+=(u-1)*((r.heatingCosts||{}).eachExtraPerson[c]||0));return Math.max(t-n,0)}}}},73378:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDefaultCostOfCareHelpers=n.getDefaultPartnerTransferHelpers=n.getDefaultAllowancesHelpers=n.getDefaultDREHelpers=n.getDefaultDisregardsHelpers=n.getDefaultIncomeHelpers=void 0;var t=r(87855);Object.defineProperty(n,"getDefaultIncomeHelpers",{enumerable:!0,get:function(){return t.getDefaultIncomeHelpers}});var a=r(41734);Object.defineProperty(n,"getDefaultDisregardsHelpers",{enumerable:!0,get:function(){return a.getDefaultDisregardsHelpers}});var i=r(1129);Object.defineProperty(n,"getDefaultDREHelpers",{enumerable:!0,get:function(){return i.getDefaultDREHelpers}});var o=r(20103);Object.defineProperty(n,"getDefaultAllowancesHelpers",{enumerable:!0,get:function(){return o.getDefaultAllowancesHelpers}});var s=r(88529);Object.defineProperty(n,"getDefaultPartnerTransferHelpers",{enumerable:!0,get:function(){return s.getDefaultPartnerTransferHelpers}});var l=r(37281);Object.defineProperty(n,"getDefaultCostOfCareHelpers",{enumerable:!0,get:function(){return l.getDefaultCostOfCareHelpers}})},74954:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getRollup=n.getResults=n.getConfig=n.getPartnerParameters=n.getParameters=void 0;var a=new(r(32954).NumberUtilsService);n.getParameters=function(e,n){var r,t,a,i,o,s,l,u,c,d,p,g,f,m,v,h,y,P,C,w,I,O,b=null!==(r=e.person.income)&&void 0!==r?r:{},A=null!==(t=e.person.intro)&&void 0!==t?t:{},T=null!==(a=e.person.details)&&void 0!==a?a:{},R=null!==(i=e.person.expenses)&&void 0!==i?i:{},_=null!==(o=R.disabilityRelated)&&void 0!==o?o:{},E=null!==(l=(null!==(s=e.partner)&&void 0!==s?s:{}).income)&&void 0!==l?l:{},D=null!==(u=e.person.capital)&&void 0!==u?u:{},L=null!==(d=(null!==(c=e.partner)&&void 0!==c?c:{}).capital)&&void 0!==d?d:{},S=null!==(g=(null!==(p=e.joint)&&void 0!==p?p:{}).capital)&&void 0!==g?g:{},N=null!==(m=(null!==(f=e.thirdParty)&&void 0!==f?f:{}).capital)&&void 0!==m?m:{},k=null!==(v=e.person.property)&&void 0!==v?v:{},j=null!==(h=e.peopleLivingWithYou)&&void 0!==h?h:{},M=k.numberOfPeopleOnTheContract,x=void 0===M?1:M,F=k.namedOnContract,H=void 0!==F&&F,B=!!A.hasPartner,W=B&&A.partnerStatus||"",Y=e.partner||{},G=B&&null!==(y=Y.details)&&void 0!==y?y:{},U=B&&null!==(P=Y.intro)&&void 0!==P?P:{},V=B&&!0===G.sameAddress,Z=B&&!0===U.discloseFinances,J=e.person.details.dob||"";return{fields:e,introFields:A,hasPartner:B,partnerStatus:W,partnerCohabits:V,partnerDisclosesFinances:Z,incomeFields:b,detailsFields:T,partnerDetailsFields:G,partnerIncomeFields:E,partnerIntroFields:U,capitalFields:D,partnerCapitalFields:L,jointCapitalFields:S,thirdPartyCapitalFields:N,propertyFields:k,peopleLivingWithYou:j,expensesFields:R,dreExpensesFields:_,workings:n,suDOB:J,partnerDOB:(null!==(w=(null!==(C=e.partner)&&void 0!==C?C:{}).details)&&void 0!==w?w:{}).dob||"",dob:J,disposedAssets:null!==(O=(null!==(I=e.deprivationOfAssets)&&void 0!==I?I:{}).disposedAssets)&&void 0!==O?O:{},dependentChildrenCount:(j.dependentChildren||[]).length,dependentChildren:j.dependentChildren||[],numberOfPeopleOnTheContract:x,namedOnContract:H,isPartner:!1}};n.getPartnerParameters=function(e,r){var a=(0,n.getParameters)(e,r);return t(t({},a),{incomeFields:a.partnerIncomeFields,partnerIncomeFields:a.incomeFields,introFields:a.partnerIntroFields,partnerIntroFields:a.introFields,capitalFields:a.partnerCapitalFields,partnerCapitalFields:a.capitalFields,dob:a.partnerDOB,isPartner:!0})};n.getConfig=function(e,n){var r,a=t({},null!==(r=n.default)&&void 0!==r?r:{}),i=n[e];return Object.assign({},a,i)};var i=function(e,n){return function(r,t){if(Array.isArray(t))return r+t.reduce(i(e,n),0);var a={amount:r,key:e,parameters:n};return t.call(null,a)}},o=function(e,n){return Object.keys(e).reduce((function(r,a){var s,l,u,c=e[a];return Array.isArray(c)?t(t({},r),((s={})[a]=c.reduce(i(a,n),0),s)):t(t({},r),((l={})[a]=t({},null!==(u=o(c,n))&&void 0!==u?u:{}),l))}),{})};n.getResults=function(e,n){return o(e,n)};var s=function(e){return"number"==typeof e?e:Object.keys(e).reduce((function(n,r){var t=e[r]||0;return"number"==typeof t?n+t:n+s(t)}),0)};n.getRollup=function(e){for(var n=Object.keys(e).reduce((function(n,r){var a,i;return t(t({},n),((a={})[r]=s(null!==(i=e[r])&&void 0!==i?i:0),a))}),{}),r=0,i=Object.keys(n);r<i.length;r++){var o=i[r],l=n[o];a.isNumeric(l)||delete n[o]}return n}},87855:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDefaultIncomeHelpers=void 0;var t=r(56822);n.getDefaultIncomeHelpers=function(e,n,r){var a=function(e){return void 0!==e.relationshipType&&"other"!==e.relationshipType},i=function(n,r){var a,i=null!==(a=r["".concat(n,"Period")])&&void 0!==a?a:t.PERIODS.Weekly;return e.getWeeklyAmount(r,n,{period:i})},o=function(n,r){return e.weeklyTotal(r[n])},s=function(e){return void 0===e&&(e={}),(e.otherBenefit||[]).reduce((function(e,r){var a=r.otherBenefitAmount,i=r.otherBenefitPeriod,o=void 0===i?t.PERIODS.Weekly:i;return e+n.toWeeklyAmount(a,o)}),0)},l=function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.propertyFields.ownership;return n+(t+="ownedByYou"===i?a:"ownedJointly"===i||"ownedJointlyWithPartner"===i?a/2:0)};return{zero:function(e){e.amount;return 0},simpleIncome:i,full:function(e){var n=e.amount,r=e.key,t=e.parameters;return n+i(r,t.incomeFields)},fullPartner:function(e){var n=e.amount,r=e.key,t=e.parameters;return n+i(r,t.partnerIncomeFields)},jointPartner:function(e){var n=e.amount,r=e.key,t=e.parameters,a=r,o="".concat(a,"IsJoint"),s=!0===t.partnerIncomeFields[o],l=i(a,t.partnerIncomeFields);return n+(s?l/2:0)},individual:function(e){var n=e.amount,r=e.key,t=e.parameters,a=r,o="".concat(a,"IsJoint"),s=!0===t.incomeFields[o],l=i(a,t.incomeFields);return n+(l=s?l/2:l)},ratio:function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},cap:function(e){return void 0===e&&(e=Number.POSITIVE_INFINITY),function(n){var r=n.amount;return Math.min(e,r)}},joint:function(e){var n=e.amount,r=e.key,t=e.parameters,a=t.incomeFields,o=t.partnerIncomeFields,s="".concat(r,"IsJoint"),l=!0===a[s],u=i(r,a);u=l?u/2:u,l=!0===o[s];var c=i(r,o);return n+(u+(c=l?c/2:0))},jointOnly:function(e){var n=e.amount,r=e.key,t=e.parameters,a=r,o="".concat(a,"IsJoint"),s=!0===t.incomeFields[o],l=i(a,t.incomeFields);l=s?l/2:0,s=!0===t.partnerIncomeFields[o];var u=i(a,t.partnerIncomeFields);return n+(l+(u=s?u/2:0))},ucBreakdown:function(e){var r=e.amount,a=e.key,i=e.parameters,o=a,s=(i.incomeFields.universalCreditBreakdown||{})[o]||0,l=!0===i.incomeFields.universalCreditIsJoint;s=l?s/2:s;var u=(i.partnerIncomeFields.universalCreditBreakdown||{})[o]||0;return u=(l=!0===i.partnerIncomeFields.universalCreditIsJoint)?u/2:0,r+n.toWeeklyAmount(s+u,t.PERIODS.Monthly)},ucRollup:function(e){return void 0===e&&(e=[]),function(r){var a=r.amount,i=r.parameters,o=Object.keys(i.incomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var t=(i.incomeFields.universalCreditBreakdown||{})[r]||0;return n+(!0===i.incomeFields.universalCreditIsJoint?t/2:t)}),0),s=Object.keys(i.partnerIncomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var t=(i.partnerIncomeFields.universalCreditBreakdown||{})[r]||0;return n+(!0===i.partnerIncomeFields.universalCreditIsJoint?t/2:0)}),0);return a+n.toWeeklyAmount(o+s,t.PERIODS.Monthly)}},partnerUcRollup:function(e){return void 0===e&&(e=[]),function(r){var a=r.amount,i=r.parameters,o=Object.keys(i.partnerIncomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var t=(i.partnerIncomeFields.universalCreditBreakdown||{})[r]||0;return n+(!0===i.partnerIncomeFields.universalCreditIsJoint?t/2:t)}),0),s=Object.keys(i.incomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var t=(i.incomeFields.universalCreditBreakdown||{})[r]||0;return n+(!0===i.incomeFields.universalCreditIsJoint?t/2:0)}),0);return a+n.toWeeklyAmount(s+o,t.PERIODS.Monthly)}},ucDeductionRollup:function(e){return void 0===e&&(e=[]),function(r){var a=r.amount,i=r.parameters,o=Object.keys(i.incomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var t=(i.incomeFields.universalCreditBreakdown||{})[r]||0;return n+(!0===i.incomeFields.universalCreditIsJoint?t/2:t)}),0),s=Object.keys(i.partnerIncomeFields.universalCreditBreakdown||{}).reduce((function(n,r){if(!e.includes(r))return n;var t=(i.partnerIncomeFields.universalCreditBreakdown||{})[r]||0;return n+(!0===i.partnerIncomeFields.universalCreditIsJoint?t/2:0)}),0);return a-n.toWeeklyAmount(o+s,t.PERIODS.Monthly)}},fullUniversalCredit:function(e){var r=e.amount,a=e.parameters.incomeFields.universalCreditBreakdown||{},i=Object.keys(a).reduce((function(e,n){return e+(a[n]||0)}),0);return r+(i=n.toWeeklyAmount(i,t.PERIODS.Monthly))},wages:function(n){var r=n.amount,t=n.parameters.incomeFields;return r+e.weeklyTotal(t.wages)},partnerWages:function(n){var r=n.amount,t=n.parameters;return r+e.weeklyTotal(t.partnerIncomeFields.wages)},pensions:function(e){var n=e.amount,r=e.parameters;return n+o("privatePensions",r.incomeFields)},annuities:function(e){var n=e.amount,r=e.parameters;return n+o("annuities",r.incomeFields)},occupationalPensions:function(e){var n=e.amount,r=e.parameters;return n+o("occupationalPensions",r.incomeFields)},partnerStatePension:function(n){var r=n.amount,t=n.key,a=n.parameters;return r+e.getWeeklyAmount(a.partnerIncomeFields,t)},partnerPensions:function(e){var n=e.amount,r=e.parameters;return n+o("privatePensions",r.partnerIncomeFields)},partnerAnnuities:function(e){var n=e.amount,r=e.parameters;return n+o("annuities",r.partnerIncomeFields)},partnerOccupationalPensions:function(e){var n=e.amount,r=e.parameters;return n+o("occupationalPensions",r.partnerIncomeFields)},transferPensionToPartner:function(e){var n=e.amount;return e.parameters.partnerCohabits?n/2:n},transferPensionToPartnerIfSelected:function(e){var n=e.amount;return e.parameters.detailsFields.transferHalfPensionToPartner?n/2:n},transferredPensionForPartner:function(e){var n=e.amount;return e.parameters.partnerCohabits?n/2:0},ifTransferPension:function(e){var n=e.amount;return!0===e.parameters.detailsFields.transferHalfPensionToPartner?n:0},ifPartnerIsSpouseOrCivilPartner:function(e){var n=e.amount,r=e.parameters;return"spouse"===r.partnerStatus||"civil_partner"===r.partnerStatus?n:0},otherBenefit:function(e){var n=e.amount,r=e.parameters;return n+s(r.incomeFields)},partnerOtherBenefit:function(e){var n=e.amount,r=e.parameters;return n+s(r.partnerIncomeFields)},getOtherBenefits:s,upliftable:function(e){var n=e.amount,t=e.key,a=e.parameters.incomeFields[t],i=r[t][a],o=0;return void 0!==i&&(o=i.amount||0),n+o},additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){var r=n.value||0;return n.isJointlyOwned&&(r/=2),r+e}),0)},savings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.capitalFields.savingsInvestments||[]).reduce((function(e,n){return e+n.amount}),0),t+=(r.thirdPartyCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+n.amount}),0),n+(t+=(r.jointCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+n.amount/2}),0))},partnerSavings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.partnerCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+n.amount}),0),n+(t+=(r.jointCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+n.amount/2}),0))},shareHoldings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.capitalFields.shareholdings||[]).reduce((function(e,n){return e+(n.totalValue||0)}),0),t+=(r.thirdPartyCapitalFields.shareholdings||[]).reduce((function(e,n){return e+(n.totalValue||0)}),0),(t+=(r.jointCapitalFields.shareholdings||[]).reduce((function(e,n){return e+(n.totalValue||0)/2}),0))+n},partnerShareHoldings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.partnerCapitalFields.shareholdings||[]).reduce((function(e,n){return e+(n.totalValue||0)}),0),(t+=(r.jointCapitalFields.shareholdings||[]).reduce((function(e,n){return e+(n.totalValue||0)/2}),0))+n},tariff:function(e,n){return function(r){var t=r.amount;return Math.max(0,Math.ceil((t-e)/n))}},primaryPropertyEquity:l,partnerPrimaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.propertyFields.ownership;return n+(t+="ownedByPartner"===i?a:"ownedJointly"===i?a/2:0)},partnerAdditionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){var r=n.value||0;return n.isJointlyOwned&&(e+=r/2),e}),0)},ifLivesAlone:function(e){var n=e.amount,r=e.parameters,t=r.partnerCohabits,a=r.dependentChildrenCount,i=r.peopleLivingWithYou;return 1===a+((i.hasOtherPeople?(i.otherPeople||[]).length:0)+(t?2:1))?n:0},ifNoProtectedCohabitants:function(e){var n=e.amount,r=e.parameters,t=function(e){if(null==e)return 0;var n=e.dependentChildren,r=e.otherPeople,t=0;return t+=(null!=r?r:[]).filter(a).length,t+(null!=n?n:[]).length}(r.peopleLivingWithYou);return t+=r.partnerCohabits?1:0,(t+="yes"===r.propertyFields.partnerLivesInHome?1:0)>0?0:n},ifHasEquity:function(e){var n=e.amount,r=e.parameters;return l({amount:0,parameters:r})>0?n:0},ifHasNoEquity:function(e){var n=e.amount,r=e.parameters;return 0===l({amount:0,parameters:r})?n:0},zeroIfExceedsCapitalThreshold:function(e){return function(n){var t=n.amount;return t>r.fullCostCapitalLimit[e]?0:t}},minZero:function(e){var n=e.amount;return Math.max(n,0)}}}},88529:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.getDefaultPartnerTransferHelpers=void 0;n.getDefaultPartnerTransferHelpers=function(e,n,r){return{partnerTransfer:function(e){var n=e.amount;e.parameters;return n},jointIncome:function(e){e.amount;var n=e.parameters.workings,r=void 0===n?{}:n;return(r.grossIncome||0)+(r.partnerGrossIncome||0)},jointDisregards:function(e){e.amount;var n=e.parameters.workings,r=void 0===n?{}:n;return(r.disregardsTotal||0)+(r.partnerDisregardsTotal||0)},partnerNetIncome:function(e){e.amount;var n=e.parameters.workings,r=void 0===n?{}:n;return(r.partnerGrossIncome||0)-(r.partnerDisregardsTotal||0)}}}},19666:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.runProcessors=n.getDefaultProcessors=void 0;var a=r(32954),i=r(56822);n.getDefaultProcessors=function(e){var n=e.configuration,r=new a.NumberUtilsService,o=new i.CareAssessmentService(r,n),s=function(e){var n=e.attendanceAllowance,r=e.dlaCare,t=e.pipDailyLiving;return n&&"none"!==n||r&&"none"!==r||t&&"none"!==t?"high"===n||"high"===r||"high"===t?"edp":"dp":"base"},l=function(n){var r=e.overridePensionAge;return o.getAgeLevel(n,e.levels,r,e.configuration.effectiveDate).level},u=function(e){var n;switch(e){case"low":default:n="under25";break;case"medium":n="over25";break;case"high":n="pensionAge"}return n};return{getIncomeBasedDisabilityLevel:s,getAgeLevel:l,getAgeLevelKey:u,getDisabilityLevelProcessor:function(e){var n=e.incomeFields;return t(t({},e),{disabilityLevel:s(n)})},getAgeLevelProcessor:function(e){var n=e.suDOB,r=l(n),a=u(r);return t(t({},e),{ageLevel:a})},getAllowanceTypeProcessor:function(e){var n=e.hasPartner,r=e.dependentChildrenCount,a=n?"coupleServiceUser":r>0?"loneParentUser":"singleServiceUser";return t(t({},e),{allowanceType:a})},getMIGLookupProcessor:function(n){var r=n.allowanceType,a=n.ageLevel,i=void 0===a?"under25":a;if(void 0===e.livingAllowancesMap)return n;var o=e.livingAllowancesMap[r];if(void 0===o)return n;var s=o[i];return t(t({},n),{migLookup:s})},getCarerPremiumRateLookupProcessor:function(n){var r=n.allowanceType,a=n.ageLevel,i=void 0===a?"under25":a,o=e.carerPremiumRatesMap[r][i];return t(t({},n),{carerPremiumRatesLookup:o})}}},n.runProcessors=function(e,r,t){void 0===t&&(t={});var a=(0,n.getDefaultProcessors)(r),i={getDisabilityLevelProcessor:a.getDisabilityLevelProcessor,getAgeLevelProcessor:a.getAgeLevelProcessor,getAllowanceTypeProcessor:a.getAllowanceTypeProcessor,getMIGLookupProcessor:a.getMIGLookupProcessor};return Object.keys(i).map((function(e){return t[e]||i[e]})).concat(t.additionalProcessors||[]).reduce((function(e,n){return n(e)}),e)}},56822:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.CareAssessmentService=n.PERIODS=void 0;var t,a=r(73185),i=r(5416);!function(e){e.Weekly="Weekly",e.Fortnightly="Fortnightly",e["4 Weekly"]="4 Weekly",e["6 Weekly"]="6 Weekly",e.Monthly="Monthly",e.Quarterly="Quarterly",e["6 Monthly"]="6 Monthly",e.Annually="Annually"}(t=n.PERIODS||(n.PERIODS={}));var o=function(){function e(e,n){this.numberUtils=e,this.pensionRules=[{start:"1901-01-01",end:"1950-04-05",age:60},{start:"1950-04-06",end:"1950-05-05",age:60.08},{start:"1950-05-06",end:"1950-06-05",age:60.17},{start:"1950-06-06",end:"1950-07-05",age:60.25},{start:"1950-07-06",end:"1950-08-05",age:60.34},{start:"1950-08-06",end:"1950-09-05",age:60.42},{start:"1950-09-06",end:"1950-10-05",age:60.5},{start:"1950-10-06",end:"1950-11-05",age:60.58},{start:"1950-11-06",end:"1950-12-05",age:60.66},{start:"1950-12-06",end:"1951-01-05",age:60.75},{start:"1951-01-06",end:"1951-02-05",age:60.83},{start:"1951-02-06",end:"1951-03-05",age:60.91},{start:"1951-03-06",end:"1951-04-05",age:61},{start:"1951-04-06",end:"1951-05-05",age:61.08},{start:"1951-05-06",end:"1951-06-05",age:61.17},{start:"1951-06-06",end:"1951-07-05",age:61.25},{start:"1951-07-06",end:"1951-08-05",age:61.34},{start:"1951-08-06",end:"1951-09-05",age:61.42},{start:"1951-09-06",end:"1951-10-05",age:61.5},{start:"1951-10-06",end:"1951-11-05",age:61.58},{start:"1951-11-06",end:"1951-12-05",age:61.66},{start:"1951-12-06",end:"1952-01-05",age:61.75},{start:"1952-01-06",end:"1952-02-05",age:61.83},{start:"1952-02-06",end:"1952-03-05",age:61.92},{start:"1952-03-06",end:"1952-04-05",age:62},{start:"1952-04-06",end:"1952-05-05",age:62.08},{start:"1952-05-06",end:"1952-06-05",age:62.17},{start:"1952-06-06",end:"1952-07-05",age:62.25},{start:"1952-07-06",end:"1952-08-05",age:62.34},{start:"1952-08-06",end:"1952-09-05",age:62.42},{start:"1952-09-06",end:"1952-10-05",age:62.49},{start:"1952-10-06",end:"1952-11-05",age:62.58},{start:"1952-11-06",end:"1952-12-05",age:62.66},{start:"1952-12-06",end:"1953-01-05",age:62.75},{start:"1953-01-06",end:"1953-02-05",age:62.83},{start:"1953-02-06",end:"1953-03-05",age:62.91},{start:"1953-03-06",end:"1953-04-05",age:63},{start:"1953-04-06",end:"1953-05-05",age:63.25},{start:"1953-05-06",end:"1953-06-05",age:63.5},{start:"1953-06-06",end:"1953-07-05",age:63.75},{start:"1953-07-06",end:"1953-08-05",age:64},{start:"1953-08-06",end:"1953-09-05",age:64.25},{start:"1953-09-06",end:"1953-10-05",age:64.5},{start:"1953-10-06",end:"1953-11-05",age:64.75},{start:"1953-11-06",end:"1953-12-05",age:65},{start:"1953-12-06",end:"1954-01-05",age:65.25},{start:"1954-01-06",end:"1954-02-05",age:65.33},{start:"1954-02-06",end:"1954-03-05",age:65.41},{start:"1954-03-06",end:"1954-04-05",age:65.5},{start:"1954-04-06",end:"1954-05-05",age:65.59},{start:"1954-05-06",end:"1954-06-05",age:65.67},{start:"1954-06-06",end:"1954-07-05",age:65.75},{start:"1954-07-06",end:"1954-08-05",age:65.83},{start:"1954-08-06",end:"1954-09-05",age:65.92},{start:"1954-09-06",end:"1960-04-05",age:66},{start:"1960-04-06",end:"1960-05-05",age:66.08},{start:"1960-05-06",end:"1960-06-05",age:66.17},{start:"1960-06-06",end:"1960-07-05",age:66.25},{start:"1960-07-06",end:"1960-08-05",age:66.34},{start:"1960-08-06",end:"1960-09-05",age:66.42},{start:"1960-09-06",end:"1960-10-05",age:66.5},{start:"1960-10-06",end:"1960-11-05",age:66.58},{start:"1960-11-06",end:"1960-12-05",age:66.66},{start:"1960-12-06",end:"1961-01-05",age:66.75},{start:"1961-01-06",end:"1961-02-05",age:66.83},{start:"1961-02-06",end:"1961-03-05",age:66.91},{start:"1961-03-06",end:"1977-04-05",age:67},{start:"1977-04-06",end:"1977-05-05",age:67.08},{start:"1977-05-06",end:"1977-06-05",age:67.17},{start:"1977-06-06",end:"1977-07-05",age:67.25},{start:"1977-07-06",end:"1977-08-05",age:67.34},{start:"1977-08-06",end:"1977-09-05",age:67.42},{start:"1977-09-06",end:"1977-10-05",age:67.5},{start:"1977-10-06",end:"1977-11-05",age:67.58},{start:"1977-11-06",end:"1977-12-05",age:67.66},{start:"1977-12-06",end:"1978-01-05",age:67.75},{start:"1978-01-06",end:"1978-02-05",age:67.83},{start:"1978-02-06",end:"1978-03-05",age:67.92},{start:"1978-03-06",end:"1978-04-05",age:68},{start:"1978-04-06",end:null,age:68}];var r=(n.calculatorConfig||{}).weeksPerYear||365/7,a={Weekly:t.Weekly,Fortnightly:t.Fortnightly,"4 Weekly":t["4 Weekly"],"6 Weekly":t["6 Weekly"],Monthly:t.Monthly,Quarterly:t.Quarterly,"6 Monthly":t["6 Monthly"],Annually:t.Annually};this.PERIOD=Object.freeze(a),this.weeklyConversionFactors={},this.weeklyConversionFactors[a.Weekly]=1,this.weeklyConversionFactors[a.Fortnightly]=.5,this.weeklyConversionFactors[a["4 Weekly"]]=1/4,this.weeklyConversionFactors[a["6 Weekly"]]=1/6,this.weeklyConversionFactors[a.Monthly]=12/r,this.weeklyConversionFactors[a.Quarterly]=4/r,this.weeklyConversionFactors[a["6 Monthly"]]=2/r,this.weeklyConversionFactors[a.Annually]=1/r,Object.freeze(this.weeklyConversionFactors)}return e.prototype.toWeeklyAmount=function(e,n){var r;return this.numberUtils.isNumeric(e)?(n=null!==(r=this.PERIOD[n])&&void 0!==r?r:this.PERIOD.Weekly,e*this.weeklyConversionFactors[n]):0},e.prototype.getAge=function(e){var n=i(e,"DD/MM/YYYY");return i().diff(n,"years")},e.prototype.getPensionAgeFromRules=function(e){var n=a.find(this.pensionRules,(function(n){var r=i(n.start,"YYYY-MM-DD"),t=n.end?i(n.end,"YYYY-MM-DD"):null;return r.isSameOrBefore(e)&&(!t||t.isSameOrAfter(e))}));if(!n)throw new Error("Failed to find pension age for person born in "+e);return n},e.prototype.getAgeLevel=function(e,n,r,t){if(void 0===e)throw new TypeError("Cannot calculate ageLevel with no date of birth");var a=i(e,"DD/MM/YYYY");t=null!=t?t:i().format("DD/MM/YYYY");var o=i(t,"DD/MM/YYYY").diff(a,"years",!0),s=this.getPensionAgeFromRules(a),l=r||s.age;if(18<=o&&o<25)return{level:n.low,label:"18 - 24"};if(25<=o&&o<l)return{level:n.medium,label:"25 - Pension Age"};if(o>=l)return{level:n.high,label:"Pension Age"};throw new Error("Failed to determine age level for person aged "+o)},e.prototype.getPensionAgeDate=function(e,n){if(void 0===e)throw new TypeError("Cannot calculate ageLevel with no date of birth");var r=i(e,"DD/MM/YYYY"),t=this.getPensionAgeFromRules(r),a=n||t.age;return r.add(a,"y").format("DD/MM/YYYY")},e.prototype.findPensionRuleForPensionAgeDate=function(e){return a.find(this.pensionRules,(function(n){var r=i(n.start,"YYYY-MM-DD"),t=n.end?i(n.end,"YYYY-MM-DD"):null,a=i(e,"DD/MM/YYYY").subtract(n.age,"years");return r.isSameOrBefore(a)&&(!t||t.isSameOrAfter(a))}))},e}();n.CareAssessmentService=o},94321:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.ConstantsError=n.CalculatorError=void 0,function(e){e.CALCULATOR_MISSING_FORMTYPECODE="CALCULATOR_MISSING_FORMTYPECODE",e.CALCULATOR_UNKNOWN_FORMTYPECODE="CALCULATOR_UNKNOWN_FORMTYPECODE",e.CALCULATOR_MISSING_FORMDATA="CALCULATOR_MISSING_FORMDATA",e.CALCULATOR_MISSING_CARETYPE="CALCULATOR_MISSING_CARETYPE"}(n.CalculatorError||(n.CalculatorError={})),function(e){e.CONSTANTS_MISSING_FORMTYPECODE="CONSTANTS_MISSING_FORMTYPECODE",e.CONSTANTS_UNKNOWN_FORMTYPECODE="CONSTANTS_UNKNOWN_FORMTYPECODE",e.CONSTANTS_INVALID_EFFECTIVEDATE="CONSTANTS_INVALID_EFFECTIVEDATE",e.CONSTANTS_UNSUPPORTED_EFFECTIVEDATE="CONSTANTS_UNSUPPORTED_EFFECTIVEDATE"}(n.ConstantsError||(n.ConstantsError={}))},22124:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.ChildOffsets=n.Levels=void 0,function(e){e.low="low",e.medium="medium",e.high="high"}(n.Levels||(n.Levels={})),function(e){e.standard="standard",e.disabled="disabled",e.enhanced="enhanced"}(n.ChildOffsets||(n.ChildOffsets={}))},50237:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.OptionError=n.ConstantsError=n.CalculatorError=n.MetaDataError=n.Levels=n.PERIODS=void 0;var t=r(56822);Object.defineProperty(n,"PERIODS",{enumerable:!0,get:function(){return t.PERIODS}});var a=r(22124);Object.defineProperty(n,"Levels",{enumerable:!0,get:function(){return a.Levels}});var i=r(15436);Object.defineProperty(n,"MetaDataError",{enumerable:!0,get:function(){return i.MetaDataError}});var o=r(94321);Object.defineProperty(n,"CalculatorError",{enumerable:!0,get:function(){return o.CalculatorError}}),Object.defineProperty(n,"ConstantsError",{enumerable:!0,get:function(){return o.ConstantsError}});var s=r(48439);Object.defineProperty(n,"OptionError",{enumerable:!0,get:function(){return s.OptionError}})},15436:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.MetaDataError=void 0,function(e){e.METADATA_MISSING_FORMTYPECODE="METADATA_MISSING_FORMTYPECODE",e.METADATA_UNKNOWN_FORMTYPECODE="METADATA_UNKNOWN_FORMTYPECODE",e.METADATA_MISSING_FORMDATA="METADATA_MISSING_FORMDATA",e.METADATA_MISSING_EFFECTIVEDATE="METADATA_MISSING_EFFECTIVEDATE",e.METADATA_MISSING_PERSONDOB="METADATA_MISSING_PERSONDOB",e.METADATA_INVALID_PERSONDOB="METADATA_INVALID_PERSONDOB",e.METADATA_INVALID_PERSONPENSIONDATE="METADATA_INVALID_PERSONPENSIONDATE"}(n.MetaDataError||(n.MetaDataError={}))},48439:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.OptionError=void 0,function(e){e.FORMDATA_INVALID_EFFECTIVEDATE="FORMDATA_INVALID_EFFECTIVEDATE",e.FORMDATA_UNSUPPORTED_EFFECTIVEDATE="FORMDATA_UNSUPPORTED_EFFECTIVEDATE",e.OPTIONS_INVALID_EFFECTIVEDATE="OPTIONS_INVALID_EFFECTIVEDATE",e.OPTIONS_UNSUPPORTED_EFFECTIVEDATE="OPTIONS_UNSUPPORTED_EFFECTIVEDATE",e.OPTIONS_EMPTY_MAXCONTRIBUTION="OPTIONS_EMPTY_MAXCONTRIBUTION",e.OPTIONS_INVALID_MAXCONTRIBUTION="OPTIONS_INVALID_MAXCONTRIBUTION",e.OPTIONS_UNKNOWN_MAXCONTRIBUTION="OPTIONS_UNKNOWN_MAXCONTRIBUTION",e.OPTIONS_EMPTY_EXPENSESALLOWANCES="OPTIONS_EMPTY_EXPENSESALLOWANCES",e.OPTIONS_INVALID_EXPENSESALLOWANCES="OPTIONS_INVALID_EXPENSESALLOWANCES",e.OPTIONS_EMPTY_DISABILITYBASEDDREALLOWANCE="OPTIONS_EMPTY_DISABILITYBASEDDREALLOWANCE",e.OPTIONS_INVALID_DISABILITYBASEDDREALLOWANCE="OPTIONS_INVALID_DISABILITYBASEDDREALLOWANCE",e.OPTIONS_EMPTY_WAIVECONTRIBUTIONTHRESHOLD="OPTIONS_EMPTY_WAIVECONTRIBUTIONTHRESHOLD",e.OPTIONS_INVALID_WAIVECONTRIBUTIONTHRESHOLD="OPTIONS_INVALID_WAIVECONTRIBUTIONTHRESHOLD",e.OPTIONS_UNKNOWN_WAIVECONTRIBUTIONTHRESHOLD="OPTIONS_UNKNOWN_WAIVECONTRIBUTIONTHRESHOLD",e.OPTIONS_EMPTY_MAXCONTRIBUTIONRATIO="OPTIONS_EMPTY_MAXCONTRIBUTIONRATIO",e.OPTIONS_INVALID_MAXCONTRIBUTIONRATIO="OPTIONS_INVALID_MAXCONTRIBUTIONRATIO",e.OPTIONS_UNKNOWN_MAXCONTRIBUTIONRATIO="OPTIONS_UNKNOWN_MAXCONTRIBUTIONRATIO",e.OPTIONS_INVALID_WARPENSIONDISREGARD="OPTIONS_INVALID_WARPENSIONDISREGARD",e.OPTIONS_INVALID_WARWIDOWSPENSIONDISREGARD="OPTIONS_INVALID_WARWIDOWSPENSIONDISREGARD",e.OPTIONS_INVALID_WARSPECIALPAYMENTDISREGARD="OPTIONS_INVALID_WARSPECIALPAYMENTDISREGARD",e.OPTIONS_INVALID_RENTALINCOMEDISREGARD="OPTIONS_INVALID_RENTALINCOMEDISREGARD",e.OPTIONS_INVALID_MAXDREALLOWANCE="OPTIONS_INVALID_MAXDREALLOWANCE",e.OPTIONS_INVALID_HOUSINGALLOWANCE="OPTIONS_INVALID_HOUSINGALLOWANCE",e.OPTIONS_INVALID_LANDLINETELEPHONEALLOWANCE="OPTIONS_INVALID_LANDLINETELEPHONEALLOWANCE",e.OPTIONS_INVALID_WATERCOSTSPERCOHABITANT="OPTIONS_INVALID_WATERCOSTSPERCOHABITANT",e.OPTIONS_EMPTY_WATERCOSTSPERCOHABITANT="OPTIONS_EMPTY_WATERCOSTSPERCOHABITANT",e.OPTIONS_INVALID_WASHINGEXCESSPREMIUM="OPTIONS_INVALID_WASHINGEXCESSPREMIUM",e.OPTIONS_EMPTY_WASHINGEXCESSPREMIUMLEVELS="OPTIONS_EMPTY_WASHINGEXCESSPREMIUMLEVELS",e.OPTIONS_INVALID_WASHINGEXCESSPREMIUMLEVELS="OPTIONS_INVALID_WASHINGEXCESSPREMIUMLEVELS",e.OPTIONS_INVALID_CARERSMEALALLOWANCE="OPTIONS_INVALID_CARERSMEALALLOWANCE",e.OPTIONS_INVALID_WASHINGALLOWANCE="OPTIONS_INVALID_WASHINGALLOWANCE",e.OPTIONS_EMPTY_ADDITIONALBEDDINGLEVELS="OPTIONS_EMPTY_ADDITIONALBEDDINGLEVELS",e.OPTIONS_INVALID_ADDITIONALBEDDINGLEVELS="OPTIONS_INVALID_ADDITIONALBEDDINGLEVELS",e.OPTIONS_MISSING_DISABILITYBENEFITS="OPTIONS_INVALID_DISABILITYBENEFITS",e.OPTIONS_INVALID_DISABILITYBENEFITS="OPTIONS_INVALID_DISABILITYBENEFITS",e.OPTIONS_MISSING_ATTENDANCEALLOWANCE="OPTIONS_INVALID_ATTENDANCEALLOWANCE",e.OPTIONS_INVALID_ATTENDANCEALLOWANCE="OPTIONS_INVALID_ATTENDANCEALLOWANCE",e.OPTIONS_MISSING_PIPDAILYLIVING="OPTIONS_INVALID_PIPDAILYLIVING",e.OPTIONS_INVALID_PIPDAILYLIVING="OPTIONS_INVALID_PIPDAILYLIVING",e.OPTIONS_MISSING_DLACARE="OPTIONS_INVALID_DLACARE",e.OPTIONS_INVALID_DLACARE="OPTIONS_INVALID_DLACARE",e.OPTIONS_MISSING_MOBILITYALLOWANCE="OPTIONS_INVALID_MOBILITYALLOWANCE",e.OPTIONS_INVALID_MOBILITYALLOWANCE="OPTIONS_INVALID_MOBILITYALLOWANCE",e.OPTIONS_MISSING_PIPMOBILITYALLOWANCE="OPTIONS_INVALID_PIPMOBILITYALLOWANCE",e.OPTIONS_INVALID_PIPMOBILITYALLOWANCE="OPTIONS_INVALID_PIPMOBILITYALLOWANCE",e.OPTIONS_MISSING_DLAMOBILITYALLOWANCE="OPTIONS_INVALID_DLAMOBILITYALLOWANCE",e.OPTIONS_INVALID_DLAMOBILITYALLOWANCE="OPTIONS_INVALID_DLAMOBILITYALLOWANCE",e.OPTIONS_MISSING_CONSTANTATTENDANCEALLOWANCE="OPTIONS_INVALID_CONSTANTATTENDANCEALLOWANCE",e.OPTIONS_INVALID_CONSTANTATTENDANCEALLOWANCE="OPTIONS_INVALID_CONSTANTATTENDANCEALLOWANCE",e.OPTIONS_EMPTY_FULLCOSTCAPITALLIMIT="OPTIONS_EMPTY_FULLCOSTCAPITALLIMIT",e.OPTIONS_INVALID_FULLCOSTCAPITALLIMIT="OPTIONS_INVALID_FULLCOSTCAPITALLIMIT",e.OPTIONS_MISSING_FULLCOSTCAPITALLIMIT="OPTIONS_MISSING_FULLCOSTCAPITALLIMIT",e.OPTIONS_UNKNOWN_FULLCOSTCAPITALLIMIT="OPTIONS_UNKNOWN_FULLCOSTCAPITALLIMIT",e.OPTIONS_EMPTY_CAPITALTARIFF="OPTIONS_EMPTY_CAPITALTARIFF",e.OPTIONS_INVALID_CAPITALTARIFF="OPTIONS_INVALID_CAPITALTARIFF",e.OPTIONS_MISSING_CAPITALTARIFF="OPTIONS_MISSING_CAPITALTARIFF",e.OPTIONS_UNKNOWN_CAPITALTARIFF="OPTIONS_UNKNOWN_CAPITALTARIFF",e.OPTIONS_INVALID_CAPITALLIMIT="OPTIONS_INVALID_CAPITALLIMIT",e.OPTIONS_INVALID_DWPCAPITALLIMIT="OPTIONS_INVALID_DWPCAPITALLIMIT",e.OPTIONS_INVALID_DWPCAPITALTARIFF="OPTIONS_INVALID_DWPCAPITALTARIFF",e.OPTIONS_INVALID_PARTNERCAPITALLIMIT="OPTIONS_INVALID_PARTNERCAPITALLIMIT",e.OPTIONS_INVALID_PARTNERCAPITALTARIFF="OPTIONS_INVALID_PARTNERCAPITALTARIFF",e.OPTIONS_INVALID_PARTNERSEARNINGSDISREGARDED="OPTIONS_INVALID_PARTNERSEARNINGSDISREGARDED",e.OPTIONS_INVALID_JOINTCAPITALLIMIT="OPTIONS_INVALID_JOINTCAPITALLIMIT",e.OPTIONS_INVALID_JOINTCAPITALTARIFF="OPTIONS_INVALID_JOINTCAPITALTARIFF",e.OPTIONS_INVALID_CHILDPREMIUM="OPTIONS_INVALID_CHILDPREMIUM",e.OPTIONS_INVALID_CARERSPREMIUM="OPTIONS_INVALID_CARERSPREMIUM",e.OPTIONS_INVALID_SDPPREMIUM="OPTIONS_INVALID_SDPPREMIUM",e.OPTIONS_INVALID_RESIDENTIALPEA="OPTIONS_INVALID_RESIDENTIALPEA",e.OPTIONS_EMPTY_PARTNERMIGTABLE="OPTIONS_EMPTY_PARTNERMIGTABLE",e.OPTIONS_INVALID_PARTNERMIGTABLE="OPTIONS_INVALID_PARTNERMIGTABLE",e.OPTIONS_INVALID_PARTNERMIGTABLERATE="OPTIONS_INVALID_PARTNERMIGTABLERATE",e.OPTIONS_EMPTY_PERSONALLIVINGALLOWANCE="OPTIONS_EMPTY_PERSONALLIVINGALLOWANCE",e.OPTIONS_INVALID_PERSONALLIVINGALLOWANCE="OPTIONS_INVALID_PERSONALLIVINGALLOWANCE",e.OPTIONS_EMPTY_LIVINGALLOWANCEMAP="OPTIONS_EMPTY_LIVINGALLOWANCEMAP",e.OPTIONS_EMPTY_LIVINGALLOWANCEAGERATEMAP="OPTIONS_EMPTY_LIVINGALLOWANCEAGERATEMAP",e.OPTIONS_INVALID_LIVINGALLOWANCEAGERATEMAP="OPTIONS_INVALID_LIVINGALLOWANCEAGERATEMAP",e.OPTIONS_EMPTY_LIVINGALLOWANCEDISABILITYRATEMAP="OPTIONS_EMPTY_LIVINGALLOWANCEDISABILITYRATEMAP",e.OPTIONS_INVALID_LIVINGALLOWANCEDISABILITYRATEMAP="OPTIONS_INVALID_LIVINGALLOWANCEDISABILITYRATEMAP",e.OPTIONS_EMPTY_CAPPEDRESPITERATES="OPTIONS_EMPTY_CAPPEDRESPITERATES",e.OPTIONS_MISSING_CAPPEDRESPITERATES="OPTIONS_MISSING_CAPPEDRESPITERATES",e.OPTIONS_INVALID_CAPPEDRESPITERATES="OPTIONS_INVALID_CAPPEDRESPITERATES",e.OPTIONS_EMPTY_CARERPREMIUMRATES="OPTIONS_EMPTY_CARERPREMIUMRATES",e.OPTIONS_INVALID_CARERPREMIUMRATES="OPTIONS_INVALID_CARERPREMIUMRATES",e.OPTIONS_EMPTY_CARERPREMIUMRATESMAP="OPTIONS_EMPTY_CARERPREMIUMRATESMAP",e.OPTIONS_EMPTY_CARERPREMIUMRATESAGERATEMAP="OPTIONS_EMPTY_CARERPREMIUMRATESAGERATEMAP",e.OPTIONS_INVALID_CARERPREMIUMRATESAGERATEMAP="OPTIONS_INVALID_CARERPREMIUMRATESAGERATEMAP",e.OPTIONS_EMPTY_CARERPREMIUMRATESDISABILITYRATEMAP="OPTIONS_EMPTY_CARERPREMIUMRATESDISABILITYRATEMAP",e.OPTIONS_INVALID_CARERPREMIUMRATESDISABILITYRATEMAP="OPTIONS_INVALID_CARERPREMIUMRATESDISABILITYRATEMAP",e.OPTIONS_EMPTY_PSCTHRESHOLDTABLE="OPTIONS_EMPTY_PSCTHRESHOLDTABLE",e.OPTIONS_EMPTY_PGCTHRESHOLDTABLE="OPTIONS_EMPTY_PGCTHRESHOLDTABLE",e.OPTIONS_INVALID_PSCTHRESHOLDTABLE="OPTIONS_INVALID_PSCTHRESHOLDTABLE",e.OPTIONS_INVALID_PGCTHRESHOLDTABLE="OPTIONS_INVALID_PGCTHRESHOLDTABLE",e.OPTIONS_EMPTY_PGCCOMPONENTS="OPTIONS_EMPTY_PGCCOMPONENTS",e.OPTIONS_INVALID_PGCCOMPONENTS="OPTIONS_INVALID_PGCCOMPONENTS",e.OPTIONS_EMPTY_TARIFFBASEDHEATINGCOSTS="OPTIONS_EMPTY_TARIFFBASEDHEATINGCOSTS",e.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTS="OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTS",e.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSTARIFFDATE="OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSTARIFFDATE",e.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSAPPLICANT="OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSAPPLICANT",e.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSEACHEXTRAPERSON="OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSEACHEXTRAPERSON",e.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSMISSINGKEY="OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSMISSINGKEY",e.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSINVALIDKEY="OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSINVALIDKEY",e.OPTIONS_INVALID_HEATINGCOSTSAPPLICANT="OPTIONS_INVALID_HEATINGCOSTSAPPLICANT",e.OPTIONS_INVALID_HEATINGCOSTSEACHEXTRAPERSON="OPTIONS_INVALID_HEATINGCOSTSEACHEXTRAPERSON",e.OPTIONS_INVALID_HEATINGCOSTSMISSINGKEY="OPTIONS_INVALID_HEATINGCOSTSMISSINGKEY",e.OPTIONS_INVALID_HEATINGCOSTSINVALIDKEY="OPTIONS_INVALID_HEATINGCOSTSINVALIDKEY",e.OPTIONS_INVALID_DRECAP="OPTIONS_INVALID_DRECAP",e.OPTIONS_INVALID_DRETHRESHOLD="OPTIONS_INVALID_DRETHRESHOLD",e.OPTIONS_INVALID_DRERATE="OPTIONS_INVALID_DRERATE",e.OPTIONS_INVALID_DRERATIO="OPTIONS_INVALID_DRERATIO",e.OPTIONS_EMPTY_APPLICABLEAMOUNTS="OPTIONS_EMPTY_APPLICABLEAMOUNTS",e.OPTIONS_EMPTY_APPLICABLEAMOUNTSKEY="OPTIONS_EMPTY_APPLICABLEAMOUNTSKEY",e.OPTIONS_EMPTY_APPLICABLEAMOUNTSAGERATEMAP="OPTIONS_EMPTY_APPLICABLEAMOUNTSRATEMAP",e.OPTIONS_INVALID_APPLICABLEAMOUNTSRATEMAP="OPTIONS_INVALID_APPLICABLEAMOUNTSRATEMAP",e.OPTIONS_EMPTY_BENEFITELEMENTS="OPTIONS_EMPTY_BENEFITELEMENTS",e.OPTIONS_INVALID_BENEFITELEMENTSKEY="OPTIONS_INVALID_BENEFITELEMENTSKEY",e.OPTIONS_EMPTY_BENEFITELEMENTSTABLE="OPTIONS_EMPTY_BENEFITELEMENTSTABLE",e.OPTIONS_MISSING_BENEFITELEMENTSTABLEKEY="OPTIONS_MISSING_BENEFITELEMENTSTABLEKEY",e.OPTIONS_INVALID_BENEFITELEMENTSTABLEKEY="OPTIONS_INVALID_BENEFITELEMENTSTABLEKEY",e.OPTIONS_INVALID_BENEFITELEMENTSTABLEITEM="OPTIONS_INVALID_BENEFITELEMENTSTABLEITEM",e.OPTIONS_EMPTY_PREMIA="OPTIONS_EMPTY_PREMIA",e.OPTIONS_INVALID_PREMIAKEY="OPTIONS_INVALID_PREMIAKEY",e.OPTIONS_INVALID_AGEADDITION="OPTIONS_INVALID_AGEADDITION",e.OPTIONS_INVALID_DWPMIG="OPTIONS_INVALID_DWPMIG",e.OPTIONS_INVALID_DWPMIGINCOMETHRESHOLD="OPTIONS_INVALID_DWPMIGINCOMETHRESHOLD",e.OPTIONS_MISSING_DWPCAPITALTHRESHOLD="OPTIONS_MISSING_DWPCAPITALTHRESHOLD",e.OPTIONS_INVALID_DWPCAPITALTHRESHOLD="OPTIONS_INVALID_DWPCAPITALTHRESHOLD"}(n.OptionError||(n.OptionError={}))},32954:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.NumberUtilsService=void 0;var r=function(){function e(){var e=this;this.roundUp=function(n){return e.roundNearest(Math.ceil(100*n)/100)},this.roundDown=function(n){return e.roundNearest(Math.floor(100*n)/100)},this.round=function(n){return e.roundNearest(n)}}return e.prototype.isNumeric=function(e){return e=""+e,!isNaN(parseFloat(e))&&isFinite(parseFloat(e))},e.prototype.roundNearest=function(e,n){return n=void 0===n?2:n,+e.toFixed(n)},e.prototype.sumPropertyValues=function(e){var n=0;for(var r in n=0,e=null!=e?e:{})Object.prototype.hasOwnProperty.call(e,r)&&this.isNumeric(e[r])&&(n+=e[r]);return n},e.prototype.numberToString=function(e,n){if(this.isNumeric(e)){e=void 0!==n?n(e):e;var r=this.roundNearest(e,2).toString(),t=r.split(".");return 2===t.length&&1===t[1].length&&(r+="0"),r}return e?""+e:""},e.prototype.sumArgs=function(){for(var e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];var r=0;return e.forEach((function(e){this.isNumeric(e)&&(r+=e)}),this),r},e}();n.NumberUtilsService=r},58600:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.ObjectUtilsService=void 0;var t=(new(r(32954).NumberUtilsService)).isNumeric,a=function(){function e(){}return e.prototype.setPropertyPath=function(e,n,r,a){var i;if(void 0===a&&(a=!0),(i="string"==typeof n?n.split("."):n).length>1){var o=i.shift(),s=i[0];this.setPropertyPath(e[o]="[object Object]"===Object.prototype.toString.call(e[o])||Array.isArray(e[o])?e[o]:t(s)?[]:{},i,r,a)}else!a&&Object.prototype.hasOwnProperty.call(e,i[0])||(e[i[0]]=r)},e.prototype.getPropertyPath=function(e,n){if(e&&n){for(var r=n.split("."),t=0;t<r.length;t++){if(void 0===(e=e[r[t]]))return;if(null===e)return null}return e}},e.prototype.deletePropertyPath=function(e,n){if(void 0!==e&&void 0!==n){var r;r="string"==typeof n?n.split("."):n;for(var t=0;t<r.length-1;t++)if(void 0===(e=e[r[t]]))return;delete e[r.pop()]}},e}();n.ObjectUtilsService=a},74138:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.applyOptions=n.setOptionsInConstants=void 0;var a=r(5416),i=r(85619),o=r(50237),s=new(r(32954).NumberUtilsService);n.setOptionsInConstants=function(e,n){var r,i,l,u,c,d,p,g,f,m,v,h,y,P,C,w,I,O,b,A,T,R;void 0===n&&(n={});var _=(e=Object.assign({},e)).careTypes;if(n.effectiveDate){var E=void 0;if(/\d{4}-\d{2}-\d{2}/.exec(n.effectiveDate))E=a(n.effectiveDate,"YYYY-MM-DD");else{if(!(/\d{2}\/\d{2}\/\d{4}/.exec(n.effectiveDate)||[]).length)throw new Error(o.OptionError.OPTIONS_INVALID_EFFECTIVEDATE);E=a(n.effectiveDate,"DD/MM/YYYY")}if(!E.isValid())throw new Error(o.OptionError.OPTIONS_INVALID_EFFECTIVEDATE);R=E.format("DD/MM/YYYY")}if(e.configuration.effectiveDate=null!=R?R:a().format("DD/MM/YYYY"),void 0!==n.maxContribution){if(e.maxContribution=null!==(r=e.maxContribution)&&void 0!==r?r:{},!(D=Object.keys(n.maxContribution)).length)throw new Error(o.OptionError.OPTIONS_EMPTY_MAXCONTRIBUTION);D.forEach((function(r){var t;if(!(r in _))throw new Error(o.OptionError.OPTIONS_UNKNOWN_MAXCONTRIBUTION);if("number"!=typeof(null!==(t=n.maxContribution)&&void 0!==t?t:{})[r])throw new Error(o.OptionError.OPTIONS_INVALID_MAXCONTRIBUTION);e.maxContribution[r]=n.maxContribution[r]}))}if(void 0!==n.waiveContributionThreshold){if(e.waiveContributionThreshold=null!==(i=e.waiveContributionThreshold)&&void 0!==i?i:{},!(D=Object.keys(n.waiveContributionThreshold)).length)throw new Error(o.OptionError.OPTIONS_EMPTY_WAIVECONTRIBUTIONTHRESHOLD);D.forEach((function(r){var t,a;if(!(r in _))throw new Error(o.OptionError.OPTIONS_UNKNOWN_WAIVECONTRIBUTIONTHRESHOLD);if(!s.isNumeric((null!==(t=n.waiveContributionThreshold)&&void 0!==t?t:{})[r]))throw new Error(o.OptionError.OPTIONS_INVALID_WAIVECONTRIBUTIONTHRESHOLD);var i=(null!==(a=n.waiveContributionThreshold)&&void 0!==a?a:{})[r];void 0!==i&&(e.waiveContributionThreshold[r]=i)}))}if(void 0!==n.maxContributionRatio){var D;if(e.maxContributionRatio=null!==(l=e.maxContributionRatio)&&void 0!==l?l:{},!(D=Object.keys(n.maxContributionRatio)).length)throw new Error(o.OptionError.OPTIONS_EMPTY_MAXCONTRIBUTIONRATIO);D.forEach((function(r){var t,a;if(!(r in _))throw new Error(o.OptionError.OPTIONS_UNKNOWN_MAXCONTRIBUTIONRATIO);if(!s.isNumeric((null!==(t=n.maxContributionRatio)&&void 0!==t?t:{})[r]))throw new Error(o.OptionError.OPTIONS_INVALID_MAXCONTRIBUTIONRATIO);var i=(null!==(a=n.maxContributionRatio)&&void 0!==a?a:{})[r];void 0!==i&&(e.maxContributionRatio[r]=i)}))}if(void 0!==n.waterCostsPerCohabitant){if(!Array.isArray(n.waterCostsPerCohabitant))throw new Error(o.OptionError.OPTIONS_INVALID_WATERCOSTSPERCOHABITANT);if(!n.waterCostsPerCohabitant.length)throw new Error(o.OptionError.OPTIONS_EMPTY_WATERCOSTSPERCOHABITANT);e.waterCostsPerCohabitant=n.waterCostsPerCohabitant}if(void 0!==n.warPensionDisregard){if(!s.isNumeric(n.warPensionDisregard))throw new Error(o.OptionError.OPTIONS_INVALID_WARPENSIONDISREGARD);e.warPensionDisregard=n.warPensionDisregard}if(void 0!==n.washingExcessPremium){if(!s.isNumeric(n.washingExcessPremium))throw new Error(o.OptionError.OPTIONS_INVALID_WASHINGEXCESSPREMIUM);e.washingExcessPremium=n.washingExcessPremium}if(void 0!==n.washingExcessPremiumLevels){if(!Array.isArray(n.washingExcessPremiumLevels))throw new Error(o.OptionError.OPTIONS_INVALID_WASHINGEXCESSPREMIUMLEVELS);if(!n.washingExcessPremiumLevels.length)throw new Error(o.OptionError.OPTIONS_EMPTY_WASHINGEXCESSPREMIUMLEVELS);e.washingExcessPremiumLevels=n.washingExcessPremiumLevels}if(void 0!==n.additionalBeddingLevels){if(!Array.isArray(n.additionalBeddingLevels))throw new Error(o.OptionError.OPTIONS_INVALID_ADDITIONALBEDDINGLEVELS);if(!n.additionalBeddingLevels.length)throw new Error(o.OptionError.OPTIONS_EMPTY_ADDITIONALBEDDINGLEVELS);e.additionalBeddingLevels=n.additionalBeddingLevels}if(void 0!==n.carersMealAllowance){if(!s.isNumeric(n.carersMealAllowance))throw new Error(o.OptionError.OPTIONS_INVALID_CARERSMEALALLOWANCE);e.carersMealAllowance=n.carersMealAllowance}if(void 0!==n.washingAllowancePerWash){if(!s.isNumeric(n.washingAllowancePerWash))throw new Error(o.OptionError.OPTIONS_INVALID_WASHINGALLOWANCE);e.washingAllowancePerWash=n.washingAllowancePerWash}if(void 0!==n.warWidowsPensionDisregard){if(!s.isNumeric(n.warWidowsPensionDisregard))throw new Error(o.OptionError.OPTIONS_INVALID_WARWIDOWSPENSIONDISREGARD);e.warWidowsPensionDisregard=n.warWidowsPensionDisregard}if(void 0!==n.warSpecialPaymentDisregard){if(!s.isNumeric(n.warSpecialPaymentDisregard))throw new Error(o.OptionError.OPTIONS_INVALID_WARSPECIALPAYMENTDISREGARD);e.warSpecialPaymentDisregard=n.warSpecialPaymentDisregard}if(void 0!==n.maxDREAllowance){if(!s.isNumeric(n.maxDREAllowance))throw new Error(o.OptionError.OPTIONS_INVALID_MAXDREALLOWANCE);e.maxDREAllowance=n.maxDREAllowance}if(void 0!==n.dreRatio){if(!s.isNumeric(n.dreRatio))throw new Error(o.OptionError.OPTIONS_INVALID_DRERATIO);e.dreRatio=n.dreRatio}if(void 0!==n.housingAllowance){if(!s.isNumeric(n.housingAllowance))throw new Error(o.OptionError.OPTIONS_INVALID_HOUSINGALLOWANCE);e.housingAllowance=n.housingAllowance}if(void 0!==n.landlineTelephoneAllowance){if(!s.isNumeric(n.landlineTelephoneAllowance))throw new Error(o.OptionError.OPTIONS_INVALID_LANDLINETELEPHONEALLOWANCE);e.landlineTelephoneAllowance=n.landlineTelephoneAllowance}if(void 0!==n.rentalIncomeDisregard){if(!s.isNumeric(n.rentalIncomeDisregard))throw new Error(o.OptionError.OPTIONS_INVALID_RENTALINCOMEDISREGARD);e.rentalIncomeDisregard=n.rentalIncomeDisregard}if(void 0!==n.disabilityBenefits){var L=n.disabilityBenefits;if([F=L.low,k=L.medium,H=L.high].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_DISABILITYBENEFITS);if([F,k,H].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_DISABILITYBENEFITS);e.disabilityBenefits={low:{amount:n.disabilityBenefits.low},medium:{amount:n.disabilityBenefits.medium},high:{amount:n.disabilityBenefits.high}}}if(void 0!==n.attendanceAllowance){var S=n.attendanceAllowance;if([F=S.low,H=S.high].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_ATTENDANCEALLOWANCE);if([F,H].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_ATTENDANCEALLOWANCE);e.attendanceAllowance={low:{amount:n.attendanceAllowance.low},high:{amount:n.attendanceAllowance.high}}}if(void 0!==n.pipDailyLiving){var N=n.pipDailyLiving;if([F=N.low,H=N.high].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_PIPDAILYLIVING);if([F,H].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_PIPDAILYLIVING);e.pipDailyLiving={low:{amount:n.pipDailyLiving.low},high:{amount:n.pipDailyLiving.high}}}if(void 0!==n.dlaCare){var k,j=n.dlaCare;if([F=j.low,k=j.medium,H=j.high].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_DLACARE);if([F,k,H].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_DLACARE);e.dlaCare={low:{amount:n.dlaCare.low},medium:{amount:n.dlaCare.medium},high:{amount:n.dlaCare.high}}}if(void 0!==n.mobilityAllowance){var M=n.mobilityAllowance;if([F=M.low,H=M.high].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_MOBILITYALLOWANCE);if([F,H].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_MOBILITYALLOWANCE);e.mobilityAllowance={low:{amount:n.mobilityAllowance.low},high:{amount:n.mobilityAllowance.high}}}if(void 0!==n.pipMobilityAllowance){var x=n.pipMobilityAllowance;if([F=x.low,H=x.high].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_PIPMOBILITYALLOWANCE);if([F,H].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_PIPMOBILITYALLOWANCE);e.pipMobilityAllowance={low:{amount:n.pipMobilityAllowance.low},high:{amount:n.pipMobilityAllowance.high}}}if(void 0!==n.dlaMobilityAllowance){var F,H,B=n.dlaMobilityAllowance;if([F=B.low,H=B.high].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_DLAMOBILITYALLOWANCE);if([F,H].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_DLAMOBILITYALLOWANCE);e.dlaMobilityAllowance={low:{amount:n.dlaMobilityAllowance.low},high:{amount:n.dlaMobilityAllowance.high}}}if(void 0!==n.constantAttendanceAllowance){var W=n.constantAttendanceAllowance,Y=W.exceptional,G=W.intermediate,U=W.normal,V=W.partTime;if([Y,G,U,V].some((function(e){return void 0===e})))throw new Error(o.OptionError.OPTIONS_MISSING_CONSTANTATTENDANCEALLOWANCE);if([Y,G,U,V].some((function(e){return!s.isNumeric(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_CONSTANTATTENDANCEALLOWANCE);e.constantAttendanceAllowance={exceptional:{amount:n.constantAttendanceAllowance.exceptional},intermediate:{amount:n.constantAttendanceAllowance.intermediate},normal:{amount:n.constantAttendanceAllowance.normal},partTime:{amount:n.constantAttendanceAllowance.partTime}}}if(void 0!==n.fullCostCapitalLimit){e.fullCostCapitalLimit=null!==(u=e.fullCostCapitalLimit)&&void 0!==u?u:{};var Z=Object.keys(n.fullCostCapitalLimit);if(!Z.length)throw new Error(o.OptionError.OPTIONS_EMPTY_FULLCOSTCAPITALLIMIT);Object.keys(_).every((function(e){if(!Z.includes(e))throw new Error(o.OptionError.OPTIONS_MISSING_FULLCOSTCAPITALLIMIT)})),Z.forEach((function(r){var t,a;if(!(r in _))throw new Error(o.OptionError.OPTIONS_UNKNOWN_FULLCOSTCAPITALLIMIT);if(!s.isNumeric((null!==(t=n.fullCostCapitalLimit)&&void 0!==t?t:{})[r]))throw new Error(o.OptionError.OPTIONS_INVALID_FULLCOSTCAPITALLIMIT);e.fullCostCapitalLimit[r]=(null!==(a=n.fullCostCapitalLimit)&&void 0!==a?a:{})[r]||Number.POSITIVE_INFINITY}))}if(void 0!==n.capitalTariff){e.capitalTariff=null!==(c=e.capitalTariff)&&void 0!==c?c:{};var J=Object.keys(n.capitalTariff);if(!J.length)throw new Error(o.OptionError.OPTIONS_EMPTY_CAPITALTARIFF);Object.keys(_).every((function(e){if(!J.includes(e))throw new Error(o.OptionError.OPTIONS_MISSING_CAPITALTARIFF)})),J.forEach((function(r){var t,a;if(!(r in _))throw new Error(o.OptionError.OPTIONS_UNKNOWN_CAPITALTARIFF);if(!s.isNumeric((null!==(t=n.capitalTariff)&&void 0!==t?t:{})[r]))throw new Error(o.OptionError.OPTIONS_INVALID_CAPITALTARIFF);e.capitalTariff[r]=(null!==(a=n.capitalTariff)&&void 0!==a?a:{})[r]||Number.POSITIVE_INFINITY}))}if(void 0!==n.capitalLimit){if(!s.isNumeric(n.capitalLimit))throw new Error(o.OptionError.OPTIONS_INVALID_CAPITALLIMIT);e.capitalLimit=n.capitalLimit}if(void 0!==n.dwpCapitalLimit){if(!s.isNumeric(n.dwpCapitalLimit))throw new Error(o.OptionError.OPTIONS_INVALID_DWPCAPITALLIMIT);e.dwpCapitalLimit=n.dwpCapitalLimit}if(void 0!==n.dwpCapitalTariff){if(!s.isNumeric(n.dwpCapitalTariff))throw new Error(o.OptionError.OPTIONS_INVALID_DWPCAPITALTARIFF);e.dwpCapitalTariff=n.dwpCapitalTariff}if(void 0!==n.dwpMIG){if(!s.isNumeric(n.dwpMIG))throw new Error(o.OptionError.OPTIONS_INVALID_DWPMIG);e.dwpMIG=n.dwpMIG}if(void 0!==n.dwpMIGIncomeThreshold){if(!s.isNumeric(n.dwpMIGIncomeThreshold))throw new Error(o.OptionError.OPTIONS_INVALID_DWPMIGINCOMETHRESHOLD);e.dwpMIGIncomeThreshold=n.dwpMIGIncomeThreshold}if(void 0!==n.dwpCapitalThreshold){var q=n.dwpCapitalThreshold;if(!["low","medium"].every((function(e){if(!s.isNumeric(q[e]))throw new Error(o.OptionError.OPTIONS_INVALID_DWPCAPITALTHRESHOLD);return!0})))throw new Error(o.OptionError.OPTIONS_MISSING_DWPCAPITALTHRESHOLD);e.dwpCapitalThreshold=n.dwpCapitalThreshold}if(void 0!==n.partnerCapitalLimit){if(!s.isNumeric(n.partnerCapitalLimit))throw new Error(o.OptionError.OPTIONS_INVALID_PARTNERCAPITALLIMIT);e.partnerCapitalLimit=n.partnerCapitalLimit}if(void 0!==n.partnerCapitalTariff){if(!s.isNumeric(n.partnerCapitalTariff))throw new Error(o.OptionError.OPTIONS_INVALID_PARTNERCAPITALTARIFF);e.partnerCapitalTariff=n.partnerCapitalTariff}if(void 0!==n.jointCapitalLimit){if(!s.isNumeric(n.jointCapitalLimit))throw new Error(o.OptionError.OPTIONS_INVALID_JOINTCAPITALLIMIT);e.jointCapitalLimit=n.jointCapitalLimit}if(void 0!==n.jointCapitalTariff){if(!s.isNumeric(n.jointCapitalTariff))throw new Error(o.OptionError.OPTIONS_INVALID_JOINTCAPITALTARIFF);e.jointCapitalTariff=n.jointCapitalTariff}if(void 0!==n.partnersEarningsDisregarded){if(!s.isNumeric(n.partnersEarningsDisregarded))throw new Error(o.OptionError.OPTIONS_INVALID_PARTNERSEARNINGSDISREGARDED);e.partnersEarningsDisregarded=n.partnersEarningsDisregarded}if(void 0!==n.childPremium){if(!s.isNumeric(n.childPremium))throw new Error(o.OptionError.OPTIONS_INVALID_CHILDPREMIUM);e.childPremium=n.childPremium}if(void 0!==n.carersPremium){if(!s.isNumeric(n.carersPremium))throw new Error(o.OptionError.OPTIONS_INVALID_CARERSPREMIUM);e.carersPremium=n.carersPremium}if(void 0!==n.sdpPremium){if(!s.isNumeric(n.sdpPremium))throw new Error(o.OptionError.OPTIONS_INVALID_SDPPREMIUM);e.sdpPremium=n.sdpPremium}if(void 0!==n.residentialPEA){if(!s.isNumeric(n.residentialPEA))throw new Error(o.OptionError.OPTIONS_INVALID_RESIDENTIALPEA);e.personalLivingAllowance=null!==(d=e.personalLivingAllowance)&&void 0!==d?d:{},e.personalLivingAllowance.residentialRate=n.residentialPEA}if(void 0!==n.livingAllowancesMap){e.livingAllowancesMap=null!==(p=e.livingAllowancesMap)&&void 0!==p?p:{};var X=function(e){void 0===e&&(e={});var n=Object.keys(e);if(!n.length)throw new Error(o.OptionError.OPTIONS_EMPTY_LIVINGALLOWANCEAGERATEMAP);if(!["under25","over25","pensionAge"].every((function(e){return n.includes(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_LIVINGALLOWANCEAGERATEMAP);return n.reduce((function(n,r){var a,i=function(e){var n=Object.keys(e);if(!n.length)throw new Error(o.OptionError.OPTIONS_EMPTY_LIVINGALLOWANCEDISABILITYRATEMAP);return n.forEach((function(n){if(!s.isNumeric(e[n]))throw new Error(o.OptionError.OPTIONS_INVALID_LIVINGALLOWANCEDISABILITYRATEMAP)})),t({},e)}(e[r]);return t(t({},n),((a={})[r]=i,a))}),e)},z=Object.keys(n.livingAllowancesMap);if(!z.length)throw new Error(o.OptionError.OPTIONS_EMPTY_LIVINGALLOWANCEMAP);e.livingAllowancesMap=z.reduce((function(e,r){var a,i=X(n.livingAllowancesMap[r]);return t(t({},e),((a={})[r]=i,a))}),e.livingAllowancesMap)}if(void 0!==n.carerPremiumRatesMap){e.carerPremiumRatesMap=null!==(g=e.carerPremiumRatesMap)&&void 0!==g?g:{};var K=function(e){void 0===e&&(e={});var n=Object.keys(e);if(!n.length)throw new Error(o.OptionError.OPTIONS_EMPTY_CARERPREMIUMRATESAGERATEMAP);if(!["under25","over25","pensionAge"].every((function(e){return n.includes(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_CARERPREMIUMRATESAGERATEMAP);return n.reduce((function(n,r){var a,i=function(e){var n=Object.keys(e);if(!n.length)throw new Error(o.OptionError.OPTIONS_EMPTY_CARERPREMIUMRATESDISABILITYRATEMAP);return n.forEach((function(n){if(!s.isNumeric(e[n]))throw new Error(o.OptionError.OPTIONS_INVALID_CARERPREMIUMRATESDISABILITYRATEMAP)})),t({},e)}(e[r]);return t(t({},n),((a={})[r]=i,a))}),e)},$=Object.keys(n.carerPremiumRatesMap);if(!$.length)throw new Error(o.OptionError.OPTIONS_EMPTY_CARERPREMIUMRATESMAP);e.carerPremiumRatesMap=$.reduce((function(e,r){var a,i=K(n.carerPremiumRatesMap[r]);return t(t({},e),((a={})[r]=i,a))}),e.carerPremiumRatesMap)}var Q=function(e,n,r){if(void 0===e&&(e={}),void 0!==n){if(!Object.keys(n).every((function(e){var r=n[e];return s.isNumeric(r)||r===Number.POSITIVE_INFINITY})))throw new Error;e[r]=n}};if(void 0!==n.pensionSavingsCreditIncomeThreshold){if(!(ne=Object.keys(n.pensionSavingsCreditIncomeThreshold)).length)throw new Error(o.OptionError.OPTIONS_EMPTY_PSCTHRESHOLDTABLE);var ee=null!==(f=e.pensionSavingsCreditIncomeThreshold)&&void 0!==f?f:{};ne.forEach((function(e){var r,t=(null!==(r=n.pensionSavingsCreditIncomeThreshold)&&void 0!==r?r:{})[e]||{};try{Q(ee,t,e)}catch(e){throw new Error(o.OptionError.OPTIONS_INVALID_PSCTHRESHOLDTABLE)}}))}if(void 0!==n.pensionGuaranteeCreditIncomeThreshold){var ne;if(!(ne=Object.keys(n.pensionGuaranteeCreditIncomeThreshold)).length)throw new Error(o.OptionError.OPTIONS_EMPTY_PGCTHRESHOLDTABLE);var re=null!==(m=e.pensionGuaranteeCreditIncomeThreshold)&&void 0!==m?m:{};ne.forEach((function(e){var r,t=(null!==(r=n.pensionGuaranteeCreditIncomeThreshold)&&void 0!==r?r:{})[e]||{};try{Q(re,t,e)}catch(e){throw new Error(o.OptionError.OPTIONS_INVALID_PGCTHRESHOLDTABLE)}}))}if(void 0!==n.pensionGuaranteeCreditEntitlements){if(void 0===n.pensionGuaranteeCreditEntitlements.base)throw new Error(o.OptionError.OPTIONS_EMPTY_PGCCOMPONENTS);if(!s.isNumeric(n.pensionGuaranteeCreditEntitlements.base.single))throw new Error(o.OptionError.OPTIONS_INVALID_PGCCOMPONENTS);if(!s.isNumeric(n.pensionGuaranteeCreditEntitlements.base.couple))throw new Error(o.OptionError.OPTIONS_INVALID_PGCCOMPONENTS);if(!s.isNumeric(n.pensionGuaranteeCreditEntitlements.sdp))throw new Error(o.OptionError.OPTIONS_INVALID_PGCCOMPONENTS);if(!s.isNumeric(n.pensionGuaranteeCreditEntitlements.carer))throw new Error(o.OptionError.OPTIONS_INVALID_PGCCOMPONENTS);e.pensionGuaranteeCreditEntitlements=n.pensionGuaranteeCreditEntitlements}if(void 0!==n.tariffBasedHeatingCosts){if(!Array.isArray(n.tariffBasedHeatingCosts))throw new Error(o.OptionError.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTS);if(0===n.tariffBasedHeatingCosts.length)throw new Error(o.OptionError.OPTIONS_EMPTY_TARIFFBASEDHEATINGCOSTS);n.tariffBasedHeatingCosts.forEach((function(n,r){if(void 0===n.tariffDate)throw new Error(o.OptionError.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSTARIFFDATE);if(void 0===n.applicant)throw new Error(o.OptionError.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSAPPLICANT);if(void 0===n.eachExtraPerson)throw new Error(o.OptionError.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSEACHEXTRAPERSON);["flat","terraced","semiDetached","detached"].forEach((function(e){if(void 0===n.applicant[e])throw new Error(o.OptionError.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSMISSINGKEY);if(!s.isNumeric(n.applicant[e]))throw new Error(o.OptionError.OPTIONS_INVALID_TARIFFBASEDHEATINGCOSTSINVALIDKEY)})),e.tariffBasedHeatingCosts=e.tariffBasedHeatingCosts||[],e.tariffBasedHeatingCosts[r]=n}))}if(void 0!==n.heatingCosts&&(e.heatingCosts=function(e,n){if(void 0===e.applicant)throw new Error("OptionError.OPTIONS_INVALID_".concat(n,"COSTSAPPLICANT"));if(void 0===e.eachExtraPerson)throw new Error("OptionError.OPTIONS_INVALID_".concat(n,"COSTSEACHEXTRAPERSON"));return["flat","terraced","semiDetached","detached"].forEach((function(r){if(void 0===e.applicant[r])throw new Error("OptionError.OPTIONS_INVALID_".concat(n,"COSTSMISSINGKEY"));if(!s.isNumeric(e.applicant[r])&&e.applicant[r]!==Number.POSITIVE_INFINITY)throw new Error("OptionError.OPTIONS_INVALID_".concat(n,"COSTSINVALIDKEY"))})),e}(n.heatingCosts,"HEATING")),void 0!==n.expensesAllowances){e.expensesAllowances=null!==(v=e.expensesAllowances)&&void 0!==v?v:{};var te=Object.keys(n.expensesAllowances);if(!te.length)throw new Error(o.OptionError.OPTIONS_EMPTY_EXPENSESALLOWANCES);te.forEach((function(r){var t,a;if("number"!=typeof(null!==(t=n.expensesAllowances)&&void 0!==t?t:{})[r])throw new Error(o.OptionError.OPTIONS_INVALID_EXPENSESALLOWANCES);e.expensesAllowances[r]=(null!==(a=n.expensesAllowances)&&void 0!==a?a:{})[r]||0}))}if(void 0!==n.disabilityBasedDREAllowance){e.disabilityBasedDREAllowance=null!==(h=e.disabilityBasedDREAllowance)&&void 0!==h?h:{};var ae=Object.keys(n.disabilityBasedDREAllowance);if(!ae.length)throw new Error(o.OptionError.OPTIONS_EMPTY_DISABILITYBASEDDREALLOWANCE);ae.forEach((function(r){var t,a;if("number"!=typeof(null!==(t=n.disabilityBasedDREAllowance)&&void 0!==t?t:{})[r])throw new Error(o.OptionError.OPTIONS_INVALID_DISABILITYBASEDDREALLOWANCE);e.disabilityBasedDREAllowance[r]=(null!==(a=n.disabilityBasedDREAllowance)&&void 0!==a?a:{})[r]||0}))}if(void 0!==n.dreCaps&&(e.dreCaps=null!==(y=e.dreCaps)&&void 0!==y?y:{},Object.keys(n.dreCaps).forEach((function(r){var t,a,i=(null!==(t=n.dreCaps)&&void 0!==t?t:{})[r];if(!s.isNumeric(i))throw new Error(o.OptionError.OPTIONS_INVALID_DRECAP);(null!==(a=e.dreCaps)&&void 0!==a?a:{})[r]=i}))),void 0!==n.dreThresholds&&(e.dreThresholds=null!==(P=e.dreThresholds)&&void 0!==P?P:{},Object.keys(n.dreThresholds).forEach((function(r){var t,a,i=(null!==(t=n.dreThresholds)&&void 0!==t?t:{})[r];if(!s.isNumeric(i))throw new Error(o.OptionError.OPTIONS_INVALID_DRETHRESHOLD);(null!==(a=e.dreThresholds)&&void 0!==a?a:{})[r]=i}))),void 0!==n.dreRates&&(e.dreRates=null!==(C=e.dreRates)&&void 0!==C?C:{},Object.keys(n.dreRates).forEach((function(r){var t,a,i=(null!==(t=n.dreRates)&&void 0!==t?t:{})[r];if(!s.isNumeric(i))throw new Error(o.OptionError.OPTIONS_INVALID_DRERATE);(null!==(a=e.dreRates)&&void 0!==a?a:{})[r]=i}))),void 0!==n.applicableAmounts){e.applicableAmounts=null!==(w=e.applicableAmounts)&&void 0!==w?w:{};var ie=Object.keys(n.applicableAmounts);if(!ie.length)throw new Error("OPTIONS_EMPTY_APPLICABLEAMOUNTS");var oe=null!==(I=n.applicableAmounts)&&void 0!==I?I:{},se=null!==(O=e.applicableAmounts)&&void 0!==O?O:{};ie.forEach((function(e){var n,r=oe[e],t=null!==(n=se[e])&&void 0!==n?n:{},a=Object.keys(r);if(!a.length)throw new Error("OPTIONS_EMPTY_APPLICABLEAMOUNTSKEY");a.forEach((function(e){var n,a=r[e],i=null!==(n=t[e])&&void 0!==n?n:{},o=Object.keys(a);if(!o.length)throw new Error("OPTIONS_EMPTY_APPLICABLEAMOUNTSRATEMAP");o.forEach((function(e){var n=a[e];if(!s.isNumeric(n))throw new Error("OPTIONS_INVALID_APPLICABLEAMOUNTSRATEMAP");a[e]&&(i[e]=n)}))}))}))}if(void 0!==n.cappedRespiteRates){e.cappedRespiteRates=null!==(b=e.cappedRespiteRates)&&void 0!==b?b:{};var le=Object.keys(n.cappedRespiteRates);if(!le.length)throw new Error(o.OptionError.OPTIONS_EMPTY_CAPPEDRESPITERATES);if(!["low","medium","high"].every((function(e){return le.includes(e)})))throw new Error(o.OptionError.OPTIONS_MISSING_CAPPEDRESPITERATES);le.forEach((function(r){var t,a;if(!s.isNumeric((null!==(t=n.cappedRespiteRates)&&void 0!==t?t:{})[r]))throw new Error(o.OptionError.OPTIONS_INVALID_CAPPEDRESPITERATES);e.cappedRespiteRates[r]=(null!==(a=n.cappedRespiteRates)&&void 0!==a?a:{})[r]||Number.POSITIVE_INFINITY}))}if(void 0!==n.benefitElements){e.benefitElements=null!==(A=e.benefitElements)&&void 0!==A?A:{};var ue=Object.keys(n.benefitElements);if(!ue.length)throw new Error(o.OptionError.OPTIONS_EMPTY_BENEFITELEMENTS);var ce=["pensionGuaranteeCredit","employmentSupport","jobSeekersAllowance","universalCreditBreakdown","incomeSupportPayment"];if(!ue.every((function(e){return ce.includes(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_BENEFITELEMENTSKEY);var de=ue.reduce((function(e,r){var t,a=(null!==(t=n.benefitElements)&&void 0!==t?t:{})[r],i=Object.keys(a||{});if(!i.length)throw new Error(o.OptionError.OPTIONS_EMPTY_BENEFITELEMENTSTABLE);var l=["base","baseByAge","carer","edp","sdp","lcw","lcwra","work","support"];if(!i.every((function(e){return l.includes(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_BENEFITELEMENTSTABLEKEY);return e[r]=i.reduce((function(e,n){var r=(null!=a?a:{})[n];if(void 0===r)throw new Error(o.OptionError.OPTIONS_INVALID_BENEFITELEMENTSTABLEITEM);if("baseByAge"===n){if(!Object.keys(r).every((function(e){return["under25","over25","pensionAge"].includes(e)})))throw new Error(o.OptionError.OPTIONS_INVALID_BENEFITELEMENTSTABLEITEM);e[n]=r}else{if(!s.isNumeric(r))throw new Error(o.OptionError.OPTIONS_INVALID_BENEFITELEMENTSTABLEITEM);e[n]=r}return e}),{}),e}),e.benefitElements);e.benefitElements=de}if(void 0!==n.premia){e.premia=null!==(T=e.premia)&&void 0!==T?T:{};var pe=Object.keys(n.premia);if(!pe.length)throw new Error(o.OptionError.OPTIONS_EMPTY_PREMIA);pe.forEach((function(r){var t,a,i=(null!==(t=n.premia)&&void 0!==t?t:{})[r];if(!s.isNumeric(i))throw new Error(o.OptionError.OPTIONS_INVALID_PREMIAKEY);(null!==(a=e.premia)&&void 0!==a?a:{})[r]=i}))}if(void 0!==n.ageAddition){if(!s.isNumeric(n.ageAddition))throw new Error(o.OptionError.OPTIONS_INVALID_AGEADDITION);e.ageAddition=n.ageAddition}return e};n.applyOptions=function(e){var r=e.constants,t=e.defaults,a=e.options,s=void 0===a?{}:a,l=e.fields,u=void 0===l?{}:l,c=e.annualRatesLookupRules,d=void 0===c?[]:c,p=Object.assign({},t),g=u.effectiveDate;if(void 0!==g)try{p=(0,i.getRulesForEffectiveDate)(g,d)}catch(e){if(e.message===o.ConstantsError.CONSTANTS_INVALID_EFFECTIVEDATE)throw new Error(o.OptionError.FORMDATA_INVALID_EFFECTIVEDATE);throw new Error(o.OptionError.FORMDATA_UNSUPPORTED_EFFECTIVEDATE)}if(void 0!==(g=s.effectiveDate))try{p=(0,i.getRulesForEffectiveDate)(g,d)}catch(e){if(e.message===o.ConstantsError.CONSTANTS_INVALID_EFFECTIVEDATE)throw new Error(o.OptionError.OPTIONS_INVALID_EFFECTIVEDATE);throw new Error(o.OptionError.OPTIONS_UNSUPPORTED_EFFECTIVEDATE)}return r=(0,n.setOptionsInConstants)(r,p),void 0===s.effectiveDate&&void 0!==u.effectiveDate&&(s.effectiveDate=u.effectiveDate),r=(0,n.setOptionsInConstants)(r,s)}},20203:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.metadata=void 0;var t=r(50237),a=r(58600),i=r(83745),o=new a.ObjectUtilsService;n.metadata=function(e){if(void 0===e)throw new Error(t.MetaDataError.METADATA_MISSING_FORMTYPECODE);if(void 0===i.constantsLookup[e])throw new Error(t.MetaDataError.METADATA_UNKNOWN_FORMTYPECODE);var n=i.constantsLookup[e];return function(e,r){var a=!1;if(void 0===e)return{success:a,error:t.MetaDataError.METADATA_MISSING_FORMDATA};if(void 0===r)return{success:a,error:t.MetaDataError.METADATA_MISSING_EFFECTIVEDATE};var s,l,u,c,d,p=o.getPropertyPath(null!=e?e:{},"person.details.dob");if(void 0===p)return{success:a,error:t.MetaDataError.METADATA_MISSING_PERSONDOB};try{s=(0,i.getAgeLevel)(n,p,r)}catch(e){return{success:a,error:t.MetaDataError.METADATA_INVALID_PERSONDOB}}try{l=(0,i.getPensionAgeDate)(n,p)}catch(e){return{success:a,error:t.MetaDataError.METADATA_INVALID_PERSONPENSIONDATE}}var g=!0===o.getPropertyPath(null!=e?e:{},"person.intro.hasPartner");if(g){var f=o.getPropertyPath(null!=e?e:{},"partner.details.dob");if(u=!1,void 0!==f){u=!0;try{c=(0,i.getAgeLevel)(n,f,r)}catch(e){u=!1}try{d=(0,i.getPensionAgeDate)(n,f)}catch(e){u=!1}}}var m={success:!0,data:{effectiveDate:r,person:{ageLevel:s,isPensionAge:"high"===s,pensionAgeDate:l},hasPartner:g}};return g&&(m.data.partnerDOBIsKnown=u,u&&(m.data.partner={ageLevel:c,isPensionAge:"high"===c,pensionAgeDate:d})),m}}},83745:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPensionAgeDate=n.getAgeLevel=n.constantsLookup=void 0;var t=r(32954),a=r(56822),i=r(52434),o=r(86915),s=r(76634),l=r(38136),u=r(39082),c=r(97115),d=r(63662),p=r(80422),g=r(44894),f=r(60114),m=r(91403),v=r(30147),h=r(77562),y=r(70439),P=r(47630),C=r(32412),w=r(6148),I=r(34566),O=new t.NumberUtilsService,b=new a.CareAssessmentService(O,{});n.constantsLookup={CO_FCA:i.cornwall.getConstants(),LI_RFCA:s.lincolnshire.getConstants(),LI_FCA:o.lincs.constants,LI_CA:o.lincs.constants,SOT_FCA:l.southampton.getConstants(),WF_FCA:u.wakefield.getConstants(),DO_FCA:c.doncaster.getConstants(),SG_FCA:d.southglos.getConstants(),WK_FCA:p.warwickshire.getConstants(),HA_FCA:g.halton.getConstants(),NO_FCA:f.nottinghamshire.getConstants(),CAL_FCA:m.calderdale.getConstants(),HAM_FCA:v.hampshire.getConstants(),SOM_FCA:h.somerset.getConstants(),WO_FCA:y.wokingham.getConstants(),EA_FCA:P.ealing.getConstants(),FCA:C.kirklees.getConstants(),KR_CA:C.kirklees.getConstants(),WOL_FCA:w.wolverhampton.getConstants(),PL_FCA:I.plymouth.getConstants()};n.getAgeLevel=function(e,n,r){return b.getAgeLevel(n,e.levels,e.overridePensionAge,r).level};n.getPensionAgeDate=function(e,n){return b.getPensionAgeDate(n,e.overridePensionAge)}},67871:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.migrate=void 0;var a=r(76634),i=r(60114),o=r(80422),s=r(32412),l=r(63662),u=r(70439),c=r(97115),d=t(t(t(t(t(t(t({},a.lincolnshire.migrations),i.nottinghamshire.migrations),o.warwickshire.migrations),s.kirklees.migrations),l.southglos.migrations),u.wokingham.migrations),c.doncaster.migrations);n.migrate=function(e){return function(n){if(void 0===n&&(n={}),"object"==typeof(n=null!=n?n:{})&&null!==n&&0===Object.keys(n).length)return n;var r=d[e];if(void 0===r)return n;var t,a=0,i=n.schemaVersion;if(void 0!==i){var o=i.split("@"),s=o[0],l=o[1];s!==e&&console.log("Mismatched form code type supplied");var u=parseInt(l);isNaN(u)||(a=u)}var c=Object.keys(r).sort((function(e,n){return parseInt(e)-parseInt(n)})).reduce((function(e,n){var i=parseInt(n);if(i>a){var o=r[i];e=e.concat(o),t=i}return e}),[]);if(c.length){c.push((function(n){n=null!=n?n:{};var r=JSON.parse(JSON.stringify(n));return r.schemaVersion="".concat(e,"@").concat(t),r}))}return c.reduce((function(e,n){return n(e)}),n)}}},37356:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(84620),i=r(43983),o=r(56397),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l),p=l.fullCostCapitalLimit[r];if((d.totalCapital||0)>=p){var g=(l.maxContribution||{})[r];return{contributions:s.isNumeric(g)?{maxContribution:g}:{},workings:c}}c=Object.assign(c,d);var f=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,f);var m=(0,o.getExpenses)(e,r);c=Object.assign(c,m);var v=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,v);var h=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,h);var y=(0,i.getPartnerTransfer)(e,r,l,c);c=Object.assign(c,y)}else u=Object.assign(u,{fullCost:!0});for(var P in c)if(Object.prototype.hasOwnProperty.call(c,P)){var C=c[P]||0;c[P]=s.roundNearest(C)}return(0,i.getCostOfCare)(e,r,l,c,u)}},14921:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={warWidowsPensionDisregard:0,careTypes:{nonResidential:"nonResidential",respite:"respite",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,sdpPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},overridePensionAge:65,configuration:{calculatorConfig:{weeksPerYear:52}},maxDREAllowance:0,premia:{pensionCreditCouplesAmount:0,severeDisabilityPremium:0,carerPremium:0,carerPremiumCouple:0,carerElement:0,standardCouplesAllowanceHigh:0,standardCouplesAllowanceLow:0,basicElementHigh:0,basicElementLow:0,esaGroupAmountWork:0,esaGroupAmountSupport:0,enhancedDisabilityPremiumSingle:0,enhancedDisabilityPremiumCouple:0,workCapabilityPremiumWork:0,workCapabilityPremiumWorkAndRelated:0}}},84620:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(14921),i=r(30653);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}}),n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-07",values:i.latest,label:"2024-2025"}];var o=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),o=(0,t.applyOptions)({constants:o,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return o}},30653:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:145.15,dp:0,edp:26.5},over25:{base:169.1,dp:0,edp:26.5},pensionAge:{base:283.9,dp:0,edp:0}}},childPremium:105.85,carersPremium:58,sdpPremium:82.9,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}},maxDREAllowance:16,premia:{pensionCreditCouplesAmount:346.6,severeDisabilityPremium:82.9,carerPremium:46.4,carerPremiumCouple:92.8,carerElement:46.54,standardCouplesAllowanceHigh:144.65,standardCouplesAllowanceLow:92.05,basicElementHigh:144.95,basicElementLow:114.82,esaGroupAmountWork:36.55,esaGroupAmountSupport:48.5,enhancedDisabilityPremiumSingle:21.2,enhancedDisabilityPremiumCouple:30.25,workCapabilityPremiumWork:36.64,workCapabilityPremiumWorkAndRelated:97.68}}},50485:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.tenantShare=n.onlyIfPartnerDisclosesFinances=n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},n.onlyIfPartnerDisclosesFinances=function(e){var n=e.partnerDisclosesFinances,r=void 0!==n&&n,t=e.amount;return r?t:0},n.tenantShare=function(e){var n=e.namedOnContract,r=void 0!==n&&n,t=e.numberOfPeopleOnTheContract,a=void 0===t?1:t,i=e.amount;return r?(void 0===i?0:i)/(a>1?2:1):0}},56397:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=void 0;var t=r(91569),a=r(66235),i=r(84620);n.getExpenses=function(e,n){var r=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(r,e,n,a.housingExpenses)}},66235:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(50485);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],homeInsurance:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[t.full],homeInsurance:[t.full],groundRent:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],homeInsurance:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],mortgageLessHousing:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],councilTax:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],homeInsurance:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],groundRent:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances]},ownedJointly:{mortgage:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],mortgageLessHousing:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],councilTax:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],homeInsurance:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],groundRent:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances]},ownedByPartner:{mortgage:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],mortgageLessHousing:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],councilTax:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],homeInsurance:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],groundRent:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances]},tenant:{rent:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],rentLessHousing:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],councilTax:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],homeInsurance:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances]},ownedByOther:{rent:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],rentLessHousing:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],mortgage:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],mortgageLessHousing:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],councilTax:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances],homeInsurance:[(0,t.ratio)(50),t.onlyIfPartnerDisclosesFinances]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],homeInsurance:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByPartner:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],homeInsurance:[(0,t.ratio)(50)]},tenant:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],homeInsurance:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],homeInsurance:[t.full],groundRent:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],councilTax:[t.full],homeInsurance:[t.full],groundRent:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)]},ownedByPartner:{councilTax:[t.full]},tenant:{rent:[t.tenantShare],rentLessHousing:[t.tenantShare],homeInsurance:[t.tenantShare],groundRent:[t.tenantShare]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)]}}},respite:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],homeInsurance:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},tenant:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],homeInsurance:[t.full],waterRates:[(0,t.ratio)(50)]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},tenant:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],rent:[t.full],rentLessHousing:[t.full],councilTax:[t.full],homeInsurance:[t.full],waterRates:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},tenant:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],councilTax:[t.full],homeInsurance:[t.full],waterRates:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]},tenant:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[t.tenantShare],rentLessHousing:[t.tenantShare],councilTax:[t.tenantShare],homeInsurance:[t.tenantShare],waterRates:[t.tenantShare]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)]}}}}},23069:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(24742);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r),d=c.getDisabilityLevelProcessor,p=c.getAllowanceTypeProcessor,g=(0,a.getParameters)(e,l);return g=(0,i.runProcessors)(g,r,{getDisabilityLevelProcessor:d,getAllowanceTypeProcessor:p}),(0,t.sharedCalculator)(n,s,g,u)},n.partnerCalculator=function(e,n,r,o,s,l){var u=(0,a.getPartnerParameters)(e,s);return u=(0,i.runProcessors)(u,r),(0,t.sharedCalculator)(n,o,u,l)}},73062:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(43983),a=r(43983);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},41884:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(43983),a=r(43983);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},31605:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(43983),a=r(43983);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)}},68824:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(43983),a=r(43983);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},51974:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getIncome=void 0;var t=r(43983),a=r(43983);n.getIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,null!=i?i:o)};n.getPartnerIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).ptIncomeLookup;return(0,t.partnerCalculator)(e,n,r,i)}},77724:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var t=r(43983),a=r(43983),i=r(51974),o=r(43983),s=function(e,n,r,t){return function(t){var a,s,l=t.applicableAmount,u=void 0===l?0:l,c=(0,o.getIncomeConfig)(r).ptIncomeLookup,d=(0,i.getIncome)(e,n,r,c),p=(0,i.getPartnerIncome)(e,n,r),g=d.grossIncome,f=p.grossIncome,m=0,v=0,h=0;return s=u/2-f,(a=u/2-g)>0&&s>0?(m=0,v=0,h=0):a>0&&s<0?(m=0-a,h=0,v=a):a<0&&s>0?(m=s,h=s,v=0):a<0&&s<0&&(m=0,v=0,h=0),{ptApplicableAmount:null!=u?u:0,ptApplicantIncome:null!=g?g:0,ptPartnerIncome:null!=f?f:0,ptApplicantResult:null!=a?a:0,ptPartnerResult:null!=s?s:0,partnerTransfer:m=n===r.careTypes.nonResidential?m:0,partnerNotionalTransferIn:m?v:0,partnerNotionalTransferOut:m?h:0}}};n.getPartnerTransfer=function(e,n,r,i){var o=(0,a.getPartnerTransferConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i,{getRollup:s(e,n,r)})}},11438:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(43983),a=r(43983);n.getAllowancesConfig=function(e){var n=(0,a.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,t.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s],carerPremium:[c],childPremium:[u]},plaRate:[s],carerPremium:[c],childPremium:[u]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}}}}},30200:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(43983);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round,s=r.floor;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]},nonResidential:{maxContribution:[a,i(n),s]}}}}},65533:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(43983),i=r(43983);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.ratio,o=n.full,s=n.joint,l=n.wages,u=n.upliftable,c=n.zero,d=n.pensions,p=n.cap,g=n.transferredPensionForPartner,f=(0,a.getDisregardsFunctions)(e),m=f.psc,v=f.ifPartnerCohabits,h=f.shareWithPartnerIfOwnsProperty,y=f.sdpDisregard,P=f.onlyIfJoint,C={childTaxCredit:[o],warPension:[o],warSpecialPayment:[o],childBenefit:[o],charitableIncome:[o],workingTaxCredit:[o],housingBenefit:[o,r(50),v],warWidowsPension:[o,p(e.warWidowsPensionDisregard)],privatePensions:[d,g],mobilityAllowance:[u],pensionSavingsCredit:[s,m],pensionGuaranteeCredit:[P]};return{incomeLookup:{default:{disregardsTotal:t({},C),pscDisregard:{pensionSavingsCredit:[s,m]},sdpDisregard:[c]},nonResidential:{disregardsTotal:t(t({},C),{pensionSavingsCredit:[o],pensionGuaranteeCredit:[c],wages:[l],privatePensions:[c]}),pscDisregard:{pensionSavingsCredit:[o]}},respite:{disregardsTotal:t(t({},C),{pensionGuaranteeCredit:[c],privatePensions:[c]}),pscDisregard:{pensionSavingsCredit:[s,m]}},week1Residential:{disregardsTotal:t(t({},C),{privatePensions:[c],housingBenefit:[o,h]})},week5Residential:{disregardsTotal:t(t({},C),{housingBenefit:[o]}),sdpDisregard:[y]},week13Residential:{disregardsTotal:t(t({},C),{housingBenefit:[o]}),sdpDisregard:[y]}}}}},82816:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(43983),a=r(43983);n.getDREConfig=function(e){return{dreLookup:{default:{dreTotal:[(0,a.getIncomeFunctions)(e).zero]},nonResidential:{dreTotal:[(0,t.getDREFunctions)(e).dre]}}}}},19862:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(43983);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.ratio,o=n.full,s=n.fullUniversalCredit,l=n.wages,u=n.pensions,c=n.otherBenefit,d=n.upliftable,p=n.savings,g=n.shareHoldings,f=n.tariff,m=n.shareWithPartner,v=n.zero,h=n.quarterly,y=n.fourWeekly,P=n.primaryPropertyEquity,C=n.zeroIfPartnerCohabits,w=n.additionalPropertyEquity,I=function(n){return f(e.capitalLimit,e.capitalTariff[n])},O=[p,[g,r(90)],w],b={retirementPension:[o],privatePensions:[u],capitalTariff:a(a([],O,!0),[I("nonResidential")],!1)},A={grossIncome:{retirementPension:[o],universalCredit:[o],incomeSupportPayment:[o],incapacityBenefit:[o],employmentSupport:[o],jobSeekersAllowance:[o],industrialInjuriesBenefit:[o],rentalIncome:[o],workingTaxCredit:[o],childTaxCredit:[o],maintenance:[o],warSpecialPayment:[o],childBenefit:[o],carersAllowance:[o],pensionGuaranteeCredit:[o],pensionSavingsCredit:[o],charitableIncome:[o],warPension:[o],warWidowsPension:[o],cashInLieu:[o],housingBenefit:[o],dwpTariffIncome:[o],concessionaryFuelAllowance:[h],mineworkersPension:[y],wages:[l],privatePensions:[u],otherBenefit:[c],universalCreditBreakdown:[s,m],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d],mobilityAllowance:[d],capitalTariff:a(a([],O,!0),[I("nonResidential")],!1)}};return{incomeLookup:{default:{grossIncome:t({},A.grossIncome),totalCapital:a([],O,!0),capitalTariff:a(a([],O,!0),[I("nonResidential")],!1),qualifyingIncome:b},respite:{grossIncome:t(t({},A.grossIncome),{attendanceAllowance:[v],pipDailyLiving:[v],dlaCare:[v]}),totalCapital:a([],O,!0),capitalTariff:a(a([],O,!0),[I("respite")],!1),qualifyingIncome:b},week5Residential:{grossIncome:t(t({},A.grossIncome),{attendanceAllowance:[v],pipDailyLiving:[v],dlaCare:[v]}),totalCapital:a([],O,!0),capitalTariff:a(a([],O,!0),[I("week5Residential")],!1),qualifyingIncome:b},week13Residential:{grossIncome:t(t({},A.grossIncome),{attendanceAllowance:[v],pipDailyLiving:[v],dlaCare:[v]}),totalCapital:a(a([],O,!0),[[P,r(90),C]],!1),capitalTariff:a(a([],O,!0),[I("week13Residential")],!1),qualifyingIncome:b}},ptIncomeLookup:{default:{grossIncome:{retirementPension:[o],incomeSupportPayment:[o],jobSeekersAllowance:[o],rentalIncome:[o],workingTaxCredit:[o],maintenance:[o],warPension:[o],warWidowsPension:[o],warSpecialPayment:[o],carersAllowance:[o],charitableIncome:[o],pensionGuaranteeCredit:[o],mineworkersPension:[o],concessionaryFuelAllowance:[o],employmentSupport:[o],dwpTariffIncome:[o],wages:[l],privatePension:[u],otherBenefit:[c]}}}}}},80264:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(43983);n.getPartnerTransferConfig=function(e){return{lookup:{default:{applicableAmount:[(0,t.getPartnerTransferFunctions)(e).applicableAmount]}}}}},14033:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=a.carersAllowance,s=(a.universalCreditBreakdown||{}).carer,l="yes"===i.receivesCarersAllowanceForSomeoneElse,u="yes"===i.receivesUCCarerElement;return r+(o||s||l||u?e.carersPremium:0)}})}},88611:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(84620),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t(t({},d),{netContribution:function(e){e.amount;var n=e.parameters.workings,r=void 0===n?{}:n;return(r.grossIncome||0)+(r.capitalTariff||0)-(r.disregardsTotal||0)-(r.sdpDisregard||0)-(r.expensesTotal||0)-(r.dreTotal||0)-(r.livingAllowanceTotal||0)-(r.partnerTransfer||0)},floor:function(e){var n=e.amount;return Math.floor(n)}})}},33832:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,u=new o.CareAssessmentService(r,n),c=new a.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e),p=(0,s.getDefaultIncomeHelpers)(c,u,e).full;return t(t({},d),{shareWithPartner:function(e){var n=e.amount;return e.parameters.hasPartner?n/2:n},shareWithPartnerIfOwnsProperty:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.propertyFields.ownership;return t&&("ownedByYou"===a||"ownedJointly"===a||"ownedJointlyWithPartner"===a)?n/2:n},psc:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.suDOB,s=i.qualifyingIncome,l=void 0===s?0:s,c=u.getAgeLevel(o,e.levels).level,d=e.pensionSavingsCreditIncomeThreshold,p=d?d.singleApplicant:{},g=r>0;return c!==e.levels.high||l<p.INCOME_LOW?0:l>=p.INCOME_LOW&&l<p.INCOME_HIGH?g?Math.min(r||0,p.DISREGARD_MAX):p.DISREGARD_MAX:l>=p.INCOME_HIGH&&g?Math.min(r||0,p.DISREGARD_MAX):p.DISREGARD_MAX},sdpDisregard:function(n){var r=n.amount,t=n.parameters,a=t.introFields,i=t.incomeFields,o="yes"===a.receivesSDP,s=["employmentSupport","jobSeekersAllowance","incomeSupportPayment","pensionGuaranteeCredit"].reduce((function(e,n){return e+p({amount:r,key:n,parameters:t})}),0),l="none",u=i.attendanceAllowance||"",c=i.dlaCare||"";return[u,i.pipDailyLiving||""].some((function(e){if(["high","low"].includes(e))return l=e,!0})),"none"===l&&["high","medium"].includes(c)&&(l=c),["high","medium","low"].includes(l)&&o&&s>0?r+Math.min(s,e.sdpPremium):r},onlyIfJoint:function(e){var n=e.amount,r=e.key,t=e.parameters.incomeFields;return!0===t["".concat(r,"IsJoint")]?n+c.getWeeklyAmount(t,r):n}})}},29743:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(84620),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{dre:function(n){n.amount;return e.maxDREAllowance||0}})}},55249:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{shareWithPartner:function(e){var n=e.amount;return e.parameters.partnerCohabits?n/2:n},quarterly:function(e){var n=e.amount,r=e.key,t=e.parameters.incomeFields;return n+u.getWeeklyAmount(t,r,{period:s.PERIODS.Quarterly})},fourWeekly:function(e){var n=e.amount,r=e.key,t=e.parameters.incomeFields;return n+u.getWeeklyAmount(t,r,{period:s.PERIODS["4 Weekly"]})},additionalPropertyEquity:function(e){return e.amount+(e.parameters.propertyFields.additionalProperties||[]).reduce((function(e,n){return(n.value||0)+e}),0)},zeroIfPartnerCohabits:function(e){var n=e.amount;return e.parameters.partnerCohabits?0:n}})}},84811:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{applicableAmount:function(n){var r,t,a,i,o=n.amount,s=n.parameters,c=0,d=0,p=0,g=0,f=0,m=0,v=0,h=0,y=0,P=s.hasPartner,C=s.partnerCohabits,w=s.partnerDisclosesFinances,I=s.dob,O=s.partnerDOB,b=s.incomeFields,A=s.partnerIncomeFields,T=s.introFields,R=s.partnerIntroFields;if(!(P&&C&&w)||""===O||void 0===O)return o;var _=e.overridePensionAge,E=l.getAgeLevel(I,e.levels,_).level,D=void 0!==O?l.getAgeLevel(O,e.levels,_).level:void 0,L=u.getUpliftable(b,"attendanceAllowance",e),S=u.getUpliftable(b,"dlaCare",e),N=u.getUpliftable(b,"pipDailyLiving",e),k=u.getUpliftable(A,"attendanceAllowance",e),j=u.getUpliftable(A,"dlaCare",e),M=u.getUpliftable(A,"pipDailyLiving",e),x=!1,F=!1,H=T.otherRecievesCarersAllowance,B=R.otherRecievesCarersAllowance,W="yes"===T.carersAllowanceIsEntitled,Y="yes"===R.carersAllowanceIsEntitled,G="Income Related"===b.employmentSupportType,U="Income Related"===A.employmentSupportType,V=b.employmentSupportGroup,Z=A.employmentSupportGroup,J=G&&b.employmentSupportIsJoint,q=b.universalCreditBreakdown||{},X=A.universalCreditBreakdown||{},z="Limited Capability for Work"===b.assessedForLimitedWorkCapability,K="Limited Capability for Work"===A.assessedForLimitedWorkCapability,$="Limited Capability for Work Related Activities"===b.assessedForLimitedWorkCapability,Q="Limited Capability for Work Related Activities"===A.assessedForLimitedWorkCapability;if(S!==((null===(t=null===(r=e.dlaCare)||void 0===r?void 0:r.medium)||void 0===t?void 0:t.amount)||0)&&S!==e.dlaCare.high.amount&&0===L&&0===N||(x=!0),j!==((null===(i=null===(a=e.dlaCare)||void 0===a?void 0:a.medium)||void 0===i?void 0:i.amount)||0)&&j!==e.dlaCare.high.amount&&0===k&&0===M||(F=!0),P&&C&&w){if(E===e.levels.high&&D===e.levels.high&&(d=(e.premia||{}).pensionCreditCouplesAmount),(E===e.levels.high&&D===e.levels.high||G||U)&&x&&F&&(H||(p+=(e.premia||{}).severeDisabilityPremium),B||(p+=(e.premia||{}).severeDisabilityPremium)),E===e.levels.high&&D===e.levels.high?((x&&W||F&&!Y)&&(g+=(e.premia||{}).carerPremium),(F&&Y||x&&!W)&&(g+=(e.premia||{}).carerPremium)):G||U?(x&&W&&(g+=(e.premia||{}).carerPremium),F&&Y&&(g+=(e.premia||{}).carerPremium)):(q.carer&&(g+=(e.premia||{}).carerElement),X.carer&&(g+=(e.premia||{}).carerElement)),E===e.levels.high&&D===e.levels.high||([E,D].indexOf(e.levels.low)>-1?E===e.levels.low&&D===e.levels.low?G||U||(m+=(e.premia||{}).basicElementLow):G||U?f+=(e.premia||{}).standardCouplesAllowanceLow:m+=(e.premia||{}).basicElementHigh:G||U?f+=(e.premia||{}).standardCouplesAllowanceHigh:m+=(e.premia||{}).basicElementHigh),E!==e.levels.high||D!==e.levels.high){G&&("Work"===V?v+=(e.premia||{}).esaGroupAmountWork:"Support"===V&&(v+=(e.premia||{}).esaGroupAmountSupport)),U&&("Work"===Z?v+=(e.premia||{}).esaGroupAmountWork:"Support"===Z&&(v+=(e.premia||{}).esaGroupAmountSupport));var ee=S===e.dlaCare.high.amount||N===e.pipDailyLiving.high.amount,ne=j===e.dlaCare.high.amount||M===e.pipDailyLiving.high.amount,re=G&&"Support"===V,te=ee||re;te&&(h=re&&J||te&&(te&&(ne||U&&"Support"===Z))?(e.premia||{}).enhancedDisabilityPremiumCouple:(e.premia||{}).enhancedDisabilityPremiumSingle)}G||U||((q.limitedWorkCapability||z)&&(y+=(e.premia||{}).workCapabilityPremiumWork),(q.limitedWorkAndRelatedCapability||$)&&(y+=(e.premia||{}).workCapabilityPremiumWorkAndRelated),(X.limitedWorkCapability||K)&&(y+=(e.premia||{}).workCapabilityPremiumWork),(X.limitedWorkAndRelatedCapability||Q)&&(y+=(e.premia||{}).workCapabilityPremiumWorkAndRelated))}return o+(c+=d+p+g+f+m+v+h+y)}})}},43983:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getAllowances=n.getDREs=n.getDisregards=n.getPartnerIncome=n.getIncome=void 0;var t=r(51974);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}});var a=r(31605);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(68824);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(73062);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(77724);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(41884);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(19862);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(65533);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(82816);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(11438);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(80264);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(30200);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(55249);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(33832);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(29743);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(14033);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(84811);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(88611);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(23069);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(24742);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},24742:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){var n=(0,a.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel;return{getDisabilityLevelProcessor:function(e){var r=e.incomeFields,a=n(r),i=r.employmentSupport,o=r.employmentSupportGroup,s=r.universalCreditBreakdown||{},l="Limited Capability for Work Related Activities"===r.assessedForLimitedWorkCapability;return(i&&"Support"===o||s.limitedWorkAndRelatedCapability||l)&&(a="edp"),t(t({},e),{disabilityLevel:a})},getAllowanceTypeProcessor:function(e){return t(t({},e),{allowanceType:"singleServiceUser"})}}}},39082:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.wakefield=void 0;var t=r(37356),a=r(84620);n.wakefield={calculator:t.calculator,getConstants:a.getConstants}},9968:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(71368),i=r(83827),o=r(26561),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if("agree"===(e.person.intro||{}).provideFinancialDetails){var d=(0,i.getIncome)(e,r,l);c=Object.assign(c,d);var p=l.fullCostCapitalLimit[r];if((d.totalCapital||0)>=p){var g=(l.maxContribution||{})[r];return{contributions:s.isNumeric(g)?{maxContribution:g}:{},workings:c}}var f=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,f);var m=(0,o.getExpenses)(e,r);c=Object.assign(c,m);var v=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,v),u=Object.assign(u,{expensesAboveMaxThreshold:(0,i.getExpensesAboveThreshold)(e,r,l,c)});var h=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,h);var y=(0,i.getPartnerTransfer)(e,r,l,c);c=Object.assign(c,y)}else u=Object.assign(u,{fullCost:!0});for(var P in c)if(Object.prototype.hasOwnProperty.call(c,P)){var C=c[P]||0;c[P]=s.roundNearest(C)}return(0,i.getCostOfCare)(e,r,l,c,u)}},61253:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",tempResidential:"tempResidential",permWeek1Residential:"permWeek1Residential",permWeek5Residential:"permWeek5Residential",permWeek13Residential:"permWeek13Residential"},warWidowsPensionDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},constantAttendanceAllowance:{exceptional:{amount:0},intermediate:{amount:0},normal:{amount:0},partTime:{amount:0}},fullCostCapitalLimit:{nonResidential:0,tempResidential:0,permWeek1Residential:0,permWeek5Residential:0,permWeek13Residential:0},capitalTariff:{nonResidential:0,tempResidential:0,permWeek1Residential:0,permWeek5Residential:0,permWeek13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},overridePensionAge:60,configuration:{calculatorConfig:{weeksPerYear:52}},dreCaps:{gardening:0,domesticHelp:0,chiropodist:0,poweredBed:0,bedTurning:0,stairLift:0,hoistPurchase:0,manualWheelchairPurchase:0,poweredWheelchairPurchase:0,manualWheelchairHire:0,poweredWheelchairHire:0,specialClothes:0,additionalBedding:0,poweredRecliningChair:0,prescription:0}}},71368:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(61253),i=r(7737);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(3263);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},7737:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},constantAttendanceAllowance:{exceptional:180.4,intermediate:135.3,normal:90.2,partTime:45.1},fullCostCapitalLimit:{nonResidential:23250,tempResidential:23250,permWeek1Residential:23250,permWeek5Residential:23250,permWeek13Residential:23250},capitalTariff:{nonResidential:250,tempResidential:250,permWeek1Residential:250,permWeek5Residential:250,permWeek13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}}},carersPremium:53.25,childPremium:102.95,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,DISREGARD_MAX:10.6}},dreCaps:{gardening:8.55,chiropodist:5.04,poweredBed:5.6,bedTurning:9.8,stairLift:7.91,hoistPurchase:3.89,manualWheelchairPurchase:5.07,poweredWheelchairPurchase:12.31,manualWheelchairHire:5.07,poweredWheelchairHire:12.31,specialClothes:5.13,additionalBedding:5.13,poweredRecliningChair:4.44,prescription:2.2}}},3263:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warWidowsPensionDisregard:10,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},constantAttendanceAllowance:{exceptional:177.4,intermediate:133.05,normal:88.7,partTime:44.35},fullCostCapitalLimit:{nonResidential:23250,tempResidential:23250,permWeek1Residential:23250,permWeek5Residential:23250,permWeek13Residential:23250},capitalTariff:{nonResidential:250,tempResidential:250,permWeek1Residential:250,permWeek5Residential:250,permWeek13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:136.45-87.65,edp:160.3-136.45},over25:{base:110.6,dp:159.4-110.6,edp:183.25-159.4},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},over25:{base:86.85,dp:121.65-86.85,edp:138.8-121.65},pensionAge:{base:174.6,dp:0,edp:0}}},carersPremium:52.35,childPremium:101.25,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:301.22,INCOME_HIGH:332.95,DISREGARD_MAX:10.4}},dreCaps:{gardening:8.33,domesticHelp:19,chiropodist:4.91,poweredBed:5.46,bedTurning:9.55,stairLift:7.71,hoistPurchase:3.79,manualWheelchairPurchase:4.94,poweredWheelchairPurchase:12,manualWheelchairHire:4.94,poweredWheelchairHire:12,specialClothes:5,additionalBedding:5,poweredRecliningChair:4.33,prescription:2.15}}},71137:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.share=n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},n.share=function(e){var n=e.amount,r=e.partnerCohabits,t=e.numberOfOtherPeople,a=(void 0===t?0:t)+(r?2:1),i=n*(a>1?100/a:100)/100;return Math.max(0,i)}},26561:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=void 0;var t=r(91569),a=r(44407),i=r(71368);n.getExpenses=function(e,n){var r=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(r,e,n,a.housingExpenses)}},44407:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(71137);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},ownedByPartner:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},tenant:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},ownedJointly:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},ownedByPartner:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.share],mortgageLessHousing:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],homeInsurance:[t.share],contentsInsurance:[t.share]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],homeInsurance:[t.share],contentsInsurance:[t.share]},ownedByPartner:{serviceCharge:[t.share],councilTax:[t.share],waterRates:[t.share],contentsInsurance:[t.share]},tenant:{mortgage:[t.share],mortgageLessHousing:[t.share],rentLessHousing:[t.share],rent:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],contentsInsurance:[t.share]},ownedByOther:{mortgage:[t.share],mortgageLessHousing:[t.share],rentLessHousing:[t.share],rent:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],contentsInsurance:[t.share]}}},tempResidential:{single:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedByPartner:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]}},cohabitingPartner:{ownedByYou:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedByPartner:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},tenant:{rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedByOther:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],rentLessHousing:[(0,t.ratio)(50)],rent:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],waterRates:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},ownedJointly:{mortgage:[(0,t.ratio)(50)],mortgageLessHousing:[(0,t.ratio)(50)],serviceCharge:[(0,t.ratio)(50)],groundRent:[(0,t.ratio)(50)],councilTax:[(0,t.ratio)(50)],homeInsurance:[(0,t.ratio)(50)],contentsInsurance:[(0,t.ratio)(50)]},ownedByPartner:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],homeInsurance:[t.full],contentsInsurance:[t.full]},tenant:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]},ownedByOther:{rentLessHousing:[t.full],rent:[t.full],serviceCharge:[t.full],groundRent:[t.full],councilTax:[t.full],waterRates:[t.full],contentsInsurance:[t.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[t.share],mortgageLessHousing:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],homeInsurance:[t.share],contentsInsurance:[t.share]},ownedJointly:{mortgage:[t.share],mortgageLessHousing:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],homeInsurance:[t.share],contentsInsurance:[t.share]},ownedByPartner:{serviceCharge:[t.share],councilTax:[t.share],waterRates:[t.share],contentsInsurance:[t.share]},tenant:{mortgage:[t.share],mortgageLessHousing:[t.share],rentLessHousing:[t.share],rent:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],contentsInsurance:[t.share]},ownedByOther:{mortgage:[t.share],mortgageLessHousing:[t.share],rentLessHousing:[t.share],rent:[t.share],serviceCharge:[t.share],groundRent:[t.share],councilTax:[t.share],waterRates:[t.share],contentsInsurance:[t.share]}}}}},79049:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(21986);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r).getAllowanceTypeProcessor,d=(0,a.getParameters)(e,l);return d=(0,i.runProcessors)(d,r,{getAllowanceTypeProcessor:c}),(0,t.sharedCalculator)(n,s,d,u)},n.partnerCalculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r).getAllowanceTypeProcessor,d=(0,a.getPartnerParameters)(e,l);return d=(0,i.runProcessors)(d,r,{getAllowanceTypeProcessor:c}),(0,t.sharedCalculator)(n,s,d,u)}},31970:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerAllowances=n.getAllowances=void 0;var t=r(83827),a=r(83827);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).partnerLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},72560:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(83827),a=r(83827);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},97553:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(83827),a=r(83827);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).disregardsLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).partnerDisregardsLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},8156:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpensesAboveThreshold=n.getDREs=void 0;var t=r(83827),a=r(83827);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)};n.getExpensesAboveThreshold=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLimitLookup;return(0,t.calculator)(e,n,r,o,i,{getRollup:function(e){var n=[],t=e.dreTotal,a=r.dreCaps||{};return Object.entries(t).forEach((function(e){var r=e[0];e[1]>(a[r]||Number.POSITIVE_INFINITY)&&n.push(r)})),n}})}},30914:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getIncome=void 0;var t=r(83827),a=r(83827);n.getIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,t.partnerCalculator)(e,n,r,o,i)}},98040:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var t=r(83827),a=r(30914),i=r(97553),o=r(31970),s=r(83827);n.getPartnerTransfer=function(e,n,r,l){var u={},c=(0,a.getPartnerIncome)(e,n,r),d=c.grossIncome,p=c.totalCapital,g=c.capitalTariff,f=c.qualifyingIncome;u=Object.assign(u,c);var m=(0,i.getPartnerDisregards)(e,n,r,c),v=m.disregardsTotal;u=Object.assign(u,m),l=Object.assign(l,{partnerGrossIncome:d,partnerTotalCapital:p,partnerCapitalTariff:g,partnerDisregardsTotal:v,partnerQualifyingIncome:f});var h=(0,o.getPartnerAllowances)(e,n,r,u),y=h.livingAllowanceTotal;u=Object.assign(u,h),l=Object.assign(l,{partnerLivingAllowanceTotal:y});var P=(0,s.getPartnerTransferConfig)(r).lookup;return(0,t.calculator)(e,n,r,P,l)}},94826:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(83827),a=r(83827);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=n.carer,u=n.child,c=(0,a.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[u],carerPremium:[l]},plaRate:[r,i,o],childPremium:[u],carerPremium:[l]}},partnerLookup:{default:{livingAllowanceTotal:{plaRate:[c],carerPremium:[c],childPremium:[c]},plaRate:[s],childPremium:[c],carerPremium:[c]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],carerPremium:[c],childPremium:[c]},plaRate:[r,i,o],childPremium:[c],carerPremium:[c]}}}}},53084:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(83827);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o]}}}}},72745:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(83827),i=r(83827);n.getDisregardsConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.joint,o=n.cap,s=n.full,l=n.individual,u=n.wages,c=n.upliftable,d=n.zero,p=n.pensions,g=n.transferredPensionForPartner,f=n.ifTransferPension,m=(0,i.getDisregardsFunctions)(e),v=m.psc,h=m.aa,y=m.dla,P=m.ifNotReceivingExtraCare,C=m.boardingIncome,w=m.nonResCAA,I=m.tempResCAA,O=m.caa,b={wages:[u],privatePensions:[p,g,f],rentalIncome:[r],workingTaxCredit:[r],childTaxCredit:[r],warPension:[r],warSpecialPayment:[r],childBenefit:[r],charitableIncome:[r],warDisablementPension:[r],cashInLieu:[r],childMaintenance:[r],guardiansAllowance:[r],personalInjuryTrustIncome:[r],warWidowsPension:[s,o(e.warWidowsPensionDisregard)],constantAttendanceAllowance:[c,w],attendanceAllowance:[c],pipDailyLiving:[c],dlaCare:[c],mobilityAllowance:[c],pensionSavingsCredit:[s,v]},A={default:{disregardsTotal:t({},b)},nonResidential:{disregardsTotal:t(t({},b),{privatePensions:[d],boardingIncome:[s,C],pensionSavingsCredit:[s],attendanceAllowance:[c,h],pipDailyLiving:[d],dlaCare:[c,y,P]})},tempResidential:{disregardsTotal:t(t({},b),{constantAttendanceAllowance:[c,I],boardingIncome:[s,C],workingTaxCredit:[d]})},permWeek1Residential:{disregardsTotal:t(t({},b),{workingTaxCredit:[d],rentalIncome:[d],cashInLieu:[d],constantAttendanceAllowance:[c,O],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d]})},permWeek5Residential:{disregardsTotal:t(t({},b),{workingTaxCredit:[d],rentalIncome:[d],cashInLieu:[d],constantAttendanceAllowance:[d],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d]})},permWeek13Residential:{disregardsTotal:t(t({},b),{workingTaxCredit:[d],rentalIncome:[d],cashInLieu:[d],constantAttendanceAllowance:[d],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d]})}},T=t(t({},b),{rentalIncome:[l],workingTaxCredit:[l],childTaxCredit:[l],warPension:[l],warSpecialPayment:[l],childBenefit:[l],charitableIncome:[l],warDisablementPension:[l],cashInLieu:[l],childMaintenance:[l],guardiansAllowance:[l],personalInjuryTrustIncome:[l]});return{disregardsLookup:A,partnerDisregardsLookup:{default:{disregardsTotal:t({},T)},nonResidential:{disregardsTotal:t(t({},T),{boardingIncome:[s,C],pensionSavingsCredit:[s],attendanceAllowance:[c,h],pipDailyLiving:[d],dlaCare:[c,y,P]})},tempResidential:{disregardsTotal:t(t({},T),{constantAttendanceAllowance:[c,I],boardingIncome:[s,C],workingTaxCredit:[d]})},permWeek1Residential:{disregardsTotal:t(t({},T),{workingTaxCredit:[d],rentalIncome:[d],cashInLieu:[d],constantAttendanceAllowance:[c,O],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d]})},permWeek5Residential:{disregardsTotal:t(t({},T),{workingTaxCredit:[d],rentalIncome:[d],cashInLieu:[d],constantAttendanceAllowance:[d],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d]})},permWeek13Residential:{disregardsTotal:t(t({},T),{workingTaxCredit:[d],rentalIncome:[d],cashInLieu:[d],constantAttendanceAllowance:[d],attendanceAllowance:[d],pipDailyLiving:[d],dlaCare:[d]})}}}}},23796:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(83827),a=r(83827);n.getDREConfig=function(e){var n=(0,a.getDREFunctions)(e),r=n.oneOffExpense,i=n.periodicExpense,o=n.annualExpense,s=n.limit;return{dreLookup:{default:{dreTotal:[(0,t.getIncomeFunctions)(e).zero]},nonResidential:{dreTotal:{gardening:[o,s],chiropodist:[i,s],specialClothes:[i,s],additionalBedding:[i,s],prescription:[i,s],manualWheelchairHire:[i,s],poweredWheelchairHire:[i,s],poweredBed:[r(10),s],bedTurning:[r(10),s],stairLift:[r(10),s],hoistPurchase:[r(10),s],manualWheelchairPurchase:[r(5),s],poweredWheelchairPurchase:[r(5),s],poweredRecliningChair:[r(10),s]}}},dreLimitLookup:{default:{dreTotal:{gardening:[o],chiropodist:[i],specialClothes:[i],additionalBedding:[i],prescription:[i],manualWheelchairHire:[i],poweredWheelchairHire:[i],poweredBed:[r(10)],bedTurning:[r(10)],stairLift:[r(10)],hoistPurchase:[r(10)],manualWheelchairPurchase:[r(5)],poweredWheelchairPurchase:[r(5)],poweredRecliningChair:[r(10)]}}}}}},1426:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(83827);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.zero,o=n.ratio,s=n.joint,l=n.individual,u=n.full,c=n.tariff,d=n.wages,p=n.pensions,g=n.ucRollup,f=n.otherBenefit,m=n.upliftable,v=n.savings,h=n.shareHoldings,y=n.additionalPropertyEquity,P=n.primaryPropertyEquity,C=n.ifNoProtectedCohabitants,w=n.partnerAdditionalPropertyEquity,I=function(n){return c(e.capitalLimit,e.capitalTariff[n])},O=[y,v,[h,o(90)],I("nonResidential")],b=[w,v,[h,o(90)],I("nonResidential")],A={retirementPension:[l],rentalIncome:[l],warPension:[l],warWidowsPension:[l],warDisablementPension:[l],wages:[d],privatePensions:[p],capitalTariff:O},T={retirementPension:[l],rentalIncome:[l],warPension:[l],warWidowsPension:[l],warDisablementPension:[l],wages:[d],privatePensions:[p],capitalTariff:b},R=[g(["totalUCReceived"])],_={grossIncome:{retirementPension:[s],incomeSupportPayment:[s],incapacityBenefit:[s],employmentSupport:[s],jobSeekersAllowance:[s],industrialInjuriesBenefit:[s],rentalIncome:[s],boardingIncome:[s],workingTaxCredit:[s],childTaxCredit:[s],maintenance:[s],warPension:[s],warWidowsPension:[s],warSpecialPayment:[s],childBenefit:[s],carersAllowance:[s],charitableIncome:[s],pensionGuaranteeCredit:[s],pensionSavingsCredit:[s],childMaintenance:[s],cashInLieu:[s],warDisablementPension:[s],widowsPension:[s],severeDisablementAllowance:[s],industrialDeathBenefit:[s],guardiansAllowance:[s],personalInjuryTrustIncome:[s],wages:[d],privatePensions:[p],otherBenefit:[f],universalCreditBreakdown:R,constantAttendanceAllowance:[m],attendanceAllowance:[m],pipDailyLiving:[m],dlaCare:[m],mobilityAllowance:[m],privatePension:[u],capitalTariff:O}};return{incomeLookup:{default:{grossIncome:t({},_.grossIncome),additionalPropertyEquity:[y],totalCapital:[y,v,[h,o(90)]],capitalTariff:O,universalCreditBreakdown:R,qualifyingIncome:A},permWeek5Residential:{grossIncome:t(t({},_.grossIncome),{constantAttendanceAllowance:[r],attendanceAllowance:[r],pipDailyLiving:[r],dlaCare:[r]}),additionalPropertyEquity:[y],totalCapital:[y,v,[h,o(90)]],capitalTariff:O,universalCreditBreakdown:R,qualifyingIncome:A},permWeek13Residential:{grossIncome:t(t({},_.grossIncome),{constantAttendanceAllowance:[r],attendanceAllowance:[r],pipDailyLiving:[r],dlaCare:[r]}),additionalPropertyEquity:[y],totalCapital:[[P,C],y,v,[h,o(90)]],capitalTariff:a([[P,C]],O,!0),universalCreditBreakdown:R,qualifyingIncome:A}},partnerIncomeLookup:{default:{grossIncome:t({},_.grossIncome),additionalPropertyEquity:[y],totalCapital:[v,[h,o(90)],w],capitalTariff:b,qualifyingIncome:T},permWeek5Residential:{grossIncome:t(t({},_.grossIncome),{constantAttendanceAllowance:[r],attendanceAllowance:[r],pipDailyLiving:[r],dlaCare:[r]}),additionalPropertyEquity:[y],totalCapital:[v,[h,o(90)],w],capitalTariff:b,qualifyingIncome:T},permWeek13Residential:{grossIncome:t(t({},_.grossIncome),{constantAttendanceAllowance:[r],attendanceAllowance:[r],pipDailyLiving:[r],dlaCare:[r]}),additionalPropertyEquity:[y],totalCapital:[v,[h,o(90)],w],capitalTariff:b,qualifyingIncome:T}}}}},25060:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(83827),a=r(83827);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e),r=n.jointIncome,i=n.partnerTransfer,o=n.partnerNetIncome,s=(0,a.getIncomeFunctions)(e),l=s.minZero;return{lookup:{default:{partnerTransfer:[s.zero],jointIncome:[r],partnerNetIncome:[o]},nonResidential:{partnerTransfer:[i,l],jointIncome:[r],partnerNetIncome:[o]}}}}},66533:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{carer:function(n){var r=n.amount,t=n.parameters.incomeFields,a=t.carersAllowance,i=(t.universalCreditBreakdown||{}).carer;return r+(a||i?e.carersPremium:0)}})}},58559:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(71368),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},22284:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378),l=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,u=new o.CareAssessmentService(r,n),c=new a.Helpers(n),d=(0,l.getDefaultDisregardsHelpers)(c,u,e),p=(0,s.getDefaultIncomeHelpers)(c,u,e),g=d.aa,f=p.upliftable,m=function(e){var n=e.amount,r=e.parameters,t=f({amount:0,key:"attendanceAllowance",parameters:r}),a=f({amount:0,key:"pipDailyLiving",parameters:r}),i=0;return n>0&&(t&&n>t||a&&n>a?i=t||a:(t&&n<t||a&&n<a)&&(i=n)),i},v=function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.hasPartner,s=void 0!==o&&o,l=t.suDOB,c=r>0,d=i.qualifyingIncome||0,p=u.getAgeLevel(l,e.levels).level,g=function(n){void 0===n&&(n=!1);var r=e.pensionSavingsCreditIncomeThreshold,t=r?r.singleApplicant:{};return n&&(t=r&&r.applicantAndPartner||{}),t}(s);return p!==e.levels.high||d<g.INCOME_LOW?0:d>=g.INCOME_LOW&&d<g.INCOME_HIGH?c?Math.min(r||0,g.DISREGARD_MAX):g.DISREGARD_MAX:d>=g.INCOME_HIGH&&c?Math.min(r||0,g.DISREGARD_MAX):g.DISREGARD_MAX};return t(t({},d),{boardingIncome:function(e){var n=e.amount;e.parameters;return Math.min(n||0,20)+Math.max(0,(n||0)-20)/2},psc:function(e){var n=e.amount,r=e.parameters;return v({amount:n,parameters:r})},nonResCAA:function(e){var n=e.amount,r=e.parameters,t=m({amount:n,parameters:r});if(t){var a=f({amount:0,key:"attendanceAllowance",parameters:r});t-=g({amount:a,parameters:r})}return t},tempResCAA:function(e){var n=e.amount,r=e.parameters,t=m({amount:n,parameters:r});t&&(t=t-f({amount:0,key:"attendanceAllowance",parameters:r})-f({amount:0,key:"pipDailyLiving",parameters:r}));return t},caa:m})}},41691:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getDREFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultDREHelpers)(u,l,e);return t(t({},c),{washingPerWeek:function(n){return(n.parameters.dreExpensesFields.washingPerWeek||0)>=5&&e.washingExcessPremium||0},fuel:function(n){var r,t=n.amount,a=n.parameters,i=a.introFields,o=a.partnerCohabits,s=a.peopleLivingWithYou,l=(s.hasOtherPeople?(s.otherPeople||[]).length:0)+(o?2:1),u=(s.hasDependentChildren?(s.dependentChildren||[]).length:0)+l,c=i.propertyType;(r=(e.heatingCosts||{}).applicant[c]||0,u>1)&&(r+=(u-1)*((e.heatingCosts||{}).eachExtraPerson[c]||0));return Math.max(t-r,0)},water:function(n){var r,t=n.amount,a=n.parameters,i=a.partnerCohabits,o=a.peopleLivingWithYou,s=(o.hasOtherPeople?(o.otherPeople||[]).length:0)+(i?1:0),l=e.waterCostsPerCohabitant||[],u=null!==(r=l[Math.min(s,l.length-1)])&&void 0!==r?r:0;return Math.max(0,t-u)}})}},96645:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.propertyFields.ownership;return n+(t+="ownedByYou"===i||"ownedByPartner"===i?a:"ownedJointly"===i?a/2:0)}})}},23199:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new s.Helpers(n),c=(0,a.getDefaultPartnerTransferHelpers)(u,l,e);return t(t({},c),{jointIncome:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.grossIncome,s=void 0===o?0:o,l=i.partnerGrossIncome;return n+s+(void 0===l?0:l)},partnerNetIncome:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.partnerGrossIncome,s=void 0===o?0:o,l=i.partnerDisregardsTotal;return s-(void 0===l?0:l)},partnerTransfer:function(e){var n=e.amount,r=e.parameters,t=r.hasPartner,a=r.partnerDisclosesFinances;if(!t||!a)return n;var i=r.workings||{},o=i.partnerLivingAllowanceTotal,s=void 0===o?0:o,l=i.partnerGrossIncome,u=void 0===l?0:l,c=i.partnerDisregardsTotal;return n+(s-(u-(void 0===c?0:c)))}})}},83827:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getPartnerAllowances=n.getAllowances=n.getExpensesAboveThreshold=n.getDREs=n.getPartnerDisregards=n.getDisregards=n.getPartnerIncome=n.getIncome=void 0;var t=r(30914);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}});var a=r(97553);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(8156);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}}),Object.defineProperty(n,"getExpensesAboveThreshold",{enumerable:!0,get:function(){return i.getExpensesAboveThreshold}});var o=r(31970);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}}),Object.defineProperty(n,"getPartnerAllowances",{enumerable:!0,get:function(){return o.getPartnerAllowances}});var s=r(98040);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(72560);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(1426);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(72745);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(23796);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(94826);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(25060);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(53084);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(96645);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(22284);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(41691);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(66533);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(23199);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(58559);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(79049);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(21986);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},21986:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){return t(t({},(0,a.getDefaultProcessors)(e)),{getAllowanceTypeProcessor:function(e){var n=e.hasPartner?"coupleServiceUser":"singleServiceUser";return t(t({},e),{allowanceType:n})}})}},80422:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.warwickshire=void 0;var t=r(9968),a=r(71368),i=r(35934);n.warwickshire={calculator:t.calculator,getConstants:a.getConstants,migrations:i.migrations}},2876:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;var t=r(56530),a=r(50237),i=t.z.object({person:t.z.object({income:t.z.object({retirementPensionPeriod:t.z.string().optional()}).optional()}),partner:t.z.object({income:t.z.object({retirementPensionPeriod:t.z.string().optional()}).optional()}).optional()});n.m1=function(e){void 0===e&&(e={}),e=null!=e?e:{};var n,r=JSON.parse(JSON.stringify(e));if(n=e,i.safeParse(n).success){var t=i.parse(e),o=t.person.income;o&&o.retirementPensionPeriod===a.PERIODS.Monthly&&((r.person.income||{}).retirementPensionPeriod=a.PERIODS["4 Weekly"]);var s=t.partner,l=void 0!==s?s.income:{};l&&l.retirementPensionPeriod===a.PERIODS.Monthly&&(((r.partner||{}).income||{}).retirementPensionPeriod=a.PERIODS["4 Weekly"])}return r}},35934:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.migrations=void 0;var t=r(2876);n.migrations={WK_FCA:{1:[t.m1]}}},50155:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(25241),i=r(54894),o=r(28146),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){var l,u;(0,a.setOptions)(t,e);var c=(0,a.getConstants)(),d={},p={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0};if(function(e){return!["agree","limitedExcessCapital"].includes(e)}(null!==(u=null===(l=e.person.intro)||void 0===l?void 0:l.provideFinancialDetails)&&void 0!==u?u:""))d=Object.assign(d,{fullCost:!0});else{var g=(0,i.getIncome)(e,r,c);p=Object.assign(p,g);var f=c.fullCostCapitalLimit[r];if((g.totalCapital||0)>f){var m=(c.maxContribution||{})[r];return{contributions:s.isNumeric(m)?{maxContribution:m}:{},workings:p}}var v=(0,i.getDisregards)(e,r,c,p);p=Object.assign(p,v);var h=(0,o.getExpenses)(e,r);p=Object.assign(p,h);var y=(0,i.getDREs)(e,r,c,p);p=Object.assign(p,y);var P=(0,i.getAllowances)(e,r,c,p);p=Object.assign(p,P)}for(var C in p)if(Object.prototype.hasOwnProperty.call(p,C)){var w=p[C]||0;p[C]=s.roundNearest(w)}return(0,i.getCostOfCare)(e,r,c,p,d)}},72776:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",respite:"respite",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},waiveContributionThreshold:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},warWidowsPensionDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},fullCostCapitalLimit:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},childPremium:0,carersPremium:0,pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:0,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},overridePensionAge:60,configuration:{calculatorConfig:{weeksPerYear:52}},maxDREAllowance:0}},25241:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(72776),i=r(5054);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(98372);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},5054:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={waiveContributionThreshold:{nonResidential:2.5,respite:2.5,week1Residential:2.5,week5Residential:2.5,week13Residential:2.5},attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:171.63,dp:0,edp:0},over25:{base:195.56,dp:0,edp:0},pensionAge:{base:283.88,dp:0,edp:0}},loneParentUser:{under25:{base:195.56,dp:0,edp:0},over25:{base:195.56,dp:0,edp:0},pensionAge:{base:283.88,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05}},maxDREAllowance:40}},98372:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={waiveContributionThreshold:{nonResidential:2.5,respite:2.5,week1Residential:2.5,week5Residential:2.5,week13Residential:2.5},attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:168.81,dp:0,edp:0},over25:{base:192.31,dp:0,edp:0},pensionAge:{base:272.68,dp:0,edp:0}},loneParentUser:{under25:{base:192.31,dp:0,edp:0},over25:{base:192.31,dp:0,edp:0},pensionAge:{base:272.68,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95}},maxDREAllowance:40}},57990:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.share=n.half=n.full=void 0,n.full=function(e){return e.amount},n.half=function(e){return e.amount/2},n.share=function(e){var n,r=(e.numberOfOtherPeople||0)+(e.partnerCohabits?2:1);return(n=100/r,function(e){var r=e.amount*n/100;return Math.max(0,r)})(e)}},28146:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getExpenses=n.getOwnershipStatus=void 0;var t=r(91569),a=r(11944),i=r(25241);n.getOwnershipStatus=function(e){var n;switch(e.propertyOwnership){case"ownedByYou":n="ownedByYou";break;case"ownedJointly":case"ownedJointlyWithPartner":n="ownedJointly";break;case"ownedByPartner":n="ownedByPartner";break;default:n="tenant"}return n},n.getExpenses=function(e,r){var o=(0,i.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,a.housingExpenses,{getOwnershipStatus:n.getOwnershipStatus})}},11944:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.housingExpenses=void 0;var t=r(57990),a={cohabitingPartner:{ownedByPartner:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],serviceCharge:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],serviceCharge:[t.share]},tenant:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],rent:[t.share],rentLessHousing:[t.share],pitchFees:[t.share],serviceCharge:[t.share]}},cohabitingWithOther:{ownedByPartner:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],serviceCharge:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],serviceCharge:[t.share]},tenant:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],pitchFees:[t.share],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share]}},nonCohabitingPartner:{ownedByPartner:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.full],mortgageLessHousing:[t.full],pitchFees:[t.share],serviceCharge:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],serviceCharge:[t.share]},tenant:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],pitchFees:[t.share],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share]}},single:{ownedByPartner:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],pitchFees:[t.share],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.full],mortgageLessHousing:[t.full],pitchFees:[t.share],serviceCharge:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],mortgage:[t.full],mortgageLessHousing:[t.full],pitchFees:[t.share],serviceCharge:[t.share]},tenant:{compulsoryCourtPayments:[t.full],councilTax:[t.share],groundRent:[t.share],pitchFees:[t.share],rent:[t.share],rentLessHousing:[t.share],serviceCharge:[t.share]}}},i={cohabitingPartner:{ownedByPartner:{compulsoryCourtPayments:[t.full],pitchFees:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share]},tenant:{compulsoryCourtPayments:[t.full],pitchFees:[t.share]}},cohabitingWithOther:{ownedByPartner:{compulsoryCourtPayments:[t.full],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share]},tenant:{compulsoryCourtPayments:[t.full],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share]}},nonCohabitingPartner:{ownedByPartner:{compulsoryCourtPayments:[t.full],pitchFees:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share]},tenant:{compulsoryCourtPayments:[t.full],pitchFees:[t.share]}},single:{ownedByPartner:{compulsoryCourtPayments:[t.full],pitchFees:[t.share]},ownedByYou:{compulsoryCourtPayments:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],pitchFees:[t.share]},ownedJointly:{compulsoryCourtPayments:[t.full],mortgage:[t.full],mortgageLessHousing:[t.full],pitchFees:[t.share]},tenant:{compulsoryCourtPayments:[t.full],pitchFees:[t.share]}}},o={cohabitingPartner:i.cohabitingPartner,cohabitingWithOther:i.cohabitingWithOther,nonCohabitingPartner:i.nonCohabitingPartner,single:{ownedByPartner:i.single.tenant,ownedByYou:i.single.ownedByYou,ownedJointly:i.single.ownedJointly,tenant:i.single.tenant}},s={cohabitingPartner:{ownedByPartner:{pitchFees:[t.share],compulsoryCourtPayments:[t.full]},ownedByYou:{mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],compulsoryCourtPayments:[t.full]},ownedJointly:{mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],compulsoryCourtPayments:[t.full]},tenant:{pitchFees:[t.share],compulsoryCourtPayments:[t.full]}},cohabitingWithOther:{ownedByPartner:{mortgage:[t.full],mortgageLessHousing:[t.full],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share],compulsoryCourtPayments:[t.full]},ownedByYou:{councilTax:[t.full],mortgage:[t.half],mortgageLessHousing:[t.half],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share],compulsoryCourtPayments:[t.full]},ownedJointly:{mortgage:[t.half],mortgageLessHousing:[t.half],groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share],compulsoryCourtPayments:[t.full]},tenant:{groundRent:[t.share],pitchFees:[t.share],serviceCharge:[t.share],compulsoryCourtPayments:[t.full]}},nonCohabitingPartner:{ownedByPartner:{pitchFees:[t.share],compulsoryCourtPayments:[t.full]},ownedByYou:{pitchFees:[t.share],compulsoryCourtPayments:[t.full]},ownedJointly:{mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],compulsoryCourtPayments:[t.full]},tenant:{pitchFees:[t.share],compulsoryCourtPayments:[t.full]}},single:{ownedByPartner:{pitchFees:[t.share],compulsoryCourtPayments:[t.full]},ownedByYou:{mortgage:[t.full],mortgageLessHousing:[t.full],pitchFees:[t.share],compulsoryCourtPayments:[t.full]},ownedJointly:{mortgage:[t.half],mortgageLessHousing:[t.half],pitchFees:[t.share],compulsoryCourtPayments:[t.full]},tenant:{pitchFees:[t.share],compulsoryCourtPayments:[t.full]}}};n.housingExpenses={nonResidential:a,respite:a,week1Residential:i,week5Residential:o,week13Residential:s}},4707:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666),o=r(57825);n.calculator=function(e,n,r,s,l,u){var c=(0,o.getProcessors)(r).getAllowanceTypeProcessor,d=(0,a.getParameters)(e,l);return d=(0,i.runProcessors)(d,r,{getAllowanceTypeProcessor:c}),(0,t.sharedCalculator)(n,s,d,u)}},88149:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(54894),a=r(54894);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},79523:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(54894),a=r(54894);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},36002:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregards=void 0;var t=r(54894),a=r(54894);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).disregardsLookup;return(0,t.calculator)(e,n,r,o,i)}},2969:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(54894),a=r(54894);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},43185:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getIncome=void 0;var t=r(54894),a=r(54894);n.getIncome=function(e,n,r,i){var o=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)}},16917:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(54894),a=r(54894);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,i=n.dp,o=n.edp,s=n.pea,l=(0,a.getIncomeFunctions)(e).zero;return{lookup:{default:{livingAllowanceTotal:{plaRate:[s]},plaRate:[s],childPremium:[l],carerPremium:[l]},nonResidential:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[l],carerPremium:[l]},plaRate:[r,i,o],childPremium:[l],carerPremium:[l]},respite:{livingAllowanceTotal:{plaRate:[r,i,o],childPremium:[l],carerPremium:[l]},plaRate:[r,i,o],childPremium:[l],carerPremium:[l]}}}}},65431:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(54894);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.waive,s=r.round;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o("nonResidential"),s]}}}}},63162:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(54894),i=r(54894);n.getDisregardsConfig=function(e){var n=(0,a.getIncomeFunctions)(e),r=n.joint,o=n.full,s=n.wages,l=n.upliftable,u=n.zero,c=n.pensions,d=n.transferredPensionForPartner,p=(0,i.getDisregardsFunctions)(e),g=p.psc,f=p.aa,m=p.dla,v=p.ifNotReceivingExtraCare,h={wages:[s],privatePensions:[c,d,p.ifPartnerCohabits,p.ifPartnerIsSpouseOrCivilPartner],workingTaxCredit:[r],childTaxCredit:[r],childMaintenance:[r],warPension:[r],warWidowsPension:[r],warSpecialPayment:[r],childBenefit:[r],charitableIncome:[r],maintenance:[o,p.maintenance],attendanceAllowance:[l],pipDailyLiving:[l],dlaCare:[l],mobilityAllowance:[l],pensionSavingsCredit:[o,g]};return{disregardsLookup:{default:{disregardsTotal:t({},h)},nonResidential:{disregardsTotal:t(t({},h),{privatePensions:[u],pensionSavingsCredit:[o],attendanceAllowance:[l,f,v],pipDailyLiving:[u],dlaCare:[l,m,v]})},respite:{disregardsTotal:t(t({},h),{privatePensions:[u],pensionSavingsCredit:[o],attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u]})},week1Residential:{disregardsTotal:t(t({},h),{attendanceAllowance:[u],pipDailyLiving:[u],dlaCare:[u]})},week5Residential:{disregardsTotal:t({},h)},week13Residential:{disregardsTotal:t({},h)}}}}},79253:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(54894),a=r(54894);n.getDREConfig=function(e){var n=(0,a.getIncomeFunctions)(e).zero,r=(0,t.getDREFunctions)(e).dre;return{dreLookup:{default:{dreTotal:[n]},nonResidential:{dreTotal:[r]},respite:{dreTotal:[r]}}}}},35073:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(54894);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.ratio,o=n.joint,s=n.individual,l=n.tariff,u=n.wages,c=n.pensions,d=n.ucRollup,p=n.otherBenefit,g=n.upliftable,f=n.savings,m=n.bonds,v=n.jointBonds,h=n.shareHoldings,y=n.additionalPropertyEquity,P=n.primaryPropertyEquity,C=n.ifNoProtectedCohabitants,w=function(n){return l(e.capitalLimit,e.capitalTariff[n])},I=[y,f,m,v,[h,r(90)]],O=a(a([],I,!0),[w("nonResidential")],!1),b={retirementPension:[s],privatePensions:[c],capitalTariff:O},A=[d(["totalUCReceived"])],T={grossIncome:{retirementPension:[o],incomeSupportPayment:[o],incapacityBenefit:[o],employmentSupport:[o],jobSeekersAllowance:[o],industrialInjuriesBenefit:[o],rentalIncome:[o],boardingIncome:[o],workingTaxCredit:[o],childTaxCredit:[o],maintenance:[o],childMaintenance:[o],warPension:[o],warWidowsPension:[o],warSpecialPayment:[o],childBenefit:[o],carersAllowance:[o],pensionGuaranteeCredit:[o],pensionSavingsCredit:[o],charitableIncome:[o],severeDisablementAllowance:[o],dividendIncome:[o],housingBenefit:[o],wages:[u],privatePensions:[c],otherBenefit:[p],universalCreditBreakdown:A,attendanceAllowance:[g],pipDailyLiving:[g],dlaCare:[g],mobilityAllowance:[g],capitalTariff:O}};return{incomeLookup:{default:{grossIncome:t({},T.grossIncome),additionalPropertyEquity:[y],totalCapital:I,capitalTariff:O,universalCreditBreakdown:A,qualifyingIncome:b},nonResidential:{grossIncome:t({},T.grossIncome),additionalPropertyEquity:[y],totalCapital:[y,f,m,[v,r(50)],[h,r(90)]],capitalTariff:[y,f,m,[v,r(50)],[h,r(90)],w("nonResidential")],universalCreditBreakdown:A,qualifyingIncome:b},week13Residential:{grossIncome:t({},T.grossIncome),additionalPropertyEquity:[y],totalCapital:a([[P,C]],I,!0),capitalTariff:a([[P,C]],O,!0),universalCreditBreakdown:A,qualifyingIncome:b}}}}},28480:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t({},c)}},53842:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(25241),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t({},d)}},62773:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e),d=function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.hasPartner,s=void 0!==o&&o,u=t.suDOB,c=r>0,d=i.qualifyingIncome||0,p=l.getAgeLevel(u,e.levels).level,g=function(n){void 0===n&&(n=!1);var r=e.pensionSavingsCreditIncomeThreshold;return r?r.singleApplicant:{}}(s);return p!==e.levels.high?0:d<g.INCOME_LOW?r>0?Math.min(r,g.DISREGARD_MAX):0:d>=g.INCOME_LOW&&d<g.INCOME_HIGH?c?Math.min(r||0,g.DISREGARD_MAX):g.DISREGARD_MAX:d>=g.INCOME_HIGH&&c?Math.min(r||0,g.DISREGARD_MAX):g.DISREGARD_MAX};return t(t({},c),{psc:function(e){var n=e.amount,r=e.parameters;return d({amount:n,parameters:r})}})}},85436:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(25241),o=r(24609),s=r(32954),l=r(56822),u=r(19666);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,c=new l.CareAssessmentService(r,n),d=new o.Helpers(n),p=(0,u.getDefaultProcessors)(e).getIncomeBasedDisabilityLevel,g=(0,a.getDefaultDREHelpers)(d,c,e);return t(t({},g),{dre:function(n){var r=n.amount,t=n.parameters.incomeFields;return r+="base"===p(t)?0:e.maxDREAllowance||0}})}},13868:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(24609),o=r(32954),s=r(56822);n.getIncomeFunctions=function(e){var n=e.configuration,r=new o.NumberUtilsService,l=new s.CareAssessmentService(r,n),u=new i.Helpers(n),c=(0,a.getDefaultIncomeHelpers)(u,l,e);return t(t({},c),{primaryPropertyEquity:function(e){var n=e.amount,r=e.parameters,t=0,a=r.propertyFields.value||0,i=r.propertyFields.ownership;return n+(t+="ownedByYou"===i||"ownedByPartner"===i?a:"ownedJointly"===i?a/2:0)},bonds:function(e){return e.amount+(e.parameters.capitalFields.premiumBonds||0)},jointBonds:function(e){return e.amount+(e.parameters.jointCapitalFields.premiumBonds||0)}})}},54894:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.calculator=n.getCostOfCareFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getAllowances=n.getDREs=n.getDisregards=n.getIncome=void 0;var t=r(43185);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}});var a=r(36002);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}});var i=r(2969);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(88149);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(79523);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return s.getCostOfCare}});var l=r(35073);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return l.getIncomeConfig}});var u=r(63162);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return u.getDisregardsConfig}});var c=r(79253);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return c.getDREConfig}});var d=r(16917);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return d.getAllowancesConfig}});var p=r(65431);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return p.getCostOfCareConfig}});var g=r(13868);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return g.getIncomeFunctions}});var f=r(62773);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return f.getDisregardsFunctions}});var m=r(85436);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return m.getDREFunctions}});var v=r(28480);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return v.getAllowancesFunctions}});var h=r(53842);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return h.getCostOfCareFunctions}});var y=r(4707);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return y.calculator}});var P=r(57825);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return P.getProcessors}})},57825:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){return t(t({},(0,a.getDefaultProcessors)(e)),{getAllowanceTypeProcessor:function(e){var n=e.hasPartner,r=e.dependentChildrenCount,a=n?"singleServiceUser":r>0?"loneParentUser":"singleServiceUser";return t(t({},e),{allowanceType:a})}})}},70439:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.wokingham=void 0;var t=r(50155),a=r(25241),i=r(3001);n.wokingham={calculator:t.calculator,getConstants:a.getConstants,migrations:i.migrations}},64357:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.m1=void 0;var t=r(50237);n.m1=function(e){void 0===e&&(e={});var n=null!=e?e:{},r=JSON.parse(JSON.stringify(n)),a=["retirementPension","incomeSupportPayment","incapacityBenefit","employmentSupport","jobSeekersAllowance","industrialInjuriesBenefit","childBenefit","carersAllowance","pensionSavingsCredit","pensionGuaranteeCredit"],i=n.person;void 0===i&&(i={});var o=i.income;if(void 0!==o){var s=r.person.income;a.forEach((function(e){var n="".concat(e,"Period");o[n]===t.PERIODS.Monthly&&(s[n]=t.PERIODS["4 Weekly"])}))}var l=(n.partner||{}).income;if(void 0!==l){var u=r.partner.income;a.forEach((function(e){var n="".concat(e,"Period");l[n]===t.PERIODS.Monthly&&(u[n]=t.PERIODS["4 Weekly"])}))}return r}},3001:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.migrations=void 0;var t=r(64357);n.migrations={WO_FCA:{1:[t.m1]}}},99486:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.calculator=void 0;var t=r(32954),a=r(67850),i=r(42517),o=r(50171),s=new t.NumberUtilsService;n.calculator=function(e,n,r,t){(0,a.setOptions)(t,e);var l=(0,a.getConstants)(),u={},c={grossIncome:0,capitalTariff:0,expensesTotal:0,disregardsTotal:0,plaRate:0,partnerTransfer:0,dreTotal:0,livingAllowanceTotal:0},d=(e.person.intro||{}).provideFinancialDetails;if("agree"===d||"savingsOverThreshold"===d){var p=(0,i.getIncome)(e,r,l);c=Object.assign(c,p);var g=l.fullCostCapitalLimit[r];if((p.totalCapital||0)>g){var f=(l.maxContribution||{})[r];return{contributions:s.isNumeric(f)?{maxContribution:f}:{},workings:c,isMaxCost:!0}}var m=(0,i.getPartnerTransfer)(e,r,l,c),v=m.partnerTransfer;c=Object.assign(c,{partnerTransfer:v});var h=(0,i.getDisregards)(e,r,l,c);c=Object.assign(c,h);var y=(0,o.getExpenses)(e,r);c=Object.assign(c,y);var P=(0,i.getDREs)(e,r,l,c);c=Object.assign(c,P);var C=(0,i.getAllowances)(e,r,l,c);c=Object.assign(c,C),m=(0,i.getPartnerTransfer)(e,r,l,c),c=Object.assign(c,m)}else u=Object.assign(u,{fullCost:!0});for(var w in c)if(Object.prototype.hasOwnProperty.call(c,w)){var I=c[w]||0;c[w]=s.roundNearest(I)}return(0,i.getCostOfCare)(e,r,l,c,u)}},43795:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.constants=void 0;var t=r(50237);n.constants={careTypes:{nonResidential:"nonResidential",respite:"respite",week1Residential:"week1Residential",week5Residential:"week5Residential",week13Residential:"week13Residential"},warPensionDisregard:0,warSpecialPaymentDisregard:0,attendanceAllowance:{low:{amount:0},high:{amount:0}},pipDailyLiving:{low:{amount:0},high:{amount:0}},dlaCare:{low:{amount:0},medium:{amount:0},high:{amount:0}},mobilityAllowance:{low:{amount:0},high:{amount:0}},pipMobilityAllowance:{low:{amount:0},high:{amount:0}},dlaMobilityAllowance:{low:{amount:0},high:{amount:0}},constantAttendanceAllowance:{exceptional:{amount:0},intermediate:{amount:0},normal:{amount:0},partTime:{amount:0}},fullCostCapitalLimit:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalTariff:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},capitalLimit:0,waiveContributionThreshold:{nonResidential:0,respite:0,week1Residential:0,week5Residential:0,week13Residential:0},levels:{low:t.Levels.low,medium:t.Levels.medium,high:t.Levels.high},personalLivingAllowance:{residentialRate:0},livingAllowancesMap:{singleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}},loneParentUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}},coupleServiceUser:{under25:{base:0,dp:0,edp:0},over25:{base:0,dp:0,edp:0},pensionAge:{base:0,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:Number.POSITIVE_INFINITY,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0},applicantAndPartner:{INCOME_LOW:Number.POSITIVE_INFINITY,INCOME_HIGH:Number.POSITIVE_INFINITY,DISREGARD_MAX:0}},childPremium:0,carersPremium:0,configuration:{calculatorConfig:{weeksPerYear:52}},tariffBasedHeatingCosts:[{tariffDate:"previousYear",applicant:{flat:0,terraced:0,semiDetached:0,detached:0},eachExtraPerson:{flat:0,terraced:0,semiDetached:0,detached:0}},{tariffDate:"currentYear",applicant:{flat:0,terraced:0,semiDetached:0,detached:0},eachExtraPerson:{flat:0,terraced:0,semiDetached:0,detached:0}}],washingExcessPremium:0,sdpPremium:0,applicableAmounts:{pensionCredit:{pensionAge:{base:0,dp:0,carer:0}},universalCredit:{under25:{base:0,lcw:0,lcwra:0,carer:0},over25:{base:0,lcw:0,lcwra:0,carer:0}},employmentSupport:{under25:{base:0,dp:0,carer:0},over25:{base:0,dp:0,carer:0}}},benefitElements:{}}},67850:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=n.constants=n.getConstants=n.setOptions=n.annualRatesLookupRules=void 0;var t=r(74138),a=r(43795);Object.defineProperty(n,"constants",{enumerable:!0,get:function(){return a.constants}});var i=r(26519);Object.defineProperty(n,"latest",{enumerable:!0,get:function(){return i.latest}});var o=r(46177);n.annualRatesLookupRules=[{start:"2024-04-08",end:"2025-04-06",values:o.latest,label:"2024-2025"},{start:"2025-04-07",end:"2026-04-05",values:i.latest,label:"2025-2026"}];var s=(0,t.applyOptions)({constants:a.constants,defaults:i.latest});n.setOptions=function(e,r){void 0===e&&(e={}),s=(0,t.applyOptions)({constants:s,defaults:i.latest,options:e,fields:r,annualRatesLookupRules:n.annualRatesLookupRules})};n.getConstants=function(){return s}},26519:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,warSpecialPaymentDisregard:111.74,maxDREAllowance:12,attendanceAllowance:{low:73.9,high:110.4},pipDailyLiving:{low:73.9,high:110.4},dlaCare:{low:29.2,medium:73.9,high:110.4},mobilityAllowance:{low:29.2,high:77.05},pipMobilityAllowance:{low:29.2,high:77.05},dlaMobilityAllowance:{low:29.2,high:77.05},constantAttendanceAllowance:{exceptional:180.4,intermediate:135.3,normal:90.2,partTime:45.1},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,waiveContributionThreshold:{nonResidential:2.5,respite:2.5,week1Residential:2.5,week5Residential:2.5,week13Residential:2.5},residentialPEA:30.65,livingAllowancesMap:{singleServiceUser:{under25:{base:89.15,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},loneParentUser:{under25:{base:112.5,dp:49.65,edp:24.25},over25:{base:112.5,dp:49.65,edp:24.25},pensionAge:{base:232.6,dp:0,edp:0}},coupleServiceUser:{under25:{base:88.35,dp:35.4,edp:17.45},over25:{base:88.35,dp:35.4,edp:17.45},pensionAge:{base:177.55,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:198.27,INCOME_HIGH:227.1,DISREGARD_MAX:7.05},applicantAndPartner:{INCOME_LOW:314.34,INCOME_HIGH:346.6,DISREGARD_MAX:10.6}},childPremium:102.95,carersPremium:53.25,washingExcessPremium:4.74,tariffBasedHeatingCosts:[{tariffDate:"previousYear",applicant:{flat:53.11,terraced:53.11,semiDetached:56.41,detached:68.63},eachExtraPerson:{flat:16.96,terraced:16.96,semiDetached:18.06,detached:21.84}},{tariffDate:"currentYear",applicant:{flat:40.85,terraced:40.85,semiDetached:43.38,detached:52.78},eachExtraPerson:{flat:13.04,terraced:13.04,semiDetached:13.89,detached:16.8}}],sdpPremium:21.2,applicableAmounts:{pensionCredit:{pensionAge:{base:227.1,dp:82.9,carer:46.4}},universalCredit:{under25:{base:73.15,lcw:94.85,lcwra:157.85,carer:46.54},over25:{base:92.34,lcw:94.85,lcwra:157.85,carer:46.54}},employmentSupport:{under25:{base:72.9,dp:82.9,carer:46.4},over25:{base:92.05,dp:82.9,carer:46.4}}},benefitElements:{pensionGuaranteeCredit:{base:173.3,carer:46.4,edp:0,sdp:82.9,lcw:0,lcwra:0,work:0,support:0},employmentSupport:{base:72.33,carer:46.4,edp:15.13,sdp:82.9,lcw:0,lcwra:0,work:36.55,support:48.5},universalCreditBreakdown:{baseByAge:{under25:57.41,over25:72.47,pensionAge:72.47},carer:46.54,edp:0,sdp:0,lcw:36.64,lcwra:97.68,work:0,support:0},jobSeekersAllowance:{base:72.33,carer:46.4,edp:15.13,sdp:82.9,lcw:0,lcwra:0,work:0,support:0},incomeSupportPayment:{base:72.33,carer:46.4,edp:15.13,sdp:82.9,lcw:0,lcwra:0,work:0,support:0}}}},46177:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.latest=void 0,n.latest={warPensionDisregard:10,warSpecialPaymentDisregard:111.74,maxDREAllowance:12,attendanceAllowance:{low:72.65,high:108.55},pipDailyLiving:{low:72.65,high:108.55},dlaCare:{low:28.7,medium:72.65,high:108.55},mobilityAllowance:{low:28.7,high:75.75},pipMobilityAllowance:{low:28.7,high:75.75},dlaMobilityAllowance:{low:28.7,high:75.75},constantAttendanceAllowance:{exceptional:177.4,intermediate:133.05,normal:88.7,partTime:44.35},fullCostCapitalLimit:{nonResidential:23250,respite:23250,week1Residential:23250,week5Residential:23250,week13Residential:23250},capitalTariff:{nonResidential:250,respite:250,week1Residential:250,week5Residential:250,week13Residential:250},capitalLimit:14250,waiveContributionThreshold:{nonResidential:2.5,respite:2.5,week1Residential:2.5,week5Residential:2.5,week13Residential:2.5},residentialPEA:30.15,livingAllowancesMap:{singleServiceUser:{under25:{base:87.65,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},loneParentUser:{under25:{base:110.6,dp:48.8,edp:23.85},over25:{base:110.6,dp:48.8,edp:23.85},pensionAge:{base:228.7,dp:0,edp:0}},coupleServiceUser:{under25:{base:86.85,dp:34.8,edp:17.15},over25:{base:86.85,dp:34.8,edp:17.15},pensionAge:{base:174.6,dp:0,edp:0}}},pensionSavingsCreditIncomeThreshold:{singleApplicant:{INCOME_LOW:189.8,INCOME_HIGH:218.15,DISREGARD_MAX:6.95},applicantAndPartner:{INCOME_LOW:301.22,INCOME_HIGH:332.95,DISREGARD_MAX:10.4}},childPremium:101.25,carersPremium:52.35,washingExcessPremium:4.74,tariffBasedHeatingCosts:[{tariffDate:"previousYear",applicant:{flat:53.11,terraced:53.11,semiDetached:56.41,detached:68.63},eachExtraPerson:{flat:16.96,terraced:16.96,semiDetached:18.06,detached:21.84}},{tariffDate:"currentYear",applicant:{flat:40.85,terraced:40.85,semiDetached:43.38,detached:52.78},eachExtraPerson:{flat:13.04,terraced:13.04,semiDetached:13.89,detached:16.8}}],sdpPremium:20.85,applicableAmounts:{pensionCredit:{pensionAge:{base:218.15,dp:81.5,carer:45.6}},universalCredit:{under25:{base:71.93,lcw:93.23,lcwra:155.31,carer:45.76},over25:{base:90.8,lcw:93.23,lcwra:155.31,carer:45.76}},employmentSupport:{under25:{base:71.7,dp:81.5,carer:45.6},over25:{base:90.5,dp:81.5,carer:45.6}}},benefitElements:{pensionGuaranteeCredit:{base:166.48,carer:45.6,edp:0,sdp:81.5,lcw:0,lcwra:0,work:0,support:0},employmentSupport:{base:71.13,carer:45.6,edp:14.88,sdp:81.5,lcw:0,lcwra:0,work:35.95,support:47.7},universalCreditBreakdown:{baseByAge:{under25:56.45,over25:71.26,pensionAge:71.26},carer:45.76,edp:0,sdp:0,lcw:36.02,lcwra:96.04,work:0,support:0},jobSeekersAllowance:{base:71.13,carer:45.6,edp:14.88,sdp:81.5,lcw:0,lcwra:0,work:0,support:0},incomeSupportPayment:{base:71.13,carer:45.6,edp:14.88,sdp:81.5,lcw:0,lcwra:0,work:0,support:0}}}},38783:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.share=n.ratio=n.full=void 0,n.full=function(e){return e.amount},n.ratio=function(e){return function(n){var r=n.amount*e/100;return Math.max(0,r)}},n.share=function(e){var n=e.amount,r=e.partnerCohabits,t=e.numberOfOtherPeople,a=0+(r?1:0)+(void 0===t?0:t),i=n*(a>0?100/(a+1):100)/100;return Math.max(0,i)}},50171:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerExpenses=n.getExpenses=n.getPartnerArrangement=void 0;var t=r(91569),a=r(67850),i=r(33877);n.getPartnerArrangement=function(e){var n=e.hasPartner,r=e.partnerCohabits,t=e.numberOfOtherPeople;return n?r?"cohabitingPartner":"nonCohabitingPartner":t>0?"cohabitingWithOther":"single"},n.getExpenses=function(e,r){var o=(0,a.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,i.housingExpenses,{getPartnerArrangement:n.getPartnerArrangement})},n.getPartnerExpenses=function(e,r){var o=(0,a.getConstants)().configuration;return(0,t.expensesCalculator)(o,e,r,i.partnerHousingExpenses,{getPartnerArrangement:n.getPartnerArrangement})}},33877:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerHousingExpenses=n.housingExpenses=void 0;var t=r(73185),a=r(38783);n.housingExpenses={nonResidential:{single:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedByOther:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]}},cohabitingPartner:{ownedByYou:{mortgage:[a.share],mortgageLessHousing:[a.share],councilTax:[a.share],groundRent:[a.share],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[a.share],mortgageLessHousing:[a.share],councilTax:[a.share],groundRent:[a.share],compulsoryCourtPayments:[a.full]},ownedByPartner:{mortgage:[a.share],mortgageLessHousing:[a.share],councilTax:[a.share],groundRent:[a.share],compulsoryCourtPayments:[a.full]},tenant:{rent:[a.share],rentLessHousing:[a.share],councilTax:[a.share],groundRent:[a.share],compulsoryCourtPayments:[a.full]},ownedByOther:{rent:[a.share],rentLessHousing:[a.share],councilTax:[a.share],groundRent:[a.share],compulsoryCourtPayments:[a.full]}},nonCohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedByPartner:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedByOther:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},tenant:{rentLessHousing:[a.share],rent:[a.share],councilTax:[a.share],groundRent:[a.share],compulsoryCourtPayments:[a.full]},ownedByOther:{rentLessHousing:[a.share],rent:[a.share],councilTax:[a.share],groundRent:[a.share],compulsoryCourtPayments:[a.full]}}},respite:{single:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],combinedHomeInsurance:[a.full],homeInsurance:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[a.full],groundRent:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},ownedByPartner:{serviceCharge:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],serviceCharge:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},ownedByOther:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],serviceCharge:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]}},cohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},ownedByPartner:{councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},tenant:{rentLessHousing:[(0,a.ratio)(50)],rent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,a.ratio)(50)],rent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]}},nonCohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[a.full],serviceCharge:[a.full],groundRent:[a.full],combinedHomeInsurance:[a.full],homeInsurance:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[a.full],groundRent:[a.full],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},ownedByPartner:{serviceCharge:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},tenant:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],serviceCharge:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]},ownedByOther:{rentLessHousing:[a.full],rent:[a.full],councilTax:[a.full],serviceCharge:[a.full],contentsInsurance:[a.full],waterRates:[a.full],compulsoryCourtPayments:[a.full],tvLicence:[a.full],lineRental:[a.full],gas:[a.full],electric:[a.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],combinedHomeInsurance:[a.full],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],homeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},ownedByPartner:{councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],combinedHomeInsurance:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},tenant:{rentLessHousing:[(0,a.ratio)(50)],rent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]},ownedByOther:{rentLessHousing:[(0,a.ratio)(50)],rent:[(0,a.ratio)(50)],councilTax:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],contentsInsurance:[(0,a.ratio)(50)],waterRates:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full],tvLicence:[(0,a.ratio)(50)],lineRental:[(0,a.ratio)(50)],gas:[(0,a.ratio)(50)],electric:[(0,a.ratio)(50)]}}},week1Residential:{single:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},nonCohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingWithOther:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}}},week5Residential:{single:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},nonCohabitingPartner:{ownedByYou:{mortgage:[a.full],mortgageLessHousing:[a.full],serviceCharge:[a.full],groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{mortgage:[(0,a.ratio)(50)],mortgageLessHousing:[(0,a.ratio)(50)],serviceCharge:[(0,a.ratio)(50)],groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingWithOther:{ownedByYou:{groundRent:[a.full],compulsoryCourtPayments:[a.full]},ownedJointly:{groundRent:[(0,a.ratio)(50)],compulsoryCourtPayments:[a.full]}}},week13Residential:{single:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},nonCohabitingPartner:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]},ownedByPartner:{compulsoryCourtPayments:[a.full]},tenant:{compulsoryCourtPayments:[a.full]},ownedByOther:{compulsoryCourtPayments:[a.full]}},cohabitingWithOther:{ownedByYou:{compulsoryCourtPayments:[a.full]},ownedJointly:{compulsoryCourtPayments:[a.full]}}}},n.partnerHousingExpenses=(0,t.cloneDeep)(n.housingExpenses);var i=((n.partnerHousingExpenses.nonResidential||{}).cohabitingPartner||{}).ownedByYou||{};i.mortgage=[(0,a.ratio)(0)],i.mortgageLessHousing=[(0,a.ratio)(0)]},7039:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.partnerCalculator=n.calculator=void 0;var t=r(68879),a=r(74954),i=r(19666);n.calculator=function(e,n,r,o,s,l){var u=(0,a.getParameters)(e,s);return u=(0,i.runProcessors)(u,r),(0,t.sharedCalculator)(n,o,u,l)},n.partnerCalculator=function(e,n,r,o,s,l){var u=(0,a.getPartnerParameters)(e,s);return u=(0,i.runProcessors)(u,r),(0,t.sharedCalculator)(n,o,u,l)}},72432:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowances=void 0;var t=r(42517),a=r(42517);n.getAllowances=function(e,n,r,i){var o=(0,a.getAllowancesConfig)(r).lookup;return(0,t.calculator)(e,n,r,o,i)}},71190:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCare=void 0;var t=r(42517),a=r(42517);n.getCostOfCare=function(e,n,r,i,o){var s=(0,a.getCostOfCareConfig)(r,o).costOfCareLookup,l=(0,t.calculator)(e,n,r,s,i);return Object.assign({contributions:l,workings:i},o)}},11151:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerDisregards=n.getDisregards=void 0;var t=r(42517),a=r(42517);n.getDisregards=function(e,n,r,i){var o=(0,a.getDisregardsConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,o,i)};n.getPartnerDisregards=function(e,n,r,i,o){var s=(0,a.getDisregardsConfig)(r).partnerLookup;return o=o||s,(0,t.partnerCalculator)(e,n,r,o,i)}},66654:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREs=void 0;var t=r(42517),a=r(42517);n.getDREs=function(e,n,r,i){var o=(0,a.getDREConfig)(r).dreLookup;return(0,t.calculator)(e,n,r,o,i)}},79224:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerIncome=n.getIncome=void 0;var t=r(42517),a=r(42517);n.getIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).incomeLookup;return(0,t.calculator)(e,n,r,i)};n.getPartnerIncome=function(e,n,r){var i=(0,a.getIncomeConfig)(r).partnerIncomeLookup;return(0,t.partnerCalculator)(e,n,r,i)}},94990:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransfer=void 0;var a=r(42517),i=r(79224),o=r(11151),s=r(42517),l=function(e){return function(n){var r=n.partnerTransfer,a=void 0===r?0:r,i=e.grossIncome,o=void 0===i?0:i,s=e.disregardsTotal,l=void 0===s?0:s,u=n.partnerNetIncome,c=void 0===u?0:u,d=n.applicableAmount,p=void 0===d?0:d,g=n.jointIncome,f=void 0===g?0:g,m=n.jointDisregards,v=void 0===m?0:m,h=n.couplesEntitlement,y=void 0===h?0:h,P=e.unApportionedMeansTestedIncome,C=void 0===P?0:P;return C>0&&(o=o-C+y),c<p&&(o=f,l=v,a=p),t(t(t({},n),e),{grossIncome:o,disregardsTotal:l,partnerTransfer:a})}};n.getPartnerTransfer=function(e,n,r,t){var u=(0,i.getPartnerIncome)(e,n,r),c=u.grossIncome,d=u.totalCapital,p=u.capitalTariff,g=u.apportionedMeansTestedIncome,f=u.unApportionedMeansTestedIncome;t=Object.assign(t,{partnerGrossIncome:c,partnerTotalCapital:d,partnerCapitalTariff:p,partnerApportionedMeansTestedIncome:g,partnerUnApportionedMeansTestedIncome:f});var m=(0,o.getPartnerDisregards)(e,n,r,u),v=m.disregardsTotal,h=m.edpDisregard;t=Object.assign(t,{partnerDisregardsTotal:v,partnerEdpDisregard:h});var y=(0,s.getPartnerTransferConfig)(r).lookup;return(0,a.calculator)(e,n,r,y,t,{getRollup:l(t)})}},59016:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesConfig=void 0;var t=r(42517);n.getAllowancesConfig=function(e){var n=(0,t.getAllowancesFunctions)(e),r=n.base,a=n.dp,i=n.edp;return{lookup:{default:{livingAllowanceTotal:{plaRate:[n.pea]}},nonResidential:{livingAllowanceTotal:{plaRate:[r,a,i,n.carer,n.child]}}}}}},34466:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareConfig=void 0;var t=r(42517);n.getCostOfCareConfig=function(e,n){var r=(0,t.getCostOfCareFunctions)(e),a=r.netContribution,i=r.maxContribution,o=r.waive,s=r.round,l=r.chargingExemption;return{costOfCareLookup:{default:{maxContribution:[a,i(n),o("nonResidential"),l("respite"),s]},nonResidential:{maxContribution:[a,i(n),o("nonResidential"),l("nonResidential"),s]}}}}},69431:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsConfig=void 0;var a=r(42517),i=r(42517);n.getDisregardsConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.joint,o=n.wages,s=n.upliftable,l=n.zero,u=n.ucRollup,c=n.pensions,d=n.annuities,p=n.occupationalPensions,g=(0,a.getDisregardsFunctions)(e),f=g.aa,m=g.dla,v=g.pip,h=g.ifNotReceivingExtraCare,y=g.psc,P=g.residentialPSC,C=g.edp,w=g.disregardTransferredPension,I=g.ifTransferPension,O={childTaxCredit:[r],workingTaxCredit:[r],childBenefit:[r],warPension:[r],warWidowsPension:[r],warDisablementPension:[r],maintenance:[r],statutorySickPay:[r],wages:[o],attendanceAllowance:[s],pipDailyLiving:[s],dlaCare:[s],pipMobilityAllowance:[s],dlaMobilityAllowance:[s],universalCreditBreakdown:[u(["children","disabledChild","housingElement","childcare"])],pensionSavingsCredit:[r],edpDisregard:[l]};return{incomeLookup:{default:{disregardsTotal:t({},O),edpDisregard:[l]},nonResidential:{disregardsTotal:t(t({},O),{attendanceAllowance:[s,f,h],pipDailyLiving:[s,v,h],dlaCare:[s,m,h],edpDisregard:[C]}),edpDisregard:[C]},respite:{disregardsTotal:t(t({},O),{attendanceAllowance:[s],dlaCare:[s],pipDailyLiving:[s],pensionSavingsCredit:[r,y],workingTaxCredit:[l]})},week1Residential:{disregardsTotal:t(t({},O),{privatePensions:[c,d,p,I,w],pensionSavingsCredit:[r,P],workingTaxCredit:[l],attendanceAllowance:[l],pipDailyLiving:[l],dlaCare:[l]})},week5Residential:{disregardsTotal:t(t({},O),{privatePensions:[c,d,p,w,I],attendanceAllowance:[s],dlaCare:[s],pipDailyLiving:[s],pensionSavingsCredit:[r,P],workingTaxCredit:[l]})},week13Residential:{disregardsTotal:t(t({privatePensions:[c,d,p,w,I]},O),{attendanceAllowance:[l],pipDailyLiving:[l],dlaCare:[l],pensionSavingsCredit:[r,P],workingTaxCredit:[l]})}},partnerLookup:{default:{disregardsTotal:t({},O),edpDisregard:[l]},nonResidential:{disregardsTotal:t(t({},O),{attendanceAllowance:[s,f,h],pipDailyLiving:[s,v,h],dlaCare:[s,m,h],edpDisregard:[C]}),edpDisregard:[C]},respite:{disregardsTotal:t(t({},O),{privatePensions:[c,d,p,w,I],attendanceAllowance:[s],dlaCare:[s],pipDailyLiving:[s],pensionSavingsCredit:[l],workingTaxCredit:[l]})},week1Residential:{disregardsTotal:t(t({},O),{privatePensions:[c,d,p,I,w],pensionSavingsCredit:[l],workingTaxCredit:[l],attendanceAllowance:[l],pipDailyLiving:[l],dlaCare:[l]})},week5Residential:{disregardsTotal:t(t({},O),{privatePensions:[c,d,p,w,I],attendanceAllowance:[s],dlaCare:[s],pipDailyLiving:[s],pensionSavingsCredit:[l],workingTaxCredit:[l]})},week13Residential:{disregardsTotal:t(t({privatePensions:[c,d,p,w,I]},O),{attendanceAllowance:[l],pipDailyLiving:[l],dlaCare:[l],pensionSavingsCredit:[l],workingTaxCredit:[l]})}}}}},89910:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getDREConfig=void 0;var t=r(42517),a=r(42517);n.getDREConfig=function(e){return{dreLookup:{default:{dreTotal:[(0,a.getIncomeFunctions)(e).zero]},nonResidential:{dreTotal:[(0,t.getDREFunctions)(e).dre]}}}}},76008:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)},a=this&&this.__spreadArray||function(e,n,r){if(r||2===arguments.length)for(var t,a=0,i=n.length;a<i;a++)!t&&a in n||(t||(t=Array.prototype.slice.call(n,0,a)),t[a]=n[a]);return e.concat(t||Array.prototype.slice.call(n))};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeConfig=void 0;var i=r(42517);n.getIncomeConfig=function(e){var n=(0,i.getIncomeFunctions)(e),r=n.full,o=n.joint,s=n.jointOnly,l=n.ucRollup,u=n.ucDeductionRollup,c=n.onlyIfUCIsJoint,d=n.wages,p=n.pensions,g=n.annuities,f=n.occupationalPensions,m=n.partnerStatePension,v=n.partnerPensions,h=n.partnerAnnuities,y=n.partnerOccupationalPensions,P=n.otherBenefit,C=n.upliftable,w=n.ratio,I=n.additionalPropertyEquity,O=n.primaryPropertyEquity,b=n.partnerPrimaryPropertyEquity,A=n.partnerAdditionalPropertyEquity,T=n.savings,R=n.partnerSavings,_=n.shareHoldings,E=n.partnerShareHoldings,D=n.tariff,L=n.ifNoProtectedCohabitants,S=n.isNotNewStyleESA,N=n.apportionedAmount,k=n.minZero,j=function(n){return D(e.capitalLimit,e.capitalTariff[n])},M=[[I,w(90)],T,[_,w(90)]],x=[[A,w(90)],R,[E,w(90)]],F={retirementPension:[r],privatePensions:[p,g,f],capitalTariff:[a(a([],M,!0),[j("nonResidential")],!1)]},H={retirementPension:[r,m],privatePensions:[p,v,g,h,f,y],capitalTariff:[a(a([],M,!0),[j("nonResidential")],!1),a(a([],x,!0),[j("nonResidential")],!1)]},B={grossIncome:{childTaxCredit:[o],workingTaxCredit:[o],incomeSupportPayment:[o],employmentSupport:[o],jobSeekersAllowance:[o],industrialInjuriesBenefit:[o],warWidowsPension:[o],maintenance:[o],rentalIncome:[o],boardingIncome:[o],retirementPension:[o],carersAllowance:[o],incapacityBenefit:[o],warDisablementPension:[o],childBenefit:[o],severeDisablementAllowance:[o],pensionGuaranteeCredit:[o],pensionSavingsCredit:[o],industrialDeathBenefit:[o],warPension:[o],statutorySickPay:[o],wages:[d],privatePensions:[p,g,f],otherBenefit:[P],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"]),u(["other","earnings","capitalTariff","benefitLimit","landlordPayment"]),k],attendanceAllowance:[C],pipDailyLiving:[C],dlaCare:[C],pipMobilityAllowance:[C],dlaMobilityAllowance:[C],capitalTariff:a(a([],M,!0),[j("nonResidential")],!1)}},W={default:{grossIncome:t({},B.grossIncome),additionalPropertyEquity:[I,w(90)],totalCapital:a([],M,!0),capitalTariff:a(a([],M,!0),[j("nonResidential")],!1),qualifyingIncome:F,jointQualifyingIncome:H,apportionedMeansTestedIncome:{pensionGuaranteeCredit:[o,N],employmentSupport:[o,N],jobSeekersAllowance:[o,N],incomeSupportPayment:[o,N],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"]),N]},unApportionedMeansTestedIncome:{pensionGuaranteeCredit:[s],employmentSupport:[s,S],jobSeekersAllowance:[s],incomeSupportPayment:[s],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"]),c]}},respite:{grossIncome:t({},B.grossIncome),additionalPropertyEquity:[I,w(90)],totalCapital:a([],M,!0),capitalTariff:a(a([],M,!0),[j("nonResidential")],!1),qualifyingIncome:F,jointQualifyingIncome:H,unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{}},week1Residential:t(t({},B),{qualifyingIncome:F,jointQualifyingIncome:H,unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{}}),week5Residential:t(t({},B),{qualifyingIncome:F,jointQualifyingIncome:H,unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{}}),week13Residential:{grossIncome:t(t({},B.grossIncome),{capitalTariff:[a(a([[O,L,w(90)]],M,!0),[j("nonResidential")],!1)]}),totalCapital:[[O,L,w(90)],a([],M,!0)],capitalTariff:[[O,L,w(90)],a([],M,!0),j("week13Residential")],qualifyingIncome:F,jointQualifyingIncome:H,unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{}}},Y=[[A,w(90)],T,[_,w(90)]],G={retirementPension:[r,m],privatePensions:[p,v,g,h,f,y],capitalTariff:[a(a([],Y,!0),[j("nonResidential")],!1)]};return{incomeLookup:W,partnerIncomeLookup:{default:{grossIncome:t({},B.grossIncome),totalCapital:a([],Y,!0),capitalTariff:a(a([],Y,!0),[j("nonResidential")],!1),apportionedMeansTestedIncome:{pensionGuaranteeCredit:[o,N],employmentSupport:[o,N],jobSeekersAllowance:[o,N],incomeSupportPayment:[o,N],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"]),N]},unApportionedMeansTestedIncome:{pensionGuaranteeCredit:[s],employmentSupport:[s,S],jobSeekersAllowance:[s],incomeSupportPayment:[s],universalCreditBreakdown:[l(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"]),c]},qualifyingIncome:G},respite:{grossIncome:t({},B.grossIncome),totalCapital:a([],Y,!0),capitalTariff:a(a([],Y,!0),[j("nonResidential")],!1),unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{},qualifyingIncome:G},week1Residential:{grossIncome:t({},B.grossIncome),totalCapital:a([],Y,!0),capitalTariff:a(a([],Y,!0),[j("nonResidential")],!1),unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{},qualifyingIncome:G},week5Residential:{grossIncome:t({},B.grossIncome),totalCapital:a([],Y,!0),capitalTariff:a(a([],Y,!0),[j("nonResidential")],!1),unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{},qualifyingIncome:G},week13Residential:{grossIncome:t(t({},B.grossIncome),{capitalTariff:[[b,L,w(90)],a(a([],Y,!0),[j("week13Residential")],!1)]}),totalCapital:[[b,L,w(90)],a([],Y,!0)],capitalTariff:[[b,L,w(90)],a([],Y,!0),j("week13Residential")],unApportionedMeansTestedIncome:{},apportionedMeansTestedIncome:{},qualifyingIncome:G}}}}},61738:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferConfig=void 0;var t=r(42517),a=r(42517);n.getPartnerTransferConfig=function(e){var n=(0,t.getPartnerTransferFunctions)(e),r=n.base,i=n.dp,o=n.capability,s=n.jointIncome,l=n.jointDisregards,u=n.partnerNetIncome,c=n.partnerTransfer,d=n.couplesEntitlement,p=(0,a.getIncomeFunctions)(e),g=p.minZero;return{lookup:{default:{applicableAmount:[p.zero],jointIncome:[s],jointDisregards:[l],partnerNetIncome:[u,g]},nonResidential:{couplesEntitlement:[d],partnerTransfer:[c]},respite:{applicableAmount:[r,i,o],jointIncome:[s],jointDisregards:[l],partnerNetIncome:[u,g]}}}}},41339:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getAllowancesFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getAllowancesFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultAllowancesHelpers)(u,l,e);return t(t({},c),{edp:function(e){var n=e.amount,r=e.parameters,t=r.migLookup,a=r.disabilityLevel,i=void 0===a?"base":a,o=t.edp,s=r.incomeFields,l=(s.employmentSupport||0)>0&&"support"===s.employmentSupportGroup,u="lcwra"===s.assessedForLimitedWorkCapability||((s.universalCreditBreakdown||{}).limitedWorkAndRelatedCapability||0)>0;return n+("edp"===i||l||u?o:0)},carer:function(n){var r=n.amount,t=n.parameters,a=t.incomeFields,i=t.introFields,o=t.partnerIncomeFields,s=a.carersAllowance,l="yes"===i.carersAllowanceIsEntitled,u=((a.universalCreditBreakdown||{}).carer||0)>0,c=((o.universalCreditBreakdown||{}).carer||0)>0,d=a.carerAssessmentEntitlement,p=o.carerAssessmentEntitlement;return r+(s||l||(u&&("applicant"===d||"both"===d)||c&&("applicant"===p||"both"===p))?e.carersPremium:0)}})}},69437:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getCostOfCareFunctions=void 0;var a=r(73378),i=r(67850),o=r(24609),s=r(32954),l=r(56822);n.getCostOfCareFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultCostOfCareHelpers)(c,u,e);return t(t({},d),{chargingExemption:function(e){return function(n){var r=n.amount;switch(n.parameters.detailsFields.chargingExemption){case"exemptCJD":case"exemptSection117":r=0;break;case"exemptSR1":"nonResidential"===e&&(r=0)}return r}}})}},45146:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDisregardsFunctions=void 0;var a=r(24609),i=r(32954),o=r(56822),s=r(73378);n.getDisregardsFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,l=new o.CareAssessmentService(r,n),u=new a.Helpers(n),c=(0,s.getDefaultDisregardsHelpers)(u,l,e),d=function(n,r,t,a){var i=a>0;return n!==e.levels.high||r<t.INCOME_LOW?0:r>=t.INCOME_LOW&&r<t.INCOME_HIGH?i?Math.min(a||0,t.DISREGARD_MAX):0:(t.INCOME_HIGH,t.DISREGARD_MAX)};return t(t({},c),{psc:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.hasPartner,s=void 0!==o&&o,u=t.suDOB,c=l.getAgeLevel(u,e.levels).level,p=function(n,r){void 0===n&&(n=!1);var t=r.partnerTransfer,a=void 0===t?0:t,i=e.pensionSavingsCreditIncomeThreshold,o=i?i.singleApplicant:{};return n&&a>0&&(o=i&&i.applicantAndPartner||{}),o}(s,i),g=function(e,n){void 0===e&&(e=!1);var r=n.qualifyingIncome||0,t=n.partnerTransfer;return e&&(void 0===t?0:t)>0&&(r=n.jointQualifyingIncome||0),r}(s,i);return d(c,g,p,r)},residentialPSC:function(n){var r=n.amount,t=n.parameters,a=t.workings,i=void 0===a?{}:a,o=t.hasPartner,s=void 0!==o&&o,u=t.suDOB,c=l.getAgeLevel(u,e.levels).level,p=e.pensionSavingsCreditIncomeThreshold,g=p?p.singleApplicant:{};s&&(g=p&&p.applicantAndPartner||{});var f=i.qualifyingIncome||0;return s&&(f=i.jointQualifyingIncome||0),d(c,f,g,r)},edp:function(n){var t=n.amount,a=n.parameters,i=a.dob,o=a.incomeFields;if(""===i)return t;var s=e.overridePensionAge,u=l.getAgeLevel(i,e.levels,s).level,c=o.dlaCare,d=o.pipDailyLiving,p=(o.employmentSupport||0)>0&&"support"===o.employmentSupportGroup,g="lcwra"===o.assessedForLimitedWorkCapability||((o.universalCreditBreakdown||{}).limitedWorkAndRelatedCapability||0)>0;return["low","medium"].includes(u)&&(g||p||"high"===c||"high"===d)&&(t+=r.roundUp(.3*(e.sdpPremium||0))),t}})}},36821:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getDREFunctions=void 0;var a=r(73378),i=r(67850),o=r(24609),s=r(32954),l=r(56822);n.getDREFunctions=function(e){var n=(0,i.getConstants)().configuration,r=new s.NumberUtilsService,u=new l.CareAssessmentService(r,n),c=new o.Helpers(n),d=(0,a.getDefaultDREHelpers)(c,u,e);return t(t({},d),{dre:function(n){n.amount;return e.maxDREAllowance||0}})}},64739:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getIncomeFunctions=void 0;var a=r(73378),i=r(19666),o=r(67850),s=r(24609),l=r(32954),u=r(56822);n.getIncomeFunctions=function(e){var n=(0,o.getConstants)().configuration,r=new l.NumberUtilsService,c=new u.CareAssessmentService(r,n),d=new s.Helpers(n),p=(0,a.getDefaultIncomeHelpers)(d,c,e),g=(0,i.getDefaultProcessors)(e),f=p.ucRollup,m=p.joint,v=g.getAgeLevel,h=g.getAgeLevelKey,y=g.getIncomeBasedDisabilityLevel,P=function(e){var n=e.amount,r=e.parameters;return m({amount:0,key:"pensionGuaranteeCredit",parameters:r})+m({amount:0,key:"jobSeekersAllowance",parameters:r})+m({amount:0,key:"incomeSupportPayment",parameters:r})+f(["standardAllowance","children","disabledChild","housingElement","limitedWorkCapability","limitedWorkAndRelatedCapability","carer","childcare"])({amount:n,parameters:r})};return t(t({},p),{savings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.capitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount)}),0),t+=(r.thirdPartyCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount)}),0),n+(t+=(r.jointCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount/2)}),0))},partnerSavings:function(e){var n=e.amount,r=e.parameters,t=0;return t+=(r.partnerCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount)}),0),n+(t+=(r.jointCapitalFields.savingsInvestments||[]).reduce((function(e,n){return e+("life_assured_bond"===n.accountType?0:n.amount/2)}),0))},onlyIfUCIsJoint:function(e){var n=e.amount,r=e.parameters,t=r.incomeFields,a=r.partnerIncomeFields;return!0===t.universalCreditIsJoint||!0===a.universalCreditIsJoint?n:0},isNewStyleESA:function(e){var n=e.amount,r=e.parameters,t=r.incomeFields,a=r.partnerIncomeFields,i=t.employmentSupportType,o=a.employmentSupportType,s=P({amount:0,parameters:r});return"contributionBased"===i||"contributionBased"===o||("unknown"===i||"unknown"===o)&&s>0?n:0},isNotNewStyleESA:function(e){var n=e.amount,r=e.parameters,t=r.incomeFields,a=r.partnerIncomeFields,i=t.employmentSupportType,o=a.employmentSupportType,s=P({amount:0,parameters:r});return"contributionBased"===i||"contributionBased"===o||("unknown"===i||"unknown"===o)&&s>0?0:n},apportionedAmount:function(n){n.amount;var r=n.key,t=n.parameters,a=t.introFields,i=t.incomeFields,o=t.partnerIncomeFields,s=t.partnerIntroFields,l=t.peopleLivingWithYou,u=t.isPartner,c=t.dob,d=t.partnerDOB,p="".concat(r,"IsJoint"),g=!0===i[p]||!0===o[p];if("universalCreditBreakdown"===r&&(g=!0===i.universalCreditIsJoint||!0===o.universalCreditIsJoint),!g||void 0===d)return 0;var f,m=(e.benefitElements||{})[r]||{},C=0,w=0,I=0,O=0,b=0,A=0,T=0,R=v(c),_=h(R),E=v(d),D=h(E),L="under25";[_,D].includes("pensionAge")?L="pensionAge":[_,D].includes("over25")&&(L="over25"),f=void 0!==m.baseByAge?m.baseByAge[L]||0:m.base||0;var S=(i.carersAllowance||0)>0,N="yes"===a.carersAllowanceIsEntitled,k=!1;if("universalCreditBreakdown"===r){var j=a.receivesUCCarerElement,M=i.carerAssessmentEntitlement,x=u?"partner":"applicant";"yes"===j&&(M!==x&&"both"!==M||(k=!0));var F=s.receivesUCCarerElement,H=o.carerAssessmentEntitlement;"yes"===F&&(H!==x&&"both"!==H||(k=!0))}(S||N||k)&&(C=m.carer||0);var B=y(i),W=y(o),Y=i.dlaCare,G=o.dlaCare,U=i.pipDailyLiving,V=o.pipDailyLiving,Z=(l.otherPeople||[]).every((function(e){return!0===e.receivingDisabilityBenefits})),J="dp"===B||"edp"===B,q="dp"===W||"edp"===W;if("employmentSupport"===r||"jobSeekersAllowance"===r||"incomeSupportPayment"===r){var X=[e.levels.high,e.levels.medium,e.levels.low];(X.includes(U)||X.includes(V)||X.includes(Y)||X.includes(G))&&(w=m.edp||0)}var z="yes"===a.someoneReceivesCarersAllowance;if("universalCreditBreakdown"!==r&&Z&&(z||J&&q&&(I=m.sdp||0)),"employmentSupport"===r){var K=i.employmentSupportType,$=o.employmentSupportType,Q=P({amount:0,parameters:t});if("contributionBased"===K||"contributionBased"===$||("unknown"===K||"unknown"===$)&&Q>0)return 0;var ee=i.employmentSupportGroup;"work"===ee?O=m.work||0:"support"===ee&&(b=m.support||0)}if("universalCreditBreakdown"===r){var ne=i.assessedForLimitedWorkCapability,re=i.lcwAssessmentEntitlement;re==(x=u?"partner":"applicant")?"lcw"===ne?A=m.lcw||0:"lcwra"===ne&&(T=m.lcwra||0):"both"==re&&("lcw"===ne?A=m.lcw/2||0:"lcwra"===ne&&(T=m.lcwra/2||0));var te=o.assessedForLimitedWorkCapability,ae=o.lcwAssessmentEntitlement;ae==x?"lcw"===te?A=m.lcw||0:"lcwra"===te&&(T=m.lcwra||0):"both"==ae&&("lcw"===te?A=m.lcw/2||0:"lcwra"===te&&(T=m.lcwra/2||0))}return f+C+w+I+O+b+A+T}})}},26693:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getPartnerTransferFunctions=void 0;var a=r(73378),i=r(32954),o=r(56822),s=r(24609),l=r(19666);n.getPartnerTransferFunctions=function(e){var n=e.configuration,r=new i.NumberUtilsService,u=new o.CareAssessmentService(r,n),c=new s.Helpers(n),d=(0,a.getDefaultPartnerTransferHelpers)(c,u,e),p=(0,l.getDefaultProcessors)(e),g=p.getAgeLevel,f=p.getAgeLevelKey,m=function(n,r){var t=g(n),a=f(t),i=(r.employmentSupport||0)>0;return(("pensionAge"===a?(e.applicableAmounts||{}).pensionCredit:i?(e.applicableAmounts||{}).employmentSupport:(e.applicableAmounts||{}).universalCredit)||{})[a]};return t(t({},d),{base:function(e){var n=e.amount,r=e.parameters,t=r.partnerDOB,a=r.partnerIncomeFields;if(""===t)return n;var i=(m(t,a)||{}).base;return n+(void 0===i?0:i)},dp:function(e){var n=e.amount,r=e.parameters,t=r.partnerDOB,a=r.partnerIncomeFields;if(""===t)return n;var i=a.dlaCare,o=a.pipDailyLiving,s=a.attendanceAllowance,l=[i,o].some((function(e){return void 0===e&&(e=""),["medium","high"].includes(e)})),u=[s].some((function(e){return void 0===e&&(e=""),["low","high"].includes(e)}));if(!l&&!u)return n;var c=(m(t,a)||{}).dp;return n+(void 0===c?0:c)},capability:function(e){var n=e.amount,r=e.parameters,t=r.partnerDOB,a=r.partnerIncomeFields;if(""===t)return n;var i=((a.universalCreditBreakdown||{}).limitedWorkCapability||0)>0,o=((a.universalCreditBreakdown||{}).limitedWorkAndRelatedCapability||0)>0,s=m(t,a)||{},l=s.lcw,u=void 0===l?0:l,c=s.lcwra;return n+(o?void 0===c?0:c:i?u:0)},partnerTransfer:function(e){var n=e.amount,r=e.parameters.workings,t=void 0===r?{}:r,a=t.apportionedMeansTestedIncome,i=void 0===a?0:a,o=t.unApportionedMeansTestedIncome,s=void 0===o?0:o,l=t.partnerApportionedMeansTestedIncome,u=void 0===l?0:l,c=t.partnerUnApportionedMeansTestedIncome,d=void 0===c?0:c,p=Math.max(0,i),g=Math.max(0,u),f=s+d,m=Math.max(0,f-p);return n+Math.min(m,g)},couplesEntitlement:function(e){var n=e.amount,r=e.parameters.workings,t=void 0===r?{}:r,a=t.apportionedMeansTestedIncome,i=void 0===a?0:a,o=t.unApportionedMeansTestedIncome,s=void 0===o?0:o,l=t.partnerApportionedMeansTestedIncome,u=void 0===l?0:l,c=t.partnerUnApportionedMeansTestedIncome,d=s+(void 0===c?0:c),p=i,g=u,f=Math.max(0,p)+Math.max(0,g);return n+Math.min(f,d)}})}},42517:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=n.partnerCalculator=n.calculator=n.getCostOfCareFunctions=n.getPartnerTransferFunctions=n.getAllowancesFunctions=n.getDREFunctions=n.getDisregardsFunctions=n.getIncomeFunctions=n.getCostOfCareConfig=n.getPartnerTransferConfig=n.getAllowancesConfig=n.getDREConfig=n.getDisregardsConfig=n.getIncomeConfig=n.getCostOfCare=n.getPartnerTransfer=n.getAllowances=n.getDREs=n.getPartnerDisregards=n.getDisregards=n.getPartnerIncome=n.getIncome=void 0;var t=r(79224);Object.defineProperty(n,"getIncome",{enumerable:!0,get:function(){return t.getIncome}}),Object.defineProperty(n,"getPartnerIncome",{enumerable:!0,get:function(){return t.getPartnerIncome}});var a=r(11151);Object.defineProperty(n,"getDisregards",{enumerable:!0,get:function(){return a.getDisregards}}),Object.defineProperty(n,"getPartnerDisregards",{enumerable:!0,get:function(){return a.getPartnerDisregards}});var i=r(66654);Object.defineProperty(n,"getDREs",{enumerable:!0,get:function(){return i.getDREs}});var o=r(72432);Object.defineProperty(n,"getAllowances",{enumerable:!0,get:function(){return o.getAllowances}});var s=r(94990);Object.defineProperty(n,"getPartnerTransfer",{enumerable:!0,get:function(){return s.getPartnerTransfer}});var l=r(71190);Object.defineProperty(n,"getCostOfCare",{enumerable:!0,get:function(){return l.getCostOfCare}});var u=r(76008);Object.defineProperty(n,"getIncomeConfig",{enumerable:!0,get:function(){return u.getIncomeConfig}});var c=r(69431);Object.defineProperty(n,"getDisregardsConfig",{enumerable:!0,get:function(){return c.getDisregardsConfig}});var d=r(89910);Object.defineProperty(n,"getDREConfig",{enumerable:!0,get:function(){return d.getDREConfig}});var p=r(59016);Object.defineProperty(n,"getAllowancesConfig",{enumerable:!0,get:function(){return p.getAllowancesConfig}});var g=r(61738);Object.defineProperty(n,"getPartnerTransferConfig",{enumerable:!0,get:function(){return g.getPartnerTransferConfig}});var f=r(34466);Object.defineProperty(n,"getCostOfCareConfig",{enumerable:!0,get:function(){return f.getCostOfCareConfig}});var m=r(64739);Object.defineProperty(n,"getIncomeFunctions",{enumerable:!0,get:function(){return m.getIncomeFunctions}});var v=r(45146);Object.defineProperty(n,"getDisregardsFunctions",{enumerable:!0,get:function(){return v.getDisregardsFunctions}});var h=r(36821);Object.defineProperty(n,"getDREFunctions",{enumerable:!0,get:function(){return h.getDREFunctions}});var y=r(41339);Object.defineProperty(n,"getAllowancesFunctions",{enumerable:!0,get:function(){return y.getAllowancesFunctions}});var P=r(26693);Object.defineProperty(n,"getPartnerTransferFunctions",{enumerable:!0,get:function(){return P.getPartnerTransferFunctions}});var C=r(69437);Object.defineProperty(n,"getCostOfCareFunctions",{enumerable:!0,get:function(){return C.getCostOfCareFunctions}});var w=r(7039);Object.defineProperty(n,"calculator",{enumerable:!0,get:function(){return w.calculator}}),Object.defineProperty(n,"partnerCalculator",{enumerable:!0,get:function(){return w.partnerCalculator}});var I=r(64572);Object.defineProperty(n,"getProcessors",{enumerable:!0,get:function(){return I.getProcessors}})},64572:function(e,n,r){var t=this&&this.__assign||function(){return t=Object.assign||function(e){for(var n,r=1,t=arguments.length;r<t;r++)for(var a in n=arguments[r])Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);return e},t.apply(this,arguments)};Object.defineProperty(n,"__esModule",{value:!0}),n.getProcessors=void 0;var a=r(19666);n.getProcessors=function(e){return t({},(0,a.getDefaultProcessors)(e))}},6148:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.wolverhampton=void 0;var t=r(99486),a=r(67850);n.wolverhampton={calculator:t.calculator,getConstants:a.getConstants}},95225:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.ZodError=n.quotelessJson=n.ZodIssueCode=void 0;const t=r(29694);n.ZodIssueCode=t.util.arrayToEnum(["invalid_type","invalid_literal","custom","invalid_union","invalid_union_discriminator","invalid_enum_value","unrecognized_keys","invalid_arguments","invalid_return_type","invalid_date","invalid_string","too_small","too_big","invalid_intersection_types","not_multiple_of","not_finite"]);n.quotelessJson=e=>JSON.stringify(e,null,2).replace(/"([^"]+)":/g,"$1:");class a extends Error{constructor(e){super(),this.issues=[],this.addIssue=e=>{this.issues=[...this.issues,e]},this.addIssues=(e=[])=>{this.issues=[...this.issues,...e]};const n=new.target.prototype;Object.setPrototypeOf?Object.setPrototypeOf(this,n):this.__proto__=n,this.name="ZodError",this.issues=e}get errors(){return this.issues}format(e){const n=e||function(e){return e.message},r={_errors:[]},t=e=>{for(const a of e.issues)if("invalid_union"===a.code)a.unionErrors.map(t);else if("invalid_return_type"===a.code)t(a.returnTypeError);else if("invalid_arguments"===a.code)t(a.argumentsError);else if(0===a.path.length)r._errors.push(n(a));else{let e=r,t=0;for(;t<a.path.length;){const r=a.path[t];t===a.path.length-1?(e[r]=e[r]||{_errors:[]},e[r]._errors.push(n(a))):e[r]=e[r]||{_errors:[]},e=e[r],t++}}};return t(this),r}toString(){return this.message}get message(){return JSON.stringify(this.issues,t.util.jsonStringifyReplacer,2)}get isEmpty(){return 0===this.issues.length}flatten(e=e=>e.message){const n={},r=[];for(const t of this.issues)t.path.length>0?(n[t.path[0]]=n[t.path[0]]||[],n[t.path[0]].push(e(t))):r.push(e(t));return{formErrors:r,fieldErrors:n}}get formErrors(){return this.flatten()}}n.ZodError=a,a.create=e=>new a(e)},34567:function(e,n,r){var t=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0}),n.getErrorMap=n.setErrorMap=n.defaultErrorMap=void 0;const a=t(r(3983));n.defaultErrorMap=a.default;let i=a.default;n.setErrorMap=function(e){i=e},n.getErrorMap=function(){return i}},69687:function(e,n,r){var t=this&&this.__createBinding||(Object.create?function(e,n,r,t){void 0===t&&(t=r),Object.defineProperty(e,t,{enumerable:!0,get:function(){return n[r]}})}:function(e,n,r,t){void 0===t&&(t=r),e[t]=n[r]}),a=this&&this.__exportStar||function(e,n){for(var r in e)"default"===r||Object.prototype.hasOwnProperty.call(n,r)||t(n,e,r)};Object.defineProperty(n,"__esModule",{value:!0}),a(r(34567),n),a(r(69915),n),a(r(38768),n),a(r(29694),n),a(r(36655),n),a(r(95225),n)},36650:function(e,n){Object.defineProperty(n,"__esModule",{value:!0}),n.errorUtil=void 0,function(e){e.errToObj=e=>"string"==typeof e?{message:e}:e||{},e.toString=e=>"string"==typeof e?e:null==e?void 0:e.message}(n.errorUtil||(n.errorUtil={}))},69915:function(e,n,r){var t=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(n,"__esModule",{value:!0}),n.isAsync=n.isValid=n.isDirty=n.isAborted=n.OK=n.DIRTY=n.INVALID=n.ParseStatus=n.addIssueToContext=n.EMPTY_PATH=n.makeIssue=void 0;const a=r(34567),i=t(r(3983));n.makeIssue=e=>{const{data:n,path:r,errorMaps:t,issueData:a}=e,i=[...r,...a.path||[]],o={...a,path:i};let s="";const l=t.filter((e=>!!e)).slice().reverse();for(const e of l)s=e(o,{data:n,defaultError:s}).message;return{...a,path:i,message:a.message||s}},n.EMPTY_PATH=[],n.addIssueToContext=function(e,r){const t=(0,n.makeIssue)({issueData:r,data:e.data,path:e.path,errorMaps:[e.common.contextualErrorMap,e.schemaErrorMap,(0,a.getErrorMap)(),i.default].filter((e=>!!e))});e.common.issues.push(t)};class o{constructor(){this.value="valid"}dirty(){"valid"===this.value&&(this.value="dirty")}abort(){"aborted"!==this.value&&(this.value="aborted")}static mergeArray(e,r){const t=[];for(const a of r){if("aborted"===a.status)return n.INVALID;"dirty"===a.status&&e.dirty(),t.push(a.value)}return{status:e.value,value:t}}static async mergeObjectAsync(e,n){const r=[];for(const e of n)r.push({key:await e.key,value:await e.value});return o.mergeObjectSync(e,r)}static mergeObjectSync(e,r){const t={};for(const a of r){const{key:r,value:i}=a;if("aborted"===r.status)return n.INVALID;if("aborted"===i.status)return n.INVALID;"dirty"===r.status&&e.dirty(),"dirty"===i.status&&e.dirty(),"__proto__"===r.value||void 0===i.value&&!a.alwaysSet||(t[r.value]=i.value)}return{status:e.value,value:t}}}n.ParseStatus=o,n.INVALID=Object.freeze({status:"aborted"});n.DIRTY=e=>({status:"dirty",value:e});n.OK=e=>({status:"valid",value:e});n.isAborted=e=>"aborted"===e.status;n.isDirty=e=>"dirty"===e.status;n.isValid=e=>"valid"===e.status;n.isAsync=e=>"undefined"!=typeof Promise&&e instanceof Promise},38768:function(e,n){Object.defineProperty(n,"__esModule",{value:!0})},29694:function(e,n){var r;Object.defineProperty(n,"__esModule",{value:!0}),n.getParsedType=n.ZodParsedType=n.objectUtil=n.util=void 0,function(e){e.assertEqual=e=>e,e.assertIs=function(e){},e.assertNever=function(e){throw new Error},e.arrayToEnum=e=>{const n={};for(const r of e)n[r]=r;return n},e.getValidEnumValues=n=>{const r=e.objectKeys(n).filter((e=>"number"!=typeof n[n[e]])),t={};for(const e of r)t[e]=n[e];return e.objectValues(t)},e.objectValues=n=>e.objectKeys(n).map((function(e){return n[e]})),e.objectKeys="function"==typeof Object.keys?e=>Object.keys(e):e=>{const n=[];for(const r in e)Object.prototype.hasOwnProperty.call(e,r)&&n.push(r);return n},e.find=(e,n)=>{for(const r of e)if(n(r))return r},e.isInteger="function"==typeof Number.isInteger?e=>Number.isInteger(e):e=>"number"==typeof e&&isFinite(e)&&Math.floor(e)===e,e.joinValues=function(e,n=" | "){return e.map((e=>"string"==typeof e?`'${e}'`:e)).join(n)},e.jsonStringifyReplacer=(e,n)=>"bigint"==typeof n?n.toString():n}(r=n.util||(n.util={})),function(e){e.mergeShapes=(e,n)=>({...e,...n})}(n.objectUtil||(n.objectUtil={})),n.ZodParsedType=r.arrayToEnum(["string","nan","number","integer","float","boolean","date","bigint","symbol","function","undefined","null","array","object","unknown","promise","void","never","map","set"]);n.getParsedType=e=>{switch(typeof e){case"undefined":return n.ZodParsedType.undefined;case"string":return n.ZodParsedType.string;case"number":return isNaN(e)?n.ZodParsedType.nan:n.ZodParsedType.number;case"boolean":return n.ZodParsedType.boolean;case"function":return n.ZodParsedType.function;case"bigint":return n.ZodParsedType.bigint;case"symbol":return n.ZodParsedType.symbol;case"object":return Array.isArray(e)?n.ZodParsedType.array:null===e?n.ZodParsedType.null:e.then&&"function"==typeof e.then&&e.catch&&"function"==typeof e.catch?n.ZodParsedType.promise:"undefined"!=typeof Map&&e instanceof Map?n.ZodParsedType.map:"undefined"!=typeof Set&&e instanceof Set?n.ZodParsedType.set:"undefined"!=typeof Date&&e instanceof Date?n.ZodParsedType.date:n.ZodParsedType.object;default:return n.ZodParsedType.unknown}}},56530:function(e,n,r){var t=this&&this.__createBinding||(Object.create?function(e,n,r,t){void 0===t&&(t=r),Object.defineProperty(e,t,{enumerable:!0,get:function(){return n[r]}})}:function(e,n,r,t){void 0===t&&(t=r),e[t]=n[r]}),a=this&&this.__setModuleDefault||(Object.create?function(e,n){Object.defineProperty(e,"default",{enumerable:!0,value:n})}:function(e,n){e.default=n}),i=this&&this.__importStar||function(e){if(e&&e.__esModule)return e;var n={};if(null!=e)for(var r in e)"default"!==r&&Object.prototype.hasOwnProperty.call(e,r)&&t(n,e,r);return a(n,e),n},o=this&&this.__exportStar||function(e,n){for(var r in e)"default"===r||Object.prototype.hasOwnProperty.call(n,r)||t(n,e,r)};Object.defineProperty(n,"__esModule",{value:!0}),n.z=void 0;const s=i(r(69687));n.z=s,o(r(69687),n),n.default=s},3983:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0});const t=r(29694),a=r(95225);n.default=(e,n)=>{let r;switch(e.code){case a.ZodIssueCode.invalid_type:r=e.received===t.ZodParsedType.undefined?"Required":`Expected ${e.expected}, received ${e.received}`;break;case a.ZodIssueCode.invalid_literal:r=`Invalid literal value, expected ${JSON.stringify(e.expected,t.util.jsonStringifyReplacer)}`;break;case a.ZodIssueCode.unrecognized_keys:r=`Unrecognized key(s) in object: ${t.util.joinValues(e.keys,", ")}`;break;case a.ZodIssueCode.invalid_union:r="Invalid input";break;case a.ZodIssueCode.invalid_union_discriminator:r=`Invalid discriminator value. Expected ${t.util.joinValues(e.options)}`;break;case a.ZodIssueCode.invalid_enum_value:r=`Invalid enum value. Expected ${t.util.joinValues(e.options)}, received '${e.received}'`;break;case a.ZodIssueCode.invalid_arguments:r="Invalid function arguments";break;case a.ZodIssueCode.invalid_return_type:r="Invalid function return type";break;case a.ZodIssueCode.invalid_date:r="Invalid date";break;case a.ZodIssueCode.invalid_string:"object"==typeof e.validation?"includes"in e.validation?(r=`Invalid input: must include "${e.validation.includes}"`,"number"==typeof e.validation.position&&(r=`${r} at one or more positions greater than or equal to ${e.validation.position}`)):"startsWith"in e.validation?r=`Invalid input: must start with "${e.validation.startsWith}"`:"endsWith"in e.validation?r=`Invalid input: must end with "${e.validation.endsWith}"`:t.util.assertNever(e.validation):r="regex"!==e.validation?`Invalid ${e.validation}`:"Invalid";break;case a.ZodIssueCode.too_small:r="array"===e.type?`Array must contain ${e.exact?"exactly":e.inclusive?"at least":"more than"} ${e.minimum} element(s)`:"string"===e.type?`String must contain ${e.exact?"exactly":e.inclusive?"at least":"over"} ${e.minimum} character(s)`:"number"===e.type?`Number must be ${e.exact?"exactly equal to ":e.inclusive?"greater than or equal to ":"greater than "}${e.minimum}`:"date"===e.type?`Date must be ${e.exact?"exactly equal to ":e.inclusive?"greater than or equal to ":"greater than "}${new Date(Number(e.minimum))}`:"Invalid input";break;case a.ZodIssueCode.too_big:r="array"===e.type?`Array must contain ${e.exact?"exactly":e.inclusive?"at most":"less than"} ${e.maximum} element(s)`:"string"===e.type?`String must contain ${e.exact?"exactly":e.inclusive?"at most":"under"} ${e.maximum} character(s)`:"number"===e.type?`Number must be ${e.exact?"exactly":e.inclusive?"less than or equal to":"less than"} ${e.maximum}`:"bigint"===e.type?`BigInt must be ${e.exact?"exactly":e.inclusive?"less than or equal to":"less than"} ${e.maximum}`:"date"===e.type?`Date must be ${e.exact?"exactly":e.inclusive?"smaller than or equal to":"smaller than"} ${new Date(Number(e.maximum))}`:"Invalid input";break;case a.ZodIssueCode.custom:r="Invalid input";break;case a.ZodIssueCode.invalid_intersection_types:r="Intersection results could not be merged";break;case a.ZodIssueCode.not_multiple_of:r=`Number must be a multiple of ${e.multipleOf}`;break;case a.ZodIssueCode.not_finite:r="Number must be finite";break;default:r=n.defaultError,t.util.assertNever(e)}return{message:r}}},36655:function(e,n,r){Object.defineProperty(n,"__esModule",{value:!0}),n.date=n.boolean=n.bigint=n.array=n.any=n.coerce=n.ZodFirstPartyTypeKind=n.late=n.ZodSchema=n.Schema=n.custom=n.ZodReadonly=n.ZodPipeline=n.ZodBranded=n.BRAND=n.ZodNaN=n.ZodCatch=n.ZodDefault=n.ZodNullable=n.ZodOptional=n.ZodTransformer=n.ZodEffects=n.ZodPromise=n.ZodNativeEnum=n.ZodEnum=n.ZodLiteral=n.ZodLazy=n.ZodFunction=n.ZodSet=n.ZodMap=n.ZodRecord=n.ZodTuple=n.ZodIntersection=n.ZodDiscriminatedUnion=n.ZodUnion=n.ZodObject=n.ZodArray=n.ZodVoid=n.ZodNever=n.ZodUnknown=n.ZodAny=n.ZodNull=n.ZodUndefined=n.ZodSymbol=n.ZodDate=n.ZodBoolean=n.ZodBigInt=n.ZodNumber=n.ZodString=n.ZodType=void 0,n.NEVER=n.void=n.unknown=n.union=n.undefined=n.tuple=n.transformer=n.symbol=n.string=n.strictObject=n.set=n.record=n.promise=n.preprocess=n.pipeline=n.ostring=n.optional=n.onumber=n.oboolean=n.object=n.number=n.nullable=n.null=n.never=n.nativeEnum=n.nan=n.map=n.literal=n.lazy=n.intersection=n.instanceof=n.function=n.enum=n.effect=n.discriminatedUnion=void 0;const t=r(34567),a=r(36650),i=r(69915),o=r(29694),s=r(95225);class l{constructor(e,n,r,t){this._cachedPath=[],this.parent=e,this.data=n,this._path=r,this._key=t}get path(){return this._cachedPath.length||(this._key instanceof Array?this._cachedPath.push(...this._path,...this._key):this._cachedPath.push(...this._path,this._key)),this._cachedPath}}const u=(e,n)=>{if((0,i.isValid)(n))return{success:!0,data:n.value};if(!e.common.issues.length)throw new Error("Validation failed but no issues detected.");return{success:!1,get error(){if(this._error)return this._error;const n=new s.ZodError(e.common.issues);return this._error=n,this._error}}};function c(e){if(!e)return{};const{errorMap:n,invalid_type_error:r,required_error:t,description:a}=e;if(n&&(r||t))throw new Error('Can\'t use "invalid_type_error" or "required_error" in conjunction with custom error map.');if(n)return{errorMap:n,description:a};return{errorMap:(e,n)=>"invalid_type"!==e.code?{message:n.defaultError}:void 0===n.data?{message:null!=t?t:n.defaultError}:{message:null!=r?r:n.defaultError},description:a}}class d{constructor(e){this.spa=this.safeParseAsync,this._def=e,this.parse=this.parse.bind(this),this.safeParse=this.safeParse.bind(this),this.parseAsync=this.parseAsync.bind(this),this.safeParseAsync=this.safeParseAsync.bind(this),this.spa=this.spa.bind(this),this.refine=this.refine.bind(this),this.refinement=this.refinement.bind(this),this.superRefine=this.superRefine.bind(this),this.optional=this.optional.bind(this),this.nullable=this.nullable.bind(this),this.nullish=this.nullish.bind(this),this.array=this.array.bind(this),this.promise=this.promise.bind(this),this.or=this.or.bind(this),this.and=this.and.bind(this),this.transform=this.transform.bind(this),this.brand=this.brand.bind(this),this.default=this.default.bind(this),this.catch=this.catch.bind(this),this.describe=this.describe.bind(this),this.pipe=this.pipe.bind(this),this.readonly=this.readonly.bind(this),this.isNullable=this.isNullable.bind(this),this.isOptional=this.isOptional.bind(this)}get description(){return this._def.description}_getType(e){return(0,o.getParsedType)(e.data)}_getOrReturnCtx(e,n){return n||{common:e.parent.common,data:e.data,parsedType:(0,o.getParsedType)(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}_processInputParams(e){return{status:new i.ParseStatus,ctx:{common:e.parent.common,data:e.data,parsedType:(0,o.getParsedType)(e.data),schemaErrorMap:this._def.errorMap,path:e.path,parent:e.parent}}}_parseSync(e){const n=this._parse(e);if((0,i.isAsync)(n))throw new Error("Synchronous parse encountered promise.");return n}_parseAsync(e){const n=this._parse(e);return Promise.resolve(n)}parse(e,n){const r=this.safeParse(e,n);if(r.success)return r.data;throw r.error}safeParse(e,n){var r;const t={common:{issues:[],async:null!==(r=null==n?void 0:n.async)&&void 0!==r&&r,contextualErrorMap:null==n?void 0:n.errorMap},path:(null==n?void 0:n.path)||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:(0,o.getParsedType)(e)},a=this._parseSync({data:e,path:t.path,parent:t});return u(t,a)}async parseAsync(e,n){const r=await this.safeParseAsync(e,n);if(r.success)return r.data;throw r.error}async safeParseAsync(e,n){const r={common:{issues:[],contextualErrorMap:null==n?void 0:n.errorMap,async:!0},path:(null==n?void 0:n.path)||[],schemaErrorMap:this._def.errorMap,parent:null,data:e,parsedType:(0,o.getParsedType)(e)},t=this._parse({data:e,path:r.path,parent:r}),a=await((0,i.isAsync)(t)?t:Promise.resolve(t));return u(r,a)}refine(e,n){const r=e=>"string"==typeof n||void 0===n?{message:n}:"function"==typeof n?n(e):n;return this._refinement(((n,t)=>{const a=e(n),i=()=>t.addIssue({code:s.ZodIssueCode.custom,...r(n)});return"undefined"!=typeof Promise&&a instanceof Promise?a.then((e=>!!e||(i(),!1))):!!a||(i(),!1)}))}refinement(e,n){return this._refinement(((r,t)=>!!e(r)||(t.addIssue("function"==typeof n?n(r,t):n),!1)))}_refinement(e){return new $({schema:this,typeName:se.ZodEffects,effect:{type:"refinement",refinement:e}})}superRefine(e){return this._refinement(e)}optional(){return Q.create(this,this._def)}nullable(){return ee.create(this,this._def)}nullish(){return this.nullable().optional()}array(){return N.create(this,this._def)}promise(){return K.create(this,this._def)}or(e){return M.create([this,e],this._def)}and(e){return B.create(this,e,this._def)}transform(e){return new $({...c(this._def),schema:this,typeName:se.ZodEffects,effect:{type:"transform",transform:e}})}default(e){const n="function"==typeof e?e:()=>e;return new ne({...c(this._def),innerType:this,defaultValue:n,typeName:se.ZodDefault})}brand(){return new ae({typeName:se.ZodBranded,type:this,...c(this._def)})}catch(e){const n="function"==typeof e?e:()=>e;return new re({...c(this._def),innerType:this,catchValue:n,typeName:se.ZodCatch})}describe(e){return new(0,this.constructor)({...this._def,description:e})}pipe(e){return ie.create(this,e)}readonly(){return oe.create(this)}isOptional(){return this.safeParse(void 0).success}isNullable(){return this.safeParse(null).success}}n.ZodType=d,n.Schema=d,n.ZodSchema=d;const p=/^c[^\s-]{8,}$/i,g=/^[a-z][a-z0-9]*$/,f=/^[0-9A-HJKMNP-TV-Z]{26}$/,m=/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i,v=/^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;let h;const y=/^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/,P=/^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;class C extends d{_parse(e){this._def.coerce&&(e.data=String(e.data));if(this._getType(e)!==o.ZodParsedType.string){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.string,received:n.parsedType}),i.INVALID}const n=new i.ParseStatus;let r;for(const u of this._def.checks)if("min"===u.kind)e.data.length<u.value&&(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_small,minimum:u.value,type:"string",inclusive:!0,exact:!1,message:u.message}),n.dirty());else if("max"===u.kind)e.data.length>u.value&&(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_big,maximum:u.value,type:"string",inclusive:!0,exact:!1,message:u.message}),n.dirty());else if("length"===u.kind){const t=e.data.length>u.value,a=e.data.length<u.value;(t||a)&&(r=this._getOrReturnCtx(e,r),t?(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_big,maximum:u.value,type:"string",inclusive:!0,exact:!0,message:u.message}):a&&(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_small,minimum:u.value,type:"string",inclusive:!0,exact:!0,message:u.message}),n.dirty())}else if("email"===u.kind)v.test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"email",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty());else if("emoji"===u.kind)h||(h=new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$","u")),h.test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"emoji",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty());else if("uuid"===u.kind)m.test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"uuid",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty());else if("cuid"===u.kind)p.test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"cuid",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty());else if("cuid2"===u.kind)g.test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"cuid2",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty());else if("ulid"===u.kind)f.test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"ulid",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty());else if("url"===u.kind)try{new URL(e.data)}catch(t){r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"url",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty()}else if("regex"===u.kind){u.regex.lastIndex=0;u.regex.test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"regex",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty())}else if("trim"===u.kind)e.data=e.data.trim();else if("includes"===u.kind)e.data.includes(u.value,u.position)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_string,validation:{includes:u.value,position:u.position},message:u.message}),n.dirty());else if("toLowerCase"===u.kind)e.data=e.data.toLowerCase();else if("toUpperCase"===u.kind)e.data=e.data.toUpperCase();else if("startsWith"===u.kind)e.data.startsWith(u.value)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_string,validation:{startsWith:u.value},message:u.message}),n.dirty());else if("endsWith"===u.kind)e.data.endsWith(u.value)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_string,validation:{endsWith:u.value},message:u.message}),n.dirty());else if("datetime"===u.kind){((l=u).precision?l.offset?new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${l.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`):new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${l.precision}}Z$`):0===l.precision?l.offset?new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$"):new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$"):l.offset?new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$"):new RegExp("^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$")).test(e.data)||(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_string,validation:"datetime",message:u.message}),n.dirty())}else"ip"===u.kind?(t=e.data,("v4"!==(a=u.version)&&a||!y.test(t))&&("v6"!==a&&a||!P.test(t))&&(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{validation:"ip",code:s.ZodIssueCode.invalid_string,message:u.message}),n.dirty())):o.util.assertNever(u);var t,a,l;return{status:n.value,value:e.data}}_regex(e,n,r){return this.refinement((n=>e.test(n)),{validation:n,code:s.ZodIssueCode.invalid_string,...a.errorUtil.errToObj(r)})}_addCheck(e){return new C({...this._def,checks:[...this._def.checks,e]})}email(e){return this._addCheck({kind:"email",...a.errorUtil.errToObj(e)})}url(e){return this._addCheck({kind:"url",...a.errorUtil.errToObj(e)})}emoji(e){return this._addCheck({kind:"emoji",...a.errorUtil.errToObj(e)})}uuid(e){return this._addCheck({kind:"uuid",...a.errorUtil.errToObj(e)})}cuid(e){return this._addCheck({kind:"cuid",...a.errorUtil.errToObj(e)})}cuid2(e){return this._addCheck({kind:"cuid2",...a.errorUtil.errToObj(e)})}ulid(e){return this._addCheck({kind:"ulid",...a.errorUtil.errToObj(e)})}ip(e){return this._addCheck({kind:"ip",...a.errorUtil.errToObj(e)})}datetime(e){var n;return"string"==typeof e?this._addCheck({kind:"datetime",precision:null,offset:!1,message:e}):this._addCheck({kind:"datetime",precision:void 0===(null==e?void 0:e.precision)?null:null==e?void 0:e.precision,offset:null!==(n=null==e?void 0:e.offset)&&void 0!==n&&n,...a.errorUtil.errToObj(null==e?void 0:e.message)})}regex(e,n){return this._addCheck({kind:"regex",regex:e,...a.errorUtil.errToObj(n)})}includes(e,n){return this._addCheck({kind:"includes",value:e,position:null==n?void 0:n.position,...a.errorUtil.errToObj(null==n?void 0:n.message)})}startsWith(e,n){return this._addCheck({kind:"startsWith",value:e,...a.errorUtil.errToObj(n)})}endsWith(e,n){return this._addCheck({kind:"endsWith",value:e,...a.errorUtil.errToObj(n)})}min(e,n){return this._addCheck({kind:"min",value:e,...a.errorUtil.errToObj(n)})}max(e,n){return this._addCheck({kind:"max",value:e,...a.errorUtil.errToObj(n)})}length(e,n){return this._addCheck({kind:"length",value:e,...a.errorUtil.errToObj(n)})}nonempty(e){return this.min(1,a.errorUtil.errToObj(e))}trim(){return new C({...this._def,checks:[...this._def.checks,{kind:"trim"}]})}toLowerCase(){return new C({...this._def,checks:[...this._def.checks,{kind:"toLowerCase"}]})}toUpperCase(){return new C({...this._def,checks:[...this._def.checks,{kind:"toUpperCase"}]})}get isDatetime(){return!!this._def.checks.find((e=>"datetime"===e.kind))}get isEmail(){return!!this._def.checks.find((e=>"email"===e.kind))}get isURL(){return!!this._def.checks.find((e=>"url"===e.kind))}get isEmoji(){return!!this._def.checks.find((e=>"emoji"===e.kind))}get isUUID(){return!!this._def.checks.find((e=>"uuid"===e.kind))}get isCUID(){return!!this._def.checks.find((e=>"cuid"===e.kind))}get isCUID2(){return!!this._def.checks.find((e=>"cuid2"===e.kind))}get isULID(){return!!this._def.checks.find((e=>"ulid"===e.kind))}get isIP(){return!!this._def.checks.find((e=>"ip"===e.kind))}get minLength(){let e=null;for(const n of this._def.checks)"min"===n.kind&&(null===e||n.value>e)&&(e=n.value);return e}get maxLength(){let e=null;for(const n of this._def.checks)"max"===n.kind&&(null===e||n.value<e)&&(e=n.value);return e}}function w(e,n){const r=(e.toString().split(".")[1]||"").length,t=(n.toString().split(".")[1]||"").length,a=r>t?r:t;return parseInt(e.toFixed(a).replace(".",""))%parseInt(n.toFixed(a).replace(".",""))/Math.pow(10,a)}n.ZodString=C,C.create=e=>{var n;return new C({checks:[],typeName:se.ZodString,coerce:null!==(n=null==e?void 0:e.coerce)&&void 0!==n&&n,...c(e)})};class I extends d{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte,this.step=this.multipleOf}_parse(e){this._def.coerce&&(e.data=Number(e.data));if(this._getType(e)!==o.ZodParsedType.number){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.number,received:n.parsedType}),i.INVALID}let n;const r=new i.ParseStatus;for(const t of this._def.checks)if("int"===t.kind)o.util.isInteger(e.data)||(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:"integer",received:"float",message:t.message}),r.dirty());else if("min"===t.kind){(t.inclusive?e.data<t.value:e.data<=t.value)&&(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.too_small,minimum:t.value,type:"number",inclusive:t.inclusive,exact:!1,message:t.message}),r.dirty())}else if("max"===t.kind){(t.inclusive?e.data>t.value:e.data>=t.value)&&(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.too_big,maximum:t.value,type:"number",inclusive:t.inclusive,exact:!1,message:t.message}),r.dirty())}else"multipleOf"===t.kind?0!==w(e.data,t.value)&&(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.not_multiple_of,multipleOf:t.value,message:t.message}),r.dirty()):"finite"===t.kind?Number.isFinite(e.data)||(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.not_finite,message:t.message}),r.dirty()):o.util.assertNever(t);return{status:r.value,value:e.data}}gte(e,n){return this.setLimit("min",e,!0,a.errorUtil.toString(n))}gt(e,n){return this.setLimit("min",e,!1,a.errorUtil.toString(n))}lte(e,n){return this.setLimit("max",e,!0,a.errorUtil.toString(n))}lt(e,n){return this.setLimit("max",e,!1,a.errorUtil.toString(n))}setLimit(e,n,r,t){return new I({...this._def,checks:[...this._def.checks,{kind:e,value:n,inclusive:r,message:a.errorUtil.toString(t)}]})}_addCheck(e){return new I({...this._def,checks:[...this._def.checks,e]})}int(e){return this._addCheck({kind:"int",message:a.errorUtil.toString(e)})}positive(e){return this._addCheck({kind:"min",value:0,inclusive:!1,message:a.errorUtil.toString(e)})}negative(e){return this._addCheck({kind:"max",value:0,inclusive:!1,message:a.errorUtil.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:0,inclusive:!0,message:a.errorUtil.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:0,inclusive:!0,message:a.errorUtil.toString(e)})}multipleOf(e,n){return this._addCheck({kind:"multipleOf",value:e,message:a.errorUtil.toString(n)})}finite(e){return this._addCheck({kind:"finite",message:a.errorUtil.toString(e)})}safe(e){return this._addCheck({kind:"min",inclusive:!0,value:Number.MIN_SAFE_INTEGER,message:a.errorUtil.toString(e)})._addCheck({kind:"max",inclusive:!0,value:Number.MAX_SAFE_INTEGER,message:a.errorUtil.toString(e)})}get minValue(){let e=null;for(const n of this._def.checks)"min"===n.kind&&(null===e||n.value>e)&&(e=n.value);return e}get maxValue(){let e=null;for(const n of this._def.checks)"max"===n.kind&&(null===e||n.value<e)&&(e=n.value);return e}get isInt(){return!!this._def.checks.find((e=>"int"===e.kind||"multipleOf"===e.kind&&o.util.isInteger(e.value)))}get isFinite(){let e=null,n=null;for(const r of this._def.checks){if("finite"===r.kind||"int"===r.kind||"multipleOf"===r.kind)return!0;"min"===r.kind?(null===n||r.value>n)&&(n=r.value):"max"===r.kind&&(null===e||r.value<e)&&(e=r.value)}return Number.isFinite(n)&&Number.isFinite(e)}}n.ZodNumber=I,I.create=e=>new I({checks:[],typeName:se.ZodNumber,coerce:(null==e?void 0:e.coerce)||!1,...c(e)});class O extends d{constructor(){super(...arguments),this.min=this.gte,this.max=this.lte}_parse(e){this._def.coerce&&(e.data=BigInt(e.data));if(this._getType(e)!==o.ZodParsedType.bigint){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.bigint,received:n.parsedType}),i.INVALID}let n;const r=new i.ParseStatus;for(const t of this._def.checks)if("min"===t.kind){(t.inclusive?e.data<t.value:e.data<=t.value)&&(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.too_small,type:"bigint",minimum:t.value,inclusive:t.inclusive,message:t.message}),r.dirty())}else if("max"===t.kind){(t.inclusive?e.data>t.value:e.data>=t.value)&&(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.too_big,type:"bigint",maximum:t.value,inclusive:t.inclusive,message:t.message}),r.dirty())}else"multipleOf"===t.kind?e.data%t.value!==BigInt(0)&&(n=this._getOrReturnCtx(e,n),(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.not_multiple_of,multipleOf:t.value,message:t.message}),r.dirty()):o.util.assertNever(t);return{status:r.value,value:e.data}}gte(e,n){return this.setLimit("min",e,!0,a.errorUtil.toString(n))}gt(e,n){return this.setLimit("min",e,!1,a.errorUtil.toString(n))}lte(e,n){return this.setLimit("max",e,!0,a.errorUtil.toString(n))}lt(e,n){return this.setLimit("max",e,!1,a.errorUtil.toString(n))}setLimit(e,n,r,t){return new O({...this._def,checks:[...this._def.checks,{kind:e,value:n,inclusive:r,message:a.errorUtil.toString(t)}]})}_addCheck(e){return new O({...this._def,checks:[...this._def.checks,e]})}positive(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!1,message:a.errorUtil.toString(e)})}negative(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!1,message:a.errorUtil.toString(e)})}nonpositive(e){return this._addCheck({kind:"max",value:BigInt(0),inclusive:!0,message:a.errorUtil.toString(e)})}nonnegative(e){return this._addCheck({kind:"min",value:BigInt(0),inclusive:!0,message:a.errorUtil.toString(e)})}multipleOf(e,n){return this._addCheck({kind:"multipleOf",value:e,message:a.errorUtil.toString(n)})}get minValue(){let e=null;for(const n of this._def.checks)"min"===n.kind&&(null===e||n.value>e)&&(e=n.value);return e}get maxValue(){let e=null;for(const n of this._def.checks)"max"===n.kind&&(null===e||n.value<e)&&(e=n.value);return e}}n.ZodBigInt=O,O.create=e=>{var n;return new O({checks:[],typeName:se.ZodBigInt,coerce:null!==(n=null==e?void 0:e.coerce)&&void 0!==n&&n,...c(e)})};class b extends d{_parse(e){this._def.coerce&&(e.data=Boolean(e.data));if(this._getType(e)!==o.ZodParsedType.boolean){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.boolean,received:n.parsedType}),i.INVALID}return(0,i.OK)(e.data)}}n.ZodBoolean=b,b.create=e=>new b({typeName:se.ZodBoolean,coerce:(null==e?void 0:e.coerce)||!1,...c(e)});class A extends d{_parse(e){this._def.coerce&&(e.data=new Date(e.data));if(this._getType(e)!==o.ZodParsedType.date){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.date,received:n.parsedType}),i.INVALID}if(isNaN(e.data.getTime())){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_date}),i.INVALID}const n=new i.ParseStatus;let r;for(const t of this._def.checks)"min"===t.kind?e.data.getTime()<t.value&&(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_small,message:t.message,inclusive:!0,exact:!1,minimum:t.value,type:"date"}),n.dirty()):"max"===t.kind?e.data.getTime()>t.value&&(r=this._getOrReturnCtx(e,r),(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_big,message:t.message,inclusive:!0,exact:!1,maximum:t.value,type:"date"}),n.dirty()):o.util.assertNever(t);return{status:n.value,value:new Date(e.data.getTime())}}_addCheck(e){return new A({...this._def,checks:[...this._def.checks,e]})}min(e,n){return this._addCheck({kind:"min",value:e.getTime(),message:a.errorUtil.toString(n)})}max(e,n){return this._addCheck({kind:"max",value:e.getTime(),message:a.errorUtil.toString(n)})}get minDate(){let e=null;for(const n of this._def.checks)"min"===n.kind&&(null===e||n.value>e)&&(e=n.value);return null!=e?new Date(e):null}get maxDate(){let e=null;for(const n of this._def.checks)"max"===n.kind&&(null===e||n.value<e)&&(e=n.value);return null!=e?new Date(e):null}}n.ZodDate=A,A.create=e=>new A({checks:[],coerce:(null==e?void 0:e.coerce)||!1,typeName:se.ZodDate,...c(e)});class T extends d{_parse(e){if(this._getType(e)!==o.ZodParsedType.symbol){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.symbol,received:n.parsedType}),i.INVALID}return(0,i.OK)(e.data)}}n.ZodSymbol=T,T.create=e=>new T({typeName:se.ZodSymbol,...c(e)});class R extends d{_parse(e){if(this._getType(e)!==o.ZodParsedType.undefined){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.undefined,received:n.parsedType}),i.INVALID}return(0,i.OK)(e.data)}}n.ZodUndefined=R,R.create=e=>new R({typeName:se.ZodUndefined,...c(e)});class _ extends d{_parse(e){if(this._getType(e)!==o.ZodParsedType.null){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.null,received:n.parsedType}),i.INVALID}return(0,i.OK)(e.data)}}n.ZodNull=_,_.create=e=>new _({typeName:se.ZodNull,...c(e)});class E extends d{constructor(){super(...arguments),this._any=!0}_parse(e){return(0,i.OK)(e.data)}}n.ZodAny=E,E.create=e=>new E({typeName:se.ZodAny,...c(e)});class D extends d{constructor(){super(...arguments),this._unknown=!0}_parse(e){return(0,i.OK)(e.data)}}n.ZodUnknown=D,D.create=e=>new D({typeName:se.ZodUnknown,...c(e)});class L extends d{_parse(e){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.never,received:n.parsedType}),i.INVALID}}n.ZodNever=L,L.create=e=>new L({typeName:se.ZodNever,...c(e)});class S extends d{_parse(e){if(this._getType(e)!==o.ZodParsedType.undefined){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.void,received:n.parsedType}),i.INVALID}return(0,i.OK)(e.data)}}n.ZodVoid=S,S.create=e=>new S({typeName:se.ZodVoid,...c(e)});class N extends d{_parse(e){const{ctx:n,status:r}=this._processInputParams(e),t=this._def;if(n.parsedType!==o.ZodParsedType.array)return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.array,received:n.parsedType}),i.INVALID;if(null!==t.exactLength){const e=n.data.length>t.exactLength.value,a=n.data.length<t.exactLength.value;(e||a)&&((0,i.addIssueToContext)(n,{code:e?s.ZodIssueCode.too_big:s.ZodIssueCode.too_small,minimum:a?t.exactLength.value:void 0,maximum:e?t.exactLength.value:void 0,type:"array",inclusive:!0,exact:!0,message:t.exactLength.message}),r.dirty())}if(null!==t.minLength&&n.data.length<t.minLength.value&&((0,i.addIssueToContext)(n,{code:s.ZodIssueCode.too_small,minimum:t.minLength.value,type:"array",inclusive:!0,exact:!1,message:t.minLength.message}),r.dirty()),null!==t.maxLength&&n.data.length>t.maxLength.value&&((0,i.addIssueToContext)(n,{code:s.ZodIssueCode.too_big,maximum:t.maxLength.value,type:"array",inclusive:!0,exact:!1,message:t.maxLength.message}),r.dirty()),n.common.async)return Promise.all([...n.data].map(((e,r)=>t.type._parseAsync(new l(n,e,n.path,r))))).then((e=>i.ParseStatus.mergeArray(r,e)));const a=[...n.data].map(((e,r)=>t.type._parseSync(new l(n,e,n.path,r))));return i.ParseStatus.mergeArray(r,a)}get element(){return this._def.type}min(e,n){return new N({...this._def,minLength:{value:e,message:a.errorUtil.toString(n)}})}max(e,n){return new N({...this._def,maxLength:{value:e,message:a.errorUtil.toString(n)}})}length(e,n){return new N({...this._def,exactLength:{value:e,message:a.errorUtil.toString(n)}})}nonempty(e){return this.min(1,e)}}function k(e){if(e instanceof j){const n={};for(const r in e.shape){const t=e.shape[r];n[r]=Q.create(k(t))}return new j({...e._def,shape:()=>n})}return e instanceof N?new N({...e._def,type:k(e.element)}):e instanceof Q?Q.create(k(e.unwrap())):e instanceof ee?ee.create(k(e.unwrap())):e instanceof W?W.create(e.items.map((e=>k(e)))):e}n.ZodArray=N,N.create=(e,n)=>new N({type:e,minLength:null,maxLength:null,exactLength:null,typeName:se.ZodArray,...c(n)});class j extends d{constructor(){super(...arguments),this._cached=null,this.nonstrict=this.passthrough,this.augment=this.extend}_getCached(){if(null!==this._cached)return this._cached;const e=this._def.shape(),n=o.util.objectKeys(e);return this._cached={shape:e,keys:n}}_parse(e){if(this._getType(e)!==o.ZodParsedType.object){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.object,received:n.parsedType}),i.INVALID}const{status:n,ctx:r}=this._processInputParams(e),{shape:t,keys:a}=this._getCached(),u=[];if(!(this._def.catchall instanceof L&&"strip"===this._def.unknownKeys))for(const e in r.data)a.includes(e)||u.push(e);const c=[];for(const e of a){const n=t[e],a=r.data[e];c.push({key:{status:"valid",value:e},value:n._parse(new l(r,a,r.path,e)),alwaysSet:e in r.data})}if(this._def.catchall instanceof L){const e=this._def.unknownKeys;if("passthrough"===e)for(const e of u)c.push({key:{status:"valid",value:e},value:{status:"valid",value:r.data[e]}});else if("strict"===e)u.length>0&&((0,i.addIssueToContext)(r,{code:s.ZodIssueCode.unrecognized_keys,keys:u}),n.dirty());else if("strip"!==e)throw new Error("Internal ZodObject error: invalid unknownKeys value.")}else{const e=this._def.catchall;for(const n of u){const t=r.data[n];c.push({key:{status:"valid",value:n},value:e._parse(new l(r,t,r.path,n)),alwaysSet:n in r.data})}}return r.common.async?Promise.resolve().then((async()=>{const e=[];for(const n of c){const r=await n.key;e.push({key:r,value:await n.value,alwaysSet:n.alwaysSet})}return e})).then((e=>i.ParseStatus.mergeObjectSync(n,e))):i.ParseStatus.mergeObjectSync(n,c)}get shape(){return this._def.shape()}strict(e){return a.errorUtil.errToObj,new j({...this._def,unknownKeys:"strict",...void 0!==e?{errorMap:(n,r)=>{var t,i,o,s;const l=null!==(o=null===(i=(t=this._def).errorMap)||void 0===i?void 0:i.call(t,n,r).message)&&void 0!==o?o:r.defaultError;return"unrecognized_keys"===n.code?{message:null!==(s=a.errorUtil.errToObj(e).message)&&void 0!==s?s:l}:{message:l}}}:{}})}strip(){return new j({...this._def,unknownKeys:"strip"})}passthrough(){return new j({...this._def,unknownKeys:"passthrough"})}extend(e){return new j({...this._def,shape:()=>({...this._def.shape(),...e})})}merge(e){return new j({unknownKeys:e._def.unknownKeys,catchall:e._def.catchall,shape:()=>({...this._def.shape(),...e._def.shape()}),typeName:se.ZodObject})}setKey(e,n){return this.augment({[e]:n})}catchall(e){return new j({...this._def,catchall:e})}pick(e){const n={};return o.util.objectKeys(e).forEach((r=>{e[r]&&this.shape[r]&&(n[r]=this.shape[r])})),new j({...this._def,shape:()=>n})}omit(e){const n={};return o.util.objectKeys(this.shape).forEach((r=>{e[r]||(n[r]=this.shape[r])})),new j({...this._def,shape:()=>n})}deepPartial(){return k(this)}partial(e){const n={};return o.util.objectKeys(this.shape).forEach((r=>{const t=this.shape[r];e&&!e[r]?n[r]=t:n[r]=t.optional()})),new j({...this._def,shape:()=>n})}required(e){const n={};return o.util.objectKeys(this.shape).forEach((r=>{if(e&&!e[r])n[r]=this.shape[r];else{let e=this.shape[r];for(;e instanceof Q;)e=e._def.innerType;n[r]=e}})),new j({...this._def,shape:()=>n})}keyof(){return q(o.util.objectKeys(this.shape))}}n.ZodObject=j,j.create=(e,n)=>new j({shape:()=>e,unknownKeys:"strip",catchall:L.create(),typeName:se.ZodObject,...c(n)}),j.strictCreate=(e,n)=>new j({shape:()=>e,unknownKeys:"strict",catchall:L.create(),typeName:se.ZodObject,...c(n)}),j.lazycreate=(e,n)=>new j({shape:e,unknownKeys:"strip",catchall:L.create(),typeName:se.ZodObject,...c(n)});class M extends d{_parse(e){const{ctx:n}=this._processInputParams(e),r=this._def.options;if(n.common.async)return Promise.all(r.map((async e=>{const r={...n,common:{...n.common,issues:[]},parent:null};return{result:await e._parseAsync({data:n.data,path:n.path,parent:r}),ctx:r}}))).then((function(e){for(const n of e)if("valid"===n.result.status)return n.result;for(const r of e)if("dirty"===r.result.status)return n.common.issues.push(...r.ctx.common.issues),r.result;const r=e.map((e=>new s.ZodError(e.ctx.common.issues)));return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_union,unionErrors:r}),i.INVALID}));{let e;const t=[];for(const a of r){const r={...n,common:{...n.common,issues:[]},parent:null},i=a._parseSync({data:n.data,path:n.path,parent:r});if("valid"===i.status)return i;"dirty"!==i.status||e||(e={result:i,ctx:r}),r.common.issues.length&&t.push(r.common.issues)}if(e)return n.common.issues.push(...e.ctx.common.issues),e.result;const a=t.map((e=>new s.ZodError(e)));return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_union,unionErrors:a}),i.INVALID}}get options(){return this._def.options}}n.ZodUnion=M,M.create=(e,n)=>new M({options:e,typeName:se.ZodUnion,...c(n)});const x=e=>e instanceof Z?x(e.schema):e instanceof $?x(e.innerType()):e instanceof J?[e.value]:e instanceof X?e.options:e instanceof z?Object.keys(e.enum):e instanceof ne?x(e._def.innerType):e instanceof R?[void 0]:e instanceof _?[null]:null;class F extends d{_parse(e){const{ctx:n}=this._processInputParams(e);if(n.parsedType!==o.ZodParsedType.object)return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.object,received:n.parsedType}),i.INVALID;const r=this.discriminator,t=n.data[r],a=this.optionsMap.get(t);return a?n.common.async?a._parseAsync({data:n.data,path:n.path,parent:n}):a._parseSync({data:n.data,path:n.path,parent:n}):((0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_union_discriminator,options:Array.from(this.optionsMap.keys()),path:[r]}),i.INVALID)}get discriminator(){return this._def.discriminator}get options(){return this._def.options}get optionsMap(){return this._def.optionsMap}static create(e,n,r){const t=new Map;for(const r of n){const n=x(r.shape[e]);if(!n)throw new Error(`A discriminator value for key \`${e}\` could not be extracted from all schema options`);for(const a of n){if(t.has(a))throw new Error(`Discriminator property ${String(e)} has duplicate value ${String(a)}`);t.set(a,r)}}return new F({typeName:se.ZodDiscriminatedUnion,discriminator:e,options:n,optionsMap:t,...c(r)})}}function H(e,n){const r=(0,o.getParsedType)(e),t=(0,o.getParsedType)(n);if(e===n)return{valid:!0,data:e};if(r===o.ZodParsedType.object&&t===o.ZodParsedType.object){const r=o.util.objectKeys(n),t=o.util.objectKeys(e).filter((e=>-1!==r.indexOf(e))),a={...e,...n};for(const r of t){const t=H(e[r],n[r]);if(!t.valid)return{valid:!1};a[r]=t.data}return{valid:!0,data:a}}if(r===o.ZodParsedType.array&&t===o.ZodParsedType.array){if(e.length!==n.length)return{valid:!1};const r=[];for(let t=0;t<e.length;t++){const a=H(e[t],n[t]);if(!a.valid)return{valid:!1};r.push(a.data)}return{valid:!0,data:r}}return r===o.ZodParsedType.date&&t===o.ZodParsedType.date&&+e==+n?{valid:!0,data:e}:{valid:!1}}n.ZodDiscriminatedUnion=F;class B extends d{_parse(e){const{status:n,ctx:r}=this._processInputParams(e),t=(e,t)=>{if((0,i.isAborted)(e)||(0,i.isAborted)(t))return i.INVALID;const a=H(e.value,t.value);return a.valid?(((0,i.isDirty)(e)||(0,i.isDirty)(t))&&n.dirty(),{status:n.value,value:a.data}):((0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_intersection_types}),i.INVALID)};return r.common.async?Promise.all([this._def.left._parseAsync({data:r.data,path:r.path,parent:r}),this._def.right._parseAsync({data:r.data,path:r.path,parent:r})]).then((([e,n])=>t(e,n))):t(this._def.left._parseSync({data:r.data,path:r.path,parent:r}),this._def.right._parseSync({data:r.data,path:r.path,parent:r}))}}n.ZodIntersection=B,B.create=(e,n,r)=>new B({left:e,right:n,typeName:se.ZodIntersection,...c(r)});class W extends d{_parse(e){const{status:n,ctx:r}=this._processInputParams(e);if(r.parsedType!==o.ZodParsedType.array)return(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.array,received:r.parsedType}),i.INVALID;if(r.data.length<this._def.items.length)return(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_small,minimum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),i.INVALID;!this._def.rest&&r.data.length>this._def.items.length&&((0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_big,maximum:this._def.items.length,inclusive:!0,exact:!1,type:"array"}),n.dirty());const t=[...r.data].map(((e,n)=>{const t=this._def.items[n]||this._def.rest;return t?t._parse(new l(r,e,r.path,n)):null})).filter((e=>!!e));return r.common.async?Promise.all(t).then((e=>i.ParseStatus.mergeArray(n,e))):i.ParseStatus.mergeArray(n,t)}get items(){return this._def.items}rest(e){return new W({...this._def,rest:e})}}n.ZodTuple=W,W.create=(e,n)=>{if(!Array.isArray(e))throw new Error("You must pass an array of schemas to z.tuple([ ... ])");return new W({items:e,typeName:se.ZodTuple,rest:null,...c(n)})};class Y extends d{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){const{status:n,ctx:r}=this._processInputParams(e);if(r.parsedType!==o.ZodParsedType.object)return(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.object,received:r.parsedType}),i.INVALID;const t=[],a=this._def.keyType,u=this._def.valueType;for(const e in r.data)t.push({key:a._parse(new l(r,e,r.path,e)),value:u._parse(new l(r,r.data[e],r.path,e))});return r.common.async?i.ParseStatus.mergeObjectAsync(n,t):i.ParseStatus.mergeObjectSync(n,t)}get element(){return this._def.valueType}static create(e,n,r){return new Y(n instanceof d?{keyType:e,valueType:n,typeName:se.ZodRecord,...c(r)}:{keyType:C.create(),valueType:e,typeName:se.ZodRecord,...c(n)})}}n.ZodRecord=Y;class G extends d{get keySchema(){return this._def.keyType}get valueSchema(){return this._def.valueType}_parse(e){const{status:n,ctx:r}=this._processInputParams(e);if(r.parsedType!==o.ZodParsedType.map)return(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.map,received:r.parsedType}),i.INVALID;const t=this._def.keyType,a=this._def.valueType,u=[...r.data.entries()].map((([e,n],i)=>({key:t._parse(new l(r,e,r.path,[i,"key"])),value:a._parse(new l(r,n,r.path,[i,"value"]))})));if(r.common.async){const e=new Map;return Promise.resolve().then((async()=>{for(const r of u){const t=await r.key,a=await r.value;if("aborted"===t.status||"aborted"===a.status)return i.INVALID;"dirty"!==t.status&&"dirty"!==a.status||n.dirty(),e.set(t.value,a.value)}return{status:n.value,value:e}}))}{const e=new Map;for(const r of u){const t=r.key,a=r.value;if("aborted"===t.status||"aborted"===a.status)return i.INVALID;"dirty"!==t.status&&"dirty"!==a.status||n.dirty(),e.set(t.value,a.value)}return{status:n.value,value:e}}}}n.ZodMap=G,G.create=(e,n,r)=>new G({valueType:n,keyType:e,typeName:se.ZodMap,...c(r)});class U extends d{_parse(e){const{status:n,ctx:r}=this._processInputParams(e);if(r.parsedType!==o.ZodParsedType.set)return(0,i.addIssueToContext)(r,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.set,received:r.parsedType}),i.INVALID;const t=this._def;null!==t.minSize&&r.data.size<t.minSize.value&&((0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_small,minimum:t.minSize.value,type:"set",inclusive:!0,exact:!1,message:t.minSize.message}),n.dirty()),null!==t.maxSize&&r.data.size>t.maxSize.value&&((0,i.addIssueToContext)(r,{code:s.ZodIssueCode.too_big,maximum:t.maxSize.value,type:"set",inclusive:!0,exact:!1,message:t.maxSize.message}),n.dirty());const a=this._def.valueType;function u(e){const r=new Set;for(const t of e){if("aborted"===t.status)return i.INVALID;"dirty"===t.status&&n.dirty(),r.add(t.value)}return{status:n.value,value:r}}const c=[...r.data.values()].map(((e,n)=>a._parse(new l(r,e,r.path,n))));return r.common.async?Promise.all(c).then((e=>u(e))):u(c)}min(e,n){return new U({...this._def,minSize:{value:e,message:a.errorUtil.toString(n)}})}max(e,n){return new U({...this._def,maxSize:{value:e,message:a.errorUtil.toString(n)}})}size(e,n){return this.min(e,n).max(e,n)}nonempty(e){return this.min(1,e)}}n.ZodSet=U,U.create=(e,n)=>new U({valueType:e,minSize:null,maxSize:null,typeName:se.ZodSet,...c(n)});class V extends d{constructor(){super(...arguments),this.validate=this.implement}_parse(e){const{ctx:n}=this._processInputParams(e);if(n.parsedType!==o.ZodParsedType.function)return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.function,received:n.parsedType}),i.INVALID;function r(e,r){return(0,i.makeIssue)({data:e,path:n.path,errorMaps:[n.common.contextualErrorMap,n.schemaErrorMap,(0,t.getErrorMap)(),t.defaultErrorMap].filter((e=>!!e)),issueData:{code:s.ZodIssueCode.invalid_arguments,argumentsError:r}})}function a(e,r){return(0,i.makeIssue)({data:e,path:n.path,errorMaps:[n.common.contextualErrorMap,n.schemaErrorMap,(0,t.getErrorMap)(),t.defaultErrorMap].filter((e=>!!e)),issueData:{code:s.ZodIssueCode.invalid_return_type,returnTypeError:r}})}const l={errorMap:n.common.contextualErrorMap},u=n.data;if(this._def.returns instanceof K){const e=this;return(0,i.OK)((async function(...n){const t=new s.ZodError([]),i=await e._def.args.parseAsync(n,l).catch((e=>{throw t.addIssue(r(n,e)),t})),o=await Reflect.apply(u,this,i);return await e._def.returns._def.type.parseAsync(o,l).catch((e=>{throw t.addIssue(a(o,e)),t}))}))}{const e=this;return(0,i.OK)((function(...n){const t=e._def.args.safeParse(n,l);if(!t.success)throw new s.ZodError([r(n,t.error)]);const i=Reflect.apply(u,this,t.data),o=e._def.returns.safeParse(i,l);if(!o.success)throw new s.ZodError([a(i,o.error)]);return o.data}))}}parameters(){return this._def.args}returnType(){return this._def.returns}args(...e){return new V({...this._def,args:W.create(e).rest(D.create())})}returns(e){return new V({...this._def,returns:e})}implement(e){return this.parse(e)}strictImplement(e){return this.parse(e)}static create(e,n,r){return new V({args:e||W.create([]).rest(D.create()),returns:n||D.create(),typeName:se.ZodFunction,...c(r)})}}n.ZodFunction=V;class Z extends d{get schema(){return this._def.getter()}_parse(e){const{ctx:n}=this._processInputParams(e);return this._def.getter()._parse({data:n.data,path:n.path,parent:n})}}n.ZodLazy=Z,Z.create=(e,n)=>new Z({getter:e,typeName:se.ZodLazy,...c(n)});class J extends d{_parse(e){if(e.data!==this._def.value){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{received:n.data,code:s.ZodIssueCode.invalid_literal,expected:this._def.value}),i.INVALID}return{status:"valid",value:e.data}}get value(){return this._def.value}}function q(e,n){return new X({values:e,typeName:se.ZodEnum,...c(n)})}n.ZodLiteral=J,J.create=(e,n)=>new J({value:e,typeName:se.ZodLiteral,...c(n)});class X extends d{_parse(e){if("string"!=typeof e.data){const n=this._getOrReturnCtx(e),r=this._def.values;return(0,i.addIssueToContext)(n,{expected:o.util.joinValues(r),received:n.parsedType,code:s.ZodIssueCode.invalid_type}),i.INVALID}if(-1===this._def.values.indexOf(e.data)){const n=this._getOrReturnCtx(e),r=this._def.values;return(0,i.addIssueToContext)(n,{received:n.data,code:s.ZodIssueCode.invalid_enum_value,options:r}),i.INVALID}return(0,i.OK)(e.data)}get options(){return this._def.values}get enum(){const e={};for(const n of this._def.values)e[n]=n;return e}get Values(){const e={};for(const n of this._def.values)e[n]=n;return e}get Enum(){const e={};for(const n of this._def.values)e[n]=n;return e}extract(e){return X.create(e)}exclude(e){return X.create(this.options.filter((n=>!e.includes(n))))}}n.ZodEnum=X,X.create=q;class z extends d{_parse(e){const n=o.util.getValidEnumValues(this._def.values),r=this._getOrReturnCtx(e);if(r.parsedType!==o.ZodParsedType.string&&r.parsedType!==o.ZodParsedType.number){const e=o.util.objectValues(n);return(0,i.addIssueToContext)(r,{expected:o.util.joinValues(e),received:r.parsedType,code:s.ZodIssueCode.invalid_type}),i.INVALID}if(-1===n.indexOf(e.data)){const e=o.util.objectValues(n);return(0,i.addIssueToContext)(r,{received:r.data,code:s.ZodIssueCode.invalid_enum_value,options:e}),i.INVALID}return(0,i.OK)(e.data)}get enum(){return this._def.values}}n.ZodNativeEnum=z,z.create=(e,n)=>new z({values:e,typeName:se.ZodNativeEnum,...c(n)});class K extends d{unwrap(){return this._def.type}_parse(e){const{ctx:n}=this._processInputParams(e);if(n.parsedType!==o.ZodParsedType.promise&&!1===n.common.async)return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.promise,received:n.parsedType}),i.INVALID;const r=n.parsedType===o.ZodParsedType.promise?n.data:Promise.resolve(n.data);return(0,i.OK)(r.then((e=>this._def.type.parseAsync(e,{path:n.path,errorMap:n.common.contextualErrorMap}))))}}n.ZodPromise=K,K.create=(e,n)=>new K({type:e,typeName:se.ZodPromise,...c(n)});class $ extends d{innerType(){return this._def.schema}sourceType(){return this._def.schema._def.typeName===se.ZodEffects?this._def.schema.sourceType():this._def.schema}_parse(e){const{status:n,ctx:r}=this._processInputParams(e),t=this._def.effect||null,a={addIssue:e=>{(0,i.addIssueToContext)(r,e),e.fatal?n.abort():n.dirty()},get path(){return r.path}};if(a.addIssue=a.addIssue.bind(a),"preprocess"===t.type){const e=t.transform(r.data,a);return r.common.issues.length?{status:"dirty",value:r.data}:r.common.async?Promise.resolve(e).then((e=>this._def.schema._parseAsync({data:e,path:r.path,parent:r}))):this._def.schema._parseSync({data:e,path:r.path,parent:r})}if("refinement"===t.type){const e=e=>{const n=t.refinement(e,a);if(r.common.async)return Promise.resolve(n);if(n instanceof Promise)throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");return e};if(!1===r.common.async){const t=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});return"aborted"===t.status?i.INVALID:("dirty"===t.status&&n.dirty(),e(t.value),{status:n.value,value:t.value})}return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then((r=>"aborted"===r.status?i.INVALID:("dirty"===r.status&&n.dirty(),e(r.value).then((()=>({status:n.value,value:r.value}))))))}if("transform"===t.type){if(!1===r.common.async){const e=this._def.schema._parseSync({data:r.data,path:r.path,parent:r});if(!(0,i.isValid)(e))return e;const o=t.transform(e.value,a);if(o instanceof Promise)throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");return{status:n.value,value:o}}return this._def.schema._parseAsync({data:r.data,path:r.path,parent:r}).then((e=>(0,i.isValid)(e)?Promise.resolve(t.transform(e.value,a)).then((e=>({status:n.value,value:e}))):e))}o.util.assertNever(t)}}n.ZodEffects=$,n.ZodTransformer=$,$.create=(e,n,r)=>new $({schema:e,typeName:se.ZodEffects,effect:n,...c(r)}),$.createWithPreprocess=(e,n,r)=>new $({schema:n,effect:{type:"preprocess",transform:e},typeName:se.ZodEffects,...c(r)});class Q extends d{_parse(e){return this._getType(e)===o.ZodParsedType.undefined?(0,i.OK)(void 0):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}}n.ZodOptional=Q,Q.create=(e,n)=>new Q({innerType:e,typeName:se.ZodOptional,...c(n)});class ee extends d{_parse(e){return this._getType(e)===o.ZodParsedType.null?(0,i.OK)(null):this._def.innerType._parse(e)}unwrap(){return this._def.innerType}}n.ZodNullable=ee,ee.create=(e,n)=>new ee({innerType:e,typeName:se.ZodNullable,...c(n)});class ne extends d{_parse(e){const{ctx:n}=this._processInputParams(e);let r=n.data;return n.parsedType===o.ZodParsedType.undefined&&(r=this._def.defaultValue()),this._def.innerType._parse({data:r,path:n.path,parent:n})}removeDefault(){return this._def.innerType}}n.ZodDefault=ne,ne.create=(e,n)=>new ne({innerType:e,typeName:se.ZodDefault,defaultValue:"function"==typeof n.default?n.default:()=>n.default,...c(n)});class re extends d{_parse(e){const{ctx:n}=this._processInputParams(e),r={...n,common:{...n.common,issues:[]}},t=this._def.innerType._parse({data:r.data,path:r.path,parent:{...r}});return(0,i.isAsync)(t)?t.then((e=>({status:"valid",value:"valid"===e.status?e.value:this._def.catchValue({get error(){return new s.ZodError(r.common.issues)},input:r.data})}))):{status:"valid",value:"valid"===t.status?t.value:this._def.catchValue({get error(){return new s.ZodError(r.common.issues)},input:r.data})}}removeCatch(){return this._def.innerType}}n.ZodCatch=re,re.create=(e,n)=>new re({innerType:e,typeName:se.ZodCatch,catchValue:"function"==typeof n.catch?n.catch:()=>n.catch,...c(n)});class te extends d{_parse(e){if(this._getType(e)!==o.ZodParsedType.nan){const n=this._getOrReturnCtx(e);return(0,i.addIssueToContext)(n,{code:s.ZodIssueCode.invalid_type,expected:o.ZodParsedType.nan,received:n.parsedType}),i.INVALID}return{status:"valid",value:e.data}}}n.ZodNaN=te,te.create=e=>new te({typeName:se.ZodNaN,...c(e)}),n.BRAND=Symbol("zod_brand");class ae extends d{_parse(e){const{ctx:n}=this._processInputParams(e),r=n.data;return this._def.type._parse({data:r,path:n.path,parent:n})}unwrap(){return this._def.type}}n.ZodBranded=ae;class ie extends d{_parse(e){const{status:n,ctx:r}=this._processInputParams(e);if(r.common.async){return(async()=>{const e=await this._def.in._parseAsync({data:r.data,path:r.path,parent:r});return"aborted"===e.status?i.INVALID:"dirty"===e.status?(n.dirty(),(0,i.DIRTY)(e.value)):this._def.out._parseAsync({data:e.value,path:r.path,parent:r})})()}{const e=this._def.in._parseSync({data:r.data,path:r.path,parent:r});return"aborted"===e.status?i.INVALID:"dirty"===e.status?(n.dirty(),{status:"dirty",value:e.value}):this._def.out._parseSync({data:e.value,path:r.path,parent:r})}}static create(e,n){return new ie({in:e,out:n,typeName:se.ZodPipeline})}}n.ZodPipeline=ie;class oe extends d{_parse(e){const n=this._def.innerType._parse(e);return(0,i.isValid)(n)&&(n.value=Object.freeze(n.value)),n}}n.ZodReadonly=oe,oe.create=(e,n)=>new oe({innerType:e,typeName:se.ZodReadonly,...c(n)});var se;n.custom=(e,n={},r)=>e?E.create().superRefine(((t,a)=>{var i,o;if(!e(t)){const e="function"==typeof n?n(t):"string"==typeof n?{message:n}:n,s=null===(o=null!==(i=e.fatal)&&void 0!==i?i:r)||void 0===o||o,l="string"==typeof e?{message:e}:e;a.addIssue({code:"custom",...l,fatal:s})}})):E.create(),n.late={object:j.lazycreate},function(e){e.ZodString="ZodString",e.ZodNumber="ZodNumber",e.ZodNaN="ZodNaN",e.ZodBigInt="ZodBigInt",e.ZodBoolean="ZodBoolean",e.ZodDate="ZodDate",e.ZodSymbol="ZodSymbol",e.ZodUndefined="ZodUndefined",e.ZodNull="ZodNull",e.ZodAny="ZodAny",e.ZodUnknown="ZodUnknown",e.ZodNever="ZodNever",e.ZodVoid="ZodVoid",e.ZodArray="ZodArray",e.ZodObject="ZodObject",e.ZodUnion="ZodUnion",e.ZodDiscriminatedUnion="ZodDiscriminatedUnion",e.ZodIntersection="ZodIntersection",e.ZodTuple="ZodTuple",e.ZodRecord="ZodRecord",e.ZodMap="ZodMap",e.ZodSet="ZodSet",e.ZodFunction="ZodFunction",e.ZodLazy="ZodLazy",e.ZodLiteral="ZodLiteral",e.ZodEnum="ZodEnum",e.ZodEffects="ZodEffects",e.ZodNativeEnum="ZodNativeEnum",e.ZodOptional="ZodOptional",e.ZodNullable="ZodNullable",e.ZodDefault="ZodDefault",e.ZodCatch="ZodCatch",e.ZodPromise="ZodPromise",e.ZodBranded="ZodBranded",e.ZodPipeline="ZodPipeline",e.ZodReadonly="ZodReadonly"}(se=n.ZodFirstPartyTypeKind||(n.ZodFirstPartyTypeKind={}));n.instanceof=(e,r={message:`Input not instance of ${e.name}`})=>(0,n.custom)((n=>n instanceof e),r);const le=C.create;n.string=le;const ue=I.create;n.number=ue;const ce=te.create;n.nan=ce;const de=O.create;n.bigint=de;const pe=b.create;n.boolean=pe;const ge=A.create;n.date=ge;const fe=T.create;n.symbol=fe;const me=R.create;n.undefined=me;const ve=_.create;n.null=ve;const he=E.create;n.any=he;const ye=D.create;n.unknown=ye;const Pe=L.create;n.never=Pe;const Ce=S.create;n.void=Ce;const we=N.create;n.array=we;const Ie=j.create;n.object=Ie;const Oe=j.strictCreate;n.strictObject=Oe;const be=M.create;n.union=be;const Ae=F.create;n.discriminatedUnion=Ae;const Te=B.create;n.intersection=Te;const Re=W.create;n.tuple=Re;const _e=Y.create;n.record=_e;const Ee=G.create;n.map=Ee;const De=U.create;n.set=De;const Le=V.create;n.function=Le;const Se=Z.create;n.lazy=Se;const Ne=J.create;n.literal=Ne;const ke=X.create;n.enum=ke;const je=z.create;n.nativeEnum=je;const Me=K.create;n.promise=Me;const xe=$.create;n.effect=xe,n.transformer=xe;const Fe=Q.create;n.optional=Fe;const He=ee.create;n.nullable=He;const Be=$.createWithPreprocess;n.preprocess=Be;const We=ie.create;n.pipeline=We;n.ostring=()=>le().optional();n.onumber=()=>ue().optional();n.oboolean=()=>pe().optional(),n.coerce={string:e=>C.create({...e,coerce:!0}),number:e=>I.create({...e,coerce:!0}),boolean:e=>b.create({...e,coerce:!0}),bigint:e=>O.create({...e,coerce:!0}),date:e=>A.create({...e,coerce:!0})},n.NEVER=i.INVALID},73185:function(n){n.exports=e},5416:function(e){e.exports=n}},t={};var a=function e(n){var a=t[n];if(void 0!==a)return a.exports;var i=t[n]={exports:{}};return r[n].call(i.exports,i,i.exports,e),i.exports}(3644);return a}()}));
//# sourceMappingURL=index.js.map